import {
  Duration__minus_impl_q5cfm715b1yelrxm0ir as Duration__minus_impl_q5cfm7,
  Duration__plus_impl_yu9v8f24i74j9g7b01u as Duration__plus_impl_yu9v8f,
  Duration__compareTo_impl_pchp0f86u5y5kbz283 as Duration__compareTo_impl_pchp0f,
  THROW_CCE2g6jy02ryeudk as THROW_CCE,
  Unit_instanceat14thlj150z as Unit_instance,
  Comparable198qfk8pnblz0 as Comparable,
  AutoCloseable1l5p57f9lp7kv as AutoCloseable,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
  VOID7hggqo3abtya as VOID,
  Duration__toString_impl_8d916b13ohvvi8wucz4 as Duration__toString_impl_8d916b,
  ValueTimeMark__elapsedNow_impl_eonqvs3jczd809bixyd as ValueTimeMark__elapsedNow_impl_eonqvs,
  Duration5ynfiptaqcrg as Duration,
  printStackTrace18lnx7a39cni as printStackTrace,
  Monotonic_instance29u86ypunv10 as Monotonic_instance,
  ArrayDeque2dzc9uld4xi7n as ArrayDeque,
  maxOfnpw4mt1rg0hl as maxOf,
  KMutableProperty025txtn5b59pq1 as KMutableProperty0,
  getPropertyCallableRef1ajb9in178r5r as getPropertyCallableRef,
  protoOf180f3jzyo7rfj as protoOf,
  ensureNotNull1e947j3ixpazm as ensureNotNull,
  createThis2j2avj17cvnv2 as createThis,
  IllegalStateExceptionkoljg5n0nrlr as IllegalStateException,
  toString1pkumu07cwy4m as toString,
  initMetadataForInterface1egvbzx539z91 as initMetadataForInterface,
  initMetadataForCompanion1wyw17z38v6ac as initMetadataForCompanion,
  getBooleanHashCode1bbj3u6b3v0a7 as getBooleanHashCode,
  Enum3alwj03lh1n41 as Enum,
  _Char___init__impl__6a9atx367vrx0avsvbg as _Char___init__impl__6a9atx,
  Companion_getInstance148flmv2wtrla as Companion_getInstance,
  toString14fd7g605f91p as toString_0,
  Char__hashCode_impl_otmys1ewos5t0dm35g as Char__hashCode_impl_otmys,
  getStringHashCode26igk1bx568vk as getStringHashCode,
  getNumberHashCode2l4nbdcihl25f as getNumberHashCode,
  equals2au1ep9vhcato as equals,
  toString30pk9tzaqopn as toString_1,
  hashCodeq5arwsb9dgti as hashCode,
  Exceptiondt2hlxn7j7vw as Exception,
  captureStack1fzi4aczwc4hg as captureStack,
  fillArrayVali8eppxapiek4 as fillArrayVal,
  joinToString1cxrrlmo0chqs as joinToString,
  booleanArray2jdug9b51huk7 as booleanArray,
  StringBuildermazzzhj6kkai as StringBuilder,
  ArrayList3it5z8td81qkl as ArrayList,
  collectionSizeOrDefault36dulx8yinfqm as collectionSizeOrDefault,
  emptySetcxexqki71qfa as emptySet,
  Long2qws0ah9gnpki as Long,
  isInterface3d6p8outrmvmk as isInterface,
  distinct10qe1scfdvu5k as distinct,
  compareTo3ankvs086tmwq as compareTo,
  Companion_getInstance1krakgr3yg44t as Companion_getInstance_0,
  toLongw1zpgk99d84b as toLong,
  initMetadataForObject1cxne3s9w65el as initMetadataForObject,
  numberToInt1ygmcfwhs2fkq as numberToInt,
  KProperty1ca4yb4wlo496 as KProperty1,
  RuntimeException1r3t0zl97011n as RuntimeException,
  toList3jhuyej2anx2q as toList,
  listOfvhqybd2zx248 as listOf,
  LinkedHashSet2tkztfx86kyx2 as LinkedHashSet,
  HashMap1a0ld5kgwhmhv as HashMap,
  lazy2hsh8ze7j6ikd as lazy,
  numberToLong1a4cndvg6c52s as numberToLong,
  println2shhhgwwt4c61 as println,
  KMutableProperty11e8g1gb0ecb9j as KMutableProperty1,
  NotImplementedErrorfzlkpv14xxr8 as NotImplementedError,
  noWhenBranchMatchedException2a6r7ubxgky5j as noWhenBranchMatchedException,
  mapCapacity1h45rc3eh9p2l as mapCapacity,
  coerceAtLeast2bkz8m9ik7hep as coerceAtLeast,
  LinkedHashMap1zhqxkxv3xnkl as LinkedHashMap,
  listOf1jh22dvmctj1r as listOf_0,
  Triple1vhi3d0dgpnjb as Triple,
  stackTraceToString2670q6lbhdojj as stackTraceToString,
  last1vo29oleiqj36 as last,
  Regexxgw0gjiagf4z as Regex,
  replace3le3ie7l9k8aq as replace,
  isCharSequence1ju9jr1w86plq as isCharSequence,
  trim11nh7r46at6sx as trim,
  toIntOrNull3w2d066r9pvwm as toIntOrNull,
  getKClassFromExpression3vpejubogshaw as getKClassFromExpression,
  getOrNull1go7ef9ldk0df as getOrNull,
  FunctionAdapter3lcrrz3moet5b as FunctionAdapter,
  Comparator2b3maoeh98xtg as Comparator,
  compareValues1n2ayl87ihzfk as compareValues,
  sortedWith2csnbbb21k0lg as sortedWith,
  charSequenceLength3278n89t01tmv as charSequenceLength,
  emptyList1g2z5xcrvp2zy as emptyList,
  reversed22y3au42jl32b as reversed,
  HashSet2dzve9y63nf0v as HashSet,
  plus310ted5e4i90h as plus,
  joinToStringxqcavsxcmh4q as joinToString_0,
  contains2el4s70rdq4ld as contains,
  maxOrNull2e5ok5wkly1cp as maxOrNull,
  Iterable1y3qizuf89iou as Iterable,
  checkIndexOverflow3frtmheghr0th as checkIndexOverflow,
  contentEqualsaf55p28mnw74 as contentEquals,
  contentHashCode2i020q5tbeh2s as contentHashCode,
  toList383f556t1dixk as toList_0,
  to2cs3ny02qtbcb as to,
  boxApply1qmzdb3dh90hg as boxApply,
  plus1ogy4liedzq5j as plus_0,
  withIndex37cl61h9v5txo as withIndex,
  charSequenceGet1vxk1y5n17t1z as charSequenceGet,
  Char__toInt_impl_vasixd17daqndsyg0ov as Char__toInt_impl_vasixd,
  toByte4i43936u611k as toByte,
  numberToChar93r9buh19yek as numberToChar,
  until1jbpn0z3f8lbg as until,
  toSet2orjxp16sotqu as toSet,
  split2bvyvnrlcifjv as split,
  get_COROUTINE_SUSPENDED3ujt3p13qm4iy as get_COROUTINE_SUSPENDED,
  suspendOrReturn49pspzlx5djv as suspendOrReturn,
  numberToDouble210hrknaofnhf as numberToDouble,
  get_indicesc04v40g017hw as get_indices,
  anyToString3ho3k49fc56mj as anyToString,
  DurationUnit_MILLISECONDS_getInstancedq9xrzm1t8sm as DurationUnit_MILLISECONDS_getInstance,
  toDuration28gf6ughsr3vf as toDuration,
  copyToArray2j022khrow2yi as copyToArray,
  startsWith1bgirhbedtv2y as startsWith,
  isBlank1dvkhjjvox3p0 as isBlank,
  charArrayOf27f4r3dozbrk1 as charArrayOf,
  split3d3yeauc4rm2n as split_0,
  KtMutableMap1kqeifoi36kpz as KtMutableMap,
  toShort36kaw0zjdq3ex as toShort,
  contains1tccixv8iwdcq as contains_0,
  EmptyCoroutineContext_getInstance7yleecrz3jzr as EmptyCoroutineContext_getInstance,
  round2mrvepag8eey0 as round,
  coerceAtLeastklytehohcpeq as coerceAtLeast_0,
  throwUninitializedPropertyAccessExceptionyynx7gkm73wd as throwUninitializedPropertyAccessException,
  mapOf1xd03cq9cnmy8 as mapOf,
  initMetadataForLambda3af3he42mmnh as initMetadataForLambda,
  ObservableProperty3aw08lidjfpjm as ObservableProperty,
  Delegates_instance3jf2rsvdhmxzn as Delegates_instance,
  DurationUnit_MICROSECONDS_getInstance3qb7b7owxf6lo as DurationUnit_MICROSECONDS_getInstance,
  Duration__times_impl_sfuzvp2zkq9ykxbil7d as Duration__times_impl_sfuzvp,
  get6d5x931vk0s as get,
  fold36i9psb7d5v48 as fold,
  minusKeyyqanvso9aovh as minusKey,
  plusolev77jfy5r9 as plus_1,
  Element2gr7ezmxqaln7 as Element,
  Companion_instance144r68bk89en4 as Companion_instance,
  _Result___init__impl__xyqfz8oelep8i0cbta as _Result___init__impl__xyqfz8,
  createFailure8paxfkfa5dc7 as createFailure,
  DurationUnit_SECONDS_getInstance162tnxlnf2fpv as DurationUnit_SECONDS_getInstance,
  toDurationba1nlt78o6vu as toDuration_0,
  PrimitiveClasses_getInstanceeand5azd2sul as PrimitiveClasses_getInstance,
  arrayOf1akklvh2at202 as arrayOf,
  createKType1lgox3mzhchp5 as createKType,
  createInvariantKTypeProjection3sfd0u0y62ozd as createInvariantKTypeProjection,
  getKClass1s3j9wy1cofik as getKClass,
  Unitkvevlwgzwiuc as Unit,
  encodeToByteArray1onwao0uakjfh as encodeToByteArray,
  KProperty02ce7r476m8633 as KProperty0,
  toSet1glep2u1u9tcb as toSet_0,
  reversednxqwdkac9dn0 as reversed_0,
  toMutableListoiy7juhbnlr7 as toMutableList,
  removeSuffix3d61x5lsuvuho as removeSuffix,
  isInfinite12nl8hpz1hbp2 as isInfinite,
  isNaNymqb93xtq8w8 as isNaN_0,
} from './kotlin-kotlin-stdlib.mjs';
import {
  Console_getInstance8lqb2pbph5yn as Console_getInstance,
  Companion_getInstance3qvmjlq9y5ia6 as Companion_getInstance_1,
  Level_INFO_getInstance3huxkjtm54h8u as Level_INFO_getInstance,
  Level_ERROR_getInstance18552yzhsfztk as Level_ERROR_getInstance,
  Level_TRACE_getInstance1ni95vo21pald as Level_TRACE_getInstance,
  Level_DEBUG_getInstancewzibhbcrmy7h as Level_DEBUG_getInstance,
  valueOf3aj0dpb8xpu5n as valueOf,
  Level_WARN_getInstance2cg04z8rod8ga as Level_WARN_getInstance,
} from './korlibs-logger-root-korlibs-logger.mjs';
import {
  SyncPauseable20rt0nt3umu2s as SyncPauseable,
  Companion_instance2r8kc48nhvjcq as Companion_instance_0,
  FastIdentityMap17d14y8i3m5g7 as FastIdentityMap,
  get2pw1zlgv5zypd as get_0,
  set2vuztm9k7ubgo as set,
  FastIntMapl0pzyavg6uw5 as FastIntMap,
  IntArrayList3liuagbdnwmna as IntArrayList,
  Ref11k43t82thcp3 as Ref,
  FastStringMap1l1uzdhsfbatm as FastStringMap,
  linkedHashMapOf2w2uhgrq4khrk as linkedHashMapOf,
  toIntMapp1jij98esrcm as toIntMap,
  IntMap2d9g6f5pyaoc2 as IntMap,
  Pool1zbsw0zhvh8ca as Pool,
  containsrsn76oa0puwr as contains_1,
  clear3idbm40uzyume as clear,
  get_size2tttv7g2u748n as get_size,
  FastSmallSet2og2j8v2pz4c7 as FastSmallSet,
  getAndRemove1ksxnnren48mb as getAndRemove,
  get_keyswqddktl7cnu2 as get_keys,
  ReturnablePool3rkgvxsckx2u2 as ReturnablePool,
  TGenQueue2v9j3ju90xgpv as TGenQueue,
} from './korlibs-datastructure-root-korlibs-datastructure.mjs';
import {
  Lock5n7hh3dgcidl as Lock,
  Signal3nnez3346azzf as Signal,
  invoke2sf88d1xeuyqh as invoke,
  NonRecursiveLock2vf7fkhp857q as NonRecursiveLock,
} from './korlibs-concurrent-root-korlibs-concurrent.mjs';
import {
  cancel1amaozv14ic7s as cancel,
  CloseableCancellable3mxnqaxyfppmn as CloseableCancellable,
  CancellableGroup3e8z70ga3djg as CancellableGroup,
  Companion_getInstancegk7jn4e7je7g as Companion_getInstance_2,
  get_unreachable2fi7msfg0vgzd as get_unreachable,
  unsupported198cz39rr1ztw as unsupported,
  Companion_instance1mbrm9vk5fsmd as Companion_instance_1,
  get_portableSimpleName6o7s8nc63i85 as get_portableSimpleName,
  Companion_getInstance39o54489czp6d as Companion_getInstance_3,
  Os_UNKNOWN_getInstancecnx3cm3i6e2g as Os_UNKNOWN_getInstance,
  invalidOp1stebxh2m3n07 as invalidOp,
  get_invalidOp31x7cztl0dv9m as get_invalidOp,
  DenoPointerpb0vypijx63v as DenoPointer,
  get_pointerlkbwhoqlhapz as get_pointer,
  get_jsGlobalThis3odmbn60utci as get_jsGlobalThis,
} from './korlibs-platform-root-korlibs-platform.mjs';
import {
  FastArrayListw5fr1wlp4slq as FastArrayList,
  toFastList1btvvxvv57pw as toFastList,
  Mixin3lmkm5hum2vdj as Mixin,
  fastArrayListOf1rdodhrpn0q8y as fastArrayListOf,
  setExtra314k0z6q35eku as setExtra,
  getExtraTyped8zexqxz5xxli as getExtraTyped,
  PropertyThis2r0hbk1cs09wj as PropertyThis,
  toFastListzo2jtkrx0z5y as toFastList_0,
} from './korlibs-datastructure-core-root-korlibs-datastructure-core.mjs';
import {
  Companion_getInstancewdpvtc2ehxkt as Companion_getInstance_4,
  RectangleInt3lmu13ytuf5lk as RectangleInt,
  Companion_getInstance1bdwtq6rroayu as Companion_getInstance_5,
  Vector2D378fe5rov8fgw as Vector2D,
  BoundsBuilder__plus_impl_cz7f7xocbq7jeozma3 as BoundsBuilder__plus_impl_cz7f7x,
  Size2Dum5ayuyhhau7 as Size2D,
  Companion_getInstance3qti4zygy7usz as Companion_getInstance_6,
  Companion_getInstance1zxby1ngivg0d as Companion_getInstance_7,
  MatrixTransform1wlsrhxt7473v as MatrixTransform,
  get_scale17gmsnxnqj6j9 as get_scale,
  Matrix43neeu8v4zk4i7 as Matrix4,
  orthow9c0o91bw54n as ortho,
  SizeInte6w85oa6mz6v as SizeInt,
  Companion_instanceu31qrc8c1r0r as Companion_instance_2,
  get_degrees3czcd4ojw4i as get_degrees,
  Angle__times_impl_v3s9y21yznxo5bj1uj7 as Angle__times_impl_v3s9y2,
  Angle2itorpob18n08 as Angle,
} from './korlibs-math-vector-root-korlibs-math-vector.mjs';
import {
  Companion_getInstance36wz4kh9aujgq as Companion_getInstance_8,
  DateTime__hashCode_impl_yf0bc92s64omsn0fynv as DateTime__hashCode_impl_yf0bc9,
  _FastDuration___get_fastNanoseconds__impl__9kjwbr3nvm3csqkttdd as _FastDuration___get_fastNanoseconds__impl__9kjwbr,
  get_fastNanosecondsibv7lnrlu50o as get_fastNanoseconds,
  _FastDuration___get_fastMilliseconds__impl__pe68va81p5t8ucvnk8 as _FastDuration___get_fastMilliseconds__impl__pe68va,
  get_fastMillisecondsfxaeyfzoedsj as get_fastMilliseconds,
  FastDuration__minus_impl_evs237rhg84spop2c8 as FastDuration__minus_impl_evs237,
  FastDuration__compareTo_impl_4fhnj72c084ut3ho50d as FastDuration__compareTo_impl_4fhnj7,
  Companion_instance293l0r179rei7 as Companion_instance_3,
  get_fastNanoseconds1laeiegsk8vcx as get_fastNanoseconds_0,
  FastDuration__plus_impl_q1enab1plpz0e6mgxzj as FastDuration__plus_impl_q1enab,
  toDuration15w5sljvx2ut2 as toDuration_1,
  FastDuration__hashCode_impl_y13la6nym0c1xbwjaa as FastDuration__hashCode_impl_y13la6,
  get_fastMicroseconds3xewe49ldi5s as get_fastMicroseconds,
  FastDuration__minus_impl_evs237bt7zqxxnwet as FastDuration__minus_impl_evs237_0,
  FastDuration3d3pupg2e5ora as FastDuration,
  minus2npwq73u0d9yx as minus,
  max1q2oylvn6uire as max,
  get_fastMilliseconds2pmoifl74b2oz as get_fastMilliseconds_0,
  FastDuration__plus_impl_q1enab30y5opwsu5po5 as FastDuration__plus_impl_q1enab_0,
  get_fast37cu8s8qwnuyi as get_fast,
  roundMilliseconds3bd2pntxev66o as roundMilliseconds,
  FastDuration__toString_impl_c9xohb3u75ye94mx1dw as FastDuration__toString_impl_c9xohb,
} from './korlibs-time-root-korlibs-time-core.mjs';
import {
  arraycopy52dxe7vhzf14 as arraycopy,
  clonelcrqoxe4ne5i as clone,
  Companion_instancejzamqjlqqs4y as Companion_instance_4,
  _Int8Buffer___init__impl__e20lvcp4p2uvfo996c as _Int8Buffer___init__impl__e20lvc,
  _Int8Buffer___get_buffer__impl__q0gulbq12sgwh1jcvh as _Int8Buffer___get_buffer__impl__q0gulb,
  _Float32Buffer___init__impl__403k2m1hlz2hcoqnaef as _Float32Buffer___init__impl__403k2m,
  _Float32Buffer___get_buffer__impl__x5nu9xp04xjj40882q as _Float32Buffer___get_buffer__impl__x5nu9x,
  sliceWithSize2i7i6olf26byj as sliceWithSize,
  Companion_getInstance35xii7iw9kdg2 as Companion_getInstance_9,
  ByteUnits__toString_impl_ox2ku22zb4xrvk9phl9 as ByteUnits__toString_impl_ox2ku2,
  arraycopy3uxsqjlixmnz3 as arraycopy_0,
  Buffer25z94vsj0kb1s as Buffer,
  get_i323p4hlz6j3xys8 as get_i32,
  arraycopy1hsh296f5d0xg as arraycopy_1,
  get_f3218rglfhpgbhzp as get_f32,
  arraycopy3fi6tr79d693r as arraycopy_2,
  get_i83qhdj74rhdyeg as get_i8,
  arraycopyphzg5lpa6gvz as arraycopy_3,
  get_size13scmefs6mbfn as get_size_0,
  allocDirecttfrgytwudkpf as allocDirect,
  sliceBufferpiate0wictoq as sliceBuffer,
  arrayequal25g4om83vd8w1 as arrayequal,
  copyOfnqvdm0sc8lk as copyOf,
  setArrayLEwil75hzlfusu as setArrayLE,
  setInt32178h074gei71f as setInt32,
  getInt32gmg3zyw00v1v as getInt32,
  arraycopy9a0yzbjqwnvw as arraycopy_4,
  Uint16Buffer__set_impl_g0kliu1ltqm2yo4vfb6 as Uint16Buffer__set_impl_g0kliu,
  Float32Buffer__get_impl_659lhu2fcy7ilfo0o6g as Float32Buffer__get_impl_659lhu,
  Float32Buffer__set_impl_34sznedf8x821xo8e0 as Float32Buffer__set_impl_34szne,
  get_u163bxpdbbave1v5 as get_u16,
  setFloat323e0ukqyly1ufv as setFloat32,
  asUShortArrayInt2gfk0h9rafip5 as asUShortArrayInt,
  arraycopy28e1us87mwypg as arraycopy_5,
  arrayadd3erpr00t9k8j as arrayadd,
  arraycopyqmyo4vjwforw as arraycopy_6,
  arrayfill1njpugsfcm512 as arrayfill,
  arrayfill2iqmyqqqfwuaf as arrayfill_0,
  allocNoDirect3dykranmovqsj as allocNoDirect,
  get_arrayUByte9swx7ogt2hf2 as get_arrayUByte,
  get_arrayInt3v8kuk47rixtz as get_arrayInt,
  get_arrayFloat1r0vk858s9phl as get_arrayFloat,
} from './korlibs-memory-root-korlibs-memory.mjs';
import {
  get_niceStr1tlwtz2l2j4my as get_niceStr,
  get_isPowerOfTwoeb2yxu9ww0f7 as get_isPowerOfTwo,
  extract2vhru1ihy4ogl as extract,
  insert52qor1kqho1lpj as insert5,
  insert22yqrzxcpmo55e as insert2,
  insert2fz5125p2hdyd as insert,
  insert42sy0xc4ax89g9 as insert4,
  toShortClampedqjuvod9w2qhj as toShortClamped,
  toIntRound1mv0y8x9hh1p4 as toIntRound,
  toIntRoundjnzmk86x1qp5 as toIntRound_0,
  get_low2kdkn3173rx8r as get_low,
  get_high3vl4k4kkorqlu as get_high,
  insert141hi307uxchfzk as insert14,
  ilog23dbvpk38jf7rc as ilog2,
  insert8f3zk23r8x9da as insert8,
  insert32d422lnha9g5r as insert3,
  extractScaledf013fj6eqsu4szwo as extractScaledf01,
  insertScaledf01oj6k04gavkch as insertScaledf01,
  insertm9bp9ll4cml3 as insert_0,
  min1z074tc6jeruz as min,
  max1izmzj76cv5b4 as max_0,
  nextMultipleOf14oge7vxqp9sy as nextMultipleOf,
  nextAlignedTo2788hp7lcoqp as nextAlignedTo,
  setBitsqsmqq5kc486j as setBits,
  Companion_getInstance2tun2u13u8fzr as Companion_getInstance_10,
  _Ratio___init__impl__9mwvn224skkn3fz6cfs as _Ratio___init__impl__9mwvn2,
  Ratio136tf4z2t0p2d as Ratio,
  interpolate35pbs3ac913y4 as interpolate,
  interpolate2g7wzskc23f1q as interpolate_0,
} from './korlibs-math-core-root-korlibs-math-core.mjs';
import {
  NullBitmap15b22oyta4usb as NullBitmap,
  MultiBitmapk0zsv2zy1mpk as MultiBitmap,
  ForcedTexId3ivekmtdm8t3u as ForcedTexId,
  RGBA__toString_impl_4lw6dp2tumn1mea41fm as RGBA__toString_impl_4lw6dp,
  RGBA__hashCode_impl_h59qf629uhw1oxrapg6 as RGBA__hashCode_impl_h59qf6,
  FloatBitmap321fufbxi3ys0iu as FloatBitmap32,
  Bitmap82ekc5d8xpcfp2 as Bitmap8,
  NativeImagebqxh3nwkmck as NativeImage,
  _RGBA___get_rf__impl__kvz75k2enjmg3zrtnq3 as _RGBA___get_rf__impl__kvz75k,
  _RGBA___get_gf__impl__5gcu1f1tcfjj6a92jd8 as _RGBA___get_gf__impl__5gcu1f,
  _RGBA___get_bf__impl__1xz5yg37iolmxbb8ro0 as _RGBA___get_bf__impl__1xz5yg,
  _RGBA___get_af__impl__vu36qv3fdqajvftucv7 as _RGBA___get_af__impl__vu36qv,
  _RGBAPremultiplied___get_rf__impl__pt0c4yud4u7tot9j6v as _RGBAPremultiplied___get_rf__impl__pt0c4y,
  _RGBAPremultiplied___get_gf__impl__ivron7124n55fu7nftq as _RGBAPremultiplied___get_gf__impl__ivron7,
  _RGBAPremultiplied___get_bf__impl__qa3on231tqs9tgl21ni as _RGBAPremultiplied___get_bf__impl__qa3on2,
  _RGBAPremultiplied___get_af__impl__euwcjn2miyh1t3zubgx as _RGBAPremultiplied___get_af__impl__euwcjn,
  _ColorAdd___get_rf__impl__4xdwim38adda9jzln7f as _ColorAdd___get_rf__impl__4xdwim,
  _ColorAdd___get_gf__impl__v9pxpl3b35saap1pnga as _ColorAdd___get_gf__impl__v9pxpl,
  _ColorAdd___get_bf__impl__nvdxpq26lfvmiy6mias as _ColorAdd___get_bf__impl__nvdxpq,
  _ColorAdd___get_af__impl__60q32p2fncy9agnk301 as _ColorAdd___get_af__impl__60q32p,
  Colors_getInstance2cnv7p5d6jz4u as Colors_getInstance,
  Companion_instance1sgltfeqg9bxt as Companion_instance_5,
  ImageDecodingProps12g4gdsvb3zm5 as ImageDecodingProps,
  readBitmap1yhww5yoq3a9l as readBitmap,
  slice2pfxfvku0ybgy as slice,
  Companion_instance1zw3l6m7tnvps as Companion_instance_6,
  Glyphdz1l7rusab9h as Glyph,
  BitmapFontImpljoxrxbqjo5ee as BitmapFontImpl,
  get_baseMipmapLevel1ty2cgb5p9xw4 as get_baseMipmapLevel,
  get_maxMipmapLevel13juf70j6ney9 as get_maxMipmapLevel,
  _RGBA___get_value__impl__hhco8vehpblbe3f2y8 as _RGBA___get_value__impl__hhco8v,
  RGBA34obx2i62wcl3 as RGBA,
  Bitmaps_instance27726euemn90u as Bitmaps_instance,
  get_Bitmaps_white37u58wbn8ngk2 as get_Bitmaps_white,
  Companion_getInstance2ou2xyvohty1g as Companion_getInstance_11,
  HtmlNativeImagenz79853f60h as HtmlNativeImage,
  toHtmlNative1zcg9na83p2te as toHtmlNative,
} from './korlibs-image-root-korlibs-image.mjs';
import {
  get_hex32p4ssq0y1xxx as get_hex,
  fromBase6434uveajlhn2ar as fromBase64,
} from './korlibs-encoding-root-korlibs-encoding.mjs';
import {
  atomic$int$11d5swdyn6j0pu as atomic$int$1,
  atomic$ref$130aurmcwdfdf1 as atomic$ref$1,
} from './kotlinx-atomicfu.mjs';
import {
  Companion_getInstance2vt0vokm4ixbh as Companion_getInstance_12,
  Indenterdf10c5coibyi as Indenter,
  MountableVfs3mmbka3zq5l6i as MountableVfs,
  get_resourcesVfs3qrvup7jpy9uc as get_resourcesVfs,
  launchImmediatelylnv8lnistpdy as launchImmediately,
  delay2vwv568c245r8 as delay,
  toVfsr7ir4p66g1my as toVfs,
  launchImmediately11za8mkid9pxu as launchImmediately_0,
} from './korlibs-io-root-korlibs-io.mjs';
import {
  DisposableHandle1uzxt8frdchxn as DisposableHandle,
  delay1blitpytzu6gr as delay_0,
  CoroutineName2g5zosw74tf0f as CoroutineName,
  cancelChildrennwartoz0yn6c as cancelChildren,
  CoroutineDispatcherizb7p9bijexj as CoroutineDispatcher,
  Delay9umexudtwyie as Delay,
  cancelAndJoin2j6ktsickm6hy as cancelAndJoin,
  await24mygle6x7vn5 as await_0,
  MainScope1gi1r4abhrtmm as MainScope,
} from './kotlinx-coroutines-core.mjs';
import {
  get_immutablepxpdoj6e54ll as get_immutable,
  Companion_instance2i0t7ux7bzoqc as Companion_instance_7,
  RectSlicec5msorw5q4el as RectSlice,
  Companion_getInstance154uzbkgf0e3s as Companion_getInstance_13,
  toMatrix42ci5k1es0x1v1 as toMatrix4,
  MMatrix1y71lv7vv6y8t as MMatrix,
} from './korlibs-math-root-korlibs-math.mjs';
import { openAsync37anb1e84urmo as openAsync } from './korlibs-io-stream-root-korlibs-io-stream.mjs';
import { InjectorDependency2f8dsqe1kn3nn as InjectorDependency } from './korlibs-inject-root-korlibs-inject.mjs';
import {
  IntTimedCache39ymx9abjz88x as IntTimedCache,
  PerformanceCounter_getInstance3b8d94s1bsc37 as PerformanceCounter_getInstance,
  Stopwatch1guqi4xl0rpfb as Stopwatch,
} from './korlibs-time-root-korlibs-time.mjs';
import {
  FFILiby83bova0zjfy as FFILib,
  Companion_getInstance2ww1whxsubyyu as Companion_getInstance_14,
  FuncInfocud0a7bce10z as FuncInfo,
  CreateFFIPointernsr7ilwulbub as CreateFFIPointer,
  get_pointer2afz2rc14joly as get_pointer_0,
  CreateFFIMemoryv82e6jbfcdze as CreateFFIMemory,
  set3216gyp8r69gas8 as set32,
  CreateFFIMemory2iekizxdvtyvt as CreateFFIMemory_0,
  setFFIPointerjzarmbova4sm as setFFIPointer,
  getS32284qh8a5ldxzn as getS32,
} from './korlibs-ffi-root-korlibs-ffi-legacy.mjs';
//region block: imports
var imul = Math.imul;
//endregion
//region block: pre-declaration
class TimedTask {
  constructor(eventLoop, now, time, interval, callback) {
    this.h68_1 = eventLoop;
    this.i68_1 = now;
    this.j68_1 = time;
    this.k68_1 = interval;
    this.l68_1 = callback;
  }
  m68(value) {
    this.i68_1 = Duration__minus_impl_q5cfm7(value, this.j68_1);
  }
  n68() {
    return Duration__plus_impl_yu9v8f(this.i68_1, this.j68_1);
  }
  o68(other) {
    return Duration__compareTo_impl_pchp0f(this.n68(), other.n68());
  }
  d(other) {
    return this.o68(other instanceof TimedTask ? other : THROW_CCE());
  }
  f6() {
    this.k68_1 = false;
    this.h68_1.y68_1.h2m(this);
  }
}
class BaseEventLoop {
  constructor() {
    this.h69_1 = new Lock();
  }
}
class SyncEventLoop extends BaseEventLoop {
  constructor(immediateRun) {
    immediateRun = immediateRun === VOID ? false : immediateRun;
    super();
    this.q68_1 = immediateRun;
    this.r68_1 = new SyncPauseable();
    this.s68_1 = paused$factory(this.r68_1);
    this.t68_1 = new Lock();
    this.u68_1 = true;
    this.v68_1 = Monotonic_instance.ej();
    var tmp = this;
    tmp.w68_1 = SyncEventLoop$nowProvider$lambda(this);
    this.x68_1 = ArrayDeque.mk();
    var tmp_0 = this;
    var tmp_1 = Companion_instance_0;
    tmp_0.y68_1 = tmp_1.x2q(VOID, SyncEventLoop$timedTasks$lambda);
    var tmp_2 = this;
    tmp_2.z68_1 = SyncEventLoop$uncatchedExceptionHandler$lambda;
    this.a69_1 = null;
  }
  b69(task) {
    // Inline function 'korlibs.concurrent.lock.Lock.invoke' call
    var this_0 = this.t68_1;
    $l$block: {
      // Inline function 'korlibs.concurrent.lock.LockImpl.lockUnlock' call
      this_0.n1v();
      try {
        this.x68_1.pk(task);
        this.t68_1.r1v();
        break $l$block;
      }finally {
        this_0.p1v();
      }
    }
  }
  c69(time, task) {
    return _queueAfter(this, time, false, task);
  }
  f6() {
    var oldImmediateRun = this.q68_1;
    try {
      this.q68_1 = true;
      this.d69();
      this.u68_1 = false;
    }finally {
      this.q68_1 = oldImmediateRun;
    }
  }
  e69(task) {
    if (this.q68_1)
      return true;
    return Duration__compareTo_impl_pchp0f(_get_now__e6dlkr(this), this.y68_1.d2r().n68()) >= 0;
  }
  f69(runTimers) {
    var count = 0;
    while (this.g69(runTimers)) {
      count = count + 1 | 0;
    }
    return count;
  }
  d69(runTimers, $super) {
    runTimers = runTimers === VOID ? true : runTimers;
    return $super === VOID ? this.f69(runTimers) : $super.f69.call(this, runTimers);
  }
  g69(runTimers) {
    // Inline function 'korlibs.concurrent.lock.Lock.invoke' call
    var this_0 = this.t68_1;
    var tmp$ret$2;
    $l$block: {
      // Inline function 'korlibs.concurrent.lock.LockImpl.lockUnlock' call
      this_0.n1v();
      try {
        // Inline function 'korlibs.datastructure.event.SyncEventLoop.runAvailableNextTask.<anonymous>' call
        var tmp;
        if (runTimers) {
          var tmp_0;
          var tmp_1;
          // Inline function 'kotlin.collections.isNotEmpty' call
          if (!this.y68_1.g1()) {
            tmp_1 = this.e69(this.y68_1.d2r());
          } else {
            tmp_1 = false;
          }
          if (tmp_1) {
            tmp_0 = this.y68_1.e2r();
          } else {
            tmp_0 = null;
          }
          tmp = tmp_0;
        } else {
          tmp = null;
        }
        tmp$ret$2 = tmp;
        break $l$block;
      }finally {
        this_0.p1v();
      }
    }
    var timedTask = tmp$ret$2;
    if (!(timedTask == null)) {
      // Inline function 'korlibs.datastructure.event.SyncEventLoop.runCatchingExceptions' call
      try {
        // Inline function 'kotlin.run' call
        // Inline function 'kotlin.contracts.contract' call
        // Inline function 'korlibs.datastructure.event.SyncEventLoop.runAvailableNextTask.<anonymous>' call
        timedTask.l68_1();
      } catch ($p) {
        if ($p instanceof Error) {
          var e = $p;
          this.z68_1(e);
        } else {
          throw $p;
        }
      }
      if (timedTask.k68_1 && !this.q68_1) {
        timedTask.m68(maxOf(new Duration(Duration__plus_impl_yu9v8f(timedTask.n68(), timedTask.j68_1)), new Duration(_get_now__e6dlkr(this))).kj_1);
        this.y68_1.g2m(timedTask);
      }
    }
    // Inline function 'korlibs.concurrent.lock.Lock.invoke' call
    var this_1 = this.t68_1;
    var tmp$ret$7;
    $l$block_0: {
      // Inline function 'korlibs.concurrent.lock.LockImpl.lockUnlock' call
      this_1.n1v();
      try {
        // Inline function 'korlibs.datastructure.event.SyncEventLoop.runAvailableNextTask.<anonymous>' call
        var tmp_2;
        // Inline function 'kotlin.collections.isNotEmpty' call
        if (!this.x68_1.g1()) {
          tmp_2 = this.x68_1.qk();
        } else {
          tmp_2 = null;
        }
        tmp$ret$7 = tmp_2;
        break $l$block_0;
      }finally {
        this_1.p1v();
      }
    }
    var task = tmp$ret$7;
    // Inline function 'korlibs.datastructure.event.SyncEventLoop.runCatchingExceptions' call
    try {
      // Inline function 'kotlin.run' call
      // Inline function 'kotlin.contracts.contract' call
      if (task == null)
        null;
      else
        task();
    } catch ($p) {
      if ($p instanceof Error) {
        var e_0 = $p;
        this.z68_1(e_0);
      } else {
        throw $p;
      }
    }
    return !(task == null) || !(timedTask == null);
  }
}
class Listener {
  constructor(func, node, base) {
    this.i69_1 = func;
    this.j69_1 = node;
    this.k69_1 = base;
  }
  f6() {
    if (this.j69_1.m69_1.m3(this)) {
      __updateChildListenerCount(this.k69_1, this.j69_1.l69_1, -1);
    }
  }
  o69() {
    this.j69_1.m69_1.h(this);
    __updateChildListenerCount(this.k69_1, this.j69_1.l69_1, 1);
  }
}
class ListenerNode {
  constructor(type) {
    this.l69_1 = type;
    this.m69_1 = FastArrayList.sy();
    this.n69_1 = FastArrayList.sy();
  }
}
class EventListener {}
function onEvents(etypes, handler) {
  // Inline function 'kotlin.collections.isEmpty' call
  if (etypes.length === 0) {
    // Inline function 'kotlin.error' call
    var message = 'Must have at least one event type';
    throw IllegalStateException.z4(toString(message));
  }
  var closeable = new CancellableGroup();
  // Inline function 'korlibs.datastructure.iterators.fastForEach' call
  var n = 0;
  while (n < etypes.length) {
    // Inline function 'korlibs.event.EventListener.onEvents.<anonymous>' call
    var _unary__edvuaz = n;
    n = _unary__edvuaz + 1 | 0;
    var it = etypes[_unary__edvuaz];
    closeable.cs(this.v69(it, handler));
  }
  return closeable;
}
function dispatch(type, event, result) {
  return this.x69(type, event, result, true, true);
}
function dispatch$default(type, event, result, $super) {
  result = result === VOID ? null : result;
  return $super === VOID ? this.e6a(type, event, result) : dispatch(type, event, result);
}
function dispatchDown(type, event, result) {
  return this.x69(type, event, result, false, true);
}
function dispatchUp(type, event, result) {
  return this.x69(type, event, result, true, false);
}
function dispatch_0(event) {
  // Inline function 'korlibs.datastructure.fastCastTo' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  return this.f6a(event.w29(), event);
}
class BaseEventListener {
  static t69() {
    var $this = createThis(this);
    $this.p69_1 = null;
    $this.q69_1 = null;
    $this.r69_1 = null;
    $this.s69_1 = null;
    return $this;
  }
  ay(_set____db54di) {
    this.p69_1 = _set____db54di;
  }
  by() {
    return this.p69_1;
  }
  u69(other) {
    var tmp0_safe_receiver = this.q69_1;
    if (tmp0_safe_receiver == null)
      null;
    else {
      __updateChildListenerCount_0(tmp0_safe_receiver, this, false);
    }
    this.q69_1 = other;
    var tmp1_safe_receiver = this.q69_1;
    if (tmp1_safe_receiver == null)
      null;
    else {
      __updateChildListenerCount_0(tmp1_safe_receiver, this, true);
    }
  }
  v69(type, handler) {
    if (this.r69_1 == null)
      this.r69_1 = FastIdentityMap();
    var tmp$ret$0;
    $l$block: {
      // Inline function 'korlibs.datastructure.getOrPut' call
      var this_0 = ensureNotNull(this.r69_1);
      var res = get_0(this_0, type);
      if (!(res == null)) {
        tmp$ret$0 = res;
        break $l$block;
      }
      // Inline function 'korlibs.event.BaseEventListener.onEvent.<anonymous>' call
      var out = new ListenerNode(type);
      set(this_0, type, out);
      tmp$ret$0 = out;
    }
    var tmp = tmp$ret$0;
    var lists = tmp instanceof ListenerNode ? tmp : THROW_CCE();
    // Inline function 'kotlin.also' call
    var this_1 = new Listener(handler, lists, this);
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.event.BaseEventListener.onEvent.<anonymous>' call
    this_1.o69();
    return this_1;
  }
  w69(type) {
    var tmp0_safe_receiver = this.r69_1;
    var tmp = tmp0_safe_receiver == null ? null : get_0(tmp0_safe_receiver, type);
    return tmp instanceof ListenerNode ? tmp : null;
  }
  x69(type, event, result, up, down) {
    var eventListenerCount = this.y69(type);
    if (eventListenerCount <= 0)
      return false;
    if (down) {
      this.z69(type, event, result);
    }
    var listeners = this.w69(type);
    var tmp1_safe_receiver = listeners == null ? null : listeners.m69_1;
    if (tmp1_safe_receiver == null)
      null;
    else {
      // Inline function 'korlibs.datastructure.iterators.fastForEachWithTemp' call
      var temp = listeners.n69_1;
      toFastList(tmp1_safe_receiver, temp);
      try {
        // Inline function 'korlibs.datastructure.FastArrayList.fastForEach' call
        // Inline function 'korlibs.datastructure.FastArrayList.jsArray' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        var array = temp.qy_1;
        var n = 0;
        while (n < array.length) {
          // Inline function 'korlibs.event.BaseEventListener.dispatch.<anonymous>' call
          // Inline function 'kotlin.js.unsafeCast' call
          // Inline function 'korlibs.datastructure.get' call
          var _unary__edvuaz = n;
          n = _unary__edvuaz + 1 | 0;
          // Inline function 'kotlin.js.asDynamic' call
          // Inline function 'kotlin.js.asDynamic' call
          array[_unary__edvuaz].i69_1(event);
          if (result == null)
            null;
          else {
            // Inline function 'kotlin.let' call
            // Inline function 'kotlin.contracts.contract' call
            result.b6a_1 = result.b6a_1 + 1 | 0;
          }
        }
      }finally {
        temp.l3();
      }
    }
    if (up) {
      this.c6a(type, event, result);
    }
    if (result == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'korlibs.event.BaseEventListener.dispatch.<anonymous>' call
      result.a6a_1 = result.a6a_1 + 1 | 0;
    }
    return event.d6a();
  }
  e6a(type, event, result) {
    return dispatch.call(this, type, event, result);
  }
  g6a(event) {
    return dispatch_0.call(this, event);
  }
  c6a(type, event, result) {
  }
  z69(type, event, result) {
  }
  y69(type) {
    var tmp0_safe_receiver = this.s69_1;
    var tmp;
    if (tmp0_safe_receiver == null) {
      tmp = null;
    } else {
      // Inline function 'korlibs.datastructure.getNull' call
      tmp = type == null ? null : get_0(tmp0_safe_receiver, type);
    }
    var tmp1_elvis_lhs = tmp;
    return tmp1_elvis_lhs == null ? 0 : tmp1_elvis_lhs;
  }
}
class EventResult {
  constructor(iterationCount, resultCount) {
    iterationCount = iterationCount === VOID ? 0 : iterationCount;
    resultCount = resultCount === VOID ? 0 : resultCount;
    this.a6a_1 = iterationCount;
    this.b6a_1 = resultCount;
  }
  t2q() {
    this.a6a_1 = 0;
    this.b6a_1 = 0;
  }
  toString() {
    return 'EventResult(iterationCount=' + this.a6a_1 + ', resultCount=' + this.b6a_1 + ')';
  }
  hashCode() {
    var result = this.a6a_1;
    result = imul(result, 31) + this.b6a_1 | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof EventResult))
      return false;
    var tmp0_other_with_cast = other instanceof EventResult ? other : THROW_CCE();
    if (!(this.a6a_1 === tmp0_other_with_cast.a6a_1))
      return false;
    if (!(this.b6a_1 === tmp0_other_with_cast.b6a_1))
      return false;
    return true;
  }
}
class Companion {}
class Event {
  constructor() {
    this.n6a_1 = null;
    this.o6a_1 = false;
  }
  p6a(_set____db54di) {
    this.n6a_1 = _set____db54di;
  }
  a6d(reason) {
    throw StopPropagatingException.q6d(reason);
  }
  q6a(_set____db54di) {
    this.o6a_1 = _set____db54di;
  }
  d6a() {
    return this.o6a_1;
  }
  r6a(reason) {
    this.o6a_1 = true;
  }
  s6a(reason, $super) {
    reason = reason === VOID ? null : reason;
    var tmp;
    if ($super === VOID) {
      this.r6a(reason);
      tmp = Unit_instance;
    } else {
      tmp = $super.r6a.call(this, reason);
    }
    return tmp;
  }
}
class TypedEvent extends Event {
  constructor(type) {
    super();
    this.m6a_1 = type;
  }
  w29() {
    return this.m6a_1;
  }
}
class PauseEvent extends TypedEvent {
  constructor() {
    super(Companion_instance_8);
  }
}
class Companion_0 {}
class ResumeEvent extends TypedEvent {
  constructor() {
    super(Companion_instance_9);
  }
}
class Companion_1 {}
class StopEvent extends TypedEvent {
  constructor() {
    super(Companion_instance_10);
  }
}
class Companion_2 {}
class DestroyEvent extends TypedEvent {
  constructor() {
    super(Companion_instance_11);
  }
}
class RenderEvent extends TypedEvent {
  constructor() {
    Companion_getInstance_19();
    super(Companion_getInstance_19());
    this.w6a_1 = true;
    this.x6a_1 = true;
  }
  toString() {
    return 'RenderEvent(update=' + this.w6a_1 + ', render=' + this.x6a_1 + ')';
  }
}
class Companion_3 extends RenderEvent {
  constructor() {
    Companion_instance_12 = null;
    super();
    Companion_instance_12 = this;
  }
}
class InitEvent extends TypedEvent {
  constructor() {
    Companion_getInstance_20();
    super(Companion_getInstance_20());
  }
}
class Companion_4 extends InitEvent {
  constructor() {
    Companion_instance_13 = null;
    super();
    Companion_instance_13 = this;
  }
}
class Companion_5 {}
class DisposeEvent extends TypedEvent {
  constructor() {
    super(Companion_instance_14);
  }
}
class Companion_6 {}
class FullScreenEvent extends TypedEvent {
  constructor(fullscreen) {
    fullscreen = fullscreen === VOID ? false : fullscreen;
    super(Companion_instance_15);
    this.b6b_1 = fullscreen;
  }
  toString() {
    return 'FullScreenEvent(fullscreen=' + this.b6b_1 + ')';
  }
  hashCode() {
    return getBooleanHashCode(this.b6b_1);
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof FullScreenEvent))
      return false;
    var tmp0_other_with_cast = other instanceof FullScreenEvent ? other : THROW_CCE();
    if (!(this.b6b_1 === tmp0_other_with_cast.b6b_1))
      return false;
    return true;
  }
}
class Companion_7 {}
class ReshapeEvent extends TypedEvent {
  constructor(x, y, width, height, setPos) {
    x = x === VOID ? 0 : x;
    y = y === VOID ? 0 : y;
    width = width === VOID ? 0 : width;
    height = height === VOID ? 0 : height;
    setPos = setPos === VOID ? true : setPos;
    super(Companion_instance_16);
    this.f6b_1 = x;
    this.g6b_1 = y;
    this.h6b_1 = width;
    this.i6b_1 = height;
    this.j6b_1 = setPos;
  }
  toString() {
    return 'ReshapeEvent(x=' + this.f6b_1 + ', y=' + this.g6b_1 + ', width=' + this.h6b_1 + ', height=' + this.i6b_1 + ', setPos=' + this.j6b_1 + ')';
  }
  hashCode() {
    var result = this.f6b_1;
    result = imul(result, 31) + this.g6b_1 | 0;
    result = imul(result, 31) + this.h6b_1 | 0;
    result = imul(result, 31) + this.i6b_1 | 0;
    result = imul(result, 31) + getBooleanHashCode(this.j6b_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof ReshapeEvent))
      return false;
    var tmp0_other_with_cast = other instanceof ReshapeEvent ? other : THROW_CCE();
    if (!(this.f6b_1 === tmp0_other_with_cast.f6b_1))
      return false;
    if (!(this.g6b_1 === tmp0_other_with_cast.g6b_1))
      return false;
    if (!(this.h6b_1 === tmp0_other_with_cast.h6b_1))
      return false;
    if (!(this.i6b_1 === tmp0_other_with_cast.i6b_1))
      return false;
    if (!(this.j6b_1 === tmp0_other_with_cast.j6b_1))
      return false;
    return true;
  }
}
class Companion_8 {
  constructor() {
    Companion_instance_17 = this;
    this.k6b_1 = values();
  }
}
class Type extends Enum {}
class KeyEvent extends Event {
  constructor(type, id, key, keyCode, character, shift, ctrl, alt, meta, str) {
    type = type === VOID ? Type_UP_getInstance() : type;
    id = id === VOID ? 0 : id;
    key = key === VOID ? Key_UP_getInstance() : key;
    keyCode = keyCode === VOID ? 0 : keyCode;
    character = character === VOID ? _Char___init__impl__6a9atx(0) : character;
    shift = shift === VOID ? false : shift;
    ctrl = ctrl === VOID ? false : ctrl;
    alt = alt === VOID ? false : alt;
    meta = meta === VOID ? false : meta;
    str = str === VOID ? null : str;
    super();
    this.n6b_1 = type;
    this.o6b_1 = id;
    this.p6b_1 = key;
    this.q6b_1 = keyCode;
    this.r6b_1 = character;
    this.s6b_1 = shift;
    this.t6b_1 = ctrl;
    this.u6b_1 = alt;
    this.v6b_1 = meta;
    this.w6b_1 = str;
    this.x6b_1 = Companion_getInstance().lj_1;
  }
  w29() {
    return this.n6b_1;
  }
  y6b() {
    var tmp0_elvis_lhs = this.w6b_1;
    return tmp0_elvis_lhs == null ? toString_0(this.r6b_1) : tmp0_elvis_lhs;
  }
  z6b() {
    return Companion_getInstance_2().iu().fu() ? this.v6b_1 : this.t6b_1;
  }
  toString() {
    return 'KeyEvent(type=' + toString(this.n6b_1) + ', id=' + this.o6b_1 + ', key=' + this.p6b_1.toString() + ', keyCode=' + this.q6b_1 + ', character=' + toString_0(this.r6b_1) + ', shift=' + this.s6b_1 + ', ctrl=' + this.t6b_1 + ', alt=' + this.u6b_1 + ', meta=' + this.v6b_1 + ', str=' + this.w6b_1 + ')';
  }
  hashCode() {
    var result = this.n6b_1.hashCode();
    result = imul(result, 31) + this.o6b_1 | 0;
    result = imul(result, 31) + this.p6b_1.hashCode() | 0;
    result = imul(result, 31) + this.q6b_1 | 0;
    result = imul(result, 31) + Char__hashCode_impl_otmys(this.r6b_1) | 0;
    result = imul(result, 31) + getBooleanHashCode(this.s6b_1) | 0;
    result = imul(result, 31) + getBooleanHashCode(this.t6b_1) | 0;
    result = imul(result, 31) + getBooleanHashCode(this.u6b_1) | 0;
    result = imul(result, 31) + getBooleanHashCode(this.v6b_1) | 0;
    result = imul(result, 31) + (this.w6b_1 == null ? 0 : getStringHashCode(this.w6b_1)) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof KeyEvent))
      return false;
    var tmp0_other_with_cast = other instanceof KeyEvent ? other : THROW_CCE();
    if (!this.n6b_1.equals(tmp0_other_with_cast.n6b_1))
      return false;
    if (!(this.o6b_1 === tmp0_other_with_cast.o6b_1))
      return false;
    if (!this.p6b_1.equals(tmp0_other_with_cast.p6b_1))
      return false;
    if (!(this.q6b_1 === tmp0_other_with_cast.q6b_1))
      return false;
    if (!(this.r6b_1 === tmp0_other_with_cast.r6b_1))
      return false;
    if (!(this.s6b_1 === tmp0_other_with_cast.s6b_1))
      return false;
    if (!(this.t6b_1 === tmp0_other_with_cast.t6b_1))
      return false;
    if (!(this.u6b_1 === tmp0_other_with_cast.u6b_1))
      return false;
    if (!(this.v6b_1 === tmp0_other_with_cast.v6b_1))
      return false;
    if (!(this.w6b_1 == tmp0_other_with_cast.w6b_1))
      return false;
    return true;
  }
}
class Companion_9 {
  constructor() {
    Companion_instance_18 = this;
    this.a6c_1 = values_0();
  }
}
class Type_0 extends Enum {}
class ScrollDeltaMode extends Enum {
  constructor(name, ordinal, scale) {
    super(name, ordinal);
    this.d6c_1 = scale;
  }
}
class MouseEvent extends Event {
  constructor(type, id, x, y, button, buttons, scrollDeltaX, scrollDeltaY, scrollDeltaZ, isShiftDown, isCtrlDown, isAltDown, isMetaDown, scaleCoords, emulated, scrollDeltaMode) {
    type = type === VOID ? Type_MOVE_getInstance() : type;
    id = id === VOID ? 0 : id;
    x = x === VOID ? 0 : x;
    y = y === VOID ? 0 : y;
    button = button === VOID ? MouseButton_NONE_getInstance() : button;
    buttons = buttons === VOID ? 0 : buttons;
    scrollDeltaX = scrollDeltaX === VOID ? 0.0 : scrollDeltaX;
    scrollDeltaY = scrollDeltaY === VOID ? 0.0 : scrollDeltaY;
    scrollDeltaZ = scrollDeltaZ === VOID ? 0.0 : scrollDeltaZ;
    isShiftDown = isShiftDown === VOID ? false : isShiftDown;
    isCtrlDown = isCtrlDown === VOID ? false : isCtrlDown;
    isAltDown = isAltDown === VOID ? false : isAltDown;
    isMetaDown = isMetaDown === VOID ? false : isMetaDown;
    scaleCoords = scaleCoords === VOID ? true : scaleCoords;
    emulated = emulated === VOID ? false : emulated;
    scrollDeltaMode = scrollDeltaMode === VOID ? ScrollDeltaMode_LINE_getInstance() : scrollDeltaMode;
    super();
    this.g6c_1 = type;
    this.h6c_1 = id;
    this.i6c_1 = x;
    this.j6c_1 = y;
    this.k6c_1 = button;
    this.l6c_1 = buttons;
    this.m6c_1 = scrollDeltaX;
    this.n6c_1 = scrollDeltaY;
    this.o6c_1 = scrollDeltaZ;
    this.p6c_1 = isShiftDown;
    this.q6c_1 = isCtrlDown;
    this.r6c_1 = isAltDown;
    this.s6c_1 = isMetaDown;
    this.t6c_1 = scaleCoords;
    this.u6c_1 = emulated;
    this.v6c_1 = scrollDeltaMode;
    this.w6c_1 = null;
    var tmp = this;
    tmp.x6c_1 = MouseEvent$requestLock$lambda;
  }
  w29() {
    return this.g6c_1;
  }
  y6c(other) {
    this.g6c_1 = other.g6c_1;
    this.h6c_1 = other.h6c_1;
    this.i6c_1 = other.i6c_1;
    this.j6c_1 = other.j6c_1;
    this.k6c_1 = other.k6c_1;
    this.l6c_1 = other.l6c_1;
    this.m6c_1 = other.m6c_1;
    this.n6c_1 = other.n6c_1;
    this.o6c_1 = other.o6c_1;
    this.p6c_1 = other.p6c_1;
    this.q6c_1 = other.q6c_1;
    this.r6c_1 = other.r6c_1;
    this.s6c_1 = other.s6c_1;
    this.t6c_1 = other.t6c_1;
    this.u6c_1 = other.u6c_1;
    this.v6c_1 = other.v6c_1;
  }
  z6c(mode, x, y, z) {
    this.v6c_1 = mode;
    this.m6c_1 = x;
    this.n6c_1 = y;
    this.o6c_1 = z;
  }
  toString() {
    return 'MouseEvent(type=' + toString(this.g6c_1) + ', id=' + this.h6c_1 + ', x=' + this.i6c_1 + ', y=' + this.j6c_1 + ', button=' + this.k6c_1.toString() + ', buttons=' + this.l6c_1 + ', scrollDeltaX=' + this.m6c_1 + ', scrollDeltaY=' + this.n6c_1 + ', scrollDeltaZ=' + this.o6c_1 + ', isShiftDown=' + this.p6c_1 + ', isCtrlDown=' + this.q6c_1 + ', isAltDown=' + this.r6c_1 + ', isMetaDown=' + this.s6c_1 + ', scaleCoords=' + this.t6c_1 + ', emulated=' + this.u6c_1 + ', scrollDeltaMode=' + this.v6c_1.toString() + ')';
  }
  hashCode() {
    var result = this.g6c_1.hashCode();
    result = imul(result, 31) + this.h6c_1 | 0;
    result = imul(result, 31) + this.i6c_1 | 0;
    result = imul(result, 31) + this.j6c_1 | 0;
    result = imul(result, 31) + this.k6c_1.hashCode() | 0;
    result = imul(result, 31) + this.l6c_1 | 0;
    result = imul(result, 31) + getNumberHashCode(this.m6c_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.n6c_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.o6c_1) | 0;
    result = imul(result, 31) + getBooleanHashCode(this.p6c_1) | 0;
    result = imul(result, 31) + getBooleanHashCode(this.q6c_1) | 0;
    result = imul(result, 31) + getBooleanHashCode(this.r6c_1) | 0;
    result = imul(result, 31) + getBooleanHashCode(this.s6c_1) | 0;
    result = imul(result, 31) + getBooleanHashCode(this.t6c_1) | 0;
    result = imul(result, 31) + getBooleanHashCode(this.u6c_1) | 0;
    result = imul(result, 31) + this.v6c_1.hashCode() | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof MouseEvent))
      return false;
    var tmp0_other_with_cast = other instanceof MouseEvent ? other : THROW_CCE();
    if (!this.g6c_1.equals(tmp0_other_with_cast.g6c_1))
      return false;
    if (!(this.h6c_1 === tmp0_other_with_cast.h6c_1))
      return false;
    if (!(this.i6c_1 === tmp0_other_with_cast.i6c_1))
      return false;
    if (!(this.j6c_1 === tmp0_other_with_cast.j6c_1))
      return false;
    if (!this.k6c_1.equals(tmp0_other_with_cast.k6c_1))
      return false;
    if (!(this.l6c_1 === tmp0_other_with_cast.l6c_1))
      return false;
    if (!equals(this.m6c_1, tmp0_other_with_cast.m6c_1))
      return false;
    if (!equals(this.n6c_1, tmp0_other_with_cast.n6c_1))
      return false;
    if (!equals(this.o6c_1, tmp0_other_with_cast.o6c_1))
      return false;
    if (!(this.p6c_1 === tmp0_other_with_cast.p6c_1))
      return false;
    if (!(this.q6c_1 === tmp0_other_with_cast.q6c_1))
      return false;
    if (!(this.r6c_1 === tmp0_other_with_cast.r6c_1))
      return false;
    if (!(this.s6c_1 === tmp0_other_with_cast.s6c_1))
      return false;
    if (!(this.t6c_1 === tmp0_other_with_cast.t6c_1))
      return false;
    if (!(this.u6c_1 === tmp0_other_with_cast.u6c_1))
      return false;
    if (!this.v6c_1.equals(tmp0_other_with_cast.v6c_1))
      return false;
    return true;
  }
}
class Companion_10 {
  constructor() {
    Companion_instance_19 = this;
    this.b6d_1 = values_1();
  }
}
class Type_1 extends Enum {}
class GestureEvent extends Event {
  constructor(type, id, amountX, amountY) {
    type = type === VOID ? Type_MAGNIFY_getInstance() : type;
    id = id === VOID ? 0 : id;
    amountX = amountX === VOID ? 0.0 : amountX;
    amountY = amountY === VOID ? 0.0 : amountY;
    super();
    this.e6d_1 = type;
    this.f6d_1 = id;
    this.g6d_1 = amountX;
    this.h6d_1 = amountY;
  }
  w29() {
    return this.e6d_1;
  }
  toString() {
    return 'GestureEvent(type=' + toString(this.e6d_1) + ', id=' + this.f6d_1 + ', amountX=' + this.g6d_1 + ', amountY=' + this.h6d_1 + ')';
  }
  hashCode() {
    var result = this.e6d_1.hashCode();
    result = imul(result, 31) + this.f6d_1 | 0;
    result = imul(result, 31) + getNumberHashCode(this.g6d_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.h6d_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof GestureEvent))
      return false;
    var tmp0_other_with_cast = other instanceof GestureEvent ? other : THROW_CCE();
    if (!this.e6d_1.equals(tmp0_other_with_cast.e6d_1))
      return false;
    if (!(this.f6d_1 === tmp0_other_with_cast.f6d_1))
      return false;
    if (!equals(this.g6d_1, tmp0_other_with_cast.g6d_1))
      return false;
    if (!equals(this.h6d_1, tmp0_other_with_cast.h6d_1))
      return false;
    return true;
  }
}
class Companion_11 {
  constructor() {
    Companion_instance_20 = this;
    this.i6d_1 = values_2();
  }
}
class Type_2 extends Enum {}
class DropFileEvent extends Event {
  constructor(type, files) {
    type = type === VOID ? Type_START_getInstance() : type;
    files = files === VOID ? null : files;
    super();
    this.l6d_1 = type;
    this.m6d_1 = files;
  }
  w29() {
    return this.l6d_1;
  }
  toString() {
    return 'DropFileEvent(type=' + toString(this.l6d_1) + ', files=' + toString_1(this.m6d_1) + ')';
  }
  hashCode() {
    var result = this.l6d_1.hashCode();
    result = imul(result, 31) + (this.m6d_1 == null ? 0 : hashCode(this.m6d_1)) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof DropFileEvent))
      return false;
    var tmp0_other_with_cast = other instanceof DropFileEvent ? other : THROW_CCE();
    if (!this.l6d_1.equals(tmp0_other_with_cast.l6d_1))
      return false;
    if (!equals(this.m6d_1, tmp0_other_with_cast.m6d_1))
      return false;
    return true;
  }
}
class StopPropagatingException extends Exception {
  static q6d(reason) {
    reason = reason === VOID ? null : reason;
    var $this = this.xd();
    captureStack($this, $this.p6d_1);
    $this.o6d_1 = reason;
    return $this;
  }
}
class Status extends Enum {}
class Kind extends Enum {}
class Companion_12 {
  constructor() {
    Companion_instance_21 = this;
    this.r6d_1 = new Touch(-1);
  }
}
class Touch {
  constructor(index, id, p, force, status, kind, button) {
    Companion_getInstance_28();
    index = index === VOID ? -1 : index;
    id = id === VOID ? -1 : id;
    p = p === VOID ? Companion_getInstance_4().o25_1 : p;
    force = force === VOID ? 1.0 : force;
    status = status === VOID ? Status_KEEP_getInstance() : status;
    kind = kind === VOID ? Kind_FINGER_getInstance() : kind;
    button = button === VOID ? MouseButton_LEFT_getInstance() : button;
    this.s6d_1 = new Mixin();
    this.t6d_1 = index;
    this.u6d_1 = id;
    this.v6d_1 = p;
    this.w6d_1 = force;
    this.x6d_1 = status;
    this.y6d_1 = kind;
    this.z6d_1 = button;
  }
  a6e() {
    return this.v6d_1.m25_1;
  }
  b6e() {
    return this.v6d_1.n25_1;
  }
  c15() {
    return !this.x6d_1.equals(Status_REMOVE_getInstance());
  }
  c6e(other) {
    this.u6d_1 = other.u6d_1;
    this.v6d_1 = other.v6d_1;
    this.w6d_1 = other.w6d_1;
    this.x6d_1 = other.x6d_1;
    this.y6d_1 = other.y6d_1;
    this.z6d_1 = other.z6d_1;
  }
  hashCode() {
    return this.t6d_1;
  }
  equals(other) {
    var tmp;
    if (other instanceof Touch) {
      tmp = this.t6d_1 === other.t6d_1;
    } else {
      tmp = false;
    }
    return tmp;
  }
  toString() {
    return 'Touch(index=' + this.t6d_1 + ', id=' + this.u6d_1 + ', p=' + this.v6d_1.toString() + ', force=' + this.w6d_1 + ', status=' + this.x6d_1.toString() + ', kind=' + this.y6d_1.toString() + ', button=' + this.z6d_1.toString() + ')';
  }
  ay(value) {
    this.s6d_1.ay(value);
  }
  by() {
    return this.s6d_1.by();
  }
}
class Companion_13 {
  constructor() {
    Companion_instance_22 = this;
    this.d6e_1 = values_3();
  }
}
class Type_3 extends Enum {}
class Companion_14 {
  constructor() {
    this.e6e_1 = 10;
  }
}
class TouchEvent extends Event {
  constructor(type, screen, currentTime, scaleCoords, emulated) {
    type = type === VOID ? Type_START_getInstance_0() : type;
    screen = screen === VOID ? 0 : screen;
    currentTime = currentTime === VOID ? Companion_getInstance_8().t1u_1 : currentTime;
    scaleCoords = scaleCoords === VOID ? true : scaleCoords;
    emulated = emulated === VOID ? false : emulated;
    super();
    this.h6e_1 = type;
    this.i6e_1 = screen;
    this.j6e_1 = currentTime;
    this.k6e_1 = scaleCoords;
    this.l6e_1 = emulated;
    var tmp = this;
    var tmp_0 = 0;
    var tmp_1 = Companion_instance_23.e6e_1;
    // Inline function 'kotlin.arrayOfNulls' call
    var tmp_2 = fillArrayVal(Array(tmp_1), null);
    while (tmp_0 < tmp_1) {
      var tmp_3 = tmp_0;
      tmp_2[tmp_3] = new Touch(tmp_3);
      tmp_0 = tmp_0 + 1 | 0;
    }
    tmp.m6e_1 = tmp_2;
    this.n6e_1 = FastArrayList.sy();
    this.o6e_1 = FastArrayList.sy();
    this.p6e_1 = FastIntMap();
  }
  w29() {
    return this.h6e_1;
  }
  q6e() {
    return this.n6e_1;
  }
  r6e() {
    return this.q6e().e1();
  }
  s6e(id) {
    // Inline function 'korlibs.datastructure.get' call
    // Inline function 'kotlin.js.asDynamic' call
    return this.p6e_1.get(id);
  }
  toString() {
    var tmp = toString(this.h6e_1);
    var tmp_0 = this.r6e();
    var tmp_1 = this.q6e();
    return 'TouchEvent[' + tmp + '][' + tmp_0 + '](' + joinToString(tmp_1, ', ', VOID, VOID, VOID, VOID, TouchEvent$toString$lambda) + ')';
  }
  t6e(type) {
    this.h6e_1 = type;
    this.j6e_1 = Companion_getInstance_8().x1u();
    this.n6e_1.l3();
    // Inline function 'korlibs.datastructure.clear' call
    // Inline function 'kotlin.js.asDynamic' call
    this.p6e_1.clear();
  }
  u6e() {
    this.o6e_1.l3();
    // Inline function 'korlibs.datastructure.iterators.fastForEach' call
    var this_0 = this.q6e();
    var n = 0;
    while (n < this_0.e1()) {
      // Inline function 'korlibs.event.TouchEvent.endFrame.<anonymous>' call
      var _unary__edvuaz = n;
      n = _unary__edvuaz + 1 | 0;
      var it = this_0.d1(_unary__edvuaz);
      if (it.c15()) {
        this.o6e_1.h(it);
      }
    }
  }
  v6e(id) {
    // Inline function 'korlibs.datastructure.get' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp0_elvis_lhs = this.p6e_1.get(id);
    return tmp0_elvis_lhs == null ? this.w6e(id) : tmp0_elvis_lhs;
  }
  w6e(id) {
    var touch = this.m6e_1[this.n6e_1.e1()];
    touch.u6d_1 = id;
    this.n6e_1.h(touch);
    // Inline function 'korlibs.datastructure.set' call
    var this_0 = this.p6e_1;
    var key = touch.u6d_1;
    // Inline function 'kotlin.js.asDynamic' call
    this_0.set(key, touch);
    return touch;
  }
  x6e(id, p, status, force, kind, button) {
    var touch = this.v6e(id);
    touch.v6d_1 = p;
    touch.x6d_1 = status;
    touch.w6d_1 = force;
    touch.y6d_1 = kind;
    touch.z6d_1 = button;
  }
  y6e(id, p, status, force, kind, button, $super) {
    status = status === VOID ? Status_KEEP_getInstance() : status;
    force = force === VOID ? 1.0 : force;
    kind = kind === VOID ? Kind_FINGER_getInstance() : kind;
    button = button === VOID ? MouseButton_LEFT_getInstance() : button;
    var tmp;
    if ($super === VOID) {
      this.x6e(id, p, status, force, kind, button);
      tmp = Unit_instance;
    } else {
      tmp = $super.x6e.call(this, id, p, status, force, kind, button);
    }
    return tmp;
  }
  z6e(touch) {
    this.x6e(touch.u6d_1, touch.v6d_1, touch.x6d_1, touch.w6d_1, touch.y6d_1, touch.z6d_1);
  }
  a6f(other) {
    this.h6e_1 = other.h6e_1;
    this.i6e_1 = other.i6e_1;
    this.j6e_1 = other.j6e_1;
    this.k6e_1 = other.k6e_1;
    this.l6e_1 = other.l6e_1;
    var inductionVariable = 0;
    var last = Companion_instance_23.e6e_1;
    if (inductionVariable < last)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        this.m6e_1[n].c6e(other.m6e_1[n]);
      }
       while (inductionVariable < last);
    this.n6e_1.l3();
    this.o6e_1.l3();
    // Inline function 'korlibs.datastructure.clear' call
    // Inline function 'kotlin.js.asDynamic' call
    this.p6e_1.clear();
    // Inline function 'korlibs.datastructure.iterators.fastForEach' call
    var this_0 = other.q6e();
    var n_0 = 0;
    while (n_0 < this_0.e1()) {
      // Inline function 'korlibs.event.TouchEvent.copyFrom.<anonymous>' call
      var _unary__edvuaz = n_0;
      n_0 = _unary__edvuaz + 1 | 0;
      var otherTouch = this_0.d1(_unary__edvuaz);
      var touch = this.m6e_1[otherTouch.t6d_1];
      this.n6e_1.h(touch);
      if (touch.c15()) {
        this.o6e_1.h(touch);
      }
      // Inline function 'korlibs.datastructure.set' call
      var this_1 = this.p6e_1;
      var key = touch.u6d_1;
      // Inline function 'kotlin.js.asDynamic' call
      this_1.set(key, touch);
    }
  }
  b6f() {
    return this.h6e_1.equals(Type_START_getInstance_0());
  }
  c6f() {
    return this.h6e_1.equals(Type_END_getInstance_0());
  }
  hashCode() {
    var result = this.h6e_1.hashCode();
    result = imul(result, 31) + this.i6e_1 | 0;
    result = imul(result, 31) + DateTime__hashCode_impl_yf0bc9(this.j6e_1) | 0;
    result = imul(result, 31) + getBooleanHashCode(this.k6e_1) | 0;
    result = imul(result, 31) + getBooleanHashCode(this.l6e_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof TouchEvent))
      return false;
    var tmp0_other_with_cast = other instanceof TouchEvent ? other : THROW_CCE();
    if (!this.h6e_1.equals(tmp0_other_with_cast.h6e_1))
      return false;
    if (!(this.i6e_1 === tmp0_other_with_cast.i6e_1))
      return false;
    if (!equals(this.j6e_1, tmp0_other_with_cast.j6e_1))
      return false;
    if (!(this.k6e_1 === tmp0_other_with_cast.k6e_1))
      return false;
    if (!(this.l6e_1 === tmp0_other_with_cast.l6e_1))
      return false;
    return true;
  }
}
class Mode extends Enum {}
class TouchBuilder {
  constructor() {
    this.d6f_1 = new TouchEvent();
    this.e6f_1 = new TouchEvent();
    this.f6f_1 = Mode_JS_getInstance();
  }
  g6f(type, scaleCoords) {
    this.e6f_1.k6e_1 = scaleCoords;
    this.e6f_1.t6e(type);
    if (this.f6f_1.r3_1 === 2) {
      this.e6f_1.a6f(this.d6f_1);
      this.e6f_1.h6e_1 = type;
      // Inline function 'korlibs.datastructure.iterators.fastIterateRemove' call
      var this_0 = this.e6f_1.n6e_1;
      var n = 0;
      var m = 0;
      while (n < this_0.e1()) {
        if (m >= 0 && !(m === n)) {
          this_0.o3(m, this_0.d1(n));
        }
        // Inline function 'korlibs.event.TouchBuilder.startFrame.<anonymous>' call
        var it = this_0.d1(n);
        var tmp;
        if (it.c15()) {
          it.x6d_1 = Status_KEEP_getInstance();
          tmp = false;
        } else {
          // Inline function 'korlibs.datastructure.remove' call
          var this_1 = this.e6f_1.p6e_1;
          var key = it.u6d_1;
          // Inline function 'kotlin.js.asDynamic' call
          this_1.delete(key);
          tmp = true;
        }
        if (tmp) {
          m = m - 1 | 0;
        }
        n = n + 1 | 0;
        m = m + 1 | 0;
      }
      while (this_0.e1() > m) {
        this_0.p3(this_0.e1() - 1 | 0);
      }
    }
  }
  h6f() {
    switch (this.f6f_1.r3_1) {
      case 0:
        // Inline function 'korlibs.datastructure.iterators.fastForEach' call

        var this_0 = this.d6f_1.q6e();
        var n = 0;
        while (n < this_0.e1()) {
          // Inline function 'korlibs.event.TouchBuilder.endFrame.<anonymous>' call
          var _unary__edvuaz = n;
          n = _unary__edvuaz + 1 | 0;
          var oldTouch = this_0.d1(_unary__edvuaz);
          if (this.e6f_1.s6e(oldTouch.u6d_1) == null) {
            if (oldTouch.c15()) {
              oldTouch.x6d_1 = Status_REMOVE_getInstance();
              this.e6f_1.z6e(oldTouch);
            }
          }
        }

        break;
      case 2:
        break;
      default:
        break;
    }
    this.e6f_1.u6e();
    this.d6f_1.a6f(this.e6f_1);
    return this.e6f_1;
  }
  i6f(id, p, force, kind, button) {
    var touch = this.e6f_1.v6e(id);
    touch.v6d_1 = p;
    touch.w6d_1 = force;
    touch.y6d_1 = kind;
    touch.z6d_1 = button;
    if (this.f6f_1.r3_1 === 2) {
      var tmp = touch;
      switch (this.e6f_1.h6e_1.r3_1) {
        case 0:
          tmp.x6d_1 = Status_ADD_getInstance();
          break;
        case 1:
          tmp.x6d_1 = Status_REMOVE_getInstance();
          break;
        default:
          tmp.x6d_1 = Status_KEEP_getInstance();
          break;
      }
    } else {
      var oldTouch = this.d6f_1.s6e(id);
      touch.x6d_1 = oldTouch == null ? Status_ADD_getInstance() : Status_KEEP_getInstance();
    }
  }
  j6f(id, p, force, kind, button, $super) {
    force = force === VOID ? 1.0 : force;
    kind = kind === VOID ? Kind_FINGER_getInstance() : kind;
    button = button === VOID ? MouseButton_LEFT_getInstance() : button;
    var tmp;
    if ($super === VOID) {
      this.i6f(id, p, force, kind, button);
      tmp = Unit_instance;
    } else {
      tmp = $super.i6f.call(this, id, p, force, kind, button);
    }
    return tmp;
  }
}
class GamepadInfoEmitter {
  constructor(dispatcher) {
    this.k6f_1 = dispatcher;
    this.l6f_1 = booleanArray(4);
    this.m6f_1 = new GamePadUpdateEvent();
    this.n6f_1 = new GamePadConnectionEvent();
    this.o6f_1 = IntArrayList.a2k();
  }
  p6f() {
    // Inline function 'korlibs.datastructure.iterators.fastForEach' call
    var this_0 = this.m6f_1.t6f_1;
    var n = 0;
    while (n < this_0.length) {
      // Inline function 'korlibs.event.GamepadInfoEmitter.dispatchGamepadUpdateStart.<anonymous>' call
      var _unary__edvuaz = n;
      n = _unary__edvuaz + 1 | 0;
      this_0[_unary__edvuaz].v6f_1 = false;
    }
    this.m6f_1.s6f_1 = 0;
  }
  b6g(info) {
    var _receiver__tnumb7 = this.m6f_1;
    var _unary__edvuaz = _receiver__tnumb7.s6f_1;
    _receiver__tnumb7.s6f_1 = _unary__edvuaz + 1 | 0;
    var index = _unary__edvuaz;
    var pad = this.m6f_1.t6f_1[index];
    pad.c6g(info);
    pad.v6f_1 = true;
    pad.u6f_1 = index;
  }
  d6g(out) {
    out.l3();
    // Inline function 'korlibs.datastructure.iterators.fastForEach' call
    var this_0 = this.m6f_1.t6f_1;
    var n = 0;
    while (n < this_0.length) {
      // Inline function 'korlibs.event.GamepadInfoEmitter.dispatchGamepadUpdateEnd.<anonymous>' call
      var _unary__edvuaz = n;
      n = _unary__edvuaz + 1 | 0;
      var it = this_0[_unary__edvuaz];
      if (!(this.l6f_1[it.u6f_1] === it.v6f_1)) {
        this.l6f_1[it.u6f_1] = it.v6f_1;
        out.g2k(it.u6f_1);
        if (!it.v6f_1) {
          it.w6f_1 = null;
        }
        // Inline function 'kotlin.apply' call
        var this_1 = this.n6f_1;
        // Inline function 'kotlin.contracts.contract' call
        // Inline function 'korlibs.event.GamepadInfoEmitter.dispatchGamepadUpdateEnd.<anonymous>.<anonymous>' call
        this_1.g6g_1 = Companion_getInstance_33().j6g(it.v6f_1);
        this_1.h6g_1 = it.u6f_1;
        this.k6f_1.g6a(this_1);
      }
    }
    this.k6f_1.g6a(this.m6f_1);
    return out;
  }
}
class BatteryStatus extends Enum {}
class Companion_15 {
  constructor() {
    this.k6g_1 = 'Wireless Controller';
    this.l6g_1 = 4;
    this.m6g_1 = 0.075;
  }
  n6g(value, margin, apply) {
    var tmp;
    if (apply) {
      // Inline function 'kotlin.math.absoluteValue' call
      tmp = Math.abs(value) < margin;
    } else {
      tmp = false;
    }
    if (tmp)
      return 0.0;
    return value;
  }
  o6g(value, margin, apply, $super) {
    margin = margin === VOID ? 0.075 : margin;
    apply = apply === VOID ? true : apply;
    return $super === VOID ? this.n6g(value, margin, apply) : $super.n6g.call(this, value, margin, apply);
  }
}
class GamepadInfo {
  constructor(index, connected, name, rawButtons, batteryLevel, name2, batteryStatus) {
    index = index === VOID ? 0 : index;
    connected = connected === VOID ? false : connected;
    name = name === VOID ? null : name;
    rawButtons = rawButtons === VOID ? new Float32Array(32) : rawButtons;
    batteryLevel = batteryLevel === VOID ? 1.0 : batteryLevel;
    name2 = name2 === VOID ? Companion_instance_24.k6g_1 : name2;
    batteryStatus = batteryStatus === VOID ? BatteryStatus_UNKNOWN_getInstance() : batteryStatus;
    this.u6f_1 = index;
    this.v6f_1 = connected;
    this.w6f_1 = name;
    this.x6f_1 = rawButtons;
    this.y6f_1 = batteryLevel;
    this.z6f_1 = name2;
    this.a6g_1 = batteryStatus;
  }
  p6g() {
    var tmp0_elvis_lhs = this.w6f_1;
    return (tmp0_elvis_lhs == null ? 'unknown' : tmp0_elvis_lhs) + ' - ' + this.z6f_1;
  }
  c6g(that) {
    this.u6f_1 = that.u6f_1;
    this.w6f_1 = that.w6f_1;
    this.z6f_1 = that.z6f_1;
    this.v6f_1 = that.v6f_1;
    this.y6f_1 = that.y6f_1;
    this.a6g_1 = that.a6g_1;
    var tmp = that.x6f_1;
    var tmp_0 = this.x6f_1;
    // Inline function 'kotlin.math.min' call
    var a = this.x6f_1.length;
    var b = that.x6f_1.length;
    var tmp$ret$0 = Math.min(a, b);
    arraycopy(tmp, 0, tmp_0, 0, tmp$ret$0);
  }
  q6g(button) {
    return this.x6f_1[button.t6g()];
  }
  u6g(includeButtons) {
    // Inline function 'kotlin.text.buildString' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'kotlin.apply' call
    var this_0 = StringBuilder.f();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.event.GamepadInfo.toStringEx.<anonymous>' call
    this_0.tb('Gamepad[' + this.u6f_1 + '][' + this.p6g() + ']');
    if (includeButtons) {
      this_0.tb('[');
      var count = 0;
      var indexedObject = values_5();
      var inductionVariable = 0;
      var last = indexedObject.length;
      while (inductionVariable < last) {
        var button = indexedObject[inductionVariable];
        inductionVariable = inductionVariable + 1 | 0;
        var value = this.q6g(button);
        if (!(value === 0.0)) {
          if (count > 0) {
            this_0.tb(',');
          }
          this_0.tb(button.toString() + '=' + get_niceStr(value));
          count = count + 1 | 0;
        }
      }
      this_0.tb(']');
    }
    return this_0.toString();
  }
  v6g(includeButtons, $super) {
    includeButtons = includeButtons === VOID ? true : includeButtons;
    return $super === VOID ? this.u6g(includeButtons) : $super.u6g.call(this, includeButtons);
  }
  toString() {
    return this.u6g(false);
  }
}
class Companion_16 {}
class GamePadUpdateEvent extends Event {
  constructor(gamepadsLength, gamepads) {
    gamepadsLength = gamepadsLength === VOID ? 0 : gamepadsLength;
    var tmp;
    if (gamepads === VOID) {
      var tmp_0 = 0;
      // Inline function 'kotlin.arrayOfNulls' call
      var tmp_1 = fillArrayVal(Array(4), null);
      while (tmp_0 < 4) {
        var tmp_2 = tmp_0;
        tmp_1[tmp_2] = new GamepadInfo(tmp_2);
        tmp_0 = tmp_0 + 1 | 0;
      }
      tmp = tmp_1;
    } else {
      tmp = gamepads;
    }
    gamepads = tmp;
    super();
    this.s6f_1 = gamepadsLength;
    this.t6f_1 = gamepads;
  }
  w29() {
    return Companion_instance_25;
  }
  toString() {
    // Inline function 'kotlin.collections.map' call
    // Inline function 'kotlin.collections.filter' call
    // Inline function 'kotlin.collections.filterTo' call
    var this_0 = this.t6f_1;
    var destination = ArrayList.h1();
    var inductionVariable = 0;
    var last = this_0.length;
    while (inductionVariable < last) {
      var element = this_0[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      // Inline function 'korlibs.event.GamePadUpdateEvent.toString.<anonymous>' call
      if (element.v6f_1) {
        destination.h(element);
      }
    }
    // Inline function 'kotlin.collections.mapTo' call
    var destination_0 = ArrayList.w(collectionSizeOrDefault(destination, 10));
    var tmp0_iterator = destination.a1();
    while (tmp0_iterator.b1()) {
      var item = tmp0_iterator.c1();
      // Inline function 'korlibs.event.GamePadUpdateEvent.toString.<anonymous>' call
      var tmp$ret$3 = item.v6g();
      destination_0.h(tmp$ret$3);
    }
    return 'GamePadUpdateEvent(' + toString(destination_0) + ')';
  }
  hashCode() {
    var result = this.s6f_1;
    result = imul(result, 31) + hashCode(this.t6f_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof GamePadUpdateEvent))
      return false;
    var tmp0_other_with_cast = other instanceof GamePadUpdateEvent ? other : THROW_CCE();
    if (!(this.s6f_1 === tmp0_other_with_cast.s6f_1))
      return false;
    if (!equals(this.t6f_1, tmp0_other_with_cast.t6f_1))
      return false;
    return true;
  }
}
class Companion_17 {
  constructor() {
    Companion_instance_26 = this;
    this.i6g_1 = values_4();
  }
  j6g(connected) {
    return connected ? Type_CONNECTED_getInstance() : Type_DISCONNECTED_getInstance();
  }
}
class Type_4 extends Enum {}
class GamePadConnectionEvent extends Event {
  constructor(type, gamepad) {
    type = type === VOID ? Type_CONNECTED_getInstance() : type;
    gamepad = gamepad === VOID ? 0 : gamepad;
    super();
    this.g6g_1 = type;
    this.h6g_1 = gamepad;
  }
  w29() {
    return this.g6g_1;
  }
  toString() {
    return 'GamePadConnectionEvent(type=' + toString(this.g6g_1) + ', gamepad=' + this.h6g_1 + ')';
  }
  hashCode() {
    var result = this.g6g_1.hashCode();
    result = imul(result, 31) + this.h6g_1 | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof GamePadConnectionEvent))
      return false;
    var tmp0_other_with_cast = other instanceof GamePadConnectionEvent ? other : THROW_CCE();
    if (!this.g6g_1.equals(tmp0_other_with_cast.g6g_1))
      return false;
    if (!(this.h6g_1 === tmp0_other_with_cast.h6g_1))
      return false;
    return true;
  }
}
class Companion_18 {
  constructor() {
    Companion_instance_27 = this;
    this.w6g_1 = values_5();
    this.x6g_1 = 32;
  }
}
class GameButton extends Enum {
  t6g() {
    return this.r3_1;
  }
}
class Companion_19 {
  constructor() {
    Companion_instance_28 = this;
    this.y6g_1 = Key_UNKNOWN_getInstance().r3_1 + 1 | 0;
    this.z6g_1 = Key_ENTER_getInstance();
    this.a6h_1 = Key_N0_getInstance();
    this.b6h_1 = Key_N1_getInstance();
    this.c6h_1 = Key_N2_getInstance();
    this.d6h_1 = Key_N3_getInstance();
    this.e6h_1 = Key_N4_getInstance();
    this.f6h_1 = Key_N5_getInstance();
    this.g6h_1 = Key_N6_getInstance();
    this.h6h_1 = Key_N7_getInstance();
    this.i6h_1 = Key_N8_getInstance();
    this.j6h_1 = Key_N9_getInstance();
  }
  k6h() {
    return Key_CONTROL_getInstance();
  }
  l6h() {
    return Key_CONTROL_getInstance();
  }
  m6h() {
    return Key_SHIFT_getInstance();
  }
  n6h() {
    return Key_SHIFT_getInstance();
  }
  o6h() {
    return Key_ALT_getInstance();
  }
  p6h() {
    return Key_ALT_getInstance();
  }
  q6h() {
    return Key_SUPER_getInstance();
  }
  r6h() {
    return Key_SUPER_getInstance();
  }
}
class Key extends Enum {
  u6h() {
    switch (this.r3_1) {
      case 81:
      case 82:
      case 83:
      case 84:
      case 85:
      case 86:
      case 87:
      case 88:
      case 89:
      case 90:
      case 91:
      case 92:
      case 93:
      case 94:
      case 95:
      case 96:
      case 97:
      case 98:
      case 99:
      case 100:
      case 101:
      case 102:
      case 103:
      case 104:
      case 105:
        return true;
      default:
        return false;
    }
  }
}
class Companion_20 {
  constructor() {
    Companion_instance_29 = this;
    this.v6h_1 = MouseButton_NONE_getInstance().r3_1 + 1 | 0;
    this.w6h_1 = values_6();
  }
  d1(id) {
    // Inline function 'kotlin.collections.getOrElse' call
    var this_0 = this.w6h_1;
    // Inline function 'kotlin.contracts.contract' call
    var tmp;
    if (0 <= id ? id <= (this_0.length - 1 | 0) : false) {
      tmp = this_0[id];
    } else {
      // Inline function 'korlibs.event.Companion.get.<anonymous>' call
      tmp = MouseButton_BUTTON_UNKNOWN_getInstance();
    }
    return tmp;
  }
}
class MouseButton extends Enum {
  constructor(name, ordinal, id, bits) {
    bits = bits === VOID ? 1 << id : bits;
    super(name, ordinal);
    this.z6h_1 = id;
    this.a6i_1 = bits;
  }
}
class ISoftKeyboardConfig {}
class SoftKeyboardType extends Enum {}
class SoftKeyboardReturnKeyType extends Enum {}
class SoftKeyboardConfig {
  constructor(softKeyboardType, softKeyboardSmartDashes, softKeyboardSmartQuotes, softKeyboardSpellChecking, softKeyboardTextContentType, softKeyboardSmartInsertDelete, softKeyboardPassword, softKeyboardReturnKeyType, softKeyboardAutocapitalization, softKeyboardAutocorrection, softKeyboardEnablesReturnKeyAutomatically) {
    softKeyboardType = softKeyboardType === VOID ? SoftKeyboardType_DEFAULT_getInstance() : softKeyboardType;
    softKeyboardSmartDashes = softKeyboardSmartDashes === VOID ? null : softKeyboardSmartDashes;
    softKeyboardSmartQuotes = softKeyboardSmartQuotes === VOID ? null : softKeyboardSmartQuotes;
    softKeyboardSpellChecking = softKeyboardSpellChecking === VOID ? null : softKeyboardSpellChecking;
    softKeyboardTextContentType = softKeyboardTextContentType === VOID ? null : softKeyboardTextContentType;
    softKeyboardSmartInsertDelete = softKeyboardSmartInsertDelete === VOID ? null : softKeyboardSmartInsertDelete;
    softKeyboardPassword = softKeyboardPassword === VOID ? false : softKeyboardPassword;
    softKeyboardReturnKeyType = softKeyboardReturnKeyType === VOID ? SoftKeyboardReturnKeyType_DEFAULT_getInstance() : softKeyboardReturnKeyType;
    softKeyboardAutocapitalization = softKeyboardAutocapitalization === VOID ? null : softKeyboardAutocapitalization;
    softKeyboardAutocorrection = softKeyboardAutocorrection === VOID ? null : softKeyboardAutocorrection;
    softKeyboardEnablesReturnKeyAutomatically = softKeyboardEnablesReturnKeyAutomatically === VOID ? false : softKeyboardEnablesReturnKeyAutomatically;
    this.b6i_1 = softKeyboardType;
    this.c6i_1 = softKeyboardSmartDashes;
    this.d6i_1 = softKeyboardSmartQuotes;
    this.e6i_1 = softKeyboardSpellChecking;
    this.f6i_1 = softKeyboardTextContentType;
    this.g6i_1 = softKeyboardSmartInsertDelete;
    this.h6i_1 = softKeyboardPassword;
    this.i6i_1 = softKeyboardReturnKeyType;
    this.j6i_1 = softKeyboardAutocapitalization;
    this.k6i_1 = softKeyboardAutocorrection;
    this.l6i_1 = softKeyboardEnablesReturnKeyAutomatically;
  }
  toString() {
    return 'SoftKeyboardConfig(softKeyboardType=' + this.b6i_1.toString() + ', softKeyboardSmartDashes=' + this.c6i_1 + ', softKeyboardSmartQuotes=' + this.d6i_1 + ', softKeyboardSpellChecking=' + this.e6i_1 + ', softKeyboardTextContentType=' + this.f6i_1 + ', softKeyboardSmartInsertDelete=' + this.g6i_1 + ', softKeyboardPassword=' + this.h6i_1 + ', softKeyboardReturnKeyType=' + this.i6i_1.toString() + ', softKeyboardAutocapitalization=' + this.j6i_1 + ', softKeyboardAutocorrection=' + this.k6i_1 + ', softKeyboardEnablesReturnKeyAutomatically=' + this.l6i_1 + ')';
  }
  hashCode() {
    var result = this.b6i_1.hashCode();
    result = imul(result, 31) + (this.c6i_1 == null ? 0 : getBooleanHashCode(this.c6i_1)) | 0;
    result = imul(result, 31) + (this.d6i_1 == null ? 0 : getBooleanHashCode(this.d6i_1)) | 0;
    result = imul(result, 31) + (this.e6i_1 == null ? 0 : getBooleanHashCode(this.e6i_1)) | 0;
    result = imul(result, 31) + (this.f6i_1 == null ? 0 : getStringHashCode(this.f6i_1)) | 0;
    result = imul(result, 31) + (this.g6i_1 == null ? 0 : getBooleanHashCode(this.g6i_1)) | 0;
    result = imul(result, 31) + getBooleanHashCode(this.h6i_1) | 0;
    result = imul(result, 31) + this.i6i_1.hashCode() | 0;
    result = imul(result, 31) + (this.j6i_1 == null ? 0 : getBooleanHashCode(this.j6i_1)) | 0;
    result = imul(result, 31) + (this.k6i_1 == null ? 0 : getBooleanHashCode(this.k6i_1)) | 0;
    result = imul(result, 31) + getBooleanHashCode(this.l6i_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof SoftKeyboardConfig))
      return false;
    var tmp0_other_with_cast = other instanceof SoftKeyboardConfig ? other : THROW_CCE();
    if (!this.b6i_1.equals(tmp0_other_with_cast.b6i_1))
      return false;
    if (!(this.c6i_1 == tmp0_other_with_cast.c6i_1))
      return false;
    if (!(this.d6i_1 == tmp0_other_with_cast.d6i_1))
      return false;
    if (!(this.e6i_1 == tmp0_other_with_cast.e6i_1))
      return false;
    if (!(this.f6i_1 == tmp0_other_with_cast.f6i_1))
      return false;
    if (!(this.g6i_1 == tmp0_other_with_cast.g6i_1))
      return false;
    if (!(this.h6i_1 === tmp0_other_with_cast.h6i_1))
      return false;
    if (!this.i6i_1.equals(tmp0_other_with_cast.i6i_1))
      return false;
    if (!(this.j6i_1 == tmp0_other_with_cast.j6i_1))
      return false;
    if (!(this.k6i_1 == tmp0_other_with_cast.k6i_1))
      return false;
    if (!(this.l6i_1 === tmp0_other_with_cast.l6i_1))
      return false;
    return true;
  }
}
class Companion_21 {
  constructor() {
    Companion_instance_30 = this;
    this.m6i_1 = Companion_getInstance_1().qw('AG');
    this.n6i_1 = 96.0;
  }
}
class AGFeatures {}
function get_parentFeatures() {
  return null;
}
function get_isUniformBuffersSupported() {
  var tmp0_safe_receiver = this.o6j();
  var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.p6j();
  return tmp1_elvis_lhs == null ? false : tmp1_elvis_lhs;
}
function get_isVertexArraysSupported() {
  var tmp0_safe_receiver = this.o6j();
  var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.q6j();
  return tmp1_elvis_lhs == null ? false : tmp1_elvis_lhs;
}
class AG {
  static s6i() {
    Companion_getInstance_37();
    var $this = createThis(this);
    $this.o6i_1 = new Mixin();
    $this.p6i_1 = AGFrameBuffer.g6j(true);
    $this.q6i_1 = 0;
    $this.r6i_1 = new AGStats();
    return $this;
  }
  h6j() {
    return this.p6i_1;
  }
  i6j() {
    // Inline function 'korlibs.logger.Logger.info' call
    var this_0 = Companion_getInstance_37().m6i_1;
    var level = Level_INFO_getInstance();
    var tmp;
    if (this_0.a2u(level)) {
      // Inline function 'korlibs.graphics.AG.contextLost.<anonymous>' call
      this_0.b2u(level, this);
      tmp = Unit_instance;
    }
    // Inline function 'korlibs.logger.Logger.info' call
    var this_1 = Companion_getInstance_37().m6i_1;
    var level_0 = Level_INFO_getInstance();
    var tmp_0;
    if (this_1.a2u(level_0)) {
      // Inline function 'korlibs.graphics.AG.contextLost.<anonymous>' call
      var tmp$ret$2 = 'AG.contextLost()';
      this_1.b2u(level_0, tmp$ret$2);
      tmp_0 = Unit_instance;
    }
    this.q6i_1 = this.q6i_1 + 1 | 0;
  }
  j6j() {
    return this.k6j(AGFinish_instance);
  }
  l6j() {
    return Unit_instance;
  }
  u6e() {
    return Unit_instance;
  }
  k6j(command) {
    return Unit_instance;
  }
  m6j(frameBuffer, frameBufferInfo, color, depth, stencil, clearColor, clearDepth, clearStencil, scissor) {
    return this.k6j(new AGClear(frameBuffer, frameBufferInfo, color, depth, stencil, clearColor, clearDepth, clearStencil));
  }
  n6j(frameBuffer, frameBufferInfo, vertexData, program, drawType, vertexCount, indices, indexType, drawOffset, blending, uniformBlocks, textureUnits, stencilRef, stencilOpFunc, colorMask, depthAndFrontFace, scissor, cullFace, instances) {
    return this.k6j(new AGBatch(frameBuffer, frameBufferInfo, vertexData, indices, indexType, program, uniformBlocks, textureUnits, blending, stencilOpFunc, stencilRef, colorMask, depthAndFrontFace, scissor, cullFace, drawType, drawOffset, vertexCount, instances));
  }
  ay(value) {
    this.o6i_1.ay(value);
  }
  by() {
    return this.o6i_1.by();
  }
}
class Immutable {
  constructor(parentFeatures, graphicExtensions, isInstancedSupported, isUniformBuffersSupported, isVertexArraysSupported, isStorageMultisampleSupported, isFloatTextureSupported) {
    parentFeatures = parentFeatures === VOID ? null : parentFeatures;
    graphicExtensions = graphicExtensions === VOID ? emptySet() : graphicExtensions;
    isInstancedSupported = isInstancedSupported === VOID ? false : isInstancedSupported;
    isUniformBuffersSupported = isUniformBuffersSupported === VOID ? false : isUniformBuffersSupported;
    isVertexArraysSupported = isVertexArraysSupported === VOID ? false : isVertexArraysSupported;
    isStorageMultisampleSupported = isStorageMultisampleSupported === VOID ? false : isStorageMultisampleSupported;
    isFloatTextureSupported = isFloatTextureSupported === VOID ? false : isFloatTextureSupported;
    this.a6l_1 = parentFeatures;
    this.b6l_1 = graphicExtensions;
    this.c6l_1 = isInstancedSupported;
    this.d6l_1 = isUniformBuffersSupported;
    this.e6l_1 = isVertexArraysSupported;
    this.f6l_1 = isStorageMultisampleSupported;
    this.g6l_1 = isFloatTextureSupported;
  }
  o6j() {
    return this.a6l_1;
  }
  p6j() {
    return this.d6l_1;
  }
  q6j() {
    return this.e6l_1;
  }
  toString() {
    return 'Immutable(parentFeatures=' + toString_1(this.a6l_1) + ', graphicExtensions=' + toString(this.b6l_1) + ', isInstancedSupported=' + this.c6l_1 + ', isUniformBuffersSupported=' + this.d6l_1 + ', isVertexArraysSupported=' + this.e6l_1 + ', isStorageMultisampleSupported=' + this.f6l_1 + ', isFloatTextureSupported=' + this.g6l_1 + ')';
  }
  hashCode() {
    var result = this.a6l_1 == null ? 0 : hashCode(this.a6l_1);
    result = imul(result, 31) + hashCode(this.b6l_1) | 0;
    result = imul(result, 31) + getBooleanHashCode(this.c6l_1) | 0;
    result = imul(result, 31) + getBooleanHashCode(this.d6l_1) | 0;
    result = imul(result, 31) + getBooleanHashCode(this.e6l_1) | 0;
    result = imul(result, 31) + getBooleanHashCode(this.f6l_1) | 0;
    result = imul(result, 31) + getBooleanHashCode(this.g6l_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof Immutable))
      return false;
    var tmp0_other_with_cast = other instanceof Immutable ? other : THROW_CCE();
    if (!equals(this.a6l_1, tmp0_other_with_cast.a6l_1))
      return false;
    if (!equals(this.b6l_1, tmp0_other_with_cast.b6l_1))
      return false;
    if (!(this.c6l_1 === tmp0_other_with_cast.c6l_1))
      return false;
    if (!(this.d6l_1 === tmp0_other_with_cast.d6l_1))
      return false;
    if (!(this.e6l_1 === tmp0_other_with_cast.e6l_1))
      return false;
    if (!(this.f6l_1 === tmp0_other_with_cast.f6l_1))
      return false;
    if (!(this.g6l_1 === tmp0_other_with_cast.g6l_1))
      return false;
    return true;
  }
}
class AGObject {
  constructor() {
    this.h6m_1 = null;
    this.i6m_1 = -1;
    this.j6m_1 = -2;
    this.k6m_1 = -1;
  }
  r6m() {
    this.l6m();
    this.j6m_1 = this.k6m_1 - 1 | 0;
  }
  l6m() {
    this.k6m_1 = this.k6m_1 + 1 | 0;
  }
  f6() {
    var tmp0_safe_receiver = this.h6m_1;
    if (tmp0_safe_receiver == null)
      null;
    else {
      tmp0_safe_receiver.u6p();
    }
    this.h6m_1 = null;
  }
}
class AGBuffer extends AGObject {
  constructor() {
    super();
    this.g6m_1 = null;
  }
  m6m(data, offset, length) {
    return upload(this, _Int8Buffer___get_buffer__impl__q0gulb(_Int8Buffer___init__impl__e20lvc(data, offset, length)), false);
  }
  n6m(data, offset, length) {
    return upload(this, _Float32Buffer___get_buffer__impl__x5nu9x(_Float32Buffer___init__impl__403k2m(data, offset, length)), false);
  }
  o6m(data, offset, length, $super) {
    offset = offset === VOID ? 0 : offset;
    length = length === VOID ? data.length - offset | 0 : length;
    return $super === VOID ? this.n6m(data, offset, length) : $super.n6m.call(this, data, offset, length);
  }
  p6m(data, offset, length) {
    return upload(this, sliceWithSize(data, offset, length), true);
  }
  q6m(data) {
    return upload(this, data, true);
  }
  toString() {
    var tmp0_safe_receiver = this.g6m_1;
    var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.r12();
    return 'AGBuffer(' + (tmp1_elvis_lhs == null ? 0 : tmp1_elvis_lhs) + ')';
  }
}
class Companion_22 {
  constructor() {
    this.c6k_1 = 8;
  }
  d6k() {
    return AGTextureUnits.u6m();
  }
}
class AGTextureUnits {
  static v6m(textures, infos) {
    var $this = createThis(this);
    $this.s6m_1 = textures;
    $this.t6m_1 = infos;
    return $this;
  }
  static u6m(size) {
    size = size === VOID ? Companion_instance_31.c6k_1 : size;
    // Inline function 'kotlin.arrayOfNulls' call
    var tmp$ret$0 = fillArrayVal(Array(size), null);
    return this.v6m(tmp$ret$0, _AGTextureUnitInfoArray___init__impl__c77rdb_0(size));
  }
  e1() {
    return this.s6m_1.length;
  }
  w6m(other, index) {
    return this.x6m(index, other.s6m_1[index], AGTextureUnitInfoArray__get_impl_xhvpef(other.t6m_1, index));
  }
  x6m(index, texture, info) {
    this.s6m_1[index] = texture;
    AGTextureUnitInfoArray__set_impl_s95rfh(this.t6m_1, index, info);
  }
  y6m(index, texture, info, $super) {
    info = info === VOID ? Companion_getInstance_40().a6n_1 : info;
    var tmp;
    if ($super === VOID) {
      this.x6m(index, texture, info);
      tmp = Unit_instance;
    } else {
      tmp = $super.x6m.call(this, index, texture, new AGTextureUnitInfo(info));
    }
    return tmp;
  }
  b6n(sampler, texture, info) {
    this.x6m(sampler.n6n_1, texture, info);
  }
  p6n(sampler, texture, info, $super) {
    info = info === VOID ? Companion_getInstance_40().a6n_1 : info;
    var tmp;
    if ($super === VOID) {
      this.b6n(sampler, texture, info);
      tmp = Unit_instance;
    } else {
      tmp = $super.b6n.call(this, sampler, texture, new AGTextureUnitInfo(info));
    }
    return tmp;
  }
  l3() {
    var inductionVariable = 0;
    var last = this.e1();
    if (inductionVariable < last)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        this.x6m(n, null, Companion_getInstance_40().a6n_1);
      }
       while (inductionVariable < last);
  }
  wx() {
    // Inline function 'kotlin.collections.copyOf' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$1 = this.s6m_1.slice();
    return AGTextureUnits.v6m(tmp$ret$1, AGTextureUnitInfoArray__copyOf_impl_z2w8z3(this.t6m_1));
  }
  toString() {
    return 'AGTextureUnits(textures=' + toString(this.s6m_1) + ', infos=' + AGTextureUnitInfoArray__toString_impl_kr9cgh(this.t6m_1) + ')';
  }
  hashCode() {
    var result = hashCode(this.s6m_1);
    result = imul(result, 31) + AGTextureUnitInfoArray__hashCode_impl_siosps(this.t6m_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof AGTextureUnits))
      return false;
    var tmp0_other_with_cast = other instanceof AGTextureUnits ? other : THROW_CCE();
    if (!equals(this.s6m_1, tmp0_other_with_cast.s6m_1))
      return false;
    if (!equals(this.t6m_1, tmp0_other_with_cast.t6m_1))
      return false;
    return true;
  }
}
class Companion_23 {
  constructor() {
    this.q6n_1 = 128;
    this.r6n_1 = 128;
  }
}
class AGFrameBuffer {
  static s6n(base, id) {
    id = id === VOID ? -1 : id;
    var $this = createThis(this);
    $this.t6i_1 = base;
    $this.u6i_1 = id;
    $this.v6i_1 = 1;
    $this.w6i_1 = true;
    $this.x6i_1 = true;
    $this.y6i_1 = 0;
    $this.z6i_1 = 0;
    $this.a6j_1 = 128;
    $this.b6j_1 = 128;
    $this.c6j_1 = 128;
    $this.d6j_1 = 128;
    $this.e6j_1 = RectangleInt.u2f();
    $this.f6j_1 = null;
    return $this;
  }
  static g6j(isMain, id) {
    isMain = isMain === VOID ? false : isMain;
    id = id === VOID ? -1 : id;
    return this.s6n(new AGFrameBufferBase(isMain), id);
  }
  t6n() {
    return this.t6i_1.t6n();
  }
  b6o() {
    return this.t6i_1.y6n_1;
  }
  c6o() {
    return this.t6i_1.z6n_1;
  }
  z6k() {
    return AGFrameBufferInfo__withHasStencil_impl_nbaemo(AGFrameBufferInfo__withHasDepth_impl_fjgbiv(AGFrameBufferInfo__withSamples_impl_83818f(AGFrameBufferInfo__withBounds_impl_sg0n3x(_AGFrameBufferInfo___init__impl__dbxiro(new Long(0, 0)), this.y6i_1, this.z6i_1, this.a6j_1, this.b6j_1), this.v6i_1), this.x6i_1), this.w6i_1);
  }
  d6o(width, height) {
    return this.e6o(0, 0, width, height);
  }
  f6o(x, y, width, height, fullWidth, fullHeight) {
    if (this.y6i_1 === x && this.z6i_1 === y && this.a6j_1 === width && this.b6j_1 === height && this.c6j_1 === fullWidth && this.d6j_1 === fullHeight)
      return true;
    this.c6o().u6o(NullBitmap.a4f(width, height));
    this.t6i_1.a6o_1 = Companion_getInstance_9().q14(imul(imul(fullWidth, fullHeight), 8));
    this.y6i_1 = x;
    this.z6i_1 = y;
    this.a6j_1 = width;
    this.b6j_1 = height;
    this.c6j_1 = fullWidth;
    this.d6j_1 = fullHeight;
    markAsDirty(this);
    return false;
  }
  e6o(x, y, width, height, fullWidth, fullHeight, $super) {
    fullWidth = fullWidth === VOID ? width : fullWidth;
    fullHeight = fullHeight === VOID ? height : fullHeight;
    return $super === VOID ? this.f6o(x, y, width, height, fullWidth, fullHeight) : $super.f6o.call(this, x, y, width, height, fullWidth, fullHeight);
  }
  f6() {
    this.t6i_1.f6();
  }
  v6o(samples) {
    if (this.v6i_1 === samples)
      return Unit_instance;
    this.v6i_1 = samples;
    markAsDirty(this);
  }
  w6o(hasDepth, hasStencil) {
    if (this.x6i_1 === hasDepth && this.w6i_1 === hasStencil)
      return Unit_instance;
    this.x6i_1 = hasDepth;
    this.w6i_1 = hasStencil;
    markAsDirty(this);
  }
  toString() {
    return 'AGFrameBuffer(' + (this.b6o() ? 'main' : '' + this.u6i_1) + ', ' + this.a6j_1 + ', ' + this.b6j_1 + ')';
  }
}
class AGTexture extends AGObject {
  constructor(targetKind) {
    targetKind = targetKind === VOID ? Companion_getInstance_51().x6o_1 : targetKind;
    super();
    this.k6o_1 = targetKind;
    this.l6o_1 = Companion_getInstance_1().qw('AGTexture');
    this.m6o_1 = false;
    this.n6o_1 = false;
    this.o6o_1 = null;
    this.p6o_1 = null;
    this.q6o_1 = null;
    this.r6o_1 = false;
    this.s6o_1 = null;
    this.t6o_1 = Companion_getInstance_9().r14(new Long(0, 0));
  }
  b6p() {
    var tmp0_safe_receiver = this.s6o_1;
    var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.y4d();
    var tmp;
    if (tmp1_safe_receiver == null) {
      tmp = null;
    } else {
      // Inline function 'kotlin.let' call
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'korlibs.graphics.AGTexture.<get-implForcedTexTarget>.<anonymous>' call
      tmp = fromGl(Companion_getInstance_51(), tmp1_safe_receiver);
    }
    var tmp2_elvis_lhs = tmp;
    var tmp_0;
    var tmp_1 = tmp2_elvis_lhs;
    if ((tmp_1 == null ? null : new AGTextureTargetKind(tmp_1)) == null) {
      tmp_0 = this.k6o_1;
    } else {
      tmp_0 = tmp2_elvis_lhs;
    }
    return tmp_0;
  }
  z2i() {
    var tmp0_safe_receiver = this.q6o_1;
    var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.x3z_1;
    return tmp1_elvis_lhs == null ? 0 : tmp1_elvis_lhs;
  }
  a2j() {
    var tmp0_safe_receiver = this.q6o_1;
    var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.y3z_1;
    return tmp1_elvis_lhs == null ? 0 : tmp1_elvis_lhs;
  }
  d6p() {
    var tmp = this.q6o_1;
    var tmp0_safe_receiver = (tmp == null ? true : tmp instanceof MultiBitmap) ? tmp : null;
    var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.r6p_1;
    var tmp2_elvis_lhs = tmp1_safe_receiver == null ? null : tmp1_safe_receiver.e1();
    return tmp2_elvis_lhs == null ? 1 : tmp2_elvis_lhs;
  }
  s6p(bmp, mipmaps, baseMipmapLevel, maxMipmapLevel) {
    if (bmp == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      // Inline function 'kotlin.contracts.contract' call
      checkBitmaps(this, bmp);
    }
    var tmp = this;
    tmp.s6o_1 = (bmp == null ? true : isInterface(bmp, ForcedTexId)) ? bmp : null;
    this.q6o_1 = bmp;
    this.t6o_1 = Companion_getInstance_9().q14(imul(imul(imul(this.z2i(), this.a2j()), this.d6p()), 4));
    this.l6m();
    this.n6o_1 = mipmaps;
    this.o6o_1 = baseMipmapLevel;
    this.p6o_1 = maxMipmapLevel;
    return this;
  }
  u6o(bmp, mipmaps, baseMipmapLevel, maxMipmapLevel, $super) {
    mipmaps = mipmaps === VOID ? false : mipmaps;
    baseMipmapLevel = baseMipmapLevel === VOID ? null : baseMipmapLevel;
    maxMipmapLevel = maxMipmapLevel === VOID ? null : maxMipmapLevel;
    return $super === VOID ? this.s6p(bmp, mipmaps, baseMipmapLevel, maxMipmapLevel) : $super.s6p.call(this, bmp, mipmaps, baseMipmapLevel, maxMipmapLevel);
  }
  t6p(bitmap, requestMipmaps) {
    var tmp1_elvis_lhs = bitmap == null ? null : bitmap.x3z_1;
    var width = tmp1_elvis_lhs == null ? 0 : tmp1_elvis_lhs;
    var tmp3_elvis_lhs = bitmap == null ? null : bitmap.y3z_1;
    var height = tmp3_elvis_lhs == null ? 0 : tmp3_elvis_lhs;
    return requestMipmaps && get_isPowerOfTwo(width) && get_isPowerOfTwo(height);
  }
  toString() {
    return 'AGTexture(size=' + this.z2i() + ',' + this.a2j() + ')';
  }
}
class AGFrameBufferBase extends AGObject {
  constructor(isMain) {
    super();
    this.y6n_1 = isMain;
    var tmp = this;
    // Inline function 'kotlin.also' call
    var this_0 = new AGTexture();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.graphics.AGFrameBufferBase.tex.<anonymous>' call
    this_0.m6o_1 = true;
    tmp.z6n_1 = this_0;
    this.a6o_1 = Companion_getInstance_9().q14(0);
  }
  t6n() {
    return !this.y6n_1;
  }
  f6() {
    this.z6n_1.f6();
  }
  toString() {
    return 'AGFrameBufferBase(isMain=' + this.y6n_1 + ')';
  }
}
class Companion_24 {
  constructor() {
    Companion_instance_33 = this;
    this.z6m_1 = _AGTextureUnitInfo___init__impl__s1tthu(-1);
    this.a6n_1 = AGTextureUnitInfo__withKind_impl_aa0b04(AGTextureUnitInfo__withWrap_impl_akwb6y(AGTextureUnitInfo__withLinearTrilinear_impl_aactvz(_AGTextureUnitInfo___init__impl__s1tthu(0), true, true), Companion_getInstance_52().w6p_1), Companion_getInstance_51().x6o_1);
  }
  v6p(data) {
    return _AGTextureUnitInfo___init__impl__s1tthu(data);
  }
  z6p(wrap, linear, trilinear) {
    return AGTextureUnitInfo__withLinearTrilinear_impl_aactvz(AGTextureUnitInfo__withWrap_impl_akwb6y(_AGTextureUnitInfo___init__impl__s1tthu(0), wrap), linear, trilinear);
  }
  a6q(wrap, linear, trilinear, $super) {
    wrap = wrap === VOID ? Companion_getInstance_52().w6p_1 : wrap;
    linear = linear === VOID ? true : linear;
    trilinear = trilinear === VOID ? linear : trilinear;
    return $super === VOID ? this.z6p(wrap, linear, trilinear) : $super.z6p.call(this, new AGWrapMode(wrap), linear, trilinear).b6q_1;
  }
}
class AGTextureUnitInfo {
  constructor(data) {
    Companion_getInstance_40();
    this.b6q_1 = data;
  }
  toString() {
    return AGTextureUnitInfo__toString_impl_7im6je(this.b6q_1);
  }
  hashCode() {
    return AGTextureUnitInfo__hashCode_impl_e8jq9h(this.b6q_1);
  }
  equals(other) {
    return AGTextureUnitInfo__equals_impl_j2jlgn(this.b6q_1, other);
  }
}
class AGNativeObject {}
class BufferCache {
  constructor() {
    this.c6q_1 = FastIdentityMap();
  }
  t2q() {
    // Inline function 'korlibs.datastructure.fastForEach' call
    var this_0 = this.c6q_1;
    // Inline function 'korlibs.datastructure.fastKeyForEach' call
    // Inline function 'kotlin.js.asDynamic' call
    var mapIterator = this_0.keys();
    $l$loop: while (true) {
      var v = mapIterator.next();
      if (v.done)
        break $l$loop;
      // Inline function 'korlibs.datastructure.fastForEach.<anonymous>' call
      var it = v.value;
      // Inline function 'korlibs.graphics.BufferCache.reset.<anonymous>' call
      ensureNotNull(get_0(this_0, it)).t2q();
    }
  }
  l6q() {
    // Inline function 'korlibs.datastructure.fastForEach' call
    var this_0 = this.c6q_1;
    // Inline function 'korlibs.datastructure.fastKeyForEach' call
    // Inline function 'kotlin.js.asDynamic' call
    var mapIterator = this_0.keys();
    $l$loop: while (true) {
      var v = mapIterator.next();
      if (v.done)
        break $l$loop;
      // Inline function 'korlibs.datastructure.fastForEach.<anonymous>' call
      var it = v.value;
      // Inline function 'korlibs.graphics.BufferCache.uploadUpdatedBuffers.<anonymous>' call
      ensureNotNull(get_0(this_0, it)).m6q();
    }
  }
  n6q(block) {
    var tmp$ret$0;
    $l$block: {
      // Inline function 'korlibs.datastructure.getOrPut' call
      var this_0 = this.c6q_1;
      var res = get_0(this_0, block);
      if (!(res == null)) {
        tmp$ret$0 = res;
        break $l$block;
      }
      // Inline function 'korlibs.graphics.BufferCache.get.<anonymous>' call
      var out = new UniformBlockBuffer(block);
      set(this_0, block, out);
      tmp$ret$0 = out;
    }
    var tmp = tmp$ret$0;
    return tmp instanceof UniformBlockBuffer ? tmp : THROW_CCE();
  }
}
class AGProgramWithUniforms {
  constructor(program, bufferCache) {
    bufferCache = bufferCache === VOID ? new BufferCache() : bufferCache;
    this.o6q_1 = program;
    this.p6q_1 = bufferCache;
    var tmp = this;
    // Inline function 'kotlin.collections.map' call
    var this_0 = this.o6q_1.b6r_1;
    // Inline function 'kotlin.collections.mapTo' call
    var destination = ArrayList.w(collectionSizeOrDefault(this_0, 10));
    var tmp0_iterator = this_0.a1();
    while (tmp0_iterator.b1()) {
      var item = tmp0_iterator.c1();
      // Inline function 'korlibs.graphics.AGProgramWithUniforms.uniformLayouts.<anonymous>' call
      var tmp$ret$0 = item.v6r_1;
      destination.h(tmp$ret$0);
    }
    tmp.q6q_1 = distinct(destination);
    var tmp_0 = this;
    var tmp$ret$3;
    $l$block: {
      // Inline function 'kotlin.collections.maxOfOrNull' call
      var iterator = this.q6q_1.a1();
      if (!iterator.b1()) {
        tmp$ret$3 = null;
        break $l$block;
      }
      // Inline function 'korlibs.graphics.AGProgramWithUniforms.maxLocation.<anonymous>' call
      var maxValue = iterator.c1().x6r_1 + 1 | 0;
      while (iterator.b1()) {
        // Inline function 'korlibs.graphics.AGProgramWithUniforms.maxLocation.<anonymous>' call
        var v = iterator.c1().x6r_1 + 1 | 0;
        if (compareTo(maxValue, v) < 0) {
          maxValue = v;
        }
      }
      tmp$ret$3 = maxValue;
    }
    var tmp0_elvis_lhs = tmp$ret$3;
    tmp_0.r6q_1 = tmp0_elvis_lhs == null ? 0 : tmp0_elvis_lhs;
    var tmp_1 = this;
    // Inline function 'kotlin.also' call
    var tmp_2 = 0;
    var tmp_3 = this.r6q_1;
    // Inline function 'kotlin.arrayOfNulls' call
    var tmp_4 = fillArrayVal(Array(tmp_3), null);
    while (tmp_2 < tmp_3) {
      tmp_4[tmp_2] = null;
      tmp_2 = tmp_2 + 1 | 0;
    }
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.graphics.AGProgramWithUniforms.uniformsBlocks.<anonymous>' call
    var _iterator__ex2g4s = this.q6q_1.a1();
    while (_iterator__ex2g4s.b1()) {
      var layout = _iterator__ex2g4s.c1();
      tmp_4[layout.x6r_1] = layout;
    }
    tmp_1.s6q_1 = tmp_4;
    var tmp_5 = this;
    var tmp_6 = 0;
    var tmp_7 = this.s6q_1.length;
    // Inline function 'kotlin.arrayOfNulls' call
    var tmp_8 = fillArrayVal(Array(tmp_7), null);
    while (tmp_6 < tmp_7) {
      var tmp_9 = tmp_6;
      var tmp0_safe_receiver = this.s6q_1[tmp_9];
      var tmp_10;
      if (tmp0_safe_receiver == null) {
        tmp_10 = null;
      } else {
        // Inline function 'kotlin.let' call
        // Inline function 'kotlin.contracts.contract' call
        // Inline function 'korlibs.graphics.AGProgramWithUniforms.uniformsBlocksData.<anonymous>' call
        tmp_10 = this.p6q_1.n6q(tmp0_safe_receiver);
      }
      tmp_8[tmp_9] = tmp_10;
      tmp_6 = tmp_6 + 1 | 0;
    }
    tmp_5.t6q_1 = tmp_8;
    var tmp_11 = this;
    var tmp_12 = 0;
    var tmp_13 = this.s6q_1.length;
    // Inline function 'kotlin.arrayOfNulls' call
    var tmp_14 = fillArrayVal(Array(tmp_13), null);
    while (tmp_12 < tmp_13) {
      var tmp_15 = tmp_12;
      var tmp0_safe_receiver_0 = this.t6q_1[tmp_15];
      var tmp1_safe_receiver = tmp0_safe_receiver_0 == null ? null : tmp0_safe_receiver_0.d6q_1;
      var tmp_16;
      if (tmp1_safe_receiver == null) {
        tmp_16 = null;
      } else {
        // Inline function 'kotlin.let' call
        // Inline function 'kotlin.contracts.contract' call
        // Inline function 'korlibs.graphics.AGProgramWithUniforms.agUniformBlockDatas.<anonymous>' call
        tmp_16 = new UniformBlockBuffer(tmp1_safe_receiver);
      }
      tmp_14[tmp_15] = tmp_16;
      tmp_12 = tmp_12 + 1 | 0;
    }
    tmp_11.u6q_1 = tmp_14;
    var tmp_17 = this;
    var tmp_18 = 0;
    var tmp_19 = this.s6q_1.length;
    // Inline function 'kotlin.arrayOfNulls' call
    var tmp_20 = fillArrayVal(Array(tmp_19), null);
    while (tmp_18 < tmp_19) {
      var tmp_21 = tmp_18;
      var tmp0_safe_receiver_1 = this.t6q_1[tmp_21];
      tmp_20[tmp_21] = tmp0_safe_receiver_1 == null ? null : tmp0_safe_receiver_1.e6q_1;
      tmp_18 = tmp_18 + 1 | 0;
    }
    tmp_17.v6q_1 = tmp_20;
    var tmp_22 = this;
    var tmp_23 = 0;
    var tmp_24 = this.s6q_1.length;
    var tmp_25 = new Int32Array(tmp_24);
    while (tmp_23 < tmp_24) {
      tmp_25[tmp_23] = 0;
      tmp_23 = tmp_23 + 1 | 0;
    }
    tmp_22.w6q_1 = tmp_25;
  }
  b6s() {
    var inductionVariable = 0;
    var last = this.w6q_1.length - 1 | 0;
    if (inductionVariable <= last)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var tmp0_safe_receiver = this.t6q_1[n];
        var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.c6s();
        this.w6q_1[n] = tmp1_elvis_lhs == null ? -1 : tmp1_elvis_lhs;
      }
       while (inductionVariable <= last);
    // Inline function 'kotlin.collections.copyOf' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$1 = this.w6q_1.slice();
    return new UniformBlocksBuffersRef(this.u6q_1, this.v6q_1, tmp$ret$1);
  }
}
class AGVertexArrayObject {
  static g6s(list, isDynamic) {
    isDynamic = isDynamic === VOID ? true : isDynamic;
    var $this = createThis(this);
    $this.d6s_1 = new Mixin();
    $this.e6s_1 = list;
    $this.f6s_1 = isDynamic;
    return $this;
  }
  static h6s(datas, isDynamic) {
    isDynamic = isDynamic === VOID ? true : isDynamic;
    return this.g6s(fastArrayListOf(datas.slice()), isDynamic);
  }
  toString() {
    return 'AGVertexArrayObject(list=' + this.e6s_1.toString() + ', isDynamic=' + this.f6s_1 + ')';
  }
  hashCode() {
    var result = this.e6s_1.hashCode();
    result = imul(result, 31) + getBooleanHashCode(this.f6s_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof AGVertexArrayObject))
      return false;
    var tmp0_other_with_cast = other instanceof AGVertexArrayObject ? other : THROW_CCE();
    if (!this.e6s_1.equals(tmp0_other_with_cast.e6s_1))
      return false;
    if (!(this.f6s_1 === tmp0_other_with_cast.f6s_1))
      return false;
    return true;
  }
  ay(value) {
    this.d6s_1.ay(value);
  }
  by() {
    return this.d6s_1.by();
  }
}
class AGVertexData {
  constructor(layout, buffer, baseOffset) {
    layout = layout === VOID ? ProgramLayout.q6s([]) : layout;
    buffer = buffer === VOID ? new AGBuffer() : buffer;
    baseOffset = baseOffset === VOID ? 0 : baseOffset;
    this.r6s_1 = layout;
    this.s6s_1 = buffer;
    this.t6s_1 = baseOffset;
  }
  toString() {
    return 'AGVertexData(layout=' + this.r6s_1.toString() + ', buffer=' + this.s6s_1.toString() + ', baseOffset=' + this.t6s_1 + ')';
  }
  hashCode() {
    var result = hashCode(this.r6s_1);
    result = imul(result, 31) + hashCode(this.s6s_1) | 0;
    result = imul(result, 31) + this.t6s_1 | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof AGVertexData))
      return false;
    var tmp0_other_with_cast = other instanceof AGVertexData ? other : THROW_CCE();
    if (!equals(this.r6s_1, tmp0_other_with_cast.r6s_1))
      return false;
    if (!equals(this.s6s_1, tmp0_other_with_cast.s6s_1))
      return false;
    if (!(this.t6s_1 === tmp0_other_with_cast.t6s_1))
      return false;
    return true;
  }
}
class Companion_25 {
  constructor() {
    Companion_instance_34 = this;
    this.u6s_1 = _AGDrawType___init__impl__emm6mb(0);
    this.v6s_1 = _AGDrawType___init__impl__emm6mb(1);
    this.w6s_1 = _AGDrawType___init__impl__emm6mb(2);
    this.x6s_1 = _AGDrawType___init__impl__emm6mb(3);
    this.y6s_1 = _AGDrawType___init__impl__emm6mb(4);
    this.z6s_1 = _AGDrawType___init__impl__emm6mb(5);
    this.a6t_1 = _AGDrawType___init__impl__emm6mb(6);
  }
}
class AGDrawType {
  constructor(ordinal) {
    Companion_getInstance_41();
    this.b6t_1 = ordinal;
  }
  toString() {
    return AGDrawType__toString_impl_eonaeb(this.b6t_1);
  }
  hashCode() {
    return AGDrawType__hashCode_impl_ylaury(this.b6t_1);
  }
  equals(other) {
    return AGDrawType__equals_impl_rtafo6(this.b6t_1, other);
  }
}
class Companion_26 {
  constructor() {
    Companion_instance_35 = this;
    this.r6j_1 = _AGIndexType___init__impl__yqnmb7(0);
    this.s6j_1 = _AGIndexType___init__impl__yqnmb7(1);
    this.t6j_1 = _AGIndexType___init__impl__yqnmb7(2);
    this.u6j_1 = _AGIndexType___init__impl__yqnmb7(3);
  }
}
class Companion_27 {
  constructor() {
    Companion_instance_36 = this;
    this.v6j_1 = _AGBlending___init__impl__upt3bq(-1);
    this.w6j_1 = Companion_getInstance_43().q6t(Companion_getInstance_53().i6t_1, Companion_getInstance_53().p6t_1, Companion_getInstance_53().i6t_1, Companion_getInstance_53().p6t_1);
    this.x6j_1 = Companion_getInstance_43().q6t(Companion_getInstance_53().n6t_1, Companion_getInstance_53().l6t_1, Companion_getInstance_53().i6t_1, Companion_getInstance_53().l6t_1);
    this.y6j_1 = Companion_getInstance_43().r6t(Companion_getInstance_53().i6t_1, Companion_getInstance_53().l6t_1);
    this.z6j_1 = Companion_getInstance_43().q6t(Companion_getInstance_53().n6t_1, Companion_getInstance_53().g6t_1, Companion_getInstance_53().i6t_1, Companion_getInstance_53().i6t_1);
    this.a6k_1 = Companion_getInstance_43().q6t(Companion_getInstance_53().i6t_1, Companion_getInstance_53().i6t_1, Companion_getInstance_53().i6t_1, Companion_getInstance_53().i6t_1);
  }
  s6t(srcRGB, dstRGB, srcA, dstA, eqRGB, eqA) {
    return AGBlending__withEQ_impl_e9gm04(AGBlending__withDST_impl_y1hpet(AGBlending__withSRC_impl_hh0mjq(_AGBlending___init__impl__upt3bq(0), srcRGB, srcA), dstRGB, dstA), eqRGB, eqA);
  }
  q6t(srcRGB, dstRGB, srcA, dstA, eqRGB, eqA, $super) {
    srcA = srcA === VOID ? srcRGB : srcA;
    dstA = dstA === VOID ? dstRGB : dstA;
    eqRGB = eqRGB === VOID ? Companion_getInstance_54().t6t_1 : eqRGB;
    eqA = eqA === VOID ? eqRGB : eqA;
    return $super === VOID ? this.s6t(srcRGB, dstRGB, srcA, dstA, eqRGB, eqA) : $super.s6t.call(this, new AGBlendFactor(srcRGB), new AGBlendFactor(dstRGB), new AGBlendFactor(srcA), new AGBlendFactor(dstA), new AGBlendEquation(eqRGB), new AGBlendEquation(eqA)).c6t_1;
  }
  w6t(src, dst, eq) {
    return AGBlending__withEQ$default_impl_iltiw7(AGBlending__withDST$default_impl_leu6qg(AGBlending__withSRC$default_impl_uuu5hz(_AGBlending___init__impl__upt3bq(0), src), dst), eq);
  }
  r6t(src, dst, eq, $super) {
    eq = eq === VOID ? Companion_getInstance_54().t6t_1 : eq;
    return $super === VOID ? this.w6t(src, dst, eq) : $super.w6t.call(this, new AGBlendFactor(src), new AGBlendFactor(dst), new AGBlendEquation(eq)).c6t_1;
  }
}
class AGBlending {
  constructor(data) {
    Companion_getInstance_43();
    this.c6t_1 = data;
  }
  toString() {
    return AGBlending__toString_impl_d5hic6(this.c6t_1);
  }
  hashCode() {
    return AGBlending__hashCode_impl_ywnf51(this.c6t_1);
  }
  equals(other) {
    return AGBlending__equals_impl_rp3dmf(this.c6t_1, other);
  }
}
class Companion_28 {
  constructor() {
    Companion_instance_37 = this;
    this.q6k_1 = AGScissor.b6u(0, 0, 0, 0);
    this.r6k_1 = Companion_getInstance_44().i2e(-2147483648, -2147483648, 2147483647, 2147483647);
    this.s6k_1 = Companion_getInstance_44().i2e(-32766, -32766, 2147483647, 2147483647);
    this.t6k_1 = Companion_getInstance_44().i2e(-32767, -32767, 2147483647, 2147483647);
  }
  i2e(left, top, right, bottom) {
    return AGScissor.b6u(left, top, right - left | 0, bottom - top | 0);
  }
  c6u(left, top, right, bottom) {
    return AGScissor.d6u(left, top, right - left, bottom - top);
  }
  e6u(rect) {
    if (rect == null)
      return this.t6k_1;
    if (rect.b26())
      return this.t6k_1;
    return AGScissor.f6u(rect.w25_1, rect.x25_1, rect.y25_1, rect.z25_1);
  }
  g6u(prev, next) {
    if (prev.equals(this.t6k_1))
      return next;
    if (next.equals(this.t6k_1))
      return prev;
    var intersectsX = prev.d26() <= next.e26() && prev.e26() >= next.d26();
    var intersectsY = prev.f26() <= next.g26() && prev.g26() >= next.f26();
    if (!intersectsX || !intersectsY)
      return this.q6k_1;
    // Inline function 'kotlin.math.max' call
    var a = prev.d26();
    var b = next.d26();
    var left = Math.max(a, b);
    // Inline function 'kotlin.math.max' call
    var a_0 = prev.f26();
    var b_0 = next.f26();
    var top = Math.max(a_0, b_0);
    // Inline function 'kotlin.math.min' call
    var a_1 = prev.e26();
    var b_1 = next.e26();
    var right = Math.min(a_1, b_1);
    // Inline function 'kotlin.math.min' call
    var a_2 = prev.g26();
    var b_2 = next.g26();
    var bottom = Math.min(a_2, b_2);
    return this.i2e(left, top, right, bottom);
  }
}
class AGScissor {
  static h6u(_left, _top, _right, _bottom) {
    Companion_getInstance_44();
    var $this = createThis(this);
    $this.x6t_1 = _left;
    $this.y6t_1 = _top;
    $this.z6t_1 = _right;
    $this.a6u_1 = _bottom;
    return $this;
  }
  b26() {
    return this.equals(Companion_getInstance_44().t6k_1);
  }
  static b6u(x, y, width, height) {
    Companion_getInstance_44();
    return this.h6u(toShortClamped(x), toShortClamped(y), toShortClamped(x + width | 0), toShortClamped(y + height | 0));
  }
  static d6u(x, y, width, height) {
    Companion_getInstance_44();
    return this.b6u(toIntRound(x), toIntRound(y), toIntRound(width), toIntRound(height));
  }
  static f6u(x, y, width, height) {
    Companion_getInstance_44();
    return this.b6u(toIntRound_0(x), toIntRound_0(y), toIntRound_0(width), toIntRound_0(height));
  }
  d26() {
    return this.x6t_1;
  }
  f26() {
    return this.y6t_1;
  }
  e26() {
    return this.z6t_1;
  }
  g26() {
    return this.a6u_1;
  }
  a6e() {
    return this.d26();
  }
  b6e() {
    return this.f26();
  }
  z2i() {
    return this.e26() - this.d26() | 0;
  }
  a2j() {
    return this.g26() - this.f26() | 0;
  }
  toString() {
    if (this.equals(Companion_getInstance_44().t6k_1))
      return 'null';
    return 'Scissor(x=' + this.a6e() + ', y=' + this.b6e() + ', width=' + this.z2i() + ', height=' + this.a2j() + ')';
  }
  i6u() {
    return this.b26() ? Companion_getInstance_5().l26() : Companion_getInstance_5().e2e(this.a6e(), this.b6e(), this.z2i(), this.a2j());
  }
  j6u() {
    // Inline function 'kotlin.takeIf' call
    var this_0 = this.i6u();
    // Inline function 'kotlin.contracts.contract' call
    var tmp;
    // Inline function 'korlibs.graphics.AGScissor.toRectOrNull.<anonymous>' call
    if (this_0.c26()) {
      tmp = this_0;
    } else {
      tmp = null;
    }
    return tmp;
  }
  hashCode() {
    var result = this.x6t_1;
    result = imul(result, 31) + this.y6t_1 | 0;
    result = imul(result, 31) + this.z6t_1 | 0;
    result = imul(result, 31) + this.a6u_1 | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof AGScissor))
      return false;
    var tmp0_other_with_cast = other instanceof AGScissor ? other : THROW_CCE();
    if (!(this.x6t_1 === tmp0_other_with_cast.x6t_1))
      return false;
    if (!(this.y6t_1 === tmp0_other_with_cast.y6t_1))
      return false;
    if (!(this.z6t_1 === tmp0_other_with_cast.z6t_1))
      return false;
    if (!(this.a6u_1 === tmp0_other_with_cast.a6u_1))
      return false;
    return true;
  }
}
class Companion_29 {
  constructor() {
    Companion_instance_38 = this;
    this.l6u_1 = _AGFrameBufferInfo___init__impl__dbxiro_0(0, 0);
    this.m6u_1 = _AGFrameBufferInfo___init__impl__dbxiro_0(-1, 0);
  }
}
class AGFinish {}
class AGClear {
  constructor(frameBuffer, frameBufferInfo, color, depth, stencil, clearColor, clearDepth, clearStencil) {
    this.n6u_1 = frameBuffer;
    this.o6u_1 = frameBufferInfo;
    this.p6u_1 = color;
    this.q6u_1 = depth;
    this.r6u_1 = stencil;
    this.s6u_1 = clearColor;
    this.t6u_1 = clearDepth;
    this.u6u_1 = clearStencil;
  }
  toString() {
    return 'AGClear(frameBuffer=' + this.n6u_1.toString() + ', frameBufferInfo=' + AGFrameBufferInfo__toString_impl_xecyr8(this.o6u_1) + ', color=' + RGBA__toString_impl_4lw6dp(this.p6u_1) + ', depth=' + this.q6u_1 + ', stencil=' + this.r6u_1 + ', clearColor=' + this.s6u_1 + ', clearDepth=' + this.t6u_1 + ', clearStencil=' + this.u6u_1 + ')';
  }
  hashCode() {
    var result = hashCode(this.n6u_1);
    result = imul(result, 31) + AGFrameBufferInfo__hashCode_impl_fvl6f1(this.o6u_1) | 0;
    result = imul(result, 31) + RGBA__hashCode_impl_h59qf6(this.p6u_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.q6u_1) | 0;
    result = imul(result, 31) + this.r6u_1 | 0;
    result = imul(result, 31) + getBooleanHashCode(this.s6u_1) | 0;
    result = imul(result, 31) + getBooleanHashCode(this.t6u_1) | 0;
    result = imul(result, 31) + getBooleanHashCode(this.u6u_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof AGClear))
      return false;
    var tmp0_other_with_cast = other instanceof AGClear ? other : THROW_CCE();
    if (!equals(this.n6u_1, tmp0_other_with_cast.n6u_1))
      return false;
    if (!equals(this.o6u_1, tmp0_other_with_cast.o6u_1))
      return false;
    if (!(this.p6u_1 === tmp0_other_with_cast.p6u_1))
      return false;
    if (!equals(this.q6u_1, tmp0_other_with_cast.q6u_1))
      return false;
    if (!(this.r6u_1 === tmp0_other_with_cast.r6u_1))
      return false;
    if (!(this.s6u_1 === tmp0_other_with_cast.s6u_1))
      return false;
    if (!(this.t6u_1 === tmp0_other_with_cast.t6u_1))
      return false;
    if (!(this.u6u_1 === tmp0_other_with_cast.u6u_1))
      return false;
    return true;
  }
}
class Companion_30 {
  constructor() {
    Companion_instance_39 = this;
    this.e6k_1 = _AGStencilReference___init__impl__rta8vg(new Long(-1, -1));
    this.f6k_1 = AGStencilReference__withWriteMask$default_impl_b7j7b4(AGStencilReference__withReadMask$default_impl_7mdffx(AGStencilReference__withReferenceValue$default_impl_2trj0v(_AGStencilReference___init__impl__rta8vg(new Long(0, 0)), 0), 255), 255);
  }
}
class AGStencilReference {
  constructor(data) {
    Companion_getInstance_46();
    this.v6u_1 = data;
  }
  toString() {
    return AGStencilReference__toString_impl_qu5r8s(this.v6u_1);
  }
  hashCode() {
    return AGStencilReference__hashCode_impl_52zufx(this.v6u_1);
  }
  equals(other) {
    return AGStencilReference__equals_impl_kj05j(this.v6u_1, other);
  }
}
class Companion_31 {
  constructor() {
    Companion_instance_40 = this;
    this.g6k_1 = _AGStencilOpFunc___init__impl__t3f62q(-1);
    this.h6k_1 = AGStencilOpFunc__withAction$default_impl_jx9cm1(AGStencilOpFunc__withCompareMode$default_impl_rzbauv(AGStencilOpFunc__withEnabled_impl_mpcwmr(_AGStencilOpFunc___init__impl__t3f62q(0), false), Companion_getInstance_57().z6u_1), Companion_getInstance_56().m6v_1, Companion_getInstance_56().m6v_1, Companion_getInstance_56().m6v_1);
  }
}
class AGStencilOpFunc {
  constructor(data) {
    Companion_getInstance_47();
    this.p6v_1 = data;
  }
  toString() {
    return AGStencilOpFunc__toString_impl_pl8quy(this.p6v_1);
  }
  hashCode() {
    return AGStencilOpFunc__hashCode_impl_nopebb(this.p6v_1);
  }
  equals(other) {
    return AGStencilOpFunc__equals_impl_y44i4z(this.p6v_1, other);
  }
}
class Companion_32 {
  constructor() {
    Companion_instance_41 = this;
    this.i6k_1 = _AGColorMask___init__impl__j38ai8(-1);
    this.j6k_1 = _AGColorMask___init__impl__j38ai8_1();
    this.k6k_1 = _AGColorMask___init__impl__j38ai8_1(true);
    this.l6k_1 = _AGColorMask___init__impl__j38ai8_1(true);
    this.m6k_1 = _AGColorMask___init__impl__j38ai8_0(true, true, true, false);
    this.n6k_1 = _AGColorMask___init__impl__j38ai8_1(false);
  }
}
class AGColorMask {
  constructor(data) {
    Companion_getInstance_48();
    this.t6v_1 = data;
  }
  toString() {
    return AGColorMask__toString_impl_5i5oqg(this.t6v_1);
  }
  hashCode() {
    return AGColorMask__hashCode_impl_g9082f(this.t6v_1);
  }
  equals(other) {
    return AGColorMask__equals_impl_mrih8l(this.t6v_1, other);
  }
}
class Companion_33 {
  constructor() {
    Companion_instance_42 = this;
    this.o6k_1 = _AGDepthAndFrontFace___init__impl__ra8x65(-2);
    this.p6k_1 = AGDepthAndFrontFace__withFrontFace_impl_mwk87t(AGDepthAndFrontFace__withDepthFunc_impl_7t7yrs(AGDepthAndFrontFace__withDepthMask_impl_610nhs(AGDepthAndFrontFace__withDepth_impl_wsx82k(_AGDepthAndFrontFace___init__impl__ra8x65(0), 0.0, 1.0), true), Companion_getInstance_57().z6u_1), Companion_getInstance_58().u6v_1);
  }
}
class Companion_34 {
  constructor() {
    Companion_instance_43 = this;
    this.u6k_1 = _AGCullFace___init__impl__ckmjdg(-1);
    this.v6k_1 = _AGCullFace___init__impl__ckmjdg(0);
    this.w6k_1 = _AGCullFace___init__impl__ckmjdg(1);
    this.x6k_1 = _AGCullFace___init__impl__ckmjdg(2);
    this.y6k_1 = _AGCullFace___init__impl__ckmjdg(3);
  }
}
class AGCullFace {
  constructor(ordinal) {
    Companion_getInstance_50();
    this.x6v_1 = ordinal;
  }
  toString() {
    return AGCullFace__toString_impl_7d891w(this.x6v_1);
  }
  hashCode() {
    return AGCullFace__hashCode_impl_t4e5ur(this.x6v_1);
  }
  equals(other) {
    return AGCullFace__equals_impl_wgngjr(this.x6v_1, other);
  }
}
class AGBatch {
  constructor(frameBuffer, frameBufferInfo, vertexData, indices, indexType, program, uniformBlocks, textureUnits, blending, stencilOpFunc, stencilRef, colorMask, depthAndFrontFace, scissor, cullFace, drawType, drawOffset, vertexCount, instances) {
    vertexData = vertexData === VOID ? AGVertexArrayObject.h6s([new AGVertexData()], true) : vertexData;
    indices = indices === VOID ? null : indices;
    indexType = indexType === VOID ? Companion_getInstance_42().t6j_1 : indexType;
    program = program === VOID ? DefaultShaders_getInstance().r6w_1 : program;
    uniformBlocks = uniformBlocks === VOID ? Companion_getInstance_59().b6k_1 : uniformBlocks;
    textureUnits = textureUnits === VOID ? Companion_instance_31.d6k() : textureUnits;
    blending = blending === VOID ? Companion_getInstance_43().x6j_1 : blending;
    stencilOpFunc = stencilOpFunc === VOID ? Companion_getInstance_47().h6k_1 : stencilOpFunc;
    stencilRef = stencilRef === VOID ? Companion_getInstance_46().f6k_1 : stencilRef;
    colorMask = colorMask === VOID ? Companion_getInstance_48().k6k_1 : colorMask;
    depthAndFrontFace = depthAndFrontFace === VOID ? Companion_getInstance_49().p6k_1 : depthAndFrontFace;
    scissor = scissor === VOID ? Companion_getInstance_44().t6k_1 : scissor;
    cullFace = cullFace === VOID ? Companion_getInstance_50().v6k_1 : cullFace;
    drawType = drawType === VOID ? Companion_getInstance_41().y6s_1 : drawType;
    drawOffset = drawOffset === VOID ? 0 : drawOffset;
    vertexCount = vertexCount === VOID ? 0 : vertexCount;
    instances = instances === VOID ? 1 : instances;
    this.j6l_1 = frameBuffer;
    this.k6l_1 = frameBufferInfo;
    this.l6l_1 = vertexData;
    this.m6l_1 = indices;
    this.n6l_1 = indexType;
    this.o6l_1 = program;
    this.p6l_1 = uniformBlocks;
    this.q6l_1 = textureUnits;
    this.r6l_1 = blending;
    this.s6l_1 = stencilOpFunc;
    this.t6l_1 = stencilRef;
    this.u6l_1 = colorMask;
    this.v6l_1 = depthAndFrontFace;
    this.w6l_1 = scissor;
    this.x6l_1 = cullFace;
    this.y6l_1 = drawType;
    this.z6l_1 = drawOffset;
    this.a6m_1 = vertexCount;
    this.b6m_1 = instances;
  }
  i6l(ag) {
    ag.n6j(this.j6l_1, this.k6l_1, this.l6l_1, this.o6l_1, this.y6l_1, this.a6m_1, this.m6l_1, this.n6l_1, this.z6l_1, this.r6l_1, this.p6l_1, this.q6l_1, this.t6l_1, this.s6l_1, this.u6l_1, this.v6l_1, this.w6l_1, this.x6l_1, this.b6m_1);
  }
  toString() {
    return 'AGBatch(frameBuffer=' + this.j6l_1.toString() + ', frameBufferInfo=' + AGFrameBufferInfo__toString_impl_xecyr8(this.k6l_1) + ', vertexData=' + this.l6l_1.toString() + ', indices=' + toString_1(this.m6l_1) + ', indexType=' + AGIndexType__toString_impl_hjqwm3(this.n6l_1) + ', program=' + this.o6l_1.toString() + ', uniformBlocks=' + toString(this.p6l_1) + ', textureUnits=' + this.q6l_1.toString() + ', blending=' + AGBlending__toString_impl_d5hic6(this.r6l_1) + ', stencilOpFunc=' + AGStencilOpFunc__toString_impl_pl8quy(this.s6l_1) + ', stencilRef=' + AGStencilReference__toString_impl_qu5r8s(this.t6l_1) + ', colorMask=' + AGColorMask__toString_impl_5i5oqg(this.u6l_1) + ', depthAndFrontFace=' + AGDepthAndFrontFace__toString_impl_c305m3(this.v6l_1) + ', scissor=' + this.w6l_1.toString() + ', cullFace=' + AGCullFace__toString_impl_7d891w(this.x6l_1) + ', drawType=' + AGDrawType__toString_impl_eonaeb(this.y6l_1) + ', drawOffset=' + this.z6l_1 + ', vertexCount=' + this.a6m_1 + ', instances=' + this.b6m_1 + ')';
  }
  hashCode() {
    var result = hashCode(this.j6l_1);
    result = imul(result, 31) + AGFrameBufferInfo__hashCode_impl_fvl6f1(this.k6l_1) | 0;
    result = imul(result, 31) + this.l6l_1.hashCode() | 0;
    result = imul(result, 31) + (this.m6l_1 == null ? 0 : hashCode(this.m6l_1)) | 0;
    result = imul(result, 31) + AGIndexType__hashCode_impl_47f06s(this.n6l_1) | 0;
    result = imul(result, 31) + this.o6l_1.hashCode() | 0;
    result = imul(result, 31) + hashCode(this.p6l_1) | 0;
    result = imul(result, 31) + this.q6l_1.hashCode() | 0;
    result = imul(result, 31) + AGBlending__hashCode_impl_ywnf51(this.r6l_1) | 0;
    result = imul(result, 31) + AGStencilOpFunc__hashCode_impl_nopebb(this.s6l_1) | 0;
    result = imul(result, 31) + AGStencilReference__hashCode_impl_52zufx(this.t6l_1) | 0;
    result = imul(result, 31) + AGColorMask__hashCode_impl_g9082f(this.u6l_1) | 0;
    result = imul(result, 31) + AGDepthAndFrontFace__hashCode_impl_xu62ey(this.v6l_1) | 0;
    result = imul(result, 31) + this.w6l_1.hashCode() | 0;
    result = imul(result, 31) + AGCullFace__hashCode_impl_t4e5ur(this.x6l_1) | 0;
    result = imul(result, 31) + AGDrawType__hashCode_impl_ylaury(this.y6l_1) | 0;
    result = imul(result, 31) + this.z6l_1 | 0;
    result = imul(result, 31) + this.a6m_1 | 0;
    result = imul(result, 31) + this.b6m_1 | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof AGBatch))
      return false;
    var tmp0_other_with_cast = other instanceof AGBatch ? other : THROW_CCE();
    if (!equals(this.j6l_1, tmp0_other_with_cast.j6l_1))
      return false;
    if (!equals(this.k6l_1, tmp0_other_with_cast.k6l_1))
      return false;
    if (!this.l6l_1.equals(tmp0_other_with_cast.l6l_1))
      return false;
    if (!equals(this.m6l_1, tmp0_other_with_cast.m6l_1))
      return false;
    if (!(this.n6l_1 === tmp0_other_with_cast.n6l_1))
      return false;
    if (!this.o6l_1.equals(tmp0_other_with_cast.o6l_1))
      return false;
    if (!equals(this.p6l_1, tmp0_other_with_cast.p6l_1))
      return false;
    if (!this.q6l_1.equals(tmp0_other_with_cast.q6l_1))
      return false;
    if (!(this.r6l_1 === tmp0_other_with_cast.r6l_1))
      return false;
    if (!(this.s6l_1 === tmp0_other_with_cast.s6l_1))
      return false;
    if (!equals(this.t6l_1, tmp0_other_with_cast.t6l_1))
      return false;
    if (!(this.u6l_1 === tmp0_other_with_cast.u6l_1))
      return false;
    if (!(this.v6l_1 === tmp0_other_with_cast.v6l_1))
      return false;
    if (!this.w6l_1.equals(tmp0_other_with_cast.w6l_1))
      return false;
    if (!(this.x6l_1 === tmp0_other_with_cast.x6l_1))
      return false;
    if (!(this.y6l_1 === tmp0_other_with_cast.y6l_1))
      return false;
    if (!(this.z6l_1 === tmp0_other_with_cast.z6l_1))
      return false;
    if (!(this.a6m_1 === tmp0_other_with_cast.a6m_1))
      return false;
    if (!(this.b6m_1 === tmp0_other_with_cast.b6m_1))
      return false;
    return true;
  }
}
class Companion_35 {
  constructor() {
    Companion_instance_44 = this;
    this.x6o_1 = _AGTextureTargetKind___init__impl__4zdmch(0);
    this.y6o_1 = _AGTextureTargetKind___init__impl__4zdmch(1);
    this.z6o_1 = _AGTextureTargetKind___init__impl__4zdmch(2);
    this.a6p_1 = _AGTextureTargetKind___init__impl__4zdmch(3);
  }
}
class AGTextureTargetKind {
  constructor(ordinal) {
    Companion_getInstance_51();
    this.c6p_1 = ordinal;
  }
  toString() {
    return AGTextureTargetKind__toString_impl_68648p(this.c6p_1);
  }
  hashCode() {
    return AGTextureTargetKind__hashCode_impl_rzc11k(this.c6p_1);
  }
  equals(other) {
    return AGTextureTargetKind__equals_impl_q2tams(this.c6p_1, other);
  }
}
class Companion_36 {
  constructor() {
    Companion_instance_45 = this;
    this.w6p_1 = _AGWrapMode___init__impl__x5wmya(0);
    this.x6p_1 = _AGWrapMode___init__impl__x5wmya(1);
    this.y6p_1 = _AGWrapMode___init__impl__x5wmya(2);
  }
}
class AGWrapMode {
  constructor(ordinal) {
    Companion_getInstance_52();
    this.t6w_1 = ordinal;
  }
  toString() {
    return AGWrapMode__toString_impl_8bjnw2(this.t6w_1);
  }
  hashCode() {
    return AGWrapMode__hashCode_impl_u2pkox(this.t6w_1);
  }
  equals(other) {
    return AGWrapMode__equals_impl_4aw0kl(this.t6w_1, other);
  }
}
class Companion_37 {
  constructor() {
    Companion_instance_46 = this;
    this.g6t_1 = _AGBlendFactor___init__impl__iqtmxr(0);
    this.h6t_1 = _AGBlendFactor___init__impl__iqtmxr(1);
    this.i6t_1 = _AGBlendFactor___init__impl__iqtmxr(2);
    this.j6t_1 = _AGBlendFactor___init__impl__iqtmxr(3);
    this.k6t_1 = _AGBlendFactor___init__impl__iqtmxr(4);
    this.l6t_1 = _AGBlendFactor___init__impl__iqtmxr(5);
    this.m6t_1 = _AGBlendFactor___init__impl__iqtmxr(6);
    this.n6t_1 = _AGBlendFactor___init__impl__iqtmxr(7);
    this.o6t_1 = _AGBlendFactor___init__impl__iqtmxr(8);
    this.p6t_1 = _AGBlendFactor___init__impl__iqtmxr(9);
  }
}
class AGBlendFactor {
  constructor(ordinal) {
    Companion_getInstance_53();
    this.u6w_1 = ordinal;
  }
  toString() {
    return AGBlendFactor__toString_impl_1hr6m1(this.u6w_1);
  }
  hashCode() {
    return AGBlendFactor__hashCode_impl_n8x3ew(this.u6w_1);
  }
  equals(other) {
    return AGBlendFactor__equals_impl_dlauac(this.u6w_1, other);
  }
}
class Companion_38 {
  constructor() {
    Companion_instance_47 = this;
    this.t6t_1 = _AGBlendEquation___init__impl__fpv7c2(0);
    this.u6t_1 = _AGBlendEquation___init__impl__fpv7c2(1);
    this.v6t_1 = _AGBlendEquation___init__impl__fpv7c2(2);
  }
}
class AGBlendEquation {
  constructor(ordinal) {
    Companion_getInstance_54();
    this.v6w_1 = ordinal;
  }
  toString() {
    return AGBlendEquation__toString_impl_5t2sx6(this.v6w_1);
  }
  hashCode() {
    return AGBlendEquation__hashCode_impl_fy33vp(this.v6w_1);
  }
  equals(other) {
    return AGBlendEquation__equals_impl_yykk3b(this.v6w_1, other);
  }
}
class Companion_39 {
  w6w() {
    return _AGSize___init__impl__h9blcq(-2);
  }
  k6u(width, height) {
    return AGSize__with_impl_qn6qww(_AGSize___init__impl__h9blcq(0), width, height);
  }
}
class Companion_40 {
  constructor() {
    Companion_instance_49 = this;
    this.h6v_1 = _AGStencilOp___init__impl__llpkv6(0);
    this.i6v_1 = _AGStencilOp___init__impl__llpkv6(1);
    this.j6v_1 = _AGStencilOp___init__impl__llpkv6(2);
    this.k6v_1 = _AGStencilOp___init__impl__llpkv6(3);
    this.l6v_1 = _AGStencilOp___init__impl__llpkv6(4);
    this.m6v_1 = _AGStencilOp___init__impl__llpkv6(5);
    this.n6v_1 = _AGStencilOp___init__impl__llpkv6(6);
    this.o6v_1 = _AGStencilOp___init__impl__llpkv6(7);
  }
}
class AGStencilOp {
  constructor(ordinal) {
    Companion_getInstance_56();
    this.x6w_1 = ordinal;
  }
  toString() {
    return AGStencilOp__toString_impl_1dm6fq(this.x6w_1);
  }
  hashCode() {
    return AGStencilOp__hashCode_impl_n4s38l(this.x6w_1);
  }
  equals(other) {
    return AGStencilOp__equals_impl_rq4p55(this.x6w_1, other);
  }
}
class Companion_41 {
  constructor() {
    Companion_instance_50 = this;
    this.z6u_1 = _AGCompareMode___init__impl__j8kqbb(0);
    this.a6v_1 = _AGCompareMode___init__impl__j8kqbb(1);
    this.b6v_1 = _AGCompareMode___init__impl__j8kqbb(2);
    this.c6v_1 = _AGCompareMode___init__impl__j8kqbb(3);
    this.d6v_1 = _AGCompareMode___init__impl__j8kqbb(4);
    this.e6v_1 = _AGCompareMode___init__impl__j8kqbb(5);
    this.f6v_1 = _AGCompareMode___init__impl__j8kqbb(6);
    this.g6v_1 = _AGCompareMode___init__impl__j8kqbb(7);
  }
}
class AGCompareMode {
  constructor(ordinal) {
    Companion_getInstance_57();
    this.y6w_1 = ordinal;
  }
  toString() {
    return AGCompareMode__toString_impl_gs33a9(this.y6w_1);
  }
  hashCode() {
    return AGCompareMode__hashCode_impl_whv1w0(this.y6w_1);
  }
  equals(other) {
    return AGCompareMode__equals_impl_rbniy4(this.y6w_1, other);
  }
}
class Companion_42 {
  constructor() {
    Companion_instance_51 = this;
    this.u6v_1 = _AGFrontFace___init__impl__vsm7rb(0);
    this.v6v_1 = _AGFrontFace___init__impl__vsm7rb(1);
    this.w6v_1 = _AGFrontFace___init__impl__vsm7rb(2);
  }
}
class AGMultiBatch {
  constructor(list) {
    this.h6l_1 = list;
  }
  i6l(ag) {
    // Inline function 'korlibs.datastructure.iterators.fastForEach' call
    var this_0 = this.h6l_1;
    var n = 0;
    while (n < this_0.e1()) {
      // Inline function 'korlibs.graphics.AGMultiBatch.execute.<anonymous>' call
      var _unary__edvuaz = n;
      n = _unary__edvuaz + 1 | 0;
      this_0.d1(_unary__edvuaz).i6l(ag);
    }
  }
  toString() {
    return 'AGMultiBatch(list=' + toString(this.h6l_1) + ')';
  }
  hashCode() {
    return hashCode(this.h6l_1);
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof AGMultiBatch))
      return false;
    var tmp0_other_with_cast = other instanceof AGMultiBatch ? other : THROW_CCE();
    if (!equals(this.h6l_1, tmp0_other_with_cast.h6l_1))
      return false;
    return true;
  }
}
class AGConfig {
  constructor(antialiasHint) {
    antialiasHint = antialiasHint === VOID ? true : antialiasHint;
    this.z6w_1 = antialiasHint;
  }
  toString() {
    return 'AGConfig(antialiasHint=' + this.z6w_1 + ')';
  }
  hashCode() {
    return getBooleanHashCode(this.z6w_1);
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof AGConfig))
      return false;
    var tmp0_other_with_cast = other instanceof AGConfig ? other : THROW_CCE();
    if (!(this.z6w_1 === tmp0_other_with_cast.z6w_1))
      return false;
    return true;
  }
}
class AGBufferKind extends Enum {}
class AGStats {
  constructor(texturesCount, texturesMemory, buffersCount, buffersMemory, frameBuffersCount, frameBuffersMemory, texturesCreated, texturesDeleted, programCount) {
    texturesCount = texturesCount === VOID ? 0 : texturesCount;
    texturesMemory = texturesMemory === VOID ? Companion_getInstance_9().q14(0) : texturesMemory;
    buffersCount = buffersCount === VOID ? 0 : buffersCount;
    buffersMemory = buffersMemory === VOID ? Companion_getInstance_9().q14(0) : buffersMemory;
    frameBuffersCount = frameBuffersCount === VOID ? 0 : frameBuffersCount;
    frameBuffersMemory = frameBuffersMemory === VOID ? Companion_getInstance_9().q14(0) : frameBuffersMemory;
    texturesCreated = texturesCreated === VOID ? 0 : texturesCreated;
    texturesDeleted = texturesDeleted === VOID ? 0 : texturesDeleted;
    programCount = programCount === VOID ? 0 : programCount;
    this.a6x_1 = texturesCount;
    this.b6x_1 = texturesMemory;
    this.c6x_1 = buffersCount;
    this.d6x_1 = buffersMemory;
    this.e6x_1 = frameBuffersCount;
    this.f6x_1 = frameBuffersMemory;
    this.g6x_1 = texturesCreated;
    this.h6x_1 = texturesDeleted;
    this.i6x_1 = programCount;
  }
  toString() {
    return 'AGStats(textures[' + this.a6x_1 + '] = ' + ByteUnits__toString_impl_ox2ku2(this.b6x_1) + ', buffers[' + this.c6x_1 + '] = ' + ByteUnits__toString_impl_ox2ku2(this.d6x_1) + ', frameBuffers[' + this.e6x_1 + '] = ' + ByteUnits__toString_impl_ox2ku2(this.f6x_1) + ', programs[' + this.i6x_1 + '])';
  }
}
class UniformBlock {
  constructor(fixedLocation) {
    this.x6r_1 = fixedLocation;
    this.y6r_1 = new UBLayoutBuilder();
    var tmp = this;
    // Inline function 'kotlin.collections.arrayListOf' call
    tmp.z6r_1 = ArrayList.h1();
    this.a6s_1 = 0;
  }
  s3() {
    return get_portableSimpleName(getKClassFromExpression(this));
  }
  c6y() {
    return this.z6r_1;
  }
  d6y() {
    return this.y6r_1.e1();
  }
  e6y() {
    return nextMultipleOf(this.d6y(), 256);
  }
  f6y() {
    return this.c6y().e1();
  }
  g6y(name) {
    return this.n6y(name, VarType_Float1_getInstance(), 4, 4);
  }
  h6y(name, $super) {
    name = name === VOID ? null : name;
    return $super === VOID ? this.g6y(name) : $super.g6y.call(this, name);
  }
  i6y(name) {
    return this.n6y(name, VarType_Float2_getInstance(), 8, 8);
  }
  j6y(name, $super) {
    name = name === VOID ? null : name;
    return $super === VOID ? this.i6y(name) : $super.i6y.call(this, name);
  }
  k6y(name) {
    return this.n6y(name, VarType_Float4_getInstance(), 16, 16);
  }
  l6y(name, $super) {
    name = name === VOID ? null : name;
    return $super === VOID ? this.k6y(name) : $super.k6y.call(this, name);
  }
  m6y(name) {
    return this.n6y(name, VarType_Mat4_getInstance(), 64, 16);
  }
  p6x(name, $super) {
    name = name === VOID ? null : name;
    return $super === VOID ? this.m6y(name) : $super.m6y.call(this, name);
  }
  n6y(name, type, size, align) {
    var tmp = this.y6r_1.c7e(size, align);
    var _unary__edvuaz = this.a6s_1;
    this.a6s_1 = _unary__edvuaz + 1 | 0;
    return new Gen(this, name, tmp, _unary__edvuaz, type, 1, size, align);
  }
  toString() {
    return 'UniformBlock[' + get_portableSimpleName(getKClassFromExpression(this)) + '][' + joinToString(this.c6y(), ', ') + ', fixedLocation=' + this.x6r_1 + ']';
  }
}
class ProjViewUB extends UniformBlock {
  constructor() {
    ProjViewUB_instance = null;
    super(0);
    ProjViewUB_instance = this;
    this.n6x_1 = this.p6x().z6x(this, u_ProjMat$factory());
    this.o6x_1 = this.p6x().z6x(this, u_ViewMat$factory());
  }
  a6y() {
    return this.n6x_1.no(this, u_ProjMat$factory_0());
  }
  b6y() {
    return this.o6x_1.no(this, u_ViewMat$factory_0());
  }
}
class DefaultShaders {
  constructor() {
    DefaultShaders_instance = this;
    this.y6v_1 = Sampler_0(1, SamplerVarType_Sampler2D_getInstance()).q6y(this, u_Tex$factory());
    this.z6v_1 = Sampler_0(2, SamplerVarType_Sampler2D_getInstance()).q6y(this, u_TexEx$factory());
    this.a6w_1 = Attribute.h6z('a_Pos', VarType_Float2_getInstance(), false, Precision_HIGH_getInstance(), 0);
    this.b6w_1 = Attribute.h6z('a_Tex', VarType_Float2_getInstance(), false, Precision_MEDIUM_getInstance(), 1);
    this.c6w_1 = Attribute.h6z('a_Col', VarType_UByte4_getInstance(), true, Precision_LOW_getInstance(), 2);
    this.d6w_1 = Varying.t6z('v_Tex', VarType_Float2_getInstance(), Precision_MEDIUM_getInstance());
    this.e6w_1 = Varying.t6z('v_Col', VarType_Float4_getInstance());
    this.f6w_1 = Temp.f70(0, VarType_Float4_getInstance());
    this.g6w_1 = Temp.f70(1, VarType_Float4_getInstance());
    this.h6w_1 = Temp.f70(2, VarType_Mat2_getInstance());
    this.i6w_1 = ProgramLayout.q6s([this.a6w_1, this.b6w_1, this.c6w_1]);
    var tmp = this;
    // Inline function 'korlibs.graphics.shader.VertexShader' call
    var builder = ProgramBuilderDefault.i70();
    // Inline function 'korlibs.graphics.DefaultShaders.VERTEX_DEFAULT.<anonymous>' call
    builder.n70(builder.j70(), builder.k70());
    builder.n70(builder.o70(), builder.p70());
    builder.n70(builder.q70(), builder.r70(builder.r70(builder.a6y(), builder.b6y()), builder.u70([builder.s70(), builder.t70(0.0), builder.t70(1.0)])));
    tmp.j6w_1 = VertexShader(builder.v70());
    var tmp_0 = this;
    // Inline function 'korlibs.graphics.FragmentShaderDefault' call
    // Inline function 'kotlin.also' call
    var this_0 = ProgramBuilderDefault.i70();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.graphics.DefaultShaders.MERGE_ALPHA_PROGRAM.<anonymous>' call
    var coords = this_0.w70(this_0.j70(), 'xy');
    this_0.n70(this_0.q70(), this_0.r70(this_0.y70(this_0.x70(), coords), this_0.a71(this_0.y70(DefaultShaders_getInstance().z70(), coords))));
    var tmp$ret$2 = FragmentShader(this_0.v70());
    tmp_0.k6w_1 = new Program(this.j6w_1, tmp$ret$2);
    var tmp_1 = this;
    // Inline function 'korlibs.graphics.shader.FragmentShader' call
    var builder_0 = ProgramBuilderDefault.i70();
    // Inline function 'korlibs.graphics.DefaultShaders.FRAGMENT_DEBUG.<anonymous>' call
    builder_0.n70(builder_0.q70(), builder_0.u70([builder_0.t70(1.0), builder_0.t70(1.0), builder_0.t70(0.0), builder_0.t70(1.0)]));
    tmp_1.l6w_1 = FragmentShader(builder_0.v70());
    var tmp_2 = this;
    // Inline function 'korlibs.graphics.shader.FragmentShader' call
    var builder_1 = ProgramBuilderDefault.i70();
    // Inline function 'korlibs.graphics.DefaultShaders.FRAGMENT_SOLID_COLOR.<anonymous>' call
    builder_1.n70(builder_1.q70(), builder_1.o70());
    tmp_2.m6w_1 = FragmentShader(builder_1.v70());
    var tmp_3 = this;
    // Inline function 'korlibs.graphics.shader.FragmentShader' call
    var builder_2 = ProgramBuilderDefault.i70();
    // Inline function 'korlibs.graphics.DefaultShaders.PROGRAM_TINTED_TEXTURE.<anonymous>' call
    builder_2.n70(builder_2.q70(), builder_2.r70(builder_2.w70(builder_2.y70(builder_2.x70(), builder_2.w70(builder_2.j70(), 'xy')), 'rgba'), builder_2.o70()));
    var tmp$ret$5 = FragmentShader(builder_2.v70());
    tmp_3.n6w_1 = new Program(this.j6w_1, tmp$ret$5, 'PROGRAM_TINTED_TEXTURE');
    var tmp_4 = this;
    // Inline function 'korlibs.graphics.shader.FragmentShader' call
    var builder_3 = ProgramBuilderDefault.i70();
    // Inline function 'korlibs.graphics.DefaultShaders.PROGRAM_TINTED_TEXTURE_PREMULT.<anonymous>' call
    builder_3.n70(builder_3.b71(), builder_3.y70(builder_3.x70(), builder_3.w70(builder_3.j70(), 'xy')));
    builder_3.n70(builder_3.w70(builder_3.b71(), 'rgb'), builder_3.c71(builder_3.w70(builder_3.b71(), 'rgb'), builder_3.w70(builder_3.b71(), 'a')));
    builder_3.n70(builder_3.q70(), builder_3.r70(builder_3.w70(builder_3.b71(), 'rgba'), builder_3.o70()));
    var tmp$ret$6 = FragmentShader(builder_3.v70());
    tmp_4.o6w_1 = new Program(this.j6w_1, tmp$ret$6, 'PROGRAM_TINTED_TEXTURE');
    this.p6w_1 = new Program(this.j6w_1, this.m6w_1, 'PROGRAM_SOLID_COLOR');
    this.q6w_1 = ProgramLayout.q6s([this.a6w_1]);
    var tmp_5 = this;
    // Inline function 'korlibs.graphics.shader.VertexShader' call
    var builder_4 = ProgramBuilderDefault.i70();
    // Inline function 'korlibs.graphics.DefaultShaders.PROGRAM_DEBUG.<anonymous>' call
    builder_4.n70(builder_4.q70(), builder_4.u70([builder_4.s70(), builder_4.t70(0.0), builder_4.t70(1.0)]));
    var tmp_6 = VertexShader(builder_4.v70());
    // Inline function 'korlibs.graphics.shader.FragmentShader' call
    var builder_5 = ProgramBuilderDefault.i70();
    // Inline function 'korlibs.graphics.DefaultShaders.PROGRAM_DEBUG.<anonymous>' call
    builder_5.n70(builder_5.q70(), builder_5.u70([builder_5.t70(1.0), builder_5.t70(0.0), builder_5.t70(0.0), builder_5.t70(1.0)]));
    var tmp$ret$8 = FragmentShader(builder_5.v70());
    tmp_5.r6w_1 = new Program(tmp_6, tmp$ret$8, 'PROGRAM_DEBUG');
    var tmp_7 = this;
    // Inline function 'korlibs.graphics.shader.VertexShader' call
    var builder_6 = ProgramBuilderDefault.i70();
    // Inline function 'korlibs.graphics.DefaultShaders.PROGRAM_DEBUG_WITH_PROJ.<anonymous>' call
    builder_6.n70(builder_6.q70(), builder_6.r70(builder_6.r70(builder_6.a6y(), builder_6.b6y()), builder_6.u70([builder_6.s70(), builder_6.t70(0.0), builder_6.t70(1.0)])));
    var tmp_8 = VertexShader(builder_6.v70());
    // Inline function 'korlibs.graphics.shader.FragmentShader' call
    var builder_7 = ProgramBuilderDefault.i70();
    // Inline function 'korlibs.graphics.DefaultShaders.PROGRAM_DEBUG_WITH_PROJ.<anonymous>' call
    builder_7.n70(builder_7.q70(), builder_7.u70([builder_7.t70(1.0), builder_7.t70(0.0), builder_7.t70(0.0), builder_7.t70(1.0)]));
    var tmp$ret$10 = FragmentShader(builder_7.v70());
    tmp_7.s6w_1 = new Program(tmp_8, tmp$ret$10, 'PROGRAM_DEBUG_WITH_PROJ');
  }
  x70() {
    return this.y6v_1.no(this, u_Tex$factory_0());
  }
  z70() {
    return this.z6v_1.no(this, u_TexEx$factory_0());
  }
  a6y() {
    return ProjViewUB_getInstance().a6y().w6r_1;
  }
  b6y() {
    return ProjViewUB_getInstance().b6y().w6r_1;
  }
}
class VarTypeAccessor {}
function get_Float1() {
  return VarType_Float1_getInstance();
}
function get_Float2() {
  return VarType_Float2_getInstance();
}
function get_Float4() {
  return VarType_Float4_getInstance();
}
class ExpressionBuilder {}
function get_out() {
  return Output_getInstance();
}
function atan(y, x) {
  return Func.y7n('atan', [y, x], y.w29());
}
function texture2D(sampler, coord) {
  return Func.y7n('texture2D', [sampler, coord], VarType_Float4_getInstance());
}
function TERNARY(cond, otrue, ofalse) {
  return Ternary.k7n(cond, otrue, ofalse);
}
function pow(b, e) {
  return Func.y7n('pow', [b, e], b.w29());
}
function sqrt(v) {
  return Func.y7n('sqrt', [v], v.w29());
}
function abs(v) {
  return Func.y7n('abs', [v], v.w29());
}
function fract(v) {
  return Func.y7n('fract', [v], v.w29());
}
function clamp(v, min, max) {
  return Func.y7n('clamp', [v, min, max], v.w29());
}
function min_0(a, b) {
  return Func.y7n('min', [a, b], a.w29());
}
function max_1(a, b) {
  return Func.y7n('max', [a, b], a.w29());
}
function fwidth(a) {
  return Func.y7n('fwidth', [a], a.w29());
}
function mix(a, b, step) {
  return Func.y7n('mix', [a, b, step], a.w29());
}
function smoothstep(a, b, c) {
  return Func.y7n('smoothstep', [a, b, c], a.w29());
}
function length(a) {
  return Func.y7n('length', [a], VarType_Float1_getInstance());
}
function get_lit(_this__u8e3s4) {
  return FloatLiteral.o7n(_this__u8e3s4);
}
function vec2(ops) {
  return Vector.p7n(VarType_Float2_getInstance(), ops);
}
function vec4(ops) {
  return Vector.p7n(VarType_Float4_getInstance(), ops);
}
function get_1(_this__u8e3s4, swizzle) {
  return Swizzle.q7n(_this__u8e3s4, swizzle);
}
function get_x(_this__u8e3s4) {
  return this.w70(_this__u8e3s4, 'x');
}
function get_y(_this__u8e3s4) {
  return this.w70(_this__u8e3s4, 'y');
}
function get_z(_this__u8e3s4) {
  return this.w70(_this__u8e3s4, 'z');
}
function get_w(_this__u8e3s4) {
  return this.w70(_this__u8e3s4, 'w');
}
function get_a(_this__u8e3s4) {
  return this.w70(_this__u8e3s4, 'w');
}
function unaryMinus(_this__u8e3s4) {
  return Unop.m7n('-', _this__u8e3s4);
}
function minus_0(_this__u8e3s4, that) {
  return Binop.n7n(_this__u8e3s4, '-', that);
}
function plus_2(_this__u8e3s4, that) {
  return Binop.n7n(_this__u8e3s4, '+', that);
}
function times(_this__u8e3s4, that) {
  return Binop.n7n(_this__u8e3s4, '*', that);
}
function div(_this__u8e3s4, that) {
  return Binop.n7n(_this__u8e3s4, '/', that);
}
function eq(_this__u8e3s4, that) {
  return Binop.n7n(_this__u8e3s4, '==', that);
}
function lt(_this__u8e3s4, that) {
  return Binop.n7n(_this__u8e3s4, '<', that);
}
function le(_this__u8e3s4, that) {
  return Binop.n7n(_this__u8e3s4, '<=', that);
}
function gt(_this__u8e3s4, that) {
  return Binop.n7n(_this__u8e3s4, '>', that);
}
function minus_1(_this__u8e3s4, that) {
  return this.q72(this.t70(_this__u8e3s4), that);
}
function plus_3(_this__u8e3s4, that) {
  return this.s72(this.t70(_this__u8e3s4), that);
}
function times_0(_this__u8e3s4, that) {
  return this.r70(this.t70(_this__u8e3s4), that);
}
function plus_4(_this__u8e3s4, that) {
  return this.s72(_this__u8e3s4, this.t70(that));
}
function times_1(_this__u8e3s4, that) {
  return this.r70(_this__u8e3s4, this.t70(that));
}
function div_0(_this__u8e3s4, that) {
  return this.c71(_this__u8e3s4, this.t70(that));
}
function lt_0(_this__u8e3s4, that) {
  return this.w72(_this__u8e3s4, this.t70(that));
}
function gt_0(_this__u8e3s4, that) {
  return this.z72(_this__u8e3s4, this.t70(that));
}
function and(_this__u8e3s4, that) {
  return Binop.n7n(_this__u8e3s4, '&&', that);
}
class Builder {
  static d71(context) {
    context = context === VOID ? new BuilderContext() : context;
    var $this = createThis(this);
    $this.l70_1 = context;
    var tmp = $this;
    // Inline function 'kotlin.collections.arrayListOf' call
    tmp.m70_1 = ArrayList.h1();
    return $this;
  }
  static j7m(parent) {
    return this.d71(parent.l70_1);
  }
  e71() {
    return Builder.j7m(this);
  }
  f71() {
    return FuncBuilder.i7m(this);
  }
  g71() {
    return new Stms(toList(this.m70_1));
  }
  h71() {
    var funcs = LinkedHashMap.gc();
    (new Program$Builder$_funcs$1(funcs)).j7n(this.m70_1);
    var _iterator__ex2g4s = this.l70_1.b7o_1.a1();
    while (_iterator__ex2g4s.b1()) {
      var func = _iterator__ex2g4s.c1();
      // Inline function 'kotlin.collections.set' call
      var key = func.n7j_1;
      funcs.i3(key, func);
    }
    return toList(funcs.h3());
  }
  v70() {
    return to(this.g71(), this.h71());
  }
  i71(name, rettype, block) {
    // Inline function 'kotlin.apply' call
    var this_0 = this.f71();
    // Inline function 'kotlin.contracts.contract' call
    block(this_0);
    var funcBuild = this_0;
    // Inline function 'kotlin.also' call
    // Inline function 'kotlin.collections.map' call
    var this_1 = funcBuild.g7m_1;
    // Inline function 'kotlin.collections.mapTo' call
    var destination = ArrayList.w(collectionSizeOrDefault(this_1, 10));
    var tmp0_iterator = this_1.a1();
    while (tmp0_iterator.b1()) {
      var item = tmp0_iterator.c1();
      // Inline function 'korlibs.graphics.shader.Builder.FUNC.<anonymous>' call
      var tmp$ret$1 = to(item.d76_1, item.w29());
      destination.h(tmp$ret$1);
    }
    var this_2 = new FuncDecl(name, rettype, destination, funcBuild.g71());
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.graphics.shader.Builder.FUNC.<anonymous>' call
    // Inline function 'kotlin.collections.plusAssign' call
    this.l70_1.b7o_1.h(this_2);
    return this_2;
  }
  j71(p0, dummy, returns, block) {
    var tmp = listOf(p0);
    return new FuncProvider(returns, tmp, this, Program$Builder$FUNC$lambda(block));
  }
  k71(p0, dummy, returns, block, $super) {
    dummy = dummy === VOID ? Unit_instance : dummy;
    var tmp;
    if ($super === VOID) {
      tmp = this.j71(p0, dummy, returns, block);
    } else {
      var tmp_0 = $super.j71;
      tmp = tmp_0.call(this, p0, Unit_instance, returns, block);
    }
    return tmp;
  }
  l71(p0, p1, dummy, returns, block) {
    var tmp = listOf_0([p0, p1]);
    return new FuncProvider(returns, tmp, this, Program$Builder$FUNC$lambda_0(block));
  }
  m71(p0, p1, dummy, returns, block, $super) {
    dummy = dummy === VOID ? Unit_instance : dummy;
    var tmp;
    if ($super === VOID) {
      tmp = this.l71(p0, p1, dummy, returns, block);
    } else {
      var tmp_0 = $super.l71;
      tmp = tmp_0.call(this, p0, p1, Unit_instance, returns, block);
    }
    return tmp;
  }
  n71(p0, p1, p2, dummy, returns, block) {
    var tmp = listOf_0([p0, p1, p2]);
    return new FuncProvider(returns, tmp, this, Program$Builder$FUNC$lambda_1(block));
  }
  o71(p0, p1, p2, dummy, returns, block, $super) {
    dummy = dummy === VOID ? Unit_instance : dummy;
    var tmp;
    if ($super === VOID) {
      tmp = this.n71(p0, p1, p2, dummy, returns, block);
    } else {
      var tmp_0 = $super.n71;
      tmp = tmp_0.call(this, p0, p1, p2, Unit_instance, returns, block);
    }
    return tmp;
  }
  p71(type) {
    var _receiver__tnumb7 = this.l70_1;
    var _unary__edvuaz = _receiver__tnumb7.c7o_1;
    _receiver__tnumb7.c7o_1 = _unary__edvuaz + 1 | 0;
    return Temp.f70(_unary__edvuaz, type);
  }
  q71(initialValue) {
    var temp = this.p71(initialValue.w29());
    this.n70(temp, initialValue);
    return temp;
  }
  r71(_this__u8e3s4, p0) {
    return CustomFunc.z7n(_this__u8e3s4, listOf(p0));
  }
  s71(_this__u8e3s4, p0, p1) {
    return CustomFunc.z7n(_this__u8e3s4, listOf_0([p0, p1]));
  }
  t71(_this__u8e3s4, p0, p1, p2) {
    return CustomFunc.z7n(_this__u8e3s4, listOf_0([p0, p1, p2]));
  }
  u71(_this__u8e3s4, callback) {
    var body = this.e71();
    callback(body);
    _this__u8e3s4.a7l_1 = body.g71();
  }
  v71(ref, min, max, block) {
    if (min >= max) {
      block(this, min);
    } else if ((max - min | 0) <= 1) {
      // Inline function 'korlibs.graphics.shader.Builder.IF' call
      var cond = this.v72(ref, this.t70(min));
      var body = this.e71();
      // Inline function 'korlibs.graphics.shader.Builder.IF_ELSE_BINARY_LOOKUP.<anonymous>' call
      block(body, min);
      var stmIf = new If(cond, body.g71());
      // Inline function 'kotlin.collections.plusAssign' call
      this.m70_1.h(stmIf);
      var tmp = stmIf;
      this.u71(tmp, Program$Builder$IF_ELSE_BINARY_LOOKUP$lambda(block, max));
    } else {
      var middle = (min + max | 0) / 2 | 0;
      // Inline function 'korlibs.graphics.shader.Builder.IF' call
      var cond_0 = this.y72(ref, this.t70(middle));
      var body_0 = this.e71();
      // Inline function 'korlibs.graphics.shader.Builder.IF_ELSE_BINARY_LOOKUP.<anonymous>' call
      body_0.v71(ref, min, middle, block);
      var stmIf_0 = new If(cond_0, body_0.g71());
      // Inline function 'kotlin.collections.plusAssign' call
      this.m70_1.h(stmIf_0);
      var tmp_0 = stmIf_0;
      this.u71(tmp_0, Program$Builder$IF_ELSE_BINARY_LOOKUP$lambda_0(ref, middle, max, block));
    }
  }
  w71(ref, min, max, block) {
    if (min >= max) {
      block(this, min);
    } else {
      // Inline function 'korlibs.graphics.shader.Builder.IF' call
      var cond = this.v72(ref, this.t70(min));
      var body = this.e71();
      // Inline function 'korlibs.graphics.shader.Builder.IF_ELSE_LIST.<anonymous>' call
      block(body, min);
      var stmIf = new If(cond, body.g71());
      // Inline function 'kotlin.collections.plusAssign' call
      this.m70_1.h(stmIf);
      var tmp = stmIf;
      this.u71(tmp, Program$Builder$IF_ELSE_LIST$lambda(ref, min, max, block));
    }
  }
  x71(shader) {
    this.y71(shader);
    return this;
  }
  y71(shader) {
    var tmp = shader.l7g_1;
    if (tmp instanceof Stms) {
      this.m70_1.f1(shader.l7g_1.e7k_1);
    } else {
      this.m70_1.h(shader.l7g_1);
    }
    this.l70_1.b7o_1.f1(shader.m7g_1);
  }
  n70(target, expr) {
    // Inline function 'kotlin.collections.plusAssign' call
    var this_0 = this.m70_1;
    var element = new Set(target, expr);
    this_0.h(element);
  }
  z71() {
    // Inline function 'kotlin.collections.plusAssign' call
    var this_0 = this.m70_1;
    var element = Discard_getInstance();
    this_0.h(element);
  }
  a72(operand) {
    // Inline function 'kotlin.collections.plusAssign' call
    var this_0 = this.m70_1;
    var element = new Return(operand);
    this_0.h(element);
  }
  b72(operand, $super) {
    operand = operand === VOID ? null : operand;
    var tmp;
    if ($super === VOID) {
      this.a72(operand);
      tmp = Unit_instance;
    } else {
      tmp = $super.a72.call(this, operand);
    }
    return tmp;
  }
  c72(type) {
    var _receiver__tnumb7 = this.l70_1;
    var _unary__edvuaz = _receiver__tnumb7.c7o_1;
    _receiver__tnumb7.c7o_1 = _unary__edvuaz + 1 | 0;
    return Temp.d7o(_unary__edvuaz, type, 1);
  }
}
class IDefaultShaders {}
function get_u_Tex() {
  return DefaultShaders_getInstance().x70();
}
function get_u_ProjMat() {
  return DefaultShaders_getInstance().a6y();
}
function get_u_ViewMat() {
  return DefaultShaders_getInstance().b6y();
}
function get_a_Pos() {
  return DefaultShaders_getInstance().a6w_1;
}
function get_a_Tex() {
  return DefaultShaders_getInstance().b6w_1;
}
function get_a_Col() {
  return DefaultShaders_getInstance().c6w_1;
}
function get_v_Tex() {
  return DefaultShaders_getInstance().d6w_1;
}
function get_v_Col() {
  return DefaultShaders_getInstance().e6w_1;
}
function get_t_Temp0() {
  return DefaultShaders_getInstance().f6w_1;
}
function get_t_Temp1() {
  return DefaultShaders_getInstance().g6w_1;
}
class ProgramBuilderDefault extends Builder {
  static i70() {
    return this.d71();
  }
}
class GLVAO {
  constructor(vao, glId, contextVersion) {
    glId = glId === VOID ? -1 : glId;
    contextVersion = contextVersion === VOID ? -1 : contextVersion;
    this.d73_1 = vao;
    this.e73_1 = glId;
    this.f73_1 = contextVersion;
  }
}
class ShaderException extends RuntimeException {
  static q73(str, error, errorInt, gl, debugName, type, shaderReturnInt) {
    var $this = this.oa('Error Compiling Shader : ' + debugName + ' type=' + type + ' : ' + get_hex(errorInt) + " : '" + error + "' : source='" + str + "', shaderReturnInt=" + shaderReturnInt + ', gl.versionInt=' + get_versionInt(gl) + ", gl.versionString='" + get_versionString(gl) + "', gl=" + toString(gl));
    captureStack($this, $this.p73_1);
    $this.i73_1 = str;
    $this.j73_1 = error;
    $this.k73_1 = errorInt;
    $this.l73_1 = gl;
    $this.m73_1 = debugName;
    $this.n73_1 = type;
    $this.o73_1 = shaderReturnInt;
    return $this;
  }
}
class TextureUnitParams {
  constructor(index) {
    this.r76_1 = index;
    this.s76_1 = _AGWrapMode___init__impl__x5wmya(-1);
    this.t76_1 = -1;
    this.u76_1 = -1;
    this.v76_1 = -1;
    this.w76_1 = -1;
  }
  t2q() {
    this.s76_1 = _AGWrapMode___init__impl__x5wmya(-1);
    this.t76_1 = -1;
    this.u76_1 = -1;
    this.v76_1 = -1;
    this.w76_1 = -1;
  }
}
class AGOpengl extends AG {
  static f79(gl, context) {
    context = context === VOID ? null : context;
    var $this = this.s6i();
    $this.v73_1 = gl;
    $this.w73_1 = context;
    var tmp = $this;
    // Inline function 'kotlin.collections.linkedSetOf' call
    tmp.x73_1 = LinkedHashSet.j1();
    $this.y73_1 = new GLGlobalState($this.v73_1, $this);
    $this.z73_1 = HashMap.l8();
    $this.a74_1 = null;
    var tmp_0 = $this;
    tmp_0.b74_1 = lazy(AGOpengl$glslConfig$delegate$lambda($this));
    $this.c74_1 = null;
    $this.d74_1 = Companion_getInstance_43().v6j_1;
    $this.e74_1 = Companion_getInstance_50().u6k_1;
    $this.f74_1 = Companion_getInstance_47().g6k_1;
    $this.g74_1 = Companion_getInstance_46().e6k_1;
    $this.h74_1 = Companion_getInstance_48().i6k_1;
    $this.i74_1 = Companion_getInstance_49().o6k_1;
    $this.j74_1 = null;
    $this.k74_1 = AGTextureUnits.u6m();
    $this.l74_1 = new Int32Array($this.k74_1.e1());
    $this.m74_1 = 0;
    $this.n74_1 = Companion_getInstance_44().s6k_1;
    $this.o74_1 = -1;
    $this.p74_1 = -1;
    $this.q74_1 = get_ENABLE_VERTEX_ARRAY_OBJECTS();
    $this.r74_1 = Ref();
    $this.s74_1 = Buffer.m12(36);
    var tmp_1 = $this;
    var tmp_2 = 0;
    // Inline function 'kotlin.arrayOfNulls' call
    var tmp_3 = fillArrayVal(Array(32), null);
    while (tmp_2 < 32) {
      var tmp_4 = tmp_2;
      tmp_3[tmp_4] = new TextureUnitParams(tmp_4);
      tmp_2 = tmp_2 + 1 | 0;
    }
    tmp_1.t74_1 = tmp_3;
    $this.u74_1 = allocDirect(Companion_instance_4, 0);
    $this.v74_1 = 7;
    $this.w74_1 = 0;
    $this.x74_1 = Companion_instance_48.w6w();
    $this.y74_1 = -1;
    $this.z74_1 = new Long(-1, -1);
    $this.a75_1 = null;
    return $this;
  }
  static g79(context) {
    return this.f79(context.i79_1, context);
  }
  o6j() {
    return this.v73_1;
  }
  i6j() {
    var gl = this.v73_1;
    super.i6j();
    gl.k79();
    gl.l79();
    this.z73_1.l3();
    resetObjects(this);
    this.o74_1 = -1;
    this.p74_1 = -1;
    this.q74_1 = true;
  }
  m6j(frameBuffer, frameBufferInfo, color, depth, stencil, clearColor, clearDepth, clearStencil, scissor) {
    var gl = this.v73_1;
    this.m79(frameBuffer, frameBufferInfo);
    this.n79(scissor, frameBuffer, frameBufferInfo);
    var mask = 0;
    if (clearColor) {
      this.o79(Companion_getInstance_48().l6k_1);
      gl.p79(_RGBA___get_rf__impl__kvz75k(color), _RGBA___get_gf__impl__5gcu1f(color), _RGBA___get_bf__impl__1xz5yg(color), _RGBA___get_af__impl__vu36qv(color));
      mask = mask | 16384;
    }
    if (clearDepth) {
      gl.q79(true);
      gl.r79(depth);
      mask = mask | 256;
    }
    if (clearStencil) {
      this.f74_1 = Companion_getInstance_47().g6k_1;
      gl.s79(-1);
      gl.t79(stencil);
      mask = mask | 1024;
    }
    gl.u79(mask);
  }
  n6j(frameBuffer, frameBufferInfo, vertexData, program, drawType, vertexCount, indices, indexType, drawOffset, blending, uniformBlocks, textureUnits, stencilRef, stencilOpFunc, colorMask, depthAndFrontFace, scissor, cullFace, instances) {
    var gl = this.v73_1;
    this.m79(frameBuffer, frameBufferInfo);
    this.n79(scissor, frameBuffer, frameBufferInfo);
    var tmp1_safe_receiver = this.c74_1;
    if (!equals(tmp1_safe_receiver == null ? null : tmp1_safe_receiver.e6s_1, vertexData.e6s_1)) {
      var tmp0_safe_receiver = this.c74_1;
      if (tmp0_safe_receiver == null)
        null;
      else {
        // Inline function 'kotlin.let' call
        // Inline function 'kotlin.contracts.contract' call
        this.v79(tmp0_safe_receiver);
      }
      this.c74_1 = vertexData;
      this.w79(vertexData);
    } else {
      // Inline function 'korlibs.datastructure.FastArrayList.fastForEach' call
      // Inline function 'korlibs.datastructure.FastArrayList.jsArray' call
      // Inline function 'kotlin.js.unsafeCast' call
      // Inline function 'kotlin.js.asDynamic' call
      var array = vertexData.e6s_1.qy_1;
      var n = 0;
      while (n < array.length) {
        // Inline function 'korlibs.graphics.gl.AGOpengl.draw.<anonymous>' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'korlibs.datastructure.get' call
        var _unary__edvuaz = n;
        n = _unary__edvuaz + 1 | 0;
        // Inline function 'kotlin.js.asDynamic' call
        // Inline function 'kotlin.js.asDynamic' call
        var entry = array[_unary__edvuaz];
        bindBuffer$default(this, entry.s6s_1, AGBufferKind_VERTEX_getInstance(), true);
      }
    }
    useProgram(this, program);
    this.x79(uniformBlocks, textureUnits, program, frameBuffer);
    if (!(this.d74_1 === blending)) {
      this.d74_1 = blending;
      // Inline function 'korlibs.kgl.KmlGl.enableDisable' call
      var enable = _AGBlending___get_enabled__impl__s7igz6(blending);
      if (gl.a7a(3042, enable)) {
        // Inline function 'korlibs.graphics.gl.AGOpengl.draw.<anonymous>' call
        gl.y79(toGl(_AGBlending___get_eqRGB__impl__7pv8oi(blending)), toGl(_AGBlending___get_eqA__impl__2j4ray(blending)));
        gl.z79(toGl_0(_AGBlending___get_srcRGB__impl__jvh03e(blending)), toGl_0(_AGBlending___get_dstRGB__impl__nz9ogp(blending)), toGl_0(_AGBlending___get_srcA__impl__ftmwxe(blending)), toGl_0(_AGBlending___get_dstA__impl__l7q6tv(blending)));
      }
    }
    this.b7a(depthAndFrontFace);
    this.o79(colorMask);
    if (!(this.e74_1 === cullFace)) {
      this.e74_1 = cullFace;
      this.c7a(cullFace);
    }
    if (!(this.f74_1 === stencilOpFunc) || !equals(this.g74_1, stencilRef)) {
      this.f74_1 = stencilOpFunc;
      this.g74_1 = stencilRef;
      if (_AGStencilOpFunc___get_enabled__impl__hxq8wy(stencilOpFunc)) {
        gl.e7a(2960);
        if (_AGStencilOpFunc___get_compareModeFront__impl__uctsey(stencilOpFunc) === _AGStencilOpFunc___get_compareModeBack__impl__2rklx0(stencilOpFunc) && _AGStencilReference___get_referenceValueFront__impl__p7smsu(stencilRef) === _AGStencilReference___get_referenceValueBack__impl__mlrbhc(stencilRef) && _AGStencilReference___get_readMaskFront__impl__oc0s46(stencilRef) === _AGStencilReference___get_readMaskBack__impl__lwtaqk(stencilRef)) {
          gl.g7a(toGl_1(_AGStencilOpFunc___get_compareModeFront__impl__uctsey(stencilOpFunc)), _AGStencilReference___get_referenceValueFront__impl__p7smsu(stencilRef), _AGStencilReference___get_readMaskFront__impl__oc0s46(stencilRef));
        } else {
          gl.f7a(1028, toGl_1(_AGStencilOpFunc___get_compareModeFront__impl__uctsey(stencilOpFunc)), _AGStencilReference___get_referenceValueFront__impl__p7smsu(stencilRef), _AGStencilReference___get_readMaskFront__impl__oc0s46(stencilRef));
          gl.f7a(1029, toGl_1(_AGStencilOpFunc___get_compareModeBack__impl__2rklx0(stencilOpFunc)), _AGStencilReference___get_referenceValueBack__impl__mlrbhc(stencilRef), _AGStencilReference___get_readMaskBack__impl__lwtaqk(stencilRef));
        }
        if (_AGStencilOpFunc___get_actionOnDepthFailFront__impl__vuqmyq(stencilOpFunc) === _AGStencilOpFunc___get_actionOnDepthFailBack__impl__3tna28(stencilOpFunc) && _AGStencilOpFunc___get_actionOnDepthPassStencilFailFront__impl__kl5ndh(stencilOpFunc) === _AGStencilOpFunc___get_actionOnDepthPassStencilFailBack__impl__4qprmh(stencilOpFunc) && _AGStencilOpFunc___get_actionOnBothPassFront__impl__aehsgx(stencilOpFunc) === _AGStencilOpFunc___get_actionOnBothPassBack__impl__i5t9l9(stencilOpFunc)) {
          gl.i7a(toGl_2(_AGStencilOpFunc___get_actionOnDepthFailFront__impl__vuqmyq(stencilOpFunc)), toGl_2(_AGStencilOpFunc___get_actionOnDepthPassStencilFailFront__impl__kl5ndh(stencilOpFunc)), toGl_2(_AGStencilOpFunc___get_actionOnBothPassFront__impl__aehsgx(stencilOpFunc)));
        } else {
          gl.h7a(1028, toGl_2(_AGStencilOpFunc___get_actionOnDepthFailFront__impl__vuqmyq(stencilOpFunc)), toGl_2(_AGStencilOpFunc___get_actionOnDepthPassStencilFailFront__impl__kl5ndh(stencilOpFunc)), toGl_2(_AGStencilOpFunc___get_actionOnBothPassFront__impl__aehsgx(stencilOpFunc)));
          gl.h7a(1029, toGl_2(_AGStencilOpFunc___get_actionOnDepthFailBack__impl__3tna28(stencilOpFunc)), toGl_2(_AGStencilOpFunc___get_actionOnDepthPassStencilFailBack__impl__4qprmh(stencilOpFunc)), toGl_2(_AGStencilOpFunc___get_actionOnBothPassBack__impl__i5t9l9(stencilOpFunc)));
        }
        if (_AGStencilReference___get_writeMaskFront__impl__cqdpbj(stencilRef) === _AGStencilReference___get_writeMaskBack__impl__mths73(stencilRef)) {
          gl.s79(_AGStencilReference___get_writeMaskFront__impl__cqdpbj(stencilRef));
        } else {
          gl.j7a(1028, _AGStencilReference___get_writeMaskFront__impl__cqdpbj(stencilRef));
          gl.j7a(1029, _AGStencilReference___get_writeMaskBack__impl__mths73(stencilRef));
        }
      } else {
        gl.d7a(2960);
        gl.s79(0);
      }
    }
    if (indices == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'korlibs.graphics.gl.AGOpengl.draw.<anonymous>' call
      bindBuffer$default(this, indices, AGBufferKind_INDEX_getInstance());
    }
    var indexType_0 = !(indices == null) ? indexType : Companion_getInstance_42().r6j_1;
    if (!(indexType_0 === Companion_getInstance_42().r6j_1))
      if (!(instances === 1)) {
        gl.n7a(toGl_3(drawType), vertexCount, toGl_4(indexType_0), drawOffset, instances);
      } else {
        gl.m7a(toGl_3(drawType), vertexCount, toGl_4(indexType_0), drawOffset);
      }
     else if (!(instances === 1)) {
      gl.l7a(toGl_3(drawType), drawOffset, vertexCount, instances);
    } else {
      gl.k7a(toGl_3(drawType), drawOffset, vertexCount);
    }
  }
  g75() {
    // Inline function 'kotlin.getValue' call
    var this_0 = this.b74_1;
    glslConfig$factory();
    return this_0.u1();
  }
  l6j() {
    var gl = this.v73_1;
    var tmp0_safe_receiver = this.w73_1;
    if (tmp0_safe_receiver == null)
      null;
    else {
      tmp0_safe_receiver.o7a();
    }
    gl.p7a(this.q6i_1);
    resetObjects(this);
    this.m74_1 = getIntegerv(gl, 36006);
    gl.q78(33984);
    if (_GLVariant___get_supportTextureLevel__impl__3yeu62(gl.r78())) {
      // Inline function 'korlibs.kgl.KmlGl.TEXTURE_2D' call
      gl.p78(3553, 33084, 0);
      // Inline function 'korlibs.kgl.KmlGl.TEXTURE_2D' call
      gl.p78(3553, 33085, 0);
    }
  }
  u6e() {
    var tmp0_safe_receiver = this.c74_1;
    if (tmp0_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      // Inline function 'kotlin.contracts.contract' call
      this.v79(tmp0_safe_receiver);
    }
    this.c74_1 = null;
    this.m79(this.h6j().t6i_1, this.h6j().z6k());
    var tmp1_safe_receiver = this.w73_1;
    if (tmp1_safe_receiver == null)
      null;
    else {
      tmp1_safe_receiver.q7a();
    }
  }
  j6j() {
    var tmp0_safe_receiver = this.c74_1;
    if (tmp0_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      // Inline function 'kotlin.contracts.contract' call
      this.v79(tmp0_safe_receiver);
    }
    this.c74_1 = null;
    this.v73_1.qc();
    deletePendingObjects(this);
  }
  c7a(face) {
    if (this.v73_1.a7a(2884, _AGCullFace___get_ordinal__impl__jd1wps(face) > _AGCullFace___get_ordinal__impl__jd1wps(Companion_getInstance_50().v6k_1))) {
      this.v73_1.r7a(toGl_5(face));
    }
  }
  q77(_this__u8e3s4, block) {
    if (!(_this__u8e3s4.j6m_1 === _this__u8e3s4.k6m_1)) {
      _this__u8e3s4.j6m_1 = _this__u8e3s4.k6m_1;
      block(_this__u8e3s4);
    }
  }
  v79(vao) {
    if (this.q74_1 && this.v73_1.q6j()) {
      this.v73_1.u7a(0);
    } else {
      // Inline function 'korlibs.datastructure.FastArrayList.fastForEach' call
      // Inline function 'korlibs.datastructure.FastArrayList.jsArray' call
      // Inline function 'kotlin.js.unsafeCast' call
      // Inline function 'kotlin.js.asDynamic' call
      var array = vao.e6s_1.qy_1;
      var n = 0;
      while (n < array.length) {
        // Inline function 'korlibs.graphics.gl.AGOpengl.vaoUnuse.<anonymous>' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'korlibs.datastructure.get' call
        var _unary__edvuaz = n;
        n = _unary__edvuaz + 1 | 0;
        // Inline function 'kotlin.js.asDynamic' call
        // Inline function 'kotlin.js.asDynamic' call
        // Inline function 'korlibs.datastructure.iterators.fastForEach' call
        // Inline function 'korlibs.graphics.shader.attributes' call
        var this_0 = array[_unary__edvuaz].r6s_1.i6s_1;
        var n_0 = 0;
        while (n_0 < this_0.e1()) {
          // Inline function 'korlibs.graphics.gl.AGOpengl.vaoUnuse.<anonymous>.<anonymous>' call
          var _unary__edvuaz_0 = n_0;
          n_0 = _unary__edvuaz_0 + 1 | 0;
          var att = this_0.d1(_unary__edvuaz_0);
          if (att.e6z_1) {
            var loc = att.g6z_1;
            if (loc >= 0) {
              if (!(att.f6z_1 === 0)) {
                this.v73_1.s7a(loc, 0);
              }
              this.v73_1.t7a(loc);
            }
          }
        }
      }
    }
  }
  w79(vao) {
    var gl = this.v73_1;
    if (this.q74_1 && gl.q6j()) {
      var vaoGl = get_gl(vao);
      if (vao.f6s_1) {
        if (!(this.p74_1 === this.q6i_1)) {
          this.o74_1 = genVertexArray(gl);
          this.p74_1 = this.q6i_1;
          if (this.o74_1 <= 0)
            this.q74_1 = false;
        }
        gl.u7a(this.o74_1);
        this.v7a(vao);
      } else {
        if (!(vaoGl.f73_1 === this.q6i_1)) {
          vaoGl.f73_1 = this.q6i_1;
          vaoGl.e73_1 = genVertexArray(gl);
          if (vaoGl.e73_1 <= 0)
            this.q74_1 = false;
          gl.u7a(vaoGl.e73_1);
          this.v7a(vao);
        }
        gl.u7a(vaoGl.e73_1);
        this.w7a(vao, this.q74_1);
      }
    } else {
      this.v7a(vao);
    }
  }
  w7a(vao, updateBuffersOnly) {
    var gl = this.v73_1;
    if (updateBuffersOnly) {
      // Inline function 'korlibs.datastructure.FastArrayList.fastForEach' call
      // Inline function 'korlibs.datastructure.FastArrayList.jsArray' call
      // Inline function 'kotlin.js.unsafeCast' call
      // Inline function 'kotlin.js.asDynamic' call
      var array = vao.e6s_1.qy_1;
      var n = 0;
      while (n < array.length) {
        // Inline function 'korlibs.graphics.gl.AGOpengl._vaoUse.<anonymous>' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'korlibs.datastructure.get' call
        var _unary__edvuaz = n;
        n = _unary__edvuaz + 1 | 0;
        // Inline function 'kotlin.js.asDynamic' call
        // Inline function 'kotlin.js.asDynamic' call
        var entry = array[_unary__edvuaz];
        bindBuffer$default(this, entry.s6s_1, AGBufferKind_VERTEX_getInstance(), VOID, VOID, this.r74_1);
      }
      return Unit_instance;
    }
    // Inline function 'korlibs.datastructure.FastArrayList.fastForEach' call
    // Inline function 'korlibs.datastructure.FastArrayList.jsArray' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var array_0 = vao.e6s_1.qy_1;
    var n_0 = 0;
    while (n_0 < array_0.length) {
      // Inline function 'korlibs.graphics.gl.AGOpengl._vaoUse.<anonymous>' call
      // Inline function 'kotlin.js.unsafeCast' call
      // Inline function 'korlibs.datastructure.get' call
      var _unary__edvuaz_0 = n_0;
      n_0 = _unary__edvuaz_0 + 1 | 0;
      // Inline function 'kotlin.js.asDynamic' call
      // Inline function 'kotlin.js.asDynamic' call
      var entry_0 = array_0[_unary__edvuaz_0];
      var vertices = entry_0.s6s_1;
      var vertexLayout = entry_0.r6s_1;
      // Inline function 'korlibs.graphics.shader.attributes' call
      var vattrs = vertexLayout.i6s_1;
      // Inline function 'korlibs.graphics.shader.attributePositions' call
      var vattrspos = vertexLayout.n6s_1;
      bindBuffer$default(this, vertices, AGBufferKind_VERTEX_getInstance(), VOID, VOID, this.r74_1);
      var totalSize = vertexLayout.p6s_1;
      var inductionVariable = 0;
      var last = vattrspos.e1() - 1 | 0;
      if (inductionVariable <= last)
        $l$loop: do {
          var n_1 = inductionVariable;
          inductionVariable = inductionVariable + 1 | 0;
          var att = vattrs.d1(n_1);
          if (!att.e6z_1)
            continue $l$loop;
          var off = vattrspos.d1(n_1);
          var loc = att.g6z_1;
          var glElementType = toGl_7(att.w29());
          var elementCount = att.w29().b78_1;
          if (loc >= 0) {
            gl.x7a(loc);
            gl.y7a(loc, elementCount, glElementType, att.d6z_1, totalSize, numberToLong(entry_0.t6s_1).y3(toLong(off)));
            if (!(att.f6z_1 === 0)) {
              gl.s7a(loc, att.f6z_1);
            }
          }
        }
         while (inductionVariable <= last);
    }
  }
  v7a(vao, updateBuffersOnly, $super) {
    updateBuffersOnly = updateBuffersOnly === VOID ? false : updateBuffersOnly;
    var tmp;
    if ($super === VOID) {
      this.w7a(vao, updateBuffersOnly);
      tmp = Unit_instance;
    } else {
      tmp = $super.w7a.call(this, vao, updateBuffersOnly);
    }
    return tmp;
  }
  x79(uniformBlocks, textureUnits, program, frameBuffer) {
    var tmp0_elvis_lhs = this.j74_1;
    var tmp;
    if (tmp0_elvis_lhs == null) {
      return Unit_instance;
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var glProgram = tmp;
    // Inline function 'korlibs.graphics.AGTextureUnits.fastForEach' call
    var inductionVariable = 0;
    var last = textureUnits.e1();
    if (inductionVariable < last)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        // Inline function 'korlibs.graphics.gl.AGOpengl.uniformsSet.<anonymous>' call
        var tex = textureUnits.s6m_1[n];
        var info = AGTextureUnitInfoArray__get_impl_xhvpef(textureUnits.t6m_1, n);
        var tex_0 = tex;
        if (equals(frameBuffer.z6n_1, tex_0)) {
          tex_0 = null;
        }
        var tmp0_safe_receiver = tex_0;
        var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.k6m_1;
        var texVersion = tmp1_elvis_lhs == null ? -1 : tmp1_elvis_lhs;
        if (!(this.k74_1.s6m_1[n] === tex_0) || !(AGTextureUnitInfoArray__get_impl_xhvpef(this.k74_1.t6m_1, n) === info) || !(this.l74_1[n] === texVersion)) {
          this.k74_1.x6m(n, tex_0, info);
          this.l74_1[n] = texVersion;
          selectTextureUnit(this, n);
          if (!(tex_0 == null)) {
            var wrap = _AGTextureUnitInfo___get_wrap__impl__dwp6l(info);
            var linear = _AGTextureUnitInfo___get_linear__impl__jak6ny(info);
            var trilinear = _AGTextureUnitInfo___get_trilinear__impl__hxtqfb(info);
            this.z7a(tex_0, _AGTextureUnitInfo___get_kind__impl__6xtjoz(info));
            textureUnitParameters(this, tex_0.b6p(), wrap, this.a7b(tex_0, linear, trilinear), this.b7b(tex_0, linear, trilinear), _AGTextureTargetKind___get_dims__impl__k3cmhd(tex_0.b6p()));
          } else {
            this.z7a(null, Companion_getInstance_51().x6o_1);
          }
        }
      }
       while (inductionVariable < last);
    var glProgramInfo = glProgram.l75_1;
    // Inline function 'korlibs.graphics.shader.UniformBlocksBuffersRef.fastForEachBlock' call
    var inductionVariable_0 = 0;
    var last_0 = uniformBlocks.e1();
    if (inductionVariable_0 < last_0)
      $l$loop: do {
        var n_0 = inductionVariable_0;
        inductionVariable_0 = inductionVariable_0 + 1 | 0;
        var tmp0_elvis_lhs_0 = uniformBlocks.c7b_1[n_0];
        var tmp_0;
        if (tmp0_elvis_lhs_0 == null) {
          continue $l$loop;
        } else {
          tmp_0 = tmp0_elvis_lhs_0;
        }
        var block = tmp_0;
        $l$block: {
          // Inline function 'korlibs.graphics.gl.AGOpengl.uniformsSet.<anonymous>' call
          var buffer = uniformBlocks.d7b_1[n_0];
          var valueIndex = uniformBlocks.e7b_1[n_0];
          if (glProgram.l75_1.r75_1.q76()) {
            var buffer_0 = bindBuffer$default(this, buffer, AGBufferKind_UNIFORM_getInstance());
            var tmp1_elvis_lhs_0 = buffer_0 == null ? null : buffer_0.n77_1;
            this.v73_1.f7b(35345, block.d6q_1.x6r_1, tmp1_elvis_lhs_0 == null ? -1 : tmp1_elvis_lhs_0, imul(valueIndex, block.g6q_1), block.g6q_1);
            break $l$block;
          }
          var tmp2_elvis_lhs = glProgramInfo.u75_1[block.d6q_1.x6r_1];
          var tmp_1;
          if (tmp2_elvis_lhs == null) {
            var message = "Can't find uniform at " + block.d6q_1.x6r_1 + ' for program ' + program.toString() + ' for block ' + block.toString();
            throw IllegalStateException.z4(toString(message));
          } else {
            tmp_1 = tmp2_elvis_lhs;
          }
          var ref = tmp_1;
          var bufferMem = ensureNotNull(ensureNotNull(buffer).g6m_1);
          var currentMem = ref.h7b_1;
          var ublock = ref.g7b_1;
          if (valueIndex >= 0) {
            if (!arrayequal(bufferMem, valueIndex, currentMem, 0, ublock.e6y())) {
              arraycopy_0(bufferMem, imul(ublock.e6y(), valueIndex), currentMem, 0, ublock.e6y());
              // Inline function 'korlibs.datastructure.iterators.fastForEach' call
              var this_0 = ublock.c6y();
              var n_1 = 0;
              while (n_1 < this_0.e1()) {
                // Inline function 'korlibs.graphics.gl.AGOpengl.uniformsSet.<anonymous>.<anonymous>' call
                var _unary__edvuaz = n_1;
                n_1 = _unary__edvuaz + 1 | 0;
                var uniform = this_0.d1(_unary__edvuaz);
                writeUniform(this, uniform.w6r_1, glProgramInfo, sliceBuffer(currentMem, uniform.t6r_1, uniform.t6r_1 + uniform.x77_1 | 0), 'blockUniformSet');
              }
            }
          } else {
            println('ERROR block: ' + block.d6q_1.toString() + ' has an invalid valueIndex=' + valueIndex);
          }
        }
      }
       while (inductionVariable_0 < last_0);
  }
  a7b(_this__u8e3s4, linear, trilinear) {
    var tmp;
    if ((_this__u8e3s4 == null ? null : _this__u8e3s4.r6o_1) === true) {
      tmp = linear ? trilinear ? 9987 : 9985 : trilinear ? 9986 : 9984;
    } else {
      tmp = linear ? 9729 : 9728;
    }
    return tmp;
  }
  b7b(_this__u8e3s4, linear, trilinear) {
    return linear ? 9729 : 9728;
  }
  k7b(scissor, frameBuffer, frameBufferInfo) {
    return scissor.equals(Companion_getInstance_44().t6k_1) || scissor.equals(Companion_getInstance_44().r6k_1) ? scissor : frameBuffer.y6n_1 ? Companion_getInstance_44().i2e(scissor.d26(), _AGFrameBufferInfo___get_height__impl__yfespa(frameBufferInfo) - scissor.g26() | 0, scissor.e26(), _AGFrameBufferInfo___get_height__impl__yfespa(frameBufferInfo) - scissor.f26() | 0) : scissor;
  }
  z7a(tex, target) {
    var gl = this.v73_1;
    var glTex = tex == null ? null : _get_gl__ndc1ty_1(tex, this);
    var tmp = toGl_8(target);
    var tmp2_elvis_lhs = glTex == null ? null : glTex.b79_1;
    gl.l7b(tmp, tmp2_elvis_lhs == null ? 0 : tmp2_elvis_lhs);
    var texBitmap = tex == null ? null : tex.q6o_1;
    if (!(glTex == null) && !(texBitmap == null)) {
      if (!(glTex.c79_1 === texBitmap.g40_1) || !(glTex.d79_1 === this.q6i_1)) {
        glTex.c79_1 = texBitmap.g40_1;
        glTex.d79_1 = this.q6i_1;
        tex.r6m();
      }
      this.q77(tex, AGOpengl$textureBind$lambda(tex, target, gl, this, glTex));
    }
  }
  m79(frameBuffer, info) {
    var gl = this.v73_1;
    if (!(this.x74_1 === _AGFrameBufferInfo___get_size__impl__uw80y4(info))) {
      gl.m7b(_AGFrameBufferInfo___get_x__impl__6dzfjj(info), _AGFrameBufferInfo___get_y__impl__mfn1io(info), _AGFrameBufferInfo___get_width__impl__yhp94z(info), _AGFrameBufferInfo___get_height__impl__yfespa(info));
    }
    if (frameBuffer.y6n_1) {
      if (!(this.y74_1 === this.m74_1)) {
        this.y74_1 = this.m74_1;
        gl.n7b(36160, this.m74_1);
      }
      return Unit_instance;
    }
    var fb = _get_gl__ndc1ty_0(frameBuffer, this);
    var tex = fb.q7b_1.z6n_1;
    var doMsaa = false;
    if (!equals(fb.t7b_1, info)) {
      fb.t7b_1 = info;
      var internalFormat = _AGFrameBufferInfo___get_hasStencilAndDepth__impl__aauqdj(info) ? 34041 : _AGFrameBufferInfo___get_hasStencil__impl__hjoes3(info) ? 36168 : _AGFrameBufferInfo___get_hasDepth__impl__9knjmc(info) ? 6402 : 0;
      var texTarget = doMsaa ? 37120 : 3553;
      tex.q6o_1 = NullBitmap.a4f(_AGFrameBufferInfo___get_width__impl__yhp94z(info), _AGFrameBufferInfo___get_height__impl__yfespa(info), false);
      // Inline function 'korlibs.graphics.gl.AGOpengl.selectTextureUnitTemp' call
      var index = this.v74_1;
      var old = selectTextureUnit(this, index);
      try {
        // Inline function 'korlibs.graphics.gl.AGOpengl.bindFrameBuffer.<anonymous>' call
        this.z7a(tex, Companion_getInstance_51().x6o_1);
        textureUnitParameters(this, Companion_getInstance_51().x6o_1, Companion_getInstance_52().w6p_1, 9729, 9729, 2);
      }finally {
        if (true) {
          this.z7a(null, Companion_getInstance_51().x6o_1);
        }
        selectTextureUnit(this, old);
      }
      gl.u7b(36161, fb.r7b_1);
      if (!(internalFormat === 0)) {
        gl.v7b(36161, internalFormat, _AGFrameBufferInfo___get_width__impl__yhp94z(info), _AGFrameBufferInfo___get_height__impl__yfespa(info));
      }
      gl.u7b(36161, 0);
      gl.n7b(36160, fb.s7b_1);
      gl.w7b(36160, 36064, 3553, _get_gl__ndc1ty_1(fb.q7b_1.z6n_1, this).b79_1, 0);
      if (!(internalFormat === 0)) {
        gl.x7b(36160, _AGFrameBufferInfo___get_hasStencilAndDepth__impl__aauqdj(info) ? 33306 : _AGFrameBufferInfo___get_hasStencil__impl__hjoes3(info) ? 36128 : _AGFrameBufferInfo___get_hasDepth__impl__9knjmc(info) ? 36096 : 0, 36161, fb.r7b_1);
      } else {
        gl.x7b(36160, 36128, 36161, 0);
        gl.x7b(36160, 36096, 36161, 0);
      }
    }
    if (!(this.y74_1 === fb.s7b_1)) {
      this.y74_1 = fb.s7b_1;
      gl.n7b(36160, fb.s7b_1);
    }
  }
  b7a(renderState) {
    var gl = this.v73_1;
    if (!(this.i74_1 === renderState)) {
      this.i74_1 = renderState;
      gl.y7b(toGl_10(_AGDepthAndFrontFace___get_frontFace__impl__w07k4s(renderState)));
      gl.q79(_AGDepthAndFrontFace___get_depthMask__impl__ouijn(renderState));
      gl.z7b(_AGDepthAndFrontFace___get_depthNear__impl__cir3a1(renderState), _AGDepthAndFrontFace___get_depthFar__impl__g0cno8(renderState));
      // Inline function 'korlibs.kgl.KmlGl.enableDisable' call
      var enable = !(_AGDepthAndFrontFace___get_depthFunc__impl__8fo7zp(renderState) === Companion_getInstance_57().z6u_1);
      if (gl.a7a(2929, enable)) {
        // Inline function 'korlibs.graphics.gl.AGOpengl.setDepthAndFrontFace.<anonymous>' call
        gl.a7c(toGl_1(_AGDepthAndFrontFace___get_depthFunc__impl__8fo7zp(renderState)));
      }
    }
  }
  o79(colorMask) {
    var gl = this.v73_1;
    if (!(this.h74_1 === colorMask)) {
      this.h74_1 = colorMask;
      gl.b7c(_AGColorMask___get_red__impl__opo1fo(colorMask), _AGColorMask___get_green__impl__d3m1w2(colorMask), _AGColorMask___get_blue__impl__42l0s1(colorMask), _AGColorMask___get_alpha__impl__xmrqzb(colorMask));
    }
  }
  n79(scissor, frameBuffer, frameBufferInfo) {
    var gl = this.v73_1;
    var scissor_0 = this.k7b(scissor, frameBuffer, frameBufferInfo);
    if (!this.n74_1.equals(scissor_0)) {
      this.n74_1 = scissor_0;
      // Inline function 'korlibs.kgl.KmlGl.enableDisable' call
      var enable = !scissor_0.equals(Companion_getInstance_44().t6k_1);
      if (gl.a7a(3089, enable)) {
        // Inline function 'korlibs.graphics.gl.AGOpengl.setScissorState.<anonymous>' call
        gl.c7c(scissor_0.a6e(), scissor_0.b6e(), scissor_0.z2i(), scissor_0.a2j());
      }
    }
  }
}
class GLGlobalState {
  constructor(gl, ag) {
    this.x76_1 = gl;
    this.y76_1 = ag;
    this.z76_1 = atomic$int$1(0);
    this.a77_1 = atomic$int$1(0);
    this.b77_1 = atomic$ref$1(0.0);
    this.c77_1 = atomic$int$1(0);
    this.d77_1 = atomic$int$1(0);
    this.e77_1 = atomic$ref$1(0.0);
    this.f77_1 = new Lock();
    this.g77_1 = fastArrayListOf([]);
  }
}
class GLBaseObject {
  constructor(globalState) {
    this.h77_1 = globalState;
    this.i77_1 = this.h77_1.x76_1;
  }
  j77() {
  }
  u6p() {
    // Inline function 'korlibs.concurrent.lock.Lock.invoke' call
    var this_0 = this.h77_1.f77_1;
    $l$block: {
      // Inline function 'korlibs.concurrent.lock.LockImpl.lockUnlock' call
      this_0.n1v();
      try {
        this.h77_1.g77_1.h(this);
        break $l$block;
      }finally {
        this_0.p1v();
      }
    }
  }
}
class GLBaseProgram extends GLBaseObject {
  constructor(globalState, programInfo) {
    super(globalState);
    this.l75_1 = programInfo;
  }
  j77() {
    this.l75_1.d7c(this.i77_1);
  }
  m75() {
    this.l75_1.e7c(this.i77_1);
  }
}
class GLBuffer extends GLBaseObject {
  constructor(state) {
    super(state);
    this.n77_1 = genBuffer(this.i77_1);
    this.o77_1 = -1;
    this.p77_1 = 0.0;
    this.h77_1.c77_1.atomicfu$incrementAndGet();
  }
  s78(value) {
    $l$block: {
      // Inline function 'kotlinx.atomicfu.updateAndGet' call
      var this_0 = this.h77_1.e77_1;
      while (true) {
        var cur = this_0.kotlinx$atomicfu$value;
        // Inline function 'korlibs.graphics.gl.GLBuffer.<set-estimatedBytes>.<anonymous>' call
        var upd = cur + value - this.p77_1;
        if (this_0.atomicfu$compareAndSet(cur, upd)) {
          break $l$block;
        }
      }
    }
    this.p77_1 = value;
  }
  j77() {
    this.h77_1.d77_1.atomicfu$incrementAndGet();
    deleteBuffer(this.i77_1, this.n77_1);
    this.n77_1 = -1;
    this.o77_1 = -1;
  }
  toString() {
    return 'GLBuffer(' + this.n77_1 + ')';
  }
}
class GLTexture extends GLBaseObject {
  constructor(state) {
    super(state);
    this.b79_1 = genTexture(this.i77_1);
    this.c79_1 = -2;
    this.d79_1 = -2;
    this.e79_1 = 0.0;
    this.h77_1.z76_1.atomicfu$incrementAndGet();
  }
  s78(value) {
    $l$block: {
      // Inline function 'kotlinx.atomicfu.updateAndGet' call
      var this_0 = this.h77_1.b77_1;
      while (true) {
        var cur = this_0.kotlinx$atomicfu$value;
        // Inline function 'korlibs.graphics.gl.GLTexture.<set-estimatedBytes>.<anonymous>' call
        var upd = cur + value - this.e79_1;
        if (this_0.atomicfu$compareAndSet(cur, upd)) {
          break $l$block;
        }
      }
    }
    this.e79_1 = value;
  }
  j77() {
    this.h77_1.a77_1.atomicfu$incrementAndGet();
    deleteTexture(this.i77_1, this.b79_1);
    this.b79_1 = -1;
  }
}
class GLFrameBuffer extends GLBaseObject {
  constructor(state, ag) {
    super(state);
    this.q7b_1 = ag;
    this.r7b_1 = genRenderbuffer(this.i77_1);
    this.s7b_1 = genFramebuffer(this.i77_1);
    this.t7b_1 = Companion_getInstance_45().m6u_1;
  }
  j77() {
    deleteRenderbuffer(this.i77_1, this.r7b_1);
    deleteFramebuffer(this.i77_1, this.s7b_1);
    this.r7b_1 = -1;
    this.s7b_1 = -1;
  }
}
class GLProgramInfo {
  constructor(programId, vertexId, fragmentId, blocks, config) {
    this.n75_1 = programId;
    this.o75_1 = vertexId;
    this.p75_1 = fragmentId;
    this.q75_1 = blocks;
    this.r75_1 = config;
    var tmp = this;
    // Inline function 'kotlin.collections.associateBy' call
    var this_0 = this.q75_1;
    var capacity = coerceAtLeast(mapCapacity(collectionSizeOrDefault(this_0, 10)), 16);
    // Inline function 'kotlin.collections.associateByTo' call
    var destination = LinkedHashMap.hc(capacity);
    var tmp0_iterator = this_0.a1();
    while (tmp0_iterator.b1()) {
      var element = tmp0_iterator.c1();
      // Inline function 'korlibs.graphics.gl.GLProgramInfo.blocksByFixedLocation.<anonymous>' call
      var tmp$ret$0 = element.x6r_1;
      destination.i3(tmp$ret$0, element);
    }
    tmp.s75_1 = destination;
    var tmp_0 = this;
    var tmp$ret$3;
    $l$block: {
      // Inline function 'kotlin.collections.maxOfOrNull' call
      var iterator = this.q75_1.a1();
      if (!iterator.b1()) {
        tmp$ret$3 = null;
        break $l$block;
      }
      // Inline function 'korlibs.graphics.gl.GLProgramInfo.maxBlockId.<anonymous>' call
      var maxValue = iterator.c1().x6r_1;
      while (iterator.b1()) {
        // Inline function 'korlibs.graphics.gl.GLProgramInfo.maxBlockId.<anonymous>' call
        var v = iterator.c1().x6r_1;
        if (compareTo(maxValue, v) < 0) {
          maxValue = v;
        }
      }
      tmp$ret$3 = maxValue;
    }
    var tmp0_elvis_lhs = tmp$ret$3;
    tmp_0.t75_1 = (tmp0_elvis_lhs == null ? -1 : tmp0_elvis_lhs) + 1 | 0;
    var tmp_1 = this;
    var tmp_2 = 0;
    var tmp_3 = this.t75_1 + 1 | 0;
    // Inline function 'kotlin.arrayOfNulls' call
    var tmp_4 = fillArrayVal(Array(tmp_3), null);
    while (tmp_2 < tmp_3) {
      var tmp_5 = tmp_2;
      var tmp0_safe_receiver = this.s75_1.f3(tmp_5);
      var tmp_6;
      if (tmp0_safe_receiver == null) {
        tmp_6 = null;
      } else {
        // Inline function 'kotlin.let' call
        // Inline function 'kotlin.contracts.contract' call
        // Inline function 'korlibs.graphics.gl.GLProgramInfo.uniforms.<anonymous>' call
        tmp_6 = UniformsRef.f7c(tmp0_safe_receiver);
      }
      tmp_4[tmp_5] = tmp_6;
      tmp_2 = tmp_2 + 1 | 0;
    }
    tmp_1.u75_1 = tmp_4;
    this.v75_1 = FastStringMap();
    this.w75_1 = FastStringMap();
  }
  i76(gl, name) {
    var tmp$ret$2;
    $l$block: {
      // Inline function 'korlibs.datastructure.getOrPut' call
      var this_0 = this.w75_1;
      // Inline function 'korlibs.datastructure.get' call
      // Inline function 'kotlin.js.asDynamic' call
      var res = this_0.get(name);
      if (!(res == null)) {
        tmp$ret$2 = res;
        break $l$block;
      }
      // Inline function 'korlibs.graphics.gl.GLProgramInfo.getUniformLocation.<anonymous>' call
      var out = gl.g7c(this.n75_1, name);
      // Inline function 'korlibs.datastructure.set' call
      // Inline function 'kotlin.run' call
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'kotlin.js.asDynamic' call
      this_0.set(name, out);
      tmp$ret$2 = out;
    }
    return tmp$ret$2;
  }
  e7c(gl) {
    gl.h7c(this.n75_1);
  }
  d7c(gl) {
    if (!(this.o75_1 === 0)) {
      gl.i7c(this.o75_1);
    }
    if (!(this.p75_1 === 0)) {
      gl.i7c(this.p75_1);
    }
    if (!(this.n75_1 === 0)) {
      gl.j7c(this.n75_1);
    }
    this.o75_1 = 0;
    this.p75_1 = 0;
    this.n75_1 = 0;
  }
  toString() {
    return 'GLProgramInfo(programId=' + this.n75_1 + ', vertexId=' + this.o75_1 + ', fragmentId=' + this.p75_1 + ', blocks=' + toString(this.q75_1) + ', config=' + this.r75_1.toString() + ')';
  }
  hashCode() {
    var result = this.n75_1;
    result = imul(result, 31) + this.o75_1 | 0;
    result = imul(result, 31) + this.p75_1 | 0;
    result = imul(result, 31) + hashCode(this.q75_1) | 0;
    result = imul(result, 31) + this.r75_1.hashCode() | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof GLProgramInfo))
      return false;
    var tmp0_other_with_cast = other instanceof GLProgramInfo ? other : THROW_CCE();
    if (!(this.n75_1 === tmp0_other_with_cast.n75_1))
      return false;
    if (!(this.o75_1 === tmp0_other_with_cast.o75_1))
      return false;
    if (!(this.p75_1 === tmp0_other_with_cast.p75_1))
      return false;
    if (!equals(this.q75_1, tmp0_other_with_cast.q75_1))
      return false;
    if (!this.r75_1.equals(tmp0_other_with_cast.r75_1))
      return false;
    return true;
  }
}
class GLShaderCompiler {
  constructor() {
    GLShaderCompiler_instance = this;
    this.h75_1 = Companion_getInstance_1().qw('GLShaderCompiler');
  }
  i75(gl, config, program, debugName) {
    var id = gl.o7c();
    var guessedGlSlVersion = get_versionInt(gl);
    var tmp0_elvis_lhs = Companion_getInstance_62().q7c();
    var usedGlSlVersion = tmp0_elvis_lhs == null ? guessedGlSlVersion : tmp0_elvis_lhs;
    if (Companion_getInstance_62().r7c()) {
      // Inline function 'korlibs.logger.Logger.trace' call
      var this_0 = this.h75_1;
      var level = Level_TRACE_getInstance();
      var tmp;
      if (this_0.a2u(level)) {
        // Inline function 'korlibs.graphics.gl.GLShaderCompiler.programCreate.<anonymous>' call
        var tmp$ret$0 = 'GLSL version: usedGlSlVersion=' + usedGlSlVersion + ', guessed=' + guessedGlSlVersion + ', forced=' + Companion_getInstance_62().q7c() + '. used=' + usedGlSlVersion;
        this_0.b2u(level, tmp$ret$0);
        tmp = Unit_instance;
      }
    }
    // Inline function 'kotlin.collections.map' call
    var this_1 = listOf_0([false, true]);
    // Inline function 'kotlin.collections.mapTo' call
    var destination = ArrayList.w(collectionSizeOrDefault(this_1, 10));
    var tmp0_iterator = this_1.a1();
    while (tmp0_iterator.b1()) {
      var item = tmp0_iterator.c1();
      // Inline function 'korlibs.graphics.gl.GLShaderCompiler.programCreate.<anonymous>' call
      var tmp$ret$2 = config.s7c(VOID, VOID, usedGlSlVersion, item);
      destination.h(tmp$ret$2);
    }
    var _destruct__k2r9zo = this.t7c(gl, program, debugName, destination);
    var fragmentShaderId = _destruct__k2r9zo.jl();
    var vertexShaderId = _destruct__k2r9zo.kl();
    var finalConfig = _destruct__k2r9zo.tr();
    var _iterator__ex2g4s = program.f6r_1.a1();
    while (_iterator__ex2g4s.b1()) {
      var attr = _iterator__ex2g4s.c1();
      var location = attr.g6z_1;
      gl.u7c(id, location, attr.d76_1);
    }
    gl.v7c(id, fragmentShaderId);
    gl.v7c(id, vertexShaderId);
    gl.w7c(id);
    // Inline function 'korlibs.kgl.KmlGl.LINK_STATUS' call
    var linkStatus = getProgramiv(gl, id, 35714);
    return new GLProgramInfo(id, vertexShaderId, fragmentShaderId, program.c6r_1, finalConfig);
  }
  t7c(gl, program, debugName, configs) {
    // Inline function 'kotlin.collections.arrayListOf' call
    var errors = ArrayList.h1();
    var _iterator__ex2g4s = configs.a1();
    $l$loop: while (_iterator__ex2g4s.b1()) {
      var config = _iterator__ex2g4s.c1();
      try {
        var fragmentString = toNewGlslString(program.y6q_1, config);
        var vertexString = toNewGlslString(program.x6q_1, config);
        var fragmentShaderId = createShader(this, gl, 35632, fragmentString, debugName);
        var vertexShaderId = createShader(this, gl, 35633, vertexString, debugName);
        // Inline function 'korlibs.logger.Logger.debug' call
        var this_0 = this.h75_1;
        var level = Level_DEBUG_getInstance();
        var tmp;
        if (this_0.a2u(level)) {
          // Inline function 'korlibs.graphics.gl.GLShaderCompiler.createShaderWithConfigs.<anonymous>' call
          var tmp$ret$1 = '!!! PROGRAM SUCCESSFULLY COMPILED: config=' + config.toString() + '\n' + vertexString + '\n' + fragmentString;
          this_0.b2u(level, tmp$ret$1);
          tmp = Unit_instance;
        }
        return new Triple(fragmentShaderId, vertexShaderId, config);
      } catch ($p) {
        if ($p instanceof ShaderException) {
          var e = $p;
          // Inline function 'korlibs.logger.Logger.debug' call
          var this_1 = this.h75_1;
          var level_0 = Level_DEBUG_getInstance();
          var tmp_0;
          if (this_1.a2u(level_0)) {
            // Inline function 'korlibs.graphics.gl.GLShaderCompiler.createShaderWithConfigs.<anonymous>' call
            var tmp$ret$3 = stackTraceToString(e);
            this_1.b2u(level_0, tmp$ret$3);
            tmp_0 = Unit_instance;
          }
          // Inline function 'kotlin.collections.plusAssign' call
          errors.h(e);
          continue $l$loop;
        } else {
          throw $p;
        }
      }
    }
    // Inline function 'kotlin.collections.map' call
    // Inline function 'kotlin.collections.mapTo' call
    var destination = ArrayList.w(collectionSizeOrDefault(errors, 10));
    var tmp0_iterator = errors.a1();
    while (tmp0_iterator.b1()) {
      var item = tmp0_iterator.c1();
      // Inline function 'korlibs.graphics.gl.GLShaderCompiler.createShaderWithConfigs.<anonymous>' call
      var tmp$ret$5 = item.message;
      destination.h(tmp$ret$5);
    }
    throw Exception.yd('Tried several shaders: ' + toString(destination), last(errors));
  }
}
class AGDummy extends AG {
  static b7d(size) {
    size = size === VOID ? Size2D.t26(640, 480) : size;
    var $this = this.s6i();
    $this.h6j().d6o(numberToInt(size.r26_1), numberToInt(size.s26_1));
    return $this;
  }
}
class AGBaseLog extends AGDummy {
  static v7d(size) {
    size = size === VOID ? Size2D.t26(640, 480) : size;
    var $this = this.b7d(size);
    $this.q7d_1 = 0;
    $this.r7d_1 = 0;
    $this.s7d_1 = 0;
    $this.t7d_1 = 0;
    $this.u7d_1 = linkedHashMapOf([]);
    return $this;
  }
  w7d(str, kind) {
  }
  k6j(command) {
    this.w7d(toString(command), Kind_COMMAND_getInstance());
  }
  j6j() {
    return this.w7d('finish()', Kind_FLIP_getInstance());
  }
}
class AGPrint extends AGBaseLog {
  static l7d(size) {
    size = size === VOID ? Size2D.t26(640, 480) : size;
    return this.v7d(size);
  }
  w7d(str, kind) {
    println('PrintAG: ' + str);
  }
}
class Kind_0 extends Enum {}
class Companion_43 {
  constructor() {
    Companion_instance_52 = this;
    var tmp = this;
    // Inline function 'kotlin.emptyArray' call
    var tmp_0 = [];
    // Inline function 'kotlin.emptyArray' call
    var tmp$ret$1 = [];
    tmp.b6k_1 = new UniformBlocksBuffersRef(tmp_0, tmp$ret$1, new Int32Array(0));
  }
}
class UniformBlocksBuffersRef {
  constructor(blocks, buffers, valueIndices) {
    Companion_getInstance_59();
    this.c7b_1 = blocks;
    this.d7b_1 = buffers;
    this.e7b_1 = valueIndices;
  }
  e1() {
    return this.c7b_1.length;
  }
}
class Gen {
  constructor(block, name, voffset, vindex, type, arrayCount, size, align) {
    arrayCount = arrayCount === VOID ? 1 : arrayCount;
    this.q6x_1 = block;
    this.r6x_1 = name;
    this.s6x_1 = voffset;
    this.t6x_1 = vindex;
    this.u6x_1 = type;
    this.v6x_1 = arrayCount;
    this.w6x_1 = size;
    this.x6x_1 = align;
    var tmp = this;
    tmp.y6x_1 = lazy(UniformBlock$Gen$uniform$delegate$lambda(this));
  }
  y7d() {
    // Inline function 'kotlin.getValue' call
    var this_0 = this.y6x_1;
    uniform$factory();
    return this_0.u1();
  }
  z6x(block, property) {
    var tmp = this;
    var tmp0_elvis_lhs = this.r6x_1;
    tmp.r6x_1 = tmp0_elvis_lhs == null ? property.callableName : tmp0_elvis_lhs;
    return this.y7d();
  }
  toString() {
    return 'Gen(block=' + this.q6x_1.toString() + ', name=' + this.r6x_1 + ', voffset=' + this.s6x_1 + ', vindex=' + this.t6x_1 + ', type=' + this.u6x_1.toString() + ', arrayCount=' + this.v6x_1 + ', size=' + this.w6x_1 + ', align=' + this.x6x_1 + ')';
  }
  hashCode() {
    var result = hashCode(this.q6x_1);
    result = imul(result, 31) + (this.r6x_1 == null ? 0 : getStringHashCode(this.r6x_1)) | 0;
    result = imul(result, 31) + this.s6x_1 | 0;
    result = imul(result, 31) + this.t6x_1 | 0;
    result = imul(result, 31) + this.u6x_1.hashCode() | 0;
    result = imul(result, 31) + this.v6x_1 | 0;
    result = imul(result, 31) + this.w6x_1 | 0;
    result = imul(result, 31) + this.x6x_1 | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof Gen))
      return false;
    var tmp0_other_with_cast = other instanceof Gen ? other : THROW_CCE();
    if (!equals(this.q6x_1, tmp0_other_with_cast.q6x_1))
      return false;
    if (!(this.r6x_1 == tmp0_other_with_cast.r6x_1))
      return false;
    if (!(this.s6x_1 === tmp0_other_with_cast.s6x_1))
      return false;
    if (!(this.t6x_1 === tmp0_other_with_cast.t6x_1))
      return false;
    if (!this.u6x_1.equals(tmp0_other_with_cast.u6x_1))
      return false;
    if (!(this.v6x_1 === tmp0_other_with_cast.v6x_1))
      return false;
    if (!(this.w6x_1 === tmp0_other_with_cast.w6x_1))
      return false;
    if (!(this.x6x_1 === tmp0_other_with_cast.x6x_1))
      return false;
    return true;
  }
}
class Operand {
  static l7n(type) {
    var $this = createThis(this);
    $this.r77_1 = type;
    return $this;
  }
  w29() {
    return this.r77_1;
  }
}
class OperandWithArray extends Operand {
  static j7p(type, arrayCount) {
    var $this = this.l7n(type);
    $this.t77_1 = arrayCount;
    $this.u77_1 = type.a78_1;
    $this.v77_1 = type.b78_1;
    $this.w77_1 = imul($this.v77_1, $this.t77_1);
    $this.x77_1 = imul(type.d78_1, $this.t77_1);
    return $this;
  }
}
class Variable extends OperandWithArray {
  static k7o(name, type, arrayCount, precision) {
    precision = precision === VOID ? Precision_DEFAULT_getInstance() : precision;
    var $this = this.j7p(type, arrayCount);
    $this.d76_1 = name;
    $this.e76_1 = precision;
    var tmp = $this;
    var tmp_0 = 0;
    // Inline function 'kotlin.arrayOfNulls' call
    var tmp_1 = fillArrayVal(Array(arrayCount), null);
    while (tmp_0 < arrayCount) {
      var tmp_2 = tmp_0;
      tmp_1[tmp_2] = $this.d76_1 + '[' + tmp_2 + ']';
      tmp_0 = tmp_0 + 1 | 0;
    }
    tmp.f76_1 = tmp_1;
    $this.g76_1 = 0;
    $this.h76_1 = null;
    return $this;
  }
  static b7p(name, type, precision) {
    precision = precision === VOID ? Precision_DEFAULT_getInstance() : precision;
    return this.k7o(name, type, 1, precision);
  }
  equals(other) {
    // Inline function 'korlibs.graphics.shader.Variable.mequals' call
    var tmp;
    var tmp_0;
    var tmp_1;
    var tmp_2;
    if (other instanceof Variable) {
      tmp_2 = this.g76_1 === other.g76_1;
    } else {
      tmp_2 = false;
    }
    if (tmp_2) {
      tmp_1 = this.w29().equals(other.w29());
    } else {
      tmp_1 = false;
    }
    if (tmp_1) {
      tmp_0 = this.t77_1 === other.t77_1;
    } else {
      tmp_0 = false;
    }
    if (tmp_0) {
      tmp = this.d76_1 === other.d76_1;
    } else {
      tmp = false;
    }
    return tmp;
  }
  hashCode() {
    // Inline function 'korlibs.graphics.shader.Variable.mhashcode' call
    return (this.g76_1 + imul(this.w29().hashCode(), 7) | 0) + imul(getStringHashCode(this.d76_1), 11) | 0;
  }
}
class VariableWithOffset extends Variable {
  static p7e(name, type, arrayCount, precision, offset) {
    precision = precision === VOID ? Precision_DEFAULT_getInstance() : precision;
    offset = offset === VOID ? null : offset;
    var $this = this.k7o(name, type, arrayCount, precision);
    $this.o7e_1 = offset;
    return $this;
  }
}
class TypedUniform extends VariableWithOffset {
  static x7d(name, voffset, vindex, block, type, arrayCount) {
    var $this = this.p7e(name, type, arrayCount, Precision_DEFAULT_getInstance());
    $this.t6r_1 = voffset;
    $this.u6r_1 = vindex;
    $this.v6r_1 = block;
    $this.w6r_1 = Uniform.d7f(name, type, arrayCount, VOID, VOID, $this);
    return $this;
  }
  no(thisRef, property) {
    return this;
  }
  toString() {
    return "TypedUniform(name='" + this.d76_1 + "', offset=" + this.t6r_1 + ', type=' + this.w29().toString() + ')';
  }
}
class Companion_44 {}
class UniformBlockBuffer {
  constructor(block) {
    this.d6q_1 = block;
    this.e6q_1 = new AGBuffer();
    this.f6q_1 = this.d6q_1.d6y();
    this.g6q_1 = this.d6q_1.e6y();
    this.h6q_1 = this.d6q_1.c6y().e1();
    this.i6q_1 = Buffer.m12(imul(this.g6q_1, 1));
    this.j6q_1 = UniformsRef.e7f(this.d6q_1, this.i6q_1, -1);
    this.k6q_1 = Buffer.m12(this.d6q_1.e6y());
  }
  toString() {
    return 'UniformBlockBuffer(' + toString(this.d6q_1) + ')';
  }
  f7f(value) {
    this.j6q_1.i7b_1 = value;
  }
  c6s() {
    return this.j6q_1.i7b_1;
  }
  g7f(index) {
    if (index >= (_get_bufferSize__mp12kq(this) - 1 | 0)) {
      // Inline function 'kotlin.math.max' call
      var a = index + 1 | 0;
      var b = imul(index + 2 | 0, 3);
      var newCapacity = Math.max(a, b);
      this.i6q_1 = copyOf(this.i6q_1, imul(this.g6q_1, newCapacity));
      this.j6q_1.h7b_1 = this.i6q_1;
    }
  }
  t2q() {
    this.f7f(-1);
  }
  m6q() {
    var tmp = this.i6q_1;
    // Inline function 'kotlin.math.max' call
    var b = imul(this.c6s() + 1 | 0, this.d6q_1.e6y());
    var tmp$ret$0 = Math.max(0, b);
    this.e6q_1.p6m(tmp, 0, tmp$ret$0);
    return this;
  }
  h7f() {
    var _unary__edvuaz = this.c6s();
    this.f7f(_unary__edvuaz - 1 | 0);
  }
}
class UBLayoutBuilder {
  constructor() {
    this.z7d_1 = 0;
    this.a7e_1 = 4;
    var tmp = this;
    tmp.b7e_1 = lazy(UBLayoutBuilder$size$delegate$lambda(this));
  }
  e1() {
    // Inline function 'kotlin.getValue' call
    var this_0 = this.b7e_1;
    size$factory();
    return this_0.u1();
  }
  c7e(size, align_0) {
    // Inline function 'kotlin.also' call
    var this_0 = align(this, align_0).z7d_1;
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.graphics.shader.UBLayoutBuilder.rawAlloc.<anonymous>' call
    this.z7d_1 = this.z7d_1 + size | 0;
    return this_0;
  }
}
class UniformsRef {
  static e7f(block, buffer, index) {
    var $this = createThis(this);
    $this.g7b_1 = block;
    $this.h7b_1 = buffer;
    $this.i7b_1 = index;
    $this.j7b_1 = $this.g7b_1.e6y();
    return $this;
  }
  static f7c(block, size, index) {
    size = size === VOID ? 1 : size;
    index = index === VOID ? 0 : index;
    return this.e7f(block, Buffer.m12(imul(block.e6y(), size)), index);
  }
  i7f(uniform) {
    return imul(this.i7b_1, this.j7b_1) + uniform.t6r_1 | 0;
  }
  j7f(ref) {
    arraycopy_0(ref.i6q_1, 0, this.h7b_1, imul(this.i7b_1, this.j7b_1), this.j7b_1);
  }
  k7f(uniform, value) {
    return this.l7f(uniform, value);
  }
  m7f(uniform, value) {
    return this.n7f(uniform, value.q2e_1, value.r2e_1);
  }
  o7f(uniform, value) {
    return this.n7f(uniform, value.m25_1, value.n25_1);
  }
  p7f(uniform, value) {
    return this.q7f(uniform, _RGBA___get_rf__impl__kvz75k(value), _RGBA___get_gf__impl__5gcu1f(value), _RGBA___get_bf__impl__1xz5yg(value), _RGBA___get_af__impl__vu36qv(value));
  }
  r7f(uniform, value) {
    return this.q7f(uniform, _RGBAPremultiplied___get_rf__impl__pt0c4y(value), _RGBAPremultiplied___get_gf__impl__ivron7(value), _RGBAPremultiplied___get_bf__impl__qa3on2(value), _RGBAPremultiplied___get_af__impl__euwcjn(value));
  }
  s7f(uniform, value) {
    return this.q7f(uniform, _ColorAdd___get_rf__impl__4xdwim(value), _ColorAdd___get_gf__impl__v9pxpl(value), _ColorAdd___get_bf__impl__nvdxpq(value), _ColorAdd___get_af__impl__60q32p(value));
  }
  t7f(uniform, value) {
    return this.q7f(uniform, value.r2h_1, value.s2h_1, value.t2h_1, value.u2h_1);
  }
  u7f(uniform, value) {
    return this.q7f(uniform, value.b2e_1, value.a2e_1, value.c2e_1, value.z2d_1);
  }
  v7f(uniform, value) {
    switch (uniform.w29().r3_1) {
      case 3:
        this.w7f(uniform, value, Companion_getInstance_6().j2c_1);
        break;
      case 2:
        this.x7f(uniform, value, Companion_getInstance_6().j2c_1, 12);
        break;
      default:
        // Inline function 'kotlin.TODO' call

        throw NotImplementedError.td();
    }
  }
  x7f(uniform, value, indices, max) {
    // Inline function 'kotlin.also' call
    var this_0 = this.i7f(uniform);
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.graphics.shader.UniformsRef.set.<anonymous>' call
    // Inline function 'korlibs.graphics.shader.UniformsRef.bufferSetFloatNIndexed' call
    var inductionVariable = 0;
    if (inductionVariable < max)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        // Inline function 'korlibs.memory.setF32' call
        var this_1 = this.h7b_1;
        var byteOffset = this_0 + imul(n, 4) | 0;
        // Inline function 'korlibs.graphics.shader.UniformsRef.set.<anonymous>.<anonymous>' call
        var it = indices[n];
        var value_0 = value.n2d(it);
        var tmp;
        if (true) {
          this_1.q12(byteOffset, value_0);
          tmp = Unit_instance;
        } else {
          this_1.p12(byteOffset, value_0);
          tmp = Unit_instance;
        }
      }
       while (inductionVariable < max);
  }
  w7f(uniform, value, indices, max, $super) {
    max = max === VOID ? indices.length : max;
    var tmp;
    if ($super === VOID) {
      this.x7f(uniform, value, indices, max);
      tmp = Unit_instance;
    } else {
      tmp = $super.x7f.call(this, uniform, value, indices, max);
    }
    return tmp;
  }
  l7f(uniform, value) {
    // Inline function 'kotlin.also' call
    var this_0 = this.i7f(uniform);
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.graphics.shader.UniformsRef.set.<anonymous>' call
    // Inline function 'korlibs.memory.setF32' call
    var this_1 = this.h7b_1;
    var byteOffset = this_0 + 0 | 0;
    var tmp;
    if (true) {
      this_1.q12(byteOffset, value);
      tmp = Unit_instance;
    } else {
      this_1.p12(byteOffset, value);
      tmp = Unit_instance;
    }
  }
  n7f(uniform, x, y) {
    // Inline function 'kotlin.also' call
    var this_0 = this.i7f(uniform);
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.graphics.shader.UniformsRef.set.<anonymous>' call
    this.y7f(this_0, x, y);
  }
  q7f(uniform, x, y, z, w) {
    // Inline function 'kotlin.also' call
    var this_0 = this.i7f(uniform);
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.graphics.shader.UniformsRef.set.<anonymous>' call
    this.z7f(this_0, x, y, z, w);
  }
  y7f(index, x, y) {
    // Inline function 'korlibs.memory.setF32' call
    var this_0 = this.h7b_1;
    var byteOffset = index + 0 | 0;
    var tmp;
    if (true) {
      this_0.q12(byteOffset, x);
      tmp = Unit_instance;
    } else {
      this_0.p12(byteOffset, x);
      tmp = Unit_instance;
    }
    // Inline function 'korlibs.memory.setF32' call
    var this_1 = this.h7b_1;
    var byteOffset_0 = index + 4 | 0;
    var tmp_0;
    if (true) {
      this_1.q12(byteOffset_0, y);
      tmp_0 = Unit_instance;
    } else {
      this_1.p12(byteOffset_0, y);
      tmp_0 = Unit_instance;
    }
  }
  z7f(index, x, y, z, w) {
    // Inline function 'korlibs.memory.setF32' call
    var this_0 = this.h7b_1;
    var byteOffset = index + 0 | 0;
    var tmp;
    if (true) {
      this_0.q12(byteOffset, x);
      tmp = Unit_instance;
    } else {
      this_0.p12(byteOffset, x);
      tmp = Unit_instance;
    }
    // Inline function 'korlibs.memory.setF32' call
    var this_1 = this.h7b_1;
    var byteOffset_0 = index + 4 | 0;
    var tmp_0;
    if (true) {
      this_1.q12(byteOffset_0, y);
      tmp_0 = Unit_instance;
    } else {
      this_1.p12(byteOffset_0, y);
      tmp_0 = Unit_instance;
    }
    // Inline function 'korlibs.memory.setF32' call
    var this_2 = this.h7b_1;
    var byteOffset_1 = index + 8 | 0;
    var tmp_1;
    if (true) {
      this_2.q12(byteOffset_1, z);
      tmp_1 = Unit_instance;
    } else {
      this_2.p12(byteOffset_1, z);
      tmp_1 = Unit_instance;
    }
    // Inline function 'korlibs.memory.setF32' call
    var this_3 = this.h7b_1;
    var byteOffset_2 = index + 12 | 0;
    var tmp_2;
    if (true) {
      this_3.q12(byteOffset_2, w);
      tmp_2 = Unit_instance;
    } else {
      this_3.p12(byteOffset_2, w);
      tmp_2 = Unit_instance;
    }
  }
}
class Companion_45 {
  a7g(isES, isWebGL, isCore, version, os) {
    return _GLVariant___init__impl__cjzpjb(insert8(insert8(insert(insert(insert(0, isES, 0), isWebGL, 1), isCore, 2), version, 8), os.r3_1, 16));
  }
  b7g(isES, isWebGL, isCore, version, os, $super) {
    isES = isES === VOID ? false : isES;
    isWebGL = isWebGL === VOID ? false : isWebGL;
    isCore = isCore === VOID ? false : isCore;
    version = version === VOID ? 0 : version;
    os = os === VOID ? Os_UNKNOWN_getInstance() : os;
    return $super === VOID ? this.a7g(isES, isWebGL, isCore, version, os) : $super.a7g.call(this, isES, isWebGL, isCore, version, os).c7g_1;
  }
  d7g() {
    return Companion_instance_54.b7g(false, VOID, VOID, 1, Os_UNKNOWN_getInstance());
  }
  e7g(version) {
    return Companion_instance_54.b7g(true, true, VOID, version);
  }
}
class GLVariant {
  constructor(data) {
    this.c7g_1 = data;
  }
  toString() {
    return GLVariant__toString_impl_o5yi3l(this.c7g_1);
  }
  hashCode() {
    return GLVariant__hashCode_impl_2eslaq(this.c7g_1);
  }
  equals(other) {
    return GLVariant__equals_impl_kmlw2(this.c7g_1, other);
  }
}
class Visitor {
  constructor(default_0, $box) {
    boxApply(this, $box);
    this.x7h_1 = default_0;
  }
  y7h(func) {
    this.z7h(func.q7j_1);
  }
  j7n(stms) {
    var _iterator__ex2g4s = stms.a1();
    while (_iterator__ex2g4s.b1()) {
      var stm = _iterator__ex2g4s.c1();
      this.z7h(stm);
    }
  }
  z7h(stm) {
    var tmp;
    if (stm == null) {
      tmp = Unit_instance;
    } else {
      if (stm instanceof Stms) {
        this.a7i(stm);
        tmp = Unit_instance;
      } else {
        if (stm instanceof Set) {
          this.d7i(stm);
          tmp = Unit_instance;
        } else {
          if (stm instanceof If) {
            this.b7i(stm);
            tmp = Unit_instance;
          } else {
            if (stm instanceof ForSimple) {
              this.c7i(stm);
              tmp = Unit_instance;
            } else {
              if (stm instanceof Discard) {
                this.e7i(stm);
                tmp = Unit_instance;
              } else {
                if (stm instanceof Continue) {
                  this.g7i(stm);
                  tmp = Unit_instance;
                } else {
                  if (stm instanceof Break) {
                    this.f7i(stm);
                    tmp = Unit_instance;
                  } else {
                    if (stm instanceof Raw) {
                      this.h7i(stm);
                      tmp = Unit_instance;
                    } else {
                      if (stm instanceof Return) {
                        this.i7i(stm);
                        tmp = Unit_instance;
                      } else {
                        noWhenBranchMatchedException();
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
    return tmp;
  }
  a7i(stms) {
    var _iterator__ex2g4s = stms.e7k_1.a1();
    while (_iterator__ex2g4s.b1()) {
      var stm = _iterator__ex2g4s.c1();
      this.z7h(stm);
    }
  }
  b7i(stm) {
    this.j7i(stm.y7k_1);
    this.z7h(stm.z7k_1);
    this.z7h(stm.a7l_1);
  }
  c7i(stm) {
    this.m7i(stm.b7l_1);
    this.j7i(stm.c7l_1);
    this.z7h(stm.e7l_1);
  }
  d7i(stm) {
    this.j7i(stm.g7k_1);
    this.j7i(stm.f7k_1);
  }
  e7i(stm) {
  }
  f7i(stm) {
  }
  g7i(stm) {
  }
  h7i(stm) {
    this.z7h(stm.a7k_1);
  }
  i7i(stm) {
    var tmp0_safe_receiver = stm.h7k_1;
    if (tmp0_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'korlibs.graphics.shader.Visitor.visit.<anonymous>' call
      this.j7i(tmp0_safe_receiver);
    }
  }
  j7i(operand) {
    var tmp;
    if (operand instanceof Variable) {
      tmp = this.m7i(operand);
    } else {
      if (operand instanceof Unop) {
        tmp = this.q7i(operand);
      } else {
        if (operand instanceof Binop) {
          tmp = this.r7i(operand);
        } else {
          if (operand instanceof Ternary) {
            tmp = this.s7i(operand);
          } else {
            if (operand instanceof BoolLiteral) {
              tmp = this.y7i(operand);
            } else {
              if (operand instanceof IntLiteral) {
                tmp = this.w7i(operand);
              } else {
                if (operand instanceof FloatLiteral) {
                  tmp = this.x7i(operand);
                } else {
                  if (operand instanceof Vector) {
                    tmp = this.v7i(operand);
                  } else {
                    if (operand instanceof Swizzle) {
                      tmp = this.t7i(operand);
                    } else {
                      if (operand instanceof ArrayAccess) {
                        tmp = this.u7i(operand);
                      } else {
                        if (operand instanceof BaseFunc) {
                          tmp = this.k7i(operand);
                        } else {
                          invalidOp("Don't know how to visit operand " + toString(operand));
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
    return tmp;
  }
  k7i(func) {
    var _iterator__ex2g4s = func.t7k().a1();
    while (_iterator__ex2g4s.b1()) {
      var op = _iterator__ex2g4s.c1();
      this.j7i(op);
    }
    var tmp;
    if (func instanceof Func) {
      tmp = this.l7i(func);
    } else {
      if (func instanceof CustomFunc) {
        tmp = this.w7h(func);
      } else {
        invalidOp("Don't know how to visit func " + toString(func));
      }
    }
    return tmp;
  }
  l7i(func) {
    return this.x7h_1;
  }
  w7h(func) {
    return this.x7h_1;
  }
  m7i(operand) {
    var tmp;
    if (operand instanceof Attribute) {
      tmp = this.i7h(operand);
    } else {
      if (operand instanceof Varying) {
        tmp = this.k7h(operand);
      } else {
        if (operand instanceof Sampler) {
          tmp = this.q7h(operand);
        } else {
          if (operand instanceof Uniform) {
            tmp = this.m7h(operand);
          } else {
            if (operand instanceof TypedUniform) {
              tmp = this.o7h(operand);
            } else {
              if (operand instanceof Output) {
                tmp = this.p7i(operand);
              } else {
                if (operand instanceof Temp) {
                  tmp = this.n7i(operand);
                } else {
                  if (operand instanceof Arg) {
                    tmp = this.o7i(operand);
                  } else {
                    noWhenBranchMatchedException();
                  }
                }
              }
            }
          }
        }
      }
    }
    return tmp;
  }
  n7i(temp) {
    return this.x7h_1;
  }
  o7i(arg) {
    return this.x7h_1;
  }
  i7h(attribute) {
    return this.x7h_1;
  }
  k7h(varying) {
    return this.x7h_1;
  }
  m7h(uniform) {
    return this.x7h_1;
  }
  q7h(sampler) {
    return this.x7h_1;
  }
  o7h(typedUniform) {
    return this.m7h(typedUniform.w6r_1);
  }
  p7i(output) {
    return this.x7h_1;
  }
  q7i(operand) {
    this.j7i(operand.n7k_1);
    return this.x7h_1;
  }
  r7i(operand) {
    this.j7i(operand.p7k_1);
    this.j7i(operand.r7k_1);
    return this.x7h_1;
  }
  s7i(operand) {
    this.j7i(operand.v7k_1);
    this.j7i(operand.w7k_1);
    this.j7i(operand.x7k_1);
    return this.x7h_1;
  }
  t7i(operand) {
    this.j7i(operand.m7l_1);
    return this.x7h_1;
  }
  u7i(operand) {
    this.j7i(operand.p7l_1);
    this.j7i(operand.q7l_1);
    return this.x7h_1;
  }
  v7i(operand) {
    var indexedObject = operand.k7k_1;
    var inductionVariable = 0;
    var last = indexedObject.length;
    while (inductionVariable < last) {
      var op = indexedObject[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      this.j7i(op);
    }
    return this.x7h_1;
  }
  w7i(operand) {
    return this.x7h_1;
  }
  x7i(operand) {
    return this.x7h_1;
  }
  y7i(operand) {
    return this.x7h_1;
  }
}
class GlobalsProgramVisitor extends Visitor {
  constructor() {
    super(Unit_instance);
    this.a7h_1 = LinkedHashSet.j1();
    this.b7h_1 = LinkedHashSet.j1();
    this.c7h_1 = LinkedHashSet.j1();
    this.d7h_1 = LinkedHashSet.j1();
    this.e7h_1 = LinkedHashSet.j1();
    this.f7h_1 = LinkedHashSet.j1();
    this.g7h_1 = LinkedHashSet.j1();
  }
  h7h(attribute) {
    // Inline function 'kotlin.collections.plusAssign' call
    this.a7h_1.h(attribute);
  }
  i7h(attribute) {
    this.h7h(attribute);
    return Unit_instance;
  }
  j7h(varying) {
    // Inline function 'kotlin.collections.plusAssign' call
    this.b7h_1.h(varying);
  }
  k7h(varying) {
    this.j7h(varying);
    return Unit_instance;
  }
  l7h(uniform) {
    // Inline function 'kotlin.collections.plusAssign' call
    this.c7h_1.h(uniform);
    var tmp0_safe_receiver = uniform.c7f_1;
    if (tmp0_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      // Inline function 'kotlin.contracts.contract' call
      this.d7h_1.h(tmp0_safe_receiver);
    }
    // Inline function 'kotlin.collections.plusAssign' call
    var this_0 = this.e7h_1;
    var element = uniform.c7f_1.v6r_1;
    this_0.h(element);
  }
  m7h(uniform) {
    this.l7h(uniform);
    return Unit_instance;
  }
  n7h(typedUniform) {
    // Inline function 'kotlin.collections.plusAssign' call
    var this_0 = this.c7h_1;
    var element = typedUniform.w6r_1;
    this_0.h(element);
    // Inline function 'kotlin.collections.plusAssign' call
    this.d7h_1.h(typedUniform);
    // Inline function 'kotlin.collections.plusAssign' call
    var this_1 = this.e7h_1;
    var element_0 = typedUniform.v6r_1;
    this_1.h(element_0);
  }
  o7h(typedUniform) {
    this.n7h(typedUniform);
    return Unit_instance;
  }
  p7h(sampler) {
    // Inline function 'kotlin.collections.plusAssign' call
    this.f7h_1.h(sampler);
  }
  q7h(sampler) {
    this.p7h(sampler);
    return Unit_instance;
  }
  r7h(func) {
    // Inline function 'kotlin.collections.plusAssign' call
    var this_0 = this.g7h_1;
    var element = func.v7h().s3();
    this_0.h(element);
  }
  w7h(func) {
    this.r7h(func);
    return Unit_instance;
  }
}
class Companion_46 {
  constructor() {
    Companion_instance_55 = this;
    this.p7c_1 = Companion_getInstance_1().qw('GlslGenerator');
  }
  q7c() {
    return Companion_getInstance_63().q7c();
  }
  r7c() {
    return Companion_getInstance_63().r7c();
  }
}
class Result {
  constructor(generator, result, attributes, uniforms, varyings) {
    this.f7g_1 = generator;
    this.g7g_1 = result;
    this.h7g_1 = attributes;
    this.i7g_1 = uniforms;
    this.j7g_1 = varyings;
  }
  toString() {
    return 'Result(generator=' + toString(this.f7g_1) + ', result=' + this.g7g_1 + ', attributes=' + toString(this.h7g_1) + ', uniforms=' + toString(this.i7g_1) + ', varyings=' + toString(this.j7g_1) + ')';
  }
  hashCode() {
    var result = hashCode(this.f7g_1);
    result = imul(result, 31) + getStringHashCode(this.g7g_1) | 0;
    result = imul(result, 31) + hashCode(this.h7g_1) | 0;
    result = imul(result, 31) + hashCode(this.i7g_1) | 0;
    result = imul(result, 31) + hashCode(this.j7g_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof Result))
      return false;
    var tmp0_other_with_cast = other instanceof Result ? other : THROW_CCE();
    if (!equals(this.f7g_1, tmp0_other_with_cast.f7g_1))
      return false;
    if (!(this.g7g_1 === tmp0_other_with_cast.g7g_1))
      return false;
    if (!equals(this.h7g_1, tmp0_other_with_cast.h7g_1))
      return false;
    if (!equals(this.i7g_1, tmp0_other_with_cast.i7g_1))
      return false;
    if (!equals(this.j7g_1, tmp0_other_with_cast.j7g_1))
      return false;
    return true;
  }
}
class sam$kotlin_Comparator$0 {
  constructor(function_0) {
    this.e7j_1 = function_0;
  }
  ui(a, b) {
    return this.e7j_1(a, b);
  }
  compare(a, b) {
    return this.ui(a, b);
  }
  n4() {
    return this.e7j_1;
  }
  equals(other) {
    var tmp;
    if (!(other == null) ? isInterface(other, Comparator) : false) {
      var tmp_0;
      if (!(other == null) ? isInterface(other, FunctionAdapter) : false) {
        tmp_0 = equals(this.n4(), other.n4());
      } else {
        tmp_0 = false;
      }
      tmp = tmp_0;
    } else {
      tmp = false;
    }
    return tmp;
  }
  hashCode() {
    return hashCode(this.n4());
  }
}
class BaseGlslGenerator {}
function precToString(prec) {
  var tmp;
  if (!_GLVariant___get_isES__impl__yezzg8(this.x7j().m76_1)) {
    tmp = '';
  } else {
    var tmp_0;
    switch (prec.r3_1) {
      case 0:
        tmp_0 = '';
        break;
      case 1:
        tmp_0 = 'lowp ';
        break;
      case 2:
        tmp_0 = 'mediump ';
        break;
      case 3:
        tmp_0 = 'highp ';
        break;
      default:
        noWhenBranchMatchedException();
        break;
    }
    tmp = tmp_0;
  }
  return tmp;
}
function typeToString(type) {
  var tmp;
  switch (type.r3_1) {
    case 0:
      tmp = 'void';
      break;
    case 21:
      tmp = 'vec4';
      break;
    case 1:
      tmp = 'mat2';
      break;
    case 2:
      tmp = 'mat3';
      break;
    case 3:
      tmp = 'mat4';
      break;
    case 4:
      tmp = 'sampler1D';
      break;
    case 5:
      tmp = 'sampler2D';
      break;
    case 6:
      tmp = 'sampler3D';
      break;
    case 7:
      tmp = 'samplerCube';
      break;
    default:
      var tmp_0;
      switch (type.a78_1.r3_1) {
        case 0:
          var tmp_1;
          switch (type.b78_1) {
            case 1:
              tmp_1 = 'bool';
              break;
            case 2:
              tmp_1 = 'bvec2';
              break;
            case 3:
              tmp_1 = 'bvec3';
              break;
            case 4:
              tmp_1 = 'bvec4';
              break;
            default:
              errorType(this, type);
              break;
          }

          tmp_0 = tmp_1;
          break;
        case 1:
        case 2:
        case 3:
        case 4:
        case 6:
          var tmp_2;
          switch (type.b78_1) {
            case 1:
              tmp_2 = 'float';
              break;
            case 2:
              tmp_2 = 'vec2';
              break;
            case 3:
              tmp_2 = 'vec3';
              break;
            case 4:
              tmp_2 = 'vec4';
              break;
            default:
              errorType(this, type);
              break;
          }

          tmp_0 = tmp_2;
          break;
        case 5:
          var tmp_3;
          switch (type.b78_1) {
            case 1:
              tmp_3 = 'int';
              break;
            case 2:
              tmp_3 = 'ivec2';
              break;
            case 3:
              tmp_3 = 'ivec3';
              break;
            case 4:
              tmp_3 = 'ivec4';
              break;
            default:
              errorType(this, type);
              break;
          }

          tmp_0 = tmp_3;
          break;
        default:
          noWhenBranchMatchedException();
          break;
      }

      tmp = tmp_0;
      break;
  }
  return tmp;
}
function get_arrayDecl(_this__u8e3s4) {
  return !(_this__u8e3s4.t77_1 === 1) ? '[' + _this__u8e3s4.t77_1 + ']' : '';
}
function get_IN() {
  return this.x7j().g7j();
}
function get_OUT() {
  return this.x7j().l7j();
}
function get_UNIFORM() {
  return this.x7j().k7j();
}
class GlslGenerator {
  constructor(kind, config) {
    Companion_getInstance_62();
    this.w7g_1 = kind;
    this.x7g_1 = config;
  }
  x7j() {
    return this.x7g_1;
  }
  y7g(shader) {
    return this.y7j(shader.l7g_1, shader.m7g_1);
  }
  y7j(root, funcs) {
    var types = new GlobalsProgramVisitor();
    if (this.w7g_1.equals(ShaderType_FRAGMENT_getInstance()) && this.x7g_1.f7j()) {
      types.b7h_1.h(Varying.t6z(this.x7g_1.m7j(), VarType_Float4_getInstance()));
    }
    var tmp = VarType_TVOID_getInstance();
    // Inline function 'kotlin.collections.listOf' call
    var tmp$ret$0 = emptyList();
    var mainFunc = new FuncDecl('main', tmp, tmp$ret$0, root);
    types.y7h(mainFunc);
    // Inline function 'kotlin.collections.distinctBy' call
    // Inline function 'kotlin.collections.filter' call
    // Inline function 'kotlin.collections.filterTo' call
    var destination = ArrayList.h1();
    var tmp0_iterator = funcs.a1();
    while (tmp0_iterator.b1()) {
      var element = tmp0_iterator.c1();
      // Inline function 'korlibs.graphics.shader.gl.GlslGenerator.generateResult.<anonymous>' call
      if (types.g7h_1.z2(element.r7j_1.s3())) {
        destination.h(element);
      }
    }
    var this_0 = reversed(destination);
    var set = HashSet.ha();
    var list = ArrayList.h1();
    var tmp0_iterator_0 = this_0.a1();
    while (tmp0_iterator_0.b1()) {
      var e = tmp0_iterator_0.c1();
      // Inline function 'korlibs.graphics.shader.gl.GlslGenerator.generateResult.<anonymous>' call
      var key = e.r7j_1.s3();
      if (set.h(key)) {
        list.h(e);
      }
    }
    var customFuncs = list;
    var _iterator__ex2g4s = funcs.a1();
    while (_iterator__ex2g4s.b1()) {
      var func = _iterator__ex2g4s.c1();
      types.y7h(mainFunc);
    }
    var allFuncs = plus(customFuncs, listOf(mainFunc));
    // Inline function 'kotlin.also' call
    var tmp_0 = Companion_getInstance_12();
    var this_1 = tmp_0.d34(GlslGenerator$generateResult$lambda(this, types, allFuncs)).toString();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.graphics.shader.gl.GlslGenerator.generateResult.<anonymous>' call
    if (Companion_getInstance_63().r7c()) {
      // Inline function 'korlibs.logger.Logger.info' call
      var this_2 = Companion_getInstance_62().p7c_1;
      var level = Level_INFO_getInstance();
      var tmp_1;
      if (this_2.a2u(level)) {
        // Inline function 'korlibs.graphics.shader.gl.GlslGenerator.generateResult.<anonymous>.<anonymous>' call
        var tmp$ret$6 = 'GlSlGenerator.version: ' + this.x7g_1.o76_1;
        this_2.b2u(level, tmp$ret$6);
        tmp_1 = Unit_instance;
      }
      // Inline function 'korlibs.logger.Logger.debug' call
      var this_3 = Companion_getInstance_62().p7c_1;
      var level_0 = Level_DEBUG_getInstance();
      var tmp_2;
      if (this_3.a2u(level_0)) {
        // Inline function 'korlibs.graphics.shader.gl.GlslGenerator.generateResult.<anonymous>.<anonymous>' call
        var tmp$ret$8 = 'GlSlGenerator:\n' + this_1;
        this_3.b2u(level_0, tmp$ret$8);
        tmp_2 = Unit_instance;
      }
    }
    var result = this_1;
    var tmp_3;
    if (root instanceof Raw) {
      tmp_3 = root.b7k(Companion_getInstance_63().a7j_1);
    } else {
      tmp_3 = result;
    }
    return new Result(this, tmp_3, toList(types.a7h_1), toList(types.c7h_1), toList(types.b7h_1));
  }
}
class Companion_47 {
  constructor() {
    Companion_instance_56 = this;
    this.z7i_1 = new GlslConfig(Companion_instance_54.d7g(), new Immutable(VOID, VOID, VOID, true));
    this.a7j_1 = 'GLSL';
    this.b7j_1 = 100;
    this.c7j_1 = 'fragColor';
    this.d7j_1 = 'gl_FragColor';
  }
  q7c() {
    var tmp0_safe_receiver = Companion_instance_1.bi('FORCE_GLSL_VERSION');
    var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : replace(tmp0_safe_receiver, '.', '');
    return tmp1_safe_receiver == null ? null : toIntOrNull(tmp1_safe_receiver);
  }
  r7c() {
    return Companion_instance_1.bi('DEBUG_GLSL') === 'true';
  }
}
class GlslConfig {
  constructor(variant, features, glslVersion, compatibility) {
    Companion_getInstance_63();
    glslVersion = glslVersion === VOID ? -1 : glslVersion;
    compatibility = compatibility === VOID ? true : compatibility;
    this.m76_1 = variant;
    this.n76_1 = features;
    this.o76_1 = glslVersion;
    this.p76_1 = compatibility;
  }
  c7k(name) {
    if (this.p76_1)
      return name;
    return name === 'texture2D' ? 'texture' : name;
  }
  f7j() {
    if (_GLVariant___get_isES__impl__yezzg8(this.m76_1))
      return this.o76_1 >= 300;
    return !this.p76_1;
  }
  q76() {
    return get_ENABLE_UNIFORM_BLOCKS() && this.f7j() && this.n76_1.p6j();
  }
  g7j() {
    return this.f7j() ? 'in' : 'attribute';
  }
  l7j() {
    return this.f7j() ? 'out' : 'varying';
  }
  k7j() {
    return 'uniform';
  }
  m7j() {
    return this.f7j() ? Companion_getInstance_63().c7j_1 : Companion_getInstance_63().d7j_1;
  }
  d7k(variant, features, glslVersion, compatibility) {
    return new GlslConfig(variant, features, glslVersion, compatibility);
  }
  s7c(variant, features, glslVersion, compatibility, $super) {
    variant = variant === VOID ? this.m76_1 : variant;
    features = features === VOID ? this.n76_1 : features;
    glslVersion = glslVersion === VOID ? this.o76_1 : glslVersion;
    compatibility = compatibility === VOID ? this.p76_1 : compatibility;
    return $super === VOID ? this.d7k(variant, features, glslVersion, compatibility) : $super.d7k.call(this, new GLVariant(variant), features, glslVersion, compatibility);
  }
  toString() {
    return 'GlslConfig(variant=' + GLVariant__toString_impl_o5yi3l(this.m76_1) + ', features=' + toString(this.n76_1) + ', glslVersion=' + this.o76_1 + ', compatibility=' + this.p76_1 + ')';
  }
  hashCode() {
    var result = GLVariant__hashCode_impl_2eslaq(this.m76_1);
    result = imul(result, 31) + hashCode(this.n76_1) | 0;
    result = imul(result, 31) + this.o76_1 | 0;
    result = imul(result, 31) + getBooleanHashCode(this.p76_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof GlslConfig))
      return false;
    var tmp0_other_with_cast = other instanceof GlslConfig ? other : THROW_CCE();
    if (!(this.m76_1 === tmp0_other_with_cast.m76_1))
      return false;
    if (!equals(this.n76_1, tmp0_other_with_cast.n76_1))
      return false;
    if (!(this.o76_1 === tmp0_other_with_cast.o76_1))
      return false;
    if (!(this.p76_1 === tmp0_other_with_cast.p76_1))
      return false;
    return true;
  }
}
class GlslBodyGenerator extends Visitor {
  constructor(kind, config) {
    super('');
    this.t7j_1 = kind;
    this.u7j_1 = config;
    this.v7j_1 = LinkedHashSet.j1();
    this.w7j_1 = new Indenter();
  }
  x7j() {
    return this.u7j_1;
  }
  a7i(stms) {
    var _iterator__ex2g4s = stms.e7k_1.a1();
    while (_iterator__ex2g4s.b1()) {
      var stm = _iterator__ex2g4s.c1();
      this.z7h(stm);
    }
  }
  d7i(stm) {
    this.w7j_1.w34(this.j7i(stm.f7k_1) + ' = ' + this.j7i(stm.g7k_1) + ';');
  }
  e7i(stm) {
    this.w7j_1.w34('discard;');
  }
  f7i(stm) {
    this.w7j_1.w34('break;');
  }
  g7i(stm) {
    this.w7j_1.w34('continue;');
  }
  i7i(stm) {
    var result = stm.h7k_1;
    if (!(result == null)) {
      this.w7j_1.w34('return ' + this.j7i(result) + ';');
    } else {
      this.w7j_1.w34('return;');
    }
  }
  v7i(operand) {
    var tmp = this.i7j(operand.j7k_1) + '(';
    return tmp + joinToString_0(operand.k7k_1, ', ', VOID, VOID, VOID, VOID, GlslBodyGenerator$visit$lambda(this)) + ')';
  }
  q7i(operand) {
    return '(' + operand.m7k_1 + '(' + this.j7i(operand.n7k_1) + ')' + ')';
  }
  r7i(operand) {
    return '(' + this.j7i(operand.p7k_1) + ' ' + operand.q7k_1 + ' ' + this.j7i(operand.r7k_1) + ')';
  }
  k7i(func) {
    var tmp = this.u7j_1.c7k(func.s3()) + '(';
    var tmp_0 = func.t7k();
    return tmp + joinToString(tmp_0, ', ', VOID, VOID, VOID, VOID, GlslBodyGenerator$visit$lambda_0(this)) + ')';
  }
  s7i(ternary) {
    return '((' + this.j7i(ternary.v7k_1) + ') ? (' + this.j7i(ternary.w7k_1) + ') : (' + this.j7i(ternary.x7k_1) + '))';
  }
  b7i(stm) {
    // Inline function 'kotlin.apply' call
    var this_0 = this.w7j_1;
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.graphics.shader.gl.GlslBodyGenerator.visit.<anonymous>' call
    // Inline function 'korlibs.io.util.Indenter.line' call
    var str = 'if (' + this.j7i(stm.y7k_1) + ')';
    var tmp;
    // Inline function 'kotlin.text.isEmpty' call
    if (charSequenceLength(str) === 0) {
      tmp = '{';
    } else {
      tmp = str + ' {';
    }
    this_0.w34(tmp);
    // Inline function 'korlibs.io.util.Indenter.indent' call
    this_0.x34();
    try {
      // Inline function 'korlibs.graphics.shader.gl.GlslBodyGenerator.visit.<anonymous>.<anonymous>' call
      this.z7h(stm.z7k_1);
    }finally {
      this_0.y34();
    }
    this_0.w34('}');
    if (!(stm.a7l_1 == null)) {
      // Inline function 'korlibs.io.util.Indenter.line' call
      var tmp_0;
      // Inline function 'kotlin.text.isEmpty' call
      if (charSequenceLength('else') === 0) {
        tmp_0 = '{';
      } else {
        tmp_0 = 'else' + ' {';
      }
      this_0.w34(tmp_0);
      // Inline function 'korlibs.io.util.Indenter.indent' call
      this_0.x34();
      try {
        // Inline function 'korlibs.graphics.shader.gl.GlslBodyGenerator.visit.<anonymous>.<anonymous>' call
        this.z7h(ensureNotNull(stm.a7l_1));
      }finally {
        this_0.y34();
      }
      this_0.w34('}');
    }
  }
  c7i(stm) {
    // Inline function 'kotlin.apply' call
    var this_0 = this.w7j_1;
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.graphics.shader.gl.GlslBodyGenerator.visit.<anonymous>' call
    var varType = this.i7j(stm.b7l_1.w29());
    var loopVar = this.m7i(stm.b7l_1);
    var min = this.j7i(stm.c7l_1);
    var maxExclusive = this.j7i(stm.d7l_1);
    // Inline function 'korlibs.io.util.Indenter.line' call
    var str = 'for (' + varType + ' ' + loopVar + ' = (' + min + '); ' + loopVar + ' < (' + maxExclusive + '); ' + loopVar + '++)';
    var tmp;
    // Inline function 'kotlin.text.isEmpty' call
    if (charSequenceLength(str) === 0) {
      tmp = '{';
    } else {
      tmp = str + ' {';
    }
    this_0.w34(tmp);
    // Inline function 'korlibs.io.util.Indenter.indent' call
    this_0.x34();
    try {
      // Inline function 'korlibs.graphics.shader.gl.GlslBodyGenerator.visit.<anonymous>.<anonymous>' call
      this.z7h(stm.e7l_1);
    }finally {
      this_0.y34();
    }
    this_0.w34('}');
  }
  h7i(stm) {
    // Inline function 'kotlin.apply' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.graphics.shader.gl.GlslBodyGenerator.visit.<anonymous>' call
    this.w7j_1.w34(stm.b7k(Companion_getInstance_63().a7j_1));
  }
  m7i(operand) {
    super.m7i(operand);
    var tmp;
    if (operand instanceof Output) {
      var tmp_0;
      switch (this.t7j_1.r3_1) {
        case 0:
          tmp_0 = 'gl_Position';
          break;
        case 1:
          tmp_0 = this.u7j_1.m7j();
          break;
        default:
          noWhenBranchMatchedException();
          break;
      }
      tmp = tmp_0;
    } else {
      tmp = operand.d76_1;
    }
    return tmp;
  }
  n7i(temp) {
    // Inline function 'kotlin.collections.plusAssign' call
    this.v7j_1.h(temp);
    return super.n7i(temp);
  }
  p7i(output) {
    return super.p7i(output);
  }
  w7i(operand) {
    return '' + operand.g7l_1;
  }
  x7i(operand) {
    var str = '' + operand.i7l_1;
    return contains(str, _Char___init__impl__6a9atx(46)) ? str : str + '.0';
  }
  y7i(operand) {
    return '' + operand.k7l_1;
  }
  t7i(operand) {
    return this.j7i(operand.m7l_1) + '.' + operand.n7l_1;
  }
  u7i(operand) {
    return this.j7i(operand.p7l_1) + '[' + this.j7i(operand.q7l_1) + ']';
  }
}
class ProgramLayout {
  static r7l(items, layoutSize, fixedLocation) {
    fixedLocation = fixedLocation === VOID ? -1 : fixedLocation;
    var $this = createThis(this);
    $this.i6s_1 = items;
    $this.j6s_1 = layoutSize;
    $this.k6s_1 = fixedLocation;
    $this.l6s_1 = 0;
    var tmp = $this;
    // Inline function 'korlibs.datastructure.mapInt' call
    var this_0 = $this.i6s_1;
    // Inline function 'kotlin.also' call
    var this_1 = IntArrayList.a2k();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.datastructure.mapInt.<anonymous>' call
    var _iterator__ex2g4s = this_0.a1();
    while (_iterator__ex2g4s.b1()) {
      var v = _iterator__ex2g4s.c1();
      // Inline function 'korlibs.graphics.shader.ProgramLayout.alignments.<anonymous>' call
      var a = v.w29().a78_1.u7l_1;
      var tmp$ret$0 = a <= 1 ? 1 : a;
      this_1.g2k(tmp$ret$0);
    }
    tmp.m6s_1 = this_1;
    var tmp_0 = $this;
    // Inline function 'korlibs.datastructure.mapInt' call
    var this_2 = $this.i6s_1;
    // Inline function 'kotlin.also' call
    var this_3 = IntArrayList.a2k();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.datastructure.mapInt.<anonymous>' call
    var _iterator__ex2g4s_0 = this_2.a1();
    while (_iterator__ex2g4s_0.b1()) {
      var v_0 = _iterator__ex2g4s_0.c1();
      // Inline function 'korlibs.graphics.shader.ProgramLayout._positions.<anonymous>' call
      $this.l6s_1 = !(v_0.o7e_1 == null) ? v_0.o7e_1 : nextAlignedTo($this.l6s_1, v_0.w29().a78_1.u7l_1);
      var out = $this.l6s_1;
      $this.l6s_1 = $this.l6s_1 + v_0.w29().d78_1 | 0;
      this_3.g2k(out);
    }
    tmp_0.n6s_1 = this_3;
    var tmp_1 = $this;
    var tmp0_elvis_lhs = maxOrNull($this.m6s_1);
    tmp_1.o6s_1 = tmp0_elvis_lhs == null ? 1 : tmp0_elvis_lhs;
    var tmp_2 = $this;
    var tmp0_elvis_lhs_0 = $this.j6s_1;
    tmp_2.p6s_1 = tmp0_elvis_lhs_0 == null ? nextAlignedTo($this.l6s_1, $this.o6s_1) : tmp0_elvis_lhs_0;
    return $this;
  }
  static q6s(variables, layoutSize) {
    layoutSize = layoutSize === VOID ? null : layoutSize;
    return this.r7l(toFastList_0(variables), layoutSize);
  }
  v7l() {
    return joinToString(this.i6s_1, ', ', VOID, VOID, VOID, VOID, ProgramLayout$names$lambda);
  }
  toString() {
    return get_portableSimpleName(getKClassFromExpression(this)) + '[' + this.v7l() + ', fixedLocation=' + this.k6s_1 + ']';
  }
  a1() {
    return this.i6s_1.a1();
  }
}
class Attribute extends VariableWithOffset {
  static w7l(name, type, normalized, offset, active, precision, divisor, fixedLocation) {
    offset = offset === VOID ? null : offset;
    active = active === VOID ? true : active;
    precision = precision === VOID ? Precision_DEFAULT_getInstance() : precision;
    divisor = divisor === VOID ? 0 : divisor;
    var $this = this.p7e(name, type, 1, precision, offset);
    $this.d6z_1 = normalized;
    $this.e6z_1 = active;
    $this.f6z_1 = divisor;
    $this.g6z_1 = fixedLocation;
    return $this;
  }
  static h6z(name, type, normalized, precision, fixedLocation) {
    precision = precision === VOID ? Precision_DEFAULT_getInstance() : precision;
    return this.w7l(name, type, normalized, null, true, precision, VOID, fixedLocation);
  }
  toString() {
    return 'Attribute(' + this.d76_1 + ')';
  }
  equals(other) {
    var tmp;
    var tmp_0;
    var tmp_1;
    // Inline function 'korlibs.graphics.shader.Variable.mequals' call
    var tmp_2;
    var tmp_3;
    var tmp_4;
    var tmp_5;
    if (other instanceof Attribute) {
      tmp_5 = this.g76_1 === other.g76_1;
    } else {
      tmp_5 = false;
    }
    if (tmp_5) {
      tmp_4 = this.w29().equals(other.w29());
    } else {
      tmp_4 = false;
    }
    if (tmp_4) {
      tmp_3 = this.t77_1 === other.t77_1;
    } else {
      tmp_3 = false;
    }
    if (tmp_3) {
      tmp_2 = this.d76_1 === other.d76_1;
    } else {
      tmp_2 = false;
    }
    if (tmp_2) {
      tmp_1 = this.d6z_1 === (other instanceof Attribute ? other : THROW_CCE()).d6z_1;
    } else {
      tmp_1 = false;
    }
    if (tmp_1) {
      tmp_0 = this.o7e_1 == other.o7e_1;
    } else {
      tmp_0 = false;
    }
    if (tmp_0) {
      tmp = this.e6z_1 === other.e6z_1;
    } else {
      tmp = false;
    }
    return tmp;
  }
  hashCode() {
    // Inline function 'korlibs.graphics.shader.Variable.mhashcode' call
    var out = (this.g76_1 + imul(this.w29().hashCode(), 7) | 0) + imul(getStringHashCode(this.d76_1), 11) | 0;
    out = imul(out, 7);
    out = out + getBooleanHashCode(this.d6z_1) | 0;
    out = imul(out, 7);
    var tmp = out;
    // Inline function 'kotlin.hashCode' call
    var tmp0_safe_receiver = this.o7e_1;
    var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : hashCode(tmp0_safe_receiver);
    out = tmp + (tmp1_elvis_lhs == null ? 0 : tmp1_elvis_lhs) | 0;
    out = imul(out, 7);
    out = out + getBooleanHashCode(this.e6z_1) | 0;
    return out;
  }
}
class Stm {}
class Stms extends Stm {
  constructor(stms) {
    super();
    this.e7k_1 = stms;
  }
  toString() {
    return 'Stms(stms=' + toString(this.e7k_1) + ')';
  }
  hashCode() {
    return hashCode(this.e7k_1);
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof Stms))
      return false;
    var tmp0_other_with_cast = other instanceof Stms ? other : THROW_CCE();
    if (!equals(this.e7k_1, tmp0_other_with_cast.e7k_1))
      return false;
    return true;
  }
}
class Set extends Stm {
  constructor(to, from) {
    super();
    this.f7k_1 = to;
    this.g7k_1 = from;
  }
  toString() {
    return 'Set(to=' + toString(this.f7k_1) + ', from=' + toString(this.g7k_1) + ')';
  }
  hashCode() {
    var result = hashCode(this.f7k_1);
    result = imul(result, 31) + hashCode(this.g7k_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof Set))
      return false;
    var tmp0_other_with_cast = other instanceof Set ? other : THROW_CCE();
    if (!equals(this.f7k_1, tmp0_other_with_cast.f7k_1))
      return false;
    if (!equals(this.g7k_1, tmp0_other_with_cast.g7k_1))
      return false;
    return true;
  }
}
class Return extends Stm {
  constructor(result) {
    super();
    this.h7k_1 = result;
  }
  toString() {
    return 'Return(result=' + toString_1(this.h7k_1) + ')';
  }
  hashCode() {
    return this.h7k_1 == null ? 0 : hashCode(this.h7k_1);
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof Return))
      return false;
    var tmp0_other_with_cast = other instanceof Return ? other : THROW_CCE();
    if (!equals(this.h7k_1, tmp0_other_with_cast.h7k_1))
      return false;
    return true;
  }
}
class Break extends Stm {}
class Continue extends Stm {}
class Discard extends Stm {
  constructor() {
    Discard_instance = null;
    super();
    Discard_instance = this;
  }
  toString() {
    return 'Discard';
  }
}
class If extends Stm {
  constructor(cond, tbody, fbody) {
    fbody = fbody === VOID ? null : fbody;
    super();
    this.y7k_1 = cond;
    this.z7k_1 = tbody;
    this.a7l_1 = fbody;
  }
  toString() {
    return 'If(cond=' + toString(this.y7k_1) + ', tbody=' + toString(this.z7k_1) + ', fbody=' + toString_1(this.a7l_1) + ')';
  }
  hashCode() {
    var result = hashCode(this.y7k_1);
    result = imul(result, 31) + hashCode(this.z7k_1) | 0;
    result = imul(result, 31) + (this.a7l_1 == null ? 0 : hashCode(this.a7l_1)) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof If))
      return false;
    var tmp0_other_with_cast = other instanceof If ? other : THROW_CCE();
    if (!equals(this.y7k_1, tmp0_other_with_cast.y7k_1))
      return false;
    if (!equals(this.z7k_1, tmp0_other_with_cast.z7k_1))
      return false;
    if (!equals(this.a7l_1, tmp0_other_with_cast.a7l_1))
      return false;
    return true;
  }
}
class ForSimple extends Stm {}
class Raw extends Stm {
  x7l(name) {
    return this.z7j_1.f3(name);
  }
  y7l(name, default_0) {
    var tmp0_elvis_lhs = this.x7l(name);
    return tmp0_elvis_lhs == null ? default_0 : tmp0_elvis_lhs;
  }
  b7k(name, default_0, $super) {
    default_0 = default_0 === VOID ? '' : default_0;
    return $super === VOID ? this.y7l(name, default_0) : $super.y7l.call(this, name, default_0);
  }
}
class Program$ExpressionBuilder$Companion$INSTANCE$1 {}
class Companion_48 {
  constructor() {
    Companion_instance_57 = this;
    var tmp = this;
    tmp.z7l_1 = new Program$ExpressionBuilder$Companion$INSTANCE$1();
  }
}
class FuncBuilder extends Builder {
  static i7m(parent) {
    var $this = this.j7m(parent);
    var tmp = $this;
    // Inline function 'kotlin.collections.arrayListOf' call
    tmp.g7m_1 = ArrayList.h1();
    return $this;
  }
  h7m(name, type) {
    // Inline function 'kotlin.also' call
    var this_0 = Arg.v7m(name, type);
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.graphics.shader.FuncBuilder.ARG.<anonymous>' call
    // Inline function 'kotlin.collections.plusAssign' call
    this.g7m_1.h(this_0);
    return this_0;
  }
}
class FuncDeclGetter {
  constructor(decl) {
    this.g7n_1 = decl;
  }
  no(thisRef, property) {
    var tmp = this.g7n_1;
    return isInterface(tmp, FuncRef) ? tmp : THROW_CCE();
  }
}
class FuncProvider {
  constructor(rettype, varTypes, builder, block) {
    this.a7m_1 = rettype;
    this.b7m_1 = varTypes;
    this.c7m_1 = builder;
    this.d7m_1 = block;
  }
  q6y(thisRef, property) {
    var tmp = property.callableName;
    var tmp_0 = this.c7m_1.i71(tmp, this.a7m_1, Program$Builder$FuncProvider$provideDelegate$lambda(this));
    return new FuncDeclGetter(tmp_0 instanceof FuncDecl ? tmp_0 : THROW_CCE());
  }
}
class Program$Builder$_funcs$1 extends Visitor {
  constructor($funcs, $box) {
    if ($box === VOID)
      $box = {};
    $box.i7n_1 = $funcs;
    super(Unit_instance, $box);
  }
  r7h(func) {
    // Inline function 'kotlin.collections.set' call
    var this_0 = this.i7n_1;
    var key = func.s3();
    var tmp = func.v7h();
    var value = tmp instanceof FuncDecl ? tmp : THROW_CCE();
    this_0.i3(key, value);
  }
  w7h(func) {
    this.r7h(func);
    return Unit_instance;
  }
}
class Ternary extends Operand {
  static k7n(cond, otrue, ofalse) {
    var $this = this.l7n(otrue.w29());
    $this.v7k_1 = cond;
    $this.w7k_1 = otrue;
    $this.x7k_1 = ofalse;
    return $this;
  }
  toString() {
    return 'Ternary(cond=' + toString(this.v7k_1) + ', otrue=' + toString(this.w7k_1) + ', ofalse=' + toString(this.x7k_1) + ')';
  }
  hashCode() {
    var result = hashCode(this.v7k_1);
    result = imul(result, 31) + hashCode(this.w7k_1) | 0;
    result = imul(result, 31) + hashCode(this.x7k_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof Ternary))
      return false;
    var tmp0_other_with_cast = other instanceof Ternary ? other : THROW_CCE();
    if (!equals(this.v7k_1, tmp0_other_with_cast.v7k_1))
      return false;
    if (!equals(this.w7k_1, tmp0_other_with_cast.w7k_1))
      return false;
    if (!equals(this.x7k_1, tmp0_other_with_cast.x7k_1))
      return false;
    return true;
  }
}
class Unop extends Operand {
  static m7n(op, right) {
    var $this = this.l7n(right.w29());
    $this.m7k_1 = op;
    $this.n7k_1 = right;
    return $this;
  }
  toString() {
    return 'Unop(op=' + this.m7k_1 + ', right=' + toString(this.n7k_1) + ')';
  }
  hashCode() {
    var result = getStringHashCode(this.m7k_1);
    result = imul(result, 31) + hashCode(this.n7k_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof Unop))
      return false;
    var tmp0_other_with_cast = other instanceof Unop ? other : THROW_CCE();
    if (!(this.m7k_1 === tmp0_other_with_cast.m7k_1))
      return false;
    if (!equals(this.n7k_1, tmp0_other_with_cast.n7k_1))
      return false;
    return true;
  }
}
class Binop extends Operand {
  static n7n(left, op, right) {
    var $this = this.l7n(left.w29());
    $this.p7k_1 = left;
    $this.q7k_1 = op;
    $this.r7k_1 = right;
    return $this;
  }
  toString() {
    return 'Binop(left=' + toString(this.p7k_1) + ', op=' + this.q7k_1 + ', right=' + toString(this.r7k_1) + ')';
  }
  hashCode() {
    var result = hashCode(this.p7k_1);
    result = imul(result, 31) + getStringHashCode(this.q7k_1) | 0;
    result = imul(result, 31) + hashCode(this.r7k_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof Binop))
      return false;
    var tmp0_other_with_cast = other instanceof Binop ? other : THROW_CCE();
    if (!equals(this.p7k_1, tmp0_other_with_cast.p7k_1))
      return false;
    if (!(this.q7k_1 === tmp0_other_with_cast.q7k_1))
      return false;
    if (!equals(this.r7k_1, tmp0_other_with_cast.r7k_1))
      return false;
    return true;
  }
}
class IntLiteral extends Operand {}
class FloatLiteral extends Operand {
  static o7n(value) {
    var $this = this.l7n(VarType_Float1_getInstance());
    $this.i7l_1 = value;
    return $this;
  }
  toString() {
    return 'FloatLiteral(value=' + this.i7l_1 + ')';
  }
  hashCode() {
    return getNumberHashCode(this.i7l_1);
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof FloatLiteral))
      return false;
    var tmp0_other_with_cast = other instanceof FloatLiteral ? other : THROW_CCE();
    if (!equals(this.i7l_1, tmp0_other_with_cast.i7l_1))
      return false;
    return true;
  }
}
class BoolLiteral extends Operand {}
class Vector extends Operand {
  static p7n(type, ops) {
    var $this = this.l7n(type);
    $this.j7k_1 = type;
    $this.k7k_1 = ops;
    return $this;
  }
  w29() {
    return this.j7k_1;
  }
  equals(other) {
    var tmp;
    var tmp_0;
    if (other instanceof Vector) {
      tmp_0 = this.j7k_1.equals(other.j7k_1);
    } else {
      tmp_0 = false;
    }
    if (tmp_0) {
      tmp = contentEquals(this.k7k_1, other.k7k_1);
    } else {
      tmp = false;
    }
    return tmp;
  }
  hashCode() {
    return imul(this.j7k_1.hashCode(), 7) + contentHashCode(this.k7k_1) | 0;
  }
  toString() {
    return 'Vector(type=' + this.j7k_1.toString() + ', ops=' + toString(this.k7k_1) + ')';
  }
}
class Swizzle extends Operand {
  static q7n(left, swizzle) {
    var $this = this.l7n(left.w29().r7n(swizzle.length));
    $this.m7l_1 = left;
    $this.n7l_1 = swizzle;
    return $this;
  }
  toString() {
    return 'Swizzle(left=' + toString(this.m7l_1) + ', swizzle=' + this.n7l_1 + ')';
  }
  hashCode() {
    var result = hashCode(this.m7l_1);
    result = imul(result, 31) + getStringHashCode(this.n7l_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof Swizzle))
      return false;
    var tmp0_other_with_cast = other instanceof Swizzle ? other : THROW_CCE();
    if (!equals(this.m7l_1, tmp0_other_with_cast.m7l_1))
      return false;
    if (!(this.n7l_1 === tmp0_other_with_cast.n7l_1))
      return false;
    return true;
  }
}
class ArrayAccess extends Operand {}
class BaseFunc extends Operand {
  static s7n(type) {
    return this.l7n(type);
  }
}
class Func extends BaseFunc {
  static x7n(name, ops, type) {
    type = type === VOID ? VarType_Float1_getInstance() : type;
    var $this = this.s7n(type);
    $this.u7n_1 = name;
    $this.v7n_1 = ops;
    $this.w7n_1 = type;
    return $this;
  }
  s3() {
    return this.u7n_1;
  }
  t7k() {
    return this.v7n_1;
  }
  w29() {
    return this.w7n_1;
  }
  static y7n(name, ops, type) {
    type = type === VOID ? VarType_Float1_getInstance() : type;
    return this.x7n(name, toList_0(ops), type);
  }
  toString() {
    return 'Func(name=' + this.u7n_1 + ', ops=' + toString(this.v7n_1) + ', type=' + this.w7n_1.toString() + ')';
  }
  hashCode() {
    var result = getStringHashCode(this.u7n_1);
    result = imul(result, 31) + hashCode(this.v7n_1) | 0;
    result = imul(result, 31) + this.w7n_1.hashCode() | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof Func))
      return false;
    var tmp0_other_with_cast = other instanceof Func ? other : THROW_CCE();
    if (!(this.u7n_1 === tmp0_other_with_cast.u7n_1))
      return false;
    if (!equals(this.v7n_1, tmp0_other_with_cast.v7n_1))
      return false;
    if (!this.w7n_1.equals(tmp0_other_with_cast.w7n_1))
      return false;
    return true;
  }
}
class CustomFunc extends BaseFunc {
  static z7n(ref, ops) {
    var $this = this.s7n(ref.a7o());
    $this.t7h_1 = ref;
    $this.u7h_1 = ops;
    return $this;
  }
  v7h() {
    return this.t7h_1;
  }
  t7k() {
    return this.u7h_1;
  }
  s3() {
    return this.v7h().s3();
  }
}
class FuncRef {}
class BuilderContext {
  constructor() {
    var tmp = this;
    // Inline function 'kotlin.collections.arrayListOf' call
    tmp.b7o_1 = ArrayList.h1();
    this.c7o_1 = 3;
  }
}
class Program {
  constructor(vertex, fragment, name) {
    name = name === VOID ? 'program-' + vertex.n7g_1 + '-' + fragment.n7g_1 : name;
    this.x6q_1 = vertex;
    this.y6q_1 = fragment;
    this.z6q_1 = name;
    this.a6r_1 = plus_0(this.x6q_1.s7g_1, this.y6q_1.s7g_1);
    this.b6r_1 = plus_0(this.x6q_1.t7g_1, this.y6q_1.t7g_1);
    var tmp = this;
    // Inline function 'kotlin.collections.map' call
    var this_0 = this.b6r_1;
    // Inline function 'kotlin.collections.mapTo' call
    var destination = ArrayList.w(collectionSizeOrDefault(this_0, 10));
    var tmp0_iterator = this_0.a1();
    while (tmp0_iterator.b1()) {
      var item = tmp0_iterator.c1();
      // Inline function 'korlibs.graphics.shader.Program.uniformBlocks.<anonymous>' call
      var tmp$ret$0 = item.v6r_1;
      destination.h(tmp$ret$0);
    }
    tmp.c6r_1 = distinct(destination);
    this.d6r_1 = plus_0(this.x6q_1.v7g_1, this.y6q_1.v7g_1);
    var tmp_0 = this;
    // Inline function 'kotlin.collections.associate' call
    var this_1 = withIndex(this.a6r_1);
    var capacity = coerceAtLeast(mapCapacity(collectionSizeOrDefault(this_1, 10)), 16);
    // Inline function 'kotlin.collections.associateTo' call
    var destination_0 = LinkedHashMap.hc(capacity);
    var tmp0_iterator_0 = this_1.a1();
    while (tmp0_iterator_0.b1()) {
      var element = tmp0_iterator_0.c1();
      // Inline function 'kotlin.collections.plusAssign' call
      // Inline function 'korlibs.graphics.shader.Program.uniformsToIndex.<anonymous>' call
      var pair = to(element.dl_1, new UniformInProgram(element.dl_1, element.cl_1));
      destination_0.i3(pair.hl_1, pair.il_1);
    }
    tmp_0.e6r_1 = destination_0;
    this.f6r_1 = plus_0(this.x6q_1.u7g_1, this.y6q_1.u7g_1);
    this.g6r_1 = (imul(this.x6q_1.hashCode(), 11) + imul(this.y6q_1.hashCode(), 7) | 0) + getStringHashCode(this.z6q_1) | 0;
  }
  hashCode() {
    return this.g6r_1;
  }
  equals(other) {
    var tmp;
    if (this === other) {
      tmp = true;
    } else {
      var tmp_0;
      var tmp_1;
      var tmp_2;
      if (other instanceof Program) {
        tmp_2 = this.x6q_1.equals(other.x6q_1);
      } else {
        tmp_2 = false;
      }
      if (tmp_2) {
        tmp_1 = this.y6q_1.equals(other.y6q_1);
      } else {
        tmp_1 = false;
      }
      if (tmp_1) {
        tmp_0 = this.z6q_1 === other.z6q_1;
      } else {
        tmp_0 = false;
      }
      tmp = tmp_0;
    }
    return tmp;
  }
  f6() {
  }
  toString() {
    // Inline function 'kotlin.collections.map' call
    var this_0 = this.f6r_1;
    // Inline function 'kotlin.collections.mapTo' call
    var destination = ArrayList.w(collectionSizeOrDefault(this_0, 10));
    var tmp0_iterator = this_0.a1();
    while (tmp0_iterator.b1()) {
      var item = tmp0_iterator.c1();
      // Inline function 'korlibs.graphics.shader.Program.toString.<anonymous>' call
      var tmp$ret$0 = item.d76_1;
      destination.h(tmp$ret$0);
    }
    var tmp = toString(destination);
    // Inline function 'kotlin.collections.map' call
    var this_1 = this.a6r_1;
    // Inline function 'kotlin.collections.mapTo' call
    var destination_0 = ArrayList.w(collectionSizeOrDefault(this_1, 10));
    var tmp0_iterator_0 = this_1.a1();
    while (tmp0_iterator_0.b1()) {
      var item_0 = tmp0_iterator_0.c1();
      // Inline function 'korlibs.graphics.shader.Program.toString.<anonymous>' call
      var tmp$ret$3 = item_0.d76_1;
      destination_0.h(tmp$ret$3);
    }
    return 'Program(name=' + this.z6q_1 + ', attributes=' + tmp + ', uniforms=' + toString(destination_0) + ')';
  }
  g7o(vertex, fragment, name) {
    return new Program(vertex, fragment, name);
  }
  h7o(vertex, fragment, name, $super) {
    vertex = vertex === VOID ? this.x6q_1 : vertex;
    fragment = fragment === VOID ? this.y6q_1 : fragment;
    name = name === VOID ? this.z6q_1 : name;
    return $super === VOID ? this.g7o(vertex, fragment, name) : $super.g7o.call(this, vertex, fragment, name);
  }
}
class Shader {
  constructor(type, stm, functions, name) {
    name = name === VOID ? null : name;
    this.k7g_1 = type;
    this.l7g_1 = stm;
    this.m7g_1 = functions;
    this.n7g_1 = name;
    this.o7g_1 = hashCode(this.l7g_1);
    this.p7g_1 = hashCode(this.m7g_1);
    this.q7g_1 = (imul(this.k7g_1.hashCode(), 17) + this.o7g_1 | 0) + imul(this.p7g_1, 53) | 0;
    var tmp = this;
    // Inline function 'kotlin.also' call
    var this_0 = new GlobalsProgramVisitor();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.graphics.shader.Shader.globals.<anonymous>' call
    this_0.z7h(this.l7g_1);
    tmp.r7g_1 = this_0;
    this.s7g_1 = this.r7g_1.c7h_1;
    this.t7g_1 = this.r7g_1.d7h_1;
    this.u7g_1 = this.r7g_1.a7h_1;
    this.v7g_1 = this.r7g_1.f7h_1;
  }
  i7o() {
    var tmp = this.l7g_1;
    return tmp instanceof Raw;
  }
  equals(other) {
    var tmp;
    if (this === other) {
      tmp = true;
    } else {
      var tmp_0;
      var tmp_1;
      var tmp_2;
      var tmp_3;
      if (other instanceof Shader) {
        tmp_3 = this.k7g_1.equals(other.k7g_1);
      } else {
        tmp_3 = false;
      }
      if (tmp_3) {
        tmp_2 = this.q7g_1 === other.q7g_1;
      } else {
        tmp_2 = false;
      }
      if (tmp_2) {
        tmp_1 = equals(this.l7g_1, other.l7g_1);
      } else {
        tmp_1 = false;
      }
      if (tmp_1) {
        tmp_0 = equals(this.m7g_1, other.m7g_1);
      } else {
        tmp_0 = false;
      }
      tmp = tmp_0;
    }
    return tmp;
  }
  hashCode() {
    return this.q7g_1;
  }
  toString() {
    return 'Shader(type=' + this.k7g_1.toString() + ', stm=' + toString(this.l7g_1) + ', functions=' + toString(this.m7g_1) + ', name=' + this.n7g_1 + ')';
  }
}
class Varying extends Variable {
  static j7o(name, type, arrayCount, precision) {
    precision = precision === VOID ? Precision_DEFAULT_getInstance() : precision;
    return this.k7o(name, type, arrayCount, precision);
  }
  static t6z(name, type, precision) {
    precision = precision === VOID ? Precision_DEFAULT_getInstance() : precision;
    return this.j7o(name, type, 1, precision);
  }
  toString() {
    return 'Varying(' + this.d76_1 + ')';
  }
  equals(other) {
    // Inline function 'korlibs.graphics.shader.Variable.mequals' call
    var tmp;
    var tmp_0;
    var tmp_1;
    var tmp_2;
    if (other instanceof Varying) {
      tmp_2 = this.g76_1 === other.g76_1;
    } else {
      tmp_2 = false;
    }
    if (tmp_2) {
      tmp_1 = this.w29().equals(other.w29());
    } else {
      tmp_1 = false;
    }
    if (tmp_1) {
      tmp_0 = this.t77_1 === other.t77_1;
    } else {
      tmp_0 = false;
    }
    if (tmp_0) {
      tmp = this.d76_1 === other.d76_1;
    } else {
      tmp = false;
    }
    return tmp;
  }
  hashCode() {
    // Inline function 'korlibs.graphics.shader.Variable.mhashcode' call
    return (this.g76_1 + imul(this.w29().hashCode(), 7) | 0) + imul(getStringHashCode(this.d76_1), 11) | 0;
  }
}
class Output extends Varying {
  static w7o() {
    Output_instance = null;
    var $this = this.t6z('out', VarType_Float4_getInstance());
    Output_instance = $this;
    return $this;
  }
  toString() {
    return 'Output';
  }
  equals(other) {
    // Inline function 'korlibs.graphics.shader.Variable.mequals' call
    var tmp;
    var tmp_0;
    var tmp_1;
    var tmp_2;
    if (other instanceof Output) {
      tmp_2 = this.g76_1 === other.g76_1;
    } else {
      tmp_2 = false;
    }
    if (tmp_2) {
      tmp_1 = this.w29().equals(other.w29());
    } else {
      tmp_1 = false;
    }
    if (tmp_1) {
      tmp_0 = this.t77_1 === other.t77_1;
    } else {
      tmp_0 = false;
    }
    if (tmp_0) {
      tmp = this.d76_1 === other.d76_1;
    } else {
      tmp = false;
    }
    return tmp;
  }
  hashCode() {
    // Inline function 'korlibs.graphics.shader.Variable.mhashcode' call
    return (this.g76_1 + imul(this.w29().hashCode(), 7) | 0) + imul(getStringHashCode(this.d76_1), 11) | 0;
  }
}
class Provider {
  constructor(index, stype) {
    this.o6y_1 = index;
    this.p6y_1 = stype;
  }
  q6y(thisRef, property) {
    return Sampler.x7o(property.callableName, this.o6y_1, this.p6y_1);
  }
}
class Sampler extends Variable {
  static x7o(name, index, stype) {
    var $this = this.b7p(name, stype.a7p_1);
    $this.n6n_1 = index;
    $this.o6n_1 = stype;
    return $this;
  }
  toString() {
    return 'Sampler(' + this.d76_1 + ', ' + this.n6n_1 + ', ' + this.o6n_1.toString() + ')';
  }
  equals(other) {
    // Inline function 'korlibs.graphics.shader.Variable.mequals' call
    var tmp;
    var tmp_0;
    var tmp_1;
    var tmp_2;
    if (other instanceof Sampler) {
      tmp_2 = this.g76_1 === other.g76_1;
    } else {
      tmp_2 = false;
    }
    if (tmp_2) {
      tmp_1 = this.w29().equals(other.w29());
    } else {
      tmp_1 = false;
    }
    if (tmp_1) {
      tmp_0 = this.t77_1 === other.t77_1;
    } else {
      tmp_0 = false;
    }
    if (tmp_0) {
      tmp = this.d76_1 === other.d76_1;
    } else {
      tmp = false;
    }
    return tmp;
  }
  hashCode() {
    // Inline function 'korlibs.graphics.shader.Variable.mhashcode' call
    return (this.g76_1 + imul(this.w29().hashCode(), 7) | 0) + imul(getStringHashCode(this.d76_1), 11) | 0;
  }
  no(thisRef, property) {
    return this;
  }
}
class SamplerVarType extends Enum {
  constructor(name, ordinal, vtype) {
    super(name, ordinal);
    this.a7p_1 = vtype;
  }
}
class Uniform extends VariableWithOffset {
  static d7f(name, type, arrayCount, precision, offset, typedUniform) {
    precision = precision === VOID ? Precision_DEFAULT_getInstance() : precision;
    offset = offset === VOID ? null : offset;
    var $this = this.p7e(name, type, arrayCount, precision, offset);
    $this.c7f_1 = typedUniform;
    if (type.c7p()) {
      // Inline function 'kotlin.error' call
      var message = "Can't create uniform '" + name + "' with a sampler type '" + type.toString() + "', please use `Sampler` class instead";
      throw IllegalStateException.z4(toString(message));
    }
    return $this;
  }
  toString() {
    return 'Uniform(' + this.d76_1 + ')';
  }
  equals(other) {
    // Inline function 'korlibs.graphics.shader.Variable.mequals' call
    var tmp;
    var tmp_0;
    var tmp_1;
    var tmp_2;
    if (other instanceof Uniform) {
      tmp_2 = this.g76_1 === other.g76_1;
    } else {
      tmp_2 = false;
    }
    if (tmp_2) {
      tmp_1 = this.w29().equals(other.w29());
    } else {
      tmp_1 = false;
    }
    if (tmp_1) {
      tmp_0 = this.t77_1 === other.t77_1;
    } else {
      tmp_0 = false;
    }
    if (tmp_0) {
      tmp = this.d76_1 === other.d76_1;
    } else {
      tmp = false;
    }
    return tmp;
  }
  hashCode() {
    // Inline function 'korlibs.graphics.shader.Variable.mhashcode' call
    return (this.g76_1 + imul(this.w29().hashCode(), 7) | 0) + imul(getStringHashCode(this.d76_1), 11) | 0;
  }
}
class Companion_49 {
  d7p(count) {
    var tmp;
    switch (count) {
      case 0:
        tmp = VarType_TVOID_getInstance();
        break;
      case 1:
        tmp = VarType_SByte1_getInstance();
        break;
      case 2:
        tmp = VarType_SByte2_getInstance();
        break;
      case 3:
        tmp = VarType_SByte3_getInstance();
        break;
      case 4:
        tmp = VarType_SByte4_getInstance();
        break;
      default:
        get_invalidOp();
        break;
    }
    return tmp;
  }
  e7p(count) {
    var tmp;
    switch (count) {
      case 0:
        tmp = VarType_TVOID_getInstance();
        break;
      case 1:
        tmp = VarType_UByte1_getInstance();
        break;
      case 2:
        tmp = VarType_UByte2_getInstance();
        break;
      case 3:
        tmp = VarType_UByte3_getInstance();
        break;
      case 4:
        tmp = VarType_UByte4_getInstance();
        break;
      default:
        get_invalidOp();
        break;
    }
    return tmp;
  }
  f7p(count) {
    var tmp;
    switch (count) {
      case 0:
        tmp = VarType_TVOID_getInstance();
        break;
      case 1:
        tmp = VarType_SShort1_getInstance();
        break;
      case 2:
        tmp = VarType_SShort2_getInstance();
        break;
      case 3:
        tmp = VarType_SShort3_getInstance();
        break;
      case 4:
        tmp = VarType_SShort4_getInstance();
        break;
      default:
        get_invalidOp();
        break;
    }
    return tmp;
  }
  g7p(count) {
    var tmp;
    switch (count) {
      case 0:
        tmp = VarType_TVOID_getInstance();
        break;
      case 1:
        tmp = VarType_UShort1_getInstance();
        break;
      case 2:
        tmp = VarType_UShort2_getInstance();
        break;
      case 3:
        tmp = VarType_UShort3_getInstance();
        break;
      case 4:
        tmp = VarType_UShort4_getInstance();
        break;
      default:
        get_invalidOp();
        break;
    }
    return tmp;
  }
  h7p(count) {
    var tmp;
    switch (count) {
      case 0:
        tmp = VarType_TVOID_getInstance();
        break;
      case 1:
        tmp = VarType_SInt1_getInstance();
        break;
      case 2:
        tmp = VarType_SInt2_getInstance();
        break;
      case 3:
        tmp = VarType_SInt3_getInstance();
        break;
      case 4:
        tmp = VarType_SInt4_getInstance();
        break;
      default:
        get_invalidOp();
        break;
    }
    return tmp;
  }
  i7p(count) {
    var tmp;
    switch (count) {
      case 0:
        tmp = VarType_TVOID_getInstance();
        break;
      case 1:
        tmp = VarType_Float1_getInstance();
        break;
      case 2:
        tmp = VarType_Float2_getInstance();
        break;
      case 3:
        tmp = VarType_Float3_getInstance();
        break;
      case 4:
        tmp = VarType_Float4_getInstance();
        break;
      default:
        get_invalidOp();
        break;
    }
    return tmp;
  }
}
class VarType extends Enum {
  constructor(name, ordinal, kind, elementCount, isMatrix) {
    isMatrix = isMatrix === VOID ? false : isMatrix;
    super(name, ordinal);
    this.a78_1 = kind;
    this.b78_1 = elementCount;
    this.c78_1 = isMatrix;
    this.d78_1 = imul(this.a78_1.u7l_1, this.b78_1);
  }
  r7n(length) {
    var tmp;
    switch (this.a78_1.r3_1) {
      case 1:
        tmp = Companion_instance_58.d7p(length);
        break;
      case 2:
        tmp = Companion_instance_58.e7p(length);
        break;
      case 3:
        tmp = Companion_instance_58.f7p(length);
        break;
      case 4:
        tmp = Companion_instance_58.g7p(length);
        break;
      case 5:
        tmp = Companion_instance_58.h7p(length);
        break;
      case 6:
        tmp = Companion_instance_58.i7p(length);
        break;
      default:
        throw NotImplementedError.td();
    }
    return tmp;
  }
  c7p() {
    return this.equals(VarType_Sampler1D_getInstance()) || this.equals(VarType_Sampler2D_getInstance()) || this.equals(VarType_Sampler3D_getInstance()) || this.equals(VarType_SamplerCube_getInstance());
  }
}
class Precision extends Enum {}
class Temp extends Variable {
  static d7o(id, type, arrayCount, precision) {
    precision = precision === VOID ? Precision_DEFAULT_getInstance() : precision;
    return this.k7o('temp' + id, type, arrayCount, precision);
  }
  static f70(id, type, precision) {
    precision = precision === VOID ? Precision_DEFAULT_getInstance() : precision;
    return this.d7o(id, type, 1, precision);
  }
  toString() {
    return 'Temp(' + this.d76_1 + ')';
  }
  equals(other) {
    // Inline function 'korlibs.graphics.shader.Variable.mequals' call
    var tmp;
    var tmp_0;
    var tmp_1;
    var tmp_2;
    if (other instanceof Temp) {
      tmp_2 = this.g76_1 === other.g76_1;
    } else {
      tmp_2 = false;
    }
    if (tmp_2) {
      tmp_1 = this.w29().equals(other.w29());
    } else {
      tmp_1 = false;
    }
    if (tmp_1) {
      tmp_0 = this.t77_1 === other.t77_1;
    } else {
      tmp_0 = false;
    }
    if (tmp_0) {
      tmp = this.d76_1 === other.d76_1;
    } else {
      tmp = false;
    }
    return tmp;
  }
  hashCode() {
    // Inline function 'korlibs.graphics.shader.Variable.mhashcode' call
    return (this.g76_1 + imul(this.w29().hashCode(), 7) | 0) + imul(getStringHashCode(this.d76_1), 11) | 0;
  }
}
class FuncDecl {
  constructor(name, rettype, args, stm) {
    this.n7j_1 = name;
    this.o7j_1 = rettype;
    this.p7j_1 = args;
    this.q7j_1 = stm;
    this.r7j_1 = this;
  }
  s3() {
    return this.n7j_1;
  }
  a7o() {
    return this.o7j_1;
  }
  toString() {
    return 'FuncDecl(name=' + this.n7j_1 + ', rettype=' + this.o7j_1.toString() + ', args=' + toString(this.p7j_1) + ', stm=' + toString(this.q7j_1) + ')';
  }
  hashCode() {
    var result = getStringHashCode(this.n7j_1);
    result = imul(result, 31) + this.o7j_1.hashCode() | 0;
    result = imul(result, 31) + hashCode(this.p7j_1) | 0;
    result = imul(result, 31) + hashCode(this.q7j_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof FuncDecl))
      return false;
    var tmp0_other_with_cast = other instanceof FuncDecl ? other : THROW_CCE();
    if (!(this.n7j_1 === tmp0_other_with_cast.n7j_1))
      return false;
    if (!this.o7j_1.equals(tmp0_other_with_cast.o7j_1))
      return false;
    if (!equals(this.p7j_1, tmp0_other_with_cast.p7j_1))
      return false;
    if (!equals(this.q7j_1, tmp0_other_with_cast.q7j_1))
      return false;
    return true;
  }
}
class VarKind extends Enum {
  constructor(name, ordinal, bytesSize) {
    super(name, ordinal);
    this.u7l_1 = bytesSize;
  }
}
class UniformInProgram {
  constructor(uniform, index) {
    this.k7p_1 = uniform;
    this.l7p_1 = index;
  }
  toString() {
    return 'UniformInProgram(uniform=' + this.k7p_1.toString() + ', index=' + this.l7p_1 + ')';
  }
  hashCode() {
    var result = this.k7p_1.hashCode();
    result = imul(result, 31) + this.l7p_1 | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof UniformInProgram))
      return false;
    var tmp0_other_with_cast = other instanceof UniformInProgram ? other : THROW_CCE();
    if (!this.k7p_1.equals(tmp0_other_with_cast.k7p_1))
      return false;
    if (!(this.l7p_1 === tmp0_other_with_cast.l7p_1))
      return false;
    return true;
  }
}
class Arg extends Variable {
  static v7m(name, type, arrayCount, precision) {
    arrayCount = arrayCount === VOID ? 1 : arrayCount;
    precision = precision === VOID ? Precision_DEFAULT_getInstance() : precision;
    return this.k7o(name, type, arrayCount, precision);
  }
  toString() {
    return 'Arg(' + this.d76_1 + ')';
  }
  equals(other) {
    // Inline function 'korlibs.graphics.shader.Variable.mequals' call
    var tmp;
    var tmp_0;
    var tmp_1;
    var tmp_2;
    if (other instanceof Arg) {
      tmp_2 = this.g76_1 === other.g76_1;
    } else {
      tmp_2 = false;
    }
    if (tmp_2) {
      tmp_1 = this.w29().equals(other.w29());
    } else {
      tmp_1 = false;
    }
    if (tmp_1) {
      tmp_0 = this.t77_1 === other.t77_1;
    } else {
      tmp_0 = false;
    }
    if (tmp_0) {
      tmp = this.d76_1 === other.d76_1;
    } else {
      tmp = false;
    }
    return tmp;
  }
  hashCode() {
    // Inline function 'korlibs.graphics.shader.Variable.mhashcode' call
    return (this.g76_1 + imul(this.w29().hashCode(), 7) | 0) + imul(getStringHashCode(this.d76_1), 11) | 0;
  }
}
class ShaderType extends Enum {}
class sam$kotlinx_coroutines_DisposableHandle$0 {
  constructor(function_0) {
    this.m7p_1 = function_0;
  }
  l18() {
    return this.m7p_1();
  }
  n4() {
    return this.m7p_1;
  }
  equals(other) {
    var tmp;
    if (!(other == null) ? isInterface(other, DisposableHandle) : false) {
      var tmp_0;
      if (!(other == null) ? isInterface(other, FunctionAdapter) : false) {
        tmp_0 = equals(this.n4(), other.n4());
      } else {
        tmp_0 = false;
      }
      tmp = tmp_0;
    } else {
      tmp = false;
    }
    return tmp;
  }
  hashCode() {
    return hashCode(this.n4());
  }
}
class ContextInfo {
  constructor() {
    var tmp = this;
    tmp.n7p_1 = KmlGl$ContextInfo$current$lambda;
  }
  toString() {
    return 'current=' + toString_1(this.n7p_1());
  }
}
class Companion_50 {
  constructor() {
    this.o7p_1 = 33309;
    this.p7p_1 = 33084;
    this.q7p_1 = 33085;
    this.r7p_1 = 256;
    this.s7p_1 = 1024;
    this.t7p_1 = 16384;
    this.u7p_1 = 0;
    this.v7p_1 = 1;
    this.w7p_1 = 0;
    this.x7p_1 = 1;
    this.y7p_1 = 2;
    this.z7p_1 = 3;
    this.a7q_1 = 4;
    this.b7q_1 = 5;
    this.c7q_1 = 6;
    this.d7q_1 = 0;
    this.e7q_1 = 1;
    this.f7q_1 = 768;
    this.g7q_1 = 769;
    this.h7q_1 = 770;
    this.i7q_1 = 771;
    this.j7q_1 = 772;
    this.k7q_1 = 773;
    this.l7q_1 = 774;
    this.m7q_1 = 775;
    this.n7q_1 = 776;
    this.o7q_1 = 32774;
    this.p7q_1 = 32777;
    this.q7q_1 = 32777;
    this.r7q_1 = 34877;
    this.s7q_1 = 32778;
    this.t7q_1 = 32779;
    this.u7q_1 = 32968;
    this.v7q_1 = 32969;
    this.w7q_1 = 32970;
    this.x7q_1 = 32971;
    this.y7q_1 = 32769;
    this.z7q_1 = 32770;
    this.a7r_1 = 32771;
    this.b7r_1 = 32772;
    this.c7r_1 = 32773;
    this.d7r_1 = 34962;
    this.e7r_1 = 34963;
    this.f7r_1 = 34964;
    this.g7r_1 = 34965;
    this.h7r_1 = 35040;
    this.i7r_1 = 35044;
    this.j7r_1 = 35048;
    this.k7r_1 = 34660;
    this.l7r_1 = 34661;
    this.m7r_1 = 34342;
    this.n7r_1 = 1028;
    this.o7r_1 = 1029;
    this.p7r_1 = 1032;
    this.q7r_1 = 3553;
    this.r7r_1 = 32879;
    this.s7r_1 = 2884;
    this.t7r_1 = 3042;
    this.u7r_1 = 3024;
    this.v7r_1 = 2960;
    this.w7r_1 = 2929;
    this.x7r_1 = 3089;
    this.y7r_1 = 32823;
    this.z7r_1 = 32926;
    this.a7s_1 = 32928;
    this.b7s_1 = 0;
    this.c7s_1 = 1280;
    this.d7s_1 = 1281;
    this.e7s_1 = 1282;
    this.f7s_1 = 1285;
    this.g7s_1 = 2304;
    this.h7s_1 = 2305;
    this.i7s_1 = 2849;
    this.j7s_1 = 33901;
    this.k7s_1 = 33902;
    this.l7s_1 = 2885;
    this.m7s_1 = 2886;
    this.n7s_1 = 2928;
    this.o7s_1 = 2930;
    this.p7s_1 = 2931;
    this.q7s_1 = 2932;
    this.r7s_1 = 2961;
    this.s7s_1 = 2962;
    this.t7s_1 = 2964;
    this.u7s_1 = 2965;
    this.v7s_1 = 2966;
    this.w7s_1 = 2967;
    this.x7s_1 = 2963;
    this.y7s_1 = 2968;
    this.z7s_1 = 34816;
    this.a7t_1 = 34817;
    this.b7t_1 = 34818;
    this.c7t_1 = 34819;
    this.d7t_1 = 36003;
    this.e7t_1 = 36004;
    this.f7t_1 = 36005;
    this.g7t_1 = 2978;
    this.h7t_1 = 3088;
    this.i7t_1 = 3106;
    this.j7t_1 = 3107;
    this.k7t_1 = 3317;
    this.l7t_1 = 3333;
    this.m7t_1 = 3379;
    this.n7t_1 = 3386;
    this.o7t_1 = 3408;
    this.p7t_1 = 3410;
    this.q7t_1 = 3411;
    this.r7t_1 = 3412;
    this.s7t_1 = 3413;
    this.t7t_1 = 3414;
    this.u7t_1 = 3415;
    this.v7t_1 = 10752;
    this.w7t_1 = 32824;
    this.x7t_1 = 32873;
    this.y7t_1 = 32936;
    this.z7t_1 = 32937;
    this.a7u_1 = 32938;
    this.b7u_1 = 32939;
    this.c7u_1 = 34466;
    this.d7u_1 = 34467;
    this.e7u_1 = 4352;
    this.f7u_1 = 4353;
    this.g7u_1 = 4354;
    this.h7u_1 = 33170;
    this.i7u_1 = 5120;
    this.j7u_1 = 5121;
    this.k7u_1 = 5122;
    this.l7u_1 = 5123;
    this.m7u_1 = 5124;
    this.n7u_1 = 5125;
    this.o7u_1 = 5126;
    this.p7u_1 = 5132;
    this.q7u_1 = 6402;
    this.r7u_1 = 6406;
    this.s7u_1 = 6407;
    this.t7u_1 = 6408;
    this.u7u_1 = 6409;
    this.v7u_1 = 6410;
    this.w7u_1 = 32819;
    this.x7u_1 = 32820;
    this.y7u_1 = 33635;
    this.z7u_1 = 35632;
    this.a7v_1 = 35633;
    this.b7v_1 = 34921;
    this.c7v_1 = 36347;
    this.d7v_1 = 36348;
    this.e7v_1 = 35661;
    this.f7v_1 = 35660;
    this.g7v_1 = 34930;
    this.h7v_1 = 36349;
    this.i7v_1 = 35663;
    this.j7v_1 = 35712;
    this.k7v_1 = 35714;
    this.l7v_1 = 35715;
    this.m7v_1 = 35717;
    this.n7v_1 = 35718;
    this.o7v_1 = 35719;
    this.p7v_1 = 35721;
    this.q7v_1 = 35722;
    this.r7v_1 = 35724;
    this.s7v_1 = 35725;
    this.t7v_1 = 512;
    this.u7v_1 = 513;
    this.v7v_1 = 514;
    this.w7v_1 = 515;
    this.x7v_1 = 516;
    this.y7v_1 = 517;
    this.z7v_1 = 518;
    this.a7w_1 = 519;
    this.b7w_1 = 7680;
    this.c7w_1 = 7681;
    this.d7w_1 = 7682;
    this.e7w_1 = 7683;
    this.f7w_1 = 5386;
    this.g7w_1 = 34055;
    this.h7w_1 = 34056;
    this.i7w_1 = 7936;
    this.j7w_1 = 7937;
    this.k7w_1 = 7938;
    this.l7w_1 = 7939;
    this.m7w_1 = 9728;
    this.n7w_1 = 9729;
    this.o7w_1 = 9984;
    this.p7w_1 = 9985;
    this.q7w_1 = 9986;
    this.r7w_1 = 9987;
    this.s7w_1 = 10240;
    this.t7w_1 = 10241;
    this.u7w_1 = 10242;
    this.v7w_1 = 10243;
    this.w7w_1 = 32882;
    this.x7w_1 = 5890;
    this.y7w_1 = 34067;
    this.z7w_1 = 34068;
    this.a7x_1 = 34069;
    this.b7x_1 = 34070;
    this.c7x_1 = 34071;
    this.d7x_1 = 34072;
    this.e7x_1 = 34073;
    this.f7x_1 = 34074;
    this.g7x_1 = 34076;
    this.h7x_1 = 33984;
    this.i7x_1 = 33985;
    this.j7x_1 = 33986;
    this.k7x_1 = 33987;
    this.l7x_1 = 33988;
    this.m7x_1 = 33989;
    this.n7x_1 = 33990;
    this.o7x_1 = 33991;
    this.p7x_1 = 33992;
    this.q7x_1 = 33993;
    this.r7x_1 = 33994;
    this.s7x_1 = 33995;
    this.t7x_1 = 33996;
    this.u7x_1 = 33997;
    this.v7x_1 = 33998;
    this.w7x_1 = 33999;
    this.x7x_1 = 34000;
    this.y7x_1 = 34001;
    this.z7x_1 = 34002;
    this.a7y_1 = 34003;
    this.b7y_1 = 34004;
    this.c7y_1 = 34005;
    this.d7y_1 = 34006;
    this.e7y_1 = 34007;
    this.f7y_1 = 34008;
    this.g7y_1 = 34009;
    this.h7y_1 = 34010;
    this.i7y_1 = 34011;
    this.j7y_1 = 34012;
    this.k7y_1 = 34013;
    this.l7y_1 = 34014;
    this.m7y_1 = 34015;
    this.n7y_1 = 34016;
    this.o7y_1 = 10497;
    this.p7y_1 = 33071;
    this.q7y_1 = 33648;
    this.r7y_1 = 35664;
    this.s7y_1 = 35665;
    this.t7y_1 = 35666;
    this.u7y_1 = 35667;
    this.v7y_1 = 35668;
    this.w7y_1 = 35669;
    this.x7y_1 = 35670;
    this.y7y_1 = 35671;
    this.z7y_1 = 35672;
    this.a7z_1 = 35673;
    this.b7z_1 = 35674;
    this.c7z_1 = 35675;
    this.d7z_1 = 35676;
    this.e7z_1 = 35678;
    this.f7z_1 = 35680;
    this.g7z_1 = 34338;
    this.h7z_1 = 34339;
    this.i7z_1 = 34340;
    this.j7z_1 = 34341;
    this.k7z_1 = 34922;
    this.l7z_1 = 34373;
    this.m7z_1 = 34975;
    this.n7z_1 = 35738;
    this.o7z_1 = 35739;
    this.p7z_1 = 35713;
    this.q7z_1 = 35716;
    this.r7z_1 = 35720;
    this.s7z_1 = 36346;
    this.t7z_1 = 36344;
    this.u7z_1 = 36345;
    this.v7z_1 = 36336;
    this.w7z_1 = 36337;
    this.x7z_1 = 36338;
    this.y7z_1 = 36339;
    this.z7z_1 = 36340;
    this.a80_1 = 36341;
    this.b80_1 = 36160;
    this.c80_1 = 36161;
    this.d80_1 = 32854;
    this.e80_1 = 32855;
    this.f80_1 = 36194;
    this.g80_1 = 33189;
    this.h80_1 = 6401;
    this.i80_1 = 36168;
    this.j80_1 = 36162;
    this.k80_1 = 36163;
    this.l80_1 = 36164;
    this.m80_1 = 36176;
    this.n80_1 = 36177;
    this.o80_1 = 36178;
    this.p80_1 = 36179;
    this.q80_1 = 36180;
    this.r80_1 = 36181;
    this.s80_1 = 36048;
    this.t80_1 = 36049;
    this.u80_1 = 36050;
    this.v80_1 = 36051;
    this.w80_1 = 36064;
    this.x80_1 = 36096;
    this.y80_1 = 33306;
    this.z80_1 = 34041;
    this.a81_1 = 36128;
    this.b81_1 = 0;
    this.c81_1 = 36053;
    this.d81_1 = 36054;
    this.e81_1 = 36055;
    this.f81_1 = 36057;
    this.g81_1 = 36061;
    this.h81_1 = 36006;
    this.i81_1 = 36007;
    this.j81_1 = 34024;
    this.k81_1 = 1286;
    this.l81_1 = 37120;
    this.m81_1 = 34836;
    this.n81_1 = 3313;
    this.o81_1 = 3314;
    this.p81_1 = 3316;
    this.q81_1 = 3315;
    this.r81_1 = 3312;
    this.s81_1 = 37441;
    this.t81_1 = 36197;
    this.u81_1 = 35345;
    this.v81_1 = 35368;
    this.w81_1 = 35380;
  }
}
class KmlGl {
  constructor() {
    this.b75_1 = new Mixin();
    this.c75_1 = new ContextInfo();
    this.d75_1 = null;
    var tmp = this;
    tmp.e75_1 = lazy(KmlGl$isFloatTextureSupported$delegate$lambda(this));
  }
  q78(texture) {
    throw NotImplementedError.td();
  }
  v7c(program, shader) {
    throw NotImplementedError.td();
  }
  u7c(program, index, name) {
    throw NotImplementedError.td();
  }
  k77(target, buffer) {
    throw NotImplementedError.td();
  }
  n7b(target, framebuffer) {
    throw NotImplementedError.td();
  }
  u7b(target, renderbuffer) {
    throw NotImplementedError.td();
  }
  l7b(target, texture) {
    throw NotImplementedError.td();
  }
  y79(modeRGB, modeAlpha) {
    throw NotImplementedError.td();
  }
  z79(sfactorRGB, dfactorRGB, sfactorAlpha, dfactorAlpha) {
    throw NotImplementedError.td();
  }
  u78(target, size, data, usage) {
    throw NotImplementedError.td();
  }
  t78(target, offset, size, data) {
    throw NotImplementedError.td();
  }
  u79(mask) {
    throw NotImplementedError.td();
  }
  p79(red, green, blue, alpha) {
    throw NotImplementedError.td();
  }
  r79(d) {
    throw NotImplementedError.td();
  }
  t79(s) {
    throw NotImplementedError.td();
  }
  b7c(red, green, blue, alpha) {
    throw NotImplementedError.td();
  }
  m7c(shader) {
    throw NotImplementedError.td();
  }
  o7c() {
    throw NotImplementedError.td();
  }
  k7c(type) {
    throw NotImplementedError.td();
  }
  r7a(mode) {
    throw NotImplementedError.td();
  }
  y81(n, items) {
    throw NotImplementedError.td();
  }
  z81(n, items) {
    throw NotImplementedError.td();
  }
  j7c(program) {
    throw NotImplementedError.td();
  }
  a82(n, items) {
    throw NotImplementedError.td();
  }
  i7c(shader) {
    throw NotImplementedError.td();
  }
  b82(n, items) {
    throw NotImplementedError.td();
  }
  a7c(func) {
    throw NotImplementedError.td();
  }
  q79(flag) {
    throw NotImplementedError.td();
  }
  z7b(n, f) {
    throw NotImplementedError.td();
  }
  d7a(cap) {
    throw NotImplementedError.td();
  }
  t7a(index) {
    throw NotImplementedError.td();
  }
  k7a(mode, first, count) {
    throw NotImplementedError.td();
  }
  m7a(mode, count, type, indices) {
    throw NotImplementedError.td();
  }
  e7a(cap) {
    throw NotImplementedError.td();
  }
  x7a(index) {
    throw NotImplementedError.td();
  }
  qc() {
    throw NotImplementedError.td();
  }
  x7b(target, attachment, renderbuffertarget, renderbuffer) {
    throw NotImplementedError.td();
  }
  w7b(target, attachment, textarget, texture, level) {
    throw NotImplementedError.td();
  }
  y7b(mode) {
    throw NotImplementedError.td();
  }
  c82(n, buffers) {
    throw NotImplementedError.td();
  }
  y78(target) {
    throw NotImplementedError.td();
  }
  d82(n, framebuffers) {
    throw NotImplementedError.td();
  }
  e82(n, renderbuffers) {
    throw NotImplementedError.td();
  }
  f82(n, textures) {
    throw NotImplementedError.td();
  }
  g7c(program, name) {
    throw NotImplementedError.td();
  }
  n7c() {
    throw NotImplementedError.td();
  }
  g82(pname, data) {
    throw NotImplementedError.td();
  }
  h82(program, pname, params) {
    throw NotImplementedError.td();
  }
  i82(shader, pname, params) {
    throw NotImplementedError.td();
  }
  j82(shader, bufSize, length, infoLog) {
    throw NotImplementedError.td();
  }
  f75(name) {
    throw NotImplementedError.td();
  }
  w7c(program) {
    throw NotImplementedError.td();
  }
  v78(pname, param) {
    throw NotImplementedError.td();
  }
  v7b(target, internalformat, width, height) {
    throw NotImplementedError.td();
  }
  c7c(x, y, width, height) {
    throw NotImplementedError.td();
  }
  l7c(shader, string) {
    throw NotImplementedError.td();
  }
  g7a(func, ref, mask) {
    throw NotImplementedError.td();
  }
  f7a(face, func, ref, mask) {
    throw NotImplementedError.td();
  }
  s79(mask) {
    throw NotImplementedError.td();
  }
  j7a(face, mask) {
    throw NotImplementedError.td();
  }
  i7a(fail, zfail, zpass) {
    throw NotImplementedError.td();
  }
  h7a(face, sfail, dpfail, dppass) {
    throw NotImplementedError.td();
  }
  w78(target, level, internalformat, width, height, border, format, type, pixels) {
    throw NotImplementedError.td();
  }
  x78(target, level, internalformat, format, type, data) {
    var buffer = Buffer.m12(imul(imul(data.x3z_1, data.y3z_1), 4), true);
    setArrayLE(buffer, 0, data.u47().n3z_1);
    this.w78(target, level, internalformat, data.x3z_1, data.y3z_1, 0, format, type, buffer);
  }
  p78(target, pname, param) {
    throw NotImplementedError.td();
  }
  l78(location, count, value) {
    throw NotImplementedError.td();
  }
  j76(location, v0) {
    throw NotImplementedError.td();
  }
  e78(location, count, value) {
    throw NotImplementedError.td();
  }
  m78(location, count, value) {
    throw NotImplementedError.td();
  }
  f78(location, count, value) {
    throw NotImplementedError.td();
  }
  n78(location, count, value) {
    throw NotImplementedError.td();
  }
  g78(location, count, value) {
    throw NotImplementedError.td();
  }
  o78(location, count, value) {
    throw NotImplementedError.td();
  }
  h78(location, count, value) {
    throw NotImplementedError.td();
  }
  i78(location, count, transpose, value) {
    throw NotImplementedError.td();
  }
  j78(location, count, transpose, value) {
    throw NotImplementedError.td();
  }
  k78(location, count, transpose, value) {
    throw NotImplementedError.td();
  }
  h7c(program) {
    throw NotImplementedError.td();
  }
  y7a(index, size, type, normalized, stride, pointer) {
    throw NotImplementedError.td();
  }
  m7b(x, y, width, height) {
    throw NotImplementedError.td();
  }
  a7a(cap, enable) {
    if (enable) {
      this.e7a(cap);
    } else {
      this.d7a(cap);
    }
    return enable;
  }
  l7a(mode, first, count, instancecount) {
    unsupported('Not supported instanced drawing');
  }
  n7a(mode, count, type, indices, instancecount) {
    unsupported('Not supported instanced drawing');
  }
  s7a(index, divisor) {
    unsupported();
  }
  f7b(target, index, buffer, offset, size) {
    unsupported('Not supported uniform buffers ' + toString(getKClassFromExpression(this)));
  }
  k76(program, name) {
    unsupported('Not supported uniform buffers ' + toString(getKClassFromExpression(this)));
  }
  l76(program, uniformBlockIndex, uniformBlockBinding) {
    unsupported('Not supported uniform buffers ' + toString(getKClassFromExpression(this)));
  }
  k82(n, arrays) {
    unsupported('Not supported vertex arrays ' + toString(getKClassFromExpression(this)));
  }
  u7a(array) {
    unsupported('Not supported vertex arrays ' + toString(getKClassFromExpression(this)));
  }
  r78() {
    return Companion_instance_54.d7g();
  }
  k79() {
    return Unit_instance;
  }
  p7a(contextVersion) {
    return Unit_instance;
  }
  l82(name, index) {
    throw NotImplementedError.td();
  }
  x81() {
    if (this.d75_1 == null) {
      var tmp = this;
      var tmp_0;
      try {
        var numExtensions = getIntegerv(this, 33309);
        if (numExtensions <= 0) {
          // Inline function 'kotlin.TODO' call
          throw NotImplementedError.td();
        }
        // Inline function 'kotlin.collections.mapNotNull' call
        // Inline function 'kotlin.collections.mapNotNullTo' call
        var this_0 = until(0, numExtensions);
        var destination = ArrayList.h1();
        // Inline function 'kotlin.collections.forEach' call
        var inductionVariable = this_0.d2_1;
        var last = this_0.e2_1;
        if (inductionVariable <= last)
          do {
            var element = inductionVariable;
            inductionVariable = inductionVariable + 1 | 0;
            // Inline function 'kotlin.collections.mapNotNullTo.<anonymous>' call
            // Inline function 'korlibs.kgl.KmlGl.<get-extensions>.<anonymous>' call
            var it = element;
            // Inline function 'korlibs.kgl.KmlGl.EXTENSIONS' call
            var tmp0_safe_receiver = this.l82(7939, it);
            if (tmp0_safe_receiver == null)
              null;
            else {
              // Inline function 'kotlin.let' call
              // Inline function 'kotlin.contracts.contract' call
              destination.h(tmp0_safe_receiver);
            }
          }
           while (!(element === last));
        tmp_0 = toSet(destination);
      } catch ($p) {
        var tmp_1;
        if ($p instanceof Error) {
          var e = $p;
          // Inline function 'korlibs.kgl.KmlGl.EXTENSIONS' call
          tmp_1 = toSet(split(this.f75(7939), [' ']));
        } else {
          throw $p;
        }
        tmp_0 = tmp_1;
      }
      tmp.d75_1 = tmp_0;
    }
    return ensureNotNull(this.d75_1);
  }
  l79() {
    return this.x81();
  }
  ay(value) {
    this.b75_1.ay(value);
  }
  by() {
    return this.b75_1.by();
  }
}
class KmlGlContext {
  constructor(window_0, gl, parent, $box) {
    parent = parent === VOID ? null : parent;
    boxApply(this, $box);
    this.h79_1 = window_0;
    this.i79_1 = gl;
    this.j79_1 = parent;
  }
  o7a() {
  }
  q7a() {
  }
  f6() {
  }
}
class KorgeReloadInternalImpl {
  m82(clazz, context) {
    return clazz;
  }
  n82(old, new_0) {
    return Unit_instance;
  }
}
class ReloadClassContext {
  constructor(injector, refreshedClasses, rootFolders) {
    this.o82_1 = injector;
    this.p82_1 = refreshedClasses;
    this.q82_1 = rootFolders;
  }
}
class KorgeReload {
  constructor() {
    KorgeReload_instance = this;
    this.r82_1 = null;
    this.s82_1 = Companion_getInstance_1().qw('KorgeReload');
  }
  t82(eventDispatcher) {
    if (!Companion_getInstance_2().ju().ru() || !(Companion_instance_1.bi('KORGE_AUTORELOAD') === 'true'))
      return Unit_instance;
    this.r82_1 = eventDispatcher;
  }
  u82() {
    if (!Companion_getInstance_2().ju().ru())
      return Unit_instance;
    if (!(this.r82_1 == null))
      this.r82_1 = null;
  }
}
class Companion_51 {}
class Companion_52 {
  constructor() {
    Companion_instance_61 = this;
    var tmp = this;
    var tmp0_factors = Companion_getInstance_43().y6j_1;
    tmp.v82_1 = new BlendMode(tmp0_factors, 'NORMAL');
    this.w82_1 = this.v82_1.i86(VOID, 'INHERIT');
    var tmp_0 = this;
    var tmp0_factors_0 = Companion_getInstance_43().r6t(Companion_getInstance_53().i6t_1, Companion_getInstance_53().p6t_1);
    tmp_0.x82_1 = new BlendMode(tmp0_factors_0, 'NONE');
    var tmp_1 = this;
    var tmp0_factors_1 = Companion_getInstance_43().a6k_1;
    tmp_1.y82_1 = new BlendMode(tmp0_factors_1, 'ADD');
    var tmp_2 = this;
    var tmp0_factors_2 = Companion_getInstance_43().r6t(Companion_getInstance_53().h6t_1, Companion_getInstance_53().l6t_1);
    tmp_2.z82_1 = new BlendMode(tmp0_factors_2, 'MULTIPLY');
    var tmp_3 = this;
    var tmp0_factors_3 = Companion_getInstance_43().r6t(Companion_getInstance_53().i6t_1, Companion_getInstance_53().m6t_1);
    tmp_3.a83_1 = new BlendMode(tmp0_factors_3, 'SCREEN');
    var tmp_4 = this;
    var tmp0_factors_4 = Companion_getInstance_43().r6t(Companion_getInstance_53().p6t_1, Companion_getInstance_53().l6t_1);
    tmp_4.b83_1 = new BlendMode(tmp0_factors_4, 'ERASE');
    var tmp_5 = this;
    var tmp0_factors_5 = Companion_getInstance_43().r6t(Companion_getInstance_53().p6t_1, Companion_getInstance_53().n6t_1);
    tmp_5.c83_1 = new BlendMode(tmp0_factors_5, 'MASK');
    var tmp_6 = this;
    var tmp0_factors_6 = Companion_getInstance_43().r6t(Companion_getInstance_53().j6t_1, Companion_getInstance_53().g6t_1);
    tmp_6.d83_1 = new BlendMode(tmp0_factors_6, 'BELOW');
    var tmp_7 = this;
    var tmp0_factors_7 = Companion_getInstance_43().q6t(Companion_getInstance_53().n6t_1, Companion_getInstance_53().g6t_1, Companion_getInstance_53().i6t_1, Companion_getInstance_53().i6t_1, Companion_getInstance_54().v6t_1);
    tmp_7.e83_1 = new BlendMode(tmp0_factors_7, 'SUBTRACT');
    var tmp_8 = this;
    var tmp0_factors_8 = Companion_getInstance_43().q6t(Companion_getInstance_53().k6t_1, Companion_getInstance_53().p6t_1, Companion_getInstance_53().i6t_1, Companion_getInstance_53().i6t_1);
    tmp_8.f83_1 = new BlendMode(tmp0_factors_8, 'INVERT');
    var tmp_9 = this;
    var tmp0_factors_9 = Companion_getInstance_43().q6t(Companion_getInstance_53().n6t_1, Companion_getInstance_53().g6t_1, Companion_getInstance_53().i6t_1, Companion_getInstance_53().i6t_1);
    tmp_9.g83_1 = new BlendMode(tmp0_factors_9, 'LIGHTEN');
    var tmp_10 = this;
    var tmp0_factors_10 = Companion_getInstance_43().q6t(Companion_getInstance_53().n6t_1, Companion_getInstance_53().g6t_1, Companion_getInstance_53().i6t_1, Companion_getInstance_53().i6t_1);
    tmp_10.h83_1 = new BlendMode(tmp0_factors_10, 'DARKEN');
    var tmp_11 = this;
    var tmp0_factors_11 = Companion_getInstance_43().q6t(Companion_getInstance_53().n6t_1, Companion_getInstance_53().g6t_1, Companion_getInstance_53().i6t_1, Companion_getInstance_53().i6t_1);
    tmp_11.i83_1 = new BlendMode(tmp0_factors_11, 'DIFFERENCE');
    var tmp_12 = this;
    var tmp0_factors_12 = Companion_getInstance_43().q6t(Companion_getInstance_53().n6t_1, Companion_getInstance_53().g6t_1, Companion_getInstance_53().i6t_1, Companion_getInstance_53().i6t_1);
    tmp_12.j83_1 = new BlendMode(tmp0_factors_12, 'ALPHA');
    var tmp_13 = this;
    var tmp0_factors_13 = Companion_getInstance_43().q6t(Companion_getInstance_53().n6t_1, Companion_getInstance_53().g6t_1, Companion_getInstance_53().i6t_1, Companion_getInstance_53().i6t_1);
    tmp_13.k83_1 = new BlendMode(tmp0_factors_13, 'HARDLIGHT');
    var tmp_14 = this;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp_14.l83_1 = [this.w82_1, this.x82_1, this.v82_1, this.y82_1, this.z82_1, this.a83_1, this.b83_1, this.c83_1, this.d83_1, this.e83_1, this.f83_1, this.g83_1, this.h83_1, this.i83_1, this.j83_1, this.k83_1];
    var tmp_15 = this;
    // Inline function 'kotlin.collections.associateBy' call
    var this_0 = this.l83_1;
    var capacity = coerceAtLeast(mapCapacity(this_0.length), 16);
    // Inline function 'kotlin.collections.associateByTo' call
    var destination = LinkedHashMap.hc(capacity);
    var inductionVariable = 0;
    var last = this_0.length;
    while (inductionVariable < last) {
      var element = this_0[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      // Inline function 'korlibs.korge.blend.Companion.BY_NAME.<anonymous>' call
      var tmp$ret$3 = ensureNotNull(element.g86_1);
      destination.i3(tmp$ret$3, element);
    }
    tmp_15.m83_1 = destination;
    this.n83_1 = toList_0(this.l83_1);
    var tmp_16 = this;
    // Inline function 'kotlin.collections.associateBy' call
    var this_1 = get_indices(this.l83_1);
    var capacity_0 = coerceAtLeast(mapCapacity(collectionSizeOrDefault(this_1, 10)), 16);
    // Inline function 'kotlin.collections.associateByTo' call
    var destination_0 = LinkedHashMap.hc(capacity_0);
    var inductionVariable_0 = this_1.d2_1;
    var last_0 = this_1.e2_1;
    if (inductionVariable_0 <= last_0)
      do {
        var element_0 = inductionVariable_0;
        inductionVariable_0 = inductionVariable_0 + 1 | 0;
        // Inline function 'korlibs.korge.blend.Companion.TO_ORDINAL.<anonymous>' call
        var it = element_0;
        var tmp$ret$6 = Companion_getInstance_68().l83_1[it];
        destination_0.i3(tmp$ret$6, element_0);
      }
       while (!(element_0 === last_0));
    tmp_16.o83_1 = destination_0;
  }
}
class BlendMode {
  constructor(factors, name) {
    Companion_getInstance_68();
    name = name === VOID ? null : name;
    this.f86_1 = factors;
    this.g86_1 = name;
    var tmp = this;
    var tmp_0 = AGBlending__hashCode_impl_ywnf51(this.f86_1);
    // Inline function 'kotlin.hashCode' call
    var tmp0_safe_receiver = this.g86_1;
    var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : hashCode(tmp0_safe_receiver);
    var tmp$ret$0 = tmp1_elvis_lhs == null ? 0 : tmp1_elvis_lhs;
    tmp.h86_1 = tmp_0 + imul(tmp$ret$0, 7) | 0;
  }
  hashCode() {
    return this.h86_1;
  }
  equals(other) {
    var tmp;
    if (this === other) {
      tmp = true;
    } else {
      var tmp_0;
      var tmp_1;
      if (other instanceof BlendMode) {
        tmp_1 = this.f86_1 === other.f86_1;
      } else {
        tmp_1 = false;
      }
      if (tmp_1) {
        tmp_0 = this.g86_1 == other.g86_1;
      } else {
        tmp_0 = false;
      }
      tmp = tmp_0;
    }
    return tmp;
  }
  toString() {
    var tmp0_elvis_lhs = this.g86_1;
    return tmp0_elvis_lhs == null ? anyToString(this) : tmp0_elvis_lhs;
  }
  j86(factors, name) {
    return new BlendMode(factors, name);
  }
  i86(factors, name, $super) {
    factors = factors === VOID ? this.f86_1 : factors;
    name = name === VOID ? this.g86_1 : name;
    return $super === VOID ? this.j86(factors, name) : $super.j86.call(this, new AGBlending(factors), name);
  }
}
class InputKeys {
  constructor() {
    this.k86_1 = booleanArray(Companion_getInstance_35().y6g_1);
    this.l86_1 = booleanArray(Companion_getInstance_35().y6g_1);
    this.m86_1 = false;
    this.n86_1 = false;
    this.o86_1 = false;
    this.p86_1 = false;
  }
  q86(key) {
    return this.r86(key);
  }
  r86(key) {
    return this.k86_1[key.r3_1];
  }
  s86(key, up, shift, ctrl, alt, meta) {
    switch (up) {
      case true:
        this.k86_1[key.r3_1] = false;
        break;
      case false:
        this.k86_1[key.r3_1] = true;
        break;
      default:
        noWhenBranchMatchedException();
        break;
    }
    this.m86_1 = shift || this.q86(Companion_getInstance_35().m6h()) || this.q86(Companion_getInstance_35().n6h());
    this.n86_1 = ctrl || this.q86(Companion_getInstance_35().k6h()) || this.q86(Companion_getInstance_35().l6h());
    this.o86_1 = alt || this.q86(Companion_getInstance_35().o6h()) || this.q86(Companion_getInstance_35().p6h());
    this.p86_1 = meta || this.q86(Key_META_getInstance());
  }
  t86(e) {
    switch (e.n6b_1.r3_1) {
      case 0:
      case 1:
        this.s86(e.p6b_1, e.n6b_1.equals(Type_UP_getInstance()), this.m86_1, this.n86_1, this.o86_1, this.p86_1);
        break;
      default:
        break;
    }
  }
  u86(delta) {
  }
  v86(delta) {
    arraycopy_4(this.k86_1, 0, this.l86_1, 0, this.k86_1.length);
  }
}
class Companion_53 {
  constructor() {
    this.w86_1 = 256;
  }
}
class Input {
  constructor() {
    this.x86_1 = new Mixin();
    this.y86_1 = Companion_getInstance_28().r6d_1;
    this.z86_1 = new TouchEvent();
    var tmp = this;
    tmp.a87_1 = Input$_isTouchDeviceGen$lambda;
    var tmp_0 = this;
    // Inline function 'korlibs.time.milliseconds' call
    // Inline function 'kotlin.time.Companion.milliseconds' call
    Companion_getInstance();
    tmp_0.b87_1 = toDuration(400, DurationUnit_MILLISECONDS_getInstance());
    this.c87_1 = 20.0;
    this.d87_1 = Vector2D.w27(-1000.0, -1000.0);
    this.e87_1 = Vector2D.w27(-1000.0, -1000.0);
    this.f87_1 = 0;
    this.g87_1 = false;
    this.h87_1 = true;
    this.i87_1 = false;
    this.j87_1 = new InputKeys();
    this.k87_1 = booleanArray(256);
    this.l87_1 = booleanArray(256);
    this.m87_1 = new Float64Array(256);
    this.n87_1 = new Float64Array(256);
    this.o87_1 = booleanArray(256);
    this.p87_1 = booleanArray(256);
    this.q87_1 = booleanArray(256);
    var tmp_1 = this;
    // Inline function 'kotlin.collections.toTypedArray' call
    // Inline function 'kotlin.collections.map' call
    var this_0 = until(0, 8);
    // Inline function 'kotlin.collections.mapTo' call
    var destination = ArrayList.w(collectionSizeOrDefault(this_0, 10));
    var inductionVariable = this_0.d2_1;
    var last = this_0.e2_1;
    if (inductionVariable <= last)
      do {
        var item = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        // Inline function 'korlibs.korge.input.Input.gamepads.<anonymous>' call
        var it = item;
        var tmp$ret$2 = new GamepadInfo(it);
        destination.h(tmp$ret$2);
      }
       while (!(item === last));
    tmp_1.r87_1 = copyToArray(destination);
    var tmp_2 = this;
    // Inline function 'kotlin.collections.arrayListOf' call
    tmp_2.s87_1 = ArrayList.h1();
  }
  t87() {
    return this.a87_1();
  }
  u87(touchEvent) {
    this.z86_1.a6f(touchEvent);
  }
  v87() {
    return this.d87_1;
  }
  w87(p, down) {
    if (down)
      this.e87_1 = p;
    else
      this.d87_1 = p;
  }
  x87(button, down) {
    this.f87_1 = setBits(this.f87_1, button.a6i_1, down);
  }
  y87() {
    this.s87_1.l3();
    // Inline function 'korlibs.datastructure.iterators.fastForEach' call
    var this_0 = this.r87_1;
    var n = 0;
    while (n < this_0.length) {
      // Inline function 'korlibs.korge.input.Input.updateConnectedGamepads.<anonymous>' call
      var _unary__edvuaz = n;
      n = _unary__edvuaz + 1 | 0;
      var gamepad = this_0[_unary__edvuaz];
      if (gamepad.v6f_1) {
        // Inline function 'kotlin.collections.plusAssign' call
        this.s87_1.h(gamepad);
      }
    }
  }
  z87(keyCode, b) {
    var pKeyCode = keyCode & 255;
    if (0 <= pKeyCode ? pKeyCode <= (this.k87_1.length - 1 | 0) : false) {
      this.k87_1[pKeyCode] = b;
    }
  }
  a88(delta) {
    var tmp0_safe_receiver = this.by();
    if (tmp0_safe_receiver == null)
      null;
    else {
      tmp0_safe_receiver.l3();
    }
    this.j87_1.u86(delta);
  }
  b88(delta) {
    this.i87_1 = false;
    this.j87_1.v86(delta);
    endFrameOldKeys(this, delta);
  }
  c88(e) {
    switch (e.n6b_1.r3_1) {
      case 1:
        this.z87(e.q6b_1, true);
        break;
      case 0:
        this.z87(e.q6b_1, false);
        break;
      case 2:
        break;
      default:
        noWhenBranchMatchedException();
        break;
    }
  }
  ay(value) {
    this.x86_1.ay(value);
  }
  by() {
    return this.x86_1.by();
  }
}
class DefaultViewport {
  constructor() {
    DefaultViewport_instance = this;
    this.d88_1 = 1280;
    this.e88_1 = 720;
    this.f88_1 = Size2D.t26(1280, 720);
  }
}
class Companion_54 {
  g88(str) {
    // Inline function 'kotlin.apply' call
    var this_0 = new Props();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.korge.logger.Companion.load.<anonymous>' call
    this_0.i88(str);
    return this_0;
  }
}
class Props {
  constructor(props) {
    props = props === VOID ? LinkedHashMap.gc() : props;
    this.h88_1 = props;
  }
  j88(str) {
    var _iterator__ex2g4s = split(str, ['\n']).a1();
    $l$loop_0: while (_iterator__ex2g4s.b1()) {
      var line = _iterator__ex2g4s.c1();
      if (startsWith(line, _Char___init__impl__6a9atx(35)))
        continue $l$loop_0;
      if (isBlank(line))
        continue $l$loop_0;
      var parts = split_0(line, charArrayOf([_Char___init__impl__6a9atx(61)]), VOID, 2);
      // Inline function 'kotlin.text.trim' call
      var this_0 = parts.d1(0);
      var key = toString(trim(isCharSequence(this_0) ? this_0 : THROW_CCE()));
      // Inline function 'kotlin.text.trim' call
      // Inline function 'kotlin.collections.getOrElse' call
      // Inline function 'kotlin.contracts.contract' call
      var tmp;
      if (0 <= 1 ? 1 < parts.e1() : false) {
        tmp = parts.d1(1);
      } else {
        // Inline function 'korlibs.korge.logger.Props.deserializeAdd.<anonymous>' call
        tmp = ' ';
      }
      var this_1 = tmp;
      var value = toString(trim(isCharSequence(this_1) ? this_1 : THROW_CCE()));
      // Inline function 'kotlin.collections.set' call
      this.h88_1.i3(key, value);
    }
  }
  i88(str) {
    this.l3();
    this.j88(str);
  }
  l3() {
    this.h88_1.l3();
  }
  k88(key, value) {
    return this.h88_1.i3(key, value);
  }
  i3(key, value) {
    var tmp = (!(key == null) ? typeof key === 'string' : false) ? key : THROW_CCE();
    return this.k88(tmp, (!(value == null) ? typeof value === 'string' : false) ? value : THROW_CCE());
  }
  my(key) {
    return this.h88_1.j3(key);
  }
  j3(key) {
    if (!(!(key == null) ? typeof key === 'string' : false))
      return null;
    return this.my((!(key == null) ? typeof key === 'string' : false) ? key : THROW_CCE());
  }
  s1() {
    return this.h88_1.s1();
  }
  g3() {
    return this.h88_1.g3();
  }
  h3() {
    return this.h88_1.h3();
  }
  oy(key) {
    return this.h88_1.d3(key);
  }
  d3(key) {
    if (!(!(key == null) ? typeof key === 'string' : false))
      return false;
    return this.oy((!(key == null) ? typeof key === 'string' : false) ? key : THROW_CCE());
  }
  bi(key) {
    return this.h88_1.f3(key);
  }
  f3(key) {
    if (!(!(key == null) ? typeof key === 'string' : false))
      return null;
    return this.bi((!(key == null) ? typeof key === 'string' : false) ? key : THROW_CCE());
  }
  g1() {
    return this.h88_1.g1();
  }
  e1() {
    return this.h88_1.e1();
  }
}
class Entry {
  constructor(closeable) {
    closeable = closeable === VOID ? null : closeable;
    this.l88_1 = closeable;
  }
  m88() {
    var tmp0_safe_receiver = this.l88_1;
    if (tmp0_safe_receiver == null)
      null;
    else {
      tmp0_safe_receiver.f6();
    }
    this.l88_1 = null;
  }
  t2q() {
    this.l88_1 = null;
  }
}
class AgAutoFreeManager {
  constructor() {
    var tmp = this;
    var tmp_0 = AgAutoFreeManager$entryPool$lambda;
    tmp.n88_1 = Pool.z2p(tmp_0, VOID, AgAutoFreeManager$entryPool$lambda_0);
    this.o88_1 = FastIdentityMap();
    this.p88_1 = fastArrayListOf([]);
    this.q88_1 = 0;
    this.r88_1 = 60;
  }
  s88(closeable) {
    $l$block: {
      // Inline function 'korlibs.datastructure.getOrPut' call
      var this_0 = this.o88_1;
      var res = get_0(this_0, closeable);
      if (!(res == null)) {
        break $l$block;
      }
      // Inline function 'korlibs.korge.render.AgAutoFreeManager.reference.<anonymous>' call
      // Inline function 'kotlin.also' call
      var this_1 = this.n88_1.c2q();
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'korlibs.korge.render.AgAutoFreeManager.reference.<anonymous>.<anonymous>' call
      this_1.l88_1 = closeable;
      var out = this_1;
      set(this_0, closeable, out);
    }
  }
  t88() {
    this.q88_1 = this.q88_1 + 1 | 0;
    if (this.q88_1 >= this.r88_1) {
      this.q88_1 = 0;
      this.u88();
    }
  }
  u88() {
    var _iterator__ex2g4s = this.p88_1.a1();
    while (_iterator__ex2g4s.b1()) {
      var entry = _iterator__ex2g4s.c1();
      if (!contains_1(this.o88_1, entry.l88_1)) {
        var tmp0_safe_receiver = entry.l88_1;
        if (tmp0_safe_receiver == null)
          null;
        else {
          tmp0_safe_receiver.f6();
        }
        this.n88_1.d2q(entry);
      }
    }
    this.p88_1.l3();
    // Inline function 'korlibs.datastructure.fastValueForEach' call
    var this_0 = this.o88_1;
    // Inline function 'korlibs.datastructure.fastKeyForEach' call
    // Inline function 'kotlin.js.asDynamic' call
    var mapIterator = this_0.keys();
    $l$loop: while (true) {
      var v = mapIterator.next();
      if (v.done)
        break $l$loop;
      // Inline function 'korlibs.datastructure.fastValueForEach.<anonymous>' call
      var it = v.value;
      // Inline function 'korlibs.korge.render.AgAutoFreeManager.gc.<anonymous>' call
      var it_0 = ensureNotNull(get_0(this_0, it));
      this.p88_1.h(it_0);
    }
    clear(this.o88_1);
  }
  f6() {
    // Inline function 'korlibs.datastructure.FastArrayList.fastForEach' call
    // Inline function 'korlibs.datastructure.FastArrayList.jsArray' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var array = this.p88_1.qy_1;
    var n = 0;
    while (n < array.length) {
      // Inline function 'korlibs.korge.render.AgAutoFreeManager.close.<anonymous>' call
      // Inline function 'kotlin.js.unsafeCast' call
      // Inline function 'korlibs.datastructure.get' call
      var _unary__edvuaz = n;
      n = _unary__edvuaz + 1 | 0;
      // Inline function 'kotlin.js.asDynamic' call
      // Inline function 'kotlin.js.asDynamic' call
      array[_unary__edvuaz].m88();
    }
    // Inline function 'korlibs.datastructure.fastValueForEach' call
    var this_0 = this.o88_1;
    // Inline function 'korlibs.datastructure.fastKeyForEach' call
    // Inline function 'kotlin.js.asDynamic' call
    var mapIterator = this_0.keys();
    $l$loop: while (true) {
      var v = mapIterator.next();
      if (v.done)
        break $l$loop;
      // Inline function 'korlibs.datastructure.fastValueForEach.<anonymous>' call
      var it = v.value;
      // Inline function 'korlibs.korge.render.AgAutoFreeManager.close.<anonymous>' call
      ensureNotNull(get_0(this_0, it)).m88();
    }
    this.p88_1.l3();
    this.n88_1.l3();
    clear(this.o88_1);
  }
}
class BitmapTextureInfo {
  constructor() {
    this.v88_1 = 0;
    this.w88_1 = TextureBase.b89(null, 0, 0);
    this.x88_1 = FastIdentityMap();
  }
  t2q() {
    this.v88_1 = 0;
    this.w88_1.y88_1 = null;
    this.w88_1.a89_1 = -1;
    this.w88_1.c89(0);
    this.w88_1.d89(0);
    clear(this.x88_1);
  }
  toString() {
    return 'BitmapTextureInfo(textureBase=' + this.w88_1.toString() + ', usedMemory=' + this.v88_1 + ', slices=' + get_size(this.x88_1) + ')';
  }
}
class AgBitmapTextureManager {
  constructor(ag) {
    this.e89_1 = ag;
    this.f89_1 = new Long(0, 0);
    this.g89_1 = FastSmallSet.f2n();
    this.h89_1 = FastSmallSet.f2n();
    this.i89_1 = FastArrayList.sy();
    this.j89_1 = 60;
    this.k89_1 = new Long(0, 0);
    var tmp = this;
    var tmp_0 = AgBitmapTextureManager$textureInfoPool$lambda;
    tmp.l89_1 = Pool.z2p(tmp_0, VOID, AgBitmapTextureManager$textureInfoPool$lambda_0);
    this.m89_1 = FastIdentityMap();
    this.n89_1 = null;
    this.o89_1 = null;
    this.p89_1 = null;
    this.q89_1 = null;
    this.r89_1 = null;
    this.s89_1 = null;
    this.t89_1 = null;
    this.u89_1 = null;
    this.v89_1 = 0;
  }
  x89() {
    return this.g89_1.e1();
  }
  y89() {
    return this.h89_1.e1();
  }
  z89() {
    return this.i89_1.e1();
  }
  toString() {
    return this.a8a();
  }
  a8a() {
    return 'AgBitmapTextureManager(numCachedBitmaps=' + this.x89() + ', numReferencedBitmapsSinceGC=' + this.y89() + ', numReferencedBitmaps=' + this.z89() + ', maxCachedMemory=' + ByteUnits__toString_impl_ox2ku2(Companion_getInstance_9().r14(this.f89_1)) + ', managedTextureMemory=' + ByteUnits__toString_impl_ox2ku2(Companion_getInstance_9().r14(this.k89_1)) + ')';
  }
  b8a(bitmap) {
    return ensureNotNull(getTextureInfo(this, bitmap).w88_1);
  }
  c8a(slice) {
    var tmp = _getTexture(this, slice);
    return tmp instanceof RectSlice ? tmp : THROW_CCE();
  }
  d8a(slice) {
    return _getTexture(this, slice);
  }
  e8a() {
    clearFastCacheAccess(this);
    this.v89_1 = this.v89_1 + 1 | 0;
    if (this.v89_1 >= this.j89_1) {
      this.v89_1 = 0;
      this.u88();
    }
  }
  u88() {
    // Inline function 'korlibs.datastructure.FastArrayList.fastForEach' call
    // Inline function 'korlibs.datastructure.FastArrayList.jsArray' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var array = this.i89_1.qy_1;
    var n = 0;
    while (n < array.length) {
      // Inline function 'korlibs.korge.render.AgBitmapTextureManager.gc.<anonymous>' call
      // Inline function 'kotlin.js.unsafeCast' call
      // Inline function 'korlibs.datastructure.get' call
      var _unary__edvuaz = n;
      n = _unary__edvuaz + 1 | 0;
      // Inline function 'kotlin.js.asDynamic' call
      // Inline function 'kotlin.js.asDynamic' call
      var bmp = array[_unary__edvuaz];
      if (!this.h89_1.al(bmp))
        if (this.f89_1.z1(this.k89_1) < 0 || this.k89_1.z1(new Long(0, 0)) < 0) {
          this.f8a(bmp, 'GC');
        } else
          this.g89_1.g2n(bmp);
    }
    this.i89_1.l3();
    // Inline function 'korlibs.datastructure.FastSmallSet.fastForEach' call
    // Inline function 'kotlin.collections.forEach' call
    var tmp0_iterator = this.h89_1.b2n_1.a1();
    while (tmp0_iterator.b1()) {
      var element = tmp0_iterator.c1();
      // Inline function 'korlibs.datastructure.FastSmallSet.fastForEach.<anonymous>' call
      // Inline function 'korlibs.korge.render.AgBitmapTextureManager.gc.<anonymous>' call
      this.i89_1.h(element);
    }
    // Inline function 'korlibs.datastructure.FastSmallSet.fastForEach' call
    // Inline function 'kotlin.collections.forEach' call
    var tmp0_iterator_0 = this.g89_1.b2n_1.a1();
    while (tmp0_iterator_0.b1()) {
      var element_0 = tmp0_iterator_0.c1();
      // Inline function 'korlibs.datastructure.FastSmallSet.fastForEach.<anonymous>' call
      // Inline function 'korlibs.korge.render.AgBitmapTextureManager.gc.<anonymous>' call
      this.i89_1.h(element_0);
    }
    this.h89_1.l3();
  }
  f8a(bmp, reason) {
    var tmp0_elvis_lhs = getAndRemove(this.m89_1, bmp);
    var tmp;
    if (tmp0_elvis_lhs == null) {
      return Unit_instance;
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var info = tmp;
    var tmp_0 = this;
    // Inline function 'kotlin.Long.minus' call
    var this_0 = this.k89_1;
    var other = info.v88_1;
    tmp_0.k89_1 = this_0.a2(toLong(other));
    this.h89_1.h2n(bmp);
    if (this.o89_1 === info || this.q89_1 === info) {
      clearFastCacheAccess(this);
    }
    info.w88_1.f6();
    this.l89_1.d2q(info);
    this.g89_1.h2n(bmp);
  }
  f6() {
    clearFastCacheAccess(this);
    var _iterator__ex2g4s = toList(get_keys(this.m89_1)).a1();
    while (_iterator__ex2g4s.b1()) {
      var bmp = _iterator__ex2g4s.c1();
      this.f8a(bmp, 'close');
    }
    clear(this.m89_1);
    this.i89_1.l3();
    this.h89_1.l3();
    this.g89_1.l3();
    this.l89_1.l3();
  }
}
class AgBufferManager {
  constructor(ag) {
    this.g8a_1 = ag;
    this.h8a_1 = FastIdentityMap();
    this.i8a_1 = FastSmallSet.f2n();
    var tmp = this;
    tmp.j8a_1 = Pool.a2q(VOID, AgBufferManager$bufferPool$lambda);
    this.k8a_1 = 0;
    this.l8a_1 = 60;
    this.m8a_1 = Buffer.m12(0);
  }
  n8a(cached) {
    this.i8a_1.g2n(cached);
    var tmp$ret$0;
    $l$block: {
      // Inline function 'korlibs.datastructure.getOrPut' call
      var this_0 = this.h8a_1;
      var res = get_0(this_0, cached);
      if (!(res == null)) {
        tmp$ret$0 = res;
        break $l$block;
      }
      // Inline function 'korlibs.korge.render.AgBufferManager.getBuffer.<anonymous>' call
      // Inline function 'kotlin.also' call
      var this_1 = this.j8a_1.c2q();
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'korlibs.korge.render.AgBufferManager.getBuffer.<anonymous>.<anonymous>' call
      this_1.q6m(cached.o8a_1);
      var out = this_1;
      set(this_0, cached, out);
      tmp$ret$0 = out;
    }
    return tmp$ret$0;
  }
  t88() {
    removeCache(this);
    this.k8a_1 = this.k8a_1 + 1 | 0;
    if (this.k8a_1 >= this.l8a_1) {
      this.k8a_1 = 0;
      this.u88();
    }
  }
  u88() {
    // Inline function 'korlibs.datastructure.FastSmallSet.fastForEach' call
    // Inline function 'kotlin.collections.forEach' call
    var tmp0_iterator = this.i8a_1.b2n_1.a1();
    while (tmp0_iterator.b1()) {
      var element = tmp0_iterator.c1();
      // Inline function 'korlibs.datastructure.FastSmallSet.fastForEach.<anonymous>' call
      // Inline function 'korlibs.korge.render.AgBufferManager.gc.<anonymous>' call
      this.p8a(element);
    }
    this.i8a_1.l3();
  }
  q8a(buffer) {
    // Inline function 'korlibs.datastructure.iterators.fastForEach' call
    var n = 0;
    while (n < buffer.e1()) {
      // Inline function 'korlibs.korge.render.AgBufferManager.delete.<anonymous>' call
      var _unary__edvuaz = n;
      n = _unary__edvuaz + 1 | 0;
      var it = buffer.d1(_unary__edvuaz);
      this.p8a(it);
    }
  }
  p8a(buffer) {
    var buf = getAndRemove(this.h8a_1, buffer);
    if (buf == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      // Inline function 'kotlin.contracts.contract' call
      buf.q6m(this.m8a_1);
      this.j8a_1.d2q(buf);
    }
  }
}
class AgCachedBuffer {
  constructor(data) {
    this.o8a_1 = data;
  }
}
class BatchBuffers {
  constructor() {
    this.b8b_1 = new AGBuffer();
    this.c8b_1 = new AGBuffer();
    this.d8b_1 = new AGBuffer();
    this.e8b_1 = AGVertexArrayObject.h6s([new AGVertexData(Companion_getInstance_71().y8a_1, this.b8b_1), new AGVertexData(Companion_getInstance_71().z8a_1, this.c8b_1)], false);
  }
}
class Companion_55 {
  constructor() {
    Companion_instance_64 = this;
    var tmp = this;
    var tmp_0 = 0;
    var tmp_1 = get_BB_MAX_TEXTURES();
    // Inline function 'kotlin.arrayOfNulls' call
    var tmp_2 = fillArrayVal(Array(tmp_1), null);
    while (tmp_0 < tmp_1) {
      var tmp_3 = tmp_0;
      tmp_2[tmp_3] = Sampler.x7o('u_Tex' + tmp_3, 3 + tmp_3 | 0, SamplerVarType_Sampler2D_getInstance());
      tmp_0 = tmp_0 + 1 | 0;
    }
    tmp.r8a_1 = tmp_2;
    this.s8a_1 = 16383;
    this.t8a_1 = 8192;
    // Inline function 'korlibs.logger.Logger.trace' call
    var this_0 = get_logger();
    var level = Level_TRACE_getInstance();
    var tmp_4;
    if (this_0.a2u(level)) {
      // Inline function 'korlibs.korge.render.Companion.<anonymous>' call
      var tmp$ret$2 = 'BatchBuilder2D.Companion[0]';
      this_0.b2u(level, tmp$ret$2);
      tmp_4 = Unit_instance;
    }
    this.u8a_1 = Attribute.h6z('a_Col2', VarType_UByte4_getInstance(), true, VOID, 3);
    // Inline function 'korlibs.logger.Logger.trace' call
    var this_1 = get_logger();
    var level_0 = Level_TRACE_getInstance();
    var tmp_5;
    if (this_1.a2u(level_0)) {
      // Inline function 'korlibs.korge.render.Companion.<anonymous>' call
      var tmp$ret$4 = 'BatchBuilder2D.Companion[1]';
      this_1.b2u(level_0, tmp$ret$4);
      tmp_5 = Unit_instance;
    }
    this.v8a_1 = Varying.t6z('v_Col2', VarType_Float4_getInstance());
    this.w8a_1 = Attribute.h6z('a_TexIndex', VarType_UByte1_getInstance(), false, Precision_LOW_getInstance(), 4);
    this.x8a_1 = Varying.t6z('v_TexIndex', VarType_Float1_getInstance(), Precision_LOW_getInstance());
    // Inline function 'korlibs.logger.Logger.trace' call
    var this_2 = get_logger();
    var level_1 = Level_TRACE_getInstance();
    var tmp_6;
    if (this_2.a2u(level_1)) {
      // Inline function 'korlibs.korge.render.Companion.<anonymous>' call
      var tmp$ret$6 = 'BatchBuilder2D.Companion[2]';
      this_2.b2u(level_1, tmp$ret$6);
      tmp_6 = Unit_instance;
    }
    this.y8a_1 = ProgramLayout.q6s([DefaultShaders_getInstance().a6w_1, DefaultShaders_getInstance().b6w_1, this.f8b(), this.u8a_1]);
    this.z8a_1 = ProgramLayout.q6s([this.w8a_1]);
    // Inline function 'korlibs.logger.Logger.trace' call
    var this_3 = get_logger();
    var level_2 = Level_TRACE_getInstance();
    var tmp_7;
    if (this_3.a2u(level_2)) {
      // Inline function 'korlibs.korge.render.Companion.<anonymous>' call
      var tmp$ret$8 = 'BatchBuilder2D.Companion[3]';
      this_3.b2u(level_2, tmp$ret$8);
      tmp_7 = Unit_instance;
    }
    var tmp_8 = this;
    // Inline function 'korlibs.graphics.VertexShaderDefault' call
    // Inline function 'kotlin.also' call
    var this_4 = ProgramBuilderDefault.i70();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.korge.render.Companion.PROGRAM.<anonymous>' call
    this_4.n70(this_4.j70(), this_4.k70());
    this_4.n70(Companion_getInstance_71().x8a_1, Companion_getInstance_71().w8a_1);
    this_4.n70(Companion_getInstance_71().g8b(), this_4.u70([this_4.r70(this_4.w70(Companion_getInstance_71().f8b(), 'rgb'), this_4.w70(Companion_getInstance_71().f8b(), 'a')), this_4.w70(Companion_getInstance_71().f8b(), 'a')]));
    this_4.n70(Companion_getInstance_71().v8a_1, Companion_getInstance_71().u8a_1);
    this_4.n70(this_4.q70(), this_4.r70(this_4.r70(this_4.a6y(), this_4.b6y()), this_4.u70([this_4.s70(), this_4.t70(0.0), this_4.t70(1.0)])));
    var tmp_9 = VertexShader(this_4.v70());
    // Inline function 'korlibs.graphics.FragmentShaderDefault' call
    // Inline function 'kotlin.also' call
    var this_5 = ProgramBuilderDefault.i70();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.korge.render.Companion.PROGRAM.<anonymous>' call
    Companion_getInstance_71().h8b(this_5);
    this_5.n70(this_5.q70(), this_5.r70(this_5.q70(), Companion_getInstance_71().g8b()));
    // Inline function 'korlibs.graphics.shader.Builder.IF' call
    var cond = this_5.y72(this_5.w70(this_5.q70(), 'a'), this_5.t70(0.0));
    var body = this_5.e71();
    // Inline function 'korlibs.korge.render.Companion.PROGRAM.<anonymous>.<anonymous>' call
    body.z71();
    var stmIf = new If(cond, body.g71());
    // Inline function 'kotlin.collections.plusAssign' call
    this_5.m70_1.h(stmIf);
    var tmp$ret$14 = FragmentShader(this_5.v70());
    tmp_8.a8b_1 = new Program(tmp_9, tmp$ret$14, 'BatchBuilder2D.Tinted');
    // Inline function 'korlibs.logger.Logger.trace' call
    var this_6 = get_logger();
    var level_3 = Level_TRACE_getInstance();
    var tmp_10;
    if (this_6.a2u(level_3)) {
      // Inline function 'korlibs.korge.render.Companion.<anonymous>' call
      var tmp$ret$15 = 'BatchBuilder2D.Companion[4]';
      this_6.b2u(level_3, tmp$ret$15);
      tmp_10 = Unit_instance;
    }
  }
  f8b() {
    return DefaultShaders_getInstance().c6w_1;
  }
  g8b() {
    return DefaultShaders_getInstance().e6w_1;
  }
  h8b(builder) {
    // Inline function 'kotlin.apply' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.korge.render.Companion.createTextureLookup.<anonymous>' call
    var tmp = Companion_getInstance_71().x8a_1;
    var tmp_0 = get_BB_MAX_TEXTURES() - 1 | 0;
    builder.v71(tmp, 0, tmp_0, BatchBuilder2D$Companion$createTextureLookup$lambda(builder));
  }
}
class BatchBuilder2D {
  constructor(ctx, reqMaxQuads) {
    Companion_getInstance_71();
    reqMaxQuads = reqMaxQuads === VOID ? Companion_getInstance_71().t8a_1 : reqMaxQuads;
    this.x84_1 = ctx;
    this.y84_1 = reqMaxQuads;
    this.z84_1 = get_BB_MAX_TEXTURES();
    var tmp = this;
    // Inline function 'kotlin.math.min' call
    var a = this.y84_1;
    var b = Companion_getInstance_71().s8a_1;
    tmp.a85_1 = Math.min(a, b);
    this.b85_1 = this.x84_1.j84_1;
    this.c85_1 = this.x84_1.q83_1;
    // Inline function 'korlibs.logger.Logger.trace' call
    var this_0 = get_logger();
    var level = Level_TRACE_getInstance();
    var tmp_0;
    if (this_0.a2u(level)) {
      // Inline function 'korlibs.korge.render.BatchBuilder2D.<anonymous>' call
      var tmp$ret$1 = 'BatchBuilder2D[0]';
      this_0.b2u(level, tmp$ret$1);
      tmp_0 = Unit_instance;
    }
    this.x84_1.l84_1.b1w(BatchBuilder2D$lambda(this));
    this.d85_1 = imul(this.a85_1, 4);
    this.e85_1 = imul(this.a85_1, 6);
    // Inline function 'korlibs.logger.Logger.trace' call
    var this_1 = get_logger();
    var level_0 = Level_TRACE_getInstance();
    var tmp_1;
    if (this_1.a2u(level_0)) {
      // Inline function 'korlibs.korge.render.BatchBuilder2D.<anonymous>' call
      var tmp$ret$3 = 'BatchBuilder2D[1]';
      this_1.b2u(level_0, tmp$ret$3);
      tmp_1 = Unit_instance;
    }
    this.f85_1 = Buffer.m12(imul(24, this.d85_1));
    this.g85_1 = new Int8Array(this.d85_1);
    this.h85_1 = Buffer.m12(imul(2, this.e85_1));
    this.i85_1 = get_u16(this.h85_1);
    // Inline function 'korlibs.logger.Logger.trace' call
    var this_2 = get_logger();
    var level_1 = Level_TRACE_getInstance();
    var tmp_2;
    if (this_2.a2u(level_1)) {
      // Inline function 'korlibs.korge.render.BatchBuilder2D.<anonymous>' call
      var tmp$ret$5 = 'BatchBuilder2D[2]';
      this_2.b2u(level_1, tmp$ret$5);
      tmp_2 = Unit_instance;
    }
    this.j85_1 = 0;
    this.k85_1 = 0;
    this.l85_1 = 0;
    this.m85_1 = 0;
    var tmp_3 = this;
    var tmp_4 = 0;
    var tmp_5 = this.z84_1;
    // Inline function 'kotlin.arrayOfNulls' call
    var tmp_6 = fillArrayVal(Array(tmp_5), null);
    while (tmp_4 < tmp_5) {
      tmp_6[tmp_4] = null;
      tmp_4 = tmp_4 + 1 | 0;
    }
    tmp_3.n85_1 = tmp_6;
    this.o85_1 = false;
    this.p85_1 = Companion_getInstance_68().v82_1;
    this.q85_1 = Companion_getInstance_71().a8b_1;
    // Inline function 'korlibs.logger.Logger.trace' call
    var this_3 = get_logger();
    var level_2 = Level_TRACE_getInstance();
    var tmp_7;
    if (this_3.a2u(level_2)) {
      // Inline function 'korlibs.korge.render.BatchBuilder2D.<anonymous>' call
      var tmp$ret$9 = 'BatchBuilder2D[3]';
      this_3.b2u(level_2, tmp$ret$9);
      tmp_7 = Unit_instance;
    }
    var tmp_8 = this;
    tmp_8.r85_1 = new ReturnablePool(VOID, BatchBuilder2D$buffers$lambda);
    // Inline function 'korlibs.logger.Logger.trace' call
    var this_4 = get_logger();
    var level_3 = Level_TRACE_getInstance();
    var tmp_9;
    if (this_4.a2u(level_3)) {
      // Inline function 'korlibs.korge.render.BatchBuilder2D.<anonymous>' call
      var tmp$ret$11 = 'BatchBuilder2D[4]';
      this_4.b2u(level_3, tmp$ret$11);
      tmp_9 = Unit_instance;
    }
    this.s85_1 = Companion_getInstance_46().f6k_1;
    this.t85_1 = Companion_getInstance_47().h6k_1;
    // Inline function 'korlibs.logger.Logger.trace' call
    var this_5 = get_logger();
    var level_4 = Level_TRACE_getInstance();
    var tmp_10;
    if (this_5.a2u(level_4)) {
      // Inline function 'korlibs.korge.render.BatchBuilder2D.<anonymous>' call
      var tmp$ret$13 = 'BatchBuilder2D[5]';
      this_5.b2u(level_4, tmp$ret$13);
      tmp_10 = Unit_instance;
    }
    this.u85_1 = _AGColorMask___init__impl__j38ai8_1();
    // Inline function 'korlibs.logger.Logger.trace' call
    var this_6 = get_logger();
    var level_5 = Level_TRACE_getInstance();
    var tmp_11;
    if (this_6.a2u(level_5)) {
      // Inline function 'korlibs.korge.render.BatchBuilder2D.<anonymous>' call
      var tmp$ret$15 = 'BatchBuilder2D[6]';
      this_6.b2u(level_5, tmp$ret$15);
      tmp_11 = Unit_instance;
    }
    this.v85_1 = Companion_getInstance_44().t6k_1;
    // Inline function 'korlibs.logger.Logger.trace' call
    var this_7 = get_logger();
    var level_6 = Level_TRACE_getInstance();
    var tmp_12;
    if (this_7.a2u(level_6)) {
      // Inline function 'korlibs.korge.render.BatchBuilder2D.<anonymous>' call
      var tmp$ret$17 = 'BatchBuilder2D[7]';
      this_7.b2u(level_6, tmp$ret$17);
      tmp_12 = Unit_instance;
    }
    // Inline function 'korlibs.logger.Logger.trace' call
    var this_8 = get_logger();
    var level_7 = Level_TRACE_getInstance();
    var tmp_13;
    if (this_8.a2u(level_7)) {
      // Inline function 'korlibs.korge.render.BatchBuilder2D.<anonymous>' call
      var tmp$ret$19 = 'BatchBuilder2D[11]';
      this_8.b2u(level_7, tmp$ret$19);
      tmp_13 = Unit_instance;
    }
    this.w85_1 = new Signal();
    this.x85_1 = new Signal();
    this.y85_1 = fastArrayListOf([]);
    this.z85_1 = 0;
    this.a86_1 = 0;
    this.b86_1 = 0;
  }
  k8b() {
    return this.x84_1.e84_1;
  }
  l8b(value) {
    this.j85_1 = value;
  }
  m8b() {
    return this.j85_1;
  }
  n8b() {
    var inductionVariable = 0;
    var last = this.z84_1;
    if (inductionVariable < last)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        this.n85_1[n] = null;
      }
       while (inductionVariable < last);
    this.m85_1 = 0;
  }
  t88() {
    this.r85_1.t2q();
  }
  o8b() {
    return this.v85_1;
  }
  p8b(vd, vp, x, y, u, v, colorMul, texIndex) {
    setFloat32(vd, vp + 0 | 0, x);
    setFloat32(vd, vp + 1 | 0, y);
    setFloat32(vd, vp + 2 | 0, u);
    setFloat32(vd, vp + 3 | 0, v);
    setInt32(vd, vp + 4 | 0, colorMul);
    setInt32(vd, vp + 5 | 0, 0);
    this.g85_1[vp / 6 | 0] = toByte(texIndex);
    return 6;
  }
  q8b(x0, y0, x1, y1, x2, y2, x3, y3, tex, colorMul, texIndex) {
    this.r8b(6, 4);
    this.s8b();
    var vp = this.k85_1;
    var vd = this.f85_1;
    vp = vp + this.p8b(vd, vp, x0, y0, tex.l3h(), tex.m3h(), _RGBA___get_value__impl__hhco8v(colorMul), texIndex) | 0;
    vp = vp + this.p8b(vd, vp, x1, y1, tex.n3h(), tex.o3h(), _RGBA___get_value__impl__hhco8v(colorMul), texIndex) | 0;
    vp = vp + this.p8b(vd, vp, x2, y2, tex.p3h(), tex.q3h(), _RGBA___get_value__impl__hhco8v(colorMul), texIndex) | 0;
    vp = vp + this.p8b(vd, vp, x3, y3, tex.r3h(), tex.s3h(), _RGBA___get_value__impl__hhco8v(colorMul), texIndex) | 0;
    this.k85_1 = vp;
    this.l8b(this.m8b() + 4 | 0);
  }
  t8b(x0, y0, x1, y1, x2, y2, x3, y3, tex, colorMul, texIndex, $super) {
    texIndex = texIndex === VOID ? this.m85_1 : texIndex;
    var tmp;
    if ($super === VOID) {
      this.q8b(x0, y0, x1, y1, x2, y2, x3, y3, tex, colorMul, texIndex);
      tmp = Unit_instance;
    } else {
      tmp = $super.q8b.call(this, x0, y0, x1, y1, x2, y2, x3, y3, tex, new RGBA(colorMul), texIndex);
    }
    return tmp;
  }
  u8b(vc) {
    this.l85_1 = this.l85_1 + _addIndices(this, this.i85_1, this.l85_1, vc + 0 | 0, vc + 1 | 0, vc + 2 | 0, vc + 3 | 0, vc + 0 | 0, vc + 2 | 0) | 0;
  }
  s8b(vc, $super) {
    vc = vc === VOID ? this.m8b() : vc;
    var tmp;
    if ($super === VOID) {
      this.u8b(vc);
      tmp = Unit_instance;
    } else {
      tmp = $super.u8b.call(this, vc);
    }
    return tmp;
  }
  v8b(array, matrix, vcount, icount, texIndex) {
    this.r8b(icount, vcount);
    var i16 = this.i85_1;
    var ip = this.l85_1;
    var vc = this.m8b();
    var arrayIndices = array.w8b_1;
    // Inline function 'kotlin.math.min' call
    var b = array.z8b_1;
    var icount_0 = Math.min(icount, b);
    arraycopy_5(asUShortArrayInt(arrayIndices), 0, i16, ip, icount_0);
    arrayadd(i16, toShort(vc), ip, ip + icount_0 | 0);
    var vp = this.k85_1;
    var src = get_i32(array.a8c_1);
    var dst = get_i32(this.f85_1);
    arraycopy_6(src, 0, dst, vp, imul(vcount, 6));
    var vp6 = this.k85_1 / 6 | 0;
    arrayfill(this.g85_1, toByte(texIndex), vp6, vp6 + vcount | 0);
    if (matrix.c26()) {
      applyMatrix(this, matrix, this.k85_1, vcount);
    }
    this.j85_1 = this.j85_1 + vcount | 0;
    this.k85_1 = this.k85_1 + imul(vcount, 6) | 0;
    this.l85_1 = this.l85_1 + icount_0 | 0;
  }
  d8c(array, matrix, vcount, icount, texIndex, $super) {
    vcount = vcount === VOID ? array.y8b_1 : vcount;
    icount = icount === VOID ? array.z8b_1 : icount;
    texIndex = texIndex === VOID ? this.m85_1 : texIndex;
    var tmp;
    if ($super === VOID) {
      this.v8b(array, matrix, vcount, icount, texIndex);
      tmp = Unit_instance;
    } else {
      tmp = $super.v8b.call(this, array, matrix, vcount, icount, texIndex);
    }
    return tmp;
  }
  r8b(indices, vertices) {
    if (indices === 0 && vertices === 0)
      return false;
    var doFlush = !checkAvailable(this, indices, vertices);
    if (doFlush) {
      this.e8c();
    }
    if (!checkAvailable(this, indices, vertices)) {
      // Inline function 'kotlin.error' call
      var message = 'Too much vertices: indices=' + indices + ', vertices=' + vertices;
      throw IllegalStateException.z4(toString(message));
    }
    return doFlush;
  }
  f8c(tex, smoothing, blendMode, program, icount, vcount) {
    $l$block: {
      // Inline function 'korlibs.korge.render.BatchBuilder2D.setStateFast' call
      var tex_0 = tex.y88_1;
      this.r8b(icount, vcount);
      var pprogram = program == null ? Companion_getInstance_71().a8b_1 : program;
      if (this.g8c(tex_0, smoothing, blendMode, pprogram)) {
        break $l$block;
      }
      this.i8b();
      if (!contains_0(this.n85_1, tex_0)) {
        this.m85_1 = 0;
        this.n85_1[0] = tex_0;
      }
      this.o85_1 = smoothing;
      this.p85_1 = blendMode;
      this.q85_1 = pprogram;
    }
  }
  h8c(tex) {
    // Inline function 'korlibs.datastructure.iterators.fastForEach' call
    var this_0 = this.n85_1;
    var n = 0;
    while (n < this_0.length) {
      // Inline function 'korlibs.korge.render.BatchBuilder2D.hasTex.<anonymous>' call
      var _unary__edvuaz = n;
      n = _unary__edvuaz + 1 | 0;
      if (this_0[_unary__edvuaz] === tex)
        return true;
    }
    return false;
  }
  g8c(tex, smoothing, blendMode, program) {
    var hasTex = this.h8c(tex);
    if (!(this.n85_1[0] === null) && !hasTex) {
      var inductionVariable = 1;
      var last = this.n85_1.length;
      if (inductionVariable < last)
        $l$loop: do {
          var n = inductionVariable;
          inductionVariable = inductionVariable + 1 | 0;
          if (this.n85_1[n] === null) {
            this.n85_1[n] = tex;
            hasTex = true;
            break $l$loop;
          }
        }
         while (inductionVariable < last);
    }
    var inductionVariable_0 = 0;
    var last_0 = this.n85_1.length - 1 | 0;
    if (inductionVariable_0 <= last_0)
      $l$loop_0: do {
        var n_0 = inductionVariable_0;
        inductionVariable_0 = inductionVariable_0 + 1 | 0;
        if (tex === this.n85_1[n_0]) {
          this.m85_1 = n_0;
          break $l$loop_0;
        }
      }
       while (inductionVariable_0 <= last_0);
    return hasTex && this.o85_1 === smoothing && this.p85_1 === blendMode && this.q85_1 === program;
  }
  i8c(tex, smoothing, blendMode, program, icount, vcount) {
    this.f8c(this.b85_1.b8a(tex), smoothing, blendMode, program, icount, vcount);
  }
  j8c(tex, smoothing, blendMode, program, icount, vcount) {
    this.f8c(this.b85_1.c8a(tex).o3f_1, smoothing, blendMode, program, icount, vcount);
  }
  k8c(tex, x, y, width, height, m, filtering, colorMul, blendMode, program) {
    return this.l8c(tex, x, y, width, height, m, filtering, colorMul, blendMode, program, Unit_instance);
  }
  e86(tex, x, y, width, height, m, filtering, colorMul, blendMode, program, $super) {
    x = x === VOID ? 0.0 : x;
    y = y === VOID ? 0.0 : y;
    width = width === VOID ? tex.z2i() : width;
    height = height === VOID ? tex.a2j() : height;
    m = m === VOID ? Companion_getInstance_7().g29_1 : m;
    filtering = filtering === VOID ? true : filtering;
    colorMul = colorMul === VOID ? Colors_getInstance().e41_1 : colorMul;
    blendMode = blendMode === VOID ? Companion_getInstance_68().v82_1 : blendMode;
    program = program === VOID ? null : program;
    var tmp;
    if ($super === VOID) {
      this.k8c(tex, x, y, width, height, m, filtering, colorMul, blendMode, program);
      tmp = Unit_instance;
    } else {
      tmp = $super.k8c.call(this, tex, x, y, width, height, m, filtering, new RGBA(colorMul), blendMode, program);
    }
    return tmp;
  }
  l8c(tex, x, y, width, height, m, filtering, colorMul, blendMode, program, unit) {
    this.f8c(tex.x3g(), filtering, blendMode, program, 6, 4);
    this.m8c(x, y, width, height, m, tex, colorMul);
  }
  m8c(x, y, width, height, m, tex, colorMul) {
    var x0 = x;
    var x1 = x + width;
    var y0 = y;
    var y1 = y + height;
    this.t8b(m.z29(x0, y0), m.a2a(x0, y0), m.z29(x1, y0), m.a2a(x1, y0), m.z29(x1, y1), m.a2a(x1, y1), m.z29(x0, y1), m.a2a(x0, y1), tex, colorMul);
  }
  n8c() {
    this.r85_1.s2q_1.d8b_1.p6m(this.h85_1, 0, imul(this.l85_1, 2));
  }
  o8c() {
    this.x84_1.o8c();
    var inductionVariable = 0;
    var last = this.z84_1;
    if (inductionVariable < last)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var info = Companion_getInstance_40().a6q(VOID, this.o85_1);
        this.x84_1.z83_1.b6n(Companion_getInstance_71().r8a_1[n], this.n85_1[n], info);
      }
       while (inductionVariable < last);
  }
  i8b() {
    if (this.z85_1 === this.l85_1)
      return Unit_instance;
    this.o8c();
    this.a86_1 = this.a86_1 + 1 | 0;
    // Inline function 'kotlin.collections.plusAssign' call
    var this_0 = this.y85_1;
    var tmp0_frameBuffer = this.x84_1.t84_1.t6i_1;
    var tmp1_frameBufferInfo = this.x84_1.t84_1.z6k();
    var tmp2_vertexData = this.r85_1.s2q_1.e8b_1;
    var tmp3_indices = this.r85_1.s2q_1.d8b_1;
    var tmp4_program = this.q85_1;
    var tmp5_drawType = Companion_getInstance_41().y6s_1;
    var tmp6_blending = this.p85_1.f86_1;
    var tmp7_uniformBlocks = this.x84_1.p8c(this.q85_1, false);
    var tmp8_textureUnits = this.x84_1.z83_1.wx();
    var tmp9_stencilOpFunc = this.t85_1;
    var tmp10_stencilRef = this.s85_1;
    var tmp11_colorMask = this.u85_1;
    var tmp12_scissor = this.v85_1;
    var tmp13_drawOffset = imul(this.z85_1, 2);
    var tmp14_vertexCount = this.l85_1 - this.z85_1 | 0;
    var element = new AGBatch(tmp0_frameBuffer, tmp1_frameBufferInfo, tmp2_vertexData, tmp3_indices, VOID, tmp4_program, tmp7_uniformBlocks, tmp8_textureUnits, tmp6_blending, tmp9_stencilOpFunc, tmp10_stencilRef, tmp11_colorMask, VOID, tmp12_scissor, VOID, tmp5_drawType, tmp13_drawOffset, tmp14_vertexCount);
    this_0.h(element);
    this.z85_1 = this.l85_1;
  }
  q8c(uploadVertices, uploadIndices) {
    this.r8c(uploadVertices, uploadIndices);
    var inductionVariable = 0;
    var last = this.z84_1;
    if (inductionVariable < last)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        this.n85_1[n] = null;
      }
       while (inductionVariable < last);
    this.m85_1 = 0;
  }
  j8b(uploadVertices, uploadIndices, $super) {
    uploadVertices = uploadVertices === VOID ? true : uploadVertices;
    uploadIndices = uploadIndices === VOID ? true : uploadIndices;
    var tmp;
    if ($super === VOID) {
      this.q8c(uploadVertices, uploadIndices);
      tmp = Unit_instance;
    } else {
      tmp = $super.q8c.call(this, uploadVertices, uploadIndices);
    }
    return tmp;
  }
  r8c(uploadVertices, uploadIndices) {
    this.i8b();
    // Inline function 'kotlin.collections.isNotEmpty' call
    if (!this.y85_1.g1()) {
      if (uploadVertices) {
        this.r85_1.s2q_1.b8b_1.p6m(this.f85_1, 0, imul(this.k85_1, 4));
        this.r85_1.s2q_1.c8b_1.m6m(this.g85_1, 0, this.k85_1 / 6 | 0);
      }
      if (uploadIndices) {
        this.n8c();
      }
      this.x84_1.s8c();
      draw_0(this.c85_1, new AGMultiBatch(toList(this.y85_1)));
      this.y85_1.l3();
      this.w85_1.i1w(this);
      this.b86_1 = this.b86_1 + 1 | 0;
      this.x84_1.t8c();
      this.r85_1.c1();
    }
    this.l8b(0);
    this.k85_1 = 0;
    this.z85_1 = 0;
    this.l85_1 = 0;
  }
  e8c(uploadVertices, uploadIndices, $super) {
    uploadVertices = uploadVertices === VOID ? true : uploadVertices;
    uploadIndices = uploadIndices === VOID ? true : uploadIndices;
    var tmp;
    if ($super === VOID) {
      this.r8c(uploadVertices, uploadIndices);
      tmp = Unit_instance;
    } else {
      tmp = $super.r8c.call(this, uploadVertices, uploadIndices);
    }
    return tmp;
  }
  u8c(vertexCount) {
    var oldVertexCount = this.m8b();
    this.l8b(vertexCount);
    try {
      this.w85_1.i1w(this);
    }finally {
      this.l8b(oldVertexCount);
    }
  }
}
class BoundsProvider {}
function get_windowToGlobalScaleAvg() {
  return get_scale(this.d8d()).s2b();
}
function get_globalToWindowScaleAvg() {
  return this.h8d().s2b();
}
function windowToGlobalCoords(pos) {
  var tmp$ret$0;
  $l$block: {
    // Inline function 'korlibs.math.geom.Matrix.transform' call
    var this_0 = this.b8d();
    if (this_0.b26()) {
      tmp$ret$0 = pos;
      break $l$block;
    }
    tmp$ret$0 = Vector2D.w27(this_0.y29(pos.m25_1, pos.n25_1), this_0.b2a(pos.m25_1, pos.n25_1));
  }
  return tmp$ret$0;
}
class Base {
  constructor() {
    this.v8c_1 = Companion_getInstance_7().j29();
    this.w8c_1 = MatrixTransform.q2b();
    this.x8c_1 = Companion_getInstance_7().j29();
    this.y8c_1 = MatrixTransform.q2b();
    this.z8c_1 = Companion_getInstance_5().e2e(0, 0, 1280, 720);
  }
  a8d(_set____db54di) {
    this.v8c_1 = _set____db54di;
  }
  b8d() {
    return this.v8c_1;
  }
  c8d(_set____db54di) {
    this.w8c_1 = _set____db54di;
  }
  d8d() {
    return this.w8c_1;
  }
  e8d(_set____db54di) {
    this.x8c_1 = _set____db54di;
  }
  f8d() {
    return this.x8c_1;
  }
  g8d(_set____db54di) {
    this.y8c_1 = _set____db54di;
  }
  h8d() {
    return this.y8c_1;
  }
  i8d(_set____db54di) {
    this.z8c_1 = _set____db54di;
  }
}
class Companion_56 {
  constructor() {
    Companion_instance_65 = this;
    this.m8d_1 = ProgramLayout.q6s([DefaultShaders_getInstance().a6w_1, DefaultShaders_getInstance().c6w_1]);
    var tmp = this;
    // Inline function 'korlibs.graphics.shader.VertexShader' call
    var builder = ProgramBuilderDefault.i70();
    // Inline function 'korlibs.korge.render.Companion.VERTEX.<anonymous>' call
    // Inline function 'kotlin.apply' call
    var this_0 = DefaultShaders_getInstance();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.korge.render.Companion.VERTEX.<anonymous>.<anonymous>' call
    builder.n70(builder.q70(), builder.r70(builder.r70(this_0.a6y(), this_0.b6y()), builder.u70([this_0.a6w_1, builder.t70(0.0), builder.t70(1.0)])));
    builder.n70(this_0.e6w_1, this_0.c6w_1);
    tmp.n8d_1 = VertexShader(builder.v70());
    var tmp_0 = this;
    // Inline function 'korlibs.graphics.shader.FragmentShader' call
    var builder_0 = ProgramBuilderDefault.i70();
    // Inline function 'korlibs.korge.render.Companion.FRAGMENT.<anonymous>' call
    // Inline function 'kotlin.apply' call
    var this_1 = DefaultShaders_getInstance();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.korge.render.Companion.FRAGMENT.<anonymous>.<anonymous>' call
    builder_0.n70(builder_0.q70(), this_1.e6w_1);
    tmp_0.o8d_1 = FragmentShader(builder_0.v70());
    this.p8d_1 = new Program(this.n8d_1, this.o8d_1);
  }
}
class LineRenderBatcher {
  constructor(ctx) {
    Companion_getInstance_72();
    this.q8d_1 = ctx;
    this.r8d_1 = new Signal();
    this.q8d_1.l84_1.b1w(LineRenderBatcher$lambda(this));
    this.s8d_1 = this.q8d_1.q83_1;
    this.t8d_1 = Colors_getInstance().u46_1;
    this.u8d_1 = new AGBuffer();
    this.v8d_1 = AGVertexArrayObject.h6s([new AGVertexData(Companion_getInstance_72().m8d_1, this.u8d_1)], false);
    this.w8d_1 = 1024;
    this.x8d_1 = allocDirect(Companion_instance_4, imul(24, this.w8d_1));
    this.y8d_1 = Matrix4.p2c();
    this.z8d_1 = 0;
    this.a8e_1 = 0;
    this.b8e_1 = Companion_getInstance_68().v82_1;
    this.c8e_1 = Companion_getInstance_7().j29();
  }
  d8e(p0, p1, color0, color1, m) {
    return this.e8e(p0.m25_1, p0.n25_1, p1.m25_1, p1.n25_1, this.t8d_1, color1, m);
  }
  f8e(p0, p1, color0, color1, m, $super) {
    color0 = color0 === VOID ? this.t8d_1 : color0;
    color1 = color1 === VOID ? color0 : color1;
    m = m === VOID ? this.c8e_1 : m;
    var tmp;
    if ($super === VOID) {
      this.d8e(p0, p1, color0, color1, m);
      tmp = Unit_instance;
    } else {
      tmp = $super.d8e.call(this, p0, p1, new RGBA(color0), new RGBA(color1), m);
    }
    return tmp;
  }
  g8e(x0, y0, x1, y1, color0, color1, m) {
    if (this.z8d_1 >= (this.w8d_1 - 2 | 0)) {
      this.qc();
    }
    addVertex(this, x0, y0, color0, m);
    addVertex(this, x1, y1, color1, m);
  }
  h8e(x0, y0, x1, y1, color0, color1, m, $super) {
    color0 = color0 === VOID ? this.t8d_1 : color0;
    color1 = color1 === VOID ? color0 : color1;
    m = m === VOID ? this.c8e_1 : m;
    var tmp;
    if ($super === VOID) {
      this.g8e(x0, y0, x1, y1, color0, color1, m);
      tmp = Unit_instance;
    } else {
      tmp = $super.g8e.call(this, x0, y0, x1, y1, new RGBA(color0), new RGBA(color1), m);
    }
    return tmp;
  }
  e8e(x0, y0, x1, y1, color0, color1, m) {
    return this.g8e(x0, y0, x1, y1, color0, color1, m);
  }
  i8e(path, m) {
    var lastPos = {_v: Vector2D.h28()};
    // Inline function 'korlibs.math.geom.shape.emitPoints2' call
    var i = Vector2D.h28();
    var l = Vector2D.h28();
    // Inline function 'korlibs.math.geom.shape.emitPoints2.<anonymous>' call
    // Inline function 'korlibs.math.geom.vector.VectorPath.visitCmds' call
    var n = 0;
    // Inline function 'korlibs.datastructure.iterators.fastForEach' call
    var this_0 = path.t3d_1;
    var n_0 = 0;
    while (n_0 < this_0.e1()) {
      // Inline function 'korlibs.math.geom.vector.VectorPath.visitCmds.<anonymous>' call
      var _unary__edvuaz = n_0;
      n_0 = _unary__edvuaz + 1 | 0;
      switch (this_0.ux(_unary__edvuaz)) {
        case 0:
          // Inline function 'korlibs.math.geom.shape.emitPoints2.<anonymous>' call

          var _unary__edvuaz_0 = n;
          n = _unary__edvuaz_0 + 1 | 0;
          var tmp = path.u3d_1.d1(_unary__edvuaz_0);
          var _unary__edvuaz_1 = n;
          n = _unary__edvuaz_1 + 1 | 0;
          var it = Vector2D.w27(tmp, path.u3d_1.d1(_unary__edvuaz_1));
          i = it;
          // Inline function 'korlibs.korge.render.LineRenderBatcher.drawVector.<anonymous>' call

          if (!true) {
            this.f8e(lastPos._v, it, VOID, VOID, m);
          }

          lastPos._v = it;
          l = it;
          break;
        case 1:
          // Inline function 'korlibs.math.geom.shape.emitPoints2.<anonymous>' call

          var _unary__edvuaz_2 = n;
          n = _unary__edvuaz_2 + 1 | 0;
          var tmp_0 = path.u3d_1.d1(_unary__edvuaz_2);
          var _unary__edvuaz_3 = n;
          n = _unary__edvuaz_3 + 1 | 0;
          var it_0 = Vector2D.w27(tmp_0, path.u3d_1.d1(_unary__edvuaz_3));
          // Inline function 'korlibs.korge.render.LineRenderBatcher.drawVector.<anonymous>' call

          if (!false) {
            this.f8e(lastPos._v, it_0, VOID, VOID, m);
          }

          lastPos._v = it_0;
          l = it_0;
          // Inline function 'korlibs.math.geom.shape.emitPoints2.<anonymous>' call

          break;
        case 2:
          // Inline function 'korlibs.math.geom.shape.emitPoints2.<anonymous>' call

          var _unary__edvuaz_4 = n;
          n = _unary__edvuaz_4 + 1 | 0;
          var tmp_1 = path.u3d_1.d1(_unary__edvuaz_4);
          var _unary__edvuaz_5 = n;
          n = _unary__edvuaz_5 + 1 | 0;
          var c = Vector2D.w27(tmp_1, path.u3d_1.d1(_unary__edvuaz_5));
          var _unary__edvuaz_6 = n;
          n = _unary__edvuaz_6 + 1 | 0;
          var tmp_2 = path.u3d_1.d1(_unary__edvuaz_6);
          var _unary__edvuaz_7 = n;
          n = _unary__edvuaz_7 + 1 | 0;
          var a = Vector2D.w27(tmp_2, path.u3d_1.d1(_unary__edvuaz_7));
          var sum = Companion_getInstance_4().d2h(l, c) + Companion_getInstance_4().d2h(c, a);
          // Inline function 'korlibs.math.geom.shape.approximateCurve' call

          // Inline function 'kotlin.math.max' call

          var a_0 = numberToInt(sum);
          var rcurveSteps = Math.max(a_0, 20);
          var dt = 1.0 / rcurveSteps;
          var lastPos_0 = {_v: Vector2D.h28()};
          var prevPos = {_v: Vector2D.h28()};
          var emittedCount = {_v: 0};
          // Inline function 'korlibs.math.geom.shape.emitPoints2.<anonymous>.<anonymous>' call

          var ratio = Companion_getInstance_10().ox_1;
          // Inline function 'korlibs.math.geom.shape.approximateCurve.<anonymous>' call

          lastPos_0._v = Companion_getInstance_13().q3b(l, c, a, ratio);
          var nStart = false ? 0 : 1;
          var nEnd = true ? rcurveSteps : rcurveSteps - 1 | 0;
          var inductionVariable = nStart;
          if (inductionVariable <= nEnd)
            do {
              var n_1 = inductionVariable;
              inductionVariable = inductionVariable + 1 | 0;
              var ratio_0 = _Ratio___init__impl__9mwvn2(n_1 * dt);
              // Inline function 'korlibs.math.geom.shape.emitPoints2.<anonymous>.<anonymous>' call
              // Inline function 'korlibs.math.geom.shape.approximateCurve.<anonymous>' call
              var it_1 = Companion_getInstance_13().q3b(l, c, a, ratio_0);
              // Inline function 'korlibs.math.geom.shape.emitPoints2.<anonymous>.<anonymous>' call
              // Inline function 'korlibs.korge.render.LineRenderBatcher.drawVector.<anonymous>' call
              if (!false) {
                this.f8e(lastPos._v, it_1, VOID, VOID, m);
              }
              lastPos._v = it_1;
              emittedCount._v = emittedCount._v + 1 | 0;
              lastPos_0._v = prevPos._v;
              prevPos._v = it_1;
            }
             while (!(n_1 === nEnd));
          l = a;
          // Inline function 'korlibs.math.geom.shape.emitPoints2.<anonymous>' call

          break;
        case 3:
          // Inline function 'korlibs.math.geom.shape.emitPoints2.<anonymous>' call

          var _unary__edvuaz_8 = n;
          n = _unary__edvuaz_8 + 1 | 0;
          var tmp_3 = path.u3d_1.d1(_unary__edvuaz_8);
          var _unary__edvuaz_9 = n;
          n = _unary__edvuaz_9 + 1 | 0;
          var c0 = Vector2D.w27(tmp_3, path.u3d_1.d1(_unary__edvuaz_9));
          var _unary__edvuaz_10 = n;
          n = _unary__edvuaz_10 + 1 | 0;
          var tmp_4 = path.u3d_1.d1(_unary__edvuaz_10);
          var _unary__edvuaz_11 = n;
          n = _unary__edvuaz_11 + 1 | 0;
          var c1 = Vector2D.w27(tmp_4, path.u3d_1.d1(_unary__edvuaz_11));
          var _unary__edvuaz_12 = n;
          n = _unary__edvuaz_12 + 1 | 0;
          var tmp_5 = path.u3d_1.d1(_unary__edvuaz_12);
          var _unary__edvuaz_13 = n;
          n = _unary__edvuaz_13 + 1 | 0;
          var a_1 = Vector2D.w27(tmp_5, path.u3d_1.d1(_unary__edvuaz_13));
          var sum_0 = Companion_getInstance_4().d2h(l, c0) + Companion_getInstance_4().d2h(c0, c1) + Companion_getInstance_4().d2h(c1, a_1);
          // Inline function 'korlibs.math.geom.shape.approximateCurve' call

          // Inline function 'kotlin.math.max' call

          var a_2 = numberToInt(sum_0);
          var rcurveSteps_0 = Math.max(a_2, 20);
          var dt_0 = 1.0 / rcurveSteps_0;
          var lastPos_1 = {_v: Vector2D.h28()};
          var prevPos_0 = {_v: Vector2D.h28()};
          var emittedCount_0 = {_v: 0};
          // Inline function 'korlibs.math.geom.shape.emitPoints2.<anonymous>.<anonymous>' call

          var ratio_1 = Companion_getInstance_10().ox_1;
          // Inline function 'korlibs.math.geom.shape.approximateCurve.<anonymous>' call

          lastPos_1._v = Companion_getInstance_13().p3b(l, c0, c1, a_1, ratio_1);
          var nStart_0 = false ? 0 : 1;
          var nEnd_0 = true ? rcurveSteps_0 : rcurveSteps_0 - 1 | 0;
          var inductionVariable_0 = nStart_0;
          if (inductionVariable_0 <= nEnd_0)
            do {
              var n_2 = inductionVariable_0;
              inductionVariable_0 = inductionVariable_0 + 1 | 0;
              var ratio_2 = _Ratio___init__impl__9mwvn2(n_2 * dt_0);
              // Inline function 'korlibs.math.geom.shape.emitPoints2.<anonymous>.<anonymous>' call
              // Inline function 'korlibs.math.geom.shape.approximateCurve.<anonymous>' call
              var it_2 = Companion_getInstance_13().p3b(l, c0, c1, a_1, ratio_2);
              // Inline function 'korlibs.math.geom.shape.emitPoints2.<anonymous>.<anonymous>' call
              // Inline function 'korlibs.korge.render.LineRenderBatcher.drawVector.<anonymous>' call
              if (!false) {
                this.f8e(lastPos._v, it_2, VOID, VOID, m);
              }
              lastPos._v = it_2;
              emittedCount_0._v = emittedCount_0._v + 1 | 0;
              lastPos_1._v = prevPos_0._v;
              prevPos_0._v = it_2;
            }
             while (!(n_2 === nEnd_0));
          l = a_1;
          // Inline function 'korlibs.math.geom.shape.emitPoints2.<anonymous>' call

          break;
        case 4:
          // Inline function 'korlibs.math.geom.shape.emitPoints2.<anonymous>' call

          // Inline function 'korlibs.korge.render.LineRenderBatcher.drawVector.<anonymous>' call

          var p = i;
          if (!false) {
            this.f8e(lastPos._v, p, VOID, VOID, m);
          }

          lastPos._v = p;
          // Inline function 'korlibs.math.geom.shape.emitPoints2.<anonymous>' call

          // Inline function 'korlibs.math.geom.shape.emitPoints2.<anonymous>' call

          break;
      }
    }
    // Inline function 'korlibs.math.geom.shape.emitPoints2.<anonymous>' call
  }
  qc() {
    if (this.z8d_1 > 0) {
      this.r8d_1.i1w(this);
      this.u8d_1.p6m(this.x8d_1, 0, imul(this.a8e_1, 4));
      this.q8d_1.o8c();
      var tmp0_$receiver = this.s8d_1;
      var tmp1_frameBuffer = this.q8d_1.t84_1;
      var tmp2_vertexData = this.v8d_1;
      var tmp3_program = Companion_getInstance_72().p8d_1;
      var tmp4_drawType = Companion_getInstance_41().x6s_1;
      var tmp5_vertexCount = this.z8d_1;
      var tmp6_uniformBlocks = this.q8d_1.j8e(Companion_getInstance_72().p8d_1);
      var tmp7_blending = this.b8e_1.f86_1;
      draw(tmp0_$receiver, tmp1_frameBuffer, tmp2_vertexData, tmp3_program, tmp4_drawType, tmp5_vertexCount, VOID, VOID, VOID, tmp7_blending, tmp6_uniformBlocks);
    }
    this.z8d_1 = 0;
    this.a8e_1 = 0;
  }
}
class FlushKind extends Enum {}
class DeviceDimensionsProvider {}
function get_devicePixelRatio() {
  return 1.0;
}
function get_pixelsPerInch() {
  return 96.0 * this.c8f();
}
function get_pixelsPerLogicalInchRatio() {
  return this.d8f() / 96.0;
}
function get_computedPixelRatio() {
  return this.c8f() * this.e8f();
}
class RenderContext {
  constructor(ag, bp, deviceDimensionsProvider, stats, coroutineContext, batchMaxQuads, windowConfig) {
    bp = bp === VOID ? new Base() : bp;
    var tmp;
    if (deviceDimensionsProvider === VOID) {
      var tmp0_elvis_lhs = isInterface(bp, DeviceDimensionsProvider) ? bp : null;
      tmp = tmp0_elvis_lhs == null ? DEFAULT_instance : tmp0_elvis_lhs;
    } else {
      tmp = deviceDimensionsProvider;
    }
    deviceDimensionsProvider = tmp;
    stats = stats === VOID ? new Stats() : stats;
    coroutineContext = coroutineContext === VOID ? EmptyCoroutineContext_getInstance() : coroutineContext;
    batchMaxQuads = batchMaxQuads === VOID ? Companion_getInstance_71().t8a_1 : batchMaxQuads;
    windowConfig = windowConfig === VOID ? new Impl() : windowConfig;
    this.p83_1 = new Mixin();
    this.q83_1 = ag;
    this.r83_1 = bp;
    this.s83_1 = deviceDimensionsProvider;
    this.t83_1 = stats;
    this.u83_1 = coroutineContext;
    this.v83_1 = batchMaxQuads;
    this.w83_1 = windowConfig;
    this.x83_1 = new BufferCache();
    this.y83_1 = FastIdentityMap();
    this.z83_1 = AGTextureUnits.u6m();
    this.a84_1 = Companion_getInstance_7().j29();
    this.b84_1 = Companion_getInstance_7().j29();
    this.c84_1 = Matrix4.p2c();
    this.d84_1 = Matrix4.p2c();
    this.e84_1 = Companion_getInstance_7().j29();
    this.f84_1 = true;
    var tmp_0 = this;
    tmp_0.g84_1 = Pool.a2q(VOID, RenderContext$tempTexturePool$lambda);
    var tmp_1 = this;
    tmp_1.h84_1 = lazy(RenderContext$projViewMatUB$delegate$lambda(this));
    this.i84_1 = new AgAutoFreeManager();
    this.j84_1 = new AgBitmapTextureManager(this.q83_1);
    this.k84_1 = new AgBufferManager(this.q83_1);
    this.l84_1 = new Signal();
    this.m84_1 = 1.0;
    this.n84_1 = Colors_getInstance().e41_1;
    this.o84_1 = new BatchBuilder2D(this, this.v83_1);
    var tmp_2 = this;
    tmp_2.p84_1 = Pool.a2q(VOID, RenderContext$dynamicVertexBufferPool$lambda);
    this.q84_1 = new RenderContext2D(this.o84_1, this.j84_1);
    this.r84_1 = true;
    this.s84_1 = null;
    this.t84_1 = this.q83_1.h6j();
    this.u84_1 = LinkedHashSet.j1();
    var tmp_3 = this;
    tmp_3.v84_1 = Pool.a2q(VOID, RenderContext$frameBuffers$lambda);
    this.w84_1 = FastArrayList.sy();
  }
  k8e() {
    return this.w83_1.k8e();
  }
  t8c() {
  }
  l8e() {
    // Inline function 'kotlin.getValue' call
    var this_0 = this.h84_1;
    projViewMatUB$factory();
    return this_0.u1();
  }
  o8c() {
    if (this.f84_1 && this.t84_1.t6n()) {
      this.c84_1 = ortho(Companion_getInstance_6(), Companion_getInstance_5().i2e(0, this.t84_1.b6j_1, this.t84_1.a6j_1, 0), -1.0, 1.0);
    } else {
      this.c84_1 = ortho(Companion_getInstance_6(), Companion_getInstance_5().i2e(0, 0, this.t84_1.a6j_1, this.t84_1.b6j_1), -1.0, 1.0);
      this.c84_1 = this.c84_1.m2d(toMatrix4(this.a84_1));
    }
    $l$block: {
      // Inline function 'korlibs.graphics.shader.UniformBlockBuffer.push' call
      var this_0 = this.l8e();
      var _unary__edvuaz = this_0.c6s();
      this_0.f7f(_unary__edvuaz + 1 | 0);
      this_0.g7f(this_0.c6s() + 1 | 0);
      var blockSize = this_0.g6q_1;
      var index0 = imul(this_0.c6s() - 1 | 0, blockSize);
      var index1 = imul(this_0.c6s(), blockSize);
      var texBlockSize = this_0.d6q_1.c6y().e1();
      var texIndex0 = imul(this_0.c6s() - 1 | 0, texBlockSize);
      var texIndex1 = imul(this_0.c6s(), texBlockSize);
      if (this_0.c6s() > 0) {
        arraycopy_0(this_0.i6q_1, index0, this_0.i6q_1, index1, blockSize);
      } else {
        arrayfill_0(this_0.i6q_1, 0, 0, blockSize);
      }
      // Inline function 'korlibs.korge.render.RenderContext.updateStandardUniforms.<anonymous>' call
      var $this$push = this_0.d6q_1;
      var it = this_0.j6q_1;
      it.v7f($this$push.a6y(), this.c84_1);
      it.v7f($this$push.b6y(), this.d84_1);
      if (true && this_0.c6s() >= 1) {
        var equals = arrayequal(this_0.i6q_1, index0, this_0.i6q_1, index1, blockSize);
        if (equals) {
          var _unary__edvuaz_0 = this_0.c6s();
          this_0.f7f(_unary__edvuaz_0 - 1 | 0);
          break $l$block;
        }
      }
    }
  }
  m8e() {
    return coerceAtLeast_0(round(this.n8e() * this.m84_1), 1.0);
  }
  o8e(kind) {
    this.l84_1.i1w(kind);
  }
  c86(kind, $super) {
    kind = kind === VOID ? FlushKind_FULL_getInstance() : kind;
    var tmp;
    if ($super === VOID) {
      this.o8e(kind);
      tmp = Unit_instance;
    } else {
      tmp = $super.o8e.call(this, kind);
    }
    return tmp;
  }
  p8e() {
    var tmp0_elvis_lhs = this.t84_1;
    return tmp0_elvis_lhs == null ? this.h6j() : tmp0_elvis_lhs;
  }
  q8e() {
    return this.p8e() === this.h6j();
  }
  h6j() {
    return this.q83_1.h6j();
  }
  r8e(color, depth, stencil, clearColor, clearDepth, clearStencil, scissor) {
    this.q83_1.m6j(this.t84_1.t6i_1, this.t84_1.z6k(), color, depth, stencil, clearColor, clearDepth, clearStencil, scissor);
  }
  s8e(color, depth, stencil, clearColor, clearDepth, clearStencil, scissor, $super) {
    color = color === VOID ? Colors_getInstance().j41_1 : color;
    depth = depth === VOID ? 1.0 : depth;
    stencil = stencil === VOID ? 0 : stencil;
    clearColor = clearColor === VOID ? true : clearColor;
    clearDepth = clearDepth === VOID ? true : clearDepth;
    clearStencil = clearStencil === VOID ? true : clearStencil;
    scissor = scissor === VOID ? Companion_getInstance_44().t6k_1 : scissor;
    var tmp;
    if ($super === VOID) {
      this.r8e(color, depth, stencil, clearColor, clearDepth, clearStencil, scissor);
      tmp = Unit_instance;
    } else {
      tmp = $super.r8e.call(this, new RGBA(color), depth, stencil, clearColor, clearDepth, clearStencil, scissor);
    }
    return tmp;
  }
  j6j() {
    this.q83_1.j6j();
    this.v84_1.f2q(this.u84_1);
    // Inline function 'kotlin.collections.isNotEmpty' call
    if (!this.u84_1.g1()) {
      this.u84_1.l3();
    }
  }
  d86(bmp) {
    return this.j84_1.c8a(bmp);
  }
  t8e(bmp) {
    return this.j84_1.d8a(bmp);
  }
  n8a(buffer) {
    return this.k84_1.n8a(buffer);
  }
  u8e(closeable) {
    return this.i84_1.s88(closeable);
  }
  v8e() {
    this.o84_1.n8b();
  }
  e8a() {
    this.c86();
    this.j6j();
    this.o84_1.t88();
    this.i84_1.t88();
    this.j84_1.e8a();
    this.k84_1.t88();
  }
  f6() {
    this.j84_1.f6();
    this.i84_1.f6();
  }
  w8e(width, height, hasDepth, hasStencil, msamples, onlyThisFrame) {
    // Inline function 'kotlin.math.max' call
    var realWidth = Math.max(width, 64);
    // Inline function 'kotlin.math.max' call
    var realHeight = Math.max(height, 64);
    var rb = this.v84_1.c2q();
    if (onlyThisFrame) {
      // Inline function 'kotlin.collections.plusAssign' call
      this.u84_1.h(rb);
    }
    rb.f6o(0, 0, realWidth, realHeight, realWidth, realHeight);
    rb.w6o(hasDepth, hasStencil);
    rb.v6o(msamples);
    return rb;
  }
  x8e(width, height, hasDepth, hasStencil, msamples, onlyThisFrame, $super) {
    hasDepth = hasDepth === VOID ? false : hasDepth;
    hasStencil = hasStencil === VOID ? true : hasStencil;
    msamples = msamples === VOID ? 1 : msamples;
    onlyThisFrame = onlyThisFrame === VOID ? true : onlyThisFrame;
    return $super === VOID ? this.w8e(width, height, hasDepth, hasStencil, msamples, onlyThisFrame) : $super.w8e.call(this, width, height, hasDepth, hasStencil, msamples, onlyThisFrame);
  }
  y8e(rb) {
    this.u84_1.m3(rb);
    this.v84_1.d2q(rb);
  }
  z8e(frameBuffer) {
    this.w84_1.h(this.t84_1);
    this.t84_1 = frameBuffer;
  }
  a8f() {
    this.t84_1 = this.w84_1.p3(this.w84_1.e1() - 1 | 0);
  }
  n6q(uniformBlock) {
    return this.x83_1.n6q(uniformBlock);
  }
  b8f(program) {
    var tmp$ret$0;
    $l$block: {
      // Inline function 'korlibs.datastructure.getOrPut' call
      var this_0 = this.y83_1;
      var res = get_0(this_0, program);
      if (!(res == null)) {
        tmp$ret$0 = res;
        break $l$block;
      }
      // Inline function 'korlibs.korge.render.RenderContext.get.<anonymous>' call
      var out = new AGProgramWithUniforms(program, this.x83_1);
      set(this_0, program, out);
      tmp$ret$0 = out;
    }
    return tmp$ret$0;
  }
  p8c(program, autoUpload) {
    if (autoUpload) {
      this.s8c();
    }
    return this.b8f(program).b6s();
  }
  j8e(program, autoUpload, $super) {
    autoUpload = autoUpload === VOID ? true : autoUpload;
    return $super === VOID ? this.p8c(program, autoUpload) : $super.p8c.call(this, program, autoUpload);
  }
  s8c() {
    this.x83_1.l6q();
  }
  ay(value) {
    this.p83_1.ay(value);
  }
  by() {
    return this.p83_1.by();
  }
  a8d(_set____db54di) {
    this.r83_1.a8d(_set____db54di);
  }
  b8d() {
    return this.r83_1.b8d();
  }
  c8d(_set____db54di) {
    this.r83_1.c8d(_set____db54di);
  }
  d8d() {
    return this.r83_1.d8d();
  }
  e8d(_set____db54di) {
    this.r83_1.e8d(_set____db54di);
  }
  f8d() {
    return this.r83_1.f8d();
  }
  g8d(_set____db54di) {
    this.r83_1.g8d(_set____db54di);
  }
  h8d() {
    return this.r83_1.h8d();
  }
  i8d(_set____db54di) {
    this.r83_1.i8d(_set____db54di);
  }
  j8d() {
    return this.r83_1.j8d();
  }
  k8d() {
    return this.r83_1.k8d();
  }
  l8d(pos) {
    return this.r83_1.l8d(pos);
  }
  o6j() {
    return this.q83_1.o6j();
  }
  p6j() {
    return this.q83_1.p6j();
  }
  q6j() {
    return this.q83_1.q6j();
  }
  c8f() {
    return this.s83_1.c8f();
  }
  d8f() {
    return this.s83_1.d8f();
  }
  e8f() {
    return this.s83_1.e8f();
  }
  n8e() {
    return this.s83_1.n8e();
  }
}
class RenderContext2D {
  constructor(batch, agBitmapTextureManager) {
    this.f8f_1 = new Mixin();
    this.g8f_1 = batch;
    this.h8f_1 = agBitmapTextureManager;
    // Inline function 'korlibs.logger.Logger.trace' call
    var this_0 = get_logger_0();
    var level = Level_TRACE_getInstance();
    var tmp;
    if (this_0.a2u(level)) {
      // Inline function 'korlibs.korge.render.RenderContext2D.<anonymous>' call
      var tmp$ret$0 = 'RenderContext2D[0]';
      this_0.b2u(level, tmp$ret$0);
      tmp = Unit_instance;
    }
    this.i8f_1 = Size2D.t26(0, 0);
    var tmp_0 = this;
    tmp_0.j8f_1 = Pool.a2q(VOID, RenderContext2D$mpool$lambda);
    // Inline function 'korlibs.logger.Logger.trace' call
    var this_1 = get_logger_0();
    var level_0 = Level_TRACE_getInstance();
    var tmp_1;
    if (this_1.a2u(level_0)) {
      // Inline function 'korlibs.korge.render.RenderContext2D.<anonymous>' call
      var tmp$ret$2 = 'RenderContext2D[1]';
      this_1.b2u(level_0, tmp$ret$2);
      tmp_1 = Unit_instance;
    }
    this.k8f_1 = Companion_getInstance_7().g29_1;
    this.l8f_1 = Companion_getInstance_68().v82_1;
    this.m8f_1 = Colors_getInstance().e41_1;
    this.n8f_1 = true;
    // Inline function 'korlibs.logger.Logger.trace' call
    var this_2 = get_logger_0();
    var level_1 = Level_TRACE_getInstance();
    var tmp_2;
    if (this_2.a2u(level_1)) {
      // Inline function 'korlibs.korge.render.RenderContext2D.<anonymous>' call
      var tmp$ret$4 = 'RenderContext2D[2]';
      this_2.b2u(level_1, tmp$ret$4);
      tmp_2 = Unit_instance;
    }
  }
  h65() {
    return this.g8f_1.x84_1;
  }
  o8f(matrix) {
    this.k8f_1 = matrix;
  }
  p8f(rect, color, filtering, bmp, program) {
    var tmp0_$this = this.g8f_1;
    // Inline function 'korlibs.korge.render.RenderContext2D.getTexture' call
    var tmp1_tex = this.h8f_1.c8a(bmp);
    var tmp2_x = rect.w25_1;
    var tmp3_y = rect.x25_1;
    var tmp4_width = rect.y25_1;
    var tmp5_height = rect.z25_1;
    var tmp6_m = this.k8f_1;
    var tmp7_blendMode = this.l8f_1;
    tmp0_$this.k8c(tmp1_tex, tmp2_x, tmp3_y, tmp4_width, tmp5_height, tmp6_m, filtering, color, tmp7_blendMode, program);
  }
  q8f(rect, color, filtering, bmp, program, $super) {
    color = color === VOID ? this.m8f_1 : color;
    filtering = filtering === VOID ? this.n8f_1 : filtering;
    var tmp;
    if (bmp === VOID) {
      // Inline function 'korlibs.image.bitmap.Bitmaps.white' call
      tmp = get_Bitmaps_white();
    } else {
      tmp = bmp;
    }
    bmp = tmp;
    program = program === VOID ? null : program;
    var tmp_0;
    if ($super === VOID) {
      this.p8f(rect, color, filtering, bmp, program);
      tmp_0 = Unit_instance;
    } else {
      tmp_0 = $super.p8f.call(this, rect, new RGBA(color), filtering, bmp, program);
    }
    return tmp_0;
  }
  r8f(x, y, width, height, program, padding) {
    var ctx = this.g8f_1.x84_1;
    // Inline function 'korlibs.korge.render.RenderContext.useBatcher' call
    // Inline function 'korlibs.korge.render.BatchBuilder2D.use' call
    var this_0 = ctx.o84_1;
    var this_1 = this_0.x84_1;
    if (!(this_1.s84_1 === this_0)) {
      this_1.s84_1 = this_0;
      this_1.c86();
    }
    var L = x - padding.s28_1;
    var T = y - padding.p28_1;
    var R = width + padding.w28();
    var B = height + padding.x28();
    var l = -padding.s28_1;
    var t = -padding.p28_1;
    var r = width + padding.q28_1;
    var b = height + padding.r28_1;
    // Inline function 'korlibs.korge.render.Companion.QUAD_INDICES' call
    Companion_getInstance_73();
    var tmp$ret$0 = get_TEXTURED_ARRAY_QUAD_INDICES();
    var vertices = new TexturedVertexArray(6, tmp$ret$0);
    vertices.s8f(0, L, T, R, B, this.k8f_1, l, t, r, t, l, b, r, b, this.m8f_1);
    // Inline function 'korlibs.image.bitmap.Bitmaps.white' call
    var tmp$ret$1 = get_Bitmaps_white();
    this_0.j8c(tmp$ret$1, this.n8f_1, this.l8f_1, program, 6, 4);
    this_0.d8c(vertices, Companion_getInstance_7().h29_1);
    ctx.o8e(FlushKind_STATE_getInstance());
  }
  t8f(scissor) {
    var tmp$ret$0;
    $l$block: {
      // Inline function 'korlibs.math.geom.Matrix.transform' call
      var this_0 = this.k8f_1;
      var p = Vector2D.j28(scissor.d26(), scissor.f26());
      if (this_0.b26()) {
        tmp$ret$0 = p;
        break $l$block;
      }
      tmp$ret$0 = Vector2D.w27(this_0.y29(p.m25_1, p.n25_1), this_0.b2a(p.m25_1, p.n25_1));
    }
    var tl = tmp$ret$0;
    var tmp$ret$1;
    $l$block_0: {
      // Inline function 'korlibs.math.geom.Matrix.transform' call
      var this_1 = this.k8f_1;
      var p_0 = Vector2D.j28(scissor.e26(), scissor.g26());
      if (this_1.b26()) {
        tmp$ret$1 = p_0;
        break $l$block_0;
      }
      tmp$ret$1 = Vector2D.w27(this_1.y29(p_0.m25_1, p_0.n25_1), this_1.b2a(p_0.m25_1, p_0.n25_1));
    }
    var br = tmp$ret$1;
    return Companion_getInstance_44().c6u(tl.m25_1, tl.n25_1, br.m25_1, br.n25_1);
  }
  ay(value) {
    this.f8f_1.ay(value);
  }
  by() {
    return this.f8f_1.by();
  }
}
class SDFShaders extends Builder {
  static m8g() {
    SDFShaders_instance = null;
    var $this = this.d71();
    SDFShaders_instance = $this;
    var tmp = $this;
    var tmp_0 = $this.d72();
    var tmp_1 = $this.d72();
    var tmp_2 = $this.d72();
    var tmp_3 = $this.d72();
    tmp.w8f_1 = $this.o71(tmp_0, tmp_1, tmp_2, VOID, tmp_3, SDFShaders$opInterpolate$delegate$lambda).q6y($this, opInterpolate$factory());
    var tmp_4 = $this;
    var tmp_5 = $this.d72();
    var tmp_6 = $this.d72();
    var tmp_7 = $this.d72();
    tmp_4.x8f_1 = $this.m71(tmp_5, tmp_6, VOID, tmp_7, SDFShaders$opUnion$delegate$lambda).q6y($this, opUnion$factory());
    var tmp_8 = $this;
    var tmp_9 = $this.d72();
    var tmp_10 = $this.d72();
    var tmp_11 = $this.d72();
    tmp_8.y8f_1 = $this.m71(tmp_9, tmp_10, VOID, tmp_11, SDFShaders$opIntersect$delegate$lambda).q6y($this, opIntersect$factory());
    var tmp_12 = $this;
    var tmp_13 = $this.d72();
    var tmp_14 = $this.d72();
    var tmp_15 = $this.d72();
    tmp_12.z8f_1 = $this.m71(tmp_13, tmp_14, VOID, tmp_15, SDFShaders$opSubtract$delegate$lambda).q6y($this, opSubtract$factory());
    var tmp_16 = $this;
    var tmp_17 = $this.d72();
    var tmp_18 = $this.d72();
    var tmp_19 = $this.d72();
    tmp_16.a8g_1 = $this.m71(tmp_17, tmp_18, VOID, tmp_19, SDFShaders$opRound$delegate$lambda).q6y($this, opRound$factory());
    var tmp_20 = $this;
    var tmp_21 = $this.d72();
    var tmp_22 = $this.d72();
    var tmp_23 = $this.d72();
    tmp_20.b8g_1 = $this.m71(tmp_21, tmp_22, VOID, tmp_23, SDFShaders$opBorder$delegate$lambda).q6y($this, opBorder$factory());
    var tmp_24 = $this;
    var tmp_25 = $this.d72();
    var tmp_26 = $this.d72();
    var tmp_27 = $this.d72();
    tmp_24.c8g_1 = $this.m71(tmp_25, tmp_26, VOID, tmp_27, SDFShaders$opBorderInner$delegate$lambda).q6y($this, opBorderInner$factory());
    var tmp_28 = $this;
    var tmp_29 = $this.d72();
    var tmp_30 = $this.d72();
    tmp_28.d8g_1 = $this.k71(tmp_29, VOID, tmp_30, SDFShaders$opAA$delegate$lambda).q6y($this, opAA$factory());
    var tmp_31 = $this;
    var tmp_32 = $this.d72();
    var tmp_33 = $this.d72();
    tmp_31.e8g_1 = $this.k71(tmp_32, VOID, tmp_33, SDFShaders$opAARev$delegate$lambda).q6y($this, opAARev$factory());
    var tmp_34 = $this;
    var tmp_35 = $this.d72();
    var tmp_36 = $this.d72();
    var tmp_37 = $this.d72();
    var tmp_38 = $this.d72();
    tmp_34.f8g_1 = $this.o71(tmp_35, tmp_36, tmp_37, VOID, tmp_38, SDFShaders$opSmoothUnion$delegate$lambda).q6y($this, opSmoothUnion$factory());
    var tmp_39 = $this;
    var tmp_40 = $this.d72();
    var tmp_41 = $this.d72();
    var tmp_42 = $this.d72();
    var tmp_43 = $this.d72();
    tmp_39.g8g_1 = $this.o71(tmp_40, tmp_41, tmp_42, VOID, tmp_43, SDFShaders$opSmoothSubtraction$delegate$lambda).q6y($this, opSmoothSubtraction$factory());
    var tmp_44 = $this;
    var tmp_45 = $this.d72();
    var tmp_46 = $this.d72();
    var tmp_47 = $this.d72();
    var tmp_48 = $this.d72();
    tmp_44.h8g_1 = $this.o71(tmp_45, tmp_46, tmp_47, VOID, tmp_48, SDFShaders$opSmoothIntersection$delegate$lambda).q6y($this, opSmoothIntersection$factory());
    var tmp_49 = $this;
    var tmp_50 = $this.e7o();
    var tmp_51 = $this.d72();
    var tmp_52 = $this.d72();
    tmp_49.i8g_1 = $this.m71(tmp_50, tmp_51, VOID, tmp_52, SDFShaders$circle$delegate$lambda).q6y($this, circle$factory());
    var tmp_53 = $this;
    var tmp_54 = $this.e7o();
    var tmp_55 = $this.e7o();
    var tmp_56 = $this.f7o();
    var tmp_57 = $this.d72();
    tmp_53.j8g_1 = $this.o71(tmp_54, tmp_55, tmp_56, VOID, tmp_57, SDFShaders$roundedBox$delegate$lambda).q6y($this, roundedBox$factory());
    var tmp_58 = $this;
    var tmp_59 = $this.e7o();
    var tmp_60 = $this.e7o();
    var tmp_61 = $this.d72();
    tmp_58.k8g_1 = $this.m71(tmp_59, tmp_60, VOID, tmp_61, SDFShaders$box$delegate$lambda).q6y($this, box$factory());
    var tmp_62 = $this;
    var tmp_63 = $this.f7o();
    var tmp_64 = $this.f7o();
    var tmp_65 = $this.f7o();
    tmp_62.l8g_1 = $this.m71(tmp_63, tmp_64, VOID, tmp_65, SDFShaders$opCombinePremultipliedColors$delegate$lambda).q6y($this, opCombinePremultipliedColors$factory());
    return $this;
  }
  n8g() {
    return this.w8f_1.no(this, opInterpolate$factory_0());
  }
  o8g() {
    return this.x8f_1.no(this, opUnion$factory_0());
  }
  p8g() {
    return this.y8f_1.no(this, opIntersect$factory_0());
  }
  q8g() {
    return this.z8f_1.no(this, opSubtract$factory_0());
  }
  r8g() {
    return this.a8g_1.no(this, opRound$factory_0());
  }
  s8g() {
    return this.b8g_1.no(this, opBorder$factory_0());
  }
  t8g() {
    return this.c8g_1.no(this, opBorderInner$factory_0());
  }
  u8g() {
    return this.d8g_1.no(this, opAA$factory_0());
  }
  v8g() {
    return this.e8g_1.no(this, opAARev$factory_0());
  }
  w8g() {
    return this.f8g_1.no(this, opSmoothUnion$factory_0());
  }
  x8g() {
    return this.g8g_1.no(this, opSmoothSubtraction$factory_0());
  }
  y8g() {
    return this.h8g_1.no(this, opSmoothIntersection$factory_0());
  }
  z8g() {
    return this.i8g_1.no(this, circle$factory_0());
  }
  a8h() {
    return this.j8g_1.no(this, roundedBox$factory_0());
  }
  b8h() {
    return this.k8g_1.no(this, box$factory_0());
  }
  c8h() {
    return this.l8g_1.no(this, opCombinePremultipliedColors$factory_0());
  }
}
class TextureBase {
  static d8h(base, size) {
    var $this = createThis(this);
    $this.y88_1 = base;
    $this.z88_1 = size;
    $this.a89_1 = -1;
    return $this;
  }
  e1() {
    return this.z88_1;
  }
  static b89(base, width, height) {
    return this.d8h(base, SizeInt.x2g(width, height));
  }
  c89(width) {
    this.z88_1 = SizeInt.x2g(width, this.a2j());
  }
  z2i() {
    return this.z88_1.v2g_1;
  }
  d89(height) {
    this.z88_1 = SizeInt.x2g(this.z2i(), height);
  }
  a2j() {
    return this.z88_1.w2g_1;
  }
  f6() {
    var tmp0_safe_receiver = this.y88_1;
    if (tmp0_safe_receiver == null)
      null;
    else {
      tmp0_safe_receiver.f6();
    }
    this.y88_1 = null;
  }
  w89(bmp, mipmaps, baseMipmapLevel, maxMipmapLevel) {
    var tmp0_safe_receiver = this.y88_1;
    if (tmp0_safe_receiver == null)
      null;
    else
      tmp0_safe_receiver.s6p(bmp, mipmaps, baseMipmapLevel, maxMipmapLevel);
  }
  toString() {
    return 'TextureBase(' + toString_1(this.y88_1) + ')';
  }
}
class Companion_57 {
  constructor() {
    Companion_instance_66 = this;
    this.e8h_1 = new TexturedVertexArray(0, new Int16Array(0));
  }
}
class TexturedVertexArray {
  constructor(vcount, indices, icount) {
    Companion_getInstance_73();
    icount = icount === VOID ? indices.length : icount;
    this.w8b_1 = indices;
    this.x8b_1 = vcount;
    this.y8b_1 = vcount;
    this.z8b_1 = icount;
    this.a8c_1 = allocNoDirect(Companion_instance_4, imul(imul(6, this.x8b_1), 4));
    this.b8c_1 = this.a8c_1;
    this.c8c_1 = 0;
  }
  f8h(fast, pos, x, y, u, v, colMul) {
    setFloat32(fast, pos + 0 | 0, x);
    setFloat32(fast, pos + 1 | 0, y);
    setFloat32(fast, pos + 2 | 0, u);
    setFloat32(fast, pos + 3 | 0, v);
    setInt32(fast, pos + 4 | 0, colMul);
    setInt32(fast, pos + 5 | 0, 0);
    return 6;
  }
  g8h(index, x, y, width, height, matrix, bmp, colMul) {
    this.s8f(index, x, y, width, height, matrix, bmp.l3h(), bmp.m3h(), bmp.n3h(), bmp.o3h(), bmp.r3h(), bmp.s3h(), bmp.p3h(), bmp.q3h(), colMul);
  }
  s8f(index, x, y, width, height, matrix, tl_x, tl_y, tr_x, tr_y, bl_x, bl_y, br_x, br_y, colMul) {
    var xw = x + width;
    var yh = y + height;
    var af = matrix.l29_1;
    var cf = matrix.n29_1;
    var txf = matrix.p29_1;
    var x0 = af * x + cf * y + txf;
    var x1 = af * xw + cf * y + txf;
    var x2 = af * xw + cf * yh + txf;
    var x3 = af * x + cf * yh + txf;
    var df = matrix.o29_1;
    var bf = matrix.m29_1;
    var tyf = matrix.q29_1;
    var y0 = df * y + bf * x + tyf;
    var y1 = df * y + bf * xw + tyf;
    var y2 = df * yh + bf * xw + tyf;
    var y3 = df * yh + bf * x + tyf;
    var fast = this.b8c_1;
    var pos = imul(index, 6);
    var cm = _RGBA___get_value__impl__hhco8v(colMul);
    pos = pos + this.f8h(fast, pos, x0, y0, tl_x, tl_y, cm) | 0;
    pos = pos + this.f8h(fast, pos, x1, y1, tr_x, tr_y, cm) | 0;
    pos = pos + this.f8h(fast, pos, x2, y2, br_x, br_y, cm) | 0;
    pos = pos + this.f8h(fast, pos, x3, y3, bl_x, bl_y, cm) | 0;
  }
}
class ResourcesRoot {
  j8h(path, file) {
    _get_mountable__707cy(this).y2y(path, file);
  }
  l67(injector) {
    var tmp = this;
    // Inline function 'korlibs.io.file.std.MountableVfs' call
    // Inline function 'korlibs.io.file.std.MountableVfsSync' call
    // Inline function 'kotlin.also' call
    var this_0 = new MountableVfs(false);
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.io.file.std.MountableVfsSync.<anonymous>' call
    // Inline function 'korlibs.io.file.std.MountableVfs.<anonymous>' call
    // Inline function 'korlibs.korge.resources.ResourcesRoot.init.<anonymous>' call
    this.i8h_1 = this_0;
    tmp.h8h_1 = this_0.r23();
    this.j8h('/', get_resourcesVfs());
  }
  toString() {
    return 'ResourcesRoot[' + _get_root__dd8asp(this).toString() + ']';
  }
}
class RCollection {
  constructor() {
    this.k8h_1 = ArrayList.h1();
    this.l8h_1 = LinkedHashMap.gc();
  }
}
class Stats {
  constructor() {
    this.m8h_1 = new RCollection();
    this.n8h_1 = new RCollection();
  }
  l6j() {
    // Inline function 'korlibs.datastructure.iterators.fastForEach' call
    var this_0 = this.m8h_1.k8h_1;
    var n = 0;
    while (n < this_0.e1()) {
      // Inline function 'korlibs.korge.stat.Stats.startFrame.<anonymous>' call
      var _unary__edvuaz = n;
      n = _unary__edvuaz + 1 | 0;
      this_0.d1(_unary__edvuaz).l6j();
    }
    // Inline function 'korlibs.datastructure.iterators.fastForEach' call
    var this_1 = this.n8h_1.k8h_1;
    var n_0 = 0;
    while (n_0 < this_1.e1()) {
      // Inline function 'korlibs.korge.stat.Stats.startFrame.<anonymous>' call
      var _unary__edvuaz_0 = n_0;
      n_0 = _unary__edvuaz_0 + 1 | 0;
      this_1.d1(_unary__edvuaz_0).l6j();
    }
  }
}
class V2 {
  constructor(key, initial, end, interpolator, includeStart, fastStartTime, fastDuration, initialization) {
    fastStartTime = fastStartTime === VOID ? Companion_instance_3.c1v() : fastStartTime;
    fastDuration = fastDuration === VOID ? Companion_instance_3.d1v() : fastDuration;
    initialization = initialization === VOID ? null : initialization;
    this.v8h_1 = key;
    this.w8h_1 = initial;
    this.x8h_1 = end;
    this.y8h_1 = interpolator;
    this.z8h_1 = includeStart;
    this.a8i_1 = fastStartTime;
    this.b8i_1 = fastDuration;
    this.c8i_1 = initialization;
    this.d8i_1 = FastDuration__plus_impl_q1enab(this.a8i_1, equals(this.b8i_1, Companion_instance_3.d1v()) ? get_fastNanoseconds_0(0) : this.b8i_1);
  }
  e8i() {
    return toDuration_1(this.a8i_1);
  }
  f8i() {
    return toDuration_1(this.b8i_1);
  }
  g8i(default_0) {
    return equals(this.b8i_1, Companion_instance_3.d1v()) ? default_0 : this.d8i_1;
  }
  z35() {
    if (!this.z8h_1) {
      this.w8h_1 = this.v8h_1.get();
    }
    var tmp0_safe_receiver = this.c8i_1;
    if (tmp0_safe_receiver == null)
      null;
    else
      tmp0_safe_receiver();
  }
  h8i(ratio) {
    this.v8h_1.set(this.y8h_1(new Ratio(ratio), this.w8h_1, this.x8h_1));
  }
  toString() {
    return 'V2(key=' + this.v8h_1.callableName + ', range=[' + toString_1(this.w8h_1) + '-' + toString_1(this.x8h_1) + '], startTime=' + Duration__toString_impl_8d916b(this.e8i()) + ', duration=' + Duration__toString_impl_8d916b(this.f8i()) + ')';
  }
  hashCode() {
    var result = hashCode(this.v8h_1);
    result = imul(result, 31) + (this.w8h_1 == null ? 0 : hashCode(this.w8h_1)) | 0;
    result = imul(result, 31) + (this.x8h_1 == null ? 0 : hashCode(this.x8h_1)) | 0;
    result = imul(result, 31) + hashCode(this.y8h_1) | 0;
    result = imul(result, 31) + getBooleanHashCode(this.z8h_1) | 0;
    result = imul(result, 31) + FastDuration__hashCode_impl_y13la6(this.a8i_1) | 0;
    result = imul(result, 31) + FastDuration__hashCode_impl_y13la6(this.b8i_1) | 0;
    result = imul(result, 31) + (this.c8i_1 == null ? 0 : hashCode(this.c8i_1)) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof V2))
      return false;
    var tmp0_other_with_cast = other instanceof V2 ? other : THROW_CCE();
    if (!equals(this.v8h_1, tmp0_other_with_cast.v8h_1))
      return false;
    if (!equals(this.w8h_1, tmp0_other_with_cast.w8h_1))
      return false;
    if (!equals(this.x8h_1, tmp0_other_with_cast.x8h_1))
      return false;
    if (!equals(this.y8h_1, tmp0_other_with_cast.y8h_1))
      return false;
    if (!(this.z8h_1 === tmp0_other_with_cast.z8h_1))
      return false;
    if (!equals(this.a8i_1, tmp0_other_with_cast.a8i_1))
      return false;
    if (!equals(this.b8i_1, tmp0_other_with_cast.b8i_1))
      return false;
    if (!equals(this.c8i_1, tmp0_other_with_cast.c8i_1))
      return false;
    return true;
  }
}
class V2CallbackSupport {
  constructor() {
    V2CallbackSupport_instance = this;
    this.i8i_1 = Unit_instance;
  }
}
class DEFAULT {}
class Impl {
  constructor(quality) {
    quality = quality === VOID ? Quality_AUTOMATIC_getInstance() : quality;
    this.j8i_1 = quality;
  }
  k8e() {
    return this.j8i_1;
  }
}
class Companion_58 {
  constructor() {
    Companion_instance_67 = this;
    this.k8i_1 = mapOf([to(new Angle(Angle__times_impl_v3s9y2(get_degrees(45), 0)), Cursor_RESIZE_EAST_getInstance()), to(new Angle(Angle__times_impl_v3s9y2(get_degrees(45), 1)), Cursor_RESIZE_SOUTH_EAST_getInstance()), to(new Angle(Angle__times_impl_v3s9y2(get_degrees(45), 2)), Cursor_RESIZE_SOUTH_getInstance()), to(new Angle(Angle__times_impl_v3s9y2(get_degrees(45), 3)), Cursor_RESIZE_SOUTH_WEST_getInstance()), to(new Angle(Angle__times_impl_v3s9y2(get_degrees(45), 4)), Cursor_RESIZE_WEST_getInstance()), to(new Angle(Angle__times_impl_v3s9y2(get_degrees(45), 5)), Cursor_RESIZE_NORTH_WEST_getInstance()), to(new Angle(Angle__times_impl_v3s9y2(get_degrees(45), 6)), Cursor_RESIZE_NORTH_getInstance()), to(new Angle(Angle__times_impl_v3s9y2(get_degrees(45), 7)), Cursor_RESIZE_NORTH_EAST_getInstance())]);
  }
}
class Cursor extends Enum {}
class MenuItem {
  constructor(text, enabled, children, action) {
    enabled = enabled === VOID ? true : enabled;
    children = children === VOID ? null : children;
    var tmp;
    if (action === VOID) {
      tmp = GameWindow$MenuItem$_init_$lambda_465oqx;
    } else {
      tmp = action;
    }
    action = tmp;
    this.n8i_1 = text;
    this.o8i_1 = enabled;
    this.p8i_1 = children;
    this.q8i_1 = action;
  }
  toString() {
    return 'MenuItem(text=' + this.n8i_1 + ', enabled=' + this.o8i_1 + ', children=' + toString_1(this.p8i_1) + ', action=' + toString(this.q8i_1) + ')';
  }
  hashCode() {
    var result = this.n8i_1 == null ? 0 : getStringHashCode(this.n8i_1);
    result = imul(result, 31) + getBooleanHashCode(this.o8i_1) | 0;
    result = imul(result, 31) + (this.p8i_1 == null ? 0 : hashCode(this.p8i_1)) | 0;
    result = imul(result, 31) + hashCode(this.q8i_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof MenuItem))
      return false;
    var tmp0_other_with_cast = other instanceof MenuItem ? other : THROW_CCE();
    if (!(this.n8i_1 == tmp0_other_with_cast.n8i_1))
      return false;
    if (!(this.o8i_1 === tmp0_other_with_cast.o8i_1))
      return false;
    if (!equals(this.p8i_1, tmp0_other_with_cast.p8i_1))
      return false;
    if (!equals(this.q8i_1, tmp0_other_with_cast.q8i_1))
      return false;
    return true;
  }
}
class CoroutineKey {
  constructor() {
    CoroutineKey_instance = this;
    this.r8i_1 = 60;
    this.s8i_1 = Companion_getInstance_1().qw('GameWindow');
    this.t8i_1 = new MenuItem(null);
  }
}
class Quality extends Enum {
  constructor(name, ordinal, level) {
    super(name, ordinal);
    this.h8l_1 = level;
    this.i8l_1 = 4000000;
  }
  y2t() {
    return this.h8l_1;
  }
  j8l(width, height, devicePixelRatio, targetPixels) {
    var tmp;
    switch (this.r3_1) {
      case 0:
        tmp = 1.0;
        break;
      case 1:
        tmp = devicePixelRatio;
        break;
      case 2:
        var tmp$ret$1;
        $l$block: {
          // Inline function 'kotlin.collections.firstOrNull' call
          var tmp0_iterator = listOf_0([devicePixelRatio, 2.0, 1.0]).a1();
          while (tmp0_iterator.b1()) {
            var element = tmp0_iterator.c1();
            // Inline function 'korlibs.render.Quality.computeTargetScale.<anonymous>' call
            if (imul(width, height) * element <= targetPixels) {
              tmp$ret$1 = element;
              break $l$block;
            }
          }
          tmp$ret$1 = null;
        }

        var tmp1_elvis_lhs = tmp$ret$1;
        tmp = tmp1_elvis_lhs == null ? 1.0 : tmp1_elvis_lhs;
        break;
      default:
        noWhenBranchMatchedException();
        break;
    }
    return tmp;
  }
  k8l(width, height, devicePixelRatio, targetPixels, $super) {
    targetPixels = targetPixels === VOID ? this.i8l_1 : targetPixels;
    return $super === VOID ? this.j8l(width, height, devicePixelRatio, targetPixels) : $super.j8l.call(this, width, height, devicePixelRatio, targetPixels);
  }
}
class GameWindow$loop$slambda {
  constructor($entry, this$0) {
    this.l8i_1 = $entry;
    this.m8i_1 = this$0;
  }
  ud($completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8.bind(VOID, this), $completion);
  }
}
class _no_name_provided__qut3iv extends ObservableProperty {
  constructor($initialValue, this$0, $box) {
    if ($box === VOID)
      $box = {};
    $box.r8l_1 = this$0;
    super($initialValue, $box);
  }
  s8l(property, oldValue, newValue) {
    var tmp0_safe_receiver = this.r8l_1.l8k_1;
    if (tmp0_safe_receiver == null)
      null;
    else
      tmp0_safe_receiver(newValue);
    return Unit_instance;
  }
  mo(property, oldValue, newValue) {
    var tmp = (oldValue == null ? true : !(oldValue == null)) ? oldValue : THROW_CCE();
    return this.s8l(property, tmp, (newValue == null ? true : !(newValue == null)) ? newValue : THROW_CCE());
  }
}
class GameWindow extends BaseEventListener {
  static t8l() {
    CoroutineKey_getInstance();
    var $this = this.t69();
    $this.y8i_1 = new Mixin();
    $this.z8i_1 = Cursor_DEFAULT_getInstance();
    $this.a8j_1 = false;
    $this.b8j_1 = AGDummy.b7d();
    $this.c8j_1 = SyncEventLoopCoroutineDispatcher.w8l();
    $this.d8j_1 = GameWindowCoroutineDispatcher.h8m();
    $this.e8j_1 = new PauseEvent();
    $this.f8j_1 = new ResumeEvent();
    $this.g8j_1 = new StopEvent();
    $this.h8j_1 = new DestroyEvent();
    $this.i8j_1 = new UpdateEvent();
    $this.j8j_1 = new RenderEvent();
    $this.k8j_1 = new InitEvent();
    $this.l8j_1 = new DisposeEvent();
    $this.m8j_1 = new FullScreenEvent();
    $this.n8j_1 = new ReshapeEvent();
    $this.o8j_1 = new KeyEvent();
    $this.p8j_1 = new MouseEvent();
    $this.q8j_1 = new GestureEvent();
    $this.r8j_1 = new DropFileEvent();
    var tmp = $this;
    // Inline function 'korlibs.time.milliseconds' call
    // Inline function 'kotlin.time.Companion.milliseconds' call
    Companion_getInstance();
    var tmp_0 = toDuration(1000, DurationUnit_MILLISECONDS_getInstance());
    tmp.s8j_1 = new IntTimedCache(tmp_0, VOID, GameWindow$fpsCached$delegate$lambda($this));
    $this.t8j_1 = 60;
    $this.u8j_1 = 0;
    $this.v8j_1 = 0;
    $this.w8j_1 = true;
    $this.x8j_1 = null;
    $this.y8j_1 = false;
    $this.z8j_1 = false;
    $this.a8k_1 = Colors_getInstance().f41_1;
    $this.b8k_1 = new Signal();
    $this.c8k_1 = new Signal();
    $this.d8k_1 = null;
    $this.e8k_1 = false;
    $this.f8k_1 = true;
    $this.g8k_1 = 0;
    $this.h8k_1 = true;
    $this.i8k_1 = false;
    var tmp_1 = $this;
    // Inline function 'korlibs.time.milliseconds' call
    // Inline function 'kotlin.time.Companion.milliseconds' call
    Companion_getInstance();
    tmp_1.j8k_1 = toDuration(0, DurationUnit_MILLISECONDS_getInstance());
    var tmp_2 = $this;
    // Inline function 'korlibs.time.milliseconds' call
    // Inline function 'kotlin.time.Companion.milliseconds' call
    Companion_getInstance();
    tmp_2.k8k_1 = toDuration(0, DurationUnit_MILLISECONDS_getInstance());
    $this.l8k_1 = null;
    var tmp_3 = $this;
    // Inline function 'kotlin.properties.Delegates.observable' call
    tmp_3.m8k_1 = new _no_name_provided__qut3iv(true, $this);
    $this.n8k_1 = false;
    $this.o8k_1 = -1;
    $this.p8k_1 = -1;
    $this.q8k_1 = -1;
    $this.r8k_1 = -1;
    $this.s8k_1 = false;
    $this.t8k_1 = false;
    $this.u8k_1 = false;
    $this.v8k_1 = 0;
    $this.w8k_1 = Companion_instance_3.c1v();
    $this.x8k_1 = new Lock();
    $this.y8k_1 = booleanArray(Companion_getInstance_35().y6g_1);
    $this.z8k_1 = 0;
    $this.a8l_1 = 0.0;
    $this.b8l_1 = 0.0;
    $this.c8l_1 = 0.0;
    $this.d8l_1 = false;
    $this.e8l_1 = new GamepadInfoEmitter($this);
    return $this;
  }
  i8m(windowRect) {
  }
  j8m(force, config) {
  }
  k8m(force, config, $super) {
    force = force === VOID ? true : force;
    config = config === VOID ? null : config;
    var tmp;
    if ($super === VOID) {
      this.j8m(force, config);
      tmp = Unit_instance;
    } else {
      tmp = $super.j8m.call(this, force, config);
    }
    return tmp;
  }
  l8m() {
  }
  m8m(_set____db54di) {
    this.z8i_1 = _set____db54di;
  }
  n8m() {
    return this.z8i_1;
  }
  t1() {
    return CoroutineKey_getInstance();
  }
  o8m() {
    return this.b8j_1;
  }
  p8m() {
    return this.d8j_1;
  }
  q8m(coroutineContext) {
    return coroutineContext.dn(this.p8m());
  }
  l8l($completion) {
    // Inline function 'kotlin.js.getCoroutineContext' call
    var tmp$ret$0 = $completion.rc();
    return this.q8m(tmp$ret$0);
  }
  r8m(block) {
    return this.v69(Companion_getInstance_19(), block);
  }
  n8l() {
    return get_fastMicroseconds(1000000.0 / this.s8m());
  }
  t8m() {
    // Inline function 'korlibs.time.microseconds' call
    var this_0 = 1000000.0 / this.s8m();
    return toDuration(this_0, DurationUnit_MICROSECONDS_getInstance());
  }
  p8l() {
    return 60;
  }
  u8m(name, time) {
  }
  s8m() {
    return _get_fpsCached__581dty(this);
  }
  v8m(value) {
    return Unit_instance;
  }
  z2i() {
    return this.u8j_1;
  }
  a2j() {
    return this.v8j_1;
  }
  w8m(_set____db54di) {
    this.x8j_1 = _set____db54di;
  }
  x8m(_set____db54di) {
    this.y8j_1 = _set____db54di;
  }
  y8m(_set____db54di) {
    this.z8j_1 = _set____db54di;
  }
  z8m(_set____db54di) {
    this.a8k_1 = _set____db54di;
  }
  a8n() {
    return this.a8k_1;
  }
  b8n(value) {
    return Unit_instance;
  }
  k8e() {
    return Quality_AUTOMATIC_getInstance();
  }
  c8n(value) {
    this.e8k_1 = value;
    this.c8k_1.i1w(value);
    if (value) {
      invoke(this.b8k_1);
    }
  }
  d8n() {
    return this.e8k_1;
  }
  e8n(width, height) {
    return Unit_instance;
  }
  f8n(exitCode) {
    return this.i1d(exitCode);
  }
  g8n(exitCode, $super) {
    exitCode = exitCode === VOID ? 0 : exitCode;
    var tmp;
    if ($super === VOID) {
      this.f8n(exitCode);
      tmp = Unit_instance;
    } else {
      tmp = $super.f8n.call(this, exitCode);
    }
    return tmp;
  }
  i1d(exitCode) {
    if (this.i8k_1)
      return Unit_instance;
    this.i8k_1 = true;
    this.h8k_1 = false;
    this.g8k_1 = exitCode;
    // Inline function 'korlibs.logger.Logger.info' call
    var this_0 = CoroutineKey_getInstance().s8i_1;
    var level = Level_INFO_getInstance();
    var tmp;
    if (this_0.a2u(level)) {
      // Inline function 'korlibs.render.GameWindow.close.<anonymous>' call
      var tmp$ret$0 = 'GameWindow.close';
      this_0.b2u(level, tmp$ret$0);
      tmp = Unit_instance;
    }
    this.p8m().f6();
    cancelChildren(this.p8m());
  }
  h8n(exitCode, $super) {
    exitCode = exitCode === VOID ? 0 : exitCode;
    var tmp;
    if ($super === VOID) {
      this.i1d(exitCode);
      tmp = Unit_instance;
    } else {
      tmp = $super.i1d.call(this, exitCode);
    }
    return tmp;
  }
  i8n($completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_waitClose__fhnm35.bind(VOID, this), $completion);
  }
  j8n(entry, $completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_loop__qll5p8.bind(VOID, this, entry), $completion);
  }
  o8l(time, $completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_loopDelay__vgtnit.bind(VOID, this, time), $completion);
  }
  k8n(_set____db54di) {
    return this.m8k_1.qo(this, continuousRenderMode$factory(), _set____db54di);
  }
  l8n() {
    return this.m8k_1.oo(this, continuousRenderMode$factory_0());
  }
  m8n(doUpdate, doRender, frameStartTime) {
    var startTime = PerformanceCounter_getInstance().v67();
    if (doRender) {
      var tmp = this;
      // Inline function 'kotlin.time.measureTime' call
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'kotlin.time.measureTime' call
      // Inline function 'kotlin.contracts.contract' call
      var mark = Monotonic_instance.ej();
      // Inline function 'korlibs.render.GameWindow.frame.<anonymous>' call
      this.n8n(doUpdate, true);
      tmp.j8k_1 = ValueTimeMark__elapsedNow_impl_eonqvs(mark);
    }
    if (doUpdate) {
      var tmp_0 = this;
      // Inline function 'kotlin.time.measureTime' call
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'kotlin.time.measureTime' call
      // Inline function 'kotlin.contracts.contract' call
      var mark_0 = Monotonic_instance.ej();
      // Inline function 'korlibs.render.GameWindow.frame.<anonymous>' call
      if (!doRender) {
        this.n8n(true, false);
      }
      this.o8n(frameStartTime);
      tmp_0.k8k_1 = ValueTimeMark__elapsedNow_impl_eonqvs(mark_0);
    }
    var endTime = PerformanceCounter_getInstance().w67();
    return FastDuration__minus_impl_evs237_0(endTime, startTime);
  }
  m8l(doUpdate, doRender, frameStartTime, $super) {
    doUpdate = doUpdate === VOID ? true : doUpdate;
    doRender = doRender === VOID ? true : doRender;
    frameStartTime = frameStartTime === VOID ? PerformanceCounter_getInstance().w67() : frameStartTime;
    return $super === VOID ? this.m8n(doUpdate, doRender, frameStartTime) : $super.m8n.call(this, doUpdate, doRender, new FastDuration(frameStartTime)).f1v_1;
  }
  n8n(doUpdate, doRender) {
    if (doRender) {
      if (this.u8k_1) {
        this.u8k_1 = false;
        this.o8m().i6j();
      }
      if (this.n8k_1) {
        this.n8k_1 = false;
        this.o8m().h6j().e6o(this.o8k_1, this.p8k_1, this.q8k_1, this.r8k_1);
        this.p8n(this.o8k_1, this.p8k_1, this.q8k_1, this.r8k_1);
      }
    }
    if (this.s8k_1) {
      this.s8k_1 = false;
      println('---------------- Trigger AG.initialized ag.mainFrameBuffer.setSize (' + this.z2i() + ', ' + this.a2j() + ') --------------');
      // Inline function 'korlibs.event.reset' call
      var this_0 = this.k8j_1;
      this_0.o6a_1 = false;
      // Inline function 'korlibs.event.reset.<anonymous>' call
      this.g6a(this_0);
    }
    try {
      this.q8n(doUpdate, doRender);
    } catch ($p) {
      if ($p instanceof Error) {
        var e = $p;
        println('ERROR GameWindow.frameRender:');
        println(e);
        printStackTrace(e);
      } else {
        throw $p;
      }
    }
  }
  l6j() {
    this.v8k_1 = 0;
  }
  r8n() {
    this.v8k_1 = this.v8k_1 + 1 | 0;
  }
  o8n(startTime) {
    var tmp = this;
    // Inline function 'korlibs.time.fastMeasureTime' call
    var stopwatch = new Stopwatch();
    // Inline function 'korlibs.render.GameWindow.frameUpdate.<anonymous>' call
    this.s8n();
    tmp.w8k_1 = stopwatch.b68();
    try {
      var now = PerformanceCounter_getInstance().v67();
      var consumed = minus(now, startTime);
      var tmp0_elvis_lhs = this.p8m().f8m_1;
      var tmp_0;
      var tmp_1 = tmp0_elvis_lhs;
      if ((tmp_1 == null ? null : new Duration(tmp_1)) == null) {
        tmp_0 = Duration__times_impl_sfuzvp(this.t8m(), 10);
      } else {
        tmp_0 = tmp0_elvis_lhs;
      }
      var timeForTasks = tmp_0;
      // Inline function 'korlibs.time.milliseconds' call
      // Inline function 'kotlin.time.Companion.milliseconds' call
      Companion_getInstance();
      var tmp$ret$2 = toDuration(4, DurationUnit_MILLISECONDS_getInstance());
      var finalTimeForTasks = max(timeForTasks, tmp$ret$2);
      this.p8m().t8n(finalTimeForTasks);
    } catch ($p) {
      if ($p instanceof Error) {
        var e = $p;
        println('ERROR GameWindow.frameRender:');
        println(e);
      } else {
        throw $p;
      }
    }
  }
  s8n() {
  }
  q8n(update, render) {
    // Inline function 'korlibs.render.GameWindow.updateRenderLock' call
    // Inline function 'korlibs.concurrent.lock.Lock.invoke' call
    var this_0 = this.x8k_1;
    $l$block: {
      // Inline function 'korlibs.concurrent.lock.LockImpl.lockUnlock' call
      this_0.n1v();
      try {
        // Inline function 'korlibs.event.reset' call
        var this_1 = this.j8j_1;
        this_1.o6a_1 = false;
        // Inline function 'korlibs.render.GameWindow.dispatchRenderEvent.<anonymous>.<anonymous>' call
        this_1.w6a_1 = update;
        this_1.x6a_1 = render;
        this.g6a(this_1);
        break $l$block;
      }finally {
        this_0.p1v();
      }
    }
  }
  u8n(type, files) {
    // Inline function 'korlibs.event.reset' call
    var this_0 = this.r8j_1;
    this_0.o6a_1 = false;
    // Inline function 'korlibs.render.GameWindow.dispatchDropfileEvent.<anonymous>' call
    this_0.l6d_1 = type;
    this_0.m6d_1 = files;
    return this.g6a(this_0);
  }
  p8n(x, y, width, height) {
    this.v8n(x, y, width, height, width, height);
  }
  v8n(x, y, width, height, fullWidth, fullHeight) {
    this.o8m().h6j().f6o(x, y, width, height, fullWidth, fullHeight);
    // Inline function 'korlibs.event.reset' call
    var this_0 = this.n8j_1;
    this_0.o6a_1 = false;
    // Inline function 'korlibs.render.GameWindow.dispatchReshapeEventEx.<anonymous>' call
    this_0.f6b_1 = x;
    this_0.g6b_1 = y;
    this_0.h6b_1 = width;
    this_0.i6b_1 = height;
    this.g6a(this_0);
  }
  p6f() {
    this.e8l_1.p6f();
  }
  b6g(info) {
    this.e8l_1.b6g(info);
  }
  d6g(out) {
    return this.e8l_1.d6g(out);
  }
  w8n(out, $super) {
    out = out === VOID ? IntArrayList.a2k() : out;
    return $super === VOID ? this.d6g(out) : $super.d6g.call(this, out);
  }
  x8n(data, $completion) {
  }
  y8n($completion) {
    return null;
  }
  ay(_set____db54di) {
    this.y8i_1.ay(_set____db54di);
  }
  by() {
    return this.y8i_1.by();
  }
}
class Companion_59 {
  constructor() {
    Companion_instance_68 = this;
    this.z8n_1 = new GameWindowCreationConfig();
  }
}
class GameWindowCreationConfig {
  constructor(multithreaded, hdr, msaa, checkGl, logGl, cacheGl, fullscreen, decorated, transparent, resizable, title) {
    Companion_getInstance_75();
    multithreaded = multithreaded === VOID ? null : multithreaded;
    hdr = hdr === VOID ? null : hdr;
    msaa = msaa === VOID ? null : msaa;
    checkGl = checkGl === VOID ? false : checkGl;
    logGl = logGl === VOID ? false : logGl;
    cacheGl = cacheGl === VOID ? false : cacheGl;
    fullscreen = fullscreen === VOID ? null : fullscreen;
    decorated = decorated === VOID ? true : decorated;
    transparent = transparent === VOID ? false : transparent;
    resizable = resizable === VOID ? true : resizable;
    title = title === VOID ? '' : title;
    this.a8o_1 = multithreaded;
    this.b8o_1 = hdr;
    this.c8o_1 = msaa;
    this.d8o_1 = checkGl;
    this.e8o_1 = logGl;
    this.f8o_1 = cacheGl;
    this.g8o_1 = fullscreen;
    this.h8o_1 = decorated;
    this.i8o_1 = transparent;
    this.j8o_1 = resizable;
    this.k8o_1 = title;
  }
  l8o(multithreaded, hdr, msaa, checkGl, logGl, cacheGl, fullscreen, decorated, transparent, resizable, title) {
    return new GameWindowCreationConfig(multithreaded, hdr, msaa, checkGl, logGl, cacheGl, fullscreen, decorated, transparent, resizable, title);
  }
  m8o(multithreaded, hdr, msaa, checkGl, logGl, cacheGl, fullscreen, decorated, transparent, resizable, title, $super) {
    multithreaded = multithreaded === VOID ? this.a8o_1 : multithreaded;
    hdr = hdr === VOID ? this.b8o_1 : hdr;
    msaa = msaa === VOID ? this.c8o_1 : msaa;
    checkGl = checkGl === VOID ? this.d8o_1 : checkGl;
    logGl = logGl === VOID ? this.e8o_1 : logGl;
    cacheGl = cacheGl === VOID ? this.f8o_1 : cacheGl;
    fullscreen = fullscreen === VOID ? this.g8o_1 : fullscreen;
    decorated = decorated === VOID ? this.h8o_1 : decorated;
    transparent = transparent === VOID ? this.i8o_1 : transparent;
    resizable = resizable === VOID ? this.j8o_1 : resizable;
    title = title === VOID ? this.k8o_1 : title;
    return $super === VOID ? this.l8o(multithreaded, hdr, msaa, checkGl, logGl, cacheGl, fullscreen, decorated, transparent, resizable, title) : $super.l8o.call(this, multithreaded, hdr, msaa, checkGl, logGl, cacheGl, fullscreen, decorated, transparent, resizable, title);
  }
  toString() {
    return 'GameWindowCreationConfig(multithreaded=' + this.a8o_1 + ', hdr=' + this.b8o_1 + ', msaa=' + this.c8o_1 + ', checkGl=' + this.d8o_1 + ', logGl=' + this.e8o_1 + ', cacheGl=' + this.f8o_1 + ', fullscreen=' + this.g8o_1 + ', decorated=' + this.h8o_1 + ', transparent=' + this.i8o_1 + ', resizable=' + this.j8o_1 + ', title=' + this.k8o_1 + ')';
  }
  hashCode() {
    var result = this.a8o_1 == null ? 0 : getBooleanHashCode(this.a8o_1);
    result = imul(result, 31) + (this.b8o_1 == null ? 0 : getBooleanHashCode(this.b8o_1)) | 0;
    result = imul(result, 31) + (this.c8o_1 == null ? 0 : this.c8o_1) | 0;
    result = imul(result, 31) + getBooleanHashCode(this.d8o_1) | 0;
    result = imul(result, 31) + getBooleanHashCode(this.e8o_1) | 0;
    result = imul(result, 31) + getBooleanHashCode(this.f8o_1) | 0;
    result = imul(result, 31) + (this.g8o_1 == null ? 0 : getBooleanHashCode(this.g8o_1)) | 0;
    result = imul(result, 31) + getBooleanHashCode(this.h8o_1) | 0;
    result = imul(result, 31) + getBooleanHashCode(this.i8o_1) | 0;
    result = imul(result, 31) + getBooleanHashCode(this.j8o_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.k8o_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof GameWindowCreationConfig))
      return false;
    var tmp0_other_with_cast = other instanceof GameWindowCreationConfig ? other : THROW_CCE();
    if (!(this.a8o_1 == tmp0_other_with_cast.a8o_1))
      return false;
    if (!(this.b8o_1 == tmp0_other_with_cast.b8o_1))
      return false;
    if (!(this.c8o_1 == tmp0_other_with_cast.c8o_1))
      return false;
    if (!(this.d8o_1 === tmp0_other_with_cast.d8o_1))
      return false;
    if (!(this.e8o_1 === tmp0_other_with_cast.e8o_1))
      return false;
    if (!(this.f8o_1 === tmp0_other_with_cast.f8o_1))
      return false;
    if (!(this.g8o_1 == tmp0_other_with_cast.g8o_1))
      return false;
    if (!(this.h8o_1 === tmp0_other_with_cast.h8o_1))
      return false;
    if (!(this.i8o_1 === tmp0_other_with_cast.i8o_1))
      return false;
    if (!(this.j8o_1 === tmp0_other_with_cast.j8o_1))
      return false;
    if (!(this.k8o_1 === tmp0_other_with_cast.k8o_1))
      return false;
    return true;
  }
}
class TextClipboardData {
  constructor(text, contentType) {
    contentType = contentType === VOID ? null : contentType;
    this.n8o_1 = text;
    this.o8o_1 = contentType;
  }
  toString() {
    return 'TextClipboardData(text=' + this.n8o_1 + ', contentType=' + this.o8o_1 + ')';
  }
  hashCode() {
    var result = getStringHashCode(this.n8o_1);
    result = imul(result, 31) + (this.o8o_1 == null ? 0 : getStringHashCode(this.o8o_1)) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof TextClipboardData))
      return false;
    var tmp0_other_with_cast = other instanceof TextClipboardData ? other : THROW_CCE();
    if (!(this.n8o_1 === tmp0_other_with_cast.n8o_1))
      return false;
    if (!(this.o8o_1 == tmp0_other_with_cast.o8o_1))
      return false;
    return true;
  }
}
class TimedTask_0 {
  constructor(time, continuation, callback) {
    this.p8o_1 = time;
    this.q8o_1 = continuation;
    this.r8o_1 = callback;
    this.s8o_1 = null;
  }
}
class Companion_60 {
  constructor() {
    Companion_instance_69 = this;
    this.t8o_1 = Companion_getInstance_1().qw('GameWindow');
  }
}
class sam$kotlinx_coroutines_DisposableHandle$0_0 {
  constructor(function_0) {
    this.u8o_1 = function_0;
  }
  l18() {
    return this.u8o_1();
  }
  n4() {
    return this.u8o_1;
  }
  equals(other) {
    var tmp;
    if (!(other == null) ? isInterface(other, DisposableHandle) : false) {
      var tmp_0;
      if (!(other == null) ? isInterface(other, FunctionAdapter) : false) {
        tmp_0 = equals(this.n4(), other.n4());
      } else {
        tmp_0 = false;
      }
      tmp = tmp_0;
    } else {
      tmp = false;
    }
    return tmp;
  }
  hashCode() {
    return hashCode(this.n4());
  }
}
class GameWindowCoroutineDispatcher extends CoroutineDispatcher {
  static h8m(nowProvider, fast) {
    Companion_getInstance_76();
    var tmp;
    if (nowProvider === VOID) {
      tmp = GameWindowCoroutineDispatcher$_init_$lambda_ooms1e;
    } else {
      tmp = nowProvider;
    }
    nowProvider = tmp;
    fast = fast === VOID ? false : fast;
    var $this = this.o1b();
    $this.y8l_1 = nowProvider;
    $this.z8l_1 = fast;
    $this.a8m_1 = new TGenQueue();
    var tmp_0 = $this;
    var tmp_1 = Companion_instance_0;
    tmp_0.b8m_1 = tmp_1.x2q(VOID, GameWindowCoroutineDispatcher$timedTasks$lambda);
    $this.c8m_1 = new NonRecursiveLock();
    $this.d8m_1 = get_fastMilliseconds_0(0);
    $this.e8m_1 = get_fastMilliseconds_0(0);
    $this.f8m_1 = null;
    $this.g8m_1 = Companion_getInstance_1().qw('Korgw.GameWindow.TooManyCallbacks');
    return $this;
  }
  v8o(block) {
    if (block == null)
      return Unit_instance;
    // Inline function 'korlibs.concurrent.lock.NonRecursiveLock.invoke' call
    // Inline function 'kotlinx.atomicfu.locks.synchronized' call
    this.c8m_1.i1v_1;
    // Inline function 'korlibs.concurrent.lock.NonRecursiveLock.invoke.<anonymous>' call
    this.a8m_1.h2r(block);
  }
  q1b(context, block) {
    return this.v8o(block);
  }
  w8o() {
    return this.y8l_1().f1v_1;
  }
  b1c(timeMillis, continuation) {
    // Inline function 'korlibs.time.milliseconds' call
    var this_0 = timeMillis.m4();
    var tmp$ret$0 = toDuration(this_0, DurationUnit_MILLISECONDS_getInstance());
    this.x8o(tmp$ret$0, continuation);
  }
  x8o(time, continuation) {
    var task = new TimedTask_0(FastDuration__plus_impl_q1enab_0(this.w8o(), time), continuation, null);
    continuation.z17(GameWindowCoroutineDispatcher$scheduleResumeAfterDelay$lambda(task));
    // Inline function 'korlibs.concurrent.lock.NonRecursiveLock.invoke' call
    // Inline function 'kotlinx.atomicfu.locks.synchronized' call
    this.c8m_1.i1v_1;
    // Inline function 'korlibs.concurrent.lock.NonRecursiveLock.invoke.<anonymous>' call
    // Inline function 'korlibs.render.GameWindowCoroutineDispatcher.scheduleResumeAfterDelay.<anonymous>' call
    this.b8m_1.g2m(task);
  }
  c1c(timeMillis, block, context) {
    var tmp = this.w8o();
    // Inline function 'korlibs.time.milliseconds' call
    var this_0 = timeMillis.m4();
    var tmp$ret$0 = toDuration(this_0, DurationUnit_MILLISECONDS_getInstance());
    var task = new TimedTask_0(FastDuration__plus_impl_q1enab_0(tmp, tmp$ret$0), null, block);
    // Inline function 'korlibs.concurrent.lock.NonRecursiveLock.invoke' call
    // Inline function 'kotlinx.atomicfu.locks.synchronized' call
    this.c8m_1.i1v_1;
    // Inline function 'korlibs.concurrent.lock.NonRecursiveLock.invoke.<anonymous>' call
    // Inline function 'korlibs.render.GameWindowCoroutineDispatcher.invokeOnTimeout.<anonymous>' call
    this.b8m_1.g2m(task);
    var tmp_0 = GameWindowCoroutineDispatcher$invokeOnTimeout$lambda(this, task);
    return new sam$kotlinx_coroutines_DisposableHandle$0_0(tmp_0);
  }
  t8n(availableTime) {
    this.y8o(get_fast(availableTime));
  }
  y8o(availableTime) {
    try {
      var startTime = this.w8o();
      var processedTimedTasks = 0;
      var processedTasks = 0;
      var tmp = this;
      // Inline function 'korlibs.time.fastMeasureTime' call
      var stopwatch = new Stopwatch();
      // Inline function 'korlibs.render.GameWindowCoroutineDispatcher.executePending.<anonymous>' call
      $l$loop_0: while (true) {
        // Inline function 'korlibs.concurrent.lock.NonRecursiveLock.invoke' call
        // Inline function 'kotlinx.atomicfu.locks.synchronized' call
        this.c8m_1.i1v_1;
        // Inline function 'korlibs.concurrent.lock.NonRecursiveLock.invoke.<anonymous>' call
        // Inline function 'korlibs.render.GameWindowCoroutineDispatcher.executePending.<anonymous>.<anonymous>' call
        var tmp_0;
        var tmp_1;
        // Inline function 'kotlin.collections.isNotEmpty' call
        if (!this.b8m_1.g1()) {
          tmp_1 = this.z8l_1 || FastDuration__compareTo_impl_4fhnj7(startTime, this.b8m_1.d2r().p8o_1) >= 0;
        } else {
          tmp_1 = false;
        }
        if (tmp_1) {
          tmp_0 = this.b8m_1.e2r();
        } else {
          tmp_0 = null;
        }
        var tmp0_elvis_lhs = tmp_0;
        var tmp_2;
        if (tmp0_elvis_lhs == null) {
          break $l$loop_0;
        } else {
          tmp_2 = tmp0_elvis_lhs;
        }
        var item = tmp_2;
        try {
          if (!(item.s8o_1 == null)) {
            var tmp1_safe_receiver = item.q8o_1;
            if (tmp1_safe_receiver == null)
              null;
            else {
              // Inline function 'kotlin.coroutines.resumeWithException' call
              // Inline function 'kotlin.Companion.failure' call
              var exception = ensureNotNull(item.s8o_1);
              var tmp$ret$5 = _Result___init__impl__xyqfz8(createFailure(exception));
              tmp1_safe_receiver.tc(tmp$ret$5);
            }
            if (!(item.r8o_1 == null)) {
              var tmp2_safe_receiver = item.s8o_1;
              if (tmp2_safe_receiver == null)
                null;
              else {
                printStackTrace(tmp2_safe_receiver);
              }
            }
          } else {
            var tmp3_safe_receiver = item.q8o_1;
            if (tmp3_safe_receiver == null)
              null;
            else {
              // Inline function 'kotlin.coroutines.resume' call
              // Inline function 'kotlin.Companion.success' call
              var tmp$ret$7 = _Result___init__impl__xyqfz8(Unit_instance);
              tmp3_safe_receiver.tc(tmp$ret$7);
            }
            var tmp4_safe_receiver = item.r8o_1;
            if (tmp4_safe_receiver == null)
              null;
            else {
              tmp4_safe_receiver.m1a();
            }
          }
        } catch ($p) {
          if ($p instanceof Error) {
            var e = $p;
            printStackTrace(e);
          } else {
            throw $p;
          }
        }
        finally {
          processedTimedTasks = processedTimedTasks + 1 | 0;
        }
        var elapsedTime = FastDuration__minus_impl_evs237(this.w8o(), startTime);
        if (FastDuration__compareTo_impl_4fhnj7(elapsedTime, availableTime) >= 0) {
          this.z8o(elapsedTime, availableTime, processedTimedTasks, processedTasks);
          break $l$loop_0;
        }
      }
      tmp.d8m_1 = stopwatch.b68();
      var tmp_3 = this;
      // Inline function 'korlibs.time.fastMeasureTime' call
      var stopwatch_0 = new Stopwatch();
      // Inline function 'korlibs.render.GameWindowCoroutineDispatcher.executePending.<anonymous>' call
      $l$loop_2: while (true) {
        // Inline function 'korlibs.concurrent.lock.NonRecursiveLock.invoke' call
        // Inline function 'kotlinx.atomicfu.locks.synchronized' call
        this.c8m_1.i1v_1;
        // Inline function 'korlibs.concurrent.lock.NonRecursiveLock.invoke.<anonymous>' call
        // Inline function 'korlibs.render.GameWindowCoroutineDispatcher.executePending.<anonymous>.<anonymous>' call
        var tmp_4;
        // Inline function 'kotlin.collections.isNotEmpty' call
        if (!this.a8m_1.g1()) {
          tmp_4 = this.a8m_1.i2r();
        } else {
          tmp_4 = null;
        }
        var tmp0_elvis_lhs_0 = tmp_4;
        var tmp_5;
        if (tmp0_elvis_lhs_0 == null) {
          break $l$loop_2;
        } else {
          tmp_5 = tmp0_elvis_lhs_0;
        }
        var task = tmp_5;
        // Inline function 'korlibs.time.fastMeasureTime' call
        var stopwatch_1 = new Stopwatch();
        // Inline function 'korlibs.render.GameWindowCoroutineDispatcher.executePending.<anonymous>.<anonymous>' call
        try {
          task.m1a();
        } catch ($p) {
          if ($p instanceof Error) {
            var e_0 = $p;
            printStackTrace(e_0);
          } else {
            throw $p;
          }
        }
        finally {
          processedTasks = processedTasks + 1 | 0;
        }
        var time = stopwatch_1.b68();
        var elapsed = FastDuration__minus_impl_evs237(this.w8o(), startTime);
        if (FastDuration__compareTo_impl_4fhnj7(elapsed, availableTime) >= 0) {
          this.z8o(elapsed, availableTime, processedTimedTasks, processedTasks);
          break $l$loop_2;
        }
      }
      tmp_3.e8m_1 = stopwatch_0.b68();
    } catch ($p) {
      if ($p instanceof Error) {
        var e_1 = $p;
        println('Error in GameWindowCoroutineDispatcher.executePending:');
        printStackTrace(e_1);
      } else {
        throw $p;
      }
    }
  }
  z8o(elapsedTime, availableTime, processedTimedTasks, processedTasks) {
    // Inline function 'korlibs.logger.Logger.warn' call
    var this_0 = this.g8m_1;
    var level = Level_WARN_getInstance();
    var tmp;
    if (this_0.a2u(level)) {
      // Inline function 'korlibs.render.GameWindowCoroutineDispatcher.informTooManyCallbacksToHandleInThisFrame.<anonymous>' call
      var tmp$ret$0 = 'Too many callbacks to handle in this frame elapsedTime=' + FastDuration__toString_impl_c9xohb(roundMilliseconds(elapsedTime)) + ', availableTime=' + FastDuration__toString_impl_c9xohb(roundMilliseconds(availableTime)) + ' pending timedTasks=' + this.b8m_1.a2r_1 + ', tasks=' + this.a8m_1.e1() + ', processedTimedTasks=' + processedTimedTasks + ', processedTasks=' + processedTasks;
      this_0.b2u(level, tmp$ret$0);
      tmp = Unit_instance;
    }
  }
  f6() {
    // Inline function 'korlibs.time.seconds' call
    // Inline function 'korlibs.time.seconds' call
    var tmp$ret$1 = toDuration(2, DurationUnit_SECONDS_getInstance());
    this.t8n(tmp$ret$1);
    // Inline function 'korlibs.logger.Logger.info' call
    var this_0 = Companion_getInstance_76().t8o_1;
    var level = Level_INFO_getInstance();
    var tmp;
    if (this_0.a2u(level)) {
      // Inline function 'korlibs.render.GameWindowCoroutineDispatcher.close.<anonymous>' call
      var tmp$ret$2 = 'GameWindowCoroutineDispatcher.close';
      this_0.b2u(level, tmp$ret$2);
      tmp = Unit_instance;
    }
    $l$loop: while (true) {
      // Inline function 'kotlin.collections.isNotEmpty' call
      if (!!this.b8m_1.g1()) {
        break $l$loop;
      }
      var tmp0_safe_receiver = this.b8m_1.e2r().q8o_1;
      if (tmp0_safe_receiver == null)
        null;
      else {
        // Inline function 'kotlin.coroutines.resume' call
        // Inline function 'kotlin.Companion.success' call
        var tmp$ret$5 = _Result___init__impl__xyqfz8(Unit_instance);
        tmp0_safe_receiver.tc(tmp$ret$5);
      }
    }
    $l$loop_0: while (true) {
      // Inline function 'kotlin.collections.isNotEmpty' call
      if (!!this.a8m_1.g1()) {
        break $l$loop_0;
      }
      this.a8m_1.i2r().m1a();
    }
  }
  toString() {
    return 'GameWindowCoroutineDispatcher(setNow=setNow, fast=' + this.z8l_1 + ')';
  }
}
class SyncEventLoopCoroutineDispatcher extends CoroutineDispatcher {
  static a8p(eventLoop) {
    var $this = this.o1b();
    $this.v8l_1 = eventLoop;
    return $this;
  }
  static w8l(immediateRun) {
    immediateRun = immediateRun === VOID ? false : immediateRun;
    return this.a8p(new SyncEventLoop(immediateRun));
  }
  f6() {
    this.v8l_1.f6();
  }
  q1b(context, block) {
    this.v8l_1.b69(SyncEventLoopCoroutineDispatcher$dispatch$lambda(block));
  }
  b1c(timeMillis, continuation) {
    var cancelled = {_v: null};
    continuation.z17(SyncEventLoopCoroutineDispatcher$scheduleResumeAfterDelay$lambda(cancelled));
    // Inline function 'korlibs.time.milliseconds' call
    var tmp = toDuration_0(timeMillis, DurationUnit_MILLISECONDS_getInstance());
    this.v8l_1.c69(tmp, SyncEventLoopCoroutineDispatcher$scheduleResumeAfterDelay$lambda_0(cancelled, continuation));
  }
  c1c(timeMillis, block, context) {
    // Inline function 'korlibs.time.milliseconds' call
    var tmp = toDuration_0(timeMillis, DurationUnit_MILLISECONDS_getInstance());
    return toDisposable(this.v8l_1.c69(tmp, SyncEventLoopCoroutineDispatcher$invokeOnTimeout$lambda(block)));
  }
}
class Companion_61 {}
class UpdateEvent extends Event {
  constructor(fastDeltaTime) {
    fastDeltaTime = fastDeltaTime === VOID ? Companion_instance_3.c1v() : fastDeltaTime;
    super();
    this.d8p_1 = fastDeltaTime;
  }
  e8p() {
    return toDuration_1(this.d8p_1);
  }
  w29() {
    return Companion_instance_70;
  }
  toString() {
    return 'UpdateEvent(time=' + FastDuration__toString_impl_c9xohb(this.d8p_1) + ')';
  }
}
class Companion_62 {
  constructor() {
    this.f8p_1 = 536805376;
    this.g8p_1 = 805240832;
    this.h8p_1 = 2;
    this.i8p_1 = 32;
    this.j8p_1 = 256;
    this.k8p_1 = 512;
    this.l8p_1 = 768;
    this.m8p_1 = 769;
    this.n8p_1 = 1024;
    this.o8p_1 = 1025;
    this.p8p_1 = 1026;
    this.q8p_1 = 1027;
  }
}
class SDL extends FFILib {
  static j8q() {
    var $this = this.r2v([get_SDLPath()]);
    var tmp = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config = Companion_getInstance_14().x2v_1;
    tmp.w8p_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(1), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().wf(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().wf(), arrayOf([]), false))]), false), null, config, true)).k2v($this, SDL_Init$factory());
    var tmp_0 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_0 = Companion_getInstance_14().x2v_1;
    tmp_0.x8p_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(6), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().ag(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().wf(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().wf(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().wf(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().wf(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().wf(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(DenoPointer), arrayOf([]), false))]), false), null, config_0, true)).k2v($this, SDL_CreateWindow$factory());
    var tmp_1 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_1 = Companion_getInstance_14().x2v_1;
    tmp_1.y8p_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(2), arrayOf([createInvariantKTypeProjection(createKType(getKClass(DenoPointer), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().ag(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_1, true)).k2v($this, SDL_SetWindowTitle$factory());
    var tmp_2 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_2 = Companion_getInstance_14().x2v_1;
    tmp_2.z8p_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(3), arrayOf([createInvariantKTypeProjection(createKType(getKClass(DenoPointer), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().wf(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().wf(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_2, true)).k2v($this, SDL_SetWindowSize$factory());
    var tmp_3 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_3 = Companion_getInstance_14().x2v_1;
    tmp_3.a8q_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(3), arrayOf([createInvariantKTypeProjection(createKType(getKClass(DenoPointer), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().wf(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().wf(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_3, true)).k2v($this, SDL_SetWindowPosition$factory());
    var tmp_4 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_4 = Companion_getInstance_14().x2v_1;
    tmp_4.b8q_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(1), arrayOf([createInvariantKTypeProjection(createKType(getKClass(DenoPointer), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_4, true)).k2v($this, SDL_ShowWindow$factory());
    var tmp_5 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_5 = Companion_getInstance_14().x2v_1;
    tmp_5.c8q_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(1), arrayOf([createInvariantKTypeProjection(createKType(getKClass(DenoPointer), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_5, true)).k2v($this, SDL_RaiseWindow$factory());
    var tmp_6 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_6 = Companion_getInstance_14().x2v_1;
    tmp_6.d8q_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(1), arrayOf([createInvariantKTypeProjection(createKType(getKClass(DenoPointer), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().tf(), arrayOf([]), false))]), false), null, config_6, true)).k2v($this, SDL_PollEvent$factory());
    var tmp_7 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_7 = Companion_getInstance_14().x2v_1;
    tmp_7.e8q_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(0), arrayOf([createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_7, true)).k2v($this, SDL_Quit$factory());
    var tmp_8 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_8 = Companion_getInstance_14().x2v_1;
    tmp_8.f8q_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(1), arrayOf([createInvariantKTypeProjection(createKType(getKClass(DenoPointer), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(DenoPointer), arrayOf([]), false))]), false), null, config_8, true)).k2v($this, SDL_GL_CreateContext$factory());
    var tmp_9 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_9 = Companion_getInstance_14().x2v_1;
    tmp_9.g8q_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(1), arrayOf([createInvariantKTypeProjection(createKType(getKClass(DenoPointer), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_9, true)).k2v($this, SDL_GL_DeleteContext$factory());
    var tmp_10 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_10 = Companion_getInstance_14().x2v_1;
    tmp_10.h8q_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(2), arrayOf([createInvariantKTypeProjection(createKType(getKClass(DenoPointer), arrayOf([]), true)), createInvariantKTypeProjection(createKType(getKClass(DenoPointer), arrayOf([]), true)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().wf(), arrayOf([]), false))]), false), null, config_10, true)).k2v($this, SDL_GL_MakeCurrent$factory());
    var tmp_11 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_11 = Companion_getInstance_14().x2v_1;
    tmp_11.i8q_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(1), arrayOf([createInvariantKTypeProjection(createKType(getKClass(DenoPointer), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_11, true)).k2v($this, SDL_GL_SwapWindow$factory());
    return $this;
  }
  k8q() {
    return this.w8p_1.oo(this, SDL_Init$factory_0());
  }
  l8q() {
    return this.x8p_1.oo(this, SDL_CreateWindow$factory_0());
  }
  m8q() {
    return this.y8p_1.oo(this, SDL_SetWindowTitle$factory_0());
  }
  n8q() {
    return this.z8p_1.oo(this, SDL_SetWindowSize$factory_0());
  }
  o8q() {
    return this.a8q_1.oo(this, SDL_SetWindowPosition$factory_0());
  }
  p8q() {
    return this.b8q_1.oo(this, SDL_ShowWindow$factory_0());
  }
  q8q() {
    return this.c8q_1.oo(this, SDL_RaiseWindow$factory_0());
  }
  r8q() {
    return this.d8q_1.oo(this, SDL_PollEvent$factory_0());
  }
  s8q() {
    return this.e8q_1.oo(this, SDL_Quit$factory_0());
  }
  t8q() {
    return this.f8q_1.oo(this, SDL_GL_CreateContext$factory_0());
  }
  u8q() {
    return this.g8q_1.oo(this, SDL_GL_DeleteContext$factory_0());
  }
  v8q() {
    return this.h8q_1.oo(this, SDL_GL_MakeCurrent$factory_0());
  }
  w8q() {
    return this.i8q_1.oo(this, SDL_GL_SwapWindow$factory_0());
  }
}
class KmlGlOpenGL extends KmlGl {
  constructor(gl) {
    gl = gl === VOID ? OpenGL.a8x() : gl;
    super();
    this.f8x_1 = gl;
  }
  g8x(_this__u8e3s4) {
    return CreateFFIPointer(toLong(_this__u8e3s4));
  }
  h8x(_this__u8e3s4) {
    return CreateFFIPointer(_this__u8e3s4);
  }
  q78(texture) {
    return this.f8x_1.i8x()(texture);
  }
  v7c(program, shader) {
    return this.f8x_1.j8x()(program, shader);
  }
  u7c(program, index, name) {
    return this.f8x_1.k8x()(program, index, name);
  }
  k77(target, buffer) {
    return this.f8x_1.l8x()(target, buffer);
  }
  n7b(target, framebuffer) {
    return this.f8x_1.m8x()(target, framebuffer);
  }
  u7b(target, renderbuffer) {
    return this.f8x_1.n8x()(target, renderbuffer);
  }
  l7b(target, texture) {
    return this.f8x_1.o8x()(target, texture);
  }
  y79(modeRGB, modeAlpha) {
    return this.f8x_1.p8x()(modeRGB, modeAlpha);
  }
  z79(sfactorRGB, dfactorRGB, sfactorAlpha, dfactorAlpha) {
    return this.f8x_1.q8x()(sfactorRGB, dfactorRGB, sfactorAlpha, dfactorAlpha);
  }
  u78(target, size, data, usage) {
    return this.f8x_1.r8x()(target, this.g8x(size), get_pointer_0(data), usage);
  }
  t78(target, offset, size, data) {
    return this.f8x_1.s8x()(target, this.g8x(offset), this.g8x(size), get_pointer_0(data));
  }
  u79(mask) {
    return this.f8x_1.t8x()(mask);
  }
  p79(red, green, blue, alpha) {
    return this.f8x_1.u8x()(red, green, blue, alpha);
  }
  r79(d) {
    return this.f8x_1.v8x()(d);
  }
  t79(s) {
    return this.f8x_1.w8x()(s);
  }
  b7c(red, green, blue, alpha) {
    var tmp = this.f8x_1.x8x();
    // Inline function 'korlibs.math.toInt' call
    var tmp_0 = red ? 1 : 0;
    // Inline function 'korlibs.math.toInt' call
    var tmp_1 = green ? 1 : 0;
    // Inline function 'korlibs.math.toInt' call
    var tmp_2 = blue ? 1 : 0;
    // Inline function 'korlibs.math.toInt' call
    return tmp(tmp_0, tmp_1, tmp_2, alpha ? 1 : 0);
  }
  m7c(shader) {
    return this.f8x_1.y8x()(shader);
  }
  o7c() {
    return this.f8x_1.z8x()();
  }
  k7c(type) {
    return this.f8x_1.a8y()(type);
  }
  r7a(mode) {
    return this.f8x_1.b8y()(mode);
  }
  y81(n, items) {
    return this.f8x_1.c8y()(n, get_pointer_0(items));
  }
  z81(n, items) {
    return this.f8x_1.d8y()(n, get_pointer_0(items));
  }
  j7c(program) {
    return this.f8x_1.e8y()(program);
  }
  a82(n, items) {
    return this.f8x_1.f8y()(n, get_pointer_0(items));
  }
  i7c(shader) {
    return this.f8x_1.g8y()(shader);
  }
  b82(n, items) {
    return this.f8x_1.h8y()(n, get_pointer_0(items));
  }
  a7c(func) {
    return this.f8x_1.i8y()(func);
  }
  q79(flag) {
    var tmp = this.f8x_1.j8y();
    // Inline function 'korlibs.math.toInt' call
    return tmp(flag ? 1 : 0);
  }
  z7b(n, f) {
    return this.f8x_1.k8y()(n, f);
  }
  d7a(cap) {
    return this.f8x_1.l8y()(cap);
  }
  t7a(index) {
    return this.f8x_1.m8y()(index);
  }
  k7a(mode, first, count) {
    return this.f8x_1.n8y()(mode, first, count);
  }
  m7a(mode, count, type, indices) {
    return this.f8x_1.o8y()(mode, count, type, this.g8x(indices));
  }
  e7a(cap) {
    return this.f8x_1.p8y()(cap);
  }
  x7a(index) {
    return this.f8x_1.q8y()(index);
  }
  qc() {
    return this.f8x_1.r8y()();
  }
  x7b(target, attachment, renderbuffertarget, renderbuffer) {
    return this.f8x_1.s8y()(target, attachment, renderbuffertarget, renderbuffer);
  }
  w7b(target, attachment, textarget, texture, level) {
    return this.f8x_1.t8y()(target, attachment, textarget, texture, level);
  }
  y7b(mode) {
    return this.f8x_1.u8y()(mode);
  }
  c82(n, buffers) {
    return this.f8x_1.v8y()(n, get_pointer_0(buffers));
  }
  y78(target) {
    return this.f8x_1.w8y()(target);
  }
  d82(n, framebuffers) {
    return this.f8x_1.x8y()(n, get_pointer_0(framebuffers));
  }
  e82(n, renderbuffers) {
    return this.f8x_1.y8y()(n, get_pointer_0(renderbuffers));
  }
  f82(n, textures) {
    return this.f8x_1.z8y()(n, get_pointer_0(textures));
  }
  g7c(program, name) {
    return this.f8x_1.a8z()(program, name);
  }
  n7c() {
    return this.f8x_1.b8z()();
  }
  g82(pname, data) {
    return this.f8x_1.c8z()(pname, get_pointer_0(data));
  }
  h82(program, pname, params) {
    return this.f8x_1.d8z()(program, pname, get_pointer_0(params));
  }
  i82(shader, pname, params) {
    return this.f8x_1.e8z()(shader, pname, get_pointer_0(params));
  }
  j82(shader, bufSize, length, infoLog) {
    this.f8x_1.f8z()(shader, bufSize, get_pointer_0(length), get_pointer_0(infoLog));
  }
  f75(name) {
    var tmp0_elvis_lhs = this.f8x_1.g8z()(name);
    return tmp0_elvis_lhs == null ? '' : tmp0_elvis_lhs;
  }
  w7c(program) {
    return this.f8x_1.h8z()(program);
  }
  v78(pname, param) {
    return this.f8x_1.i8z()(pname, param);
  }
  v7b(target, internalformat, width, height) {
    return this.f8x_1.j8z()(target, internalformat, width, height);
  }
  c7c(x, y, width, height) {
    return this.f8x_1.k8z()(x, y, width, height);
  }
  l7c(shader, string) {
    // Inline function 'korlibs.ffi.usePointer' call
    var this_0 = CreateFFIMemory(8);
    var lengthsPtr = get_pointer(Deno.UnsafePointer.of(this_0));
    var bytes = encodeToByteArray(string + '\x00');
    set32(lengthsPtr, bytes.length - 1 | 0);
    // Inline function 'korlibs.ffi.usePointer' call
    var this_1 = CreateFFIMemory_0(bytes);
    var strPtr = get_pointer(Deno.UnsafePointer.of(this_1));
    // Inline function 'korlibs.ffi.usePointer' call
    var this_2 = CreateFFIMemory(8);
    var strPtrPtr = get_pointer(Deno.UnsafePointer.of(this_2));
    setFFIPointer(strPtrPtr, strPtr);
    this.f8x_1.l8z()(shader, 1, strPtrPtr, lengthsPtr);
  }
  g7a(func, ref, mask) {
    return this.f8x_1.m8z()(func, ref, mask);
  }
  f7a(face, func, ref, mask) {
    return this.f8x_1.n8z()(face, func, ref, mask);
  }
  s79(mask) {
    return this.f8x_1.o8z()(mask);
  }
  j7a(face, mask) {
    return this.f8x_1.p8z()(face, mask);
  }
  i7a(fail, zfail, zpass) {
    return this.f8x_1.q8z()(fail, zfail, zpass);
  }
  h7a(face, sfail, dpfail, dppass) {
    return this.f8x_1.r8z()(face, sfail, dpfail, dppass);
  }
  w78(target, level, internalformat, width, height, border, format, type, pixels) {
    var tmp = this.f8x_1.s8z();
    tmp(target, level, internalformat, width, height, border, format, type, pixels == null ? null : get_pointer_0(pixels));
  }
  p78(target, pname, param) {
    return this.f8x_1.t8z()(target, pname, param);
  }
  l78(location, count, value) {
    return this.f8x_1.u8z()(location, count, get_pointer_0(value));
  }
  j76(location, v0) {
    return this.f8x_1.v8z()(location, v0);
  }
  e78(location, count, value) {
    return this.f8x_1.w8z()(location, count, get_pointer_0(value));
  }
  m78(location, count, value) {
    return this.f8x_1.x8z()(location, count, get_pointer_0(value));
  }
  f78(location, count, value) {
    return this.f8x_1.y8z()(location, count, get_pointer_0(value));
  }
  n78(location, count, value) {
    return this.f8x_1.z8z()(location, count, get_pointer_0(value));
  }
  g78(location, count, value) {
    return this.f8x_1.a90()(location, count, get_pointer_0(value));
  }
  o78(location, count, value) {
    return this.f8x_1.b90()(location, count, get_pointer_0(value));
  }
  h78(location, count, value) {
    return this.f8x_1.c90()(location, count, get_pointer_0(value));
  }
  i78(location, count, transpose, value) {
    var tmp = this.f8x_1.d90();
    // Inline function 'korlibs.math.toInt' call
    return tmp(location, count, transpose ? 1 : 0, get_pointer_0(value));
  }
  j78(location, count, transpose, value) {
    var tmp = this.f8x_1.e90();
    // Inline function 'korlibs.math.toInt' call
    return tmp(location, count, transpose ? 1 : 0, get_pointer_0(value));
  }
  k78(location, count, transpose, value) {
    var tmp = this.f8x_1.f90();
    // Inline function 'korlibs.math.toInt' call
    return tmp(location, count, transpose ? 1 : 0, get_pointer_0(value));
  }
  h7c(program) {
    return this.f8x_1.g90()(program);
  }
  y7a(index, size, type, normalized, stride, pointer) {
    var tmp = this.f8x_1.h90();
    // Inline function 'korlibs.math.toInt' call
    return tmp(index, size, type, normalized ? 1 : 0, stride, this.h8x(pointer));
  }
  m7b(x, y, width, height) {
    return this.f8x_1.i90()(x, y, width, height);
  }
  l7a(mode, first, count, instancecount) {
    return this.f8x_1.j90()(mode, first, count, instancecount);
  }
  n7a(mode, count, type, indices, instancecount) {
    return this.f8x_1.k90()(mode, count, type, this.g8x(indices), instancecount);
  }
  s7a(index, divisor) {
    return this.f8x_1.l90()(index, divisor);
  }
  p6j() {
    return true;
  }
  f7b(target, index, buffer, offset, size) {
    return this.f8x_1.m90()(target, index, buffer, this.g8x(offset), this.g8x(size));
  }
  k76(program, name) {
    return this.f8x_1.n90()(program, name);
  }
  l76(program, uniformBlockIndex, uniformBlockBinding) {
    return this.f8x_1.o90()(program, uniformBlockIndex, uniformBlockBinding);
  }
  q6j() {
    return true;
  }
  k82(n, arrays) {
    return this.f8x_1.p90()(n, get_pointer_0(arrays));
  }
  u7a(array) {
    return this.f8x_1.q90()(array);
  }
}
class Companion_63 {
  constructor() {
    this.r90_1 = 16384;
  }
}
class OpenGL extends FFILib {
  static a8x() {
    var $this = this.r2v(['/System/Library/Frameworks/OpenGL.framework/OpenGL']);
    var tmp = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config = Companion_getInstance_14().x2v_1;
    tmp.c8r_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(4), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().wf(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().wf(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().wf(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().wf(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config, true)).k2v($this, glDrawArraysInstanced$factory());
    var tmp_0 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_0 = Companion_getInstance_14().x2v_1;
    tmp_0.d8r_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(5), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().wf(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().wf(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().wf(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(DenoPointer), arrayOf([]), true)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().wf(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_0, true)).k2v($this, glDrawElementsInstanced$factory());
    var tmp_1 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_1 = Companion_getInstance_14().x2v_1;
    tmp_1.e8r_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(2), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().wf(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().wf(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_1, true)).k2v($this, glVertexAttribDivisor$factory());
    var tmp_2 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_2 = Companion_getInstance_14().x2v_1;
    tmp_2.f8r_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(9), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().wf(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().wf(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().wf(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().wf(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().wf(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().wf(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().wf(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().wf(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(DenoPointer), arrayOf([]), true)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_2, true)).k2v($this, glTexSubImage2D$factory());
    var tmp_3 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_3 = Companion_getInstance_14().x2v_1;
    tmp_3.g8r_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(9), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().wf(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().wf(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().wf(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().wf(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().wf(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().wf(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().wf(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().wf(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(DenoPointer), arrayOf([]), true)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_3, true)).k2v($this, glTexImage2D$factory());
    var tmp_4 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_4 = Companion_getInstance_14().x2v_1;
    tmp_4.h8r_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(3), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().wf(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().wf(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().wf(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_4, true)).k2v($this, glTexParameteri$factory());
    var tmp_5 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_5 = Companion_getInstance_14().x2v_1;
    tmp_5.i8r_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(3), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().wf(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().wf(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().xf(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_5, true)).k2v($this, glTexParameterf$factory());
    var tmp_6 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_6 = Companion_getInstance_14().x2v_1;
    tmp_6.j8r_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(3), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().wf(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().wf(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(DenoPointer), arrayOf([]), true)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_6, true)).k2v($this, glTexParameterfv$factory());
    var tmp_7 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_7 = Companion_getInstance_14().x2v_1;
    tmp_7.k8r_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(3), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().wf(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().wf(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(DenoPointer), arrayOf([]), true)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_7, true)).k2v($this, glTexParameteriv$factory());
    var tmp_8 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_8 = Companion_getInstance_14().x2v_1;
    tmp_8.l8r_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(3), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().wf(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().wf(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().wf(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_8, true)).k2v($this, glStencilOp$factory());
    var tmp_9 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_9 = Companion_getInstance_14().x2v_1;
    tmp_9.m8r_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(1), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().wf(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_9, true)).k2v($this, glStencilMask$factory());
    var tmp_10 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_10 = Companion_getInstance_14().x2v_1;
    tmp_10.n8r_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(7), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().wf(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().wf(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().wf(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().wf(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().wf(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().wf(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(DenoPointer), arrayOf([]), true)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_10, true)).k2v($this, glReadPixels$factory());
    var tmp_11 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_11 = Companion_getInstance_14().x2v_1;
    tmp_11.o8r_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(3), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().wf(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().wf(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().wf(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_11, true)).k2v($this, glStencilFunc$factory());
    var tmp_12 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_12 = Companion_getInstance_14().x2v_1;
    tmp_12.p8r_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(4), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().wf(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().wf(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().wf(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().wf(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_12, true)).k2v($this, glScissor$factory());
    var tmp_13 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_13 = Companion_getInstance_14().x2v_1;
    tmp_13.q8r_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(2), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().xf(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().xf(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_13, true)).k2v($this, glPolygonOffset$factory());
    var tmp_14 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_14 = Companion_getInstance_14().x2v_1;
    tmp_14.r8r_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(2), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().wf(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().wf(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_14, true)).k2v($this, glPixelStorei$factory());
    var tmp_15 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_15 = Companion_getInstance_14().x2v_1;
    tmp_15.s8r_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(1), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().xf(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_15, true)).k2v($this, glLineWidth$factory());
    var tmp_16 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_16 = Companion_getInstance_14().x2v_1;
    tmp_16.t8r_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(3), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().wf(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().wf(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(DenoPointer), arrayOf([]), true)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_16, true)).k2v($this, glGetTexParameterfv$factory());
    var tmp_17 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_17 = Companion_getInstance_14().x2v_1;
    tmp_17.u8r_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(3), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().wf(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().wf(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(DenoPointer), arrayOf([]), true)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_17, true)).k2v($this, glGetTexParameteriv$factory());
    var tmp_18 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_18 = Companion_getInstance_14().x2v_1;
    tmp_18.v8r_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(0), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().wf(), arrayOf([]), false))]), false), null, config_18, true)).k2v($this, glGetError$factory());
    var tmp_19 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_19 = Companion_getInstance_14().x2v_1;
    tmp_19.w8r_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(2), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().wf(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(DenoPointer), arrayOf([]), true)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_19, true)).k2v($this, glGetFloatv$factory());
    var tmp_20 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_20 = Companion_getInstance_14().x2v_1;
    tmp_20.x8r_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(2), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().wf(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(DenoPointer), arrayOf([]), true)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_20, true)).k2v($this, glGetIntegerv$factory());
    var tmp_21 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_21 = Companion_getInstance_14().x2v_1;
    tmp_21.y8r_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(2), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().wf(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(DenoPointer), arrayOf([]), true)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_21, true)).k2v($this, glGetBooleanv$factory());
    var tmp_22 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_22 = Companion_getInstance_14().x2v_1;
    tmp_22.z8r_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(2), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().wf(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(DenoPointer), arrayOf([]), true)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_22, true)).k2v($this, glGenTextures$factory());
    var tmp_23 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_23 = Companion_getInstance_14().x2v_1;
    tmp_23.a8s_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(2), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().xf(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().xf(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_23, true)).k2v($this, glDepthRange$factory());
    var tmp_24 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_24 = Companion_getInstance_14().x2v_1;
    tmp_24.b8s_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(2), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().xf(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().xf(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_24, true)).k2v($this, glDepthRangef$factory());
    var tmp_25 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_25 = Companion_getInstance_14().x2v_1;
    tmp_25.c8s_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(1), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().xf(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_25, true)).k2v($this, glClearDepth$factory());
    var tmp_26 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_26 = Companion_getInstance_14().x2v_1;
    tmp_26.d8s_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(1), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().xf(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_26, true)).k2v($this, glClearDepthf$factory());
    var tmp_27 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_27 = Companion_getInstance_14().x2v_1;
    tmp_27.e8s_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(3), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().wf(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().wf(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().wf(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_27, true)).k2v($this, glDrawArrays$factory());
    var tmp_28 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_28 = Companion_getInstance_14().x2v_1;
    tmp_28.f8s_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(4), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().wf(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().wf(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().wf(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(DenoPointer), arrayOf([]), true)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_28, true)).k2v($this, glDrawElements$factory());
    var tmp_29 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_29 = Companion_getInstance_14().x2v_1;
    tmp_29.g8s_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(1), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().wf(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_29, true)).k2v($this, glFrontFace$factory());
    var tmp_30 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_30 = Companion_getInstance_14().x2v_1;
    tmp_30.h8s_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(0), arrayOf([createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_30, true)).k2v($this, glFinish$factory());
    var tmp_31 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_31 = Companion_getInstance_14().x2v_1;
    tmp_31.i8s_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(0), arrayOf([createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_31, true)).k2v($this, glFlush$factory());
    var tmp_32 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_32 = Companion_getInstance_14().x2v_1;
    tmp_32.j8s_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(1), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().wf(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_32, true)).k2v($this, glEnable$factory());
    var tmp_33 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_33 = Companion_getInstance_14().x2v_1;
    tmp_33.k8s_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(1), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().wf(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().wf(), arrayOf([]), false))]), false), null, config_33, true)).k2v($this, glIsEnabled$factory());
    var tmp_34 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_34 = Companion_getInstance_14().x2v_1;
    tmp_34.l8s_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(1), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().wf(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_34, true)).k2v($this, glDisable$factory());
    var tmp_35 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_35 = Companion_getInstance_14().x2v_1;
    tmp_35.m8s_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(1), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().wf(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_35, true)).k2v($this, glDepthMask$factory());
    var tmp_36 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_36 = Companion_getInstance_14().x2v_1;
    tmp_36.n8s_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(1), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().wf(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_36, true)).k2v($this, glDepthFunc$factory());
    var tmp_37 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_37 = Companion_getInstance_14().x2v_1;
    tmp_37.o8s_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(2), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().wf(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(DenoPointer), arrayOf([]), true)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_37, true)).k2v($this, glDeleteTextures$factory());
    var tmp_38 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_38 = Companion_getInstance_14().x2v_1;
    tmp_38.p8s_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(1), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().wf(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_38, true)).k2v($this, glCullFace$factory());
    var tmp_39 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_39 = Companion_getInstance_14().x2v_1;
    tmp_39.q8s_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(8), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().wf(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().wf(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().wf(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().wf(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().wf(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().wf(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().wf(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().wf(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_39, true)).k2v($this, glCopyTexImage2D$factory());
    var tmp_40 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_40 = Companion_getInstance_14().x2v_1;
    tmp_40.r8s_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(8), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().wf(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().wf(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().wf(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().wf(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().wf(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().wf(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().wf(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().wf(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_40, true)).k2v($this, glCopyTexSubImage2D$factory());
    var tmp_41 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_41 = Companion_getInstance_14().x2v_1;
    tmp_41.s8s_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(4), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().wf(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().wf(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().wf(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().wf(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_41, true)).k2v($this, glColorMask$factory());
    var tmp_42 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_42 = Companion_getInstance_14().x2v_1;
    tmp_42.t8s_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(1), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().wf(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_42, true)).k2v($this, glClearStencil$factory());
    var tmp_43 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_43 = Companion_getInstance_14().x2v_1;
    tmp_43.u8s_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(4), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().xf(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().xf(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().xf(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().xf(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_43, true)).k2v($this, glClearColor$factory());
    var tmp_44 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_44 = Companion_getInstance_14().x2v_1;
    tmp_44.v8s_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(1), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().wf(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_44, true)).k2v($this, glClear$factory());
    var tmp_45 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_45 = Companion_getInstance_14().x2v_1;
    tmp_45.w8s_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(2), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().wf(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().wf(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_45, true)).k2v($this, glBindTexture$factory());
    var tmp_46 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_46 = Companion_getInstance_14().x2v_1;
    tmp_46.x8s_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(2), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().wf(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().wf(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_46, true)).k2v($this, glHint$factory());
    var tmp_47 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_47 = Companion_getInstance_14().x2v_1;
    tmp_47.y8s_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(4), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().wf(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().wf(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().wf(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().wf(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_47, true)).k2v($this, glViewport$factory());
    var tmp_48 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_48 = Companion_getInstance_14().x2v_1;
    tmp_48.z8s_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(1), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().wf(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().ag(), arrayOf([]), true))]), false), null, config_48, true)).k2v($this, glGetString$factory());
    var tmp_49 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_49 = Companion_getInstance_14().x2v_1;
    tmp_49.a8t_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(2), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().wf(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().wf(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().ag(), arrayOf([]), true))]), false), null, config_49, true)).k2v($this, glGetStringi$factory());
    var tmp_50 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_50 = Companion_getInstance_14().x2v_1;
    tmp_50.b8t_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(6), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().wf(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().wf(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().wf(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().wf(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().wf(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(DenoPointer), arrayOf([]), true)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_50, true)).k2v($this, glVertexAttribPointer$factory());
    var tmp_51 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_51 = Companion_getInstance_14().x2v_1;
    tmp_51.c8t_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(2), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().wf(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(DenoPointer), arrayOf([]), true)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_51, true)).k2v($this, glVertexAttrib4fv$factory());
    var tmp_52 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_52 = Companion_getInstance_14().x2v_1;
    tmp_52.d8t_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(1), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().wf(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_52, true)).k2v($this, glActiveTexture$factory());
    var tmp_53 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_53 = Companion_getInstance_14().x2v_1;
    tmp_53.e8t_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(2), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().wf(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().wf(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_53, true)).k2v($this, glAttachShader$factory());
    var tmp_54 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_54 = Companion_getInstance_14().x2v_1;
    tmp_54.f8t_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(3), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().wf(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().wf(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().ag(), arrayOf([]), true)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_54, true)).k2v($this, glBindAttribLocation$factory());
    var tmp_55 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_55 = Companion_getInstance_14().x2v_1;
    tmp_55.g8t_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(2), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().wf(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().wf(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_55, true)).k2v($this, glBindBuffer$factory());
    var tmp_56 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_56 = Companion_getInstance_14().x2v_1;
    tmp_56.h8t_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(2), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().wf(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().wf(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_56, true)).k2v($this, glBindFramebuffer$factory());
    var tmp_57 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_57 = Companion_getInstance_14().x2v_1;
    tmp_57.i8t_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(2), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().wf(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().wf(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_57, true)).k2v($this, glBindRenderbuffer$factory());
    var tmp_58 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_58 = Companion_getInstance_14().x2v_1;
    tmp_58.j8t_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(4), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().xf(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().xf(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().xf(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().xf(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_58, true)).k2v($this, glBlendColor$factory());
    var tmp_59 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_59 = Companion_getInstance_14().x2v_1;
    tmp_59.k8t_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(1), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().wf(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_59, true)).k2v($this, glBlendEquation$factory());
    var tmp_60 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_60 = Companion_getInstance_14().x2v_1;
    tmp_60.l8t_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(2), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().wf(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().wf(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_60, true)).k2v($this, glBlendEquationSeparate$factory());
    var tmp_61 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_61 = Companion_getInstance_14().x2v_1;
    tmp_61.m8t_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(2), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().wf(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().wf(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_61, true)).k2v($this, glBlendFunc$factory());
    var tmp_62 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_62 = Companion_getInstance_14().x2v_1;
    tmp_62.n8t_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(4), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().wf(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().wf(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().wf(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().wf(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_62, true)).k2v($this, glBlendFuncSeparate$factory());
    var tmp_63 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_63 = Companion_getInstance_14().x2v_1;
    tmp_63.o8t_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(4), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().wf(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(DenoPointer), arrayOf([]), true)), createInvariantKTypeProjection(createKType(getKClass(DenoPointer), arrayOf([]), true)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().wf(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_63, true)).k2v($this, glBufferData$factory());
    var tmp_64 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_64 = Companion_getInstance_14().x2v_1;
    tmp_64.p8t_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(4), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().wf(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(DenoPointer), arrayOf([]), true)), createInvariantKTypeProjection(createKType(getKClass(DenoPointer), arrayOf([]), true)), createInvariantKTypeProjection(createKType(getKClass(DenoPointer), arrayOf([]), true)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_64, true)).k2v($this, glBufferSubData$factory());
    var tmp_65 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_65 = Companion_getInstance_14().x2v_1;
    tmp_65.q8t_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(1), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().wf(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().wf(), arrayOf([]), false))]), false), null, config_65, true)).k2v($this, glCheckFramebufferStatus$factory());
    var tmp_66 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_66 = Companion_getInstance_14().x2v_1;
    tmp_66.r8t_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(1), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().wf(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_66, true)).k2v($this, glCompileShader$factory());
    var tmp_67 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_67 = Companion_getInstance_14().x2v_1;
    tmp_67.s8t_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(8), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().wf(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().wf(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().wf(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().wf(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().wf(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().wf(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().wf(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(DenoPointer), arrayOf([]), true)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_67, true)).k2v($this, glCompressedTexImage2D$factory());
    var tmp_68 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_68 = Companion_getInstance_14().x2v_1;
    tmp_68.t8t_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(9), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().wf(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().wf(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().wf(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().wf(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().wf(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().wf(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().wf(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().wf(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(DenoPointer), arrayOf([]), true)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_68, true)).k2v($this, glCompressedTexSubImage2D$factory());
    var tmp_69 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_69 = Companion_getInstance_14().x2v_1;
    tmp_69.u8t_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(0), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().wf(), arrayOf([]), false))]), false), null, config_69, true)).k2v($this, glCreateProgram$factory());
    var tmp_70 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_70 = Companion_getInstance_14().x2v_1;
    tmp_70.v8t_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(1), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().wf(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().wf(), arrayOf([]), false))]), false), null, config_70, true)).k2v($this, glCreateShader$factory());
    var tmp_71 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_71 = Companion_getInstance_14().x2v_1;
    tmp_71.w8t_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(2), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().wf(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(DenoPointer), arrayOf([]), true)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_71, true)).k2v($this, glDeleteBuffers$factory());
    var tmp_72 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_72 = Companion_getInstance_14().x2v_1;
    tmp_72.x8t_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(2), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().wf(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(DenoPointer), arrayOf([]), true)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_72, true)).k2v($this, glDeleteFramebuffers$factory());
    var tmp_73 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_73 = Companion_getInstance_14().x2v_1;
    tmp_73.y8t_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(1), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().wf(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_73, true)).k2v($this, glDeleteProgram$factory());
    var tmp_74 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_74 = Companion_getInstance_14().x2v_1;
    tmp_74.z8t_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(2), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().wf(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(DenoPointer), arrayOf([]), true)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_74, true)).k2v($this, glDeleteRenderbuffers$factory());
    var tmp_75 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_75 = Companion_getInstance_14().x2v_1;
    tmp_75.a8u_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(1), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().wf(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_75, true)).k2v($this, glDeleteShader$factory());
    var tmp_76 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_76 = Companion_getInstance_14().x2v_1;
    tmp_76.b8u_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(2), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().wf(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().wf(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_76, true)).k2v($this, glDetachShader$factory());
    var tmp_77 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_77 = Companion_getInstance_14().x2v_1;
    tmp_77.c8u_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(1), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().wf(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_77, true)).k2v($this, glDisableVertexAttribArray$factory());
    var tmp_78 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_78 = Companion_getInstance_14().x2v_1;
    tmp_78.d8u_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(1), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().wf(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_78, true)).k2v($this, glEnableVertexAttribArray$factory());
    var tmp_79 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_79 = Companion_getInstance_14().x2v_1;
    tmp_79.e8u_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(4), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().wf(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().wf(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().wf(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().wf(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_79, true)).k2v($this, glFramebufferRenderbuffer$factory());
    var tmp_80 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_80 = Companion_getInstance_14().x2v_1;
    tmp_80.f8u_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(5), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().wf(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().wf(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().wf(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().wf(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().wf(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_80, true)).k2v($this, glFramebufferTexture2D$factory());
    var tmp_81 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_81 = Companion_getInstance_14().x2v_1;
    tmp_81.g8u_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(2), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().wf(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(DenoPointer), arrayOf([]), true)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_81, true)).k2v($this, glGenBuffers$factory());
    var tmp_82 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_82 = Companion_getInstance_14().x2v_1;
    tmp_82.h8u_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(1), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().wf(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_82, true)).k2v($this, glGenerateMipmap$factory());
    var tmp_83 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_83 = Companion_getInstance_14().x2v_1;
    tmp_83.i8u_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(2), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().wf(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(DenoPointer), arrayOf([]), true)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_83, true)).k2v($this, glGenFramebuffers$factory());
    var tmp_84 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_84 = Companion_getInstance_14().x2v_1;
    tmp_84.j8u_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(2), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().wf(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(DenoPointer), arrayOf([]), true)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_84, true)).k2v($this, glGenRenderbuffers$factory());
    var tmp_85 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_85 = Companion_getInstance_14().x2v_1;
    tmp_85.k8u_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(7), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().wf(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().wf(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().wf(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(DenoPointer), arrayOf([]), true)), createInvariantKTypeProjection(createKType(getKClass(DenoPointer), arrayOf([]), true)), createInvariantKTypeProjection(createKType(getKClass(DenoPointer), arrayOf([]), true)), createInvariantKTypeProjection(createKType(getKClass(DenoPointer), arrayOf([]), true)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_85, true)).k2v($this, glGetActiveAttrib$factory());
    var tmp_86 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_86 = Companion_getInstance_14().x2v_1;
    tmp_86.l8u_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(7), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().wf(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().wf(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().wf(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(DenoPointer), arrayOf([]), true)), createInvariantKTypeProjection(createKType(getKClass(DenoPointer), arrayOf([]), true)), createInvariantKTypeProjection(createKType(getKClass(DenoPointer), arrayOf([]), true)), createInvariantKTypeProjection(createKType(getKClass(DenoPointer), arrayOf([]), true)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_86, true)).k2v($this, glGetActiveUniform$factory());
    var tmp_87 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_87 = Companion_getInstance_14().x2v_1;
    tmp_87.m8u_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(4), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().wf(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().wf(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(DenoPointer), arrayOf([]), true)), createInvariantKTypeProjection(createKType(getKClass(DenoPointer), arrayOf([]), true)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_87, true)).k2v($this, glGetAttachedShaders$factory());
    var tmp_88 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_88 = Companion_getInstance_14().x2v_1;
    tmp_88.n8u_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(2), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().wf(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().ag(), arrayOf([]), true)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().wf(), arrayOf([]), false))]), false), null, config_88, true)).k2v($this, glGetAttribLocation$factory());
    var tmp_89 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_89 = Companion_getInstance_14().x2v_1;
    tmp_89.o8u_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(2), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().wf(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().ag(), arrayOf([]), true)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().wf(), arrayOf([]), false))]), false), null, config_89, true)).k2v($this, glGetUniformLocation$factory());
    var tmp_90 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_90 = Companion_getInstance_14().x2v_1;
    tmp_90.p8u_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(3), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().wf(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().wf(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(DenoPointer), arrayOf([]), true)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_90, true)).k2v($this, glGetBufferParameteriv$factory());
    var tmp_91 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_91 = Companion_getInstance_14().x2v_1;
    tmp_91.q8u_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(4), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().wf(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().wf(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().wf(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(DenoPointer), arrayOf([]), true)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_91, true)).k2v($this, glGetFramebufferAttachmentParameteriv$factory());
    var tmp_92 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_92 = Companion_getInstance_14().x2v_1;
    tmp_92.r8u_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(4), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().wf(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().wf(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(DenoPointer), arrayOf([]), true)), createInvariantKTypeProjection(createKType(getKClass(DenoPointer), arrayOf([]), true)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_92, true)).k2v($this, glGetProgramInfoLog$factory());
    var tmp_93 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_93 = Companion_getInstance_14().x2v_1;
    tmp_93.s8u_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(3), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().wf(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().wf(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(DenoPointer), arrayOf([]), true)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_93, true)).k2v($this, glGetRenderbufferParameteriv$factory());
    var tmp_94 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_94 = Companion_getInstance_14().x2v_1;
    tmp_94.t8u_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(3), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().wf(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().wf(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(DenoPointer), arrayOf([]), true)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_94, true)).k2v($this, glGetProgramiv$factory());
    var tmp_95 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_95 = Companion_getInstance_14().x2v_1;
    tmp_95.u8u_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(3), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().wf(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().wf(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(DenoPointer), arrayOf([]), true)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_95, true)).k2v($this, glGetShaderiv$factory());
    var tmp_96 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_96 = Companion_getInstance_14().x2v_1;
    tmp_96.v8u_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(4), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().wf(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().wf(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(DenoPointer), arrayOf([]), true)), createInvariantKTypeProjection(createKType(getKClass(DenoPointer), arrayOf([]), true)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_96, true)).k2v($this, glGetShaderInfoLog$factory());
    var tmp_97 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_97 = Companion_getInstance_14().x2v_1;
    tmp_97.w8u_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(3), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().wf(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(DenoPointer), arrayOf([]), true)), createInvariantKTypeProjection(createKType(getKClass(DenoPointer), arrayOf([]), true)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_97, true)).k2v($this, glGetShaderPrecisionFormat$factory());
    var tmp_98 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_98 = Companion_getInstance_14().x2v_1;
    tmp_98.x8u_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(4), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().wf(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().wf(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(DenoPointer), arrayOf([]), true)), createInvariantKTypeProjection(createKType(getKClass(DenoPointer), arrayOf([]), true)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_98, true)).k2v($this, glGetShaderSource$factory());
    var tmp_99 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_99 = Companion_getInstance_14().x2v_1;
    tmp_99.y8u_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(3), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().wf(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().wf(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(DenoPointer), arrayOf([]), true)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_99, true)).k2v($this, glGetUniformfv$factory());
    var tmp_100 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_100 = Companion_getInstance_14().x2v_1;
    tmp_100.z8u_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(3), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().wf(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().wf(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(DenoPointer), arrayOf([]), true)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_100, true)).k2v($this, glGetUniformiv$factory());
    var tmp_101 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_101 = Companion_getInstance_14().x2v_1;
    tmp_101.a8v_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(3), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().wf(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().wf(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(DenoPointer), arrayOf([]), true)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_101, true)).k2v($this, glGetVertexAttribfv$factory());
    var tmp_102 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_102 = Companion_getInstance_14().x2v_1;
    tmp_102.b8v_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(3), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().wf(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().wf(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(DenoPointer), arrayOf([]), true)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_102, true)).k2v($this, glGetVertexAttribiv$factory());
    var tmp_103 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_103 = Companion_getInstance_14().x2v_1;
    tmp_103.c8v_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(3), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().wf(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().wf(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(DenoPointer), arrayOf([]), true)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_103, true)).k2v($this, glGetVertexAttribPointerv$factory());
    var tmp_104 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_104 = Companion_getInstance_14().x2v_1;
    tmp_104.d8v_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(1), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().wf(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().wf(), arrayOf([]), false))]), false), null, config_104, true)).k2v($this, glIsBuffer$factory());
    var tmp_105 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_105 = Companion_getInstance_14().x2v_1;
    tmp_105.e8v_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(1), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().wf(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().wf(), arrayOf([]), false))]), false), null, config_105, true)).k2v($this, glIsFramebuffer$factory());
    var tmp_106 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_106 = Companion_getInstance_14().x2v_1;
    tmp_106.f8v_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(1), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().wf(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().wf(), arrayOf([]), false))]), false), null, config_106, true)).k2v($this, glIsProgram$factory());
    var tmp_107 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_107 = Companion_getInstance_14().x2v_1;
    tmp_107.g8v_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(1), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().wf(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().wf(), arrayOf([]), false))]), false), null, config_107, true)).k2v($this, glIsRenderbuffer$factory());
    var tmp_108 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_108 = Companion_getInstance_14().x2v_1;
    tmp_108.h8v_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(1), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().wf(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().wf(), arrayOf([]), false))]), false), null, config_108, true)).k2v($this, glIsTexture$factory());
    var tmp_109 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_109 = Companion_getInstance_14().x2v_1;
    tmp_109.i8v_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(1), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().wf(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().wf(), arrayOf([]), false))]), false), null, config_109, true)).k2v($this, glIsShader$factory());
    var tmp_110 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_110 = Companion_getInstance_14().x2v_1;
    tmp_110.j8v_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(1), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().wf(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_110, true)).k2v($this, glLinkProgram$factory());
    var tmp_111 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_111 = Companion_getInstance_14().x2v_1;
    tmp_111.k8v_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(0), arrayOf([createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_111, true)).k2v($this, glReleaseShaderCompiler$factory());
    var tmp_112 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_112 = Companion_getInstance_14().x2v_1;
    tmp_112.l8v_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(4), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().wf(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().wf(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().wf(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().wf(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_112, true)).k2v($this, glRenderbufferStorage$factory());
    var tmp_113 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_113 = Companion_getInstance_14().x2v_1;
    tmp_113.m8v_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(2), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().xf(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().wf(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_113, true)).k2v($this, glSampleCoverage$factory());
    var tmp_114 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_114 = Companion_getInstance_14().x2v_1;
    tmp_114.n8v_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(5), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().wf(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(DenoPointer), arrayOf([]), true)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().wf(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(DenoPointer), arrayOf([]), true)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().wf(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_114, true)).k2v($this, glShaderBinary$factory());
    var tmp_115 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_115 = Companion_getInstance_14().x2v_1;
    tmp_115.o8v_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(4), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().wf(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().wf(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(DenoPointer), arrayOf([]), true)), createInvariantKTypeProjection(createKType(getKClass(DenoPointer), arrayOf([]), true)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_115, true)).k2v($this, glShaderSource$factory());
    var tmp_116 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_116 = Companion_getInstance_14().x2v_1;
    tmp_116.p8v_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(4), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().wf(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().wf(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().wf(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().wf(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_116, true)).k2v($this, glStencilFuncSeparate$factory());
    var tmp_117 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_117 = Companion_getInstance_14().x2v_1;
    tmp_117.q8v_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(2), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().wf(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().wf(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_117, true)).k2v($this, glStencilMaskSeparate$factory());
    var tmp_118 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_118 = Companion_getInstance_14().x2v_1;
    tmp_118.r8v_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(4), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().wf(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().wf(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().wf(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().wf(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_118, true)).k2v($this, glStencilOpSeparate$factory());
    var tmp_119 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_119 = Companion_getInstance_14().x2v_1;
    tmp_119.s8v_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(2), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().wf(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().xf(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_119, true)).k2v($this, glUniform1f$factory());
    var tmp_120 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_120 = Companion_getInstance_14().x2v_1;
    tmp_120.t8v_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(3), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().wf(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().xf(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().xf(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_120, true)).k2v($this, glUniform2f$factory());
    var tmp_121 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_121 = Companion_getInstance_14().x2v_1;
    tmp_121.u8v_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(4), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().wf(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().xf(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().xf(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().xf(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_121, true)).k2v($this, glUniform3f$factory());
    var tmp_122 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_122 = Companion_getInstance_14().x2v_1;
    tmp_122.v8v_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(5), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().wf(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().xf(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().xf(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().xf(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().xf(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_122, true)).k2v($this, glUniform4f$factory());
    var tmp_123 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_123 = Companion_getInstance_14().x2v_1;
    tmp_123.w8v_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(2), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().wf(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().wf(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_123, true)).k2v($this, glUniform1i$factory());
    var tmp_124 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_124 = Companion_getInstance_14().x2v_1;
    tmp_124.x8v_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(3), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().wf(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().wf(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().wf(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_124, true)).k2v($this, glUniform2i$factory());
    var tmp_125 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_125 = Companion_getInstance_14().x2v_1;
    tmp_125.y8v_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(4), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().wf(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().wf(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().wf(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().wf(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_125, true)).k2v($this, glUniform3i$factory());
    var tmp_126 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_126 = Companion_getInstance_14().x2v_1;
    tmp_126.z8v_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(5), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().wf(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().wf(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().wf(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().wf(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().wf(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_126, true)).k2v($this, glUniform4i$factory());
    var tmp_127 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_127 = Companion_getInstance_14().x2v_1;
    tmp_127.a8w_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(3), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().wf(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().wf(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(DenoPointer), arrayOf([]), true)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_127, true)).k2v($this, glUniform1fv$factory());
    var tmp_128 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_128 = Companion_getInstance_14().x2v_1;
    tmp_128.b8w_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(3), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().wf(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().wf(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(DenoPointer), arrayOf([]), true)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_128, true)).k2v($this, glUniform2fv$factory());
    var tmp_129 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_129 = Companion_getInstance_14().x2v_1;
    tmp_129.c8w_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(3), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().wf(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().wf(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(DenoPointer), arrayOf([]), true)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_129, true)).k2v($this, glUniform3fv$factory());
    var tmp_130 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_130 = Companion_getInstance_14().x2v_1;
    tmp_130.d8w_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(3), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().wf(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().wf(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(DenoPointer), arrayOf([]), true)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_130, true)).k2v($this, glUniform4fv$factory());
    var tmp_131 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_131 = Companion_getInstance_14().x2v_1;
    tmp_131.e8w_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(3), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().wf(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().wf(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(DenoPointer), arrayOf([]), true)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_131, true)).k2v($this, glUniform1iv$factory());
    var tmp_132 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_132 = Companion_getInstance_14().x2v_1;
    tmp_132.f8w_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(3), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().wf(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().wf(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(DenoPointer), arrayOf([]), true)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_132, true)).k2v($this, glUniform2iv$factory());
    var tmp_133 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_133 = Companion_getInstance_14().x2v_1;
    tmp_133.g8w_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(3), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().wf(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().wf(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(DenoPointer), arrayOf([]), true)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_133, true)).k2v($this, glUniform3iv$factory());
    var tmp_134 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_134 = Companion_getInstance_14().x2v_1;
    tmp_134.h8w_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(3), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().wf(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().wf(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(DenoPointer), arrayOf([]), true)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_134, true)).k2v($this, glUniform4iv$factory());
    var tmp_135 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_135 = Companion_getInstance_14().x2v_1;
    tmp_135.i8w_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(4), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().wf(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().wf(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().wf(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(DenoPointer), arrayOf([]), true)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_135, true)).k2v($this, glUniformMatrix2fv$factory());
    var tmp_136 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_136 = Companion_getInstance_14().x2v_1;
    tmp_136.j8w_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(4), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().wf(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().wf(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().wf(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(DenoPointer), arrayOf([]), true)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_136, true)).k2v($this, glUniformMatrix3fv$factory());
    var tmp_137 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_137 = Companion_getInstance_14().x2v_1;
    tmp_137.k8w_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(4), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().wf(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().wf(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().wf(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(DenoPointer), arrayOf([]), true)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_137, true)).k2v($this, glUniformMatrix4fv$factory());
    var tmp_138 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_138 = Companion_getInstance_14().x2v_1;
    tmp_138.l8w_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(1), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().wf(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_138, true)).k2v($this, glUseProgram$factory());
    var tmp_139 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_139 = Companion_getInstance_14().x2v_1;
    tmp_139.m8w_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(1), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().wf(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_139, true)).k2v($this, glValidateProgram$factory());
    var tmp_140 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_140 = Companion_getInstance_14().x2v_1;
    tmp_140.n8w_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(2), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().wf(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().xf(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_140, true)).k2v($this, glVertexAttrib1f$factory());
    var tmp_141 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_141 = Companion_getInstance_14().x2v_1;
    tmp_141.o8w_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(3), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().wf(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().xf(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().xf(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_141, true)).k2v($this, glVertexAttrib2f$factory());
    var tmp_142 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_142 = Companion_getInstance_14().x2v_1;
    tmp_142.p8w_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(4), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().wf(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().xf(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().xf(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().xf(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_142, true)).k2v($this, glVertexAttrib3f$factory());
    var tmp_143 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_143 = Companion_getInstance_14().x2v_1;
    tmp_143.q8w_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(5), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().wf(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().xf(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().xf(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().xf(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().xf(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_143, true)).k2v($this, glVertexAttrib4f$factory());
    var tmp_144 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_144 = Companion_getInstance_14().x2v_1;
    tmp_144.r8w_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(2), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().wf(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(DenoPointer), arrayOf([]), true)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_144, true)).k2v($this, glVertexAttrib1fv$factory());
    var tmp_145 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_145 = Companion_getInstance_14().x2v_1;
    tmp_145.s8w_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(2), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().wf(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(DenoPointer), arrayOf([]), true)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_145, true)).k2v($this, glVertexAttrib2fv$factory());
    var tmp_146 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_146 = Companion_getInstance_14().x2v_1;
    tmp_146.t8w_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(2), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().wf(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(DenoPointer), arrayOf([]), true)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_146, true)).k2v($this, glVertexAttrib3fv$factory());
    var tmp_147 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_147 = Companion_getInstance_14().x2v_1;
    tmp_147.u8w_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(5), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().wf(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().wf(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().wf(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(DenoPointer), arrayOf([]), true)), createInvariantKTypeProjection(createKType(getKClass(DenoPointer), arrayOf([]), true)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_147, true)).k2v($this, glBindBufferRange$factory());
    var tmp_148 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_148 = Companion_getInstance_14().x2v_1;
    tmp_148.v8w_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(2), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().wf(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().ag(), arrayOf([]), true)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().wf(), arrayOf([]), false))]), false), null, config_148, true)).k2v($this, glGetUniformBlockIndex$factory());
    var tmp_149 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_149 = Companion_getInstance_14().x2v_1;
    tmp_149.w8w_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(3), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().wf(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().wf(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().wf(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_149, true)).k2v($this, glUniformBlockBinding$factory());
    var tmp_150 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_150 = Companion_getInstance_14().x2v_1;
    tmp_150.x8w_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(2), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().wf(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(DenoPointer), arrayOf([]), true)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_150, true)).k2v($this, glGenVertexArrays$factory());
    var tmp_151 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_151 = Companion_getInstance_14().x2v_1;
    tmp_151.y8w_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(2), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().wf(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(DenoPointer), arrayOf([]), true)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_151, true)).k2v($this, glDeleteVertexArrays$factory());
    var tmp_152 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_152 = Companion_getInstance_14().x2v_1;
    tmp_152.z8w_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(1), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().wf(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_152, true)).k2v($this, glBindVertexArray$factory());
    return $this;
  }
  j90() {
    return this.c8r_1.oo(this, glDrawArraysInstanced$factory_0());
  }
  k90() {
    return this.d8r_1.oo(this, glDrawElementsInstanced$factory_0());
  }
  l90() {
    return this.e8r_1.oo(this, glVertexAttribDivisor$factory_0());
  }
  s90() {
    return this.f8r_1.oo(this, glTexSubImage2D$factory_0());
  }
  s8z() {
    return this.g8r_1.oo(this, glTexImage2D$factory_0());
  }
  t8z() {
    return this.h8r_1.oo(this, glTexParameteri$factory_0());
  }
  t90() {
    return this.i8r_1.oo(this, glTexParameterf$factory_0());
  }
  u90() {
    return this.j8r_1.oo(this, glTexParameterfv$factory_0());
  }
  v90() {
    return this.k8r_1.oo(this, glTexParameteriv$factory_0());
  }
  q8z() {
    return this.l8r_1.oo(this, glStencilOp$factory_0());
  }
  o8z() {
    return this.m8r_1.oo(this, glStencilMask$factory_0());
  }
  w90() {
    return this.n8r_1.oo(this, glReadPixels$factory_0());
  }
  m8z() {
    return this.o8r_1.oo(this, glStencilFunc$factory_0());
  }
  k8z() {
    return this.p8r_1.oo(this, glScissor$factory_0());
  }
  x90() {
    return this.q8r_1.oo(this, glPolygonOffset$factory_0());
  }
  i8z() {
    return this.r8r_1.oo(this, glPixelStorei$factory_0());
  }
  y90() {
    return this.s8r_1.oo(this, glLineWidth$factory_0());
  }
  z90() {
    return this.t8r_1.oo(this, glGetTexParameterfv$factory_0());
  }
  a91() {
    return this.u8r_1.oo(this, glGetTexParameteriv$factory_0());
  }
  b8z() {
    return this.v8r_1.oo(this, glGetError$factory_0());
  }
  b91() {
    return this.w8r_1.oo(this, glGetFloatv$factory_0());
  }
  c8z() {
    return this.x8r_1.oo(this, glGetIntegerv$factory_0());
  }
  c91() {
    return this.y8r_1.oo(this, glGetBooleanv$factory_0());
  }
  z8y() {
    return this.z8r_1.oo(this, glGenTextures$factory_0());
  }
  d91() {
    return this.a8s_1.oo(this, glDepthRange$factory_0());
  }
  k8y() {
    return this.b8s_1.oo(this, glDepthRangef$factory_0());
  }
  e91() {
    return this.c8s_1.oo(this, glClearDepth$factory_0());
  }
  v8x() {
    return this.d8s_1.oo(this, glClearDepthf$factory_0());
  }
  n8y() {
    return this.e8s_1.oo(this, glDrawArrays$factory_0());
  }
  o8y() {
    return this.f8s_1.oo(this, glDrawElements$factory_0());
  }
  u8y() {
    return this.g8s_1.oo(this, glFrontFace$factory_0());
  }
  f91() {
    return this.h8s_1.oo(this, glFinish$factory_0());
  }
  r8y() {
    return this.i8s_1.oo(this, glFlush$factory_0());
  }
  p8y() {
    return this.j8s_1.oo(this, glEnable$factory_0());
  }
  g91() {
    return this.k8s_1.oo(this, glIsEnabled$factory_0());
  }
  l8y() {
    return this.l8s_1.oo(this, glDisable$factory_0());
  }
  j8y() {
    return this.m8s_1.oo(this, glDepthMask$factory_0());
  }
  i8y() {
    return this.n8s_1.oo(this, glDepthFunc$factory_0());
  }
  h8y() {
    return this.o8s_1.oo(this, glDeleteTextures$factory_0());
  }
  b8y() {
    return this.p8s_1.oo(this, glCullFace$factory_0());
  }
  h91() {
    return this.q8s_1.oo(this, glCopyTexImage2D$factory_0());
  }
  i91() {
    return this.r8s_1.oo(this, glCopyTexSubImage2D$factory_0());
  }
  x8x() {
    return this.s8s_1.oo(this, glColorMask$factory_0());
  }
  w8x() {
    return this.t8s_1.oo(this, glClearStencil$factory_0());
  }
  u8x() {
    return this.u8s_1.oo(this, glClearColor$factory_0());
  }
  t8x() {
    return this.v8s_1.oo(this, glClear$factory_0());
  }
  o8x() {
    return this.w8s_1.oo(this, glBindTexture$factory_0());
  }
  j91() {
    return this.x8s_1.oo(this, glHint$factory_0());
  }
  i90() {
    return this.y8s_1.oo(this, glViewport$factory_0());
  }
  g8z() {
    return this.z8s_1.oo(this, glGetString$factory_0());
  }
  k91() {
    return this.a8t_1.oo(this, glGetStringi$factory_0());
  }
  h90() {
    return this.b8t_1.oo(this, glVertexAttribPointer$factory_0());
  }
  l91() {
    return this.c8t_1.oo(this, glVertexAttrib4fv$factory_0());
  }
  i8x() {
    return this.d8t_1.oo(this, glActiveTexture$factory_0());
  }
  j8x() {
    return this.e8t_1.oo(this, glAttachShader$factory_0());
  }
  k8x() {
    return this.f8t_1.oo(this, glBindAttribLocation$factory_0());
  }
  l8x() {
    return this.g8t_1.oo(this, glBindBuffer$factory_0());
  }
  m8x() {
    return this.h8t_1.oo(this, glBindFramebuffer$factory_0());
  }
  n8x() {
    return this.i8t_1.oo(this, glBindRenderbuffer$factory_0());
  }
  m91() {
    return this.j8t_1.oo(this, glBlendColor$factory_0());
  }
  n91() {
    return this.k8t_1.oo(this, glBlendEquation$factory_0());
  }
  p8x() {
    return this.l8t_1.oo(this, glBlendEquationSeparate$factory_0());
  }
  o91() {
    return this.m8t_1.oo(this, glBlendFunc$factory_0());
  }
  q8x() {
    return this.n8t_1.oo(this, glBlendFuncSeparate$factory_0());
  }
  r8x() {
    return this.o8t_1.oo(this, glBufferData$factory_0());
  }
  s8x() {
    return this.p8t_1.oo(this, glBufferSubData$factory_0());
  }
  p91() {
    return this.q8t_1.oo(this, glCheckFramebufferStatus$factory_0());
  }
  y8x() {
    return this.r8t_1.oo(this, glCompileShader$factory_0());
  }
  q91() {
    return this.s8t_1.oo(this, glCompressedTexImage2D$factory_0());
  }
  r91() {
    return this.t8t_1.oo(this, glCompressedTexSubImage2D$factory_0());
  }
  z8x() {
    return this.u8t_1.oo(this, glCreateProgram$factory_0());
  }
  a8y() {
    return this.v8t_1.oo(this, glCreateShader$factory_0());
  }
  c8y() {
    return this.w8t_1.oo(this, glDeleteBuffers$factory_0());
  }
  d8y() {
    return this.x8t_1.oo(this, glDeleteFramebuffers$factory_0());
  }
  e8y() {
    return this.y8t_1.oo(this, glDeleteProgram$factory_0());
  }
  f8y() {
    return this.z8t_1.oo(this, glDeleteRenderbuffers$factory_0());
  }
  g8y() {
    return this.a8u_1.oo(this, glDeleteShader$factory_0());
  }
  s91() {
    return this.b8u_1.oo(this, glDetachShader$factory_0());
  }
  m8y() {
    return this.c8u_1.oo(this, glDisableVertexAttribArray$factory_0());
  }
  q8y() {
    return this.d8u_1.oo(this, glEnableVertexAttribArray$factory_0());
  }
  s8y() {
    return this.e8u_1.oo(this, glFramebufferRenderbuffer$factory_0());
  }
  t8y() {
    return this.f8u_1.oo(this, glFramebufferTexture2D$factory_0());
  }
  v8y() {
    return this.g8u_1.oo(this, glGenBuffers$factory_0());
  }
  w8y() {
    return this.h8u_1.oo(this, glGenerateMipmap$factory_0());
  }
  x8y() {
    return this.i8u_1.oo(this, glGenFramebuffers$factory_0());
  }
  y8y() {
    return this.j8u_1.oo(this, glGenRenderbuffers$factory_0());
  }
  t91() {
    return this.k8u_1.oo(this, glGetActiveAttrib$factory_0());
  }
  u91() {
    return this.l8u_1.oo(this, glGetActiveUniform$factory_0());
  }
  v91() {
    return this.m8u_1.oo(this, glGetAttachedShaders$factory_0());
  }
  w91() {
    return this.n8u_1.oo(this, glGetAttribLocation$factory_0());
  }
  a8z() {
    return this.o8u_1.oo(this, glGetUniformLocation$factory_0());
  }
  x91() {
    return this.p8u_1.oo(this, glGetBufferParameteriv$factory_0());
  }
  y91() {
    return this.q8u_1.oo(this, glGetFramebufferAttachmentParameteriv$factory_0());
  }
  z91() {
    return this.r8u_1.oo(this, glGetProgramInfoLog$factory_0());
  }
  a92() {
    return this.s8u_1.oo(this, glGetRenderbufferParameteriv$factory_0());
  }
  d8z() {
    return this.t8u_1.oo(this, glGetProgramiv$factory_0());
  }
  e8z() {
    return this.u8u_1.oo(this, glGetShaderiv$factory_0());
  }
  f8z() {
    return this.v8u_1.oo(this, glGetShaderInfoLog$factory_0());
  }
  b92() {
    return this.w8u_1.oo(this, glGetShaderPrecisionFormat$factory_0());
  }
  c92() {
    return this.x8u_1.oo(this, glGetShaderSource$factory_0());
  }
  d92() {
    return this.y8u_1.oo(this, glGetUniformfv$factory_0());
  }
  e92() {
    return this.z8u_1.oo(this, glGetUniformiv$factory_0());
  }
  f92() {
    return this.a8v_1.oo(this, glGetVertexAttribfv$factory_0());
  }
  g92() {
    return this.b8v_1.oo(this, glGetVertexAttribiv$factory_0());
  }
  h92() {
    return this.c8v_1.oo(this, glGetVertexAttribPointerv$factory_0());
  }
  i92() {
    return this.d8v_1.oo(this, glIsBuffer$factory_0());
  }
  j92() {
    return this.e8v_1.oo(this, glIsFramebuffer$factory_0());
  }
  k92() {
    return this.f8v_1.oo(this, glIsProgram$factory_0());
  }
  l92() {
    return this.g8v_1.oo(this, glIsRenderbuffer$factory_0());
  }
  m92() {
    return this.h8v_1.oo(this, glIsTexture$factory_0());
  }
  n92() {
    return this.i8v_1.oo(this, glIsShader$factory_0());
  }
  h8z() {
    return this.j8v_1.oo(this, glLinkProgram$factory_0());
  }
  o92() {
    return this.k8v_1.oo(this, glReleaseShaderCompiler$factory_0());
  }
  j8z() {
    return this.l8v_1.oo(this, glRenderbufferStorage$factory_0());
  }
  p92() {
    return this.m8v_1.oo(this, glSampleCoverage$factory_0());
  }
  q92() {
    return this.n8v_1.oo(this, glShaderBinary$factory_0());
  }
  l8z() {
    return this.o8v_1.oo(this, glShaderSource$factory_0());
  }
  n8z() {
    return this.p8v_1.oo(this, glStencilFuncSeparate$factory_0());
  }
  p8z() {
    return this.q8v_1.oo(this, glStencilMaskSeparate$factory_0());
  }
  r8z() {
    return this.r8v_1.oo(this, glStencilOpSeparate$factory_0());
  }
  r92() {
    return this.s8v_1.oo(this, glUniform1f$factory_0());
  }
  s92() {
    return this.t8v_1.oo(this, glUniform2f$factory_0());
  }
  t92() {
    return this.u8v_1.oo(this, glUniform3f$factory_0());
  }
  u92() {
    return this.v8v_1.oo(this, glUniform4f$factory_0());
  }
  v8z() {
    return this.w8v_1.oo(this, glUniform1i$factory_0());
  }
  v92() {
    return this.x8v_1.oo(this, glUniform2i$factory_0());
  }
  w92() {
    return this.y8v_1.oo(this, glUniform3i$factory_0());
  }
  x92() {
    return this.z8v_1.oo(this, glUniform4i$factory_0());
  }
  u8z() {
    return this.a8w_1.oo(this, glUniform1fv$factory_0());
  }
  x8z() {
    return this.b8w_1.oo(this, glUniform2fv$factory_0());
  }
  z8z() {
    return this.c8w_1.oo(this, glUniform3fv$factory_0());
  }
  b90() {
    return this.d8w_1.oo(this, glUniform4fv$factory_0());
  }
  w8z() {
    return this.e8w_1.oo(this, glUniform1iv$factory_0());
  }
  y8z() {
    return this.f8w_1.oo(this, glUniform2iv$factory_0());
  }
  a90() {
    return this.g8w_1.oo(this, glUniform3iv$factory_0());
  }
  c90() {
    return this.h8w_1.oo(this, glUniform4iv$factory_0());
  }
  d90() {
    return this.i8w_1.oo(this, glUniformMatrix2fv$factory_0());
  }
  e90() {
    return this.j8w_1.oo(this, glUniformMatrix3fv$factory_0());
  }
  f90() {
    return this.k8w_1.oo(this, glUniformMatrix4fv$factory_0());
  }
  g90() {
    return this.l8w_1.oo(this, glUseProgram$factory_0());
  }
  y92() {
    return this.m8w_1.oo(this, glValidateProgram$factory_0());
  }
  z92() {
    return this.n8w_1.oo(this, glVertexAttrib1f$factory_0());
  }
  a93() {
    return this.o8w_1.oo(this, glVertexAttrib2f$factory_0());
  }
  b93() {
    return this.p8w_1.oo(this, glVertexAttrib3f$factory_0());
  }
  c93() {
    return this.q8w_1.oo(this, glVertexAttrib4f$factory_0());
  }
  d93() {
    return this.r8w_1.oo(this, glVertexAttrib1fv$factory_0());
  }
  e93() {
    return this.s8w_1.oo(this, glVertexAttrib2fv$factory_0());
  }
  f93() {
    return this.t8w_1.oo(this, glVertexAttrib3fv$factory_0());
  }
  m90() {
    return this.u8w_1.oo(this, glBindBufferRange$factory_0());
  }
  n90() {
    return this.v8w_1.oo(this, glGetUniformBlockIndex$factory_0());
  }
  o90() {
    return this.w8w_1.oo(this, glUniformBlockBinding$factory_0());
  }
  p90() {
    return this.x8w_1.oo(this, glGenVertexArrays$factory_0());
  }
  g93() {
    return this.y8w_1.oo(this, glDeleteVertexArrays$factory_0());
  }
  q90() {
    return this.z8w_1.oo(this, glBindVertexArray$factory_0());
  }
}
class SDLGameWindow$ag$1 extends KmlGlContext {
  constructor(this$0, $box) {
    if ($box === VOID)
      $box = {};
    $box.k93_1 = this$0;
    super(this$0.z95_1, new KmlGlOpenGL(), VOID, $box);
  }
  o7a() {
    var tmp = this.k93_1.y95_1.v8q();
    var tmp_0 = this.h79_1;
    tmp(tmp_0 instanceof DenoPointer ? tmp_0 : THROW_CCE(), this.k93_1.a96_1);
  }
  q7a() {
    var tmp = this.k93_1.y95_1.v8q();
    var tmp_0 = this.h79_1;
    tmp(tmp_0 instanceof DenoPointer ? tmp_0 : THROW_CCE(), null);
  }
  f6() {
    this.k93_1.y95_1.u8q()(this.k93_1.a96_1);
  }
}
class SDLGameWindow extends GameWindow {
  static f96(size, config) {
    size = size === VOID ? Size2D.t26(640, 480) : size;
    config = config === VOID ? Companion_getInstance_75().z8n_1 : config;
    var $this = this.t8l();
    $this.w95_1 = size;
    $this.x95_1 = config;
    $this.y95_1 = SDL.j8q();
    $this.z95_1 = $this.y95_1.l8q()($this.x95_1.k8o_1, 805240832, 805240832, numberToInt($this.w95_1.r26_1), numberToInt($this.w95_1.s26_1), 34);
    $this.a96_1 = $this.y95_1.t8q()($this.z95_1);
    $this.y95_1.p8q()($this.z95_1);
    var tmp = $this;
    tmp.b96_1 = AGOpengl.g79(new SDLGameWindow$ag$1($this));
    $this.c96_1 = $this.o8m().v73_1;
    $this.d96_1 = '';
    $this.e96_1 = CreateFFIMemory(1024);
    return $this;
  }
  o8m() {
    return this.b96_1;
  }
  v8m(value) {
    this.d96_1 = value;
    this.y95_1.m8q()(this.z95_1, this.g96());
  }
  g96() {
    return this.d96_1;
  }
  e8n(width, height) {
    this.y95_1.n8q()(this.z95_1, width, height);
    this.y95_1.o8q()(this.z95_1, 805240832, 805240832);
  }
  h96() {
    // Inline function 'korlibs.ffi.usePointer' call
    var this_0 = this.e96_1;
    var it = get_pointer(Deno.UnsafePointer.of(this_0));
    while (this.y95_1.r8q()(it)) {
      var type = getS32(it, 0);
      switch (type) {
        case 512:
          println('WINDOW EVENT');
          break;
        case 1024:
          println('MOUSE MOTION');
          break;
        case 1025:
          println('MOUSE DOWN');
          break;
        case 1026:
          println('MOUSE UP');
          break;
        case 256:
          this.h8n();
          break;
        default:
          println('EVENT: type=' + type);
          break;
      }
    }
    this.y95_1.v8q()(this.z95_1, this.a96_1);
    this.c96_1.p79(1.0, 0.0, 0.0, 1.0);
    this.c96_1.u79(16384);
  }
  i96() {
    this.y95_1.w8q()(this.z95_1);
  }
  i1d(exitCode) {
    super.i1d(exitCode);
    this.y95_1.u8q()(this.a96_1);
    this.y95_1.s8q()();
  }
}
class Size3D {
  constructor(width, height, depthOrArrayLayers) {
    height = height === VOID ? 1 : height;
    depthOrArrayLayers = depthOrArrayLayers === VOID ? 1 : depthOrArrayLayers;
    this.width = width;
    this.height = height;
    this.depthOrArrayLayers = depthOrArrayLayers;
  }
  c89(_set____db54di) {
    this.width = _set____db54di;
  }
  z2i() {
    return this.width;
  }
  d89(_set____db54di) {
    this.height = _set____db54di;
  }
  a2j() {
    return this.height;
  }
  j96(_set____db54di) {
    this.depthOrArrayLayers = _set____db54di;
  }
  k96() {
    return this.depthOrArrayLayers;
  }
  toArray() {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [this.width, this.height, this.depthOrArrayLayers];
  }
  jl() {
    return this.width;
  }
  kl() {
    return this.height;
  }
  tr() {
    return this.depthOrArrayLayers;
  }
  l96(width, height, depthOrArrayLayers) {
    return new Size3D(width, height, depthOrArrayLayers);
  }
  copy(width, height, depthOrArrayLayers, $super) {
    width = width === VOID ? this.width : width;
    height = height === VOID ? this.height : height;
    depthOrArrayLayers = depthOrArrayLayers === VOID ? this.depthOrArrayLayers : depthOrArrayLayers;
    return this.l96(width, height, depthOrArrayLayers);
  }
  toString() {
    return 'Size3D(width=' + this.width + ', height=' + this.height + ', depthOrArrayLayers=' + this.depthOrArrayLayers + ')';
  }
  hashCode() {
    var result = this.width;
    result = imul(result, 31) + this.height | 0;
    result = imul(result, 31) + this.depthOrArrayLayers | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof Size3D))
      return false;
    var tmp0_other_with_cast = other instanceof Size3D ? other : THROW_CCE();
    if (!(this.width === tmp0_other_with_cast.width))
      return false;
    if (!(this.height === tmp0_other_with_cast.height))
      return false;
    if (!(this.depthOrArrayLayers === tmp0_other_with_cast.depthOrArrayLayers))
      return false;
    return true;
  }
}
class AGOpenglFactory {
  t87() {
    // Inline function 'kotlin.js.unsafeCast' call
    return 'ontouchstart' in window || navigator.maxTouchPoints;
  }
}
class KmlGlJsCanvas extends KmlGl {
  constructor(canvas, glOpts) {
    super();
    this.q96_1 = canvas;
    this.r96_1 = glOpts;
    this.s96_1 = 1;
    var tmp = this;
    // Inline function 'kotlin.js.unsafeCast' call
    var tmp_0;
    if (null == null) {
      var tmp1_safe_receiver = this.q96_1.getContext('webgl2', this.r96_1);
      var tmp_1;
      if (tmp1_safe_receiver == null) {
        tmp_1 = null;
      } else {
        // Inline function 'kotlin.also' call
        // Inline function 'kotlin.contracts.contract' call
        // Inline function 'korlibs.kgl.KmlGlJsCanvas.gl.<anonymous>' call
        this.s96_1 = 2;
        tmp_1 = tmp1_safe_receiver;
      }
      tmp_0 = tmp_1;
    } else {
      tmp_0 = null;
    }
    var tmp2_elvis_lhs = tmp_0;
    var tmp3_elvis_lhs = tmp2_elvis_lhs == null ? this.q96_1.getContext('webgl', this.r96_1) : tmp2_elvis_lhs;
    // Inline function 'kotlin.js.asDynamic' call
    var tmp4_safe_receiver = tmp3_elvis_lhs == null ? this.q96_1.getContext('experimental-webgl', this.r96_1) : tmp3_elvis_lhs;
    var tmp_2;
    if (tmp4_safe_receiver == null) {
      tmp_2 = null;
    } else {
      // Inline function 'kotlin.also' call
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'korlibs.kgl.KmlGlJsCanvas.gl.<anonymous>' call
      println('Created WebGL version=' + this.s96_1 + ', opts=' + JSON.stringify(this.r96_1));
      tmp_2 = tmp4_safe_receiver;
    }
    var tmp5_safe_receiver = tmp_2;
    var tmp_3;
    if (tmp5_safe_receiver == null) {
      tmp_3 = null;
    } else {
      // Inline function 'kotlin.also' call
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'korlibs.kgl.KmlGlJsCanvas.gl.<anonymous>' call
      tmp5_safe_receiver.getExtension('OES_standard_derivatives');
      tmp5_safe_receiver.getExtension('OES_texture_float');
      tmp5_safe_receiver.getExtension('OES_texture_float_linear');
      tmp5_safe_receiver.getExtension('OES_element_index_uint');
      tmp_3 = tmp5_safe_receiver;
    }
    var tmp6_elvis_lhs = tmp_3;
    var tmp_4;
    if (tmp6_elvis_lhs == null) {
      // Inline function 'kotlin.run' call
      // Inline function 'kotlin.contracts.contract' call
      try {
        var tmp0_safe_receiver = document.body;
        if (tmp0_safe_receiver == null)
          null;
        else {
          // Inline function 'kotlin.apply' call
          var tmp_5 = document.createElement('div');
          var this_0 = tmp_5 instanceof HTMLElement ? tmp_5 : THROW_CCE();
          // Inline function 'kotlin.contracts.contract' call
          // Inline function 'korlibs.kgl.KmlGlJsCanvas.gl.<anonymous>.<anonymous>' call
          this_0.style.color = 'red';
          this_0.style.font = '30px Arial';
          this_0.innerText = "Can't get webgl context. Running in an android emulator without cross-walk?";
          tmp0_safe_receiver.prepend(this_0);
        }
      } catch ($p) {
        if ($p instanceof Error) {
          var e = $p;
          printStackTrace(e);
        } else {
          throw $p;
        }
      }
      var message = "Can't get webgl context";
      throw IllegalStateException.z4(toString(message));
    } else {
      tmp_4 = tmp6_elvis_lhs;
    }
    tmp.t96_1 = tmp_4;
    var tmp_6 = this;
    // Inline function 'kotlin.arrayOfNulls' call
    tmp_6.u96_1 = fillArrayVal(Array(8192), null);
    this.v96_1 = toMutableList(reversed_0(until(1, this.u96_1.length)));
    var tmp_7 = this;
    tmp_7.w96_1 = lazy(KmlGlJsCanvas$extensions$delegate$lambda(this));
    var tmp_8 = this;
    tmp_8.x96_1 = lazy(KmlGlJsCanvas$isFloatTextureSupported$delegate$lambda(this));
    this.y96_1 = new WebGLExtension(this, 'ANGLE_instanced_arrays', 2, listOf_0(['drawArraysInstanced', 'drawElementsInstanced', 'vertexAttribDivisor']), 'ANGLE');
    this.z96_1 = new WebGLExtension(this, 'OES_vertex_array_object', 2, listOf_0(['createVertexArrayOES', 'deleteVertexArrayOES', 'isVertexArrayOES', 'bindVertexArrayOES']), 'OES');
  }
  r78() {
    return Companion_instance_54.e7g(this.s96_1);
  }
  q78(texture) {
    return this.t96_1.activeTexture(texture);
  }
  v7c(program, shader) {
    return this.t96_1.attachShader(get_2(program, this), get_2(shader, this));
  }
  u7c(program, index, name) {
    return this.t96_1.bindAttribLocation(get_2(program, this), index, name);
  }
  k77(target, buffer) {
    return this.t96_1.bindBuffer(target, get_2(buffer, this));
  }
  n7b(target, framebuffer) {
    return this.t96_1.bindFramebuffer(target, get_2(framebuffer, this));
  }
  u7b(target, renderbuffer) {
    return this.t96_1.bindRenderbuffer(target, get_2(renderbuffer, this));
  }
  l7b(target, texture) {
    return this.t96_1.bindTexture(target, get_2(texture, this));
  }
  y79(modeRGB, modeAlpha) {
    return this.t96_1.blendEquationSeparate(modeRGB, modeAlpha);
  }
  z79(sfactorRGB, dfactorRGB, sfactorAlpha, dfactorAlpha) {
    return this.t96_1.blendFuncSeparate(sfactorRGB, dfactorRGB, sfactorAlpha, dfactorAlpha);
  }
  u78(target, size, data, usage) {
    return this.t96_1.bufferData(target, get_arrayUByte(sliceBuffer(data, 0, size)), usage);
  }
  t78(target, offset, size, data) {
    return this.t96_1.bufferSubData(target, offset, get_arrayUByte(sliceBuffer(data, 0, size)));
  }
  u79(mask) {
    return this.t96_1.clear(mask);
  }
  p79(red, green, blue, alpha) {
    return this.t96_1.clearColor(red, green, blue, alpha);
  }
  r79(d) {
    return this.t96_1.clearDepth(d);
  }
  t79(s) {
    return this.t96_1.clearStencil(s);
  }
  b7c(red, green, blue, alpha) {
    return this.t96_1.colorMask(red, green, blue, alpha);
  }
  m7c(shader) {
    return this.t96_1.compileShader(get_2(shader, this));
  }
  o7c() {
    return alloc(this.t96_1.createProgram(), this);
  }
  k7c(type) {
    return alloc(this.t96_1.createShader(type), this);
  }
  r7a(mode) {
    return this.t96_1.cullFace(mode);
  }
  y81(n, items) {
    var inductionVariable = 0;
    if (inductionVariable < n)
      do {
        var p = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        // Inline function 'org.khronos.webgl.get' call
        // Inline function 'kotlin.js.asDynamic' call
        var tmp$ret$1 = get_arrayInt(items)[p];
        this.t96_1.deleteBuffer(free(tmp$ret$1, this));
      }
       while (inductionVariable < n);
  }
  z81(n, items) {
    var inductionVariable = 0;
    if (inductionVariable < n)
      do {
        var p = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        // Inline function 'org.khronos.webgl.get' call
        // Inline function 'kotlin.js.asDynamic' call
        var tmp$ret$1 = get_arrayInt(items)[p];
        this.t96_1.deleteFramebuffer(free(tmp$ret$1, this));
      }
       while (inductionVariable < n);
  }
  j7c(program) {
    return this.t96_1.deleteProgram(get_2(program, this));
  }
  a82(n, items) {
    var inductionVariable = 0;
    if (inductionVariable < n)
      do {
        var p = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        // Inline function 'org.khronos.webgl.get' call
        // Inline function 'kotlin.js.asDynamic' call
        var tmp$ret$1 = get_arrayInt(items)[p];
        this.t96_1.deleteRenderbuffer(free(tmp$ret$1, this));
      }
       while (inductionVariable < n);
  }
  i7c(shader) {
    return this.t96_1.deleteShader(get_2(shader, this));
  }
  b82(n, items) {
    var inductionVariable = 0;
    if (inductionVariable < n)
      do {
        var p = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        // Inline function 'org.khronos.webgl.get' call
        // Inline function 'kotlin.js.asDynamic' call
        var tmp$ret$1 = get_arrayInt(items)[p];
        this.t96_1.deleteTexture(free(tmp$ret$1, this));
      }
       while (inductionVariable < n);
  }
  a7c(func) {
    return this.t96_1.depthFunc(func);
  }
  q79(flag) {
    return this.t96_1.depthMask(flag);
  }
  z7b(n, f) {
    return this.t96_1.depthRange(n, f);
  }
  d7a(cap) {
    return this.t96_1.disable(cap);
  }
  t7a(index) {
    return this.t96_1.disableVertexAttribArray(index);
  }
  k7a(mode, first, count) {
    return this.t96_1.drawArrays(mode, first, count);
  }
  m7a(mode, count, type, indices) {
    return this.t96_1.drawElements(mode, count, type, indices);
  }
  e7a(cap) {
    return this.t96_1.enable(cap);
  }
  x7a(index) {
    return this.t96_1.enableVertexAttribArray(index);
  }
  qc() {
    return this.t96_1.flush();
  }
  x7b(target, attachment, renderbuffertarget, renderbuffer) {
    return this.t96_1.framebufferRenderbuffer(target, attachment, renderbuffertarget, get_2(renderbuffer, this));
  }
  w7b(target, attachment, textarget, texture, level) {
    return this.t96_1.framebufferTexture2D(target, attachment, textarget, get_2(texture, this), level);
  }
  y7b(mode) {
    return this.t96_1.frontFace(mode);
  }
  c82(n, buffers) {
    var inductionVariable = 0;
    if (inductionVariable < n)
      do {
        var p = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        // Inline function 'org.khronos.webgl.set' call
        // Inline function 'kotlin.js.asDynamic' call
        get_arrayInt(buffers)[p] = alloc(this.t96_1.createBuffer(), this);
      }
       while (inductionVariable < n);
  }
  y78(target) {
    return this.t96_1.generateMipmap(target);
  }
  d82(n, framebuffers) {
    var inductionVariable = 0;
    if (inductionVariable < n)
      do {
        var p = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        // Inline function 'org.khronos.webgl.set' call
        // Inline function 'kotlin.js.asDynamic' call
        get_arrayInt(framebuffers)[p] = alloc(this.t96_1.createFramebuffer(), this);
      }
       while (inductionVariable < n);
  }
  e82(n, renderbuffers) {
    var inductionVariable = 0;
    if (inductionVariable < n)
      do {
        var p = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        // Inline function 'org.khronos.webgl.set' call
        // Inline function 'kotlin.js.asDynamic' call
        get_arrayInt(renderbuffers)[p] = alloc(this.t96_1.createRenderbuffer(), this);
      }
       while (inductionVariable < n);
  }
  f82(n, textures) {
    var inductionVariable = 0;
    if (inductionVariable < n)
      do {
        var p = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        // Inline function 'org.khronos.webgl.set' call
        // Inline function 'kotlin.js.asDynamic' call
        get_arrayInt(textures)[p] = alloc(this.t96_1.createTexture(), this);
      }
       while (inductionVariable < n);
  }
  g7c(program, name) {
    // Inline function 'kotlin.js.asDynamic' call
    var prg = get_2(program, this);
    if (prg.uniforms === undefined)
      prg.uniforms = {};
    if (prg.uniforms[name] === undefined) {
      prg.uniforms[name] = alloc(this.t96_1.getUniformLocation(prg, name), this);
    }
    // Inline function 'kotlin.js.unsafeCast' call
    return prg.uniforms[name];
  }
  n7c() {
    return this.t96_1.getError();
  }
  g82(pname, data) {
    // Inline function 'org.khronos.webgl.set' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    // Inline function 'kotlin.js.asDynamic' call
    get_arrayInt(data)[0] = this.t96_1.getParameter(pname);
  }
  h82(program, pname, params) {
    // Inline function 'korlibs.kgl.KmlGl.INFO_LOG_LENGTH' call
    if (pname === 35716) {
      // Inline function 'org.khronos.webgl.set' call
      var this_0 = get_arrayInt(params);
      var tmp1_safe_receiver = this.t96_1.getProgramInfoLog(get_2(program, this));
      var tmp2_safe_receiver = tmp1_safe_receiver == null ? null : tmp1_safe_receiver.length;
      var tmp3_elvis_lhs = tmp2_safe_receiver == null ? null : tmp2_safe_receiver + 1 | 0;
      // Inline function 'kotlin.js.asDynamic' call
      this_0[0] = tmp3_elvis_lhs == null ? 1 : tmp3_elvis_lhs;
    } else {
      // Inline function 'org.khronos.webgl.set' call
      // Inline function 'kotlin.js.unsafeCast' call
      // Inline function 'kotlin.js.asDynamic' call
      // Inline function 'kotlin.js.asDynamic' call
      get_arrayInt(params)[0] = this.t96_1.getProgramParameter(get_2(program, this), pname);
    }
  }
  i82(shader, pname, params) {
    // Inline function 'korlibs.kgl.KmlGl.INFO_LOG_LENGTH' call
    if (pname === 35716) {
      // Inline function 'org.khronos.webgl.set' call
      var this_0 = get_arrayInt(params);
      var tmp1_safe_receiver = this.t96_1.getShaderInfoLog(get_2(shader, this));
      var tmp2_safe_receiver = tmp1_safe_receiver == null ? null : tmp1_safe_receiver.length;
      var tmp3_elvis_lhs = tmp2_safe_receiver == null ? null : tmp2_safe_receiver + 1 | 0;
      // Inline function 'kotlin.js.asDynamic' call
      this_0[0] = tmp3_elvis_lhs == null ? 1 : tmp3_elvis_lhs;
    } else {
      // Inline function 'org.khronos.webgl.set' call
      // Inline function 'kotlin.js.unsafeCast' call
      // Inline function 'kotlin.js.asDynamic' call
      // Inline function 'kotlin.js.asDynamic' call
      get_arrayInt(params)[0] = this.t96_1.getShaderParameter(get_2(shader, this), pname);
    }
  }
  j82(shader, bufSize, length, infoLog) {
    var tmp0_elvis_lhs = this.t96_1.getShaderInfoLog(get_2(shader, this));
    var str = tmp0_elvis_lhs == null ? '' : tmp0_elvis_lhs;
    // Inline function 'org.khronos.webgl.set' call
    // Inline function 'kotlin.js.asDynamic' call
    get_arrayInt(length)[0] = str.length;
    putAsciiString(infoLog, str);
  }
  f75(name) {
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return this.t96_1.getParameter(name);
  }
  w7c(program) {
    return this.t96_1.linkProgram(get_2(program, this));
  }
  v78(pname, param) {
    return this.t96_1.pixelStorei(pname, param);
  }
  v7b(target, internalformat, width, height) {
    return this.t96_1.renderbufferStorage(target, internalformat, width, height);
  }
  c7c(x, y, width, height) {
    return this.t96_1.scissor(x, y, width, height);
  }
  l7c(shader, string) {
    return this.t96_1.shaderSource(get_2(shader, this), string);
  }
  g7a(func, ref, mask) {
    return this.t96_1.stencilFunc(func, ref, mask);
  }
  f7a(face, func, ref, mask) {
    return this.t96_1.stencilFuncSeparate(face, func, ref, mask);
  }
  s79(mask) {
    return this.t96_1.stencilMask(mask);
  }
  j7a(face, mask) {
    return this.t96_1.stencilMaskSeparate(face, mask);
  }
  i7a(fail, zfail, zpass) {
    return this.t96_1.stencilOp(fail, zfail, zpass);
  }
  h7a(face, sfail, dpfail, dppass) {
    return this.t96_1.stencilOpSeparate(face, sfail, dpfail, dppass);
  }
  w78(target, level, internalformat, width, height, border, format, type, pixels) {
    var tmp;
    // Inline function 'korlibs.kgl.KmlGl.FLOAT' call
    if (type === 5126) {
      tmp = pixels == null ? null : get_arrayFloat(pixels);
    } else {
      tmp = pixels == null ? null : get_arrayUByte(pixels);
    }
    var vpixels = tmp;
    this.t96_1.texImage2D(target, level, internalformat, width, height, border, format, type, vpixels);
  }
  x78(target, level, internalformat, format, type, data) {
    if (data instanceof HtmlNativeImage) {
      // Inline function 'korlibs.math.toInt' call
      var tmp$ret$0 = !data.e40_1 && data.d40_1 ? 1 : 0;
      this.t96_1.pixelStorei(37441, tmp$ret$0);
      this.t96_1.texImage2D(target, level, internalformat, format, type, data.t64_1);
      this.t96_1.pixelStorei(37441, 0);
    } else {
      return super.x78(target, level, internalformat, format, type, data);
    }
  }
  p78(target, pname, param) {
    return this.t96_1.texParameteri(target, pname, param);
  }
  l78(location, count, value) {
    return this.t96_1.uniform1fv(get_2(location, this), get_arrayFloat(value).subarray(0, imul(count, 1)));
  }
  j76(location, v0) {
    return this.t96_1.uniform1i(get_2(location, this), v0);
  }
  e78(location, count, value) {
    return this.t96_1.uniform1iv(get_2(location, this), get_arrayInt(value).subarray(0, imul(count, 1)));
  }
  m78(location, count, value) {
    return this.t96_1.uniform2fv(get_2(location, this), get_arrayFloat(value).subarray(0, imul(count, 2)));
  }
  f78(location, count, value) {
    return this.t96_1.uniform2iv(get_2(location, this), get_arrayInt(value).subarray(0, imul(count, 2)));
  }
  n78(location, count, value) {
    return this.t96_1.uniform3fv(get_2(location, this), get_arrayFloat(value).subarray(0, imul(count, 3)));
  }
  g78(location, count, value) {
    return this.t96_1.uniform3iv(get_2(location, this), get_arrayInt(value).subarray(0, imul(count, 3)));
  }
  o78(location, count, value) {
    return this.t96_1.uniform4fv(get_2(location, this), get_arrayFloat(value).subarray(0, imul(count, 4)));
  }
  h78(location, count, value) {
    return this.t96_1.uniform4iv(get_2(location, this), get_arrayInt(value).subarray(0, imul(count, 4)));
  }
  i78(location, count, transpose, value) {
    return this.t96_1.uniformMatrix2fv(get_2(location, this), transpose, get_arrayFloat(value).subarray(0, imul(count, 4)));
  }
  j78(location, count, transpose, value) {
    return this.t96_1.uniformMatrix3fv(get_2(location, this), transpose, get_arrayFloat(value).subarray(0, imul(count, 9)));
  }
  k78(location, count, transpose, value) {
    return this.t96_1.uniformMatrix4fv(get_2(location, this), transpose, get_arrayFloat(value).subarray(0, imul(count, 16)));
  }
  h7c(program) {
    return this.t96_1.useProgram(get_2(program, this));
  }
  y7a(index, size, type, normalized, stride, pointer) {
    return this.t96_1.vertexAttribPointer(index, size, type, normalized, stride, pointer.l2());
  }
  m7b(x, y, width, height) {
    return this.t96_1.viewport(x, y, width, height);
  }
  x81() {
    // Inline function 'kotlin.getValue' call
    var this_0 = this.w96_1;
    extensions$factory();
    return this_0.u1();
  }
  l7a(mode, first, count, instancecount) {
    // Inline function 'kotlin.js.asDynamic' call
    this.t96_1.drawArraysInstanced(mode, first, count, instancecount);
  }
  n7a(mode, count, type, indices, instancecount) {
    // Inline function 'kotlin.js.asDynamic' call
    this.t96_1.drawElementsInstanced(mode, count, type, indices, instancecount);
  }
  s7a(index, divisor) {
    // Inline function 'kotlin.js.asDynamic' call
    this.t96_1.vertexAttribDivisor(index, divisor);
  }
  p6j() {
    return get_versionInt(this) >= 2;
  }
  f7b(target, index, buffer, offset, size) {
    // Inline function 'kotlin.js.asDynamic' call
    this.t96_1.bindBufferRange(target, index, get_2(buffer, this), offset, size);
  }
  k76(program, name) {
    // Inline function 'kotlin.js.asDynamic' call
    return this.t96_1.getUniformBlockIndex(get_2(program, this), name);
  }
  l76(program, uniformBlockIndex, uniformBlockBinding) {
    // Inline function 'kotlin.js.asDynamic' call
    this.t96_1.uniformBlockBinding(get_2(program, this), uniformBlockIndex, uniformBlockBinding);
  }
  q6j() {
    return this.z96_1.h97();
  }
  k82(n, arrays) {
    var inductionVariable = 0;
    if (inductionVariable < n)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        var tmp$ret$1 = this.t96_1.createVertexArray();
        setInt32(arrays, i, alloc(tmp$ret$1, this));
      }
       while (inductionVariable < n);
  }
  u7a(array) {
    // Inline function 'kotlin.js.asDynamic' call
    this.t96_1.bindVertexArray(get_2(array, this));
  }
}
class WebGLExtension {
  constructor(canvas, name, coreSince, functions, suffix) {
    coreSince = coreSince === VOID ? 1000 : coreSince;
    functions = functions === VOID ? emptyList() : functions;
    suffix = suffix === VOID ? '' : suffix;
    this.a97_1 = canvas;
    this.b97_1 = name;
    this.c97_1 = coreSince;
    this.d97_1 = functions;
    this.e97_1 = suffix;
    this.f97_1 = false;
    this.g97_1 = null;
  }
  u1() {
    if (!this.f97_1) {
      this.f97_1 = true;
      this.g97_1 = this.a97_1.t96_1.getExtension(this.b97_1);
      var _iterator__ex2g4s = this.d97_1.a1();
      while (_iterator__ex2g4s.b1()) {
        var func = _iterator__ex2g4s.c1();
        var base = removeSuffix(func, this.e97_1);
        var vfunc = this.g97_1[func];
        if (typeof vfunc === 'function') {
          // Inline function 'kotlin.js.asDynamic' call
          this.a97_1.t96_1[base] = vfunc.bind(this.g97_1);
        }
      }
    }
    return this.g97_1;
  }
  h97() {
    return this.a97_1.s96_1 >= this.c97_1 || this.u1() != null;
  }
}
class KorgeReloadInternal$1 extends KorgeReloadInternalImpl {}
class JsGameWindow extends GameWindow {
  static b9i() {
    return this.t8l();
  }
}
class NodeJsGameWindow extends JsGameWindow {
  static u9c() {
    return this.b9i();
  }
}
class BrowserCanvasJsGameWindow$close$slambda {
  constructor(this$0) {
    this.c9i_1 = this$0;
  }
  ud($completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_0.bind(VOID, this), $completion);
  }
}
class BrowserCanvasJsGameWindow$loop$slambda {
  constructor($entry, this$0) {
    this.d9i_1 = $entry;
    this.e9i_1 = this$0;
  }
  ud($completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_1.bind(VOID, this), $completion);
  }
}
class BrowserCanvasJsGameWindow extends JsGameWindow {
  static i9a(canvas) {
    canvas = canvas === VOID ? AGDefaultCanvas() : canvas;
    var $this = this.b9i();
    $this.t99_1 = canvas;
    $this.u99_1 = AGWebgl(new AGConfig(), $this.t99_1);
    $this.v99_1 = new DialogInterfaceJs();
    $this.w99_1 = null;
    var tmp = $this;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.x99_1 = [GameButton_BUTTON_SOUTH_getInstance(), GameButton_BUTTON_EAST_getInstance(), GameButton_BUTTON_WEST_getInstance(), GameButton_BUTTON_NORTH_getInstance(), GameButton_L1_getInstance(), GameButton_R1_getInstance(), GameButton_L2_getInstance(), GameButton_R2_getInstance(), GameButton_SELECT_getInstance(), GameButton_START_getInstance(), GameButton_L3_getInstance(), GameButton_R3_getInstance(), GameButton_UP_getInstance(), GameButton_DOWN_getInstance(), GameButton_LEFT_getInstance(), GameButton_RIGHT_getInstance(), GameButton_SYSTEM_getInstance()];
    var tmp_0 = $this;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp_0.y99_1 = [GameButton_LX_getInstance(), GameButton_LY_getInstance(), GameButton_RX_getInstance(), GameButton_RY_getInstance(), GameButton_L2_getInstance(), GameButton_R2_getInstance(), GameButton_DPADX_getInstance(), GameButton_DPADY_getInstance()];
    $this.z99_1 = new GamepadInfo();
    $this.a9a_1 = Quality_AUTOMATIC_getInstance();
    $this.b9a_1 = 1.0;
    $this.c9a_1 = new TouchBuilder();
    $this.d9a_1 = Cursor_DEFAULT_getInstance();
    $this.e9a_1 = null;
    $this.f9a_1 = null;
    // Inline function 'kotlin.js.asDynamic' call
    window.canvas = $this.t99_1;
    // Inline function 'kotlin.js.asDynamic' call
    window.ag = $this.o8m();
    // Inline function 'kotlin.js.asDynamic' call
    window.gl = $this.o8m().v73_1;
    if (get_isCanvasCreatedAndHandled()) {
      var tmp0_safe_receiver = document.body;
      if (tmp0_safe_receiver == null)
        null;
      else
        tmp0_safe_receiver.appendChild($this.t99_1);
      var tmp1_safe_receiver = document.body;
      var tmp2_safe_receiver = tmp1_safe_receiver == null ? null : tmp1_safe_receiver.style;
      if (tmp2_safe_receiver == null)
        null;
      else {
        tmp2_safe_receiver.margin = '0px';
      }
      var tmp3_safe_receiver = document.body;
      var tmp4_safe_receiver = tmp3_safe_receiver == null ? null : tmp3_safe_receiver.style;
      if (tmp4_safe_receiver == null)
        null;
      else {
        tmp4_safe_receiver.padding = '0px';
      }
      var tmp5_safe_receiver = document.body;
      var tmp6_safe_receiver = tmp5_safe_receiver == null ? null : tmp5_safe_receiver.style;
      if (tmp6_safe_receiver == null)
        null;
      else {
        tmp6_safe_receiver.overflowX = 'hidden';
      }
      var tmp7_safe_receiver = document.body;
      var tmp8_safe_receiver = tmp7_safe_receiver == null ? null : tmp7_safe_receiver.style;
      if (tmp8_safe_receiver == null)
        null;
      else {
        tmp8_safe_receiver.overflowY = 'hidden';
      }
    }
    $this.t99_1.addEventListener('wheel', BrowserCanvasJsGameWindow$lambda($this));
    $this.t99_1.addEventListener('mouseenter', BrowserCanvasJsGameWindow$lambda_0($this));
    $this.t99_1.addEventListener('mouseleave', BrowserCanvasJsGameWindow$lambda_1($this));
    $this.t99_1.addEventListener('mouseover', BrowserCanvasJsGameWindow$lambda_2($this));
    $this.t99_1.addEventListener('mousemove', BrowserCanvasJsGameWindow$lambda_3($this));
    $this.t99_1.addEventListener('mouseout', BrowserCanvasJsGameWindow$lambda_4($this));
    $this.t99_1.addEventListener('mouseup', BrowserCanvasJsGameWindow$lambda_5($this));
    $this.t99_1.addEventListener('mousedown', BrowserCanvasJsGameWindow$lambda_6($this));
    $this.t99_1.addEventListener('click', BrowserCanvasJsGameWindow$lambda_7($this));
    $this.t99_1.addEventListener('touchstart', BrowserCanvasJsGameWindow$lambda_8($this));
    $this.t99_1.addEventListener('touchmove', BrowserCanvasJsGameWindow$lambda_9($this));
    $this.t99_1.addEventListener('touchend', BrowserCanvasJsGameWindow$lambda_10($this));
    var tmp_1 = window;
    tmp_1.addEventListener('keypress', BrowserCanvasJsGameWindow$lambda_11($this));
    var tmp_2 = window;
    tmp_2.addEventListener('keydown', BrowserCanvasJsGameWindow$lambda_12($this));
    var tmp_3 = window;
    tmp_3.addEventListener('keyup', BrowserCanvasJsGameWindow$lambda_13($this));
    var tmp_4 = window;
    tmp_4.addEventListener('resize', BrowserCanvasJsGameWindow$lambda_14($this));
    $this.t99_1.ondragenter = BrowserCanvasJsGameWindow$lambda_15($this);
    $this.t99_1.ondragexit = BrowserCanvasJsGameWindow$lambda_16($this);
    $this.t99_1.ondragleave = BrowserCanvasJsGameWindow$lambda_17($this);
    $this.t99_1.ondragover = BrowserCanvasJsGameWindow$lambda_18;
    $this.t99_1.ondragstart = BrowserCanvasJsGameWindow$lambda_19($this);
    $this.t99_1.ondragend = BrowserCanvasJsGameWindow$lambda_20($this);
    $this.t99_1.ondrop = BrowserCanvasJsGameWindow$lambda_21($this);
    onResized($this);
    var tmp_5 = $this;
    tmp_5.g9a_1 = BrowserCanvasJsGameWindow$lambda_22($this);
    $this.h9a_1 = null;
    return $this;
  }
  g9i() {
    return window.devicePixelRatio;
  }
  c8f() {
    return this.g9i() <= 0.0 ? 1.0 : isNaN_0(this.g9i()) ? 1.0 : isInfinite(this.g9i()) ? 1.0 : this.g9i();
  }
  o8m() {
    return this.u99_1;
  }
  f9i() {
    if (this.w99_1 == null) {
      var tmp = this;
      var tmp_0;
      try {
        document.createEvent('TouchEvent');
        tmp_0 = true;
      } catch ($p) {
        var tmp_1;
        var e = $p;
        tmp_1 = false;
        tmp_0 = tmp_1;
      }
      tmp.w99_1 = tmp_0;
    }
    return ensureNotNull(this.w99_1);
  }
  s8n() {
    try {
      if (navigator.getGamepads != null) {
        // Inline function 'kotlin.js.unsafeCast' call
        var gamepads = navigator.getGamepads();
        this.p6f();
        var inductionVariable = 0;
        var last = gamepads.length;
        if (inductionVariable < last)
          $l$loop_0: do {
            var gamepadId = inductionVariable;
            inductionVariable = inductionVariable + 1 | 0;
            // Inline function 'korlibs.render.get' call
            // Inline function 'kotlin.js.asDynamic' call
            var tmp0_elvis_lhs = gamepads[gamepadId];
            var tmp;
            if (tmp0_elvis_lhs == null) {
              continue $l$loop_0;
            } else {
              tmp = tmp0_elvis_lhs;
            }
            var controller = tmp;
            if (!(controller.mapping === 'standard'))
              continue $l$loop_0;
            var gamepad = this.z99_1;
            gamepad.w6f_1 = controller.id;
            var inductionVariable_0 = 0;
            // Inline function 'kotlin.math.min' call
            var a = controller.buttons.length;
            var b = this.x99_1.length;
            var last_0 = Math.min(a, b);
            if (inductionVariable_0 < last_0)
              do {
                var n = inductionVariable_0;
                inductionVariable_0 = inductionVariable_0 + 1 | 0;
                var tmp_0 = gamepad.x6f_1;
                var tmp_1 = this.x99_1[n].t6g();
                // Inline function 'korlibs.render.get' call
                // Inline function 'kotlin.js.asDynamic' call
                tmp_0[tmp_1] = controller.buttons[n].value;
              }
               while (inductionVariable_0 < last_0);
            var inductionVariable_1 = 0;
            // Inline function 'kotlin.math.min' call
            var a_0 = controller.axes.length;
            var b_0 = this.y99_1.length;
            var last_1 = Math.min(a_0, b_0);
            if (inductionVariable_1 < last_1)
              do {
                var n_0 = inductionVariable_1;
                inductionVariable_1 = inductionVariable_1 + 1 | 0;
                var isX = (n_0 % 2 | 0) === 0;
                var isY = !isX;
                // Inline function 'korlibs.render.get' call
                // Inline function 'kotlin.js.asDynamic' call
                var value = controller.axes[n_0];
                var valueWithoutDeadRange = Companion_instance_24.o6g(value, VOID, n_0 <= 3);
                gamepad.x6f_1[this.y99_1[n_0].t6g()] = isY ? -valueWithoutDeadRange : valueWithoutDeadRange;
              }
               while (inductionVariable_1 < last_1);
            this.b6g(gamepad);
          }
           while (inductionVariable < last);
        this.w8n();
      }
    } catch ($p) {
      var e = $p;
      // Inline function 'korlibs.logger.Logger.error' call
      var this_0 = CoroutineKey_getInstance().s8i_1;
      var level = Level_ERROR_getInstance();
      var tmp_2;
      if (this_0.a2u(level)) {
        // Inline function 'korlibs.render.BrowserCanvasJsGameWindow.updateGamepads.<anonymous>' call
        this_0.b2u(level, e);
        tmp_2 = Unit_instance;
      }
    }
  }
  b8n(value) {
    if (!this.a9a_1.equals(value)) {
      this.a9a_1 = value;
      onResized(this);
    }
  }
  k8e() {
    return this.a9a_1;
  }
  v8m(value) {
    document.title = value;
  }
  z2i() {
    return this.t99_1.clientWidth;
  }
  a2j() {
    return this.t99_1.clientHeight;
  }
  m8m(value) {
    this.d9a_1 = value;
    var tmp = this.t99_1.style;
    var tmp_0;
    if (value instanceof Cursor) {
      switch (value.r3_1) {
        case 0:
          tmp_0 = 'default';
          break;
        case 1:
          tmp_0 = 'crosshair';
          break;
        case 2:
          tmp_0 = 'text';
          break;
        case 3:
          tmp_0 = 'pointer';
          break;
        case 4:
          tmp_0 = 'move';
          break;
        case 5:
          tmp_0 = 'wait';
          break;
        case 6:
          tmp_0 = 'e-resize';
          break;
        case 7:
          tmp_0 = 'w-resize';
          break;
        case 8:
          tmp_0 = 's-resize';
          break;
        case 9:
          tmp_0 = 'n-resize';
          break;
        case 10:
          tmp_0 = 'ne-resize';
          break;
        case 11:
          tmp_0 = 'nw-resize';
          break;
        case 12:
          tmp_0 = 'se-resize';
          break;
        case 13:
          tmp_0 = 'sw-resize';
          break;
        default:
          tmp_0 = 'default';
          break;
      }
    } else {
      tmp_0 = 'default';
    }
    tmp.cursor = tmp_0;
  }
  n8m() {
    return this.d9a_1;
  }
  w8m(value) {
    this.e9a_1 = value;
    if (!(value == null)) {
      // Inline function 'kotlin.js.unsafeCast' call
      // Inline function 'kotlin.js.asDynamic' call
      var link = document.querySelector("link[rel*='icon']");
      link.type = 'image/png';
      link.rel = 'shortcut icon';
      link.href = toHtmlNative(value).j65();
      // Inline function 'org.w3c.dom.get' call
      // Inline function 'kotlin.js.asDynamic' call
      var tmp0_safe_receiver = document.getElementsByTagName('head')[0];
      if (tmp0_safe_receiver == null)
        null;
      else
        tmp0_safe_receiver.appendChild(link);
    } else {
      var tmp1_safe_receiver = document.querySelector("link[rel*='icon']");
      if (tmp1_safe_receiver == null)
        null;
      else {
        tmp1_safe_receiver.remove();
      }
    }
  }
  x8m(value) {
    if (!(this.h9i() === value)) {
      // Inline function 'kotlin.runCatching' call
      var tmp;
      try {
        // Inline function 'kotlin.Companion.success' call
        // Inline function 'korlibs.render.BrowserCanvasJsGameWindow.<set-fullscreen>.<anonymous>' call
        var tmp_0;
        if (value) {
          tmp_0 = this.t99_1.requestFullscreen();
        } else {
          tmp_0 = document.exitFullscreen();
        }
        var value_0 = tmp_0;
        tmp = _Result___init__impl__xyqfz8(value_0);
      } catch ($p) {
        var tmp_1;
        if ($p instanceof Error) {
          var e = $p;
          // Inline function 'kotlin.Companion.failure' call
          tmp_1 = _Result___init__impl__xyqfz8(createFailure(e));
        } else {
          throw $p;
        }
        tmp = tmp_1;
      }
    }
  }
  h9i() {
    return !(document.fullscreenElement == null);
  }
  y8m(value) {
    this.t99_1.style.visibility = value ? 'visible' : 'hidden';
  }
  e8n(width, height) {
  }
  i1d(exitCode) {
    var tmp = MainScope();
    launchImmediately_0(tmp, BrowserCanvasJsGameWindow$close$slambda_0(this));
    this.f9a_1 = null;
  }
  j8n(entry, $completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_loop__qll5p8_0.bind(VOID, this, entry), $completion);
  }
  x8n(data, $completion) {
    try {
      var tmp = _get_navigatorClipboard__ni2gks(this);
      tmp.writeText((data instanceof TextClipboardData ? data : THROW_CCE()).n8o_1);
    } catch ($p) {
      if ($p instanceof Error) {
        var e = $p;
        console.error('Failed to write to clipboard: ' + e.message);
      } else {
        throw $p;
      }
    }
  }
  y8n($completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_clipboardRead__wie2ug.bind(VOID, this), $completion);
  }
  i8m(windowRect) {
    ensureSoftKeyboardInput(this);
    var tmp0_safe_receiver = this.h9a_1;
    var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.style;
    if (tmp1_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      // Inline function 'kotlin.contracts.contract' call
      tmp1_safe_receiver.left = '' + windowRect.d26() / this.b9a_1 + 'px';
      tmp1_safe_receiver.top = '' + (windowRect.f26() / this.b9a_1 - 16) + 'px';
      tmp1_safe_receiver.width = '' + windowRect.y25_1 / this.b9a_1 + 'px';
      tmp1_safe_receiver.font = '32px Arial';
      tmp1_safe_receiver.height = '1px';
      tmp1_safe_receiver.opacity = '0';
      tmp1_safe_receiver.background = 'transparent';
      tmp1_safe_receiver.color = 'transparent';
      println('BOUNDS.setInputRectangle:' + tmp1_safe_receiver.left + ',' + tmp1_safe_receiver.top + ',' + tmp1_safe_receiver.width + ',' + tmp1_safe_receiver.height);
    }
  }
  j8m(force, config) {
    var tmp0_safe_receiver = document.body;
    if (tmp0_safe_receiver == null)
      null;
    else
      tmp0_safe_receiver.appendChild(ensureNotNull(this.h9a_1));
    var tmp1_safe_receiver = this.h9a_1;
    if (tmp1_safe_receiver == null)
      null;
    else {
      tmp1_safe_receiver.focus();
    }
  }
  l8m() {
    var tmp0_safe_receiver = this.h9a_1;
    if (tmp0_safe_receiver == null)
      null;
    else {
      tmp0_safe_receiver.blur();
    }
    var tmp1_safe_receiver = document.body;
    if (tmp1_safe_receiver == null)
      null;
    else
      tmp1_safe_receiver.removeChild(ensureNotNull(this.h9a_1));
  }
}
class DenoJsGameWindow$loop$slambda {
  constructor($entry, this$0) {
    this.i9i_1 = $entry;
    this.j9i_1 = this$0;
  }
  ud($completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_2.bind(VOID, this), $completion);
  }
}
class DenoJsGameWindow extends SDLGameWindow {
  static p9f(size, config) {
    size = size === VOID ? Size2D.t26(640, 480) : size;
    config = config === VOID ? Companion_getInstance_75().z8n_1 : config;
    return this.f96(size, config);
  }
  j8n(entry, $completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_loop__qll5p8_1.bind(VOID, this, entry), $completion);
  }
  i1d(exitCode) {
    super.i1d(exitCode);
    Deno.exit(exitCode);
  }
}
class DialogInterfaceJs {}
//endregion
function _get_now__e6dlkr($this) {
  return $this.w68_1().kj_1;
}
function _queueAfter($this, time, interval, task) {
  // Inline function 'korlibs.concurrent.lock.Lock.invoke' call
  var this_0 = $this.t68_1;
  $l$block: {
    // Inline function 'korlibs.concurrent.lock.LockImpl.lockUnlock' call
    this_0.n1v();
    try {
      // Inline function 'korlibs.datastructure.event.SyncEventLoop._queueAfter.<anonymous>' call
      var task_0 = new TimedTask($this, _get_now__e6dlkr($this), time, interval, task);
      if ($this.u68_1) {
        $this.y68_1.g2m(task_0);
      } else {
        Console_getInstance().g2t(['WARNING: QUEUED TASK time=' + Duration__toString_impl_8d916b(time) + ' interval=' + interval + ' without running']);
      }
      $this.t68_1.r1v();
      break $l$block;
    }finally {
      this_0.p1v();
    }
  }
  return task_0;
}
function SyncEventLoop$nowProvider$lambda(this$0) {
  return function () {
    return new Duration(ValueTimeMark__elapsedNow_impl_eonqvs(this$0.v68_1));
  };
}
function SyncEventLoop$timedTasks$lambda(a, b) {
  return a.o68(b);
}
function SyncEventLoop$uncatchedExceptionHandler$lambda(it) {
  printStackTrace(it);
  return Unit_instance;
}
function paused$factory($b0) {
  return getPropertyCallableRef('paused', 0, KMutableProperty0, function () {
    return $b0.o2r_1;
  }, function (value) {
    return $b0.p2r(value);
  });
}
function __updateChildListenerCount($this, type, delta) {
  if (delta === 0)
    return Unit_instance;
  if ($this.s69_1 == null)
    $this.s69_1 = FastIdentityMap();
  var tmp0_safe_receiver = $this.s69_1;
  if (tmp0_safe_receiver == null)
    null;
  else {
    var tmp1_elvis_lhs = get_0(ensureNotNull($this.s69_1), type);
    set(tmp0_safe_receiver, type, (tmp1_elvis_lhs == null ? 0 : tmp1_elvis_lhs) + delta | 0);
  }
  var tmp2_safe_receiver = $this.q69_1;
  if (tmp2_safe_receiver == null)
    null;
  else {
    __updateChildListenerCount(tmp2_safe_receiver, type, delta);
  }
}
function __updateChildListenerCount_0($this, child, add) {
  var tmp0_safe_receiver = child.s69_1;
  if (tmp0_safe_receiver == null)
    null;
  else {
    // Inline function 'korlibs.datastructure.fastForEach' call
    // Inline function 'korlibs.datastructure.fastKeyForEach' call
    // Inline function 'kotlin.js.asDynamic' call
    var mapIterator = tmp0_safe_receiver.keys();
    $l$loop: while (true) {
      var v = mapIterator.next();
      if (v.done)
        break $l$loop;
      // Inline function 'korlibs.datastructure.fastForEach.<anonymous>' call
      var it = v.value;
      // Inline function 'korlibs.event.BaseEventListener.__updateChildListenerCount.<anonymous>' call
      var i = ensureNotNull(get_0(tmp0_safe_receiver, it));
      __updateChildListenerCount($this, it, add ? +i : -i | 0);
    }
  }
}
var Companion_instance_8;
function Companion_getInstance_15() {
  return Companion_instance_8;
}
var Companion_instance_9;
function Companion_getInstance_16() {
  return Companion_instance_9;
}
var Companion_instance_10;
function Companion_getInstance_17() {
  return Companion_instance_10;
}
var Companion_instance_11;
function Companion_getInstance_18() {
  return Companion_instance_11;
}
var Companion_instance_12;
function Companion_getInstance_19() {
  if (Companion_instance_12 === VOID)
    new Companion_3();
  return Companion_instance_12;
}
var Companion_instance_13;
function Companion_getInstance_20() {
  if (Companion_instance_13 === VOID)
    new Companion_4();
  return Companion_instance_13;
}
var Companion_instance_14;
function Companion_getInstance_21() {
  return Companion_instance_14;
}
var Companion_instance_15;
function Companion_getInstance_22() {
  return Companion_instance_15;
}
var Companion_instance_16;
function Companion_getInstance_23() {
  return Companion_instance_16;
}
var Type_UP_instance;
var Type_DOWN_instance;
var Type_TYPE_instance;
var Companion_instance_17;
function Companion_getInstance_24() {
  Type_initEntries();
  if (Companion_instance_17 === VOID)
    new Companion_8();
  return Companion_instance_17;
}
function values() {
  return [Type_UP_getInstance(), Type_DOWN_getInstance(), Type_TYPE_getInstance()];
}
var Type_entriesInitialized;
function Type_initEntries() {
  if (Type_entriesInitialized)
    return Unit_instance;
  Type_entriesInitialized = true;
  Type_UP_instance = new Type('UP', 0);
  Type_DOWN_instance = new Type('DOWN', 1);
  Type_TYPE_instance = new Type('TYPE', 2);
  Companion_getInstance_24();
}
function Type_UP_getInstance() {
  Type_initEntries();
  return Type_UP_instance;
}
function Type_DOWN_getInstance() {
  Type_initEntries();
  return Type_DOWN_instance;
}
function Type_TYPE_getInstance() {
  Type_initEntries();
  return Type_TYPE_instance;
}
var Type_MOVE_instance;
var Type_DRAG_instance;
var Type_UP_instance_0;
var Type_DOWN_instance_0;
var Type_CLICK_instance;
var Type_ENTER_instance;
var Type_EXIT_instance;
var Type_SCROLL_instance;
var Companion_instance_18;
function Companion_getInstance_25() {
  Type_initEntries_0();
  if (Companion_instance_18 === VOID)
    new Companion_9();
  return Companion_instance_18;
}
function values_0() {
  return [Type_MOVE_getInstance(), Type_DRAG_getInstance(), Type_UP_getInstance_0(), Type_DOWN_getInstance_0(), Type_CLICK_getInstance(), Type_ENTER_getInstance(), Type_EXIT_getInstance(), Type_SCROLL_getInstance()];
}
var Type_entriesInitialized_0;
function Type_initEntries_0() {
  if (Type_entriesInitialized_0)
    return Unit_instance;
  Type_entriesInitialized_0 = true;
  Type_MOVE_instance = new Type_0('MOVE', 0);
  Type_DRAG_instance = new Type_0('DRAG', 1);
  Type_UP_instance_0 = new Type_0('UP', 2);
  Type_DOWN_instance_0 = new Type_0('DOWN', 3);
  Type_CLICK_instance = new Type_0('CLICK', 4);
  Type_ENTER_instance = new Type_0('ENTER', 5);
  Type_EXIT_instance = new Type_0('EXIT', 6);
  Type_SCROLL_instance = new Type_0('SCROLL', 7);
  Companion_getInstance_25();
}
var ScrollDeltaMode_PIXEL_instance;
var ScrollDeltaMode_LINE_instance;
var ScrollDeltaMode_PAGE_instance;
var ScrollDeltaMode_entriesInitialized;
function ScrollDeltaMode_initEntries() {
  if (ScrollDeltaMode_entriesInitialized)
    return Unit_instance;
  ScrollDeltaMode_entriesInitialized = true;
  ScrollDeltaMode_PIXEL_instance = new ScrollDeltaMode('PIXEL', 0, 1.0);
  ScrollDeltaMode_LINE_instance = new ScrollDeltaMode('LINE', 1, 10.0);
  ScrollDeltaMode_PAGE_instance = new ScrollDeltaMode('PAGE', 2, 100.0);
}
function MouseEvent$requestLock$lambda() {
  return Unit_instance;
}
function Type_MOVE_getInstance() {
  Type_initEntries_0();
  return Type_MOVE_instance;
}
function Type_DRAG_getInstance() {
  Type_initEntries_0();
  return Type_DRAG_instance;
}
function Type_UP_getInstance_0() {
  Type_initEntries_0();
  return Type_UP_instance_0;
}
function Type_DOWN_getInstance_0() {
  Type_initEntries_0();
  return Type_DOWN_instance_0;
}
function Type_CLICK_getInstance() {
  Type_initEntries_0();
  return Type_CLICK_instance;
}
function Type_ENTER_getInstance() {
  Type_initEntries_0();
  return Type_ENTER_instance;
}
function Type_EXIT_getInstance() {
  Type_initEntries_0();
  return Type_EXIT_instance;
}
function Type_SCROLL_getInstance() {
  Type_initEntries_0();
  return Type_SCROLL_instance;
}
function ScrollDeltaMode_PIXEL_getInstance() {
  ScrollDeltaMode_initEntries();
  return ScrollDeltaMode_PIXEL_instance;
}
function ScrollDeltaMode_LINE_getInstance() {
  ScrollDeltaMode_initEntries();
  return ScrollDeltaMode_LINE_instance;
}
function ScrollDeltaMode_PAGE_getInstance() {
  ScrollDeltaMode_initEntries();
  return ScrollDeltaMode_PAGE_instance;
}
var Type_MAGNIFY_instance;
var Type_ROTATE_instance;
var Type_SWIPE_instance;
var Type_SMART_MAGNIFY_instance;
var Companion_instance_19;
function Companion_getInstance_26() {
  Type_initEntries_1();
  if (Companion_instance_19 === VOID)
    new Companion_10();
  return Companion_instance_19;
}
function values_1() {
  return [Type_MAGNIFY_getInstance(), Type_ROTATE_getInstance(), Type_SWIPE_getInstance(), Type_SMART_MAGNIFY_getInstance()];
}
var Type_entriesInitialized_1;
function Type_initEntries_1() {
  if (Type_entriesInitialized_1)
    return Unit_instance;
  Type_entriesInitialized_1 = true;
  Type_MAGNIFY_instance = new Type_1('MAGNIFY', 0);
  Type_ROTATE_instance = new Type_1('ROTATE', 1);
  Type_SWIPE_instance = new Type_1('SWIPE', 2);
  Type_SMART_MAGNIFY_instance = new Type_1('SMART_MAGNIFY', 3);
  Companion_getInstance_26();
}
function Type_MAGNIFY_getInstance() {
  Type_initEntries_1();
  return Type_MAGNIFY_instance;
}
function Type_ROTATE_getInstance() {
  Type_initEntries_1();
  return Type_ROTATE_instance;
}
function Type_SWIPE_getInstance() {
  Type_initEntries_1();
  return Type_SWIPE_instance;
}
function Type_SMART_MAGNIFY_getInstance() {
  Type_initEntries_1();
  return Type_SMART_MAGNIFY_instance;
}
var Type_START_instance;
var Type_END_instance;
var Type_DROP_instance;
var Companion_instance_20;
function Companion_getInstance_27() {
  Type_initEntries_2();
  if (Companion_instance_20 === VOID)
    new Companion_11();
  return Companion_instance_20;
}
function values_2() {
  return [Type_START_getInstance(), Type_END_getInstance(), Type_DROP_getInstance()];
}
var Type_entriesInitialized_2;
function Type_initEntries_2() {
  if (Type_entriesInitialized_2)
    return Unit_instance;
  Type_entriesInitialized_2 = true;
  Type_START_instance = new Type_2('START', 0);
  Type_END_instance = new Type_2('END', 1);
  Type_DROP_instance = new Type_2('DROP', 2);
  Companion_getInstance_27();
}
function Type_START_getInstance() {
  Type_initEntries_2();
  return Type_START_instance;
}
function Type_END_getInstance() {
  Type_initEntries_2();
  return Type_END_instance;
}
function Type_DROP_getInstance() {
  Type_initEntries_2();
  return Type_DROP_instance;
}
var Status_ADD_instance;
var Status_KEEP_instance;
var Status_REMOVE_instance;
var Status_entriesInitialized;
function Status_initEntries() {
  if (Status_entriesInitialized)
    return Unit_instance;
  Status_entriesInitialized = true;
  Status_ADD_instance = new Status('ADD', 0);
  Status_KEEP_instance = new Status('KEEP', 1);
  Status_REMOVE_instance = new Status('REMOVE', 2);
}
var Kind_FINGER_instance;
var Kind_MOUSE_instance;
var Kind_STYLUS_instance;
var Kind_ERASER_instance;
var Kind_UNKNOWN_instance;
var Kind_entriesInitialized;
function Kind_initEntries() {
  if (Kind_entriesInitialized)
    return Unit_instance;
  Kind_entriesInitialized = true;
  Kind_FINGER_instance = new Kind('FINGER', 0);
  Kind_MOUSE_instance = new Kind('MOUSE', 1);
  Kind_STYLUS_instance = new Kind('STYLUS', 2);
  Kind_ERASER_instance = new Kind('ERASER', 3);
  Kind_UNKNOWN_instance = new Kind('UNKNOWN', 4);
}
var Companion_instance_21;
function Companion_getInstance_28() {
  if (Companion_instance_21 === VOID)
    new Companion_12();
  return Companion_instance_21;
}
function Status_ADD_getInstance() {
  Status_initEntries();
  return Status_ADD_instance;
}
function Status_KEEP_getInstance() {
  Status_initEntries();
  return Status_KEEP_instance;
}
function Status_REMOVE_getInstance() {
  Status_initEntries();
  return Status_REMOVE_instance;
}
function Kind_FINGER_getInstance() {
  Kind_initEntries();
  return Kind_FINGER_instance;
}
function Kind_MOUSE_getInstance() {
  Kind_initEntries();
  return Kind_MOUSE_instance;
}
var Type_START_instance_0;
var Type_END_instance_0;
var Type_MOVE_instance_0;
var Type_HOVER_instance;
var Type_UNKNOWN_instance;
var Companion_instance_22;
function Companion_getInstance_29() {
  Type_initEntries_3();
  if (Companion_instance_22 === VOID)
    new Companion_13();
  return Companion_instance_22;
}
function values_3() {
  return [Type_START_getInstance_0(), Type_END_getInstance_0(), Type_MOVE_getInstance_0(), Type_HOVER_getInstance(), Type_UNKNOWN_getInstance()];
}
var Type_entriesInitialized_3;
function Type_initEntries_3() {
  if (Type_entriesInitialized_3)
    return Unit_instance;
  Type_entriesInitialized_3 = true;
  Type_START_instance_0 = new Type_3('START', 0);
  Type_END_instance_0 = new Type_3('END', 1);
  Type_MOVE_instance_0 = new Type_3('MOVE', 2);
  Type_HOVER_instance = new Type_3('HOVER', 3);
  Type_UNKNOWN_instance = new Type_3('UNKNOWN', 4);
  Companion_getInstance_29();
}
var Companion_instance_23;
function Companion_getInstance_30() {
  return Companion_instance_23;
}
function TouchEvent$toString$lambda(it) {
  return it.toString();
}
function Type_START_getInstance_0() {
  Type_initEntries_3();
  return Type_START_instance_0;
}
function Type_END_getInstance_0() {
  Type_initEntries_3();
  return Type_END_instance_0;
}
function Type_MOVE_getInstance_0() {
  Type_initEntries_3();
  return Type_MOVE_instance_0;
}
function Type_HOVER_getInstance() {
  Type_initEntries_3();
  return Type_HOVER_instance;
}
function Type_UNKNOWN_getInstance() {
  Type_initEntries_3();
  return Type_UNKNOWN_instance;
}
function invoke_0(_this__u8e3s4, block) {
  block(_this__u8e3s4);
  return _this__u8e3s4;
}
var Mode_JS_instance;
var Mode_Android_instance;
var Mode_IOS_instance;
var Mode_entriesInitialized;
function Mode_initEntries() {
  if (Mode_entriesInitialized)
    return Unit_instance;
  Mode_entriesInitialized = true;
  Mode_JS_instance = new Mode('JS', 0);
  Mode_Android_instance = new Mode('Android', 1);
  Mode_IOS_instance = new Mode('IOS', 2);
}
function Mode_JS_getInstance() {
  Mode_initEntries();
  return Mode_JS_instance;
}
var BatteryStatus_CHARGING_instance;
var BatteryStatus_DISCHARGING_instance;
var BatteryStatus_FULL_instance;
var BatteryStatus_UNKNOWN_instance;
var BatteryStatus_entriesInitialized;
function BatteryStatus_initEntries() {
  if (BatteryStatus_entriesInitialized)
    return Unit_instance;
  BatteryStatus_entriesInitialized = true;
  BatteryStatus_CHARGING_instance = new BatteryStatus('CHARGING', 0);
  BatteryStatus_DISCHARGING_instance = new BatteryStatus('DISCHARGING', 1);
  BatteryStatus_FULL_instance = new BatteryStatus('FULL', 2);
  BatteryStatus_UNKNOWN_instance = new BatteryStatus('UNKNOWN', 3);
}
var Companion_instance_24;
function Companion_getInstance_31() {
  return Companion_instance_24;
}
function BatteryStatus_UNKNOWN_getInstance() {
  BatteryStatus_initEntries();
  return BatteryStatus_UNKNOWN_instance;
}
var Companion_instance_25;
function Companion_getInstance_32() {
  return Companion_instance_25;
}
var Type_CONNECTED_instance;
var Type_DISCONNECTED_instance;
var Companion_instance_26;
function Companion_getInstance_33() {
  Type_initEntries_4();
  if (Companion_instance_26 === VOID)
    new Companion_17();
  return Companion_instance_26;
}
function values_4() {
  return [Type_CONNECTED_getInstance(), Type_DISCONNECTED_getInstance()];
}
var Type_entriesInitialized_4;
function Type_initEntries_4() {
  if (Type_entriesInitialized_4)
    return Unit_instance;
  Type_entriesInitialized_4 = true;
  Type_CONNECTED_instance = new Type_4('CONNECTED', 0);
  Type_DISCONNECTED_instance = new Type_4('DISCONNECTED', 1);
  Companion_getInstance_33();
}
function Type_CONNECTED_getInstance() {
  Type_initEntries_4();
  return Type_CONNECTED_instance;
}
function Type_DISCONNECTED_getInstance() {
  Type_initEntries_4();
  return Type_DISCONNECTED_instance;
}
var GameButton_LEFT_instance;
var GameButton_RIGHT_instance;
var GameButton_UP_instance;
var GameButton_DOWN_instance;
var GameButton_BUTTON_SOUTH_instance;
var GameButton_BUTTON_EAST_instance;
var GameButton_BUTTON_WEST_instance;
var GameButton_BUTTON_NORTH_instance;
var GameButton_SELECT_instance;
var GameButton_START_instance;
var GameButton_SYSTEM_instance;
var GameButton_L1_instance;
var GameButton_R1_instance;
var GameButton_L2_instance;
var GameButton_R2_instance;
var GameButton_L3_instance;
var GameButton_R3_instance;
var GameButton_LX_instance;
var GameButton_LY_instance;
var GameButton_RX_instance;
var GameButton_RY_instance;
var GameButton_BUTTON4_instance;
var GameButton_BUTTON5_instance;
var GameButton_BUTTON6_instance;
var GameButton_BUTTON7_instance;
var GameButton_BUTTON8_instance;
var GameButton_RECORD_instance;
var GameButton_DPADX_instance;
var GameButton_DPADY_instance;
var Companion_instance_27;
function Companion_getInstance_34() {
  GameButton_initEntries();
  if (Companion_instance_27 === VOID)
    new Companion_18();
  return Companion_instance_27;
}
function values_5() {
  return [GameButton_LEFT_getInstance(), GameButton_RIGHT_getInstance(), GameButton_UP_getInstance(), GameButton_DOWN_getInstance(), GameButton_BUTTON_SOUTH_getInstance(), GameButton_BUTTON_EAST_getInstance(), GameButton_BUTTON_WEST_getInstance(), GameButton_BUTTON_NORTH_getInstance(), GameButton_SELECT_getInstance(), GameButton_START_getInstance(), GameButton_SYSTEM_getInstance(), GameButton_L1_getInstance(), GameButton_R1_getInstance(), GameButton_L2_getInstance(), GameButton_R2_getInstance(), GameButton_L3_getInstance(), GameButton_R3_getInstance(), GameButton_LX_getInstance(), GameButton_LY_getInstance(), GameButton_RX_getInstance(), GameButton_RY_getInstance(), GameButton_BUTTON4_getInstance(), GameButton_BUTTON5_getInstance(), GameButton_BUTTON6_getInstance(), GameButton_BUTTON7_getInstance(), GameButton_BUTTON8_getInstance(), GameButton_RECORD_getInstance(), GameButton_DPADX_getInstance(), GameButton_DPADY_getInstance()];
}
var GameButton_entriesInitialized;
function GameButton_initEntries() {
  if (GameButton_entriesInitialized)
    return Unit_instance;
  GameButton_entriesInitialized = true;
  GameButton_LEFT_instance = new GameButton('LEFT', 0);
  GameButton_RIGHT_instance = new GameButton('RIGHT', 1);
  GameButton_UP_instance = new GameButton('UP', 2);
  GameButton_DOWN_instance = new GameButton('DOWN', 3);
  GameButton_BUTTON_SOUTH_instance = new GameButton('BUTTON_SOUTH', 4);
  GameButton_BUTTON_EAST_instance = new GameButton('BUTTON_EAST', 5);
  GameButton_BUTTON_WEST_instance = new GameButton('BUTTON_WEST', 6);
  GameButton_BUTTON_NORTH_instance = new GameButton('BUTTON_NORTH', 7);
  GameButton_SELECT_instance = new GameButton('SELECT', 8);
  GameButton_START_instance = new GameButton('START', 9);
  GameButton_SYSTEM_instance = new GameButton('SYSTEM', 10);
  GameButton_L1_instance = new GameButton('L1', 11);
  GameButton_R1_instance = new GameButton('R1', 12);
  GameButton_L2_instance = new GameButton('L2', 13);
  GameButton_R2_instance = new GameButton('R2', 14);
  GameButton_L3_instance = new GameButton('L3', 15);
  GameButton_R3_instance = new GameButton('R3', 16);
  GameButton_LX_instance = new GameButton('LX', 17);
  GameButton_LY_instance = new GameButton('LY', 18);
  GameButton_RX_instance = new GameButton('RX', 19);
  GameButton_RY_instance = new GameButton('RY', 20);
  GameButton_BUTTON4_instance = new GameButton('BUTTON4', 21);
  GameButton_BUTTON5_instance = new GameButton('BUTTON5', 22);
  GameButton_BUTTON6_instance = new GameButton('BUTTON6', 23);
  GameButton_BUTTON7_instance = new GameButton('BUTTON7', 24);
  GameButton_BUTTON8_instance = new GameButton('BUTTON8', 25);
  GameButton_RECORD_instance = new GameButton('RECORD', 26);
  GameButton_DPADX_instance = new GameButton('DPADX', 27);
  GameButton_DPADY_instance = new GameButton('DPADY', 28);
  Companion_getInstance_34();
}
function GameButton_LEFT_getInstance() {
  GameButton_initEntries();
  return GameButton_LEFT_instance;
}
function GameButton_RIGHT_getInstance() {
  GameButton_initEntries();
  return GameButton_RIGHT_instance;
}
function GameButton_UP_getInstance() {
  GameButton_initEntries();
  return GameButton_UP_instance;
}
function GameButton_DOWN_getInstance() {
  GameButton_initEntries();
  return GameButton_DOWN_instance;
}
function GameButton_BUTTON_SOUTH_getInstance() {
  GameButton_initEntries();
  return GameButton_BUTTON_SOUTH_instance;
}
function GameButton_BUTTON_EAST_getInstance() {
  GameButton_initEntries();
  return GameButton_BUTTON_EAST_instance;
}
function GameButton_BUTTON_WEST_getInstance() {
  GameButton_initEntries();
  return GameButton_BUTTON_WEST_instance;
}
function GameButton_BUTTON_NORTH_getInstance() {
  GameButton_initEntries();
  return GameButton_BUTTON_NORTH_instance;
}
function GameButton_SELECT_getInstance() {
  GameButton_initEntries();
  return GameButton_SELECT_instance;
}
function GameButton_START_getInstance() {
  GameButton_initEntries();
  return GameButton_START_instance;
}
function GameButton_SYSTEM_getInstance() {
  GameButton_initEntries();
  return GameButton_SYSTEM_instance;
}
function GameButton_L1_getInstance() {
  GameButton_initEntries();
  return GameButton_L1_instance;
}
function GameButton_R1_getInstance() {
  GameButton_initEntries();
  return GameButton_R1_instance;
}
function GameButton_L2_getInstance() {
  GameButton_initEntries();
  return GameButton_L2_instance;
}
function GameButton_R2_getInstance() {
  GameButton_initEntries();
  return GameButton_R2_instance;
}
function GameButton_L3_getInstance() {
  GameButton_initEntries();
  return GameButton_L3_instance;
}
function GameButton_R3_getInstance() {
  GameButton_initEntries();
  return GameButton_R3_instance;
}
function GameButton_LX_getInstance() {
  GameButton_initEntries();
  return GameButton_LX_instance;
}
function GameButton_LY_getInstance() {
  GameButton_initEntries();
  return GameButton_LY_instance;
}
function GameButton_RX_getInstance() {
  GameButton_initEntries();
  return GameButton_RX_instance;
}
function GameButton_RY_getInstance() {
  GameButton_initEntries();
  return GameButton_RY_instance;
}
function GameButton_BUTTON4_getInstance() {
  GameButton_initEntries();
  return GameButton_BUTTON4_instance;
}
function GameButton_BUTTON5_getInstance() {
  GameButton_initEntries();
  return GameButton_BUTTON5_instance;
}
function GameButton_BUTTON6_getInstance() {
  GameButton_initEntries();
  return GameButton_BUTTON6_instance;
}
function GameButton_BUTTON7_getInstance() {
  GameButton_initEntries();
  return GameButton_BUTTON7_instance;
}
function GameButton_BUTTON8_getInstance() {
  GameButton_initEntries();
  return GameButton_BUTTON8_instance;
}
function GameButton_RECORD_getInstance() {
  GameButton_initEntries();
  return GameButton_RECORD_instance;
}
function GameButton_DPADX_getInstance() {
  GameButton_initEntries();
  return GameButton_DPADX_instance;
}
function GameButton_DPADY_getInstance() {
  GameButton_initEntries();
  return GameButton_DPADY_instance;
}
var Key_SPACE_instance;
var Key_APOSTROPHE_instance;
var Key_COMMA_instance;
var Key_MINUS_instance;
var Key_PLUS_instance;
var Key_PERIOD_instance;
var Key_SLASH_instance;
var Key_N0_instance;
var Key_N1_instance;
var Key_N2_instance;
var Key_N3_instance;
var Key_N4_instance;
var Key_N5_instance;
var Key_N6_instance;
var Key_N7_instance;
var Key_N8_instance;
var Key_N9_instance;
var Key_N11_instance;
var Key_N12_instance;
var Key_N3D_MODE_instance;
var Key_SEMICOLON_instance;
var Key_EQUAL_instance;
var Key_AT_instance;
var Key_A_instance;
var Key_B_instance;
var Key_C_instance;
var Key_D_instance;
var Key_E_instance;
var Key_F_instance;
var Key_G_instance;
var Key_H_instance;
var Key_I_instance;
var Key_J_instance;
var Key_K_instance;
var Key_L_instance;
var Key_M_instance;
var Key_N_instance;
var Key_O_instance;
var Key_P_instance;
var Key_Q_instance;
var Key_R_instance;
var Key_S_instance;
var Key_T_instance;
var Key_U_instance;
var Key_V_instance;
var Key_W_instance;
var Key_X_instance;
var Key_Y_instance;
var Key_Z_instance;
var Key_LEFT_BRACKET_instance;
var Key_BACKSLASH_instance;
var Key_RIGHT_BRACKET_instance;
var Key_GRAVE_ACCENT_instance;
var Key_WORLD_1_instance;
var Key_WORLD_2_instance;
var Key_ESCAPE_instance;
var Key_META_instance;
var Key_ENTER_instance;
var Key_TAB_instance;
var Key_BACKSPACE_instance;
var Key_INSERT_instance;
var Key_DELETE_instance;
var Key_RIGHT_instance;
var Key_LEFT_instance;
var Key_DOWN_instance;
var Key_UP_instance;
var Key_PAGE_UP_instance;
var Key_PAGE_DOWN_instance;
var Key_FUNCTION_instance;
var Key_HELP_instance;
var Key_MUTE_instance;
var Key_VOLUME_DOWN_instance;
var Key_VOLUME_UP_instance;
var Key_VOLUME_MUTE_instance;
var Key_HOME_instance;
var Key_END_instance;
var Key_CAPS_LOCK_instance;
var Key_SCROLL_LOCK_instance;
var Key_NUM_LOCK_instance;
var Key_PRINT_SCREEN_instance;
var Key_PAUSE_instance;
var Key_F1_instance;
var Key_F2_instance;
var Key_F3_instance;
var Key_F4_instance;
var Key_F5_instance;
var Key_F6_instance;
var Key_F7_instance;
var Key_F8_instance;
var Key_F9_instance;
var Key_F10_instance;
var Key_F11_instance;
var Key_F12_instance;
var Key_F13_instance;
var Key_F14_instance;
var Key_F15_instance;
var Key_F16_instance;
var Key_F17_instance;
var Key_F18_instance;
var Key_F19_instance;
var Key_F20_instance;
var Key_F21_instance;
var Key_F22_instance;
var Key_F23_instance;
var Key_F24_instance;
var Key_F25_instance;
var Key_KP_0_instance;
var Key_KP_1_instance;
var Key_KP_2_instance;
var Key_KP_3_instance;
var Key_KP_4_instance;
var Key_KP_5_instance;
var Key_KP_6_instance;
var Key_KP_7_instance;
var Key_KP_8_instance;
var Key_KP_9_instance;
var Key_KP_DECIMAL_instance;
var Key_KP_DIVIDE_instance;
var Key_KP_MULTIPLY_instance;
var Key_KP_SUBTRACT_instance;
var Key_KP_ADD_instance;
var Key_KP_COMMA_instance;
var Key_KP_DOT_instance;
var Key_KP_ENTER_instance;
var Key_KP_EQUAL_instance;
var Key_KP_SEPARATOR_instance;
var Key_KP_LEFT_PAREN_instance;
var Key_KP_RIGHT_PAREN_instance;
var Key_SHIFT_instance;
var Key_CONTROL_instance;
var Key_ALT_instance;
var Key_SUPER_instance;
var Key_MENU_instance;
var Key_BACK_instance;
var Key_BACKQUOTE_instance;
var Key_QUOTE_instance;
var Key_KP_UP_instance;
var Key_KP_DOWN_instance;
var Key_KP_LEFT_instance;
var Key_KP_RIGHT_instance;
var Key_UNDERLINE_instance;
var Key_SELECT_KEY_instance;
var Key_CANCEL_instance;
var Key_CLEAR_instance;
var Key_OPEN_BRACKET_instance;
var Key_CLOSE_BRACKET_instance;
var Key_PLAY_instance;
var Key_NONAME_instance;
var Key_FINAL_instance;
var Key_OEM102_instance;
var Key_OEM1_instance;
var Key_OEM2_instance;
var Key_OEM3_instance;
var Key_OEM4_instance;
var Key_OEM5_instance;
var Key_OEM6_instance;
var Key_OEM7_instance;
var Key_OEM8_instance;
var Key_LEFT_MENU_instance;
var Key_RIGHT_MENU_instance;
var Key_SLEEP_instance;
var Key_SNAPSHOT_instance;
var Key_INFO_instance;
var Key_XBUTTON1_instance;
var Key_XBUTTON2_instance;
var Key_XBUTTON3_instance;
var Key_XBUTTON4_instance;
var Key_XBUTTON5_instance;
var Key_XBUTTON6_instance;
var Key_XBUTTON7_instance;
var Key_XBUTTON8_instance;
var Key_XBUTTON9_instance;
var Key_XBUTTON10_instance;
var Key_XBUTTON11_instance;
var Key_XBUTTON12_instance;
var Key_XBUTTON13_instance;
var Key_XBUTTON14_instance;
var Key_XBUTTON15_instance;
var Key_XBUTTON16_instance;
var Key_XBUTTON_A_instance;
var Key_XBUTTON_B_instance;
var Key_XBUTTON_C_instance;
var Key_XBUTTON_L1_instance;
var Key_XBUTTON_L2_instance;
var Key_XBUTTON_MODE_instance;
var Key_XBUTTON_R1_instance;
var Key_XBUTTON_R2_instance;
var Key_XBUTTON_SELECT_instance;
var Key_XBUTTON_START_instance;
var Key_XBUTTON_THUMBL_instance;
var Key_XBUTTON_THUMBR_instance;
var Key_XBUTTON_X_instance;
var Key_XBUTTON_Y_instance;
var Key_XBUTTON_Z_instance;
var Key_DPAD_CENTER_instance;
var Key_DPAD_DOWN_instance;
var Key_DPAD_DOWN_LEFT_instance;
var Key_DPAD_DOWN_RIGHT_instance;
var Key_DPAD_LEFT_instance;
var Key_DPAD_RIGHT_instance;
var Key_DPAD_UP_instance;
var Key_DPAD_UP_LEFT_instance;
var Key_DPAD_UP_RIGHT_instance;
var Key_DVR_instance;
var Key_EISU_instance;
var Key_ENDCALL_instance;
var Key_ENVELOPE_instance;
var Key_EXPLORER_instance;
var Key_FOCUS_instance;
var Key_FORWARD_instance;
var Key_GRAVE_instance;
var Key_GUIDE_instance;
var Key_HEADSETHOOK_instance;
var Key_ABNT_C1_instance;
var Key_ABNT_C2_instance;
var Key_ATTN_instance;
var Key_CRSEL_instance;
var Key_EREOF_instance;
var Key_EXECUTE_instance;
var Key_EXSEL_instance;
var Key_ICO_CLEAR_instance;
var Key_ICO_HELP_instance;
var Key_HENKAN_instance;
var Key_PAIRING_instance;
var Key_APP_SWITCH_instance;
var Key_ASSIST_instance;
var Key_AVR_INPUT_instance;
var Key_AVR_POWER_instance;
var Key_BOOKMARK_instance;
var Key_BREAK_instance;
var Key_CAPTIONS_instance;
var Key_CAMERA_instance;
var Key_CALL_instance;
var Key_CALENDAR_instance;
var Key_BRIGHTNESS_DOWN_instance;
var Key_BRIGHTNESS_UP_instance;
var Key_CHANNEL_DOWN_instance;
var Key_CHANNEL_UP_instance;
var Key_CALCULATOR_instance;
var Key_CONTACTS_instance;
var Key_NOTIFICATION_instance;
var Key_COPY_instance;
var Key_CUT_instance;
var Key_PASTE_instance;
var Key_SEARCH_instance;
var Key_SETTINGS_instance;
var Key_SOFT_LEFT_instance;
var Key_SOFT_RIGHT_instance;
var Key_SOFT_SLEEP_instance;
var Key_STAR_instance;
var Key_STB_INPUT_instance;
var Key_STB_POWER_instance;
var Key_STEM_1_instance;
var Key_STEM_2_instance;
var Key_STEM_3_instance;
var Key_STEM_PRIMARY_instance;
var Key_SWITCH_CHARSET_instance;
var Key_SYM_instance;
var Key_SYSRQ_instance;
var Key_NUM_instance;
var Key_TV_instance;
var Key_TV_ANTENNA_CABLE_instance;
var Key_TV_AUDIO_DESCRIPTION_instance;
var Key_TV_AUDIO_DESCRIPTION_MIX_DOWN_instance;
var Key_TV_AUDIO_DESCRIPTION_MIX_UP_instance;
var Key_TV_CONTENTS_MENU_instance;
var Key_TV_DATA_SERVICE_instance;
var Key_TV_INPUT_instance;
var Key_TV_INPUT_COMPONENT_1_instance;
var Key_TV_INPUT_COMPONENT_2_instance;
var Key_TV_INPUT_COMPOSITE_1_instance;
var Key_TV_INPUT_COMPOSITE_2_instance;
var Key_TV_INPUT_HDMI_1_instance;
var Key_TV_INPUT_HDMI_2_instance;
var Key_TV_INPUT_HDMI_3_instance;
var Key_TV_INPUT_HDMI_4_instance;
var Key_TV_INPUT_VGA_1_instance;
var Key_TV_MEDIA_CONTEXT_MENU_instance;
var Key_TV_NETWORK_instance;
var Key_TV_NUMBER_ENTRY_instance;
var Key_TV_POWER_instance;
var Key_TV_RADIO_SERVICE_instance;
var Key_TV_SATELLITE_instance;
var Key_TV_SATELLITE_BS_instance;
var Key_TV_SATELLITE_CS_instance;
var Key_TV_SATELLITE_SERVICE_instance;
var Key_TV_TELETEXT_instance;
var Key_TV_TERRESTRIAL_ANALOG_instance;
var Key_TV_TERRESTRIAL_DIGITAL_instance;
var Key_TV_TIMER_PROGRAMMING_instance;
var Key_TV_ZOOM_MODE_instance;
var Key_VOICE_ASSIST_instance;
var Key_WAKEUP_instance;
var Key_WINDOW_instance;
var Key_YEN_instance;
var Key_ZENKAKU_HANKAKU_instance;
var Key_ZOOM_IN_instance;
var Key_ZOOM_OUT_instance;
var Key_SYSTEM_NAVIGATION_DOWN_instance;
var Key_SYSTEM_NAVIGATION_LEFT_instance;
var Key_SYSTEM_NAVIGATION_RIGHT_instance;
var Key_SYSTEM_NAVIGATION_UP_instance;
var Key_PICTSYMBOLS_instance;
var Key_POUND_instance;
var Key_POWER_instance;
var Key_PROG_BLUE_instance;
var Key_PROG_GREEN_instance;
var Key_PROG_RED_instance;
var Key_PROG_YELLOW_instance;
var Key_RO_instance;
var Key_OEM_ATTN_instance;
var Key_OEM_AUTO_instance;
var Key_OEM_AX_instance;
var Key_OEM_BACKTAB_instance;
var Key_OEM_CLEAR_instance;
var Key_OEM_COMMA_instance;
var Key_OEM_COPY_instance;
var Key_OEM_CUSEL_instance;
var Key_OEM_ENLW_instance;
var Key_OEM_FINISH_instance;
var Key_OEM_FJ_LOYA_instance;
var Key_OEM_FJ_MASSHOU_instance;
var Key_OEM_FJ_ROYA_instance;
var Key_OEM_FJ_TOUROKU_instance;
var Key_OEM_JUMP_instance;
var Key_OEM_MINUS_instance;
var Key_OEM_PA1_instance;
var Key_OEM_PA2_instance;
var Key_OEM_PA3_instance;
var Key_OEM_PERIOD_instance;
var Key_OEM_PLUS_instance;
var Key_OEM_RESET_instance;
var Key_OEM_WSCTRL_instance;
var Key_PA1_instance;
var Key_PACKET_instance;
var Key_PROCESSKEY_instance;
var Key_ZOOM_instance;
var Key_NONE_instance;
var Key_ACCEPT_instance;
var Key_APPS_instance;
var Key_BROWSER_BACK_instance;
var Key_BROWSER_FAVORITES_instance;
var Key_BROWSER_FORWARD_instance;
var Key_BROWSER_HOME_instance;
var Key_BROWSER_REFRESH_instance;
var Key_BROWSER_SEARCH_instance;
var Key_BROWSER_STOP_instance;
var Key_CAPITAL_instance;
var Key_CONVERT_instance;
var Key_ICO_00_instance;
var Key_JUNJA_instance;
var Key_KANA_instance;
var Key_KANJI_instance;
var Key_KATAKANA_HIRAGANA_instance;
var Key_LANGUAGE_SWITCH_instance;
var Key_MUHENKAN_instance;
var Key_LAUNCH_APP1_instance;
var Key_LAUNCH_APP2_instance;
var Key_LAUNCH_MAIL_instance;
var Key_LAUNCH_MEDIA_SELECT_instance;
var Key_LEFT_BUTTON_instance;
var Key_MIDDLE_BUTTON_instance;
var Key_MUSIC_instance;
var Key_MEDIA_NEXT_TRACK_instance;
var Key_MEDIA_PLAY_PAUSE_instance;
var Key_MEDIA_PREV_TRACK_instance;
var Key_MEDIA_STOP_instance;
var Key_MEDIA_PLAY_instance;
var Key_MEDIA_PAUSE_instance;
var Key_MEDIA_AUDIO_TRACK_instance;
var Key_MEDIA_CLOSE_instance;
var Key_MEDIA_EJECT_instance;
var Key_MEDIA_FAST_FORWARD_instance;
var Key_MEDIA_RECORD_instance;
var Key_MEDIA_REWIND_instance;
var Key_MEDIA_SKIP_BACKWARD_instance;
var Key_MEDIA_SKIP_FORWARD_instance;
var Key_MEDIA_STEP_BACKWARD_instance;
var Key_MEDIA_STEP_FORWARD_instance;
var Key_MEDIA_TOP_MENU_instance;
var Key_MODECHANGE_instance;
var Key_NEXT_instance;
var Key_NONCONVERT_instance;
var Key_OEM_FJ_JISHO_instance;
var Key_PRIOR_instance;
var Key_RIGHT_BUTTON_instance;
var Key_LAST_CHANNEL_instance;
var Key_MANNER_MODE_instance;
var Key_NAVIGATE_IN_instance;
var Key_NAVIGATE_NEXT_instance;
var Key_NAVIGATE_OUT_instance;
var Key_NAVIGATE_PREVIOUS_instance;
var Key_HYPHEN_instance;
var Key_UNDEFINED_instance;
var Key_UNKNOWN_instance;
var Companion_instance_28;
function Companion_getInstance_35() {
  Key_initEntries();
  if (Companion_instance_28 === VOID)
    new Companion_19();
  return Companion_instance_28;
}
var Key_entriesInitialized;
function Key_initEntries() {
  if (Key_entriesInitialized)
    return Unit_instance;
  Key_entriesInitialized = true;
  Key_SPACE_instance = new Key('SPACE', 0);
  Key_APOSTROPHE_instance = new Key('APOSTROPHE', 1);
  Key_COMMA_instance = new Key('COMMA', 2);
  Key_MINUS_instance = new Key('MINUS', 3);
  Key_PLUS_instance = new Key('PLUS', 4);
  Key_PERIOD_instance = new Key('PERIOD', 5);
  Key_SLASH_instance = new Key('SLASH', 6);
  Key_N0_instance = new Key('N0', 7);
  Key_N1_instance = new Key('N1', 8);
  Key_N2_instance = new Key('N2', 9);
  Key_N3_instance = new Key('N3', 10);
  Key_N4_instance = new Key('N4', 11);
  Key_N5_instance = new Key('N5', 12);
  Key_N6_instance = new Key('N6', 13);
  Key_N7_instance = new Key('N7', 14);
  Key_N8_instance = new Key('N8', 15);
  Key_N9_instance = new Key('N9', 16);
  Key_N11_instance = new Key('N11', 17);
  Key_N12_instance = new Key('N12', 18);
  Key_N3D_MODE_instance = new Key('N3D_MODE', 19);
  Key_SEMICOLON_instance = new Key('SEMICOLON', 20);
  Key_EQUAL_instance = new Key('EQUAL', 21);
  Key_AT_instance = new Key('AT', 22);
  Key_A_instance = new Key('A', 23);
  Key_B_instance = new Key('B', 24);
  Key_C_instance = new Key('C', 25);
  Key_D_instance = new Key('D', 26);
  Key_E_instance = new Key('E', 27);
  Key_F_instance = new Key('F', 28);
  Key_G_instance = new Key('G', 29);
  Key_H_instance = new Key('H', 30);
  Key_I_instance = new Key('I', 31);
  Key_J_instance = new Key('J', 32);
  Key_K_instance = new Key('K', 33);
  Key_L_instance = new Key('L', 34);
  Key_M_instance = new Key('M', 35);
  Key_N_instance = new Key('N', 36);
  Key_O_instance = new Key('O', 37);
  Key_P_instance = new Key('P', 38);
  Key_Q_instance = new Key('Q', 39);
  Key_R_instance = new Key('R', 40);
  Key_S_instance = new Key('S', 41);
  Key_T_instance = new Key('T', 42);
  Key_U_instance = new Key('U', 43);
  Key_V_instance = new Key('V', 44);
  Key_W_instance = new Key('W', 45);
  Key_X_instance = new Key('X', 46);
  Key_Y_instance = new Key('Y', 47);
  Key_Z_instance = new Key('Z', 48);
  Key_LEFT_BRACKET_instance = new Key('LEFT_BRACKET', 49);
  Key_BACKSLASH_instance = new Key('BACKSLASH', 50);
  Key_RIGHT_BRACKET_instance = new Key('RIGHT_BRACKET', 51);
  Key_GRAVE_ACCENT_instance = new Key('GRAVE_ACCENT', 52);
  Key_WORLD_1_instance = new Key('WORLD_1', 53);
  Key_WORLD_2_instance = new Key('WORLD_2', 54);
  Key_ESCAPE_instance = new Key('ESCAPE', 55);
  Key_META_instance = new Key('META', 56);
  Key_ENTER_instance = new Key('ENTER', 57);
  Key_TAB_instance = new Key('TAB', 58);
  Key_BACKSPACE_instance = new Key('BACKSPACE', 59);
  Key_INSERT_instance = new Key('INSERT', 60);
  Key_DELETE_instance = new Key('DELETE', 61);
  Key_RIGHT_instance = new Key('RIGHT', 62);
  Key_LEFT_instance = new Key('LEFT', 63);
  Key_DOWN_instance = new Key('DOWN', 64);
  Key_UP_instance = new Key('UP', 65);
  Key_PAGE_UP_instance = new Key('PAGE_UP', 66);
  Key_PAGE_DOWN_instance = new Key('PAGE_DOWN', 67);
  Key_FUNCTION_instance = new Key('FUNCTION', 68);
  Key_HELP_instance = new Key('HELP', 69);
  Key_MUTE_instance = new Key('MUTE', 70);
  Key_VOLUME_DOWN_instance = new Key('VOLUME_DOWN', 71);
  Key_VOLUME_UP_instance = new Key('VOLUME_UP', 72);
  Key_VOLUME_MUTE_instance = new Key('VOLUME_MUTE', 73);
  Key_HOME_instance = new Key('HOME', 74);
  Key_END_instance = new Key('END', 75);
  Key_CAPS_LOCK_instance = new Key('CAPS_LOCK', 76);
  Key_SCROLL_LOCK_instance = new Key('SCROLL_LOCK', 77);
  Key_NUM_LOCK_instance = new Key('NUM_LOCK', 78);
  Key_PRINT_SCREEN_instance = new Key('PRINT_SCREEN', 79);
  Key_PAUSE_instance = new Key('PAUSE', 80);
  Key_F1_instance = new Key('F1', 81);
  Key_F2_instance = new Key('F2', 82);
  Key_F3_instance = new Key('F3', 83);
  Key_F4_instance = new Key('F4', 84);
  Key_F5_instance = new Key('F5', 85);
  Key_F6_instance = new Key('F6', 86);
  Key_F7_instance = new Key('F7', 87);
  Key_F8_instance = new Key('F8', 88);
  Key_F9_instance = new Key('F9', 89);
  Key_F10_instance = new Key('F10', 90);
  Key_F11_instance = new Key('F11', 91);
  Key_F12_instance = new Key('F12', 92);
  Key_F13_instance = new Key('F13', 93);
  Key_F14_instance = new Key('F14', 94);
  Key_F15_instance = new Key('F15', 95);
  Key_F16_instance = new Key('F16', 96);
  Key_F17_instance = new Key('F17', 97);
  Key_F18_instance = new Key('F18', 98);
  Key_F19_instance = new Key('F19', 99);
  Key_F20_instance = new Key('F20', 100);
  Key_F21_instance = new Key('F21', 101);
  Key_F22_instance = new Key('F22', 102);
  Key_F23_instance = new Key('F23', 103);
  Key_F24_instance = new Key('F24', 104);
  Key_F25_instance = new Key('F25', 105);
  Key_KP_0_instance = new Key('KP_0', 106);
  Key_KP_1_instance = new Key('KP_1', 107);
  Key_KP_2_instance = new Key('KP_2', 108);
  Key_KP_3_instance = new Key('KP_3', 109);
  Key_KP_4_instance = new Key('KP_4', 110);
  Key_KP_5_instance = new Key('KP_5', 111);
  Key_KP_6_instance = new Key('KP_6', 112);
  Key_KP_7_instance = new Key('KP_7', 113);
  Key_KP_8_instance = new Key('KP_8', 114);
  Key_KP_9_instance = new Key('KP_9', 115);
  Key_KP_DECIMAL_instance = new Key('KP_DECIMAL', 116);
  Key_KP_DIVIDE_instance = new Key('KP_DIVIDE', 117);
  Key_KP_MULTIPLY_instance = new Key('KP_MULTIPLY', 118);
  Key_KP_SUBTRACT_instance = new Key('KP_SUBTRACT', 119);
  Key_KP_ADD_instance = new Key('KP_ADD', 120);
  Key_KP_COMMA_instance = new Key('KP_COMMA', 121);
  Key_KP_DOT_instance = new Key('KP_DOT', 122);
  Key_KP_ENTER_instance = new Key('KP_ENTER', 123);
  Key_KP_EQUAL_instance = new Key('KP_EQUAL', 124);
  Key_KP_SEPARATOR_instance = new Key('KP_SEPARATOR', 125);
  Key_KP_LEFT_PAREN_instance = new Key('KP_LEFT_PAREN', 126);
  Key_KP_RIGHT_PAREN_instance = new Key('KP_RIGHT_PAREN', 127);
  Key_SHIFT_instance = new Key('SHIFT', 128);
  Key_CONTROL_instance = new Key('CONTROL', 129);
  Key_ALT_instance = new Key('ALT', 130);
  Key_SUPER_instance = new Key('SUPER', 131);
  Key_MENU_instance = new Key('MENU', 132);
  Key_BACK_instance = new Key('BACK', 133);
  Key_BACKQUOTE_instance = new Key('BACKQUOTE', 134);
  Key_QUOTE_instance = new Key('QUOTE', 135);
  Key_KP_UP_instance = new Key('KP_UP', 136);
  Key_KP_DOWN_instance = new Key('KP_DOWN', 137);
  Key_KP_LEFT_instance = new Key('KP_LEFT', 138);
  Key_KP_RIGHT_instance = new Key('KP_RIGHT', 139);
  Key_UNDERLINE_instance = new Key('UNDERLINE', 140);
  Key_SELECT_KEY_instance = new Key('SELECT_KEY', 141);
  Key_CANCEL_instance = new Key('CANCEL', 142);
  Key_CLEAR_instance = new Key('CLEAR', 143);
  Key_OPEN_BRACKET_instance = new Key('OPEN_BRACKET', 144);
  Key_CLOSE_BRACKET_instance = new Key('CLOSE_BRACKET', 145);
  Key_PLAY_instance = new Key('PLAY', 146);
  Key_NONAME_instance = new Key('NONAME', 147);
  Key_FINAL_instance = new Key('FINAL', 148);
  Key_OEM102_instance = new Key('OEM102', 149);
  Key_OEM1_instance = new Key('OEM1', 150);
  Key_OEM2_instance = new Key('OEM2', 151);
  Key_OEM3_instance = new Key('OEM3', 152);
  Key_OEM4_instance = new Key('OEM4', 153);
  Key_OEM5_instance = new Key('OEM5', 154);
  Key_OEM6_instance = new Key('OEM6', 155);
  Key_OEM7_instance = new Key('OEM7', 156);
  Key_OEM8_instance = new Key('OEM8', 157);
  Key_LEFT_MENU_instance = new Key('LEFT_MENU', 158);
  Key_RIGHT_MENU_instance = new Key('RIGHT_MENU', 159);
  Key_SLEEP_instance = new Key('SLEEP', 160);
  Key_SNAPSHOT_instance = new Key('SNAPSHOT', 161);
  Key_INFO_instance = new Key('INFO', 162);
  Key_XBUTTON1_instance = new Key('XBUTTON1', 163);
  Key_XBUTTON2_instance = new Key('XBUTTON2', 164);
  Key_XBUTTON3_instance = new Key('XBUTTON3', 165);
  Key_XBUTTON4_instance = new Key('XBUTTON4', 166);
  Key_XBUTTON5_instance = new Key('XBUTTON5', 167);
  Key_XBUTTON6_instance = new Key('XBUTTON6', 168);
  Key_XBUTTON7_instance = new Key('XBUTTON7', 169);
  Key_XBUTTON8_instance = new Key('XBUTTON8', 170);
  Key_XBUTTON9_instance = new Key('XBUTTON9', 171);
  Key_XBUTTON10_instance = new Key('XBUTTON10', 172);
  Key_XBUTTON11_instance = new Key('XBUTTON11', 173);
  Key_XBUTTON12_instance = new Key('XBUTTON12', 174);
  Key_XBUTTON13_instance = new Key('XBUTTON13', 175);
  Key_XBUTTON14_instance = new Key('XBUTTON14', 176);
  Key_XBUTTON15_instance = new Key('XBUTTON15', 177);
  Key_XBUTTON16_instance = new Key('XBUTTON16', 178);
  Key_XBUTTON_A_instance = new Key('XBUTTON_A', 179);
  Key_XBUTTON_B_instance = new Key('XBUTTON_B', 180);
  Key_XBUTTON_C_instance = new Key('XBUTTON_C', 181);
  Key_XBUTTON_L1_instance = new Key('XBUTTON_L1', 182);
  Key_XBUTTON_L2_instance = new Key('XBUTTON_L2', 183);
  Key_XBUTTON_MODE_instance = new Key('XBUTTON_MODE', 184);
  Key_XBUTTON_R1_instance = new Key('XBUTTON_R1', 185);
  Key_XBUTTON_R2_instance = new Key('XBUTTON_R2', 186);
  Key_XBUTTON_SELECT_instance = new Key('XBUTTON_SELECT', 187);
  Key_XBUTTON_START_instance = new Key('XBUTTON_START', 188);
  Key_XBUTTON_THUMBL_instance = new Key('XBUTTON_THUMBL', 189);
  Key_XBUTTON_THUMBR_instance = new Key('XBUTTON_THUMBR', 190);
  Key_XBUTTON_X_instance = new Key('XBUTTON_X', 191);
  Key_XBUTTON_Y_instance = new Key('XBUTTON_Y', 192);
  Key_XBUTTON_Z_instance = new Key('XBUTTON_Z', 193);
  Key_DPAD_CENTER_instance = new Key('DPAD_CENTER', 194);
  Key_DPAD_DOWN_instance = new Key('DPAD_DOWN', 195);
  Key_DPAD_DOWN_LEFT_instance = new Key('DPAD_DOWN_LEFT', 196);
  Key_DPAD_DOWN_RIGHT_instance = new Key('DPAD_DOWN_RIGHT', 197);
  Key_DPAD_LEFT_instance = new Key('DPAD_LEFT', 198);
  Key_DPAD_RIGHT_instance = new Key('DPAD_RIGHT', 199);
  Key_DPAD_UP_instance = new Key('DPAD_UP', 200);
  Key_DPAD_UP_LEFT_instance = new Key('DPAD_UP_LEFT', 201);
  Key_DPAD_UP_RIGHT_instance = new Key('DPAD_UP_RIGHT', 202);
  Key_DVR_instance = new Key('DVR', 203);
  Key_EISU_instance = new Key('EISU', 204);
  Key_ENDCALL_instance = new Key('ENDCALL', 205);
  Key_ENVELOPE_instance = new Key('ENVELOPE', 206);
  Key_EXPLORER_instance = new Key('EXPLORER', 207);
  Key_FOCUS_instance = new Key('FOCUS', 208);
  Key_FORWARD_instance = new Key('FORWARD', 209);
  Key_GRAVE_instance = new Key('GRAVE', 210);
  Key_GUIDE_instance = new Key('GUIDE', 211);
  Key_HEADSETHOOK_instance = new Key('HEADSETHOOK', 212);
  Key_ABNT_C1_instance = new Key('ABNT_C1', 213);
  Key_ABNT_C2_instance = new Key('ABNT_C2', 214);
  Key_ATTN_instance = new Key('ATTN', 215);
  Key_CRSEL_instance = new Key('CRSEL', 216);
  Key_EREOF_instance = new Key('EREOF', 217);
  Key_EXECUTE_instance = new Key('EXECUTE', 218);
  Key_EXSEL_instance = new Key('EXSEL', 219);
  Key_ICO_CLEAR_instance = new Key('ICO_CLEAR', 220);
  Key_ICO_HELP_instance = new Key('ICO_HELP', 221);
  Key_HENKAN_instance = new Key('HENKAN', 222);
  Key_PAIRING_instance = new Key('PAIRING', 223);
  Key_APP_SWITCH_instance = new Key('APP_SWITCH', 224);
  Key_ASSIST_instance = new Key('ASSIST', 225);
  Key_AVR_INPUT_instance = new Key('AVR_INPUT', 226);
  Key_AVR_POWER_instance = new Key('AVR_POWER', 227);
  Key_BOOKMARK_instance = new Key('BOOKMARK', 228);
  Key_BREAK_instance = new Key('BREAK', 229);
  Key_CAPTIONS_instance = new Key('CAPTIONS', 230);
  Key_CAMERA_instance = new Key('CAMERA', 231);
  Key_CALL_instance = new Key('CALL', 232);
  Key_CALENDAR_instance = new Key('CALENDAR', 233);
  Key_BRIGHTNESS_DOWN_instance = new Key('BRIGHTNESS_DOWN', 234);
  Key_BRIGHTNESS_UP_instance = new Key('BRIGHTNESS_UP', 235);
  Key_CHANNEL_DOWN_instance = new Key('CHANNEL_DOWN', 236);
  Key_CHANNEL_UP_instance = new Key('CHANNEL_UP', 237);
  Key_CALCULATOR_instance = new Key('CALCULATOR', 238);
  Key_CONTACTS_instance = new Key('CONTACTS', 239);
  Key_NOTIFICATION_instance = new Key('NOTIFICATION', 240);
  Key_COPY_instance = new Key('COPY', 241);
  Key_CUT_instance = new Key('CUT', 242);
  Key_PASTE_instance = new Key('PASTE', 243);
  Key_SEARCH_instance = new Key('SEARCH', 244);
  Key_SETTINGS_instance = new Key('SETTINGS', 245);
  Key_SOFT_LEFT_instance = new Key('SOFT_LEFT', 246);
  Key_SOFT_RIGHT_instance = new Key('SOFT_RIGHT', 247);
  Key_SOFT_SLEEP_instance = new Key('SOFT_SLEEP', 248);
  Key_STAR_instance = new Key('STAR', 249);
  Key_STB_INPUT_instance = new Key('STB_INPUT', 250);
  Key_STB_POWER_instance = new Key('STB_POWER', 251);
  Key_STEM_1_instance = new Key('STEM_1', 252);
  Key_STEM_2_instance = new Key('STEM_2', 253);
  Key_STEM_3_instance = new Key('STEM_3', 254);
  Key_STEM_PRIMARY_instance = new Key('STEM_PRIMARY', 255);
  Key_SWITCH_CHARSET_instance = new Key('SWITCH_CHARSET', 256);
  Key_SYM_instance = new Key('SYM', 257);
  Key_SYSRQ_instance = new Key('SYSRQ', 258);
  Key_NUM_instance = new Key('NUM', 259);
  Key_TV_instance = new Key('TV', 260);
  Key_TV_ANTENNA_CABLE_instance = new Key('TV_ANTENNA_CABLE', 261);
  Key_TV_AUDIO_DESCRIPTION_instance = new Key('TV_AUDIO_DESCRIPTION', 262);
  Key_TV_AUDIO_DESCRIPTION_MIX_DOWN_instance = new Key('TV_AUDIO_DESCRIPTION_MIX_DOWN', 263);
  Key_TV_AUDIO_DESCRIPTION_MIX_UP_instance = new Key('TV_AUDIO_DESCRIPTION_MIX_UP', 264);
  Key_TV_CONTENTS_MENU_instance = new Key('TV_CONTENTS_MENU', 265);
  Key_TV_DATA_SERVICE_instance = new Key('TV_DATA_SERVICE', 266);
  Key_TV_INPUT_instance = new Key('TV_INPUT', 267);
  Key_TV_INPUT_COMPONENT_1_instance = new Key('TV_INPUT_COMPONENT_1', 268);
  Key_TV_INPUT_COMPONENT_2_instance = new Key('TV_INPUT_COMPONENT_2', 269);
  Key_TV_INPUT_COMPOSITE_1_instance = new Key('TV_INPUT_COMPOSITE_1', 270);
  Key_TV_INPUT_COMPOSITE_2_instance = new Key('TV_INPUT_COMPOSITE_2', 271);
  Key_TV_INPUT_HDMI_1_instance = new Key('TV_INPUT_HDMI_1', 272);
  Key_TV_INPUT_HDMI_2_instance = new Key('TV_INPUT_HDMI_2', 273);
  Key_TV_INPUT_HDMI_3_instance = new Key('TV_INPUT_HDMI_3', 274);
  Key_TV_INPUT_HDMI_4_instance = new Key('TV_INPUT_HDMI_4', 275);
  Key_TV_INPUT_VGA_1_instance = new Key('TV_INPUT_VGA_1', 276);
  Key_TV_MEDIA_CONTEXT_MENU_instance = new Key('TV_MEDIA_CONTEXT_MENU', 277);
  Key_TV_NETWORK_instance = new Key('TV_NETWORK', 278);
  Key_TV_NUMBER_ENTRY_instance = new Key('TV_NUMBER_ENTRY', 279);
  Key_TV_POWER_instance = new Key('TV_POWER', 280);
  Key_TV_RADIO_SERVICE_instance = new Key('TV_RADIO_SERVICE', 281);
  Key_TV_SATELLITE_instance = new Key('TV_SATELLITE', 282);
  Key_TV_SATELLITE_BS_instance = new Key('TV_SATELLITE_BS', 283);
  Key_TV_SATELLITE_CS_instance = new Key('TV_SATELLITE_CS', 284);
  Key_TV_SATELLITE_SERVICE_instance = new Key('TV_SATELLITE_SERVICE', 285);
  Key_TV_TELETEXT_instance = new Key('TV_TELETEXT', 286);
  Key_TV_TERRESTRIAL_ANALOG_instance = new Key('TV_TERRESTRIAL_ANALOG', 287);
  Key_TV_TERRESTRIAL_DIGITAL_instance = new Key('TV_TERRESTRIAL_DIGITAL', 288);
  Key_TV_TIMER_PROGRAMMING_instance = new Key('TV_TIMER_PROGRAMMING', 289);
  Key_TV_ZOOM_MODE_instance = new Key('TV_ZOOM_MODE', 290);
  Key_VOICE_ASSIST_instance = new Key('VOICE_ASSIST', 291);
  Key_WAKEUP_instance = new Key('WAKEUP', 292);
  Key_WINDOW_instance = new Key('WINDOW', 293);
  Key_YEN_instance = new Key('YEN', 294);
  Key_ZENKAKU_HANKAKU_instance = new Key('ZENKAKU_HANKAKU', 295);
  Key_ZOOM_IN_instance = new Key('ZOOM_IN', 296);
  Key_ZOOM_OUT_instance = new Key('ZOOM_OUT', 297);
  Key_SYSTEM_NAVIGATION_DOWN_instance = new Key('SYSTEM_NAVIGATION_DOWN', 298);
  Key_SYSTEM_NAVIGATION_LEFT_instance = new Key('SYSTEM_NAVIGATION_LEFT', 299);
  Key_SYSTEM_NAVIGATION_RIGHT_instance = new Key('SYSTEM_NAVIGATION_RIGHT', 300);
  Key_SYSTEM_NAVIGATION_UP_instance = new Key('SYSTEM_NAVIGATION_UP', 301);
  Key_PICTSYMBOLS_instance = new Key('PICTSYMBOLS', 302);
  Key_POUND_instance = new Key('POUND', 303);
  Key_POWER_instance = new Key('POWER', 304);
  Key_PROG_BLUE_instance = new Key('PROG_BLUE', 305);
  Key_PROG_GREEN_instance = new Key('PROG_GREEN', 306);
  Key_PROG_RED_instance = new Key('PROG_RED', 307);
  Key_PROG_YELLOW_instance = new Key('PROG_YELLOW', 308);
  Key_RO_instance = new Key('RO', 309);
  Key_OEM_ATTN_instance = new Key('OEM_ATTN', 310);
  Key_OEM_AUTO_instance = new Key('OEM_AUTO', 311);
  Key_OEM_AX_instance = new Key('OEM_AX', 312);
  Key_OEM_BACKTAB_instance = new Key('OEM_BACKTAB', 313);
  Key_OEM_CLEAR_instance = new Key('OEM_CLEAR', 314);
  Key_OEM_COMMA_instance = new Key('OEM_COMMA', 315);
  Key_OEM_COPY_instance = new Key('OEM_COPY', 316);
  Key_OEM_CUSEL_instance = new Key('OEM_CUSEL', 317);
  Key_OEM_ENLW_instance = new Key('OEM_ENLW', 318);
  Key_OEM_FINISH_instance = new Key('OEM_FINISH', 319);
  Key_OEM_FJ_LOYA_instance = new Key('OEM_FJ_LOYA', 320);
  Key_OEM_FJ_MASSHOU_instance = new Key('OEM_FJ_MASSHOU', 321);
  Key_OEM_FJ_ROYA_instance = new Key('OEM_FJ_ROYA', 322);
  Key_OEM_FJ_TOUROKU_instance = new Key('OEM_FJ_TOUROKU', 323);
  Key_OEM_JUMP_instance = new Key('OEM_JUMP', 324);
  Key_OEM_MINUS_instance = new Key('OEM_MINUS', 325);
  Key_OEM_PA1_instance = new Key('OEM_PA1', 326);
  Key_OEM_PA2_instance = new Key('OEM_PA2', 327);
  Key_OEM_PA3_instance = new Key('OEM_PA3', 328);
  Key_OEM_PERIOD_instance = new Key('OEM_PERIOD', 329);
  Key_OEM_PLUS_instance = new Key('OEM_PLUS', 330);
  Key_OEM_RESET_instance = new Key('OEM_RESET', 331);
  Key_OEM_WSCTRL_instance = new Key('OEM_WSCTRL', 332);
  Key_PA1_instance = new Key('PA1', 333);
  Key_PACKET_instance = new Key('PACKET', 334);
  Key_PROCESSKEY_instance = new Key('PROCESSKEY', 335);
  Key_ZOOM_instance = new Key('ZOOM', 336);
  Key_NONE_instance = new Key('NONE', 337);
  Key_ACCEPT_instance = new Key('ACCEPT', 338);
  Key_APPS_instance = new Key('APPS', 339);
  Key_BROWSER_BACK_instance = new Key('BROWSER_BACK', 340);
  Key_BROWSER_FAVORITES_instance = new Key('BROWSER_FAVORITES', 341);
  Key_BROWSER_FORWARD_instance = new Key('BROWSER_FORWARD', 342);
  Key_BROWSER_HOME_instance = new Key('BROWSER_HOME', 343);
  Key_BROWSER_REFRESH_instance = new Key('BROWSER_REFRESH', 344);
  Key_BROWSER_SEARCH_instance = new Key('BROWSER_SEARCH', 345);
  Key_BROWSER_STOP_instance = new Key('BROWSER_STOP', 346);
  Key_CAPITAL_instance = new Key('CAPITAL', 347);
  Key_CONVERT_instance = new Key('CONVERT', 348);
  Key_ICO_00_instance = new Key('ICO_00', 349);
  Key_JUNJA_instance = new Key('JUNJA', 350);
  Key_KANA_instance = new Key('KANA', 351);
  Key_KANJI_instance = new Key('KANJI', 352);
  Key_KATAKANA_HIRAGANA_instance = new Key('KATAKANA_HIRAGANA', 353);
  Key_LANGUAGE_SWITCH_instance = new Key('LANGUAGE_SWITCH', 354);
  Key_MUHENKAN_instance = new Key('MUHENKAN', 355);
  Key_LAUNCH_APP1_instance = new Key('LAUNCH_APP1', 356);
  Key_LAUNCH_APP2_instance = new Key('LAUNCH_APP2', 357);
  Key_LAUNCH_MAIL_instance = new Key('LAUNCH_MAIL', 358);
  Key_LAUNCH_MEDIA_SELECT_instance = new Key('LAUNCH_MEDIA_SELECT', 359);
  Key_LEFT_BUTTON_instance = new Key('LEFT_BUTTON', 360);
  Key_MIDDLE_BUTTON_instance = new Key('MIDDLE_BUTTON', 361);
  Key_MUSIC_instance = new Key('MUSIC', 362);
  Key_MEDIA_NEXT_TRACK_instance = new Key('MEDIA_NEXT_TRACK', 363);
  Key_MEDIA_PLAY_PAUSE_instance = new Key('MEDIA_PLAY_PAUSE', 364);
  Key_MEDIA_PREV_TRACK_instance = new Key('MEDIA_PREV_TRACK', 365);
  Key_MEDIA_STOP_instance = new Key('MEDIA_STOP', 366);
  Key_MEDIA_PLAY_instance = new Key('MEDIA_PLAY', 367);
  Key_MEDIA_PAUSE_instance = new Key('MEDIA_PAUSE', 368);
  Key_MEDIA_AUDIO_TRACK_instance = new Key('MEDIA_AUDIO_TRACK', 369);
  Key_MEDIA_CLOSE_instance = new Key('MEDIA_CLOSE', 370);
  Key_MEDIA_EJECT_instance = new Key('MEDIA_EJECT', 371);
  Key_MEDIA_FAST_FORWARD_instance = new Key('MEDIA_FAST_FORWARD', 372);
  Key_MEDIA_RECORD_instance = new Key('MEDIA_RECORD', 373);
  Key_MEDIA_REWIND_instance = new Key('MEDIA_REWIND', 374);
  Key_MEDIA_SKIP_BACKWARD_instance = new Key('MEDIA_SKIP_BACKWARD', 375);
  Key_MEDIA_SKIP_FORWARD_instance = new Key('MEDIA_SKIP_FORWARD', 376);
  Key_MEDIA_STEP_BACKWARD_instance = new Key('MEDIA_STEP_BACKWARD', 377);
  Key_MEDIA_STEP_FORWARD_instance = new Key('MEDIA_STEP_FORWARD', 378);
  Key_MEDIA_TOP_MENU_instance = new Key('MEDIA_TOP_MENU', 379);
  Key_MODECHANGE_instance = new Key('MODECHANGE', 380);
  Key_NEXT_instance = new Key('NEXT', 381);
  Key_NONCONVERT_instance = new Key('NONCONVERT', 382);
  Key_OEM_FJ_JISHO_instance = new Key('OEM_FJ_JISHO', 383);
  Key_PRIOR_instance = new Key('PRIOR', 384);
  Key_RIGHT_BUTTON_instance = new Key('RIGHT_BUTTON', 385);
  Key_LAST_CHANNEL_instance = new Key('LAST_CHANNEL', 386);
  Key_MANNER_MODE_instance = new Key('MANNER_MODE', 387);
  Key_NAVIGATE_IN_instance = new Key('NAVIGATE_IN', 388);
  Key_NAVIGATE_NEXT_instance = new Key('NAVIGATE_NEXT', 389);
  Key_NAVIGATE_OUT_instance = new Key('NAVIGATE_OUT', 390);
  Key_NAVIGATE_PREVIOUS_instance = new Key('NAVIGATE_PREVIOUS', 391);
  Key_HYPHEN_instance = new Key('HYPHEN', 392);
  Key_UNDEFINED_instance = new Key('UNDEFINED', 393);
  Key_UNKNOWN_instance = new Key('UNKNOWN', 394);
  Companion_getInstance_35();
}
function Key_SPACE_getInstance() {
  Key_initEntries();
  return Key_SPACE_instance;
}
function Key_APOSTROPHE_getInstance() {
  Key_initEntries();
  return Key_APOSTROPHE_instance;
}
function Key_COMMA_getInstance() {
  Key_initEntries();
  return Key_COMMA_instance;
}
function Key_MINUS_getInstance() {
  Key_initEntries();
  return Key_MINUS_instance;
}
function Key_PLUS_getInstance() {
  Key_initEntries();
  return Key_PLUS_instance;
}
function Key_PERIOD_getInstance() {
  Key_initEntries();
  return Key_PERIOD_instance;
}
function Key_SLASH_getInstance() {
  Key_initEntries();
  return Key_SLASH_instance;
}
function Key_N0_getInstance() {
  Key_initEntries();
  return Key_N0_instance;
}
function Key_N1_getInstance() {
  Key_initEntries();
  return Key_N1_instance;
}
function Key_N2_getInstance() {
  Key_initEntries();
  return Key_N2_instance;
}
function Key_N3_getInstance() {
  Key_initEntries();
  return Key_N3_instance;
}
function Key_N4_getInstance() {
  Key_initEntries();
  return Key_N4_instance;
}
function Key_N5_getInstance() {
  Key_initEntries();
  return Key_N5_instance;
}
function Key_N6_getInstance() {
  Key_initEntries();
  return Key_N6_instance;
}
function Key_N7_getInstance() {
  Key_initEntries();
  return Key_N7_instance;
}
function Key_N8_getInstance() {
  Key_initEntries();
  return Key_N8_instance;
}
function Key_N9_getInstance() {
  Key_initEntries();
  return Key_N9_instance;
}
function Key_SEMICOLON_getInstance() {
  Key_initEntries();
  return Key_SEMICOLON_instance;
}
function Key_A_getInstance() {
  Key_initEntries();
  return Key_A_instance;
}
function Key_B_getInstance() {
  Key_initEntries();
  return Key_B_instance;
}
function Key_C_getInstance() {
  Key_initEntries();
  return Key_C_instance;
}
function Key_D_getInstance() {
  Key_initEntries();
  return Key_D_instance;
}
function Key_E_getInstance() {
  Key_initEntries();
  return Key_E_instance;
}
function Key_F_getInstance() {
  Key_initEntries();
  return Key_F_instance;
}
function Key_G_getInstance() {
  Key_initEntries();
  return Key_G_instance;
}
function Key_H_getInstance() {
  Key_initEntries();
  return Key_H_instance;
}
function Key_I_getInstance() {
  Key_initEntries();
  return Key_I_instance;
}
function Key_J_getInstance() {
  Key_initEntries();
  return Key_J_instance;
}
function Key_K_getInstance() {
  Key_initEntries();
  return Key_K_instance;
}
function Key_L_getInstance() {
  Key_initEntries();
  return Key_L_instance;
}
function Key_M_getInstance() {
  Key_initEntries();
  return Key_M_instance;
}
function Key_N_getInstance() {
  Key_initEntries();
  return Key_N_instance;
}
function Key_O_getInstance() {
  Key_initEntries();
  return Key_O_instance;
}
function Key_P_getInstance() {
  Key_initEntries();
  return Key_P_instance;
}
function Key_Q_getInstance() {
  Key_initEntries();
  return Key_Q_instance;
}
function Key_R_getInstance() {
  Key_initEntries();
  return Key_R_instance;
}
function Key_S_getInstance() {
  Key_initEntries();
  return Key_S_instance;
}
function Key_T_getInstance() {
  Key_initEntries();
  return Key_T_instance;
}
function Key_U_getInstance() {
  Key_initEntries();
  return Key_U_instance;
}
function Key_V_getInstance() {
  Key_initEntries();
  return Key_V_instance;
}
function Key_W_getInstance() {
  Key_initEntries();
  return Key_W_instance;
}
function Key_X_getInstance() {
  Key_initEntries();
  return Key_X_instance;
}
function Key_Y_getInstance() {
  Key_initEntries();
  return Key_Y_instance;
}
function Key_Z_getInstance() {
  Key_initEntries();
  return Key_Z_instance;
}
function Key_ESCAPE_getInstance() {
  Key_initEntries();
  return Key_ESCAPE_instance;
}
function Key_META_getInstance() {
  Key_initEntries();
  return Key_META_instance;
}
function Key_ENTER_getInstance() {
  Key_initEntries();
  return Key_ENTER_instance;
}
function Key_TAB_getInstance() {
  Key_initEntries();
  return Key_TAB_instance;
}
function Key_BACKSPACE_getInstance() {
  Key_initEntries();
  return Key_BACKSPACE_instance;
}
function Key_INSERT_getInstance() {
  Key_initEntries();
  return Key_INSERT_instance;
}
function Key_DELETE_getInstance() {
  Key_initEntries();
  return Key_DELETE_instance;
}
function Key_RIGHT_getInstance() {
  Key_initEntries();
  return Key_RIGHT_instance;
}
function Key_LEFT_getInstance() {
  Key_initEntries();
  return Key_LEFT_instance;
}
function Key_DOWN_getInstance() {
  Key_initEntries();
  return Key_DOWN_instance;
}
function Key_UP_getInstance() {
  Key_initEntries();
  return Key_UP_instance;
}
function Key_PAGE_UP_getInstance() {
  Key_initEntries();
  return Key_PAGE_UP_instance;
}
function Key_PAGE_DOWN_getInstance() {
  Key_initEntries();
  return Key_PAGE_DOWN_instance;
}
function Key_HOME_getInstance() {
  Key_initEntries();
  return Key_HOME_instance;
}
function Key_END_getInstance() {
  Key_initEntries();
  return Key_END_instance;
}
function Key_F1_getInstance() {
  Key_initEntries();
  return Key_F1_instance;
}
function Key_F2_getInstance() {
  Key_initEntries();
  return Key_F2_instance;
}
function Key_F3_getInstance() {
  Key_initEntries();
  return Key_F3_instance;
}
function Key_F4_getInstance() {
  Key_initEntries();
  return Key_F4_instance;
}
function Key_F5_getInstance() {
  Key_initEntries();
  return Key_F5_instance;
}
function Key_F6_getInstance() {
  Key_initEntries();
  return Key_F6_instance;
}
function Key_F7_getInstance() {
  Key_initEntries();
  return Key_F7_instance;
}
function Key_F8_getInstance() {
  Key_initEntries();
  return Key_F8_instance;
}
function Key_F9_getInstance() {
  Key_initEntries();
  return Key_F9_instance;
}
function Key_F10_getInstance() {
  Key_initEntries();
  return Key_F10_instance;
}
function Key_F11_getInstance() {
  Key_initEntries();
  return Key_F11_instance;
}
function Key_F12_getInstance() {
  Key_initEntries();
  return Key_F12_instance;
}
function Key_F13_getInstance() {
  Key_initEntries();
  return Key_F13_instance;
}
function Key_F14_getInstance() {
  Key_initEntries();
  return Key_F14_instance;
}
function Key_F15_getInstance() {
  Key_initEntries();
  return Key_F15_instance;
}
function Key_F16_getInstance() {
  Key_initEntries();
  return Key_F16_instance;
}
function Key_F17_getInstance() {
  Key_initEntries();
  return Key_F17_instance;
}
function Key_F18_getInstance() {
  Key_initEntries();
  return Key_F18_instance;
}
function Key_F19_getInstance() {
  Key_initEntries();
  return Key_F19_instance;
}
function Key_F20_getInstance() {
  Key_initEntries();
  return Key_F20_instance;
}
function Key_F21_getInstance() {
  Key_initEntries();
  return Key_F21_instance;
}
function Key_F22_getInstance() {
  Key_initEntries();
  return Key_F22_instance;
}
function Key_F23_getInstance() {
  Key_initEntries();
  return Key_F23_instance;
}
function Key_F24_getInstance() {
  Key_initEntries();
  return Key_F24_instance;
}
function Key_F25_getInstance() {
  Key_initEntries();
  return Key_F25_instance;
}
function Key_SHIFT_getInstance() {
  Key_initEntries();
  return Key_SHIFT_instance;
}
function Key_CONTROL_getInstance() {
  Key_initEntries();
  return Key_CONTROL_instance;
}
function Key_ALT_getInstance() {
  Key_initEntries();
  return Key_ALT_instance;
}
function Key_SUPER_getInstance() {
  Key_initEntries();
  return Key_SUPER_instance;
}
function Key_QUOTE_getInstance() {
  Key_initEntries();
  return Key_QUOTE_instance;
}
function Key_UNKNOWN_getInstance() {
  Key_initEntries();
  return Key_UNKNOWN_instance;
}
var MouseButton_LEFT_instance;
var MouseButton_MIDDLE_instance;
var MouseButton_RIGHT_instance;
var MouseButton_BUTTON3_instance;
var MouseButton_BUTTON4_instance;
var MouseButton_BUTTON5_instance;
var MouseButton_BUTTON6_instance;
var MouseButton_BUTTON7_instance;
var MouseButton_BUTTON_WHEEL_instance;
var MouseButton_BUTTON_UNKNOWN_instance;
var MouseButton_NONE_instance;
var Companion_instance_29;
function Companion_getInstance_36() {
  MouseButton_initEntries();
  if (Companion_instance_29 === VOID)
    new Companion_20();
  return Companion_instance_29;
}
function values_6() {
  return [MouseButton_LEFT_getInstance(), MouseButton_MIDDLE_getInstance(), MouseButton_RIGHT_getInstance(), MouseButton_BUTTON3_getInstance(), MouseButton_BUTTON4_getInstance(), MouseButton_BUTTON5_getInstance(), MouseButton_BUTTON6_getInstance(), MouseButton_BUTTON7_getInstance(), MouseButton_BUTTON_WHEEL_getInstance(), MouseButton_BUTTON_UNKNOWN_getInstance(), MouseButton_NONE_getInstance()];
}
var MouseButton_entriesInitialized;
function MouseButton_initEntries() {
  if (MouseButton_entriesInitialized)
    return Unit_instance;
  MouseButton_entriesInitialized = true;
  MouseButton_LEFT_instance = new MouseButton('LEFT', 0, 0);
  MouseButton_MIDDLE_instance = new MouseButton('MIDDLE', 1, 1);
  MouseButton_RIGHT_instance = new MouseButton('RIGHT', 2, 2);
  MouseButton_BUTTON3_instance = new MouseButton('BUTTON3', 3, 3);
  MouseButton_BUTTON4_instance = new MouseButton('BUTTON4', 4, 4);
  MouseButton_BUTTON5_instance = new MouseButton('BUTTON5', 5, 5);
  MouseButton_BUTTON6_instance = new MouseButton('BUTTON6', 6, 6);
  MouseButton_BUTTON7_instance = new MouseButton('BUTTON7', 7, 7);
  MouseButton_BUTTON_WHEEL_instance = new MouseButton('BUTTON_WHEEL', 8, 8);
  MouseButton_BUTTON_UNKNOWN_instance = new MouseButton('BUTTON_UNKNOWN', 9, 10);
  MouseButton_NONE_instance = new MouseButton('NONE', 10, 11, 0);
  Companion_getInstance_36();
}
function MouseButton_LEFT_getInstance() {
  MouseButton_initEntries();
  return MouseButton_LEFT_instance;
}
function MouseButton_MIDDLE_getInstance() {
  MouseButton_initEntries();
  return MouseButton_MIDDLE_instance;
}
function MouseButton_RIGHT_getInstance() {
  MouseButton_initEntries();
  return MouseButton_RIGHT_instance;
}
function MouseButton_BUTTON3_getInstance() {
  MouseButton_initEntries();
  return MouseButton_BUTTON3_instance;
}
function MouseButton_BUTTON4_getInstance() {
  MouseButton_initEntries();
  return MouseButton_BUTTON4_instance;
}
function MouseButton_BUTTON5_getInstance() {
  MouseButton_initEntries();
  return MouseButton_BUTTON5_instance;
}
function MouseButton_BUTTON6_getInstance() {
  MouseButton_initEntries();
  return MouseButton_BUTTON6_instance;
}
function MouseButton_BUTTON7_getInstance() {
  MouseButton_initEntries();
  return MouseButton_BUTTON7_instance;
}
function MouseButton_BUTTON_WHEEL_getInstance() {
  MouseButton_initEntries();
  return MouseButton_BUTTON_WHEEL_instance;
}
function MouseButton_BUTTON_UNKNOWN_getInstance() {
  MouseButton_initEntries();
  return MouseButton_BUTTON_UNKNOWN_instance;
}
function MouseButton_NONE_getInstance() {
  MouseButton_initEntries();
  return MouseButton_NONE_instance;
}
var SoftKeyboardType_DEFAULT_instance;
var SoftKeyboardType_ASCII_CAPABLE_instance;
var SoftKeyboardType_NUMBERS_AND_PUNCTUATION_instance;
var SoftKeyboardType_URL_instance;
var SoftKeyboardType_NUMBER_PAD_instance;
var SoftKeyboardType_PHONE_PAD_instance;
var SoftKeyboardType_NAME_PHONE_PAD_instance;
var SoftKeyboardType_EMAIL_ADDRESS_instance;
var SoftKeyboardType_DECIMAL_PAD_instance;
var SoftKeyboardType_TWITTER_instance;
var SoftKeyboardType_WEB_SEARCH_instance;
var SoftKeyboardType_ASCII_CAPABLE_NUMBER_PAD_instance;
var SoftKeyboardType_ALPHABET_instance;
var SoftKeyboardType_entriesInitialized;
function SoftKeyboardType_initEntries() {
  if (SoftKeyboardType_entriesInitialized)
    return Unit_instance;
  SoftKeyboardType_entriesInitialized = true;
  SoftKeyboardType_DEFAULT_instance = new SoftKeyboardType('DEFAULT', 0);
  SoftKeyboardType_ASCII_CAPABLE_instance = new SoftKeyboardType('ASCII_CAPABLE', 1);
  SoftKeyboardType_NUMBERS_AND_PUNCTUATION_instance = new SoftKeyboardType('NUMBERS_AND_PUNCTUATION', 2);
  SoftKeyboardType_URL_instance = new SoftKeyboardType('URL', 3);
  SoftKeyboardType_NUMBER_PAD_instance = new SoftKeyboardType('NUMBER_PAD', 4);
  SoftKeyboardType_PHONE_PAD_instance = new SoftKeyboardType('PHONE_PAD', 5);
  SoftKeyboardType_NAME_PHONE_PAD_instance = new SoftKeyboardType('NAME_PHONE_PAD', 6);
  SoftKeyboardType_EMAIL_ADDRESS_instance = new SoftKeyboardType('EMAIL_ADDRESS', 7);
  SoftKeyboardType_DECIMAL_PAD_instance = new SoftKeyboardType('DECIMAL_PAD', 8);
  SoftKeyboardType_TWITTER_instance = new SoftKeyboardType('TWITTER', 9);
  SoftKeyboardType_WEB_SEARCH_instance = new SoftKeyboardType('WEB_SEARCH', 10);
  SoftKeyboardType_ASCII_CAPABLE_NUMBER_PAD_instance = new SoftKeyboardType('ASCII_CAPABLE_NUMBER_PAD', 11);
  SoftKeyboardType_ALPHABET_instance = new SoftKeyboardType('ALPHABET', 12);
}
var SoftKeyboardReturnKeyType_DEFAULT_instance;
var SoftKeyboardReturnKeyType_GO_instance;
var SoftKeyboardReturnKeyType_JOIN_instance;
var SoftKeyboardReturnKeyType_NEXT_instance;
var SoftKeyboardReturnKeyType_ROUTE_instance;
var SoftKeyboardReturnKeyType_SEARCH_instance;
var SoftKeyboardReturnKeyType_DONE_instance;
var SoftKeyboardReturnKeyType_EMERGENCY_CALL_instance;
var SoftKeyboardReturnKeyType_CONTINUE_instance;
var SoftKeyboardReturnKeyType_entriesInitialized;
function SoftKeyboardReturnKeyType_initEntries() {
  if (SoftKeyboardReturnKeyType_entriesInitialized)
    return Unit_instance;
  SoftKeyboardReturnKeyType_entriesInitialized = true;
  SoftKeyboardReturnKeyType_DEFAULT_instance = new SoftKeyboardReturnKeyType('DEFAULT', 0);
  SoftKeyboardReturnKeyType_GO_instance = new SoftKeyboardReturnKeyType('GO', 1);
  SoftKeyboardReturnKeyType_JOIN_instance = new SoftKeyboardReturnKeyType('JOIN', 2);
  SoftKeyboardReturnKeyType_NEXT_instance = new SoftKeyboardReturnKeyType('NEXT', 3);
  SoftKeyboardReturnKeyType_ROUTE_instance = new SoftKeyboardReturnKeyType('ROUTE', 4);
  SoftKeyboardReturnKeyType_SEARCH_instance = new SoftKeyboardReturnKeyType('SEARCH', 5);
  SoftKeyboardReturnKeyType_DONE_instance = new SoftKeyboardReturnKeyType('DONE', 6);
  SoftKeyboardReturnKeyType_EMERGENCY_CALL_instance = new SoftKeyboardReturnKeyType('EMERGENCY_CALL', 7);
  SoftKeyboardReturnKeyType_CONTINUE_instance = new SoftKeyboardReturnKeyType('CONTINUE', 8);
}
function SoftKeyboardType_DEFAULT_getInstance() {
  SoftKeyboardType_initEntries();
  return SoftKeyboardType_DEFAULT_instance;
}
function SoftKeyboardReturnKeyType_DEFAULT_getInstance() {
  SoftKeyboardReturnKeyType_initEntries();
  return SoftKeyboardReturnKeyType_DEFAULT_instance;
}
var Companion_instance_30;
function Companion_getInstance_37() {
  if (Companion_instance_30 === VOID)
    new Companion_21();
  return Companion_instance_30;
}
function draw(_this__u8e3s4, frameBuffer, vertexData, program, drawType, vertexCount, indices, indexType, drawOffset, blending, uniformBlocks, textureUnits, stencilRef, stencilOpFunc, colorMask, depthAndFrontFace, scissor, cullFace, instances) {
  indices = indices === VOID ? null : indices;
  indexType = indexType === VOID ? Companion_getInstance_42().t6j_1 : indexType;
  drawOffset = drawOffset === VOID ? 0 : drawOffset;
  blending = blending === VOID ? Companion_getInstance_43().x6j_1 : blending;
  uniformBlocks = uniformBlocks === VOID ? Companion_getInstance_59().b6k_1 : uniformBlocks;
  textureUnits = textureUnits === VOID ? Companion_instance_31.d6k() : textureUnits;
  stencilRef = stencilRef === VOID ? Companion_getInstance_46().f6k_1 : stencilRef;
  stencilOpFunc = stencilOpFunc === VOID ? Companion_getInstance_47().h6k_1 : stencilOpFunc;
  colorMask = colorMask === VOID ? Companion_getInstance_48().l6k_1 : colorMask;
  depthAndFrontFace = depthAndFrontFace === VOID ? Companion_getInstance_49().p6k_1 : depthAndFrontFace;
  scissor = scissor === VOID ? Companion_getInstance_44().t6k_1 : scissor;
  cullFace = cullFace === VOID ? Companion_getInstance_50().v6k_1 : cullFace;
  instances = instances === VOID ? 1 : instances;
  return _this__u8e3s4.n6j(frameBuffer.t6i_1, frameBuffer.z6k(), vertexData, program, drawType, vertexCount, indices, indexType, drawOffset, blending, uniformBlocks, textureUnits, stencilRef, stencilOpFunc, colorMask, depthAndFrontFace, scissor, cullFace, instances);
}
function draw_0(_this__u8e3s4, batch) {
  return batch.i6l(_this__u8e3s4);
}
function draw_1(_this__u8e3s4, batch) {
  return batch.i6l(_this__u8e3s4);
}
function upload($this, data, needClone) {
  var tmp0_safe_receiver = $this.g6m_1;
  if ((tmp0_safe_receiver == null ? null : tmp0_safe_receiver.r12()) === data.r12()) {
    if (data.r12() < 1024 && Companion_instance_4.j12(data, 0, ensureNotNull($this.g6m_1), 0, data.r12())) {
      return $this;
    }
    Companion_instance_4.i12(data, 0, ensureNotNull($this.g6m_1), 0, data.r12());
  } else {
    $this.g6m_1 = needClone ? clone(data) : data;
  }
  $this.l6m();
  return $this;
}
var Companion_instance_31;
function Companion_getInstance_38() {
  return Companion_instance_31;
}
var Companion_instance_32;
function Companion_getInstance_39() {
  return Companion_instance_32;
}
function markAsDirty($this) {
}
function checkBitmaps($this, bmp) {
  if (!bmp.d40_1) {
    // Inline function 'korlibs.logger.Logger.error' call
    var this_0 = $this.l6o_1;
    var level = Level_ERROR_getInstance();
    var tmp;
    if (this_0.a2u(level)) {
      // Inline function 'korlibs.graphics.AGTexture.checkBitmaps.<anonymous>' call
      var tmp$ret$0 = 'Trying to upload a non-premultiplied bitmap: ' + toString(bmp) + '. This will cause rendering artifacts';
      this_0.b2u(level, tmp$ret$0);
      tmp = Unit_instance;
    }
  }
}
function _AGTextureUnitInfoArray___init__impl__c77rdb(data) {
  return data;
}
function _AGTextureUnitInfoArray___get_data__impl__a4ycyo($this) {
  return $this;
}
function _AGTextureUnitInfoArray___init__impl__c77rdb_0(size) {
  var tmp = 0;
  var tmp_0 = new Int32Array(size);
  while (tmp < size) {
    tmp_0[tmp] = _AGTextureUnitInfo___get_data__impl__oupy3n(Companion_getInstance_40().a6n_1);
    tmp = tmp + 1 | 0;
  }
  return _AGTextureUnitInfoArray___init__impl__c77rdb(tmp_0);
}
function AGTextureUnitInfoArray__set_impl_s95rfh($this, index, value) {
  _AGTextureUnitInfoArray___get_data__impl__a4ycyo($this)[index] = _AGTextureUnitInfo___get_data__impl__oupy3n(value);
}
function AGTextureUnitInfoArray__get_impl_xhvpef($this, index) {
  return Companion_getInstance_40().v6p(_AGTextureUnitInfoArray___get_data__impl__a4ycyo($this)[index]);
}
function AGTextureUnitInfoArray__copyOf_impl_z2w8z3($this) {
  // Inline function 'kotlin.collections.copyOf' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$1 = _AGTextureUnitInfoArray___get_data__impl__a4ycyo($this).slice();
  return _AGTextureUnitInfoArray___init__impl__c77rdb(tmp$ret$1);
}
function AGTextureUnitInfoArray__toString_impl_kr9cgh($this) {
  return 'AGTextureUnitInfoArray(data=' + toString($this) + ')';
}
function AGTextureUnitInfoArray__hashCode_impl_siosps($this) {
  return hashCode($this);
}
function _AGTextureUnitInfo___init__impl__s1tthu(data) {
  return data;
}
function _AGTextureUnitInfo___get_data__impl__oupy3n($this) {
  return $this;
}
var Companion_instance_33;
function Companion_getInstance_40() {
  if (Companion_instance_33 === VOID)
    new Companion_24();
  return Companion_instance_33;
}
function _AGTextureUnitInfo___get_wrap__impl__dwp6l($this) {
  // Inline function 'korlibs.memory.extract2' call
  var tmp$ret$0 = (_AGTextureUnitInfo___get_data__impl__oupy3n($this) >>> 0 | 0) & 3;
  return _AGWrapMode___init__impl__x5wmya(tmp$ret$0);
}
function _AGTextureUnitInfo___get_linear__impl__jak6ny($this) {
  // Inline function 'korlibs.memory.extract' call
  // Inline function 'korlibs.memory.extract1' call
  return !(((_AGTextureUnitInfo___get_data__impl__oupy3n($this) >>> 2 | 0) & 1) === 0);
}
function _AGTextureUnitInfo___get_trilinear__impl__hxtqfb($this) {
  // Inline function 'korlibs.memory.extract' call
  // Inline function 'korlibs.memory.extract1' call
  return !(((_AGTextureUnitInfo___get_data__impl__oupy3n($this) >>> 3 | 0) & 1) === 0);
}
function _AGTextureUnitInfo___get_kind__impl__6xtjoz($this) {
  return _AGTextureTargetKind___init__impl__4zdmch(extract(_AGTextureUnitInfo___get_data__impl__oupy3n($this), 8, 5));
}
function AGTextureUnitInfo__withKind_impl_aa0b04($this, kind) {
  return _AGTextureUnitInfo___init__impl__s1tthu(insert5(_AGTextureUnitInfo___get_data__impl__oupy3n($this), _AGTextureTargetKind___get_ordinal__impl__gjzc5p(kind), 8));
}
function AGTextureUnitInfo__withWrap_impl_akwb6y($this, wrap) {
  return _AGTextureUnitInfo___init__impl__s1tthu(insert2(_AGTextureUnitInfo___get_data__impl__oupy3n($this), _AGWrapMode___get_ordinal__impl__rc38w2(wrap), 0));
}
function AGTextureUnitInfo__withLinear_impl_jl8yud($this, linear) {
  return _AGTextureUnitInfo___init__impl__s1tthu(insert(_AGTextureUnitInfo___get_data__impl__oupy3n($this), linear, 2));
}
function AGTextureUnitInfo__withTrilinear_impl_vhkcy2($this, trilinear) {
  return _AGTextureUnitInfo___init__impl__s1tthu(insert(_AGTextureUnitInfo___get_data__impl__oupy3n($this), trilinear, 3));
}
function AGTextureUnitInfo__withLinearTrilinear_impl_aactvz($this, linear, trilinear) {
  return AGTextureUnitInfo__withTrilinear_impl_vhkcy2(AGTextureUnitInfo__withLinear_impl_jl8yud($this, linear), trilinear);
}
function AGTextureUnitInfo__toString_impl_7im6je($this) {
  return 'AGTextureUnitInfo(wrap=' + AGWrapMode__toString_impl_8bjnw2(_AGTextureUnitInfo___get_wrap__impl__dwp6l($this)) + ', linear=' + _AGTextureUnitInfo___get_linear__impl__jak6ny($this) + ', trilinear=' + _AGTextureUnitInfo___get_trilinear__impl__hxtqfb($this) + ', kind=' + AGTextureTargetKind__toString_impl_68648p(_AGTextureUnitInfo___get_kind__impl__6xtjoz($this)) + ')';
}
function AGTextureUnitInfo__hashCode_impl_e8jq9h($this) {
  return $this;
}
function AGTextureUnitInfo__equals_impl_j2jlgn($this, other) {
  if (!(other instanceof AGTextureUnitInfo))
    return false;
  if (!($this === (other instanceof AGTextureUnitInfo ? other.b6q_1 : THROW_CCE())))
    return false;
  return true;
}
function _AGDrawType___init__impl__emm6mb(ordinal) {
  return ordinal;
}
var Companion_instance_34;
function Companion_getInstance_41() {
  if (Companion_instance_34 === VOID)
    new Companion_25();
  return Companion_instance_34;
}
function AGDrawType__toString_impl_eonaeb($this) {
  return $this === Companion_getInstance_41().u6s_1 ? 'POINTS' : $this === Companion_getInstance_41().v6s_1 ? 'LINE_STRIP' : $this === Companion_getInstance_41().w6s_1 ? 'LINE_LOOP' : $this === Companion_getInstance_41().x6s_1 ? 'LINES' : $this === Companion_getInstance_41().y6s_1 ? 'TRIANGLES' : $this === Companion_getInstance_41().z6s_1 ? 'TRIANGLE_STRIP' : $this === Companion_getInstance_41().a6t_1 ? 'TRIANGLE_FAN' : '-';
}
function AGDrawType__hashCode_impl_ylaury($this) {
  return $this;
}
function AGDrawType__equals_impl_rtafo6($this, other) {
  if (!(other instanceof AGDrawType))
    return false;
  if (!($this === (other instanceof AGDrawType ? other.b6t_1 : THROW_CCE())))
    return false;
  return true;
}
function _AGIndexType___init__impl__yqnmb7(ordinal) {
  return ordinal;
}
var Companion_instance_35;
function Companion_getInstance_42() {
  if (Companion_instance_35 === VOID)
    new Companion_26();
  return Companion_instance_35;
}
function AGIndexType__toString_impl_hjqwm3($this) {
  return $this === Companion_getInstance_42().r6j_1 ? 'null' : $this === Companion_getInstance_42().s6j_1 ? 'UBYTE' : $this === Companion_getInstance_42().t6j_1 ? 'USHORT' : $this === Companion_getInstance_42().u6j_1 ? 'UINT' : '-';
}
function AGIndexType__hashCode_impl_47f06s($this) {
  return $this;
}
function _AGBlending___init__impl__upt3bq(data) {
  return data;
}
function _AGBlending___get_data__impl__7m3zd1($this) {
  return $this;
}
function _AGBlending___get_srcRGB__impl__jvh03e($this) {
  // Inline function 'korlibs.memory.extract4' call
  var tmp$ret$0 = (_AGBlending___get_data__impl__7m3zd1($this) >>> 0 | 0) & 15;
  return _AGBlendFactor___init__impl__iqtmxr(tmp$ret$0);
}
function _AGBlending___get_srcA__impl__ftmwxe($this) {
  // Inline function 'korlibs.memory.extract4' call
  var tmp$ret$0 = (_AGBlending___get_data__impl__7m3zd1($this) >>> 4 | 0) & 15;
  return _AGBlendFactor___init__impl__iqtmxr(tmp$ret$0);
}
function _AGBlending___get_dstRGB__impl__nz9ogp($this) {
  // Inline function 'korlibs.memory.extract4' call
  var tmp$ret$0 = (_AGBlending___get_data__impl__7m3zd1($this) >>> 8 | 0) & 15;
  return _AGBlendFactor___init__impl__iqtmxr(tmp$ret$0);
}
function _AGBlending___get_dstA__impl__l7q6tv($this) {
  // Inline function 'korlibs.memory.extract4' call
  var tmp$ret$0 = (_AGBlending___get_data__impl__7m3zd1($this) >>> 12 | 0) & 15;
  return _AGBlendFactor___init__impl__iqtmxr(tmp$ret$0);
}
function _AGBlending___get_eqRGB__impl__7pv8oi($this) {
  // Inline function 'korlibs.memory.extract2' call
  var tmp$ret$0 = (_AGBlending___get_data__impl__7m3zd1($this) >>> 16 | 0) & 3;
  return _AGBlendEquation___init__impl__fpv7c2(tmp$ret$0);
}
function _AGBlending___get_eqA__impl__2j4ray($this) {
  // Inline function 'korlibs.memory.extract2' call
  var tmp$ret$0 = (_AGBlending___get_data__impl__7m3zd1($this) >>> 18 | 0) & 3;
  return _AGBlendEquation___init__impl__fpv7c2(tmp$ret$0);
}
function AGBlending__withSRC_impl_hh0mjq($this, rgb, a) {
  return _AGBlending___init__impl__upt3bq(insert4(insert4(_AGBlending___get_data__impl__7m3zd1($this), _AGBlendFactor___get_ordinal__impl__r9efzn(rgb), 0), _AGBlendFactor___get_ordinal__impl__r9efzn(a), 4));
}
function AGBlending__withSRC$default_impl_uuu5hz($this, rgb, a, $super) {
  a = a === VOID ? rgb : a;
  var tmp;
  if ($super === VOID) {
    tmp = AGBlending__withSRC_impl_hh0mjq($this, rgb, a);
  } else {
    var tmp_0 = $super;
    tmp = (tmp_0 == null ? null : new AGBlending(tmp_0)).d6t.call(new AGBlending($this), new AGBlendFactor(rgb), new AGBlendFactor(a)).c6t_1;
  }
  return tmp;
}
function AGBlending__withDST_impl_y1hpet($this, rgb, a) {
  return _AGBlending___init__impl__upt3bq(insert4(insert4(_AGBlending___get_data__impl__7m3zd1($this), _AGBlendFactor___get_ordinal__impl__r9efzn(rgb), 8), _AGBlendFactor___get_ordinal__impl__r9efzn(a), 12));
}
function AGBlending__withDST$default_impl_leu6qg($this, rgb, a, $super) {
  a = a === VOID ? rgb : a;
  var tmp;
  if ($super === VOID) {
    tmp = AGBlending__withDST_impl_y1hpet($this, rgb, a);
  } else {
    var tmp_0 = $super;
    tmp = (tmp_0 == null ? null : new AGBlending(tmp_0)).e6t.call(new AGBlending($this), new AGBlendFactor(rgb), new AGBlendFactor(a)).c6t_1;
  }
  return tmp;
}
function AGBlending__withEQ_impl_e9gm04($this, rgb, a) {
  return _AGBlending___init__impl__upt3bq(insert2(insert2(_AGBlending___get_data__impl__7m3zd1($this), _AGBlendEquation___get_ordinal__impl__895p3q(rgb), 16), _AGBlendEquation___get_ordinal__impl__895p3q(a), 18));
}
function AGBlending__withEQ$default_impl_iltiw7($this, rgb, a, $super) {
  a = a === VOID ? rgb : a;
  var tmp;
  if ($super === VOID) {
    tmp = AGBlending__withEQ_impl_e9gm04($this, rgb, a);
  } else {
    var tmp_0 = $super;
    tmp = (tmp_0 == null ? null : new AGBlending(tmp_0)).f6t.call(new AGBlending($this), new AGBlendEquation(rgb), new AGBlendEquation(a)).c6t_1;
  }
  return tmp;
}
function _AGBlending___get_enabled__impl__s7igz6($this) {
  return !($this === Companion_getInstance_43().w6j_1);
}
function AGBlending__toString_impl_d5hic6($this) {
  return 'Blending(outRGB = (srcRGB * ' + _AGBlendFactor___get_op__impl__b5pfnd(_AGBlending___get_srcRGB__impl__jvh03e($this)) + ') ' + _AGBlendEquation___get_op__impl__7f9os6(_AGBlending___get_eqRGB__impl__7pv8oi($this)) + ' (dstRGB * ' + _AGBlendFactor___get_op__impl__b5pfnd(_AGBlending___get_dstRGB__impl__nz9ogp($this)) + '), outA = (srcA * ' + _AGBlendFactor___get_op__impl__b5pfnd(_AGBlending___get_srcA__impl__ftmwxe($this)) + ') ' + _AGBlendEquation___get_op__impl__7f9os6(_AGBlending___get_eqA__impl__2j4ray($this)) + ' (dstA * ' + _AGBlendFactor___get_op__impl__b5pfnd(_AGBlending___get_dstA__impl__l7q6tv($this)) + '))';
}
var Companion_instance_36;
function Companion_getInstance_43() {
  if (Companion_instance_36 === VOID)
    new Companion_27();
  return Companion_instance_36;
}
function AGBlending__hashCode_impl_ywnf51($this) {
  return $this;
}
function AGBlending__equals_impl_rp3dmf($this, other) {
  if (!(other instanceof AGBlending))
    return false;
  if (!($this === (other instanceof AGBlending ? other.c6t_1 : THROW_CCE())))
    return false;
  return true;
}
var Companion_instance_37;
function Companion_getInstance_44() {
  if (Companion_instance_37 === VOID)
    new Companion_28();
  return Companion_instance_37;
}
function _AGFrameBufferInfo___init__impl__dbxiro(dataLong) {
  return dataLong;
}
function _AGFrameBufferInfo___get_dataLong__impl__7vov5d($this) {
  return $this;
}
function _AGFrameBufferInfo___get_data__impl__7q146j($this) {
  return get_low(_AGFrameBufferInfo___get_dataLong__impl__7vov5d($this));
}
function _AGFrameBufferInfo___get_data2__impl__rgyo5b($this) {
  return get_high(_AGFrameBufferInfo___get_dataLong__impl__7vov5d($this));
}
function _AGFrameBufferInfo___init__impl__dbxiro_0(data, data2) {
  // Inline function 'korlibs.memory.fromLowHigh' call
  Companion_getInstance_0();
  var tmp$ret$0 = toLong(data).j4(new Long(-1, 0)).k4(toLong(data2).g4(32));
  return _AGFrameBufferInfo___init__impl__dbxiro(tmp$ret$0);
}
function _AGFrameBufferInfo___get_width__impl__yhp94z($this) {
  // Inline function 'korlibs.memory.extract14' call
  return (_AGFrameBufferInfo___get_data__impl__7q146j($this) >>> 0 | 0) & 16383;
}
function _AGFrameBufferInfo___get_height__impl__yfespa($this) {
  // Inline function 'korlibs.memory.extract14' call
  return (_AGFrameBufferInfo___get_data__impl__7q146j($this) >>> 14 | 0) & 16383;
}
function _AGFrameBufferInfo___get_x__impl__6dzfjj($this) {
  // Inline function 'korlibs.memory.extract14' call
  return (_AGFrameBufferInfo___get_data2__impl__rgyo5b($this) >>> 0 | 0) & 16383;
}
function _AGFrameBufferInfo___get_y__impl__mfn1io($this) {
  // Inline function 'korlibs.memory.extract14' call
  return (_AGFrameBufferInfo___get_data2__impl__rgyo5b($this) >>> 14 | 0) & 16383;
}
function _AGFrameBufferInfo___get_size__impl__uw80y4($this) {
  return Companion_instance_48.k6u(_AGFrameBufferInfo___get_width__impl__yhp94z($this), _AGFrameBufferInfo___get_height__impl__yfespa($this));
}
function _AGFrameBufferInfo___get_hasDepth__impl__9knjmc($this) {
  // Inline function 'korlibs.memory.extractBool' call
  // Inline function 'korlibs.memory.extract1' call
  return !(((_AGFrameBufferInfo___get_data__impl__7q146j($this) >>> 28 | 0) & 1) === 0);
}
function _AGFrameBufferInfo___get_hasStencil__impl__hjoes3($this) {
  // Inline function 'korlibs.memory.extractBool' call
  // Inline function 'korlibs.memory.extract1' call
  return !(((_AGFrameBufferInfo___get_data__impl__7q146j($this) >>> 29 | 0) & 1) === 0);
}
function _get_samplesBits__rfaq0u($this) {
  // Inline function 'korlibs.memory.extract2' call
  return (_AGFrameBufferInfo___get_data__impl__7q146j($this) >>> 30 | 0) & 3;
}
function _AGFrameBufferInfo___get_samples__impl__7k555s($this) {
  return 1 << _get_samplesBits__rfaq0u($this);
}
function _AGFrameBufferInfo___get_hasStencilAndDepth__impl__aauqdj($this) {
  return _AGFrameBufferInfo___get_hasDepth__impl__9knjmc($this) && _AGFrameBufferInfo___get_hasStencil__impl__hjoes3($this);
}
function AGFrameBufferInfo__withXY_impl_rfdctr($this, x, y) {
  return _AGFrameBufferInfo___init__impl__dbxiro_0(_AGFrameBufferInfo___get_data__impl__7q146j($this), insert14(insert14(_AGFrameBufferInfo___get_data2__impl__rgyo5b($this), x, 0), y, 14));
}
function AGFrameBufferInfo__withSize_impl_sc5iep($this, width, height) {
  return _AGFrameBufferInfo___init__impl__dbxiro_0(insert14(insert14(_AGFrameBufferInfo___get_data__impl__7q146j($this), width, 0), height, 14), _AGFrameBufferInfo___get_data2__impl__rgyo5b($this));
}
function AGFrameBufferInfo__withBounds_impl_sg0n3x($this, x, y, width, height) {
  return AGFrameBufferInfo__withSize_impl_sc5iep(AGFrameBufferInfo__withXY_impl_rfdctr($this, x, y), width, height);
}
function AGFrameBufferInfo__withHasDepth_impl_fjgbiv($this, hasDepth) {
  return _AGFrameBufferInfo___init__impl__dbxiro_0(insert(_AGFrameBufferInfo___get_data__impl__7q146j($this), hasDepth, 28), _AGFrameBufferInfo___get_data2__impl__rgyo5b($this));
}
function AGFrameBufferInfo__withHasStencil_impl_nbaemo($this, hasStencil) {
  return _AGFrameBufferInfo___init__impl__dbxiro_0(insert(_AGFrameBufferInfo___get_data__impl__7q146j($this), hasStencil, 29), _AGFrameBufferInfo___get_data2__impl__rgyo5b($this));
}
function AGFrameBufferInfo__withSamples_impl_83818f($this, samples) {
  return withSamplesBits($this, ilog2(samples));
}
function withSamplesBits($this, bits) {
  return _AGFrameBufferInfo___init__impl__dbxiro_0(insert2(_AGFrameBufferInfo___get_data__impl__7q146j($this), bits, 30), _AGFrameBufferInfo___get_data2__impl__rgyo5b($this));
}
function AGFrameBufferInfo__toString_impl_xecyr8($this) {
  return 'AGFrameBufferInfo(width=' + _AGFrameBufferInfo___get_width__impl__yhp94z($this) + ', height=' + _AGFrameBufferInfo___get_height__impl__yfespa($this) + ', hasDepth=' + _AGFrameBufferInfo___get_hasDepth__impl__9knjmc($this) + ', hasStencil=' + _AGFrameBufferInfo___get_hasStencil__impl__hjoes3($this) + ', samples=' + _AGFrameBufferInfo___get_samples__impl__7k555s($this) + ')';
}
var Companion_instance_38;
function Companion_getInstance_45() {
  if (Companion_instance_38 === VOID)
    new Companion_29();
  return Companion_instance_38;
}
function AGFrameBufferInfo__hashCode_impl_fvl6f1($this) {
  return $this.hashCode();
}
var AGFinish_instance;
function AGFinish_getInstance() {
  return AGFinish_instance;
}
function _AGStencilReference___init__impl__rta8vg(data) {
  return data;
}
function _AGStencilReference___get_data__impl__j5p6bn($this) {
  return $this;
}
function _AGStencilReference___init__impl__rta8vg_0(front, back) {
  // Inline function 'korlibs.memory.fromLowHigh' call
  Companion_getInstance_0();
  var tmp$ret$0 = toLong(front).j4(new Long(-1, 0)).k4(toLong(back).g4(32));
  return _AGStencilReference___init__impl__rta8vg(tmp$ret$0);
}
var Companion_instance_39;
function Companion_getInstance_46() {
  if (Companion_instance_39 === VOID)
    new Companion_30();
  return Companion_instance_39;
}
function _AGStencilReference___get_front__impl__6ggyy0($this) {
  return get_low(_AGStencilReference___get_data__impl__j5p6bn($this));
}
function _AGStencilReference___get_back__impl__mm7fqe($this) {
  return get_high(_AGStencilReference___get_data__impl__j5p6bn($this));
}
function _AGStencilReference___get_referenceValueFront__impl__p7smsu($this) {
  // Inline function 'korlibs.memory.extract8' call
  return (_AGStencilReference___get_front__impl__6ggyy0($this) >>> 0 | 0) & 255;
}
function _AGStencilReference___get_readMaskFront__impl__oc0s46($this) {
  // Inline function 'korlibs.memory.extract8' call
  return (_AGStencilReference___get_front__impl__6ggyy0($this) >>> 8 | 0) & 255;
}
function _AGStencilReference___get_writeMaskFront__impl__cqdpbj($this) {
  // Inline function 'korlibs.memory.extract8' call
  return (_AGStencilReference___get_front__impl__6ggyy0($this) >>> 16 | 0) & 255;
}
function _AGStencilReference___get_referenceValueBack__impl__mlrbhc($this) {
  // Inline function 'korlibs.memory.extract8' call
  return (_AGStencilReference___get_back__impl__mm7fqe($this) >>> 0 | 0) & 255;
}
function _AGStencilReference___get_readMaskBack__impl__lwtaqk($this) {
  // Inline function 'korlibs.memory.extract8' call
  return (_AGStencilReference___get_back__impl__mm7fqe($this) >>> 8 | 0) & 255;
}
function _AGStencilReference___get_writeMaskBack__impl__mths73($this) {
  // Inline function 'korlibs.memory.extract8' call
  return (_AGStencilReference___get_back__impl__mm7fqe($this) >>> 16 | 0) & 255;
}
function AGStencilReference__withReferenceValue_impl_lm1qpg($this, referenceValue, referenceValueBack) {
  return _AGStencilReference___init__impl__rta8vg_0(insert8(_AGStencilReference___get_front__impl__6ggyy0($this), referenceValue, 0), insert8(_AGStencilReference___get_back__impl__mm7fqe($this), referenceValueBack, 0));
}
function AGStencilReference__withReferenceValue$default_impl_2trj0v($this, referenceValue, referenceValueBack, $super) {
  referenceValueBack = referenceValueBack === VOID ? referenceValue : referenceValueBack;
  var tmp;
  if ($super === VOID) {
    tmp = AGStencilReference__withReferenceValue_impl_lm1qpg($this, referenceValue, referenceValueBack);
  } else {
    var tmp_0 = $super;
    tmp = (tmp_0 == null ? null : new AGStencilReference(tmp_0)).w6u.call(new AGStencilReference($this), referenceValue, referenceValueBack).v6u_1;
  }
  return tmp;
}
function AGStencilReference__withReadMask_impl_75whrk($this, readMask, readMaskBack) {
  return _AGStencilReference___init__impl__rta8vg_0(insert8(_AGStencilReference___get_front__impl__6ggyy0($this), readMask, 8), insert8(_AGStencilReference___get_back__impl__mm7fqe($this), readMaskBack, 8));
}
function AGStencilReference__withReadMask$default_impl_7mdffx($this, readMask, readMaskBack, $super) {
  readMaskBack = readMaskBack === VOID ? readMask : readMaskBack;
  var tmp;
  if ($super === VOID) {
    tmp = AGStencilReference__withReadMask_impl_75whrk($this, readMask, readMaskBack);
  } else {
    var tmp_0 = $super;
    tmp = (tmp_0 == null ? null : new AGStencilReference(tmp_0)).x6u.call(new AGStencilReference($this), readMask, readMaskBack).v6u_1;
  }
  return tmp;
}
function AGStencilReference__withWriteMask_impl_s5s8t($this, writeMask, writeMaskBack) {
  return _AGStencilReference___init__impl__rta8vg_0(insert8(_AGStencilReference___get_front__impl__6ggyy0($this), writeMask, 16), insert8(_AGStencilReference___get_back__impl__mm7fqe($this), writeMaskBack, 16));
}
function AGStencilReference__withWriteMask$default_impl_b7j7b4($this, writeMask, writeMaskBack, $super) {
  writeMaskBack = writeMaskBack === VOID ? writeMask : writeMaskBack;
  var tmp;
  if ($super === VOID) {
    tmp = AGStencilReference__withWriteMask_impl_s5s8t($this, writeMask, writeMaskBack);
  } else {
    var tmp_0 = $super;
    tmp = (tmp_0 == null ? null : new AGStencilReference(tmp_0)).y6u.call(new AGStencilReference($this), writeMask, writeMaskBack).v6u_1;
  }
  return tmp;
}
function AGStencilReference__toString_impl_qu5r8s($this) {
  return 'AGStencilReference(front=[referenceValue=' + _AGStencilReference___get_referenceValueFront__impl__p7smsu($this) + ', readMask=' + _AGStencilReference___get_readMaskFront__impl__oc0s46($this) + ', writeMask=' + _AGStencilReference___get_writeMaskFront__impl__cqdpbj($this) + '], back=[referenceValue=' + _AGStencilReference___get_referenceValueBack__impl__mlrbhc($this) + ', readMask=' + _AGStencilReference___get_readMaskBack__impl__lwtaqk($this) + ', writeMask=' + _AGStencilReference___get_writeMaskBack__impl__mths73($this) + '])';
}
function AGStencilReference__hashCode_impl_52zufx($this) {
  return $this.hashCode();
}
function AGStencilReference__equals_impl_kj05j($this, other) {
  if (!(other instanceof AGStencilReference))
    return false;
  var tmp0_other_with_cast = other instanceof AGStencilReference ? other.v6u_1 : THROW_CCE();
  if (!$this.equals(tmp0_other_with_cast))
    return false;
  return true;
}
function _AGStencilOpFunc___init__impl__t3f62q(data) {
  return data;
}
function _AGStencilOpFunc___get_data__impl__jitrg1($this) {
  return $this;
}
var Companion_instance_40;
function Companion_getInstance_47() {
  if (Companion_instance_40 === VOID)
    new Companion_31();
  return Companion_instance_40;
}
function _AGStencilOpFunc___get_enabled__impl__hxq8wy($this) {
  // Inline function 'korlibs.memory.extractBool' call
  // Inline function 'korlibs.memory.extract1' call
  return !(((_AGStencilOpFunc___get_data__impl__jitrg1($this) >>> 31 | 0) & 1) === 0);
}
function _AGStencilOpFunc___get_compareModeFront__impl__uctsey($this) {
  // Inline function 'korlibs.memory.extract3' call
  var tmp$ret$0 = (_AGStencilOpFunc___get_data__impl__jitrg1($this) >>> 0 | 0) & 7;
  return _AGCompareMode___init__impl__j8kqbb(tmp$ret$0);
}
function _AGStencilOpFunc___get_actionOnBothPassFront__impl__aehsgx($this) {
  // Inline function 'korlibs.memory.extract3' call
  var tmp$ret$0 = (_AGStencilOpFunc___get_data__impl__jitrg1($this) >>> 3 | 0) & 7;
  return _AGStencilOp___init__impl__llpkv6(tmp$ret$0);
}
function _AGStencilOpFunc___get_actionOnDepthFailFront__impl__vuqmyq($this) {
  // Inline function 'korlibs.memory.extract3' call
  var tmp$ret$0 = (_AGStencilOpFunc___get_data__impl__jitrg1($this) >>> 6 | 0) & 7;
  return _AGStencilOp___init__impl__llpkv6(tmp$ret$0);
}
function _AGStencilOpFunc___get_actionOnDepthPassStencilFailFront__impl__kl5ndh($this) {
  // Inline function 'korlibs.memory.extract3' call
  var tmp$ret$0 = (_AGStencilOpFunc___get_data__impl__jitrg1($this) >>> 9 | 0) & 7;
  return _AGStencilOp___init__impl__llpkv6(tmp$ret$0);
}
function _AGStencilOpFunc___get_compareModeBack__impl__2rklx0($this) {
  // Inline function 'korlibs.memory.extract3' call
  var tmp$ret$0 = (_AGStencilOpFunc___get_data__impl__jitrg1($this) >>> 12 | 0) & 7;
  return _AGCompareMode___init__impl__j8kqbb(tmp$ret$0);
}
function _AGStencilOpFunc___get_actionOnBothPassBack__impl__i5t9l9($this) {
  // Inline function 'korlibs.memory.extract3' call
  var tmp$ret$0 = (_AGStencilOpFunc___get_data__impl__jitrg1($this) >>> 15 | 0) & 7;
  return _AGStencilOp___init__impl__llpkv6(tmp$ret$0);
}
function _AGStencilOpFunc___get_actionOnDepthFailBack__impl__3tna28($this) {
  // Inline function 'korlibs.memory.extract3' call
  var tmp$ret$0 = (_AGStencilOpFunc___get_data__impl__jitrg1($this) >>> 18 | 0) & 7;
  return _AGStencilOp___init__impl__llpkv6(tmp$ret$0);
}
function _AGStencilOpFunc___get_actionOnDepthPassStencilFailBack__impl__4qprmh($this) {
  // Inline function 'korlibs.memory.extract3' call
  var tmp$ret$0 = (_AGStencilOpFunc___get_data__impl__jitrg1($this) >>> 21 | 0) & 7;
  return _AGStencilOp___init__impl__llpkv6(tmp$ret$0);
}
function AGStencilOpFunc__withEnabled_impl_mpcwmr($this, enabled) {
  return _AGStencilOpFunc___init__impl__t3f62q(insert(_AGStencilOpFunc___get_data__impl__jitrg1($this), enabled, 31));
}
function AGStencilOpFunc__withCompareMode_impl_5ovohy($this, compareMode, compareModeBack) {
  return _AGStencilOpFunc___init__impl__t3f62q(insert3(insert3(_AGStencilOpFunc___get_data__impl__jitrg1($this), _AGCompareMode___get_ordinal__impl__ikvlmz(compareMode), 0), _AGCompareMode___get_ordinal__impl__ikvlmz(compareModeBack), 12));
}
function AGStencilOpFunc__withCompareMode$default_impl_rzbauv($this, compareMode, compareModeBack, $super) {
  compareModeBack = compareModeBack === VOID ? compareMode : compareModeBack;
  var tmp;
  if ($super === VOID) {
    tmp = AGStencilOpFunc__withCompareMode_impl_5ovohy($this, compareMode, compareModeBack);
  } else {
    var tmp_0 = $super;
    tmp = (tmp_0 == null ? null : new AGStencilOpFunc(tmp_0)).q6v.call(new AGStencilOpFunc($this), new AGCompareMode(compareMode), new AGCompareMode(compareModeBack)).p6v_1;
  }
  return tmp;
}
function AGStencilOpFunc__withActionOnBothPass_impl_qbn6at($this, actionOnBothPass, actionOnBothPassBack) {
  return _AGStencilOpFunc___init__impl__t3f62q(insert3(insert3(_AGStencilOpFunc___get_data__impl__jitrg1($this), _AGStencilOp___get_ordinal__impl__xkavfu(actionOnBothPass), 3), _AGStencilOp___get_ordinal__impl__xkavfu(actionOnBothPassBack), 15));
}
function AGStencilOpFunc__withActionOnBothPass$default_impl_69nsgo($this, actionOnBothPass, actionOnBothPassBack, $super) {
  actionOnBothPassBack = actionOnBothPassBack === VOID ? actionOnBothPass : actionOnBothPassBack;
  var tmp;
  if ($super === VOID) {
    tmp = AGStencilOpFunc__withActionOnBothPass_impl_qbn6at($this, actionOnBothPass, actionOnBothPassBack);
  } else {
    var tmp_0 = $super;
    tmp = (tmp_0 == null ? null : new AGStencilOpFunc(tmp_0)).r6v.call(new AGStencilOpFunc($this), new AGStencilOp(actionOnBothPass), new AGStencilOp(actionOnBothPassBack)).p6v_1;
  }
  return tmp;
}
function AGStencilOpFunc__withActionOnDepthFail_impl_6tt0te($this, actionOnDepthFail, actionOnDepthFailBack) {
  return _AGStencilOpFunc___init__impl__t3f62q(insert3(insert3(_AGStencilOpFunc___get_data__impl__jitrg1($this), _AGStencilOp___get_ordinal__impl__xkavfu(actionOnDepthFail), 6), _AGStencilOp___get_ordinal__impl__xkavfu(actionOnDepthFailBack), 18));
}
function AGStencilOpFunc__withActionOnDepthPassStencilFail_impl_q34w35($this, actionOnDepthPassStencilFail, actionOnDepthPassStencilFailBack) {
  return _AGStencilOpFunc___init__impl__t3f62q(insert3(insert3(_AGStencilOpFunc___get_data__impl__jitrg1($this), _AGStencilOp___get_ordinal__impl__xkavfu(actionOnDepthPassStencilFail), 9), _AGStencilOp___get_ordinal__impl__xkavfu(actionOnDepthPassStencilFailBack), 21));
}
function AGStencilOpFunc__withAction_impl_p1jbl6($this, actionOnBothPass, actionOnDepthFail, actionOnDepthPassStencilFail, actionOnBothPassBack, actionOnDepthFailBack, actionOnDepthPassStencilFailBack) {
  return AGStencilOpFunc__withActionOnDepthPassStencilFail_impl_q34w35(AGStencilOpFunc__withActionOnDepthFail_impl_6tt0te(AGStencilOpFunc__withActionOnBothPass_impl_qbn6at($this, actionOnBothPass, actionOnBothPassBack), actionOnDepthFail, actionOnDepthFailBack), actionOnDepthPassStencilFail, actionOnDepthPassStencilFailBack);
}
function AGStencilOpFunc__withAction$default_impl_jx9cm1($this, actionOnBothPass, actionOnDepthFail, actionOnDepthPassStencilFail, actionOnBothPassBack, actionOnDepthFailBack, actionOnDepthPassStencilFailBack, $super) {
  actionOnDepthFail = actionOnDepthFail === VOID ? actionOnBothPass : actionOnDepthFail;
  actionOnDepthPassStencilFail = actionOnDepthPassStencilFail === VOID ? actionOnDepthFail : actionOnDepthPassStencilFail;
  actionOnBothPassBack = actionOnBothPassBack === VOID ? actionOnBothPass : actionOnBothPassBack;
  actionOnDepthFailBack = actionOnDepthFailBack === VOID ? actionOnDepthFail : actionOnDepthFailBack;
  actionOnDepthPassStencilFailBack = actionOnDepthPassStencilFailBack === VOID ? actionOnDepthPassStencilFail : actionOnDepthPassStencilFailBack;
  var tmp;
  if ($super === VOID) {
    tmp = AGStencilOpFunc__withAction_impl_p1jbl6($this, actionOnBothPass, actionOnDepthFail, actionOnDepthPassStencilFail, actionOnBothPassBack, actionOnDepthFailBack, actionOnDepthPassStencilFailBack);
  } else {
    var tmp_0 = $super;
    tmp = (tmp_0 == null ? null : new AGStencilOpFunc(tmp_0)).s6v.call(new AGStencilOpFunc($this), new AGStencilOp(actionOnBothPass), new AGStencilOp(actionOnDepthFail), new AGStencilOp(actionOnDepthPassStencilFail), new AGStencilOp(actionOnBothPassBack), new AGStencilOp(actionOnDepthFailBack), new AGStencilOp(actionOnDepthPassStencilFailBack)).p6v_1;
  }
  return tmp;
}
function AGStencilOpFunc__toString_impl_pl8quy($this) {
  if (!_AGStencilOpFunc___get_enabled__impl__hxq8wy($this))
    return 'AGStencilOpFunc(enabled=false)';
  return 'AGStencilOpFunc(enabled=' + _AGStencilOpFunc___get_enabled__impl__hxq8wy($this) + ', front=[compareMode=' + AGCompareMode__toString_impl_gs33a9(_AGStencilOpFunc___get_compareModeFront__impl__uctsey($this)) + ', actions=[' + AGStencilOp__toString_impl_1dm6fq(_AGStencilOpFunc___get_actionOnBothPassFront__impl__aehsgx($this)) + ', ' + AGStencilOp__toString_impl_1dm6fq(_AGStencilOpFunc___get_actionOnDepthFailFront__impl__vuqmyq($this)) + ', ' + AGStencilOp__toString_impl_1dm6fq(_AGStencilOpFunc___get_actionOnDepthPassStencilFailFront__impl__kl5ndh($this)) + ']], back=[compareMode=' + AGCompareMode__toString_impl_gs33a9(_AGStencilOpFunc___get_compareModeBack__impl__2rklx0($this)) + ', actions=[' + AGStencilOp__toString_impl_1dm6fq(_AGStencilOpFunc___get_actionOnBothPassBack__impl__i5t9l9($this)) + ', ' + AGStencilOp__toString_impl_1dm6fq(_AGStencilOpFunc___get_actionOnDepthFailBack__impl__3tna28($this)) + ', ' + AGStencilOp__toString_impl_1dm6fq(_AGStencilOpFunc___get_actionOnDepthPassStencilFailBack__impl__4qprmh($this)) + ']])';
}
function AGStencilOpFunc__hashCode_impl_nopebb($this) {
  return $this;
}
function AGStencilOpFunc__equals_impl_y44i4z($this, other) {
  if (!(other instanceof AGStencilOpFunc))
    return false;
  if (!($this === (other instanceof AGStencilOpFunc ? other.p6v_1 : THROW_CCE())))
    return false;
  return true;
}
function _AGColorMask___init__impl__j38ai8(data) {
  return data;
}
function _AGColorMask___get_data__impl__swj1bz($this) {
  return $this;
}
function _AGColorMask___get_red__impl__opo1fo($this) {
  // Inline function 'korlibs.memory.extractBool' call
  // Inline function 'korlibs.memory.extract1' call
  return !(((_AGColorMask___get_data__impl__swj1bz($this) >>> 0 | 0) & 1) === 0);
}
function _AGColorMask___get_green__impl__d3m1w2($this) {
  // Inline function 'korlibs.memory.extractBool' call
  // Inline function 'korlibs.memory.extract1' call
  return !(((_AGColorMask___get_data__impl__swj1bz($this) >>> 1 | 0) & 1) === 0);
}
function _AGColorMask___get_blue__impl__42l0s1($this) {
  // Inline function 'korlibs.memory.extractBool' call
  // Inline function 'korlibs.memory.extract1' call
  return !(((_AGColorMask___get_data__impl__swj1bz($this) >>> 2 | 0) & 1) === 0);
}
function _AGColorMask___get_alpha__impl__xmrqzb($this) {
  // Inline function 'korlibs.memory.extractBool' call
  // Inline function 'korlibs.memory.extract1' call
  return !(((_AGColorMask___get_data__impl__swj1bz($this) >>> 3 | 0) & 1) === 0);
}
function _AGColorMask___init__impl__j38ai8_0(red, green, blue, alpha) {
  return _AGColorMask___init__impl__j38ai8(insert(insert(insert(insert(0, red, 0), green, 1), blue, 2), alpha, 3));
}
function _AGColorMask___init__impl__j38ai8_1(value) {
  value = value === VOID ? true : value;
  return _AGColorMask___init__impl__j38ai8_0(value, value, value, value);
}
function AGColorMask__toString_impl_5i5oqg($this) {
  // Inline function 'kotlin.text.buildString' call
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'kotlin.apply' call
  var this_0 = StringBuilder.f();
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'korlibs.graphics.AGColorMask.toString.<anonymous>' call
  this_0.tb('AGColorMask(');
  this_0.tb(_AGColorMask___get_red__impl__opo1fo($this) ? 'R' : 'r');
  this_0.tb(_AGColorMask___get_green__impl__d3m1w2($this) ? 'G' : 'g');
  this_0.tb(_AGColorMask___get_blue__impl__42l0s1($this) ? 'B' : 'b');
  this_0.tb(_AGColorMask___get_alpha__impl__xmrqzb($this) ? 'A' : 'a');
  this_0.tb(')');
  return this_0.toString();
}
var Companion_instance_41;
function Companion_getInstance_48() {
  if (Companion_instance_41 === VOID)
    new Companion_32();
  return Companion_instance_41;
}
function AGColorMask__hashCode_impl_g9082f($this) {
  return $this;
}
function AGColorMask__equals_impl_mrih8l($this, other) {
  if (!(other instanceof AGColorMask))
    return false;
  if (!($this === (other instanceof AGColorMask ? other.t6v_1 : THROW_CCE())))
    return false;
  return true;
}
function _AGDepthAndFrontFace___init__impl__ra8x65(data) {
  return data;
}
function _AGDepthAndFrontFace___get_data__impl__v8zkce($this) {
  return $this;
}
var Companion_instance_42;
function Companion_getInstance_49() {
  if (Companion_instance_42 === VOID)
    new Companion_33();
  return Companion_instance_42;
}
function _AGDepthAndFrontFace___get_depthNear__impl__cir3a1($this) {
  return extractScaledf01(_AGDepthAndFrontFace___get_data__impl__v8zkce($this), 0, 12);
}
function _AGDepthAndFrontFace___get_depthFar__impl__g0cno8($this) {
  return extractScaledf01(_AGDepthAndFrontFace___get_data__impl__v8zkce($this), 12, 12);
}
function _AGDepthAndFrontFace___get_depthMask__impl__ouijn($this) {
  // Inline function 'korlibs.memory.extractBool' call
  // Inline function 'korlibs.memory.extract1' call
  return !(((_AGDepthAndFrontFace___get_data__impl__v8zkce($this) >>> 24 | 0) & 1) === 0);
}
function _AGDepthAndFrontFace___get_depthFunc__impl__8fo7zp($this) {
  // Inline function 'korlibs.memory.extract3' call
  var tmp$ret$0 = (_AGDepthAndFrontFace___get_data__impl__v8zkce($this) >>> 26 | 0) & 7;
  return _AGCompareMode___init__impl__j8kqbb(tmp$ret$0);
}
function _AGDepthAndFrontFace___get_frontFace__impl__w07k4s($this) {
  // Inline function 'korlibs.memory.extract2' call
  var tmp$ret$0 = (_AGDepthAndFrontFace___get_data__impl__v8zkce($this) >>> 30 | 0) & 3;
  return _AGFrontFace___init__impl__vsm7rb(tmp$ret$0);
}
function AGDepthAndFrontFace__withDepth_impl_wsx82k($this, near, far) {
  return _AGDepthAndFrontFace___init__impl__ra8x65(insertScaledf01(insertScaledf01(_AGDepthAndFrontFace___get_data__impl__v8zkce($this), near, 0, 12), far, 12, 12));
}
function AGDepthAndFrontFace__withDepthMask_impl_610nhs($this, depthMask) {
  return _AGDepthAndFrontFace___init__impl__ra8x65(insert(_AGDepthAndFrontFace___get_data__impl__v8zkce($this), depthMask, 24));
}
function AGDepthAndFrontFace__withDepthFunc_impl_7t7yrs($this, depthFunc) {
  return _AGDepthAndFrontFace___init__impl__ra8x65(insert3(_AGDepthAndFrontFace___get_data__impl__v8zkce($this), _AGCompareMode___get_ordinal__impl__ikvlmz(depthFunc), 26));
}
function AGDepthAndFrontFace__withFrontFace_impl_mwk87t($this, frontFace) {
  return _AGDepthAndFrontFace___init__impl__ra8x65(insert2(_AGDepthAndFrontFace___get_data__impl__v8zkce($this), _AGFrontFace___get_ordinal__impl__d4iagj(frontFace), 30));
}
function AGDepthAndFrontFace__toString_impl_c305m3($this) {
  return 'AGDepthAndFrontFace(data=' + $this + ')';
}
function AGDepthAndFrontFace__hashCode_impl_xu62ey($this) {
  return $this;
}
function _AGCullFace___init__impl__ckmjdg(ordinal) {
  return ordinal;
}
function _AGCullFace___get_ordinal__impl__jd1wps($this) {
  return $this;
}
var Companion_instance_43;
function Companion_getInstance_50() {
  if (Companion_instance_43 === VOID)
    new Companion_34();
  return Companion_instance_43;
}
function AGCullFace__toString_impl_7d891w($this) {
  return $this === Companion_getInstance_50().v6k_1 ? 'NONE' : $this === Companion_getInstance_50().y6k_1 ? 'BOTH' : $this === Companion_getInstance_50().w6k_1 ? 'FRONT' : $this === Companion_getInstance_50().x6k_1 ? 'BACK' : '-';
}
function AGCullFace__hashCode_impl_t4e5ur($this) {
  return $this;
}
function AGCullFace__equals_impl_wgngjr($this, other) {
  if (!(other instanceof AGCullFace))
    return false;
  if (!($this === (other instanceof AGCullFace ? other.x6v_1 : THROW_CCE())))
    return false;
  return true;
}
function _AGTextureTargetKind___init__impl__4zdmch(ordinal) {
  return ordinal;
}
function _AGTextureTargetKind___get_ordinal__impl__gjzc5p($this) {
  return $this;
}
function AGTextureTargetKind__toString_impl_68648p($this) {
  return $this === Companion_getInstance_51().x6o_1 ? 'TEXTURE_2D' : $this === Companion_getInstance_51().y6o_1 ? 'TEXTURE_3D' : $this === Companion_getInstance_51().z6o_1 ? 'TEXTURE_CUBE_MAP' : $this === Companion_getInstance_51().a6p_1 ? 'EXTERNAL_TEXTURE' : 'AGTextureTargetKind(' + _AGTextureTargetKind___get_ordinal__impl__gjzc5p($this) + ')';
}
function _AGTextureTargetKind___get_dims__impl__k3cmhd($this) {
  return $this === Companion_getInstance_51().x6o_1 ? 2 : $this === Companion_getInstance_51().y6o_1 ? 3 : $this === Companion_getInstance_51().z6o_1 ? 3 : $this === Companion_getInstance_51().a6p_1 ? 3 : 0;
}
var Companion_instance_44;
function Companion_getInstance_51() {
  if (Companion_instance_44 === VOID)
    new Companion_35();
  return Companion_instance_44;
}
function AGTextureTargetKind__hashCode_impl_rzc11k($this) {
  return $this;
}
function AGTextureTargetKind__equals_impl_q2tams($this, other) {
  if (!(other instanceof AGTextureTargetKind))
    return false;
  if (!($this === (other instanceof AGTextureTargetKind ? other.c6p_1 : THROW_CCE())))
    return false;
  return true;
}
function _AGWrapMode___init__impl__x5wmya(ordinal) {
  return ordinal;
}
function _AGWrapMode___get_ordinal__impl__rc38w2($this) {
  return $this;
}
var Companion_instance_45;
function Companion_getInstance_52() {
  if (Companion_instance_45 === VOID)
    new Companion_36();
  return Companion_instance_45;
}
function AGWrapMode__toString_impl_8bjnw2($this) {
  return $this === Companion_getInstance_52().w6p_1 ? 'CLAMP_TO_EDGE' : $this === Companion_getInstance_52().x6p_1 ? 'REPEAT' : $this === Companion_getInstance_52().y6p_1 ? 'MIRRORED_REPEAT' : '<' + _AGWrapMode___get_ordinal__impl__rc38w2($this) + '>';
}
function AGWrapMode__hashCode_impl_u2pkox($this) {
  return $this;
}
function AGWrapMode__equals_impl_4aw0kl($this, other) {
  if (!(other instanceof AGWrapMode))
    return false;
  if (!($this === (other instanceof AGWrapMode ? other.t6w_1 : THROW_CCE())))
    return false;
  return true;
}
function _AGBlendFactor___init__impl__iqtmxr(ordinal) {
  return ordinal;
}
function _AGBlendFactor___get_ordinal__impl__r9efzn($this) {
  return $this;
}
var Companion_instance_46;
function Companion_getInstance_53() {
  if (Companion_instance_46 === VOID)
    new Companion_37();
  return Companion_instance_46;
}
function AGBlendFactor__toString_impl_1hr6m1($this) {
  return $this === Companion_getInstance_53().g6t_1 ? 'DESTINATION_ALPHA' : $this === Companion_getInstance_53().h6t_1 ? 'DESTINATION_COLOR' : $this === Companion_getInstance_53().i6t_1 ? 'ONE' : $this === Companion_getInstance_53().j6t_1 ? 'ONE_MINUS_DESTINATION_ALPHA' : $this === Companion_getInstance_53().k6t_1 ? 'ONE_MINUS_DESTINATION_COLOR' : $this === Companion_getInstance_53().l6t_1 ? 'ONE_MINUS_SOURCE_ALPHA' : $this === Companion_getInstance_53().m6t_1 ? 'ONE_MINUS_SOURCE_COLOR' : $this === Companion_getInstance_53().n6t_1 ? 'SOURCE_ALPHA' : $this === Companion_getInstance_53().o6t_1 ? 'SOURCE_COLOR' : $this === Companion_getInstance_53().p6t_1 ? 'ZERO' : '-';
}
function _AGBlendFactor___get_op__impl__b5pfnd($this) {
  var tmp;
  if ($this === Companion_getInstance_53().g6t_1) {
    tmp = 'dstA';
  } else if ($this === Companion_getInstance_53().h6t_1) {
    tmp = 'dstRGB';
  } else if ($this === Companion_getInstance_53().i6t_1) {
    tmp = '1';
  } else if ($this === Companion_getInstance_53().j6t_1) {
    tmp = '(1 - dstA)';
  } else if ($this === Companion_getInstance_53().k6t_1) {
    tmp = '(1 - dstRGB)';
  } else if ($this === Companion_getInstance_53().l6t_1) {
    tmp = '(1 - srcA)';
  } else if ($this === Companion_getInstance_53().m6t_1) {
    tmp = '(1 - srcRGB)';
  } else if ($this === Companion_getInstance_53().n6t_1) {
    tmp = 'srcA';
  } else if ($this === Companion_getInstance_53().o6t_1) {
    tmp = 'srcRGB';
  } else if ($this === Companion_getInstance_53().p6t_1) {
    tmp = '0';
  } else {
    get_unreachable();
  }
  return tmp;
}
function AGBlendFactor__hashCode_impl_n8x3ew($this) {
  return $this;
}
function AGBlendFactor__equals_impl_dlauac($this, other) {
  if (!(other instanceof AGBlendFactor))
    return false;
  if (!($this === (other instanceof AGBlendFactor ? other.u6w_1 : THROW_CCE())))
    return false;
  return true;
}
function _AGBlendEquation___init__impl__fpv7c2(ordinal) {
  return ordinal;
}
function _AGBlendEquation___get_ordinal__impl__895p3q($this) {
  return $this;
}
var Companion_instance_47;
function Companion_getInstance_54() {
  if (Companion_instance_47 === VOID)
    new Companion_38();
  return Companion_instance_47;
}
function AGBlendEquation__toString_impl_5t2sx6($this) {
  return $this === Companion_getInstance_54().t6t_1 ? 'ADD' : $this === Companion_getInstance_54().u6t_1 ? 'SUBTRACT' : $this === Companion_getInstance_54().v6t_1 ? 'REVERSE_SUBTRACT' : '-';
}
function _AGBlendEquation___get_op__impl__7f9os6($this) {
  var tmp;
  if ($this === Companion_getInstance_54().t6t_1) {
    tmp = '+';
  } else if ($this === Companion_getInstance_54().u6t_1) {
    tmp = '-';
  } else if ($this === Companion_getInstance_54().v6t_1) {
    tmp = 'r-';
  } else {
    get_unreachable();
  }
  return tmp;
}
function AGBlendEquation__hashCode_impl_fy33vp($this) {
  return $this;
}
function AGBlendEquation__equals_impl_yykk3b($this, other) {
  if (!(other instanceof AGBlendEquation))
    return false;
  if (!($this === (other instanceof AGBlendEquation ? other.v6w_1 : THROW_CCE())))
    return false;
  return true;
}
function _AGSize___init__impl__h9blcq(data) {
  return data;
}
function AGSize__with_impl_qn6qww($this, width, height) {
  return _AGSize___init__impl__h9blcq(insert_0(insert_0(0, width, 0, 16), height, 16, 16));
}
var Companion_instance_48;
function Companion_getInstance_55() {
  return Companion_instance_48;
}
function _AGStencilOp___init__impl__llpkv6(ordinal) {
  return ordinal;
}
function _AGStencilOp___get_ordinal__impl__xkavfu($this) {
  return $this;
}
var Companion_instance_49;
function Companion_getInstance_56() {
  if (Companion_instance_49 === VOID)
    new Companion_40();
  return Companion_instance_49;
}
function AGStencilOp__toString_impl_1dm6fq($this) {
  return $this === Companion_getInstance_56().h6v_1 ? 'DECREMENT_SATURATE' : $this === Companion_getInstance_56().i6v_1 ? 'DECREMENT_WRAP' : $this === Companion_getInstance_56().j6v_1 ? 'INCREMENT_SATURATE' : $this === Companion_getInstance_56().k6v_1 ? 'INCREMENT_WRAP' : $this === Companion_getInstance_56().l6v_1 ? 'INVERT' : $this === Companion_getInstance_56().m6v_1 ? 'KEEP' : $this === Companion_getInstance_56().n6v_1 ? 'SET' : $this === Companion_getInstance_56().o6v_1 ? 'ZERO' : '-';
}
function AGStencilOp__hashCode_impl_n4s38l($this) {
  return $this;
}
function AGStencilOp__equals_impl_rq4p55($this, other) {
  if (!(other instanceof AGStencilOp))
    return false;
  if (!($this === (other instanceof AGStencilOp ? other.x6w_1 : THROW_CCE())))
    return false;
  return true;
}
function _AGCompareMode___init__impl__j8kqbb(ordinal) {
  return ordinal;
}
function _AGCompareMode___get_ordinal__impl__ikvlmz($this) {
  return $this;
}
var Companion_instance_50;
function Companion_getInstance_57() {
  if (Companion_instance_50 === VOID)
    new Companion_41();
  return Companion_instance_50;
}
function AGCompareMode__toString_impl_gs33a9($this) {
  return $this === Companion_getInstance_57().z6u_1 ? 'ALWAYS' : $this === Companion_getInstance_57().a6v_1 ? 'EQUAL' : $this === Companion_getInstance_57().b6v_1 ? 'GREATER' : $this === Companion_getInstance_57().c6v_1 ? 'GREATER_EQUAL' : $this === Companion_getInstance_57().d6v_1 ? 'LESS' : $this === Companion_getInstance_57().e6v_1 ? 'LESS_EQUAL' : $this === Companion_getInstance_57().f6v_1 ? 'NEVER' : $this === Companion_getInstance_57().g6v_1 ? 'NOT_EQUAL' : '-';
}
function AGCompareMode__inverted_impl_7xxk8m($this) {
  return $this === Companion_getInstance_57().z6u_1 ? Companion_getInstance_57().f6v_1 : $this === Companion_getInstance_57().a6v_1 ? Companion_getInstance_57().g6v_1 : $this === Companion_getInstance_57().b6v_1 ? Companion_getInstance_57().e6v_1 : $this === Companion_getInstance_57().c6v_1 ? Companion_getInstance_57().d6v_1 : $this === Companion_getInstance_57().d6v_1 ? Companion_getInstance_57().c6v_1 : $this === Companion_getInstance_57().e6v_1 ? Companion_getInstance_57().b6v_1 : $this === Companion_getInstance_57().f6v_1 ? Companion_getInstance_57().z6u_1 : $this === Companion_getInstance_57().g6v_1 ? Companion_getInstance_57().a6v_1 : Companion_getInstance_57().f6v_1;
}
function AGCompareMode__hashCode_impl_whv1w0($this) {
  return $this;
}
function AGCompareMode__equals_impl_rbniy4($this, other) {
  if (!(other instanceof AGCompareMode))
    return false;
  if (!($this === (other instanceof AGCompareMode ? other.y6w_1 : THROW_CCE())))
    return false;
  return true;
}
function _AGFrontFace___init__impl__vsm7rb(ordinal) {
  return ordinal;
}
function _AGFrontFace___get_ordinal__impl__d4iagj($this) {
  return $this;
}
var Companion_instance_51;
function Companion_getInstance_58() {
  if (Companion_instance_51 === VOID)
    new Companion_42();
  return Companion_instance_51;
}
function toAGScissor(_this__u8e3s4) {
  if (_this__u8e3s4 == null)
    return Companion_getInstance_44().t6k_1;
  return AGScissor.b6u(numberToInt(_this__u8e3s4.w25_1), numberToInt(_this__u8e3s4.x25_1), numberToInt(_this__u8e3s4.y25_1), numberToInt(_this__u8e3s4.z25_1));
}
function plus_5(_this__u8e3s4, scissor) {
  return BoundsBuilder__plus_impl_cz7f7x(BoundsBuilder__plus_impl_cz7f7x(_this__u8e3s4, Vector2D.j28(scissor.d26(), scissor.f26())), Vector2D.j28(scissor.e26(), scissor.g26()));
}
function applyMatrixBounds(_this__u8e3s4, m) {
  var x0 = m.c2a(_this__u8e3s4.d26(), _this__u8e3s4.f26());
  var x1 = m.c2a(_this__u8e3s4.e26(), _this__u8e3s4.f26());
  var x2 = m.c2a(_this__u8e3s4.d26(), _this__u8e3s4.g26());
  var x3 = m.c2a(_this__u8e3s4.e26(), _this__u8e3s4.g26());
  var y0 = m.d2a(_this__u8e3s4.d26(), _this__u8e3s4.f26());
  var y1 = m.d2a(_this__u8e3s4.e26(), _this__u8e3s4.f26());
  var y2 = m.d2a(_this__u8e3s4.d26(), _this__u8e3s4.g26());
  var y3 = m.d2a(_this__u8e3s4.e26(), _this__u8e3s4.g26());
  return Companion_getInstance_44().i2e(numberToInt(min(x0, x1, x2, x3)), numberToInt(min(y0, y1, y2, y3)), numberToInt(max_0(x0, x1, x2, x3)), numberToInt(max_0(y0, y1, y2, y3)));
}
var AGBufferKind_INDEX_instance;
var AGBufferKind_VERTEX_instance;
var AGBufferKind_UNIFORM_instance;
var AGBufferKind_entriesInitialized;
function AGBufferKind_initEntries() {
  if (AGBufferKind_entriesInitialized)
    return Unit_instance;
  AGBufferKind_entriesInitialized = true;
  AGBufferKind_INDEX_instance = new AGBufferKind('INDEX', 0);
  AGBufferKind_VERTEX_instance = new AGBufferKind('VERTEX', 1);
  AGBufferKind_UNIFORM_instance = new AGBufferKind('UNIFORM', 2);
}
function AGBufferKind_INDEX_getInstance() {
  AGBufferKind_initEntries();
  return AGBufferKind_INDEX_instance;
}
function AGBufferKind_VERTEX_getInstance() {
  AGBufferKind_initEntries();
  return AGBufferKind_VERTEX_instance;
}
function AGBufferKind_UNIFORM_getInstance() {
  AGBufferKind_initEntries();
  return AGBufferKind_UNIFORM_instance;
}
var ProjViewUB_instance;
function ProjViewUB_getInstance() {
  if (ProjViewUB_instance === VOID)
    new ProjViewUB();
  return ProjViewUB_instance;
}
var DefaultShaders_instance;
function DefaultShaders_getInstance() {
  if (DefaultShaders_instance === VOID)
    new DefaultShaders();
  return DefaultShaders_instance;
}
function u_Tex$factory() {
  return getPropertyCallableRef('u_Tex', 1, KProperty1, function (receiver) {
    return receiver.x70();
  }, null);
}
function u_TexEx$factory() {
  return getPropertyCallableRef('u_TexEx', 1, KProperty1, function (receiver) {
    return receiver.z70();
  }, null);
}
function u_Tex$factory_0() {
  return getPropertyCallableRef('u_Tex', 1, KProperty1, function (receiver) {
    return receiver.x70();
  }, null);
}
function u_TexEx$factory_0() {
  return getPropertyCallableRef('u_TexEx', 1, KProperty1, function (receiver) {
    return receiver.z70();
  }, null);
}
function u_ProjMat$factory() {
  return getPropertyCallableRef('u_ProjMat', 1, KProperty1, function (receiver) {
    return receiver.a6y();
  }, null);
}
function u_ViewMat$factory() {
  return getPropertyCallableRef('u_ViewMat', 1, KProperty1, function (receiver) {
    return receiver.b6y();
  }, null);
}
function u_ProjMat$factory_0() {
  return getPropertyCallableRef('u_ProjMat', 1, KProperty1, function (receiver) {
    return receiver.a6y();
  }, null);
}
function u_ViewMat$factory_0() {
  return getPropertyCallableRef('u_ViewMat', 1, KProperty1, function (receiver) {
    return receiver.b6y();
  }, null);
}
function get_ENABLE_UNIFORM_BLOCKS() {
  _init_properties_AGOpengl_kt__dtzqx7();
  return ENABLE_UNIFORM_BLOCKS;
}
var ENABLE_UNIFORM_BLOCKS;
function get_ENABLE_VERTEX_ARRAY_OBJECTS() {
  _init_properties_AGOpengl_kt__dtzqx7();
  return ENABLE_VERTEX_ARRAY_OBJECTS;
}
var ENABLE_VERTEX_ARRAY_OBJECTS;
function set_gl(_this__u8e3s4, _set____db54di) {
  _init_properties_AGOpengl_kt__dtzqx7();
  var this_0 = gl$delegate;
  var property = gl$factory();
  var value = this_0.gy_1(_this__u8e3s4, _set____db54di);
  var tmp0_elvis_lhs = this_0.ey_1;
  setExtra(_this__u8e3s4, tmp0_elvis_lhs == null ? property.callableName : tmp0_elvis_lhs, value);
  return Unit_instance;
}
function get_gl(_this__u8e3s4) {
  _init_properties_AGOpengl_kt__dtzqx7();
  var tmp$ret$0;
  $l$block: {
    // Inline function 'korlibs.datastructure.PropertyThis.getValue' call
    var this_0 = gl$delegate;
    var property = gl$factory_0();
    var tmp0_elvis_lhs = this_0.ey_1;
    var res = getExtraTyped(_this__u8e3s4, tmp0_elvis_lhs == null ? property.callableName : tmp0_elvis_lhs);
    if (res == null) {
      var r = this_0.fy_1(_this__u8e3s4);
      // Inline function 'korlibs.datastructure.PropertyThis.setValueUntransformed' call
      var tmp0_elvis_lhs_0 = this_0.ey_1;
      setExtra(_this__u8e3s4, tmp0_elvis_lhs_0 == null ? property.callableName : tmp0_elvis_lhs_0, r);
      tmp$ret$0 = r;
      break $l$block;
    }
    tmp$ret$0 = res;
  }
  return tmp$ret$0;
}
var gl$delegate;
function useProgram($this, program) {
  var gl = $this.v73_1;
  var map = $this.z73_1;
  if ($this.a74_1 == null) {
    $this.a74_1 = gl.f75(35724);
    // Inline function 'korlibs.logger.Logger.info' call
    var this_0 = Companion_getInstance_37().m6i_1;
    var level = Level_INFO_getInstance();
    var tmp;
    if (this_0.a2u(level)) {
      // Inline function 'korlibs.graphics.gl.AGOpengl.useProgram.<anonymous>' call
      var tmp$ret$0 = 'GL_VERSION=' + gl.f75(7938);
      this_0.b2u(level, tmp$ret$0);
      tmp = Unit_instance;
    }
    // Inline function 'korlibs.logger.Logger.info' call
    var this_1 = Companion_getInstance_37().m6i_1;
    var level_0 = Level_INFO_getInstance();
    var tmp_0;
    if (this_1.a2u(level_0)) {
      // Inline function 'korlibs.graphics.gl.AGOpengl.useProgram.<anonymous>' call
      var tmp$ret$2 = 'GL_SHADING_LANGUAGE_VERSION=' + $this.a74_1;
      this_1.b2u(level_0, tmp$ret$2);
      tmp_0 = Unit_instance;
    }
    // Inline function 'korlibs.logger.Logger.info' call
    var this_2 = Companion_getInstance_37().m6i_1;
    var level_1 = Level_INFO_getInstance();
    var tmp_1;
    if (this_2.a2u(level_1)) {
      // Inline function 'korlibs.graphics.gl.AGOpengl.useProgram.<anonymous>' call
      var tmp$ret$4 = 'GL_UNIFORM_BUFFER_OFFSET_ALIGNMENT=' + getInteger(gl, 35380);
      this_2.b2u(level_1, tmp$ret$4);
      tmp_1 = Unit_instance;
    }
    // Inline function 'korlibs.logger.Logger.info' call
    var this_3 = Companion_getInstance_37().m6i_1;
    var level_2 = Level_INFO_getInstance();
    var tmp_2;
    if (this_3.a2u(level_2)) {
      // Inline function 'korlibs.graphics.gl.AGOpengl.useProgram.<anonymous>' call
      var tmp$ret$6 = 'gl.versionString=' + get_versionString(gl);
      this_3.b2u(level_2, tmp$ret$6);
      tmp_2 = Unit_instance;
    }
    // Inline function 'korlibs.logger.Logger.info' call
    var this_4 = Companion_getInstance_37().m6i_1;
    var level_3 = Level_INFO_getInstance();
    var tmp_3;
    if (this_4.a2u(level_3)) {
      // Inline function 'korlibs.graphics.gl.AGOpengl.useProgram.<anonymous>' call
      var tmp$ret$8 = 'gl.versionInt=' + get_versionInt(gl);
      this_4.b2u(level_3, tmp$ret$8);
      tmp_3 = Unit_instance;
    }
  }
  // Inline function 'kotlin.collections.getOrPut' call
  var value = map.f3(program);
  var tmp_4;
  if (value == null) {
    // Inline function 'korlibs.graphics.gl.AGOpengl.useProgram.<anonymous>' call
    // Inline function 'kotlin.also' call
    var this_5 = new GLBaseProgram($this.y73_1, GLShaderCompiler_getInstance().i75(gl, $this.g75(), program, program.z6q_1));
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.graphics.gl.AGOpengl.useProgram.<anonymous>.<anonymous>' call
    this_5.m75();
    var programInfo = this_5.l75_1;
    var programId = programInfo.n75_1;
    // Inline function 'kotlin.collections.forEach' call
    var tmp0_iterator = program.d6r_1.a1();
    while (tmp0_iterator.b1()) {
      var element = tmp0_iterator.c1();
      // Inline function 'korlibs.graphics.gl.AGOpengl.useProgram.<anonymous>.<anonymous>.<anonymous>' call
      var location = programInfo.i76(gl, element.d76_1);
      gl.j76(location, element.n6n_1);
    }
    if (programInfo.r75_1.q76()) {
      // Inline function 'korlibs.datastructure.iterators.fastForEach' call
      var this_6 = program.c6r_1;
      var n = 0;
      while (n < this_6.e1()) {
        // Inline function 'korlibs.graphics.gl.AGOpengl.useProgram.<anonymous>.<anonymous>.<anonymous>' call
        var _unary__edvuaz = n;
        n = _unary__edvuaz + 1 | 0;
        var it = this_6.d1(_unary__edvuaz);
        var index = gl.k76(programId, it.s3());
        gl.l76(programId, index, it.x6r_1);
      }
    }
    var answer = this_5;
    map.i3(program, answer);
    tmp_4 = answer;
  } else {
    tmp_4 = value;
  }
  var nprogram = tmp_4;
  if (!equals($this.j74_1, nprogram)) {
    $this.j74_1 = nprogram;
    nprogram.m75();
  }
}
function resetObjects($this) {
  $this.c74_1 = null;
  $this.n74_1 = Companion_getInstance_44().s6k_1;
  $this.d74_1 = Companion_getInstance_43().v6j_1;
  $this.e74_1 = Companion_getInstance_50().u6k_1;
  $this.f74_1 = Companion_getInstance_47().g6k_1;
  $this.g74_1 = Companion_getInstance_46().e6k_1;
  $this.h74_1 = Companion_getInstance_48().i6k_1;
  $this.i74_1 = Companion_getInstance_49().o6k_1;
  $this.k74_1.l3();
  $this.j74_1 = null;
  $this.y74_1 = -1;
  $this.w74_1 = 0;
  $this.x74_1 = Companion_instance_48.w6w();
  // Inline function 'korlibs.datastructure.iterators.fastForEach' call
  var this_0 = $this.t74_1;
  var n = 0;
  while (n < this_0.length) {
    // Inline function 'korlibs.graphics.gl.AGOpengl.resetObjects.<anonymous>' call
    var _unary__edvuaz = n;
    n = _unary__edvuaz + 1 | 0;
    this_0[_unary__edvuaz].t2q();
  }
}
function deletePendingObjects($this) {
  while (true) {
    // Inline function 'korlibs.datastructure.iterators.fastForEach' call
    // Inline function 'korlibs.concurrent.lock.Lock.invoke' call
    var this_0 = $this.y73_1.f77_1;
    var tmp$ret$3;
    $l$block: {
      // Inline function 'korlibs.concurrent.lock.LockImpl.lockUnlock' call
      this_0.n1v();
      try {
        // Inline function 'korlibs.graphics.gl.AGOpengl.deletePendingObjects.<anonymous>' call
        var tmp;
        // Inline function 'kotlin.collections.isNotEmpty' call
        if (!$this.y73_1.g77_1.g1()) {
          // Inline function 'kotlin.also' call
          var this_1 = toList($this.y73_1.g77_1);
          // Inline function 'kotlin.contracts.contract' call
          // Inline function 'korlibs.graphics.gl.AGOpengl.deletePendingObjects.<anonymous>.<anonymous>' call
          $this.y73_1.g77_1.l3();
          tmp = this_1;
        } else {
          return Unit_instance;
        }
        tmp$ret$3 = tmp;
        break $l$block;
      }finally {
        this_0.p1v();
      }
    }
    var n = 0;
    while (n < tmp$ret$3.e1()) {
      // Inline function 'korlibs.graphics.gl.AGOpengl.deletePendingObjects.<anonymous>' call
      var _unary__edvuaz = n;
      n = _unary__edvuaz + 1 | 0;
      tmp$ret$3.d1(_unary__edvuaz).j77();
    }
  }
}
function bindBuffer($this, buffer, target, onlyUpdate, reallocated, updated) {
  var gl = $this.v73_1;
  if (reallocated == null)
    null;
  else {
    reallocated.j2r(false);
  }
  if (updated == null)
    null;
  else {
    updated.j2r(false);
  }
  if (buffer == null) {
    gl.k77(toGl_6(target), 0);
    return null;
  }
  var bufferInfo = _get_gl__ndc1ty(buffer, $this);
  if (!onlyUpdate) {
    gl.k77(toGl_6(target), bufferInfo.n77_1);
  }
  $this.q77(buffer, AGOpengl$bindBuffer$lambda(buffer, bufferInfo, onlyUpdate, gl, target, reallocated, updated));
  return bufferInfo;
}
function bindBuffer$default($this, buffer, target, onlyUpdate, reallocated, updated, $super) {
  onlyUpdate = onlyUpdate === VOID ? false : onlyUpdate;
  reallocated = reallocated === VOID ? null : reallocated;
  updated = updated === VOID ? null : updated;
  return bindBuffer($this, buffer, target, onlyUpdate, reallocated, updated);
}
function writeUniform($this, uniform, programInfo, data, source) {
  var gl = $this.v73_1;
  var location = programInfo.i76(gl, uniform.d76_1);
  var uniformType = uniform.w29();
  var arrayCount = uniform.t77_1;
  if (uniformType.a78_1.r3_1 === 6) {
    switch (uniformType.r3_1) {
      case 1:
        gl.i78(location, arrayCount, false, data);
        break;
      case 2:
        var inductionVariable = 0;
        if (inductionVariable < 3)
          do {
            var n = inductionVariable;
            inductionVariable = inductionVariable + 1 | 0;
            arraycopy_0(data, imul(n, 16), $this.s74_1, imul(n, 12), 12);
          }
           while (inductionVariable < 3);
        gl.j78(location, arrayCount, false, $this.s74_1);
        break;
      case 3:
        gl.k78(location, arrayCount, false, data);
        break;
      default:
        switch (uniformType.b78_1) {
          case 1:
            gl.l78(location, arrayCount, data);
            break;
          case 2:
            gl.m78(location, arrayCount, data);
            break;
          case 3:
            gl.n78(location, arrayCount, data);
            break;
          case 4:
            gl.o78(location, arrayCount, data);
            break;
        }

        break;
    }
  } else {
    switch (uniformType.b78_1) {
      case 1:
        gl.e78(location, arrayCount, data);
        break;
      case 2:
        gl.f78(location, arrayCount, data);
        break;
      case 3:
        gl.g78(location, arrayCount, data);
        break;
      case 4:
        gl.h78(location, arrayCount, data);
        break;
    }
  }
}
function textureUnitParameters($this, implForcedTexTarget, wrap, minFilter, magFilter, dims) {
  var gl = $this.v73_1;
  var params = $this.t74_1[$this.w74_1];
  var glTarget = toGl_8(implForcedTexTarget);
  params.s76_1 = wrap;
  var glWrap = toGl_9(wrap);
  gl.p78(glTarget, 10242, glWrap);
  gl.p78(glTarget, 10243, glWrap);
  if (dims >= 3) {
    gl.p78(glTarget, 32882, glWrap);
  }
  params.t76_1 = minFilter;
  params.u76_1 = magFilter;
  gl.p78(glTarget, 10241, minFilter);
  gl.p78(glTarget, 10240, magFilter);
}
function createBufferForBitmap($this, bmp) {
  var tmp;
  if (bmp == null) {
    tmp = null;
  } else {
    if (bmp instanceof NativeImage) {
      unsupported('Should not call createBufferForBitmap with a NativeImage');
    } else {
      if (bmp instanceof Bitmap8) {
        // Inline function 'kotlin.also' call
        var this_0 = Buffer.m12(bmp.v2f());
        // Inline function 'kotlin.contracts.contract' call
        // Inline function 'korlibs.graphics.gl.AGOpengl.createBufferForBitmap.<anonymous>' call
        arraycopy_3(bmp.j49(), 0, get_i8(this_0), 0, bmp.v2f());
        tmp = this_0;
      } else {
        if (bmp instanceof FloatBitmap32) {
          // Inline function 'kotlin.also' call
          var this_1 = Buffer.m12(imul(imul(bmp.v2f(), 4), 4));
          // Inline function 'kotlin.contracts.contract' call
          // Inline function 'korlibs.graphics.gl.AGOpengl.createBufferForBitmap.<anonymous>' call
          arraycopy_2(bmp.q4c_1, 0, get_f32(this_1), 0, imul(bmp.v2f(), 4));
          tmp = this_1;
        } else {
          // Inline function 'kotlin.also' call
          var this_2 = Buffer.m12(imul(bmp.v2f(), 4));
          // Inline function 'kotlin.contracts.contract' call
          // Inline function 'korlibs.graphics.gl.AGOpengl.createBufferForBitmap.<anonymous>' call
          var abmp = bmp.d40_1 ? bmp.u47().y4a() : bmp.u47().z4a();
          arraycopy_1(abmp.n3z_1, 0, get_i32(this_2), 0, abmp.v2f());
          tmp = this_2;
        }
      }
    }
  }
  return tmp;
}
function selectTextureUnit($this, index) {
  var old = $this.w74_1;
  if (!($this.w74_1 === index)) {
    $this.w74_1 = index;
    if (index >= 0) {
      $this.v73_1.q78(33984 + index | 0);
    }
  }
  return old;
}
function _get_gl__ndc1ty(_this__u8e3s4, $this) {
  return gl(_this__u8e3s4, $this.y73_1);
}
function _get_gl__ndc1ty_0(_this__u8e3s4, $this) {
  return gl_0(_this__u8e3s4, $this.y73_1);
}
function _get_gl__ndc1ty_1(_this__u8e3s4, $this) {
  return gl_1(_this__u8e3s4, $this.y73_1);
}
function AGOpengl$glslConfig$delegate$lambda(this$0) {
  return function () {
    return new GlslConfig(this$0.v73_1.r78(), this$0.v73_1);
  };
}
function AGOpengl$bindBuffer$lambda($buffer, $bufferInfo, $onlyUpdate, $gl, $target, $reallocated, $updated) {
  return function (it) {
    var tmp0_elvis_lhs = $buffer.g6m_1;
    var mem = tmp0_elvis_lhs == null ? Buffer.m12(0) : tmp0_elvis_lhs;
    $bufferInfo.s78(mem.r12());
    var tmp;
    if ($onlyUpdate) {
      $gl.k77(toGl_6($target), $bufferInfo.n77_1);
      tmp = Unit_instance;
    }
    var tmp_0;
    if ($bufferInfo.o77_1 < mem.r12()) {
      $bufferInfo.o77_1 = mem.r12();
      $gl.u78(toGl_6($target), mem.r12(), mem, 35048);
      var tmp1_safe_receiver = $reallocated;
      if (tmp1_safe_receiver == null)
        null;
      else {
        tmp1_safe_receiver.j2r(true);
      }
      tmp_0 = Unit_instance;
    } else {
      $gl.t78(toGl_6($target), 0, mem.r12(), mem);
      tmp_0 = Unit_instance;
    }
    var tmp2_safe_receiver = $updated;
    if (tmp2_safe_receiver == null)
      null;
    else {
      tmp2_safe_receiver.j2r(true);
    }
    return Unit_instance;
  };
}
function AGOpengl$textureBind$lambda($tex, $target, $gl, this$0, $glTex) {
  return function (it) {
    var rbmp = $tex.q6o_1;
    var tmp0_safe_receiver = (rbmp == null ? true : rbmp instanceof MultiBitmap) ? rbmp : null;
    var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.r6p_1;
    var bmps = tmp1_elvis_lhs == null ? listOf(rbmp) : tmp1_elvis_lhs;
    var requestMipmaps = $tex.n6o_1;
    $tex.r6o_1 = $tex.t6p(rbmp, requestMipmaps);
    var totalSize = 0.0;
    var iterator = bmps.a1();
    var index = 0;
    while (iterator.b1()) {
      var index_0 = index;
      index = index + 1 | 0;
      var bmp = iterator.c1();
      var isFloat = bmp instanceof FloatBitmap32;
      var tmp;
      if (bmp instanceof Bitmap8) {
        tmp = 6409;
      } else {
        tmp = 6408;
      }
      var type = tmp;
      var texTarget = $target === Companion_getInstance_51().z6o_1 ? 34069 + index_0 | 0 : toGl_8($target);
      var internalFormat = isFloat && (_GLVariant___get_isWebGL__impl__bbd1dd($gl.r78()) && _GLVariant___get_version__impl__9nyfwa($gl.r78()) >= 2) ? 34836 : type;
      var format = type;
      var texType = isFloat ? 5126 : 5121;
      if (_GLVariant___get_os__impl__aswhdw($gl.r78()).au()) {
        $gl.v78(3313, 0);
        $gl.v78(3312, 1);
      }
      if (bmp == null) {
        $gl.w78(toGl_8($target), 0, type, $tex.z2i(), $tex.a2j(), 0, type, 5121, null);
      } else {
        if (bmp instanceof NativeImage) {
          if (!(bmp.v2f() === 0)) {
            $gl.x78(texTarget, 0, type, type, 5121, bmp);
          }
        } else {
          if (bmp instanceof NullBitmap) {
            $gl.w78(texTarget, 0, internalFormat, bmp.x3z_1, bmp.y3z_1, 0, format, texType, null);
          } else {
            var buffer = createBufferForBitmap(this$0, bmp);
            if (!(buffer == null) && !(bmp.x3z_1 === 0) && !(bmp.y3z_1 === 0) && !(get_size_0(buffer) === 0)) {
              $gl.w78(texTarget, 0, internalFormat, bmp.x3z_1, bmp.y3z_1, 0, format, texType, buffer);
            }
          }
        }
      }
      totalSize = totalSize + imul(imul($tex.z2i(), $tex.a2j()), 4);
      if (_GLVariant___get_supportTextureLevel__impl__3yeu62($gl.r78())) {
        var tmp_0;
        if ($tex.r6o_1) {
          var tmp4_elvis_lhs = $tex.o6o_1;
          tmp_0 = tmp4_elvis_lhs == null ? 0 : tmp4_elvis_lhs;
        } else {
          tmp_0 = 0;
        }
        $gl.p78(3553, 33084, tmp_0);
        var tmp_1;
        if ($tex.r6o_1) {
          var tmp5_elvis_lhs = $tex.p6o_1;
          tmp_1 = tmp5_elvis_lhs == null ? 1000 : tmp5_elvis_lhs;
        } else {
          tmp_1 = 0;
        }
        $gl.p78(3553, 33085, tmp_1);
      }
      if ($tex.r6o_1) {
        $gl.y78(texTarget);
      }
    }
    $glTex.s78(totalSize);
    return Unit_instance;
  };
}
function gl$delegate$lambda($this$PropertyThis) {
  _init_properties_AGOpengl_kt__dtzqx7();
  return new GLVAO($this$PropertyThis);
}
function gl$factory() {
  return getPropertyCallableRef('gl', 1, KMutableProperty1, function (receiver) {
    return get_gl(receiver);
  }, function (receiver, value) {
    return set_gl(receiver, value);
  });
}
function gl$factory_0() {
  return getPropertyCallableRef('gl', 1, KMutableProperty1, function (receiver) {
    return get_gl(receiver);
  }, function (receiver, value) {
    return set_gl(receiver, value);
  });
}
function glslConfig$factory() {
  return getPropertyCallableRef('glslConfig', 1, KProperty1, function (receiver) {
    return receiver.g75();
  }, null);
}
var properties_initialized_AGOpengl_kt_5em8g9;
function _init_properties_AGOpengl_kt__dtzqx7() {
  if (!properties_initialized_AGOpengl_kt_5em8g9) {
    properties_initialized_AGOpengl_kt_5em8g9 = true;
    ENABLE_UNIFORM_BLOCKS = !(Companion_instance_1.bi('DISABLE_UNIFORM_BLOCKS') === 'true');
    ENABLE_VERTEX_ARRAY_OBJECTS = !(Companion_instance_1.bi('DISABLE_VERTEX_ARRAY_OBJECTS') === 'true');
    gl$delegate = new PropertyThis(VOID, gl$delegate$lambda);
  }
}
function fromGl(_this__u8e3s4, value) {
  var tmp;
  switch (value) {
    case 3553:
      tmp = Companion_getInstance_51().x6o_1;
      break;
    case 32879:
      tmp = Companion_getInstance_51().y6o_1;
      break;
    case 34067:
      tmp = Companion_getInstance_51().z6o_1;
      break;
    case 36197:
      tmp = Companion_getInstance_51().a6p_1;
      break;
    case 34069:
      tmp = Companion_getInstance_51().z6o_1;
      break;
    case 34070:
      tmp = Companion_getInstance_51().z6o_1;
      break;
    case 34071:
      tmp = Companion_getInstance_51().z6o_1;
      break;
    case 34072:
      tmp = Companion_getInstance_51().z6o_1;
      break;
    case 34073:
      tmp = Companion_getInstance_51().z6o_1;
      break;
    case 34074:
      tmp = Companion_getInstance_51().z6o_1;
      break;
    default:
      var reason = 'Unknown TextureTargetKind: ' + value;
      throw NotImplementedError.td('An operation is not implemented: ' + reason);
  }
  return tmp;
}
function toGl(_this__u8e3s4) {
  var tmp;
  if (_this__u8e3s4 === Companion_getInstance_54().t6t_1) {
    tmp = 32774;
  } else if (_this__u8e3s4 === Companion_getInstance_54().u6t_1) {
    tmp = 32778;
  } else if (_this__u8e3s4 === Companion_getInstance_54().v6t_1) {
    tmp = 32779;
  } else {
    get_unreachable();
  }
  return tmp;
}
function toGl_0(_this__u8e3s4) {
  var tmp;
  if (_this__u8e3s4 === Companion_getInstance_53().g6t_1) {
    tmp = 772;
  } else if (_this__u8e3s4 === Companion_getInstance_53().h6t_1) {
    tmp = 774;
  } else if (_this__u8e3s4 === Companion_getInstance_53().i6t_1) {
    tmp = 1;
  } else if (_this__u8e3s4 === Companion_getInstance_53().j6t_1) {
    tmp = 773;
  } else if (_this__u8e3s4 === Companion_getInstance_53().k6t_1) {
    tmp = 775;
  } else if (_this__u8e3s4 === Companion_getInstance_53().l6t_1) {
    tmp = 771;
  } else if (_this__u8e3s4 === Companion_getInstance_53().m6t_1) {
    tmp = 769;
  } else if (_this__u8e3s4 === Companion_getInstance_53().n6t_1) {
    tmp = 770;
  } else if (_this__u8e3s4 === Companion_getInstance_53().o6t_1) {
    tmp = 768;
  } else if (_this__u8e3s4 === Companion_getInstance_53().p6t_1) {
    tmp = 0;
  } else {
    get_unreachable();
  }
  return tmp;
}
function toGl_1(_this__u8e3s4) {
  var tmp;
  if (_this__u8e3s4 === Companion_getInstance_57().z6u_1) {
    tmp = 519;
  } else if (_this__u8e3s4 === Companion_getInstance_57().a6v_1) {
    tmp = 514;
  } else if (_this__u8e3s4 === Companion_getInstance_57().b6v_1) {
    tmp = 516;
  } else if (_this__u8e3s4 === Companion_getInstance_57().c6v_1) {
    tmp = 518;
  } else if (_this__u8e3s4 === Companion_getInstance_57().d6v_1) {
    tmp = 513;
  } else if (_this__u8e3s4 === Companion_getInstance_57().e6v_1) {
    tmp = 515;
  } else if (_this__u8e3s4 === Companion_getInstance_57().f6v_1) {
    tmp = 512;
  } else if (_this__u8e3s4 === Companion_getInstance_57().g6v_1) {
    tmp = 517;
  } else {
    get_unreachable();
  }
  return tmp;
}
function toGl_2(_this__u8e3s4) {
  return _this__u8e3s4 === Companion_getInstance_56().h6v_1 ? 7683 : _this__u8e3s4 === Companion_getInstance_56().i6v_1 ? 34056 : _this__u8e3s4 === Companion_getInstance_56().j6v_1 ? 7682 : _this__u8e3s4 === Companion_getInstance_56().k6v_1 ? 34055 : _this__u8e3s4 === Companion_getInstance_56().l6v_1 ? 5386 : _this__u8e3s4 === Companion_getInstance_56().m6v_1 ? 7680 : _this__u8e3s4 === Companion_getInstance_56().n6v_1 ? 7681 : _this__u8e3s4 === Companion_getInstance_56().o6v_1 ? 0 : 0;
}
function toGl_3(_this__u8e3s4) {
  var tmp;
  if (_this__u8e3s4 === Companion_getInstance_41().u6s_1) {
    tmp = 0;
  } else if (_this__u8e3s4 === Companion_getInstance_41().v6s_1) {
    tmp = 3;
  } else if (_this__u8e3s4 === Companion_getInstance_41().w6s_1) {
    tmp = 2;
  } else if (_this__u8e3s4 === Companion_getInstance_41().x6s_1) {
    tmp = 1;
  } else if (_this__u8e3s4 === Companion_getInstance_41().z6s_1) {
    tmp = 5;
  } else if (_this__u8e3s4 === Companion_getInstance_41().a6t_1) {
    tmp = 6;
  } else if (_this__u8e3s4 === Companion_getInstance_41().y6s_1) {
    tmp = 4;
  } else {
    get_unreachable();
  }
  return tmp;
}
function toGl_4(_this__u8e3s4) {
  var tmp;
  if (_this__u8e3s4 === Companion_getInstance_42().r6j_1) {
    tmp = 0;
  } else if (_this__u8e3s4 === Companion_getInstance_42().s6j_1) {
    tmp = 5121;
  } else if (_this__u8e3s4 === Companion_getInstance_42().t6j_1) {
    tmp = 5123;
  } else if (_this__u8e3s4 === Companion_getInstance_42().u6j_1) {
    tmp = 5125;
  } else {
    get_unreachable();
  }
  return tmp;
}
function toGl_5(_this__u8e3s4) {
  var tmp;
  if (_this__u8e3s4 === Companion_getInstance_50().y6k_1) {
    tmp = 1032;
  } else if (_this__u8e3s4 === Companion_getInstance_50().w6k_1) {
    tmp = 1028;
  } else if (_this__u8e3s4 === Companion_getInstance_50().x6k_1) {
    tmp = 1029;
  } else {
    var reason = 'Invalid AGCullFace(' + AGCullFace__toString_impl_7d891w(_this__u8e3s4) + ')';
    throw NotImplementedError.td('An operation is not implemented: ' + reason);
  }
  return tmp;
}
function toGl_6(_this__u8e3s4) {
  var tmp;
  switch (_this__u8e3s4.r3_1) {
    case 0:
      tmp = 34963;
      break;
    case 1:
      tmp = 34962;
      break;
    case 2:
      tmp = 35345;
      break;
    default:
      noWhenBranchMatchedException();
      break;
  }
  return tmp;
}
function toGl_7(_this__u8e3s4) {
  var tmp;
  switch (_this__u8e3s4.a78_1.r3_1) {
    case 0:
      tmp = 35670;
      break;
    case 1:
      tmp = 5120;
      break;
    case 2:
      tmp = 5121;
      break;
    case 3:
      tmp = 5122;
      break;
    case 4:
      tmp = 5123;
      break;
    case 5:
      tmp = 5125;
      break;
    case 6:
      tmp = 5126;
      break;
    default:
      noWhenBranchMatchedException();
      break;
  }
  return tmp;
}
function toGl_8(_this__u8e3s4) {
  return _this__u8e3s4 === Companion_getInstance_51().x6o_1 ? 3553 : _this__u8e3s4 === Companion_getInstance_51().y6o_1 ? 32879 : _this__u8e3s4 === Companion_getInstance_51().z6o_1 ? 34067 : _this__u8e3s4 === Companion_getInstance_51().a6p_1 ? 36197 : _AGTextureTargetKind___get_ordinal__impl__gjzc5p(_this__u8e3s4);
}
function toGl_9(_this__u8e3s4) {
  return _this__u8e3s4 === Companion_getInstance_52().w6p_1 ? 33071 : _this__u8e3s4 === Companion_getInstance_52().x6p_1 ? 10497 : _this__u8e3s4 === Companion_getInstance_52().y6p_1 ? 33648 : 33071;
}
function toGl_10(_this__u8e3s4) {
  var tmp;
  if (_this__u8e3s4 === Companion_getInstance_58().u6v_1) {
    tmp = 2305;
  } else if (_this__u8e3s4 === Companion_getInstance_58().w6v_1) {
    tmp = 2304;
  } else if (_this__u8e3s4 === Companion_getInstance_58().v6v_1) {
    tmp = 2305;
  } else {
    get_unreachable();
  }
  return tmp;
}
function gl(_this__u8e3s4, state) {
  return createOnce(_this__u8e3s4, state, gl$lambda(state));
}
function gl_0(_this__u8e3s4, state) {
  return createOnce(_this__u8e3s4, state, gl$lambda_0(state, _this__u8e3s4));
}
function gl_1(_this__u8e3s4, state) {
  return createOnce(_this__u8e3s4, state, gl$lambda_1(state));
}
function createOnce(_this__u8e3s4, state, block) {
  if (_this__u8e3s4.h6m_1 == null || !(_this__u8e3s4.i6m_1 === state.y76_1.q6i_1)) {
    _this__u8e3s4.i6m_1 = state.y76_1.q6i_1;
    _this__u8e3s4.r6m();
    _this__u8e3s4.h6m_1 = block(_this__u8e3s4);
  }
  var tmp = _this__u8e3s4.h6m_1;
  return (!(tmp == null) ? isInterface(tmp, AGNativeObject) : false) ? tmp : THROW_CCE();
}
function gl$lambda($state) {
  return function (it) {
    return new GLBuffer($state);
  };
}
function gl$lambda_0($state, $this_gl) {
  return function (it) {
    return new GLFrameBuffer($state, $this_gl);
  };
}
function gl$lambda_1($state) {
  return function (it) {
    return new GLTexture($state);
  };
}
function get_versionString(_this__u8e3s4) {
  _init_properties_GLShaderCompiler_kt__3td561();
  var tmp$ret$0;
  $l$block: {
    // Inline function 'korlibs.datastructure.PropertyThis.getValue' call
    var this_0 = versionString$delegate;
    var property = versionString$factory();
    var tmp0_elvis_lhs = this_0.ey_1;
    var res = getExtraTyped(_this__u8e3s4, tmp0_elvis_lhs == null ? property.callableName : tmp0_elvis_lhs);
    if (res == null) {
      var r = this_0.fy_1(_this__u8e3s4);
      // Inline function 'korlibs.datastructure.PropertyThis.setValueUntransformed' call
      var tmp0_elvis_lhs_0 = this_0.ey_1;
      setExtra(_this__u8e3s4, tmp0_elvis_lhs_0 == null ? property.callableName : tmp0_elvis_lhs_0, r);
      tmp$ret$0 = r;
      break $l$block;
    }
    tmp$ret$0 = res;
  }
  return tmp$ret$0;
}
var versionString$delegate;
function get_versionInt(_this__u8e3s4) {
  _init_properties_GLShaderCompiler_kt__3td561();
  var tmp$ret$0;
  $l$block: {
    // Inline function 'korlibs.datastructure.PropertyThis.getValue' call
    var this_0 = versionInt$delegate;
    var property = versionInt$factory();
    var tmp0_elvis_lhs = this_0.ey_1;
    var res = getExtraTyped(_this__u8e3s4, tmp0_elvis_lhs == null ? property.callableName : tmp0_elvis_lhs);
    if (res == null) {
      var r = this_0.fy_1(_this__u8e3s4);
      // Inline function 'korlibs.datastructure.PropertyThis.setValueUntransformed' call
      var tmp0_elvis_lhs_0 = this_0.ey_1;
      setExtra(_this__u8e3s4, tmp0_elvis_lhs_0 == null ? property.callableName : tmp0_elvis_lhs_0, r);
      tmp$ret$0 = r;
      break $l$block;
    }
    tmp$ret$0 = res;
  }
  return tmp$ret$0;
}
var versionInt$delegate;
function createShader($this, gl, type, str, debugName) {
  var shaderId = gl.k7c(type);
  gl.l7c(shaderId, str);
  gl.m7c(shaderId);
  // Inline function 'korlibs.kgl.KmlGl.COMPILE_STATUS' call
  var out = getShaderiv(gl, shaderId, 35713);
  var errorInt = gl.n7c();
  // Inline function 'korlibs.kgl.KmlGl.GTRUE' call
  if (!(out === 1)) {
    var error = getShaderInfoLog(gl, shaderId);
    throw ShaderException.q73(str, error, errorInt, gl, debugName, type, out);
  }
  return shaderId;
}
var GLShaderCompiler_instance;
function GLShaderCompiler_getInstance() {
  if (GLShaderCompiler_instance === VOID)
    new GLShaderCompiler();
  return GLShaderCompiler_instance;
}
function versionString$delegate$lambda($this$PropertyThis) {
  _init_properties_GLShaderCompiler_kt__3td561();
  var tmp;
  if (_GLVariant___get_isWebGL__impl__bbd1dd($this$PropertyThis.r78())) {
    tmp = _GLVariant___get_version__impl__9nyfwa($this$PropertyThis.r78()) === 1 ? '1.00' : '3.00';
  } else {
    // Inline function 'korlibs.kgl.KmlGl.SHADING_LANGUAGE_VERSION' call
    tmp = $this$PropertyThis.f75(35724);
  }
  return tmp;
}
function versionInt$delegate$lambda($this$PropertyThis) {
  _init_properties_GLShaderCompiler_kt__3td561();
  var tmp0_safe_receiver = Regex.oh('(\\d+\\.\\d+)').qh(get_versionString($this$PropertyThis));
  var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.u1();
  var tmp2_safe_receiver = tmp1_safe_receiver == null ? null : replace(tmp1_safe_receiver, '.', '');
  var tmp;
  if (tmp2_safe_receiver == null) {
    tmp = null;
  } else {
    // Inline function 'kotlin.text.trim' call
    tmp = toString(trim(isCharSequence(tmp2_safe_receiver) ? tmp2_safe_receiver : THROW_CCE()));
  }
  var tmp3_safe_receiver = tmp;
  var tmp4_elvis_lhs = tmp3_safe_receiver == null ? null : toIntOrNull(tmp3_safe_receiver);
  return tmp4_elvis_lhs == null ? 100 : tmp4_elvis_lhs;
}
function versionString$factory() {
  return getPropertyCallableRef('versionString', 1, KProperty1, function (receiver) {
    return get_versionString(receiver);
  }, null);
}
function versionInt$factory() {
  return getPropertyCallableRef('versionInt', 1, KProperty1, function (receiver) {
    return get_versionInt(receiver);
  }, null);
}
var properties_initialized_GLShaderCompiler_kt_k11ei3;
function _init_properties_GLShaderCompiler_kt__3td561() {
  if (!properties_initialized_GLShaderCompiler_kt_k11ei3) {
    properties_initialized_GLShaderCompiler_kt_k11ei3 = true;
    versionString$delegate = new PropertyThis(VOID, versionString$delegate$lambda);
    versionInt$delegate = new PropertyThis(VOID, versionInt$delegate$lambda);
  }
}
var Kind_COMMAND_instance;
var Kind_DRAW_instance;
var Kind_DRAW_DETAILS_instance;
var Kind_CLEAR_instance;
var Kind_METRICS_instance;
var Kind_FLIP_instance;
var Kind_READ_instance;
var Kind_REPAINT_instance;
var Kind_DISPOSE_instance;
var Kind_TEXTURE_UPLOAD_instance;
var Kind_CLOSE_instance;
var Kind_FRAME_BUFFER_instance;
var Kind_BUFFER_instance;
var Kind_TEXTURE_instance;
var Kind_SHADER_instance;
var Kind_OTHER_instance;
var Kind_UNIFORM_instance;
var Kind_UNIFORM_VALUES_instance;
var Kind_SCISSORS_instance;
var Kind_VIEWPORT_instance;
var Kind_VERTEX_instance;
var Kind_ENABLE_DISABLE_instance;
var Kind_CONTEXT_LOST_instance;
var Kind_FLUSH_instance;
var Kind_entriesInitialized_0;
function Kind_initEntries_0() {
  if (Kind_entriesInitialized_0)
    return Unit_instance;
  Kind_entriesInitialized_0 = true;
  Kind_COMMAND_instance = new Kind_0('COMMAND', 0);
  Kind_DRAW_instance = new Kind_0('DRAW', 1);
  Kind_DRAW_DETAILS_instance = new Kind_0('DRAW_DETAILS', 2);
  Kind_CLEAR_instance = new Kind_0('CLEAR', 3);
  Kind_METRICS_instance = new Kind_0('METRICS', 4);
  Kind_FLIP_instance = new Kind_0('FLIP', 5);
  Kind_READ_instance = new Kind_0('READ', 6);
  Kind_REPAINT_instance = new Kind_0('REPAINT', 7);
  Kind_DISPOSE_instance = new Kind_0('DISPOSE', 8);
  Kind_TEXTURE_UPLOAD_instance = new Kind_0('TEXTURE_UPLOAD', 9);
  Kind_CLOSE_instance = new Kind_0('CLOSE', 10);
  Kind_FRAME_BUFFER_instance = new Kind_0('FRAME_BUFFER', 11);
  Kind_BUFFER_instance = new Kind_0('BUFFER', 12);
  Kind_TEXTURE_instance = new Kind_0('TEXTURE', 13);
  Kind_SHADER_instance = new Kind_0('SHADER', 14);
  Kind_OTHER_instance = new Kind_0('OTHER', 15);
  Kind_UNIFORM_instance = new Kind_0('UNIFORM', 16);
  Kind_UNIFORM_VALUES_instance = new Kind_0('UNIFORM_VALUES', 17);
  Kind_SCISSORS_instance = new Kind_0('SCISSORS', 18);
  Kind_VIEWPORT_instance = new Kind_0('VIEWPORT', 19);
  Kind_VERTEX_instance = new Kind_0('VERTEX', 20);
  Kind_ENABLE_DISABLE_instance = new Kind_0('ENABLE_DISABLE', 21);
  Kind_CONTEXT_LOST_instance = new Kind_0('CONTEXT_LOST', 22);
  Kind_FLUSH_instance = new Kind_0('FLUSH', 23);
}
function Kind_COMMAND_getInstance() {
  Kind_initEntries_0();
  return Kind_COMMAND_instance;
}
function Kind_FLIP_getInstance() {
  Kind_initEntries_0();
  return Kind_FLIP_instance;
}
var Companion_instance_52;
function Companion_getInstance_59() {
  if (Companion_instance_52 === VOID)
    new Companion_43();
  return Companion_instance_52;
}
function UniformBlock$Gen$uniform$delegate$lambda(this$0) {
  return function () {
    // Inline function 'kotlin.also' call
    var tmp0_elvis_lhs = this$0.r6x_1;
    var this_0 = TypedUniform.x7d(tmp0_elvis_lhs == null ? 'unknown' + this$0.q6x_1.f6y() : tmp0_elvis_lhs, this$0.s6x_1, this$0.t6x_1, this$0.q6x_1, this$0.u6x_1, this$0.v6x_1);
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.graphics.shader.Gen.uniform$delegate.<anonymous>.<anonymous>' call
    this$0.q6x_1.z6r_1.h(this_0);
    return this_0;
  };
}
var Companion_instance_53;
function Companion_getInstance_60() {
  return Companion_instance_53;
}
function _get_bufferSize__mp12kq($this) {
  return $this.i6q_1.r12() / $this.g6q_1 | 0;
}
function align($this, size) {
  var tmp = $this;
  // Inline function 'kotlin.math.max' call
  var a = $this.a7e_1;
  tmp.a7e_1 = Math.max(a, size);
  while (!(($this.z7d_1 % size | 0) === 0)) {
    $this.z7d_1 = $this.z7d_1 + 1 | 0;
  }
  return $this;
}
function UBLayoutBuilder$size$delegate$lambda(this$0) {
  return function () {
    align(this$0, this$0.a7e_1);
    return this$0.z7d_1;
  };
}
function uniform$factory() {
  return getPropertyCallableRef('uniform', 1, KProperty1, function (receiver) {
    return receiver.y7d();
  }, null);
}
function size$factory() {
  return getPropertyCallableRef('size', 1, KProperty1, function (receiver) {
    return receiver.e1();
  }, null);
}
function _GLVariant___init__impl__cjzpjb(data) {
  return data;
}
function _GLVariant___get_data__impl__nn46ye($this) {
  return $this;
}
function _GLVariant___get_isES__impl__yezzg8($this) {
  // Inline function 'korlibs.memory.extractBool' call
  // Inline function 'korlibs.memory.extract1' call
  return !(((_GLVariant___get_data__impl__nn46ye($this) >>> 0 | 0) & 1) === 0);
}
function _GLVariant___get_isWebGL__impl__bbd1dd($this) {
  // Inline function 'korlibs.memory.extractBool' call
  // Inline function 'korlibs.memory.extract1' call
  return !(((_GLVariant___get_data__impl__nn46ye($this) >>> 1 | 0) & 1) === 0);
}
function _GLVariant___get_version__impl__9nyfwa($this) {
  // Inline function 'korlibs.memory.extract8' call
  return (_GLVariant___get_data__impl__nn46ye($this) >>> 8 | 0) & 255;
}
function _GLVariant___get_os__impl__aswhdw($this) {
  var tmp = Companion_getInstance_3().wt_1;
  // Inline function 'korlibs.memory.extract8' call
  var tmp$ret$0 = (_GLVariant___get_data__impl__nn46ye($this) >>> 16 | 0) & 255;
  var tmp0_elvis_lhs = getOrNull(tmp, tmp$ret$0);
  return tmp0_elvis_lhs == null ? Os_UNKNOWN_getInstance() : tmp0_elvis_lhs;
}
function _GLVariant___get_supportTextureLevel__impl__3yeu62($this) {
  return !_GLVariant___get_isWebGL__impl__bbd1dd($this) && !_GLVariant___get_isES__impl__yezzg8($this);
}
var Companion_instance_54;
function Companion_getInstance_61() {
  return Companion_instance_54;
}
function GLVariant__toString_impl_o5yi3l($this) {
  return 'GLVariant(data=' + $this + ')';
}
function GLVariant__hashCode_impl_2eslaq($this) {
  return $this;
}
function GLVariant__equals_impl_kmlw2($this, other) {
  if (!(other instanceof GLVariant))
    return false;
  if (!($this === (other instanceof GLVariant ? other.c7g_1 : THROW_CCE())))
    return false;
  return true;
}
function toNewGlslString(_this__u8e3s4, config) {
  return toNewGlslStringResult(_this__u8e3s4, config).g7g_1;
}
function toNewGlslStringResult(_this__u8e3s4, config) {
  return (new GlslGenerator(_this__u8e3s4.k7g_1, config)).y7g(_this__u8e3s4);
}
var Companion_instance_55;
function Companion_getInstance_62() {
  if (Companion_instance_55 === VOID)
    new Companion_46();
  return Companion_instance_55;
}
function GlslGenerator$generateResult$lambda$lambda(a, b) {
  // Inline function 'kotlin.comparisons.compareValuesBy' call
  // Inline function 'korlibs.graphics.shader.gl.GlslGenerator.generateResult.<anonymous>.<anonymous>' call
  var tmp = a.d76_1;
  // Inline function 'korlibs.graphics.shader.gl.GlslGenerator.generateResult.<anonymous>.<anonymous>' call
  var tmp$ret$1 = b.d76_1;
  return compareValues(tmp, tmp$ret$1);
}
function GlslGenerator$generateResult$lambda(this$0, $types, $allFuncs) {
  return function ($this$Indenter) {
    var tmp;
    if (!this$0.x7g_1.p76_1) {
      var suffix = _GLVariant___get_isES__impl__yezzg8(this$0.x7g_1.m76_1) ? ' es' : '';
      $this$Indenter.w34('#version ' + this$0.x7g_1.o76_1 + suffix);
      tmp = Unit_instance;
    }
    var tmp_0;
    if (this$0.w7g_1.equals(ShaderType_FRAGMENT_getInstance())) {
      $this$Indenter.w34('#extension GL_OES_standard_derivatives : enable');
      tmp_0 = Unit_instance;
    }
    $this$Indenter.w34('#ifdef GL_ES');
    $this$Indenter.w34('precision mediump float;');
    $this$Indenter.w34('#endif');
    var _iterator__ex2g4s = $types.a7h_1.a1();
    while (_iterator__ex2g4s.b1()) {
      var it = _iterator__ex2g4s.c1();
      var layout = this$0.x7g_1.f7j() && this$0.x7g_1.o76_1 >= 410 ? 'layout(location = ' + it.g6z_1 + ') ' : '';
      $this$Indenter.w34(layout + this$0.g7j() + ' ' + this$0.h7j(it.e76_1) + this$0.i7j(it.w29()) + ' ' + it.d76_1 + this$0.j7j(it) + ';');
    }
    var _iterator__ex2g4s_0 = $types.f7h_1.a1();
    while (_iterator__ex2g4s_0.b1()) {
      var it_0 = _iterator__ex2g4s_0.c1();
      var layout_0 = this$0.x7g_1.f7j() ? '' : '';
      $this$Indenter.w34(layout_0 + this$0.k7j() + ' ' + this$0.h7j(it_0.e76_1) + this$0.i7j(it_0.w29()) + ' ' + it_0.d76_1 + this$0.j7j(it_0) + ';');
    }
    var tmp_1;
    if (this$0.x7g_1.q76()) {
      var _iterator__ex2g4s_1 = $types.e7h_1.a1();
      while (_iterator__ex2g4s_1.b1()) {
        var block = _iterator__ex2g4s_1.c1();
        $this$Indenter.w34('layout(std140) uniform ' + block.s3() + ' {');
        var _iterator__ex2g4s_2 = block.c6y().a1();
        while (_iterator__ex2g4s_2.b1()) {
          var uniform = _iterator__ex2g4s_2.c1();
          $this$Indenter.w34('  ' + this$0.h7j(uniform.e76_1) + this$0.i7j(uniform.w29()) + ' ' + uniform.d76_1 + this$0.j7j(uniform) + ';');
        }
        $this$Indenter.w34('};');
      }
      tmp_1 = Unit_instance;
    } else {
      var _iterator__ex2g4s_3 = $types.c7h_1.a1();
      while (_iterator__ex2g4s_3.b1()) {
        var it_1 = _iterator__ex2g4s_3.c1();
        $this$Indenter.w34(this$0.k7j() + ' ' + this$0.h7j(it_1.e76_1) + this$0.i7j(it_1.w29()) + ' ' + it_1.d76_1 + this$0.j7j(it_1) + ';');
      }
      tmp_1 = Unit_instance;
    }
    // Inline function 'kotlin.collections.sortedBy' call
    var this_0 = $types.b7h_1;
    // Inline function 'kotlin.comparisons.compareBy' call
    var tmp_2 = GlslGenerator$generateResult$lambda$lambda;
    var tmp$ret$0 = new sam$kotlin_Comparator$0(tmp_2);
    var iterator = sortedWith(this_0, tmp$ret$0).a1();
    var index = 0;
    $l$loop: while (iterator.b1()) {
      var index_0 = index;
      index = index + 1 | 0;
      var it_2 = iterator.c1();
      if (it_2 instanceof Output)
        continue $l$loop;
      var INOUT = !this$0.x7g_1.f7j() ? this$0.l7j() : it_2.d76_1 === this$0.x7g_1.m7j() && this$0.w7g_1.equals(ShaderType_FRAGMENT_getInstance()) ? this$0.l7j() : this$0.w7g_1.equals(ShaderType_VERTEX_getInstance()) ? this$0.l7j() : this$0.g7j();
      $this$Indenter.w34(INOUT + ' ' + this$0.h7j(it_2.e76_1) + this$0.i7j(it_2.w29()) + ' ' + it_2.d76_1 + ';');
    }
    var _iterator__ex2g4s_4 = $allFuncs.a1();
    while (_iterator__ex2g4s_4.b1()) {
      var func = _iterator__ex2g4s_4.c1();
      var gen = new GlslBodyGenerator(this$0.w7g_1, this$0.x7g_1);
      gen.y7h(func);
      // Inline function 'kotlin.collections.map' call
      var this_1 = func.p7j_1;
      // Inline function 'kotlin.collections.mapTo' call
      var destination = ArrayList.w(collectionSizeOrDefault(this_1, 10));
      var tmp0_iterator = this_1.a1();
      while (tmp0_iterator.b1()) {
        var item = tmp0_iterator.c1();
        // Inline function 'korlibs.graphics.shader.gl.GlslGenerator.generateResult.<anonymous>.<anonymous>' call
        var tmp$ret$2 = this$0.i7j(item.il_1) + ' ' + item.hl_1;
        destination.h(tmp$ret$2);
      }
      var argsStrings = destination;
      // Inline function 'korlibs.io.util.Indenter.line' call
      var str = this$0.i7j(func.o7j_1) + ' ' + func.n7j_1 + '(' + joinToString(argsStrings, ', ') + ')';
      var tmp_3;
      // Inline function 'kotlin.text.isEmpty' call
      if (charSequenceLength(str) === 0) {
        tmp_3 = '{';
      } else {
        tmp_3 = str + ' {';
      }
      $this$Indenter.w34(tmp_3);
      // Inline function 'korlibs.io.util.Indenter.indent' call
      $this$Indenter.x34();
      try {
        // Inline function 'korlibs.graphics.shader.gl.GlslGenerator.generateResult.<anonymous>.<anonymous>' call
        var _iterator__ex2g4s_5 = gen.v7j_1.a1();
        while (_iterator__ex2g4s_5.b1()) {
          var temp = _iterator__ex2g4s_5.c1();
          $this$Indenter.w34(this$0.h7j(temp.e76_1) + this$0.i7j(temp.w29()) + ' ' + temp.d76_1 + ';');
        }
        $this$Indenter.v34(gen.w7j_1);
      }finally {
        $this$Indenter.y34();
      }
      $this$Indenter.w34('}');
    }
    return Unit_instance;
  };
}
var Companion_instance_56;
function Companion_getInstance_63() {
  if (Companion_instance_56 === VOID)
    new Companion_47();
  return Companion_instance_56;
}
function errorType($this, type) {
  invalidOp("Don't know how to serialize type " + type.toString());
}
function GlslBodyGenerator$visit$lambda(this$0) {
  return function (it) {
    return this$0.j7i(it);
  };
}
function GlslBodyGenerator$visit$lambda_0(this$0) {
  return function (it) {
    return this$0.j7i(it);
  };
}
function ProgramLayout$names$lambda(it) {
  return it.d76_1;
}
var Discard_instance;
function Discard_getInstance() {
  if (Discard_instance === VOID)
    new Discard();
  return Discard_instance;
}
var Companion_instance_57;
function Companion_getInstance_64() {
  if (Companion_instance_57 === VOID)
    new Companion_48();
  return Companion_instance_57;
}
function Program$Builder$FuncProvider$provideDelegate$lambda(this$0) {
  return function ($this$FUNC) {
    // Inline function 'kotlin.collections.mapIndexed' call
    var this_0 = this$0.b7m_1;
    // Inline function 'kotlin.collections.mapIndexedTo' call
    var destination = ArrayList.w(collectionSizeOrDefault(this_0, 10));
    var index = 0;
    var tmp0_iterator = this_0.a1();
    while (tmp0_iterator.b1()) {
      var item = tmp0_iterator.c1();
      // Inline function 'korlibs.graphics.shader.FuncProvider.provideDelegate.<anonymous>.<anonymous>' call
      var tmp1 = index;
      index = tmp1 + 1 | 0;
      var index_0 = checkIndexOverflow(tmp1);
      var tmp$ret$0 = $this$FUNC.h7m('p' + index_0, item);
      destination.h(tmp$ret$0);
    }
    var args = destination;
    this$0.d7m_1($this$FUNC, args);
    return Unit_instance;
  };
}
function Program$Builder$FUNC$lambda($block) {
  return function ($this$FuncProvider, it) {
    $block($this$FuncProvider, it.d1(0));
    return Unit_instance;
  };
}
function Program$Builder$FUNC$lambda_0($block) {
  return function ($this$FuncProvider, it) {
    $block($this$FuncProvider, it.d1(0), it.d1(1));
    return Unit_instance;
  };
}
function Program$Builder$FUNC$lambda_1($block) {
  return function ($this$FuncProvider, it) {
    $block($this$FuncProvider, it.d1(0), it.d1(1), it.d1(2));
    return Unit_instance;
  };
}
function Program$Builder$IF_ELSE_BINARY_LOOKUP$lambda($block, $max) {
  return function ($this$ELSE) {
    $block($this$ELSE, $max);
    return Unit_instance;
  };
}
function Program$Builder$IF_ELSE_BINARY_LOOKUP$lambda_0($ref, $middle, $max, $block) {
  return function ($this$ELSE) {
    $this$ELSE.v71($ref, $middle + 1 | 0, $max, $block);
    return Unit_instance;
  };
}
function Program$Builder$IF_ELSE_LIST$lambda($ref, $min, $max, $block) {
  return function ($this$ELSE) {
    $this$ELSE.w71($ref, $min + 1 | 0, $max, $block);
    return Unit_instance;
  };
}
var Output_instance;
function Output_getInstance() {
  if (Output_instance === VOID)
    Output.w7o();
  return Output_instance;
}
function Sampler_0(index, stype) {
  return new Provider(index, stype);
}
var SamplerVarType_Sampler1D_instance;
var SamplerVarType_Sampler2D_instance;
var SamplerVarType_Sampler3D_instance;
var SamplerVarType_SamplerCube_instance;
var SamplerVarType_entriesInitialized;
function SamplerVarType_initEntries() {
  if (SamplerVarType_entriesInitialized)
    return Unit_instance;
  SamplerVarType_entriesInitialized = true;
  SamplerVarType_Sampler1D_instance = new SamplerVarType('Sampler1D', 0, VarType_Sampler1D_getInstance());
  SamplerVarType_Sampler2D_instance = new SamplerVarType('Sampler2D', 1, VarType_Sampler2D_getInstance());
  SamplerVarType_Sampler3D_instance = new SamplerVarType('Sampler3D', 2, VarType_Sampler3D_getInstance());
  SamplerVarType_SamplerCube_instance = new SamplerVarType('SamplerCube', 3, VarType_SamplerCube_getInstance());
}
var VarType_TVOID_instance;
var VarType_Mat2_instance;
var VarType_Mat3_instance;
var VarType_Mat4_instance;
var VarType_Sampler1D_instance;
var VarType_Sampler2D_instance;
var VarType_Sampler3D_instance;
var VarType_SamplerCube_instance;
var VarType_Int1_instance;
var VarType_Float1_instance;
var VarType_Float2_instance;
var VarType_Float3_instance;
var VarType_Float4_instance;
var VarType_Short1_instance;
var VarType_Short2_instance;
var VarType_Short3_instance;
var VarType_Short4_instance;
var VarType_Bool1_instance;
var VarType_Bool2_instance;
var VarType_Bool3_instance;
var VarType_Bool4_instance;
var VarType_Byte4_instance;
var VarType_SByte1_instance;
var VarType_SByte2_instance;
var VarType_SByte3_instance;
var VarType_SByte4_instance;
var VarType_UByte1_instance;
var VarType_UByte2_instance;
var VarType_UByte3_instance;
var VarType_UByte4_instance;
var VarType_SShort1_instance;
var VarType_SShort2_instance;
var VarType_SShort3_instance;
var VarType_SShort4_instance;
var VarType_UShort1_instance;
var VarType_UShort2_instance;
var VarType_UShort3_instance;
var VarType_UShort4_instance;
var VarType_SInt1_instance;
var VarType_SInt2_instance;
var VarType_SInt3_instance;
var VarType_SInt4_instance;
var Companion_instance_58;
function Companion_getInstance_65() {
  return Companion_instance_58;
}
var VarType_entriesInitialized;
function VarType_initEntries() {
  if (VarType_entriesInitialized)
    return Unit_instance;
  VarType_entriesInitialized = true;
  VarType_TVOID_instance = new VarType('TVOID', 0, VarKind_TBYTE_getInstance(), 0);
  VarType_Mat2_instance = new VarType('Mat2', 1, VarKind_TFLOAT_getInstance(), 4, true);
  VarType_Mat3_instance = new VarType('Mat3', 2, VarKind_TFLOAT_getInstance(), 9, true);
  VarType_Mat4_instance = new VarType('Mat4', 3, VarKind_TFLOAT_getInstance(), 16, true);
  VarType_Sampler1D_instance = new VarType('Sampler1D', 4, VarKind_TINT_getInstance(), 1);
  VarType_Sampler2D_instance = new VarType('Sampler2D', 5, VarKind_TINT_getInstance(), 1);
  VarType_Sampler3D_instance = new VarType('Sampler3D', 6, VarKind_TINT_getInstance(), 1);
  VarType_SamplerCube_instance = new VarType('SamplerCube', 7, VarKind_TINT_getInstance(), 1);
  VarType_Int1_instance = new VarType('Int1', 8, VarKind_TINT_getInstance(), 1);
  VarType_Float1_instance = new VarType('Float1', 9, VarKind_TFLOAT_getInstance(), 1);
  VarType_Float2_instance = new VarType('Float2', 10, VarKind_TFLOAT_getInstance(), 2);
  VarType_Float3_instance = new VarType('Float3', 11, VarKind_TFLOAT_getInstance(), 3);
  VarType_Float4_instance = new VarType('Float4', 12, VarKind_TFLOAT_getInstance(), 4);
  VarType_Short1_instance = new VarType('Short1', 13, VarKind_TSHORT_getInstance(), 1);
  VarType_Short2_instance = new VarType('Short2', 14, VarKind_TSHORT_getInstance(), 2);
  VarType_Short3_instance = new VarType('Short3', 15, VarKind_TSHORT_getInstance(), 3);
  VarType_Short4_instance = new VarType('Short4', 16, VarKind_TSHORT_getInstance(), 4);
  VarType_Bool1_instance = new VarType('Bool1', 17, VarKind_TBOOL_getInstance(), 1);
  VarType_Bool2_instance = new VarType('Bool2', 18, VarKind_TBOOL_getInstance(), 2);
  VarType_Bool3_instance = new VarType('Bool3', 19, VarKind_TBOOL_getInstance(), 3);
  VarType_Bool4_instance = new VarType('Bool4', 20, VarKind_TBOOL_getInstance(), 4);
  VarType_Byte4_instance = new VarType('Byte4', 21, VarKind_TUNSIGNED_BYTE_getInstance(), 4);
  VarType_SByte1_instance = new VarType('SByte1', 22, VarKind_TBYTE_getInstance(), 1);
  VarType_SByte2_instance = new VarType('SByte2', 23, VarKind_TBYTE_getInstance(), 2);
  VarType_SByte3_instance = new VarType('SByte3', 24, VarKind_TBYTE_getInstance(), 3);
  VarType_SByte4_instance = new VarType('SByte4', 25, VarKind_TBYTE_getInstance(), 4);
  VarType_UByte1_instance = new VarType('UByte1', 26, VarKind_TUNSIGNED_BYTE_getInstance(), 1);
  VarType_UByte2_instance = new VarType('UByte2', 27, VarKind_TUNSIGNED_BYTE_getInstance(), 2);
  VarType_UByte3_instance = new VarType('UByte3', 28, VarKind_TUNSIGNED_BYTE_getInstance(), 3);
  VarType_UByte4_instance = new VarType('UByte4', 29, VarKind_TUNSIGNED_BYTE_getInstance(), 4);
  VarType_SShort1_instance = new VarType('SShort1', 30, VarKind_TSHORT_getInstance(), 1);
  VarType_SShort2_instance = new VarType('SShort2', 31, VarKind_TSHORT_getInstance(), 2);
  VarType_SShort3_instance = new VarType('SShort3', 32, VarKind_TSHORT_getInstance(), 3);
  VarType_SShort4_instance = new VarType('SShort4', 33, VarKind_TSHORT_getInstance(), 4);
  VarType_UShort1_instance = new VarType('UShort1', 34, VarKind_TUNSIGNED_SHORT_getInstance(), 1);
  VarType_UShort2_instance = new VarType('UShort2', 35, VarKind_TUNSIGNED_SHORT_getInstance(), 2);
  VarType_UShort3_instance = new VarType('UShort3', 36, VarKind_TUNSIGNED_SHORT_getInstance(), 3);
  VarType_UShort4_instance = new VarType('UShort4', 37, VarKind_TUNSIGNED_SHORT_getInstance(), 4);
  VarType_SInt1_instance = new VarType('SInt1', 38, VarKind_TINT_getInstance(), 1);
  VarType_SInt2_instance = new VarType('SInt2', 39, VarKind_TINT_getInstance(), 2);
  VarType_SInt3_instance = new VarType('SInt3', 40, VarKind_TINT_getInstance(), 3);
  VarType_SInt4_instance = new VarType('SInt4', 41, VarKind_TINT_getInstance(), 4);
}
var Precision_DEFAULT_instance;
var Precision_LOW_instance;
var Precision_MEDIUM_instance;
var Precision_HIGH_instance;
var Precision_entriesInitialized;
function Precision_initEntries() {
  if (Precision_entriesInitialized)
    return Unit_instance;
  Precision_entriesInitialized = true;
  Precision_DEFAULT_instance = new Precision('DEFAULT', 0);
  Precision_LOW_instance = new Precision('LOW', 1);
  Precision_MEDIUM_instance = new Precision('MEDIUM', 2);
  Precision_HIGH_instance = new Precision('HIGH', 3);
}
function FragmentShader(info) {
  return FragmentShader_0(info.hl_1, info.il_1);
}
var VarKind_TBOOL_instance;
var VarKind_TBYTE_instance;
var VarKind_TUNSIGNED_BYTE_instance;
var VarKind_TSHORT_instance;
var VarKind_TUNSIGNED_SHORT_instance;
var VarKind_TINT_instance;
var VarKind_TFLOAT_instance;
var VarKind_entriesInitialized;
function VarKind_initEntries() {
  if (VarKind_entriesInitialized)
    return Unit_instance;
  VarKind_entriesInitialized = true;
  VarKind_TBOOL_instance = new VarKind('TBOOL', 0, 1);
  VarKind_TBYTE_instance = new VarKind('TBYTE', 1, 1);
  VarKind_TUNSIGNED_BYTE_instance = new VarKind('TUNSIGNED_BYTE', 2, 1);
  VarKind_TSHORT_instance = new VarKind('TSHORT', 3, 2);
  VarKind_TUNSIGNED_SHORT_instance = new VarKind('TUNSIGNED_SHORT', 4, 2);
  VarKind_TINT_instance = new VarKind('TINT', 5, 4);
  VarKind_TFLOAT_instance = new VarKind('TFLOAT', 6, 4);
}
var ShaderType_VERTEX_instance;
var ShaderType_FRAGMENT_instance;
var ShaderType_entriesInitialized;
function ShaderType_initEntries() {
  if (ShaderType_entriesInitialized)
    return Unit_instance;
  ShaderType_entriesInitialized = true;
  ShaderType_VERTEX_instance = new ShaderType('VERTEX', 0);
  ShaderType_FRAGMENT_instance = new ShaderType('FRAGMENT', 1);
}
function VertexShader(info) {
  return VertexShader_0(info.hl_1, info.il_1);
}
function FragmentShader_0(stm, funcs) {
  var tmp;
  if (funcs === VOID) {
    // Inline function 'kotlin.collections.listOf' call
    tmp = emptyList();
  } else {
    tmp = funcs;
  }
  funcs = tmp;
  return new Shader(ShaderType_FRAGMENT_getInstance(), stm, funcs);
}
function VertexShader_0(stm, funcs) {
  var tmp;
  if (funcs === VOID) {
    // Inline function 'kotlin.collections.listOf' call
    tmp = emptyList();
  } else {
    tmp = funcs;
  }
  funcs = tmp;
  return new Shader(ShaderType_VERTEX_getInstance(), stm, funcs);
}
function SamplerVarType_Sampler2D_getInstance() {
  SamplerVarType_initEntries();
  return SamplerVarType_Sampler2D_instance;
}
function VarType_TVOID_getInstance() {
  VarType_initEntries();
  return VarType_TVOID_instance;
}
function VarType_Mat2_getInstance() {
  VarType_initEntries();
  return VarType_Mat2_instance;
}
function VarType_Mat4_getInstance() {
  VarType_initEntries();
  return VarType_Mat4_instance;
}
function VarType_Sampler1D_getInstance() {
  VarType_initEntries();
  return VarType_Sampler1D_instance;
}
function VarType_Sampler2D_getInstance() {
  VarType_initEntries();
  return VarType_Sampler2D_instance;
}
function VarType_Sampler3D_getInstance() {
  VarType_initEntries();
  return VarType_Sampler3D_instance;
}
function VarType_SamplerCube_getInstance() {
  VarType_initEntries();
  return VarType_SamplerCube_instance;
}
function VarType_Float1_getInstance() {
  VarType_initEntries();
  return VarType_Float1_instance;
}
function VarType_Float2_getInstance() {
  VarType_initEntries();
  return VarType_Float2_instance;
}
function VarType_Float3_getInstance() {
  VarType_initEntries();
  return VarType_Float3_instance;
}
function VarType_Float4_getInstance() {
  VarType_initEntries();
  return VarType_Float4_instance;
}
function VarType_SByte1_getInstance() {
  VarType_initEntries();
  return VarType_SByte1_instance;
}
function VarType_SByte2_getInstance() {
  VarType_initEntries();
  return VarType_SByte2_instance;
}
function VarType_SByte3_getInstance() {
  VarType_initEntries();
  return VarType_SByte3_instance;
}
function VarType_SByte4_getInstance() {
  VarType_initEntries();
  return VarType_SByte4_instance;
}
function VarType_UByte1_getInstance() {
  VarType_initEntries();
  return VarType_UByte1_instance;
}
function VarType_UByte2_getInstance() {
  VarType_initEntries();
  return VarType_UByte2_instance;
}
function VarType_UByte3_getInstance() {
  VarType_initEntries();
  return VarType_UByte3_instance;
}
function VarType_UByte4_getInstance() {
  VarType_initEntries();
  return VarType_UByte4_instance;
}
function VarType_SShort1_getInstance() {
  VarType_initEntries();
  return VarType_SShort1_instance;
}
function VarType_SShort2_getInstance() {
  VarType_initEntries();
  return VarType_SShort2_instance;
}
function VarType_SShort3_getInstance() {
  VarType_initEntries();
  return VarType_SShort3_instance;
}
function VarType_SShort4_getInstance() {
  VarType_initEntries();
  return VarType_SShort4_instance;
}
function VarType_UShort1_getInstance() {
  VarType_initEntries();
  return VarType_UShort1_instance;
}
function VarType_UShort2_getInstance() {
  VarType_initEntries();
  return VarType_UShort2_instance;
}
function VarType_UShort3_getInstance() {
  VarType_initEntries();
  return VarType_UShort3_instance;
}
function VarType_UShort4_getInstance() {
  VarType_initEntries();
  return VarType_UShort4_instance;
}
function VarType_SInt1_getInstance() {
  VarType_initEntries();
  return VarType_SInt1_instance;
}
function VarType_SInt2_getInstance() {
  VarType_initEntries();
  return VarType_SInt2_instance;
}
function VarType_SInt3_getInstance() {
  VarType_initEntries();
  return VarType_SInt3_instance;
}
function VarType_SInt4_getInstance() {
  VarType_initEntries();
  return VarType_SInt4_instance;
}
function Precision_DEFAULT_getInstance() {
  Precision_initEntries();
  return Precision_DEFAULT_instance;
}
function Precision_LOW_getInstance() {
  Precision_initEntries();
  return Precision_LOW_instance;
}
function Precision_MEDIUM_getInstance() {
  Precision_initEntries();
  return Precision_MEDIUM_instance;
}
function Precision_HIGH_getInstance() {
  Precision_initEntries();
  return Precision_HIGH_instance;
}
function VarKind_TBOOL_getInstance() {
  VarKind_initEntries();
  return VarKind_TBOOL_instance;
}
function VarKind_TBYTE_getInstance() {
  VarKind_initEntries();
  return VarKind_TBYTE_instance;
}
function VarKind_TUNSIGNED_BYTE_getInstance() {
  VarKind_initEntries();
  return VarKind_TUNSIGNED_BYTE_instance;
}
function VarKind_TSHORT_getInstance() {
  VarKind_initEntries();
  return VarKind_TSHORT_instance;
}
function VarKind_TUNSIGNED_SHORT_getInstance() {
  VarKind_initEntries();
  return VarKind_TUNSIGNED_SHORT_instance;
}
function VarKind_TINT_getInstance() {
  VarKind_initEntries();
  return VarKind_TINT_instance;
}
function VarKind_TFLOAT_getInstance() {
  VarKind_initEntries();
  return VarKind_TFLOAT_instance;
}
function ShaderType_VERTEX_getInstance() {
  ShaderType_initEntries();
  return ShaderType_VERTEX_instance;
}
function ShaderType_FRAGMENT_getInstance() {
  ShaderType_initEntries();
  return ShaderType_FRAGMENT_instance;
}
function toDisposable(_this__u8e3s4) {
  var tmp = toDisposable$lambda(_this__u8e3s4);
  return new sam$kotlinx_coroutines_DisposableHandle$0(tmp);
}
function toDisposable$lambda($this_toDisposable) {
  return function () {
    $this_toDisposable.f6();
    return Unit_instance;
  };
}
function putAsciiString(_this__u8e3s4, str) {
  var n = 0;
  var inductionVariable = 0;
  var last = str.length;
  while (inductionVariable < last) {
    var c = charSequenceGet(str, inductionVariable);
    inductionVariable = inductionVariable + 1 | 0;
    if (get_size_0(_this__u8e3s4) >= n) {
      var _unary__edvuaz = n;
      n = _unary__edvuaz + 1 | 0;
      // Inline function 'kotlin.code' call
      var tmp$ret$0 = Char__toInt_impl_vasixd(c);
      _this__u8e3s4.c13(_unary__edvuaz, toByte(tmp$ret$0));
    }
  }
  if (get_size_0(_this__u8e3s4) >= n) {
    var _unary__edvuaz_0 = n;
    n = _unary__edvuaz_0 + 1 | 0;
    _this__u8e3s4.c13(_unary__edvuaz_0, 0);
  }
  return _this__u8e3s4;
}
function toAsciiString(_this__u8e3s4) {
  var out = '';
  var inductionVariable = 0;
  var last = get_size_0(_this__u8e3s4);
  if (inductionVariable < last)
    $l$loop: do {
      var n = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      var b = _this__u8e3s4.a13(n);
      if (b === 0)
        break $l$loop;
      out = out + toString_0(numberToChar(b));
    }
     while (inductionVariable < last);
  return out;
}
function KmlGl$ContextInfo$current$lambda() {
  return null;
}
var Companion_instance_59;
function Companion_getInstance_66() {
  return Companion_instance_59;
}
function KmlGl$isFloatTextureSupported$delegate$lambda(this$0) {
  return function () {
    return this$0.x81().z2('GL_OES_texture_float') || this$0.x81().z2('GL_ARB_texture_float');
  };
}
var logger;
var tempNBufferByte;
function get_tempNBuffer1() {
  _init_properties_KmlGlExt_kt__r5nfv2();
  return tempNBuffer1;
}
var tempNBuffer1;
var tempNBuffer4;
function getIntegerv(_this__u8e3s4, pname) {
  _init_properties_KmlGlExt_kt__r5nfv2();
  // Inline function 'korlibs.kgl.tempInt1Buffer' call
  // Inline function 'kotlin.let' call
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'korlibs.kgl.tempInt1Buffer.<anonymous>' call
  var it = _get_tempNBuffer1_$accessor$c1x7qs_ecvwzo();
  setInt32(it, 0, 0);
  // Inline function 'korlibs.kgl.getIntegerv.<anonymous>' call
  _this__u8e3s4.g82(pname, it);
  return getInt32(it, 0);
}
function getInteger(_this__u8e3s4, pname) {
  _init_properties_KmlGlExt_kt__r5nfv2();
  return getIntegerv(_this__u8e3s4, pname);
}
function genVertexArray(_this__u8e3s4) {
  _init_properties_KmlGlExt_kt__r5nfv2();
  // Inline function 'korlibs.kgl.tempInt1Buffer' call
  // Inline function 'kotlin.let' call
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'korlibs.kgl.tempInt1Buffer.<anonymous>' call
  var it = _get_tempNBuffer1_$accessor$c1x7qs_ecvwzo();
  setInt32(it, 0, 0);
  // Inline function 'korlibs.kgl.genVertexArray.<anonymous>' call
  _this__u8e3s4.k82(1, it);
  return getInt32(it, 0);
}
function getProgramiv(_this__u8e3s4, program, type) {
  _init_properties_KmlGlExt_kt__r5nfv2();
  // Inline function 'korlibs.kgl.tempInt1Buffer' call
  // Inline function 'kotlin.let' call
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'korlibs.kgl.tempInt1Buffer.<anonymous>' call
  var it = _get_tempNBuffer1_$accessor$c1x7qs_ecvwzo();
  setInt32(it, 0, 0);
  // Inline function 'korlibs.kgl.getProgramiv.<anonymous>' call
  _this__u8e3s4.h82(program, type, it);
  return getInt32(it, 0);
}
function getShaderiv(_this__u8e3s4, shader, type) {
  _init_properties_KmlGlExt_kt__r5nfv2();
  // Inline function 'korlibs.kgl.tempInt1Buffer' call
  // Inline function 'kotlin.let' call
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'korlibs.kgl.tempInt1Buffer.<anonymous>' call
  var it = _get_tempNBuffer1_$accessor$c1x7qs_ecvwzo();
  setInt32(it, 0, 0);
  // Inline function 'korlibs.kgl.getShaderiv.<anonymous>' call
  _this__u8e3s4.i82(shader, type, it);
  return getInt32(it, 0);
}
function getShaderInfoLog(_this__u8e3s4, shader) {
  _init_properties_KmlGlExt_kt__r5nfv2();
  // Inline function 'korlibs.kgl.getInfoLog' call
  // Inline function 'korlibs.kgl.KmlGl.INFO_LOG_LENGTH' call
  var size = getShaderiv(_this__u8e3s4, shader, 35716);
  // Inline function 'korlibs.memory.BufferTemp' call
  // Inline function 'kotlin.run' call
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'korlibs.kgl.getInfoLog.<anonymous>' call
  var sizev = allocDirect(Companion_instance_4, 4);
  // Inline function 'korlibs.memory.BufferTemp' call
  // Inline function 'kotlin.run' call
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'korlibs.kgl.getInfoLog.<anonymous>.<anonymous>' call
  var mbuffer = allocDirect(Companion_instance_4, size);
  _this__u8e3s4.j82(shader, size, sizev, mbuffer);
  return toAsciiString(mbuffer);
}
function genBuffer(_this__u8e3s4) {
  _init_properties_KmlGlExt_kt__r5nfv2();
  // Inline function 'korlibs.kgl.tempInt1Buffer' call
  // Inline function 'kotlin.let' call
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'korlibs.kgl.tempInt1Buffer.<anonymous>' call
  var it = _get_tempNBuffer1_$accessor$c1x7qs_ecvwzo();
  setInt32(it, 0, 0);
  // Inline function 'korlibs.kgl.genBuffer.<anonymous>' call
  _this__u8e3s4.c82(1, it);
  return getInt32(it, 0);
}
function deleteBuffer(_this__u8e3s4, id) {
  _init_properties_KmlGlExt_kt__r5nfv2();
  // Inline function 'korlibs.kgl.tempInt1Buffer' call
  // Inline function 'kotlin.let' call
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'korlibs.kgl.tempInt1Buffer.<anonymous>' call
  var it = _get_tempNBuffer1_$accessor$c1x7qs_ecvwzo();
  setInt32(it, 0, id);
  // Inline function 'korlibs.kgl.deleteBuffer.<anonymous>' call
  _this__u8e3s4.y81(1, it);
  getInt32(it, 0);
}
function genTexture(_this__u8e3s4) {
  _init_properties_KmlGlExt_kt__r5nfv2();
  // Inline function 'korlibs.kgl.tempInt1Buffer' call
  // Inline function 'kotlin.let' call
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'korlibs.kgl.tempInt1Buffer.<anonymous>' call
  var it = _get_tempNBuffer1_$accessor$c1x7qs_ecvwzo();
  setInt32(it, 0, 0);
  // Inline function 'korlibs.kgl.genTexture.<anonymous>' call
  _this__u8e3s4.f82(1, it);
  return getInt32(it, 0);
}
function deleteTexture(_this__u8e3s4, id) {
  _init_properties_KmlGlExt_kt__r5nfv2();
  // Inline function 'korlibs.kgl.tempInt1Buffer' call
  // Inline function 'kotlin.let' call
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'korlibs.kgl.tempInt1Buffer.<anonymous>' call
  var it = _get_tempNBuffer1_$accessor$c1x7qs_ecvwzo();
  setInt32(it, 0, id);
  // Inline function 'korlibs.kgl.deleteTexture.<anonymous>' call
  _this__u8e3s4.b82(1, it);
  getInt32(it, 0);
}
function genRenderbuffer(_this__u8e3s4) {
  _init_properties_KmlGlExt_kt__r5nfv2();
  // Inline function 'korlibs.kgl.tempInt1Buffer' call
  // Inline function 'kotlin.let' call
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'korlibs.kgl.tempInt1Buffer.<anonymous>' call
  var it = _get_tempNBuffer1_$accessor$c1x7qs_ecvwzo();
  setInt32(it, 0, 0);
  // Inline function 'korlibs.kgl.genRenderbuffer.<anonymous>' call
  _this__u8e3s4.e82(1, it);
  return getInt32(it, 0);
}
function genFramebuffer(_this__u8e3s4) {
  _init_properties_KmlGlExt_kt__r5nfv2();
  // Inline function 'korlibs.kgl.tempInt1Buffer' call
  // Inline function 'kotlin.let' call
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'korlibs.kgl.tempInt1Buffer.<anonymous>' call
  var it = _get_tempNBuffer1_$accessor$c1x7qs_ecvwzo();
  setInt32(it, 0, 0);
  // Inline function 'korlibs.kgl.genFramebuffer.<anonymous>' call
  _this__u8e3s4.d82(1, it);
  return getInt32(it, 0);
}
function deleteRenderbuffer(_this__u8e3s4, id) {
  _init_properties_KmlGlExt_kt__r5nfv2();
  // Inline function 'korlibs.kgl.tempInt1Buffer' call
  // Inline function 'kotlin.let' call
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'korlibs.kgl.tempInt1Buffer.<anonymous>' call
  var it = _get_tempNBuffer1_$accessor$c1x7qs_ecvwzo();
  setInt32(it, 0, id);
  // Inline function 'korlibs.kgl.deleteRenderbuffer.<anonymous>' call
  _this__u8e3s4.a82(1, it);
  getInt32(it, 0);
}
function deleteFramebuffer(_this__u8e3s4, id) {
  _init_properties_KmlGlExt_kt__r5nfv2();
  // Inline function 'korlibs.kgl.tempInt1Buffer' call
  // Inline function 'kotlin.let' call
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'korlibs.kgl.tempInt1Buffer.<anonymous>' call
  var it = _get_tempNBuffer1_$accessor$c1x7qs_ecvwzo();
  setInt32(it, 0, id);
  // Inline function 'korlibs.kgl.deleteFramebuffer.<anonymous>' call
  _this__u8e3s4.z81(1, it);
  getInt32(it, 0);
}
function _get_tempNBuffer1_$accessor$c1x7qs_ecvwzo() {
  _init_properties_KmlGlExt_kt__r5nfv2();
  return get_tempNBuffer1();
}
var properties_initialized_KmlGlExt_kt_yrhd4c;
function _init_properties_KmlGlExt_kt__r5nfv2() {
  if (!properties_initialized_KmlGlExt_kt_yrhd4c) {
    properties_initialized_KmlGlExt_kt_yrhd4c = true;
    logger = Companion_getInstance_1().qw('KmlGlException');
    tempNBufferByte = Buffer.m12(1, true);
    tempNBuffer1 = Buffer.m12(4, true);
    tempNBuffer4 = Buffer.m12(16, true);
  }
}
var KorgeReload_instance;
function KorgeReload_getInstance() {
  if (KorgeReload_instance === VOID)
    new KorgeReload();
  return KorgeReload_instance;
}
var Companion_instance_60;
function Companion_getInstance_67() {
  return Companion_instance_60;
}
function drawText(_this__u8e3s4, font, textSize, str, x, y, m, colMul, blendMode, filtering) {
  m = m === VOID ? Companion_getInstance_7().g29_1 : m;
  colMul = colMul === VOID ? Colors_getInstance().e41_1 : colMul;
  blendMode = blendMode === VOID ? Companion_getInstance_68().w82_1 : blendMode;
  filtering = filtering === VOID ? true : filtering;
  drawText_0(font, _this__u8e3s4, textSize, str, x, y, m, colMul, blendMode, filtering);
}
function drawText_0(_this__u8e3s4, ctx, textSize, str, x, y, m, colMul, blendMode, filtering) {
  m = m === VOID ? Companion_getInstance_7().g29_1 : m;
  colMul = colMul === VOID ? Colors_getInstance().e41_1 : colMul;
  blendMode = blendMode === VOID ? Companion_getInstance_68().w82_1 : blendMode;
  filtering = filtering === VOID ? true : filtering;
  var scale = textSize / _this__u8e3s4.n4s();
  var m2 = m.r2a(x, y).i2a(scale, scale);
  var dx = 0.0;
  var dy = 0.0;
  // Inline function 'korlibs.korge.render.RenderContext.useBatcher' call
  // Inline function 'korlibs.korge.render.BatchBuilder2D.use' call
  var this_0 = ctx.o84_1;
  var this_1 = this_0.x84_1;
  if (!(this_1.s84_1 === this_0)) {
    this_1.s84_1 = this_0;
    this_1.c86();
  }
  var inductionVariable = 0;
  var last = charSequenceLength(str) - 1 | 0;
  var tmp;
  if (inductionVariable <= last) {
    $l$loop: do {
      var n = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      var c1 = Char__toInt_impl_vasixd(charSequenceGet(str, n));
      if (c1 === 10) {
        dx = 0.0;
        dy = dy + _this__u8e3s4.n4s();
        continue $l$loop;
      }
      // Inline function 'kotlin.text.getOrElse' call
      var index = n + 1 | 0;
      // Inline function 'kotlin.contracts.contract' call
      var tmp_0;
      if (0 <= index ? index <= (charSequenceLength(str) - 1 | 0) : false) {
        tmp_0 = charSequenceGet(str, index);
      } else {
        // Inline function 'korlibs.korge.bitmapfont.drawText.<anonymous>.<anonymous>' call
        tmp_0 = _Char___init__impl__6a9atx(32);
      }
      var tmp$ret$1 = tmp_0;
      var c2 = Char__toInt_impl_vasixd(tmp$ret$1);
      var glyph = _this__u8e3s4.d1(c1);
      var tex = glyph.b4s_1;
      var tmp0_tex = ctx.d86(tex);
      var tmp1_x = dx + glyph.c4s_1;
      var tmp2_y = dy + glyph.d4s_1;
      var tmp3_width = tex.x3f_1;
      var tmp4_height = tex.y3f_1;
      var tmp5_m = get_immutable(m2);
      this_0.e86(tmp0_tex, tmp1_x, tmp2_y, tmp3_width, tmp4_height, tmp5_m, filtering, colMul, blendMode);
      var tmp6_safe_receiver = _this__u8e3s4.r4s().d1(Companion_instance_5.y4r(c1, c2));
      var tmp7_elvis_lhs = tmp6_safe_receiver == null ? null : tmp6_safe_receiver.j4s_1;
      var kerningOffset = tmp7_elvis_lhs == null ? 0 : tmp7_elvis_lhs;
      dx = dx + (glyph.e4s_1 + kerningOffset | 0);
    }
     while (inductionVariable <= last);
    tmp = Unit_instance;
  }
}
var debugBmpFontOrNull;
function *_generator_debugBmpFont__zhh4ef($completion) {
  if (debugBmpFontOrNull == null) {
    var tmp = readBitmap(openAsync(get_DEBUG_FONT_BYTES()), new ImageDecodingProps(VOID, VOID, VOID, VOID, VOID, VOID, VOID, true), $completion);
    if (tmp === get_COROUTINE_SUSPENDED())
      tmp = yield tmp;
    debugBmpFontOrNull = debugBmpFont_0(slice(tmp.u47()));
  }
  return ensureNotNull(debugBmpFontOrNull);
}
function debugBmpFont($completion) {
  return suspendOrReturn(/*#__NOINLINE__*/_generator_debugBmpFont__zhh4ef.bind(VOID), $completion);
}
function debugBmpFont_0(tex) {
  var fntAdvance = 7.0;
  var fntWidth = 8.0;
  var fntHeight = 8.0;
  var fntBlockX = 2.0;
  var fntBlockY = 2.0;
  var fntBlockWidth = 12.0;
  var fntBlockHeight = 12.0;
  // Inline function 'korlibs.image.font.Companion.invoke' call
  var base = fntHeight - 1.0;
  // Inline function 'kotlin.collections.associateWith' call
  var this_0 = until(0, 256);
  var result = LinkedHashMap.hc(coerceAtLeast(mapCapacity(collectionSizeOrDefault(this_0, 10)), 16));
  // Inline function 'kotlin.collections.associateWithTo' call
  var inductionVariable = this_0.d2_1;
  var last = this_0.e2_1;
  if (inductionVariable <= last)
    do {
      var element = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      // Inline function 'korlibs.korge.bitmapfont.debugBmpFont.<anonymous>' call
      var it = element;
      var x = it % 16 | 0;
      var y = it / 16 | 0;
      var tmp$ret$0 = new Glyph(fntHeight, it, tex.f3h(numberToInt(x * fntBlockWidth + fntBlockX), numberToInt(y * fntBlockHeight + fntBlockY), numberToInt(fntWidth), numberToInt(fntHeight)), 0, 0, numberToInt(fntAdvance));
      result.i3(element, tmp$ret$0);
    }
     while (!(element === last));
  var glyphs = toIntMap(result);
  var kernings = IntMap.v2o();
  var name = 'BitmapFont';
  return new BitmapFontImpl(numberToDouble(fntHeight), numberToDouble(fntHeight), numberToDouble(base), glyphs, kernings, name, null);
}
function get_DEBUG_FONT_BYTES() {
  return fromBase64('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');
}
var Companion_instance_61;
function Companion_getInstance_68() {
  if (Companion_instance_61 === VOID)
    new Companion_52();
  return Companion_instance_61;
}
var Companion_instance_62;
function Companion_getInstance_69() {
  return Companion_instance_62;
}
function endFrameOldKeys($this, delta) {
  var inductionVariable = 0;
  if (inductionVariable < 256)
    do {
      var n = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      var prev = $this.l87_1[n];
      var curr = $this.k87_1[n];
      $this.q87_1[n] = (prev && !curr);
      $this.p87_1[n] = (!prev && curr);
      if (curr) {
        var _array__4zh2yp = $this.m87_1;
        _array__4zh2yp[n] = _array__4zh2yp[n] + _FastDuration___get_fastNanoseconds__impl__9kjwbr(delta);
      } else {
        $this.m87_1[n] = 0.0;
        $this.n87_1[n] = 0.0;
      }
      var triggerPress = false;
      var pressingTime = get_fastNanoseconds($this.m87_1[n]);
      if ($this.m87_1[n] > 0) {
        var tmp0_subject = _FastDuration___get_fastMilliseconds__impl__pe68va(pressingTime);
        var timeBarrier = (0.0 <= tmp0_subject ? tmp0_subject <= 1.0 : false) ? get_fastMilliseconds(0.0) : (1.0 <= tmp0_subject ? tmp0_subject <= 300.0 : false) ? get_fastMilliseconds(100.0) : (300.0 <= tmp0_subject ? tmp0_subject <= 1000.0 : false) ? get_fastMilliseconds(50.0) : get_fastMilliseconds(20.0);
        var elapsedTime = FastDuration__minus_impl_evs237(pressingTime, get_fastNanoseconds($this.n87_1[n]));
        if (FastDuration__compareTo_impl_4fhnj7(elapsedTime, timeBarrier) >= 0) {
          triggerPress = true;
        }
      }
      if (triggerPress) {
        $this.n87_1[n] = $this.m87_1[n];
      }
      $this.o87_1[n] = triggerPress;
    }
     while (inductionVariable < 256);
  arraycopy_4($this.k87_1, 0, $this.l87_1, 0, 256);
}
function Input$_isTouchDeviceGen$lambda() {
  return AGOpenglFactory_instance.t87();
}
var DefaultViewport_instance;
function DefaultViewport_getInstance() {
  if (DefaultViewport_instance === VOID)
    new DefaultViewport();
  return DefaultViewport_instance;
}
function *_generator_configureLoggerFromProperties__heiqlb(file, $completion) {
  try {
    var tmp = file.c24(VOID, $completion);
    if (tmp === get_COROUTINE_SUSPENDED())
      tmp = yield tmp;
    configureLoggerFromProperties_0(tmp);
  } catch ($p) {
    if ($p instanceof Error) {
      var e = $p;
    } else {
      throw $p;
    }
  }
  return Unit_instance;
}
function configureLoggerFromProperties(file, $completion) {
  return suspendOrReturn(/*#__NOINLINE__*/_generator_configureLoggerFromProperties__heiqlb.bind(VOID, file), $completion);
}
function configureLoggerFromProperties_0(str) {
  var props = Companion_instance_63.g88(str);
  // Inline function 'kotlin.collections.iterator' call
  var _iterator__ex2g4s = props.s1().a1();
  while (_iterator__ex2g4s.b1()) {
    var _destruct__k2r9zo = _iterator__ex2g4s.c1();
    // Inline function 'kotlin.collections.component1' call
    var key = _destruct__k2r9zo.t1();
    // Inline function 'kotlin.collections.component2' call
    var value = _destruct__k2r9zo.u1();
    try {
      var tmp = Companion_getInstance_1().qw(key);
      // Inline function 'kotlin.text.toUpperCase' call
      // Inline function 'kotlin.js.asDynamic' call
      var tmp$ret$4 = value.toUpperCase();
      tmp.t2t(valueOf(tmp$ret$4));
    } catch ($p) {
      if ($p instanceof Error) {
        var e = $p;
        printStackTrace(e);
      } else {
        throw $p;
      }
    }
  }
}
var Companion_instance_63;
function Companion_getInstance_70() {
  return Companion_instance_63;
}
function AgAutoFreeManager$entryPool$lambda(it) {
  it.t2q();
  return Unit_instance;
}
function AgAutoFreeManager$entryPool$lambda_0(it) {
  return new Entry();
}
function getTextureInfo($this, bitmap) {
  if ($this.n89_1 === bitmap && ensureNotNull($this.o89_1).w88_1.a89_1 === bitmap.g40_1)
    return ensureNotNull($this.o89_1);
  if ($this.p89_1 === bitmap && ensureNotNull($this.q89_1).w88_1.a89_1 === bitmap.g40_1)
    return ensureNotNull($this.q89_1);
  $this.h89_1.g2n(bitmap);
  var tmp$ret$0;
  $l$block: {
    // Inline function 'korlibs.datastructure.getOrPut' call
    var this_0 = $this.m89_1;
    var res = get_0(this_0, bitmap);
    if (!(res == null)) {
      tmp$ret$0 = res;
      break $l$block;
    }
    // Inline function 'korlibs.korge.render.AgBitmapTextureManager.getTextureInfo.<anonymous>' call
    // Inline function 'kotlin.also' call
    var this_1 = $this.l89_1.c2q();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.korge.render.AgBitmapTextureManager.getTextureInfo.<anonymous>.<anonymous>' call
    var base = this_1.w88_1;
    base.a89_1 = -1;
    var tmp = base;
    var tmp_0;
    if (bitmap instanceof MultiBitmap) {
      tmp_0 = Companion_getInstance_51().z6o_1;
    } else {
      tmp_0 = Companion_getInstance_51().x6o_1;
    }
    tmp.y88_1 = new AGTexture(tmp_0);
    base.c89(bitmap.x3z_1);
    base.d89(bitmap.y3z_1);
    var out = this_1;
    set(this_0, bitmap, out);
    tmp$ret$0 = out;
  }
  var textureInfo = tmp$ret$0;
  $this.p89_1 = $this.n89_1;
  $this.q89_1 = $this.o89_1;
  var base_0 = textureInfo.w88_1;
  $this.n89_1 = bitmap;
  $this.o89_1 = textureInfo;
  if (!(bitmap.g40_1 === base_0.a89_1)) {
    base_0.a89_1 = bitmap.g40_1;
    var tmp_1 = $this;
    // Inline function 'kotlin.Long.minus' call
    var this_2 = $this.k89_1;
    var other = textureInfo.v88_1;
    tmp_1.k89_1 = this_2.a2(toLong(other));
    try {
      base_0.w89(bitmap, bitmap.i40_1, get_baseMipmapLevel(bitmap), get_maxMipmapLevel(bitmap));
    }finally {
      textureInfo.v88_1 = _get_estimateSizeInBytes__tshb4c(bitmap, $this);
      var tmp_2 = $this;
      // Inline function 'kotlin.Long.plus' call
      var this_3 = $this.k89_1;
      var other_0 = textureInfo.v88_1;
      tmp_2.k89_1 = this_3.y3(toLong(other_0));
    }
    bitmap.t40();
  }
  return textureInfo;
}
function _get_estimateSizeInBytes__tshb4c(_this__u8e3s4, $this) {
  return imul(_this__u8e3s4.y3z_1, imul(_this__u8e3s4.x3z_1, _this__u8e3s4.z3z_1) / 8 | 0);
}
function _getTexture($this, slice) {
  if ($this.r89_1 === slice)
    return ensureNotNull($this.s89_1);
  if ($this.t89_1 === slice)
    return ensureNotNull($this.u89_1);
  var info = getTextureInfo($this, slice.x3g());
  var tmp$ret$0;
  $l$block: {
    // Inline function 'korlibs.datastructure.getOrPut' call
    var this_0 = info.x88_1;
    var res = get_0(this_0, slice);
    if (!(res == null)) {
      tmp$ret$0 = res;
      break $l$block;
    }
    // Inline function 'korlibs.korge.render.AgBitmapTextureManager._getTexture.<anonymous>' call
    var tmp;
    if (slice instanceof RectSlice) {
      tmp = Texture_1(info.w88_1).h3h(RectangleInt.h2f(slice.d26(), slice.f26(), slice.x3f_1, slice.y3f_1));
    } else {
      tmp = Companion_instance_7.z3h(info.w88_1, slice);
    }
    var out = tmp;
    set(this_0, slice, out);
    tmp$ret$0 = out;
  }
  var texture = tmp$ret$0;
  $this.t89_1 = $this.r89_1;
  $this.u89_1 = $this.s89_1;
  $this.r89_1 = slice;
  $this.s89_1 = texture;
  return texture;
}
function clearFastCacheAccess($this) {
  $this.n89_1 = null;
  $this.o89_1 = null;
  $this.p89_1 = null;
  $this.q89_1 = null;
  $this.r89_1 = null;
  $this.s89_1 = null;
  $this.t89_1 = null;
  $this.u89_1 = null;
}
function AgBitmapTextureManager$textureInfoPool$lambda(it) {
  it.t2q();
  return Unit_instance;
}
function AgBitmapTextureManager$textureInfoPool$lambda_0(it) {
  return new BitmapTextureInfo();
}
function removeCache($this) {
}
function AgBufferManager$bufferPool$lambda(it) {
  return new AGBuffer();
}
function get_logger() {
  _init_properties_BatchBuilder2D_kt__vdn94j();
  return logger_0;
}
var logger_0;
function get_BB_MAX_TEXTURES() {
  _init_properties_BatchBuilder2D_kt__vdn94j();
  return BB_MAX_TEXTURES;
}
var BB_MAX_TEXTURES;
function BatchBuilder2D$Companion$createTextureLookup$lambda($$this$apply) {
  return function ($this$IF_ELSE_BINARY_LOOKUP, n) {
    $this$IF_ELSE_BINARY_LOOKUP.n70($this$IF_ELSE_BINARY_LOOKUP.q70(), $this$IF_ELSE_BINARY_LOOKUP.y70(Companion_getInstance_71().r8a_1[n], $this$IF_ELSE_BINARY_LOOKUP.w70($$this$apply.j70(), 'xy')));
    return Unit_instance;
  };
}
function _addIndices($this, indicesI16, pos, i0, i1, i2, i3, i4, i5) {
  Uint16Buffer__set_impl_g0kliu(indicesI16, pos + 0 | 0, i0);
  Uint16Buffer__set_impl_g0kliu(indicesI16, pos + 1 | 0, i1);
  Uint16Buffer__set_impl_g0kliu(indicesI16, pos + 2 | 0, i2);
  Uint16Buffer__set_impl_g0kliu(indicesI16, pos + 3 | 0, i3);
  Uint16Buffer__set_impl_g0kliu(indicesI16, pos + 4 | 0, i4);
  Uint16Buffer__set_impl_g0kliu(indicesI16, pos + 5 | 0, i5);
  return 6;
}
function applyMatrix($this, matrix, idx, vcount) {
  var f32 = get_f32($this.f85_1);
  var idx_0 = idx;
  var ma = matrix.l29_1;
  var mb = matrix.m29_1;
  var mc = matrix.n29_1;
  var md = matrix.o29_1;
  var mtx = matrix.p29_1;
  var mty = matrix.q29_1;
  var inductionVariable = 0;
  if (inductionVariable < vcount)
    do {
      var n = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      var p = Vector2D.q2a(Float32Buffer__get_impl_659lhu(f32, idx_0 + 0 | 0), Float32Buffer__get_impl_659lhu(f32, idx_0 + 1 | 0));
      var pt = Companion_getInstance_7().t29(ma, mb, mc, md, mtx, mty, p);
      Float32Buffer__set_impl_34szne(f32, idx_0 + 0 | 0, pt.m25_1);
      Float32Buffer__set_impl_34szne(f32, idx_0 + 1 | 0, pt.n25_1);
      idx_0 = idx_0 + 6 | 0;
    }
     while (inductionVariable < vcount);
}
function checkAvailable($this, indices, vertices) {
  return ($this.l85_1 + indices | 0) < $this.e85_1 && ($this.k85_1 + vertices | 0) < $this.d85_1;
}
var Companion_instance_64;
function Companion_getInstance_71() {
  if (Companion_instance_64 === VOID)
    new Companion_55();
  return Companion_instance_64;
}
function BatchBuilder2D$lambda(this$0) {
  return function (it) {
    var tmp;
    switch (it.r3_1) {
      case 0:
        this$0.i8b();
        tmp = Unit_instance;
        break;
      case 1:
        this$0.j8b();
        tmp = Unit_instance;
        break;
      default:
        noWhenBranchMatchedException();
        break;
    }
    return Unit_instance;
  };
}
function BatchBuilder2D$buffers$lambda(it) {
  return new BatchBuffers();
}
var properties_initialized_BatchBuilder2D_kt_532b2j;
function _init_properties_BatchBuilder2D_kt__vdn94j() {
  if (!properties_initialized_BatchBuilder2D_kt_532b2j) {
    properties_initialized_BatchBuilder2D_kt_532b2j = true;
    logger_0 = Companion_getInstance_1().qw('BatchBuilder2D');
    BB_MAX_TEXTURES = Companion_getInstance_2().au() && Companion_getInstance_2().hu().lt_1 && Companion_getInstance_2().hu().qt() ? 1 : 4;
  }
}
function get_debugLineRenderContext(_this__u8e3s4) {
  _init_properties_LineRenderBatcher_kt__ezqewb();
  var tmp$ret$0;
  $l$block: {
    // Inline function 'korlibs.datastructure.PropertyThis.getValue' call
    var this_0 = debugLineRenderContext$delegate;
    var property = debugLineRenderContext$factory();
    var tmp0_elvis_lhs = this_0.ey_1;
    var res = getExtraTyped(_this__u8e3s4, tmp0_elvis_lhs == null ? property.callableName : tmp0_elvis_lhs);
    if (res == null) {
      var r = this_0.fy_1(_this__u8e3s4);
      // Inline function 'korlibs.datastructure.PropertyThis.setValueUntransformed' call
      var tmp0_elvis_lhs_0 = this_0.ey_1;
      setExtra(_this__u8e3s4, tmp0_elvis_lhs_0 == null ? property.callableName : tmp0_elvis_lhs_0, r);
      tmp$ret$0 = r;
      break $l$block;
    }
    tmp$ret$0 = res;
  }
  return tmp$ret$0;
}
var debugLineRenderContext$delegate;
var Companion_instance_65;
function Companion_getInstance_72() {
  if (Companion_instance_65 === VOID)
    new Companion_56();
  return Companion_instance_65;
}
function addVertex($this, x, y, color, m) {
  setFloat32($this.x8d_1, $this.a8e_1 + 0 | 0, m.z29(x, y));
  setFloat32($this.x8d_1, $this.a8e_1 + 1 | 0, m.a2a(x, y));
  setInt32($this.x8d_1, $this.a8e_1 + 2 | 0, _RGBA___get_value__impl__hhco8v(color));
  $this.a8e_1 = $this.a8e_1 + (Companion_getInstance_72().m8d_1.p6s_1 / 4 | 0) | 0;
  $this.z8d_1 = $this.z8d_1 + 1 | 0;
}
function LineRenderBatcher$lambda(this$0) {
  return function (it) {
    this$0.qc();
    return Unit_instance;
  };
}
function debugLineRenderContext$delegate$lambda($this$PropertyThis) {
  _init_properties_LineRenderBatcher_kt__ezqewb();
  return new LineRenderBatcher($this$PropertyThis);
}
function debugLineRenderContext$factory() {
  return getPropertyCallableRef('debugLineRenderContext', 1, KProperty1, function (receiver) {
    return get_debugLineRenderContext(receiver);
  }, null);
}
var properties_initialized_LineRenderBatcher_kt_urwcod;
function _init_properties_LineRenderBatcher_kt__ezqewb() {
  if (!properties_initialized_LineRenderBatcher_kt_urwcod) {
    properties_initialized_LineRenderBatcher_kt_urwcod = true;
    debugLineRenderContext$delegate = new PropertyThis(VOID, debugLineRenderContext$delegate$lambda);
  }
}
var FlushKind_STATE_instance;
var FlushKind_FULL_instance;
var FlushKind_entriesInitialized;
function FlushKind_initEntries() {
  if (FlushKind_entriesInitialized)
    return Unit_instance;
  FlushKind_entriesInitialized = true;
  FlushKind_STATE_instance = new FlushKind('STATE', 0);
  FlushKind_FULL_instance = new FlushKind('FULL', 1);
}
function RenderContext$tempTexturePool$lambda(it) {
  return new AGTexture();
}
function RenderContext$projViewMatUB$delegate$lambda(this$0) {
  return function () {
    return this$0.n6q(ProjViewUB_getInstance());
  };
}
function RenderContext$dynamicVertexBufferPool$lambda(it) {
  return new AGBuffer();
}
function RenderContext$frameBuffers$lambda(it) {
  return AGFrameBuffer.g6j(VOID, it);
}
function FlushKind_STATE_getInstance() {
  FlushKind_initEntries();
  return FlushKind_STATE_instance;
}
function FlushKind_FULL_getInstance() {
  FlushKind_initEntries();
  return FlushKind_FULL_instance;
}
function projViewMatUB$factory() {
  return getPropertyCallableRef('projViewMatUB', 1, KProperty1, function (receiver) {
    return receiver.l8e();
  }, null);
}
function get_logger_0() {
  _init_properties_RenderContext2D_kt__7o43tz();
  return logger_1;
}
var logger_1;
function RenderContext2D$mpool$lambda(it) {
  return new MMatrix();
}
var properties_initialized_RenderContext2D_kt_ica10b;
function _init_properties_RenderContext2D_kt__7o43tz() {
  if (!properties_initialized_RenderContext2D_kt_ica10b) {
    properties_initialized_RenderContext2D_kt_ica10b = true;
    logger_1 = Companion_getInstance_1().qw('RenderContext2D');
  }
}
function SDFShaders$opInterpolate$delegate$lambda($this$FUNC, a, b, c) {
  $this$FUNC.a72($this$FUNC.b7n(a, b, c));
  return Unit_instance;
}
function SDFShaders$opUnion$delegate$lambda($this$FUNC, a, b) {
  $this$FUNC.a72($this$FUNC.y7m(a, b));
  return Unit_instance;
}
function SDFShaders$opIntersect$delegate$lambda($this$FUNC, a, b) {
  $this$FUNC.a72($this$FUNC.z7m(a, b));
  return Unit_instance;
}
function SDFShaders$opSubtract$delegate$lambda($this$FUNC, a, b) {
  $this$FUNC.a72($this$FUNC.z7m(a, $this$FUNC.p72(b)));
  return Unit_instance;
}
function SDFShaders$opRound$delegate$lambda($this$FUNC, d, r) {
  $this$FUNC.a72($this$FUNC.q72(d, r));
  return Unit_instance;
}
function SDFShaders$opBorder$delegate$lambda($this$FUNC, d, r) {
  $this$FUNC.a72($this$FUNC.q72($this$FUNC.h72(d), r));
  return Unit_instance;
}
function SDFShaders$opBorderInner$delegate$lambda($this$FUNC, d, r) {
  // Inline function 'korlibs.graphics.shader.Builder.IF' call
  var cond = $this$FUNC.a73(d, 0.0);
  var body = $this$FUNC.e71();
  // Inline function 'korlibs.korge.render.SDFShaders.opBorderInner$delegate.<anonymous>.<anonymous>' call
  body.a72(d);
  var stmIf = new If(cond, body.g71());
  // Inline function 'kotlin.collections.plusAssign' call
  $this$FUNC.m70_1.h(stmIf);
  var tmp = stmIf;
  $this$FUNC.u71(tmp, SDFShaders$opBorderInner$delegate$lambda$lambda(d, r));
  return Unit_instance;
}
function SDFShaders$opBorderInner$delegate$lambda$lambda($d, $r) {
  return function ($this$ELSE) {
    $this$ELSE.a72($this$ELSE.q72($this$ELSE.h72($d), $r));
    return Unit_instance;
  };
}
function SDFShaders$opAA$delegate$lambda($this$FUNC, d) {
  $this$FUNC.a72($this$FUNC.r72(1.0, $this$FUNC.x7m($this$FUNC.e7n($this$FUNC.c71(d, $this$FUNC.a7n(d)), 0.5), $this$FUNC.t70(0.0), $this$FUNC.t70(1.0))));
  return Unit_instance;
}
function SDFShaders$opAARev$delegate$lambda($this$FUNC, d) {
  $this$FUNC.a72($this$FUNC.x7m($this$FUNC.e7n($this$FUNC.c71(d, $this$FUNC.a7n(d)), 0.5), $this$FUNC.t70(0.0), $this$FUNC.t70(1.0)));
  return Unit_instance;
}
function SDFShaders$opSmoothUnion$delegate$lambda($this$FUNC, d1, d2, k) {
  var h = $this$FUNC.q71($this$FUNC.x7m($this$FUNC.d7n(0.5, $this$FUNC.c71($this$FUNC.f7n(0.5, $this$FUNC.q72(d2, d1)), k)), $this$FUNC.t70(0.0), $this$FUNC.t70(1.0)));
  $this$FUNC.a72($this$FUNC.q72($this$FUNC.b7n(d2, d1, h), $this$FUNC.r70($this$FUNC.r70(k, h), $this$FUNC.r72(1.0, h))));
  return Unit_instance;
}
function SDFShaders$opSmoothSubtraction$delegate$lambda($this$FUNC, d1, d2, k) {
  var h = $this$FUNC.q71($this$FUNC.x7m($this$FUNC.r72(0.5, $this$FUNC.c71($this$FUNC.f7n(0.5, $this$FUNC.s72(d2, d1)), k)), $this$FUNC.t70(0.0), $this$FUNC.t70(1.0)));
  $this$FUNC.a72($this$FUNC.s72($this$FUNC.b7n(d2, $this$FUNC.p72(d1), h), $this$FUNC.r70($this$FUNC.r70(k, h), $this$FUNC.r72(1.0, h))));
  return Unit_instance;
}
function SDFShaders$opSmoothIntersection$delegate$lambda($this$FUNC, d1, d2, k) {
  var h = $this$FUNC.q71($this$FUNC.x7m($this$FUNC.r72(0.5, $this$FUNC.c71($this$FUNC.f7n(0.5, $this$FUNC.q72(d2, d1)), k)), $this$FUNC.t70(0.0), $this$FUNC.t70(1.0)));
  $this$FUNC.a72($this$FUNC.s72($this$FUNC.b7n(d2, d1, h), $this$FUNC.r70($this$FUNC.r70(k, h), $this$FUNC.r72(1.0, h))));
  return Unit_instance;
}
function SDFShaders$circle$delegate$lambda($this$FUNC, p, r) {
  $this$FUNC.a72($this$FUNC.q72($this$FUNC.c7n(p), r));
  return Unit_instance;
}
function SDFShaders$roundedBox$delegate$lambda($this$FUNC, p, b, r) {
  $this$FUNC.n70($this$FUNC.w70(r, 'xy'), $this$FUNC.w7m($this$FUNC.a73($this$FUNC.l72(p), 0.0), $this$FUNC.w70(r, 'xy'), $this$FUNC.w70(r, 'zw')));
  $this$FUNC.n70($this$FUNC.l72(r), $this$FUNC.w7m($this$FUNC.a73($this$FUNC.m72(p), 0.0), $this$FUNC.l72(r), $this$FUNC.m72(r)));
  var q = $this$FUNC.q71($this$FUNC.s72($this$FUNC.q72($this$FUNC.h72(p), b), $this$FUNC.l72(r)));
  $this$FUNC.a72($this$FUNC.q72($this$FUNC.s72($this$FUNC.y7m($this$FUNC.z7m($this$FUNC.l72(q), $this$FUNC.m72(q)), $this$FUNC.t70(0.0)), $this$FUNC.c7n($this$FUNC.z7m(q, $this$FUNC.t70(0.0)))), $this$FUNC.l72(r)));
  return Unit_instance;
}
function SDFShaders$box$delegate$lambda($this$FUNC, p, b) {
  var d = $this$FUNC.q71($this$FUNC.q72($this$FUNC.h72(p), b));
  $this$FUNC.a72($this$FUNC.s72($this$FUNC.c7n($this$FUNC.z7m(d, $this$FUNC.t70(0.0))), $this$FUNC.y7m($this$FUNC.z7m($this$FUNC.l72(d), $this$FUNC.m72(d)), $this$FUNC.t70(0.0))));
  return Unit_instance;
}
function SDFShaders$opCombinePremultipliedColors$delegate$lambda($this$FUNC, dst, src) {
  $this$FUNC.a72($this$FUNC.s72(src, $this$FUNC.r70(dst, $this$FUNC.r72(1.0, $this$FUNC.a71(src)))));
  return Unit_instance;
}
var SDFShaders_instance;
function SDFShaders_getInstance() {
  if (SDFShaders_instance === VOID)
    SDFShaders.m8g();
  return SDFShaders_instance;
}
function opInterpolate$factory() {
  return getPropertyCallableRef('opInterpolate', 1, KProperty1, function (receiver) {
    return receiver.n8g();
  }, null);
}
function opUnion$factory() {
  return getPropertyCallableRef('opUnion', 1, KProperty1, function (receiver) {
    return receiver.o8g();
  }, null);
}
function opIntersect$factory() {
  return getPropertyCallableRef('opIntersect', 1, KProperty1, function (receiver) {
    return receiver.p8g();
  }, null);
}
function opSubtract$factory() {
  return getPropertyCallableRef('opSubtract', 1, KProperty1, function (receiver) {
    return receiver.q8g();
  }, null);
}
function opRound$factory() {
  return getPropertyCallableRef('opRound', 1, KProperty1, function (receiver) {
    return receiver.r8g();
  }, null);
}
function opBorder$factory() {
  return getPropertyCallableRef('opBorder', 1, KProperty1, function (receiver) {
    return receiver.s8g();
  }, null);
}
function opBorderInner$factory() {
  return getPropertyCallableRef('opBorderInner', 1, KProperty1, function (receiver) {
    return receiver.t8g();
  }, null);
}
function opAA$factory() {
  return getPropertyCallableRef('opAA', 1, KProperty1, function (receiver) {
    return receiver.u8g();
  }, null);
}
function opAARev$factory() {
  return getPropertyCallableRef('opAARev', 1, KProperty1, function (receiver) {
    return receiver.v8g();
  }, null);
}
function opSmoothUnion$factory() {
  return getPropertyCallableRef('opSmoothUnion', 1, KProperty1, function (receiver) {
    return receiver.w8g();
  }, null);
}
function opSmoothSubtraction$factory() {
  return getPropertyCallableRef('opSmoothSubtraction', 1, KProperty1, function (receiver) {
    return receiver.x8g();
  }, null);
}
function opSmoothIntersection$factory() {
  return getPropertyCallableRef('opSmoothIntersection', 1, KProperty1, function (receiver) {
    return receiver.y8g();
  }, null);
}
function circle$factory() {
  return getPropertyCallableRef('circle', 1, KProperty1, function (receiver) {
    return receiver.z8g();
  }, null);
}
function roundedBox$factory() {
  return getPropertyCallableRef('roundedBox', 1, KProperty1, function (receiver) {
    return receiver.a8h();
  }, null);
}
function box$factory() {
  return getPropertyCallableRef('box', 1, KProperty1, function (receiver) {
    return receiver.b8h();
  }, null);
}
function opCombinePremultipliedColors$factory() {
  return getPropertyCallableRef('opCombinePremultipliedColors', 1, KProperty1, function (receiver) {
    return receiver.c8h();
  }, null);
}
function opInterpolate$factory_0() {
  return getPropertyCallableRef('opInterpolate', 1, KProperty1, function (receiver) {
    return receiver.n8g();
  }, null);
}
function opUnion$factory_0() {
  return getPropertyCallableRef('opUnion', 1, KProperty1, function (receiver) {
    return receiver.o8g();
  }, null);
}
function opIntersect$factory_0() {
  return getPropertyCallableRef('opIntersect', 1, KProperty1, function (receiver) {
    return receiver.p8g();
  }, null);
}
function opSubtract$factory_0() {
  return getPropertyCallableRef('opSubtract', 1, KProperty1, function (receiver) {
    return receiver.q8g();
  }, null);
}
function opRound$factory_0() {
  return getPropertyCallableRef('opRound', 1, KProperty1, function (receiver) {
    return receiver.r8g();
  }, null);
}
function opBorder$factory_0() {
  return getPropertyCallableRef('opBorder', 1, KProperty1, function (receiver) {
    return receiver.s8g();
  }, null);
}
function opBorderInner$factory_0() {
  return getPropertyCallableRef('opBorderInner', 1, KProperty1, function (receiver) {
    return receiver.t8g();
  }, null);
}
function opAA$factory_0() {
  return getPropertyCallableRef('opAA', 1, KProperty1, function (receiver) {
    return receiver.u8g();
  }, null);
}
function opAARev$factory_0() {
  return getPropertyCallableRef('opAARev', 1, KProperty1, function (receiver) {
    return receiver.v8g();
  }, null);
}
function opSmoothUnion$factory_0() {
  return getPropertyCallableRef('opSmoothUnion', 1, KProperty1, function (receiver) {
    return receiver.w8g();
  }, null);
}
function opSmoothSubtraction$factory_0() {
  return getPropertyCallableRef('opSmoothSubtraction', 1, KProperty1, function (receiver) {
    return receiver.x8g();
  }, null);
}
function opSmoothIntersection$factory_0() {
  return getPropertyCallableRef('opSmoothIntersection', 1, KProperty1, function (receiver) {
    return receiver.y8g();
  }, null);
}
function circle$factory_0() {
  return getPropertyCallableRef('circle', 1, KProperty1, function (receiver) {
    return receiver.z8g();
  }, null);
}
function roundedBox$factory_0() {
  return getPropertyCallableRef('roundedBox', 1, KProperty1, function (receiver) {
    return receiver.a8h();
  }, null);
}
function box$factory_0() {
  return getPropertyCallableRef('box', 1, KProperty1, function (receiver) {
    return receiver.b8h();
  }, null);
}
function opCombinePremultipliedColors$factory_0() {
  return getPropertyCallableRef('opCombinePremultipliedColors', 1, KProperty1, function (receiver) {
    return receiver.c8h();
  }, null);
}
function Texture(frameBuffer) {
  return Texture_0(frameBuffer.c6o(), frameBuffer.a6j_1, frameBuffer.b6j_1);
}
function Texture_0(agBase, width, height) {
  return new RectSlice(TextureBase.d8h(agBase, SizeInt.x2g(width, height)), RectangleInt.h2f(0, 0, width, height));
}
function Texture_1(base, left, top, right, bottom) {
  left = left === VOID ? 0 : left;
  top = top === VOID ? 0 : top;
  right = right === VOID ? base.z2i() : right;
  bottom = bottom === VOID ? base.a2j() : bottom;
  return new RectSlice(base, Companion_instance_2.i2e(left, top, right, bottom));
}
function get_TEXTURED_ARRAY_QUAD_INDICES() {
  _init_properties_TexturedVertexArray_kt__kev7cq();
  return TEXTURED_ARRAY_QUAD_INDICES;
}
var TEXTURED_ARRAY_QUAD_INDICES;
var TEXTURED_ARRAY_EMPTY_INT_ARRAY;
var TEXTURED_ARRAY_EMPTY_SHORT_ARRAY;
var Companion_instance_66;
function Companion_getInstance_73() {
  if (Companion_instance_66 === VOID)
    new Companion_57();
  return Companion_instance_66;
}
var properties_initialized_TexturedVertexArray_kt_ouua70;
function _init_properties_TexturedVertexArray_kt__kev7cq() {
  if (!properties_initialized_TexturedVertexArray_kt_ouua70) {
    properties_initialized_TexturedVertexArray_kt_ouua70 = true;
    // Inline function 'kotlin.shortArrayOf' call
    TEXTURED_ARRAY_QUAD_INDICES = new Int16Array([0, 1, 2, 3, 0, 2]);
    TEXTURED_ARRAY_EMPTY_INT_ARRAY = new Int32Array(0);
    TEXTURED_ARRAY_EMPTY_SHORT_ARRAY = new Int16Array(0);
  }
}
function _get_root__dd8asp($this) {
  var tmp = $this.h8h_1;
  if (!(tmp == null))
    return tmp;
  else {
    throwUninitializedPropertyAccessException('root');
  }
}
function _get_mountable__707cy($this) {
  var tmp = $this.i8h_1;
  if (!(tmp == null))
    return tmp;
  else {
    throwUninitializedPropertyAccessException('mountable');
  }
}
function V2Callback(init, callback) {
  var tmp;
  if (init === VOID) {
    tmp = V2Callback$lambda;
  } else {
    tmp = init;
  }
  init = tmp;
  var tmp_0 = dummy$factory(V2CallbackSupport_getInstance());
  return new V2(tmp_0, Unit_instance, Unit_instance, V2Callback$lambda_0(callback), true, VOID, VOID, init);
}
function _interpolate(ratio, l, r) {
  return interpolate(ratio, l, r);
}
function _interpolateColor(ratio, l, r) {
  return Companion_getInstance_11().r4r(l, r, ratio);
}
var V2CallbackSupport_instance;
function V2CallbackSupport_getInstance() {
  if (V2CallbackSupport_instance === VOID)
    new V2CallbackSupport();
  return V2CallbackSupport_instance;
}
function _interpolateRatio(ratio, l, r) {
  return interpolate_0(ratio, l, r);
}
function V2Callback$lambda() {
  return Unit_instance;
}
function V2Callback$lambda_0($callback) {
  return function (ratio, _unused_var__etf5q3, _unused_var__etf5q3_0) {
    $callback(ratio);
    return Unit_instance;
  };
}
function dummy$factory($b0) {
  return getPropertyCallableRef('dummy', 0, KMutableProperty0, function () {
    return Unit_instance;
  }, function (value) {
    $b0.i8i_1 = value;
    return Unit_instance;
  });
}
var DEFAULT_instance;
function DEFAULT_getInstance() {
  return DEFAULT_instance;
}
var GLOBAL_CHECK_GL;
var Cursor_DEFAULT_instance;
var Cursor_CROSSHAIR_instance;
var Cursor_TEXT_instance;
var Cursor_HAND_instance;
var Cursor_MOVE_instance;
var Cursor_WAIT_instance;
var Cursor_RESIZE_EAST_instance;
var Cursor_RESIZE_WEST_instance;
var Cursor_RESIZE_SOUTH_instance;
var Cursor_RESIZE_NORTH_instance;
var Cursor_RESIZE_NORTH_EAST_instance;
var Cursor_RESIZE_NORTH_WEST_instance;
var Cursor_RESIZE_SOUTH_EAST_instance;
var Cursor_RESIZE_SOUTH_WEST_instance;
var Companion_instance_67;
function Companion_getInstance_74() {
  Cursor_initEntries();
  if (Companion_instance_67 === VOID)
    new Companion_58();
  return Companion_instance_67;
}
var Cursor_entriesInitialized;
function Cursor_initEntries() {
  if (Cursor_entriesInitialized)
    return Unit_instance;
  Cursor_entriesInitialized = true;
  Cursor_DEFAULT_instance = new Cursor('DEFAULT', 0);
  Cursor_CROSSHAIR_instance = new Cursor('CROSSHAIR', 1);
  Cursor_TEXT_instance = new Cursor('TEXT', 2);
  Cursor_HAND_instance = new Cursor('HAND', 3);
  Cursor_MOVE_instance = new Cursor('MOVE', 4);
  Cursor_WAIT_instance = new Cursor('WAIT', 5);
  Cursor_RESIZE_EAST_instance = new Cursor('RESIZE_EAST', 6);
  Cursor_RESIZE_WEST_instance = new Cursor('RESIZE_WEST', 7);
  Cursor_RESIZE_SOUTH_instance = new Cursor('RESIZE_SOUTH', 8);
  Cursor_RESIZE_NORTH_instance = new Cursor('RESIZE_NORTH', 9);
  Cursor_RESIZE_NORTH_EAST_instance = new Cursor('RESIZE_NORTH_EAST', 10);
  Cursor_RESIZE_NORTH_WEST_instance = new Cursor('RESIZE_NORTH_WEST', 11);
  Cursor_RESIZE_SOUTH_EAST_instance = new Cursor('RESIZE_SOUTH_EAST', 12);
  Cursor_RESIZE_SOUTH_WEST_instance = new Cursor('RESIZE_SOUTH_WEST', 13);
  Companion_getInstance_74();
}
function GameWindow$MenuItem$_init_$lambda_465oqx() {
  return Unit_instance;
}
var Quality_PERFORMANCE_instance;
var Quality_QUALITY_instance;
var Quality_AUTOMATIC_instance;
var Quality_entriesInitialized;
function Quality_initEntries() {
  if (Quality_entriesInitialized)
    return Unit_instance;
  Quality_entriesInitialized = true;
  Quality_PERFORMANCE_instance = new Quality('PERFORMANCE', 0, 0.0);
  Quality_QUALITY_instance = new Quality('QUALITY', 1, 1.0);
  Quality_AUTOMATIC_instance = new Quality('AUTOMATIC', 2, 0.5);
}
function *_generator_invoke__zhh2q8($this, $completion) {
  var tmp = $this.l8i_1($this.m8i_1, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  return Unit_instance;
}
var CoroutineKey_instance;
function CoroutineKey_getInstance() {
  if (CoroutineKey_instance === VOID)
    new CoroutineKey();
  return CoroutineKey_instance;
}
function _get_fpsCached__581dty($this) {
  return $this.s8j_1.no($this, fpsCached$factory());
}
function *_generator_waitClose__fhnm35($this, $completion) {
  while ($this.h8k_1) {
    // Inline function 'korlibs.time.milliseconds' call
    // Inline function 'kotlin.time.Companion.milliseconds' call
    Companion_getInstance();
    var tmp$ret$1 = toDuration(100, DurationUnit_MILLISECONDS_getInstance());
    var tmp = delay_0(tmp$ret$1, $completion);
    if (tmp === get_COROUTINE_SUSPENDED())
      tmp = yield tmp;
  }
  return Unit_instance;
}
function *_generator_loop__qll5p8($this, entry, $completion) {
  var tmp = $this.l8l($completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  var tmp_0 = tmp.dn(CoroutineName.v1b('GameWindow.loop'));
  launchImmediately(tmp_0, GameWindow$loop$slambda_0(entry, $this));
  while ($this.h8k_1) {
    var elapsed;
    // Inline function 'kotlin.time.measureTime' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'kotlin.time.measureTime' call
    // Inline function 'kotlin.contracts.contract' call
    var mark = Monotonic_instance.ej();
    // Inline function 'korlibs.render.GameWindow.loop.<anonymous>' call
    elapsed = $this.m8l();
    var realElapsed = ValueTimeMark__elapsedNow_impl_eonqvs(mark);
    var available = FastDuration__minus_impl_evs237($this.n8l(), elapsed);
    if (FastDuration__compareTo_impl_4fhnj7(available, Companion_instance_3.c1v()) > 0) {
      var tmp_1 = $this.o8l(available, $completion);
      if (tmp_1 === get_COROUTINE_SUSPENDED())
        tmp_1 = yield tmp_1;
    }
  }
  return Unit_instance;
}
function *_generator_loopDelay__vgtnit($this, time, $completion) {
  var tmp = delay(time, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  return Unit_instance;
}
function GameWindow$fpsCached$delegate$lambda(this$0) {
  return function () {
    return this$0.p8l();
  };
}
function GameWindow$loop$slambda_0($entry, this$0) {
  var i = new GameWindow$loop$slambda($entry, this$0);
  var l = function ($completion) {
    return i.ud($completion);
  };
  l.$arity = 0;
  return l;
}
function Cursor_DEFAULT_getInstance() {
  Cursor_initEntries();
  return Cursor_DEFAULT_instance;
}
function Cursor_TEXT_getInstance() {
  Cursor_initEntries();
  return Cursor_TEXT_instance;
}
function Cursor_HAND_getInstance() {
  Cursor_initEntries();
  return Cursor_HAND_instance;
}
function Cursor_RESIZE_EAST_getInstance() {
  Cursor_initEntries();
  return Cursor_RESIZE_EAST_instance;
}
function Cursor_RESIZE_WEST_getInstance() {
  Cursor_initEntries();
  return Cursor_RESIZE_WEST_instance;
}
function Cursor_RESIZE_SOUTH_getInstance() {
  Cursor_initEntries();
  return Cursor_RESIZE_SOUTH_instance;
}
function Cursor_RESIZE_NORTH_getInstance() {
  Cursor_initEntries();
  return Cursor_RESIZE_NORTH_instance;
}
function Cursor_RESIZE_NORTH_EAST_getInstance() {
  Cursor_initEntries();
  return Cursor_RESIZE_NORTH_EAST_instance;
}
function Cursor_RESIZE_NORTH_WEST_getInstance() {
  Cursor_initEntries();
  return Cursor_RESIZE_NORTH_WEST_instance;
}
function Cursor_RESIZE_SOUTH_EAST_getInstance() {
  Cursor_initEntries();
  return Cursor_RESIZE_SOUTH_EAST_instance;
}
function Cursor_RESIZE_SOUTH_WEST_getInstance() {
  Cursor_initEntries();
  return Cursor_RESIZE_SOUTH_WEST_instance;
}
function Quality_PERFORMANCE_getInstance() {
  Quality_initEntries();
  return Quality_PERFORMANCE_instance;
}
function Quality_AUTOMATIC_getInstance() {
  Quality_initEntries();
  return Quality_AUTOMATIC_instance;
}
var Companion_instance_68;
function Companion_getInstance_75() {
  if (Companion_instance_68 === VOID)
    new Companion_59();
  return Companion_instance_68;
}
function configure(_this__u8e3s4, size, title, icon, fullscreen, bgcolor) {
  title = title === VOID ? 'GameWindow' : title;
  icon = icon === VOID ? null : icon;
  fullscreen = fullscreen === VOID ? null : fullscreen;
  bgcolor = bgcolor === VOID ? Colors_getInstance().f41_1 : bgcolor;
  _this__u8e3s4.e8n(numberToInt(size.r26_1), numberToInt(size.s26_1));
  if (!(title == null)) {
    _this__u8e3s4.v8m(title);
  }
  _this__u8e3s4.w8m(icon);
  if (!(fullscreen == null)) {
    _this__u8e3s4.x8m(fullscreen);
  }
  _this__u8e3s4.z8m(bgcolor);
  _this__u8e3s4.y8m(true);
}
function fpsCached$factory() {
  return getPropertyCallableRef('fpsCached', 1, KProperty1, function (receiver) {
    return _get_fpsCached__581dty(receiver);
  }, null);
}
function continuousRenderMode$factory() {
  return getPropertyCallableRef('continuousRenderMode', 1, KMutableProperty1, function (receiver) {
    return receiver.l8n();
  }, function (receiver, value) {
    return receiver.k8n(value);
  });
}
function continuousRenderMode$factory_0() {
  return getPropertyCallableRef('continuousRenderMode', 1, KMutableProperty1, function (receiver) {
    return receiver.l8n();
  }, function (receiver, value) {
    return receiver.k8n(value);
  });
}
var Companion_instance_69;
function Companion_getInstance_76() {
  if (Companion_instance_69 === VOID)
    new Companion_60();
  return Companion_instance_69;
}
function GameWindowCoroutineDispatcher$_init_$lambda_ooms1e() {
  return new FastDuration(PerformanceCounter_getInstance().w67());
}
function GameWindowCoroutineDispatcher$timedTasks$lambda(a, b) {
  return FastDuration__compareTo_impl_4fhnj7(a.p8o_1, b.p8o_1);
}
function GameWindowCoroutineDispatcher$scheduleResumeAfterDelay$lambda($task) {
  return function (it) {
    $task.s8o_1 = it;
    return Unit_instance;
  };
}
function GameWindowCoroutineDispatcher$invokeOnTimeout$lambda(this$0, $task) {
  return function () {
    // Inline function 'korlibs.concurrent.lock.NonRecursiveLock.invoke' call
    // Inline function 'kotlinx.atomicfu.locks.synchronized' call
    this$0.c8m_1.i1v_1;
    // Inline function 'korlibs.concurrent.lock.NonRecursiveLock.invoke.<anonymous>' call
    this$0.b8m_1.h2m($task);
    return Unit_instance;
  };
}
function SyncEventLoopCoroutineDispatcher$dispatch$lambda($block) {
  return function () {
    $block.m1a();
    return Unit_instance;
  };
}
function SyncEventLoopCoroutineDispatcher$scheduleResumeAfterDelay$lambda($cancelled) {
  return function (it) {
    $cancelled._v = it;
    return Unit_instance;
  };
}
function SyncEventLoopCoroutineDispatcher$scheduleResumeAfterDelay$lambda_0($cancelled, $continuation) {
  return function () {
    var tmp;
    if (!($cancelled._v == null)) {
      // Inline function 'kotlin.coroutines.resumeWithException' call
      var this_0 = $continuation;
      // Inline function 'kotlin.Companion.failure' call
      var exception = ensureNotNull($cancelled._v);
      var tmp$ret$0 = _Result___init__impl__xyqfz8(createFailure(exception));
      this_0.tc(tmp$ret$0);
      tmp = Unit_instance;
    } else {
      // Inline function 'kotlin.coroutines.resume' call
      var this_1 = $continuation;
      // Inline function 'kotlin.Companion.success' call
      var tmp$ret$2 = _Result___init__impl__xyqfz8(Unit_instance);
      this_1.tc(tmp$ret$2);
      tmp = Unit_instance;
    }
    return Unit_instance;
  };
}
function SyncEventLoopCoroutineDispatcher$invokeOnTimeout$lambda($block) {
  return function () {
    $block.m1a();
    return Unit_instance;
  };
}
var Companion_instance_70;
function Companion_getInstance_77() {
  return Companion_instance_70;
}
var korgwJvmEngine;
function get_SDLPath() {
  _init_properties_SDL_kt__pqu7sn();
  // Inline function 'kotlin.getValue' call
  var this_0 = SDLPath$delegate;
  SDLPath$factory();
  return this_0.u1();
}
var SDLPath$delegate;
var Companion_instance_71;
function Companion_getInstance_78() {
  return Companion_instance_71;
}
var Companion_instance_72;
function Companion_getInstance_79() {
  return Companion_instance_72;
}
function SDLPath$delegate$lambda() {
  _init_properties_SDL_kt__pqu7sn();
  return Companion_getInstance_2().bu() ? '/Library/Frameworks/SDL2.framework/SDL2' : 'SDL2.dll';
}
function SDLPath$factory() {
  return getPropertyCallableRef('SDLPath', 0, KProperty0, function () {
    return get_SDLPath();
  }, null);
}
function SDL_Init$factory() {
  return getPropertyCallableRef('SDL_Init', 1, KProperty1, function (receiver) {
    return receiver.k8q();
  }, null);
}
function SDL_CreateWindow$factory() {
  return getPropertyCallableRef('SDL_CreateWindow', 1, KProperty1, function (receiver) {
    return receiver.l8q();
  }, null);
}
function SDL_SetWindowTitle$factory() {
  return getPropertyCallableRef('SDL_SetWindowTitle', 1, KProperty1, function (receiver) {
    return receiver.m8q();
  }, null);
}
function SDL_SetWindowSize$factory() {
  return getPropertyCallableRef('SDL_SetWindowSize', 1, KProperty1, function (receiver) {
    return receiver.n8q();
  }, null);
}
function SDL_SetWindowPosition$factory() {
  return getPropertyCallableRef('SDL_SetWindowPosition', 1, KProperty1, function (receiver) {
    return receiver.o8q();
  }, null);
}
function SDL_ShowWindow$factory() {
  return getPropertyCallableRef('SDL_ShowWindow', 1, KProperty1, function (receiver) {
    return receiver.p8q();
  }, null);
}
function SDL_RaiseWindow$factory() {
  return getPropertyCallableRef('SDL_RaiseWindow', 1, KProperty1, function (receiver) {
    return receiver.q8q();
  }, null);
}
function SDL_PollEvent$factory() {
  return getPropertyCallableRef('SDL_PollEvent', 1, KProperty1, function (receiver) {
    return receiver.r8q();
  }, null);
}
function SDL_Quit$factory() {
  return getPropertyCallableRef('SDL_Quit', 1, KProperty1, function (receiver) {
    return receiver.s8q();
  }, null);
}
function SDL_GL_CreateContext$factory() {
  return getPropertyCallableRef('SDL_GL_CreateContext', 1, KProperty1, function (receiver) {
    return receiver.t8q();
  }, null);
}
function SDL_GL_DeleteContext$factory() {
  return getPropertyCallableRef('SDL_GL_DeleteContext', 1, KProperty1, function (receiver) {
    return receiver.u8q();
  }, null);
}
function SDL_GL_MakeCurrent$factory() {
  return getPropertyCallableRef('SDL_GL_MakeCurrent', 1, KProperty1, function (receiver) {
    return receiver.v8q();
  }, null);
}
function SDL_GL_SwapWindow$factory() {
  return getPropertyCallableRef('SDL_GL_SwapWindow', 1, KProperty1, function (receiver) {
    return receiver.w8q();
  }, null);
}
function SDL_Init$factory_0() {
  return getPropertyCallableRef('SDL_Init', 1, KProperty1, function (receiver) {
    return receiver.k8q();
  }, null);
}
function SDL_CreateWindow$factory_0() {
  return getPropertyCallableRef('SDL_CreateWindow', 1, KProperty1, function (receiver) {
    return receiver.l8q();
  }, null);
}
function SDL_SetWindowTitle$factory_0() {
  return getPropertyCallableRef('SDL_SetWindowTitle', 1, KProperty1, function (receiver) {
    return receiver.m8q();
  }, null);
}
function SDL_SetWindowSize$factory_0() {
  return getPropertyCallableRef('SDL_SetWindowSize', 1, KProperty1, function (receiver) {
    return receiver.n8q();
  }, null);
}
function SDL_SetWindowPosition$factory_0() {
  return getPropertyCallableRef('SDL_SetWindowPosition', 1, KProperty1, function (receiver) {
    return receiver.o8q();
  }, null);
}
function SDL_ShowWindow$factory_0() {
  return getPropertyCallableRef('SDL_ShowWindow', 1, KProperty1, function (receiver) {
    return receiver.p8q();
  }, null);
}
function SDL_RaiseWindow$factory_0() {
  return getPropertyCallableRef('SDL_RaiseWindow', 1, KProperty1, function (receiver) {
    return receiver.q8q();
  }, null);
}
function SDL_PollEvent$factory_0() {
  return getPropertyCallableRef('SDL_PollEvent', 1, KProperty1, function (receiver) {
    return receiver.r8q();
  }, null);
}
function SDL_Quit$factory_0() {
  return getPropertyCallableRef('SDL_Quit', 1, KProperty1, function (receiver) {
    return receiver.s8q();
  }, null);
}
function SDL_GL_CreateContext$factory_0() {
  return getPropertyCallableRef('SDL_GL_CreateContext', 1, KProperty1, function (receiver) {
    return receiver.t8q();
  }, null);
}
function SDL_GL_DeleteContext$factory_0() {
  return getPropertyCallableRef('SDL_GL_DeleteContext', 1, KProperty1, function (receiver) {
    return receiver.u8q();
  }, null);
}
function SDL_GL_MakeCurrent$factory_0() {
  return getPropertyCallableRef('SDL_GL_MakeCurrent', 1, KProperty1, function (receiver) {
    return receiver.v8q();
  }, null);
}
function SDL_GL_SwapWindow$factory_0() {
  return getPropertyCallableRef('SDL_GL_SwapWindow', 1, KProperty1, function (receiver) {
    return receiver.w8q();
  }, null);
}
function glDrawArraysInstanced$factory() {
  return getPropertyCallableRef('glDrawArraysInstanced', 1, KProperty1, function (receiver) {
    return receiver.j90();
  }, null);
}
function glDrawElementsInstanced$factory() {
  return getPropertyCallableRef('glDrawElementsInstanced', 1, KProperty1, function (receiver) {
    return receiver.k90();
  }, null);
}
function glVertexAttribDivisor$factory() {
  return getPropertyCallableRef('glVertexAttribDivisor', 1, KProperty1, function (receiver) {
    return receiver.l90();
  }, null);
}
function glTexSubImage2D$factory() {
  return getPropertyCallableRef('glTexSubImage2D', 1, KProperty1, function (receiver) {
    return receiver.s90();
  }, null);
}
function glTexImage2D$factory() {
  return getPropertyCallableRef('glTexImage2D', 1, KProperty1, function (receiver) {
    return receiver.s8z();
  }, null);
}
function glTexParameteri$factory() {
  return getPropertyCallableRef('glTexParameteri', 1, KProperty1, function (receiver) {
    return receiver.t8z();
  }, null);
}
function glTexParameterf$factory() {
  return getPropertyCallableRef('glTexParameterf', 1, KProperty1, function (receiver) {
    return receiver.t90();
  }, null);
}
function glTexParameterfv$factory() {
  return getPropertyCallableRef('glTexParameterfv', 1, KProperty1, function (receiver) {
    return receiver.u90();
  }, null);
}
function glTexParameteriv$factory() {
  return getPropertyCallableRef('glTexParameteriv', 1, KProperty1, function (receiver) {
    return receiver.v90();
  }, null);
}
function glStencilOp$factory() {
  return getPropertyCallableRef('glStencilOp', 1, KProperty1, function (receiver) {
    return receiver.q8z();
  }, null);
}
function glStencilMask$factory() {
  return getPropertyCallableRef('glStencilMask', 1, KProperty1, function (receiver) {
    return receiver.o8z();
  }, null);
}
function glReadPixels$factory() {
  return getPropertyCallableRef('glReadPixels', 1, KProperty1, function (receiver) {
    return receiver.w90();
  }, null);
}
function glStencilFunc$factory() {
  return getPropertyCallableRef('glStencilFunc', 1, KProperty1, function (receiver) {
    return receiver.m8z();
  }, null);
}
function glScissor$factory() {
  return getPropertyCallableRef('glScissor', 1, KProperty1, function (receiver) {
    return receiver.k8z();
  }, null);
}
function glPolygonOffset$factory() {
  return getPropertyCallableRef('glPolygonOffset', 1, KProperty1, function (receiver) {
    return receiver.x90();
  }, null);
}
function glPixelStorei$factory() {
  return getPropertyCallableRef('glPixelStorei', 1, KProperty1, function (receiver) {
    return receiver.i8z();
  }, null);
}
function glLineWidth$factory() {
  return getPropertyCallableRef('glLineWidth', 1, KProperty1, function (receiver) {
    return receiver.y90();
  }, null);
}
function glGetTexParameterfv$factory() {
  return getPropertyCallableRef('glGetTexParameterfv', 1, KProperty1, function (receiver) {
    return receiver.z90();
  }, null);
}
function glGetTexParameteriv$factory() {
  return getPropertyCallableRef('glGetTexParameteriv', 1, KProperty1, function (receiver) {
    return receiver.a91();
  }, null);
}
function glGetError$factory() {
  return getPropertyCallableRef('glGetError', 1, KProperty1, function (receiver) {
    return receiver.b8z();
  }, null);
}
function glGetFloatv$factory() {
  return getPropertyCallableRef('glGetFloatv', 1, KProperty1, function (receiver) {
    return receiver.b91();
  }, null);
}
function glGetIntegerv$factory() {
  return getPropertyCallableRef('glGetIntegerv', 1, KProperty1, function (receiver) {
    return receiver.c8z();
  }, null);
}
function glGetBooleanv$factory() {
  return getPropertyCallableRef('glGetBooleanv', 1, KProperty1, function (receiver) {
    return receiver.c91();
  }, null);
}
function glGenTextures$factory() {
  return getPropertyCallableRef('glGenTextures', 1, KProperty1, function (receiver) {
    return receiver.z8y();
  }, null);
}
function glDepthRange$factory() {
  return getPropertyCallableRef('glDepthRange', 1, KProperty1, function (receiver) {
    return receiver.d91();
  }, null);
}
function glDepthRangef$factory() {
  return getPropertyCallableRef('glDepthRangef', 1, KProperty1, function (receiver) {
    return receiver.k8y();
  }, null);
}
function glClearDepth$factory() {
  return getPropertyCallableRef('glClearDepth', 1, KProperty1, function (receiver) {
    return receiver.e91();
  }, null);
}
function glClearDepthf$factory() {
  return getPropertyCallableRef('glClearDepthf', 1, KProperty1, function (receiver) {
    return receiver.v8x();
  }, null);
}
function glDrawArrays$factory() {
  return getPropertyCallableRef('glDrawArrays', 1, KProperty1, function (receiver) {
    return receiver.n8y();
  }, null);
}
function glDrawElements$factory() {
  return getPropertyCallableRef('glDrawElements', 1, KProperty1, function (receiver) {
    return receiver.o8y();
  }, null);
}
function glFrontFace$factory() {
  return getPropertyCallableRef('glFrontFace', 1, KProperty1, function (receiver) {
    return receiver.u8y();
  }, null);
}
function glFinish$factory() {
  return getPropertyCallableRef('glFinish', 1, KProperty1, function (receiver) {
    return receiver.f91();
  }, null);
}
function glFlush$factory() {
  return getPropertyCallableRef('glFlush', 1, KProperty1, function (receiver) {
    return receiver.r8y();
  }, null);
}
function glEnable$factory() {
  return getPropertyCallableRef('glEnable', 1, KProperty1, function (receiver) {
    return receiver.p8y();
  }, null);
}
function glIsEnabled$factory() {
  return getPropertyCallableRef('glIsEnabled', 1, KProperty1, function (receiver) {
    return receiver.g91();
  }, null);
}
function glDisable$factory() {
  return getPropertyCallableRef('glDisable', 1, KProperty1, function (receiver) {
    return receiver.l8y();
  }, null);
}
function glDepthMask$factory() {
  return getPropertyCallableRef('glDepthMask', 1, KProperty1, function (receiver) {
    return receiver.j8y();
  }, null);
}
function glDepthFunc$factory() {
  return getPropertyCallableRef('glDepthFunc', 1, KProperty1, function (receiver) {
    return receiver.i8y();
  }, null);
}
function glDeleteTextures$factory() {
  return getPropertyCallableRef('glDeleteTextures', 1, KProperty1, function (receiver) {
    return receiver.h8y();
  }, null);
}
function glCullFace$factory() {
  return getPropertyCallableRef('glCullFace', 1, KProperty1, function (receiver) {
    return receiver.b8y();
  }, null);
}
function glCopyTexImage2D$factory() {
  return getPropertyCallableRef('glCopyTexImage2D', 1, KProperty1, function (receiver) {
    return receiver.h91();
  }, null);
}
function glCopyTexSubImage2D$factory() {
  return getPropertyCallableRef('glCopyTexSubImage2D', 1, KProperty1, function (receiver) {
    return receiver.i91();
  }, null);
}
function glColorMask$factory() {
  return getPropertyCallableRef('glColorMask', 1, KProperty1, function (receiver) {
    return receiver.x8x();
  }, null);
}
function glClearStencil$factory() {
  return getPropertyCallableRef('glClearStencil', 1, KProperty1, function (receiver) {
    return receiver.w8x();
  }, null);
}
function glClearColor$factory() {
  return getPropertyCallableRef('glClearColor', 1, KProperty1, function (receiver) {
    return receiver.u8x();
  }, null);
}
function glClear$factory() {
  return getPropertyCallableRef('glClear', 1, KProperty1, function (receiver) {
    return receiver.t8x();
  }, null);
}
function glBindTexture$factory() {
  return getPropertyCallableRef('glBindTexture', 1, KProperty1, function (receiver) {
    return receiver.o8x();
  }, null);
}
function glHint$factory() {
  return getPropertyCallableRef('glHint', 1, KProperty1, function (receiver) {
    return receiver.j91();
  }, null);
}
function glViewport$factory() {
  return getPropertyCallableRef('glViewport', 1, KProperty1, function (receiver) {
    return receiver.i90();
  }, null);
}
function glGetString$factory() {
  return getPropertyCallableRef('glGetString', 1, KProperty1, function (receiver) {
    return receiver.g8z();
  }, null);
}
function glGetStringi$factory() {
  return getPropertyCallableRef('glGetStringi', 1, KProperty1, function (receiver) {
    return receiver.k91();
  }, null);
}
function glVertexAttribPointer$factory() {
  return getPropertyCallableRef('glVertexAttribPointer', 1, KProperty1, function (receiver) {
    return receiver.h90();
  }, null);
}
function glVertexAttrib4fv$factory() {
  return getPropertyCallableRef('glVertexAttrib4fv', 1, KProperty1, function (receiver) {
    return receiver.l91();
  }, null);
}
function glActiveTexture$factory() {
  return getPropertyCallableRef('glActiveTexture', 1, KProperty1, function (receiver) {
    return receiver.i8x();
  }, null);
}
function glAttachShader$factory() {
  return getPropertyCallableRef('glAttachShader', 1, KProperty1, function (receiver) {
    return receiver.j8x();
  }, null);
}
function glBindAttribLocation$factory() {
  return getPropertyCallableRef('glBindAttribLocation', 1, KProperty1, function (receiver) {
    return receiver.k8x();
  }, null);
}
function glBindBuffer$factory() {
  return getPropertyCallableRef('glBindBuffer', 1, KProperty1, function (receiver) {
    return receiver.l8x();
  }, null);
}
function glBindFramebuffer$factory() {
  return getPropertyCallableRef('glBindFramebuffer', 1, KProperty1, function (receiver) {
    return receiver.m8x();
  }, null);
}
function glBindRenderbuffer$factory() {
  return getPropertyCallableRef('glBindRenderbuffer', 1, KProperty1, function (receiver) {
    return receiver.n8x();
  }, null);
}
function glBlendColor$factory() {
  return getPropertyCallableRef('glBlendColor', 1, KProperty1, function (receiver) {
    return receiver.m91();
  }, null);
}
function glBlendEquation$factory() {
  return getPropertyCallableRef('glBlendEquation', 1, KProperty1, function (receiver) {
    return receiver.n91();
  }, null);
}
function glBlendEquationSeparate$factory() {
  return getPropertyCallableRef('glBlendEquationSeparate', 1, KProperty1, function (receiver) {
    return receiver.p8x();
  }, null);
}
function glBlendFunc$factory() {
  return getPropertyCallableRef('glBlendFunc', 1, KProperty1, function (receiver) {
    return receiver.o91();
  }, null);
}
function glBlendFuncSeparate$factory() {
  return getPropertyCallableRef('glBlendFuncSeparate', 1, KProperty1, function (receiver) {
    return receiver.q8x();
  }, null);
}
function glBufferData$factory() {
  return getPropertyCallableRef('glBufferData', 1, KProperty1, function (receiver) {
    return receiver.r8x();
  }, null);
}
function glBufferSubData$factory() {
  return getPropertyCallableRef('glBufferSubData', 1, KProperty1, function (receiver) {
    return receiver.s8x();
  }, null);
}
function glCheckFramebufferStatus$factory() {
  return getPropertyCallableRef('glCheckFramebufferStatus', 1, KProperty1, function (receiver) {
    return receiver.p91();
  }, null);
}
function glCompileShader$factory() {
  return getPropertyCallableRef('glCompileShader', 1, KProperty1, function (receiver) {
    return receiver.y8x();
  }, null);
}
function glCompressedTexImage2D$factory() {
  return getPropertyCallableRef('glCompressedTexImage2D', 1, KProperty1, function (receiver) {
    return receiver.q91();
  }, null);
}
function glCompressedTexSubImage2D$factory() {
  return getPropertyCallableRef('glCompressedTexSubImage2D', 1, KProperty1, function (receiver) {
    return receiver.r91();
  }, null);
}
function glCreateProgram$factory() {
  return getPropertyCallableRef('glCreateProgram', 1, KProperty1, function (receiver) {
    return receiver.z8x();
  }, null);
}
function glCreateShader$factory() {
  return getPropertyCallableRef('glCreateShader', 1, KProperty1, function (receiver) {
    return receiver.a8y();
  }, null);
}
function glDeleteBuffers$factory() {
  return getPropertyCallableRef('glDeleteBuffers', 1, KProperty1, function (receiver) {
    return receiver.c8y();
  }, null);
}
function glDeleteFramebuffers$factory() {
  return getPropertyCallableRef('glDeleteFramebuffers', 1, KProperty1, function (receiver) {
    return receiver.d8y();
  }, null);
}
function glDeleteProgram$factory() {
  return getPropertyCallableRef('glDeleteProgram', 1, KProperty1, function (receiver) {
    return receiver.e8y();
  }, null);
}
function glDeleteRenderbuffers$factory() {
  return getPropertyCallableRef('glDeleteRenderbuffers', 1, KProperty1, function (receiver) {
    return receiver.f8y();
  }, null);
}
function glDeleteShader$factory() {
  return getPropertyCallableRef('glDeleteShader', 1, KProperty1, function (receiver) {
    return receiver.g8y();
  }, null);
}
function glDetachShader$factory() {
  return getPropertyCallableRef('glDetachShader', 1, KProperty1, function (receiver) {
    return receiver.s91();
  }, null);
}
function glDisableVertexAttribArray$factory() {
  return getPropertyCallableRef('glDisableVertexAttribArray', 1, KProperty1, function (receiver) {
    return receiver.m8y();
  }, null);
}
function glEnableVertexAttribArray$factory() {
  return getPropertyCallableRef('glEnableVertexAttribArray', 1, KProperty1, function (receiver) {
    return receiver.q8y();
  }, null);
}
function glFramebufferRenderbuffer$factory() {
  return getPropertyCallableRef('glFramebufferRenderbuffer', 1, KProperty1, function (receiver) {
    return receiver.s8y();
  }, null);
}
function glFramebufferTexture2D$factory() {
  return getPropertyCallableRef('glFramebufferTexture2D', 1, KProperty1, function (receiver) {
    return receiver.t8y();
  }, null);
}
function glGenBuffers$factory() {
  return getPropertyCallableRef('glGenBuffers', 1, KProperty1, function (receiver) {
    return receiver.v8y();
  }, null);
}
function glGenerateMipmap$factory() {
  return getPropertyCallableRef('glGenerateMipmap', 1, KProperty1, function (receiver) {
    return receiver.w8y();
  }, null);
}
function glGenFramebuffers$factory() {
  return getPropertyCallableRef('glGenFramebuffers', 1, KProperty1, function (receiver) {
    return receiver.x8y();
  }, null);
}
function glGenRenderbuffers$factory() {
  return getPropertyCallableRef('glGenRenderbuffers', 1, KProperty1, function (receiver) {
    return receiver.y8y();
  }, null);
}
function glGetActiveAttrib$factory() {
  return getPropertyCallableRef('glGetActiveAttrib', 1, KProperty1, function (receiver) {
    return receiver.t91();
  }, null);
}
function glGetActiveUniform$factory() {
  return getPropertyCallableRef('glGetActiveUniform', 1, KProperty1, function (receiver) {
    return receiver.u91();
  }, null);
}
function glGetAttachedShaders$factory() {
  return getPropertyCallableRef('glGetAttachedShaders', 1, KProperty1, function (receiver) {
    return receiver.v91();
  }, null);
}
function glGetAttribLocation$factory() {
  return getPropertyCallableRef('glGetAttribLocation', 1, KProperty1, function (receiver) {
    return receiver.w91();
  }, null);
}
function glGetUniformLocation$factory() {
  return getPropertyCallableRef('glGetUniformLocation', 1, KProperty1, function (receiver) {
    return receiver.a8z();
  }, null);
}
function glGetBufferParameteriv$factory() {
  return getPropertyCallableRef('glGetBufferParameteriv', 1, KProperty1, function (receiver) {
    return receiver.x91();
  }, null);
}
function glGetFramebufferAttachmentParameteriv$factory() {
  return getPropertyCallableRef('glGetFramebufferAttachmentParameteriv', 1, KProperty1, function (receiver) {
    return receiver.y91();
  }, null);
}
function glGetProgramInfoLog$factory() {
  return getPropertyCallableRef('glGetProgramInfoLog', 1, KProperty1, function (receiver) {
    return receiver.z91();
  }, null);
}
function glGetRenderbufferParameteriv$factory() {
  return getPropertyCallableRef('glGetRenderbufferParameteriv', 1, KProperty1, function (receiver) {
    return receiver.a92();
  }, null);
}
function glGetProgramiv$factory() {
  return getPropertyCallableRef('glGetProgramiv', 1, KProperty1, function (receiver) {
    return receiver.d8z();
  }, null);
}
function glGetShaderiv$factory() {
  return getPropertyCallableRef('glGetShaderiv', 1, KProperty1, function (receiver) {
    return receiver.e8z();
  }, null);
}
function glGetShaderInfoLog$factory() {
  return getPropertyCallableRef('glGetShaderInfoLog', 1, KProperty1, function (receiver) {
    return receiver.f8z();
  }, null);
}
function glGetShaderPrecisionFormat$factory() {
  return getPropertyCallableRef('glGetShaderPrecisionFormat', 1, KProperty1, function (receiver) {
    return receiver.b92();
  }, null);
}
function glGetShaderSource$factory() {
  return getPropertyCallableRef('glGetShaderSource', 1, KProperty1, function (receiver) {
    return receiver.c92();
  }, null);
}
function glGetUniformfv$factory() {
  return getPropertyCallableRef('glGetUniformfv', 1, KProperty1, function (receiver) {
    return receiver.d92();
  }, null);
}
function glGetUniformiv$factory() {
  return getPropertyCallableRef('glGetUniformiv', 1, KProperty1, function (receiver) {
    return receiver.e92();
  }, null);
}
function glGetVertexAttribfv$factory() {
  return getPropertyCallableRef('glGetVertexAttribfv', 1, KProperty1, function (receiver) {
    return receiver.f92();
  }, null);
}
function glGetVertexAttribiv$factory() {
  return getPropertyCallableRef('glGetVertexAttribiv', 1, KProperty1, function (receiver) {
    return receiver.g92();
  }, null);
}
function glGetVertexAttribPointerv$factory() {
  return getPropertyCallableRef('glGetVertexAttribPointerv', 1, KProperty1, function (receiver) {
    return receiver.h92();
  }, null);
}
function glIsBuffer$factory() {
  return getPropertyCallableRef('glIsBuffer', 1, KProperty1, function (receiver) {
    return receiver.i92();
  }, null);
}
function glIsFramebuffer$factory() {
  return getPropertyCallableRef('glIsFramebuffer', 1, KProperty1, function (receiver) {
    return receiver.j92();
  }, null);
}
function glIsProgram$factory() {
  return getPropertyCallableRef('glIsProgram', 1, KProperty1, function (receiver) {
    return receiver.k92();
  }, null);
}
function glIsRenderbuffer$factory() {
  return getPropertyCallableRef('glIsRenderbuffer', 1, KProperty1, function (receiver) {
    return receiver.l92();
  }, null);
}
function glIsTexture$factory() {
  return getPropertyCallableRef('glIsTexture', 1, KProperty1, function (receiver) {
    return receiver.m92();
  }, null);
}
function glIsShader$factory() {
  return getPropertyCallableRef('glIsShader', 1, KProperty1, function (receiver) {
    return receiver.n92();
  }, null);
}
function glLinkProgram$factory() {
  return getPropertyCallableRef('glLinkProgram', 1, KProperty1, function (receiver) {
    return receiver.h8z();
  }, null);
}
function glReleaseShaderCompiler$factory() {
  return getPropertyCallableRef('glReleaseShaderCompiler', 1, KProperty1, function (receiver) {
    return receiver.o92();
  }, null);
}
function glRenderbufferStorage$factory() {
  return getPropertyCallableRef('glRenderbufferStorage', 1, KProperty1, function (receiver) {
    return receiver.j8z();
  }, null);
}
function glSampleCoverage$factory() {
  return getPropertyCallableRef('glSampleCoverage', 1, KProperty1, function (receiver) {
    return receiver.p92();
  }, null);
}
function glShaderBinary$factory() {
  return getPropertyCallableRef('glShaderBinary', 1, KProperty1, function (receiver) {
    return receiver.q92();
  }, null);
}
function glShaderSource$factory() {
  return getPropertyCallableRef('glShaderSource', 1, KProperty1, function (receiver) {
    return receiver.l8z();
  }, null);
}
function glStencilFuncSeparate$factory() {
  return getPropertyCallableRef('glStencilFuncSeparate', 1, KProperty1, function (receiver) {
    return receiver.n8z();
  }, null);
}
function glStencilMaskSeparate$factory() {
  return getPropertyCallableRef('glStencilMaskSeparate', 1, KProperty1, function (receiver) {
    return receiver.p8z();
  }, null);
}
function glStencilOpSeparate$factory() {
  return getPropertyCallableRef('glStencilOpSeparate', 1, KProperty1, function (receiver) {
    return receiver.r8z();
  }, null);
}
function glUniform1f$factory() {
  return getPropertyCallableRef('glUniform1f', 1, KProperty1, function (receiver) {
    return receiver.r92();
  }, null);
}
function glUniform2f$factory() {
  return getPropertyCallableRef('glUniform2f', 1, KProperty1, function (receiver) {
    return receiver.s92();
  }, null);
}
function glUniform3f$factory() {
  return getPropertyCallableRef('glUniform3f', 1, KProperty1, function (receiver) {
    return receiver.t92();
  }, null);
}
function glUniform4f$factory() {
  return getPropertyCallableRef('glUniform4f', 1, KProperty1, function (receiver) {
    return receiver.u92();
  }, null);
}
function glUniform1i$factory() {
  return getPropertyCallableRef('glUniform1i', 1, KProperty1, function (receiver) {
    return receiver.v8z();
  }, null);
}
function glUniform2i$factory() {
  return getPropertyCallableRef('glUniform2i', 1, KProperty1, function (receiver) {
    return receiver.v92();
  }, null);
}
function glUniform3i$factory() {
  return getPropertyCallableRef('glUniform3i', 1, KProperty1, function (receiver) {
    return receiver.w92();
  }, null);
}
function glUniform4i$factory() {
  return getPropertyCallableRef('glUniform4i', 1, KProperty1, function (receiver) {
    return receiver.x92();
  }, null);
}
function glUniform1fv$factory() {
  return getPropertyCallableRef('glUniform1fv', 1, KProperty1, function (receiver) {
    return receiver.u8z();
  }, null);
}
function glUniform2fv$factory() {
  return getPropertyCallableRef('glUniform2fv', 1, KProperty1, function (receiver) {
    return receiver.x8z();
  }, null);
}
function glUniform3fv$factory() {
  return getPropertyCallableRef('glUniform3fv', 1, KProperty1, function (receiver) {
    return receiver.z8z();
  }, null);
}
function glUniform4fv$factory() {
  return getPropertyCallableRef('glUniform4fv', 1, KProperty1, function (receiver) {
    return receiver.b90();
  }, null);
}
function glUniform1iv$factory() {
  return getPropertyCallableRef('glUniform1iv', 1, KProperty1, function (receiver) {
    return receiver.w8z();
  }, null);
}
function glUniform2iv$factory() {
  return getPropertyCallableRef('glUniform2iv', 1, KProperty1, function (receiver) {
    return receiver.y8z();
  }, null);
}
function glUniform3iv$factory() {
  return getPropertyCallableRef('glUniform3iv', 1, KProperty1, function (receiver) {
    return receiver.a90();
  }, null);
}
function glUniform4iv$factory() {
  return getPropertyCallableRef('glUniform4iv', 1, KProperty1, function (receiver) {
    return receiver.c90();
  }, null);
}
function glUniformMatrix2fv$factory() {
  return getPropertyCallableRef('glUniformMatrix2fv', 1, KProperty1, function (receiver) {
    return receiver.d90();
  }, null);
}
function glUniformMatrix3fv$factory() {
  return getPropertyCallableRef('glUniformMatrix3fv', 1, KProperty1, function (receiver) {
    return receiver.e90();
  }, null);
}
function glUniformMatrix4fv$factory() {
  return getPropertyCallableRef('glUniformMatrix4fv', 1, KProperty1, function (receiver) {
    return receiver.f90();
  }, null);
}
function glUseProgram$factory() {
  return getPropertyCallableRef('glUseProgram', 1, KProperty1, function (receiver) {
    return receiver.g90();
  }, null);
}
function glValidateProgram$factory() {
  return getPropertyCallableRef('glValidateProgram', 1, KProperty1, function (receiver) {
    return receiver.y92();
  }, null);
}
function glVertexAttrib1f$factory() {
  return getPropertyCallableRef('glVertexAttrib1f', 1, KProperty1, function (receiver) {
    return receiver.z92();
  }, null);
}
function glVertexAttrib2f$factory() {
  return getPropertyCallableRef('glVertexAttrib2f', 1, KProperty1, function (receiver) {
    return receiver.a93();
  }, null);
}
function glVertexAttrib3f$factory() {
  return getPropertyCallableRef('glVertexAttrib3f', 1, KProperty1, function (receiver) {
    return receiver.b93();
  }, null);
}
function glVertexAttrib4f$factory() {
  return getPropertyCallableRef('glVertexAttrib4f', 1, KProperty1, function (receiver) {
    return receiver.c93();
  }, null);
}
function glVertexAttrib1fv$factory() {
  return getPropertyCallableRef('glVertexAttrib1fv', 1, KProperty1, function (receiver) {
    return receiver.d93();
  }, null);
}
function glVertexAttrib2fv$factory() {
  return getPropertyCallableRef('glVertexAttrib2fv', 1, KProperty1, function (receiver) {
    return receiver.e93();
  }, null);
}
function glVertexAttrib3fv$factory() {
  return getPropertyCallableRef('glVertexAttrib3fv', 1, KProperty1, function (receiver) {
    return receiver.f93();
  }, null);
}
function glBindBufferRange$factory() {
  return getPropertyCallableRef('glBindBufferRange', 1, KProperty1, function (receiver) {
    return receiver.m90();
  }, null);
}
function glGetUniformBlockIndex$factory() {
  return getPropertyCallableRef('glGetUniformBlockIndex', 1, KProperty1, function (receiver) {
    return receiver.n90();
  }, null);
}
function glUniformBlockBinding$factory() {
  return getPropertyCallableRef('glUniformBlockBinding', 1, KProperty1, function (receiver) {
    return receiver.o90();
  }, null);
}
function glGenVertexArrays$factory() {
  return getPropertyCallableRef('glGenVertexArrays', 1, KProperty1, function (receiver) {
    return receiver.p90();
  }, null);
}
function glDeleteVertexArrays$factory() {
  return getPropertyCallableRef('glDeleteVertexArrays', 1, KProperty1, function (receiver) {
    return receiver.g93();
  }, null);
}
function glBindVertexArray$factory() {
  return getPropertyCallableRef('glBindVertexArray', 1, KProperty1, function (receiver) {
    return receiver.q90();
  }, null);
}
function glDrawArraysInstanced$factory_0() {
  return getPropertyCallableRef('glDrawArraysInstanced', 1, KProperty1, function (receiver) {
    return receiver.j90();
  }, null);
}
function glDrawElementsInstanced$factory_0() {
  return getPropertyCallableRef('glDrawElementsInstanced', 1, KProperty1, function (receiver) {
    return receiver.k90();
  }, null);
}
function glVertexAttribDivisor$factory_0() {
  return getPropertyCallableRef('glVertexAttribDivisor', 1, KProperty1, function (receiver) {
    return receiver.l90();
  }, null);
}
function glTexSubImage2D$factory_0() {
  return getPropertyCallableRef('glTexSubImage2D', 1, KProperty1, function (receiver) {
    return receiver.s90();
  }, null);
}
function glTexImage2D$factory_0() {
  return getPropertyCallableRef('glTexImage2D', 1, KProperty1, function (receiver) {
    return receiver.s8z();
  }, null);
}
function glTexParameteri$factory_0() {
  return getPropertyCallableRef('glTexParameteri', 1, KProperty1, function (receiver) {
    return receiver.t8z();
  }, null);
}
function glTexParameterf$factory_0() {
  return getPropertyCallableRef('glTexParameterf', 1, KProperty1, function (receiver) {
    return receiver.t90();
  }, null);
}
function glTexParameterfv$factory_0() {
  return getPropertyCallableRef('glTexParameterfv', 1, KProperty1, function (receiver) {
    return receiver.u90();
  }, null);
}
function glTexParameteriv$factory_0() {
  return getPropertyCallableRef('glTexParameteriv', 1, KProperty1, function (receiver) {
    return receiver.v90();
  }, null);
}
function glStencilOp$factory_0() {
  return getPropertyCallableRef('glStencilOp', 1, KProperty1, function (receiver) {
    return receiver.q8z();
  }, null);
}
function glStencilMask$factory_0() {
  return getPropertyCallableRef('glStencilMask', 1, KProperty1, function (receiver) {
    return receiver.o8z();
  }, null);
}
function glReadPixels$factory_0() {
  return getPropertyCallableRef('glReadPixels', 1, KProperty1, function (receiver) {
    return receiver.w90();
  }, null);
}
function glStencilFunc$factory_0() {
  return getPropertyCallableRef('glStencilFunc', 1, KProperty1, function (receiver) {
    return receiver.m8z();
  }, null);
}
function glScissor$factory_0() {
  return getPropertyCallableRef('glScissor', 1, KProperty1, function (receiver) {
    return receiver.k8z();
  }, null);
}
function glPolygonOffset$factory_0() {
  return getPropertyCallableRef('glPolygonOffset', 1, KProperty1, function (receiver) {
    return receiver.x90();
  }, null);
}
function glPixelStorei$factory_0() {
  return getPropertyCallableRef('glPixelStorei', 1, KProperty1, function (receiver) {
    return receiver.i8z();
  }, null);
}
function glLineWidth$factory_0() {
  return getPropertyCallableRef('glLineWidth', 1, KProperty1, function (receiver) {
    return receiver.y90();
  }, null);
}
function glGetTexParameterfv$factory_0() {
  return getPropertyCallableRef('glGetTexParameterfv', 1, KProperty1, function (receiver) {
    return receiver.z90();
  }, null);
}
function glGetTexParameteriv$factory_0() {
  return getPropertyCallableRef('glGetTexParameteriv', 1, KProperty1, function (receiver) {
    return receiver.a91();
  }, null);
}
function glGetError$factory_0() {
  return getPropertyCallableRef('glGetError', 1, KProperty1, function (receiver) {
    return receiver.b8z();
  }, null);
}
function glGetFloatv$factory_0() {
  return getPropertyCallableRef('glGetFloatv', 1, KProperty1, function (receiver) {
    return receiver.b91();
  }, null);
}
function glGetIntegerv$factory_0() {
  return getPropertyCallableRef('glGetIntegerv', 1, KProperty1, function (receiver) {
    return receiver.c8z();
  }, null);
}
function glGetBooleanv$factory_0() {
  return getPropertyCallableRef('glGetBooleanv', 1, KProperty1, function (receiver) {
    return receiver.c91();
  }, null);
}
function glGenTextures$factory_0() {
  return getPropertyCallableRef('glGenTextures', 1, KProperty1, function (receiver) {
    return receiver.z8y();
  }, null);
}
function glDepthRange$factory_0() {
  return getPropertyCallableRef('glDepthRange', 1, KProperty1, function (receiver) {
    return receiver.d91();
  }, null);
}
function glDepthRangef$factory_0() {
  return getPropertyCallableRef('glDepthRangef', 1, KProperty1, function (receiver) {
    return receiver.k8y();
  }, null);
}
function glClearDepth$factory_0() {
  return getPropertyCallableRef('glClearDepth', 1, KProperty1, function (receiver) {
    return receiver.e91();
  }, null);
}
function glClearDepthf$factory_0() {
  return getPropertyCallableRef('glClearDepthf', 1, KProperty1, function (receiver) {
    return receiver.v8x();
  }, null);
}
function glDrawArrays$factory_0() {
  return getPropertyCallableRef('glDrawArrays', 1, KProperty1, function (receiver) {
    return receiver.n8y();
  }, null);
}
function glDrawElements$factory_0() {
  return getPropertyCallableRef('glDrawElements', 1, KProperty1, function (receiver) {
    return receiver.o8y();
  }, null);
}
function glFrontFace$factory_0() {
  return getPropertyCallableRef('glFrontFace', 1, KProperty1, function (receiver) {
    return receiver.u8y();
  }, null);
}
function glFinish$factory_0() {
  return getPropertyCallableRef('glFinish', 1, KProperty1, function (receiver) {
    return receiver.f91();
  }, null);
}
function glFlush$factory_0() {
  return getPropertyCallableRef('glFlush', 1, KProperty1, function (receiver) {
    return receiver.r8y();
  }, null);
}
function glEnable$factory_0() {
  return getPropertyCallableRef('glEnable', 1, KProperty1, function (receiver) {
    return receiver.p8y();
  }, null);
}
function glIsEnabled$factory_0() {
  return getPropertyCallableRef('glIsEnabled', 1, KProperty1, function (receiver) {
    return receiver.g91();
  }, null);
}
function glDisable$factory_0() {
  return getPropertyCallableRef('glDisable', 1, KProperty1, function (receiver) {
    return receiver.l8y();
  }, null);
}
function glDepthMask$factory_0() {
  return getPropertyCallableRef('glDepthMask', 1, KProperty1, function (receiver) {
    return receiver.j8y();
  }, null);
}
function glDepthFunc$factory_0() {
  return getPropertyCallableRef('glDepthFunc', 1, KProperty1, function (receiver) {
    return receiver.i8y();
  }, null);
}
function glDeleteTextures$factory_0() {
  return getPropertyCallableRef('glDeleteTextures', 1, KProperty1, function (receiver) {
    return receiver.h8y();
  }, null);
}
function glCullFace$factory_0() {
  return getPropertyCallableRef('glCullFace', 1, KProperty1, function (receiver) {
    return receiver.b8y();
  }, null);
}
function glCopyTexImage2D$factory_0() {
  return getPropertyCallableRef('glCopyTexImage2D', 1, KProperty1, function (receiver) {
    return receiver.h91();
  }, null);
}
function glCopyTexSubImage2D$factory_0() {
  return getPropertyCallableRef('glCopyTexSubImage2D', 1, KProperty1, function (receiver) {
    return receiver.i91();
  }, null);
}
function glColorMask$factory_0() {
  return getPropertyCallableRef('glColorMask', 1, KProperty1, function (receiver) {
    return receiver.x8x();
  }, null);
}
function glClearStencil$factory_0() {
  return getPropertyCallableRef('glClearStencil', 1, KProperty1, function (receiver) {
    return receiver.w8x();
  }, null);
}
function glClearColor$factory_0() {
  return getPropertyCallableRef('glClearColor', 1, KProperty1, function (receiver) {
    return receiver.u8x();
  }, null);
}
function glClear$factory_0() {
  return getPropertyCallableRef('glClear', 1, KProperty1, function (receiver) {
    return receiver.t8x();
  }, null);
}
function glBindTexture$factory_0() {
  return getPropertyCallableRef('glBindTexture', 1, KProperty1, function (receiver) {
    return receiver.o8x();
  }, null);
}
function glHint$factory_0() {
  return getPropertyCallableRef('glHint', 1, KProperty1, function (receiver) {
    return receiver.j91();
  }, null);
}
function glViewport$factory_0() {
  return getPropertyCallableRef('glViewport', 1, KProperty1, function (receiver) {
    return receiver.i90();
  }, null);
}
function glGetString$factory_0() {
  return getPropertyCallableRef('glGetString', 1, KProperty1, function (receiver) {
    return receiver.g8z();
  }, null);
}
function glGetStringi$factory_0() {
  return getPropertyCallableRef('glGetStringi', 1, KProperty1, function (receiver) {
    return receiver.k91();
  }, null);
}
function glVertexAttribPointer$factory_0() {
  return getPropertyCallableRef('glVertexAttribPointer', 1, KProperty1, function (receiver) {
    return receiver.h90();
  }, null);
}
function glVertexAttrib4fv$factory_0() {
  return getPropertyCallableRef('glVertexAttrib4fv', 1, KProperty1, function (receiver) {
    return receiver.l91();
  }, null);
}
function glActiveTexture$factory_0() {
  return getPropertyCallableRef('glActiveTexture', 1, KProperty1, function (receiver) {
    return receiver.i8x();
  }, null);
}
function glAttachShader$factory_0() {
  return getPropertyCallableRef('glAttachShader', 1, KProperty1, function (receiver) {
    return receiver.j8x();
  }, null);
}
function glBindAttribLocation$factory_0() {
  return getPropertyCallableRef('glBindAttribLocation', 1, KProperty1, function (receiver) {
    return receiver.k8x();
  }, null);
}
function glBindBuffer$factory_0() {
  return getPropertyCallableRef('glBindBuffer', 1, KProperty1, function (receiver) {
    return receiver.l8x();
  }, null);
}
function glBindFramebuffer$factory_0() {
  return getPropertyCallableRef('glBindFramebuffer', 1, KProperty1, function (receiver) {
    return receiver.m8x();
  }, null);
}
function glBindRenderbuffer$factory_0() {
  return getPropertyCallableRef('glBindRenderbuffer', 1, KProperty1, function (receiver) {
    return receiver.n8x();
  }, null);
}
function glBlendColor$factory_0() {
  return getPropertyCallableRef('glBlendColor', 1, KProperty1, function (receiver) {
    return receiver.m91();
  }, null);
}
function glBlendEquation$factory_0() {
  return getPropertyCallableRef('glBlendEquation', 1, KProperty1, function (receiver) {
    return receiver.n91();
  }, null);
}
function glBlendEquationSeparate$factory_0() {
  return getPropertyCallableRef('glBlendEquationSeparate', 1, KProperty1, function (receiver) {
    return receiver.p8x();
  }, null);
}
function glBlendFunc$factory_0() {
  return getPropertyCallableRef('glBlendFunc', 1, KProperty1, function (receiver) {
    return receiver.o91();
  }, null);
}
function glBlendFuncSeparate$factory_0() {
  return getPropertyCallableRef('glBlendFuncSeparate', 1, KProperty1, function (receiver) {
    return receiver.q8x();
  }, null);
}
function glBufferData$factory_0() {
  return getPropertyCallableRef('glBufferData', 1, KProperty1, function (receiver) {
    return receiver.r8x();
  }, null);
}
function glBufferSubData$factory_0() {
  return getPropertyCallableRef('glBufferSubData', 1, KProperty1, function (receiver) {
    return receiver.s8x();
  }, null);
}
function glCheckFramebufferStatus$factory_0() {
  return getPropertyCallableRef('glCheckFramebufferStatus', 1, KProperty1, function (receiver) {
    return receiver.p91();
  }, null);
}
function glCompileShader$factory_0() {
  return getPropertyCallableRef('glCompileShader', 1, KProperty1, function (receiver) {
    return receiver.y8x();
  }, null);
}
function glCompressedTexImage2D$factory_0() {
  return getPropertyCallableRef('glCompressedTexImage2D', 1, KProperty1, function (receiver) {
    return receiver.q91();
  }, null);
}
function glCompressedTexSubImage2D$factory_0() {
  return getPropertyCallableRef('glCompressedTexSubImage2D', 1, KProperty1, function (receiver) {
    return receiver.r91();
  }, null);
}
function glCreateProgram$factory_0() {
  return getPropertyCallableRef('glCreateProgram', 1, KProperty1, function (receiver) {
    return receiver.z8x();
  }, null);
}
function glCreateShader$factory_0() {
  return getPropertyCallableRef('glCreateShader', 1, KProperty1, function (receiver) {
    return receiver.a8y();
  }, null);
}
function glDeleteBuffers$factory_0() {
  return getPropertyCallableRef('glDeleteBuffers', 1, KProperty1, function (receiver) {
    return receiver.c8y();
  }, null);
}
function glDeleteFramebuffers$factory_0() {
  return getPropertyCallableRef('glDeleteFramebuffers', 1, KProperty1, function (receiver) {
    return receiver.d8y();
  }, null);
}
function glDeleteProgram$factory_0() {
  return getPropertyCallableRef('glDeleteProgram', 1, KProperty1, function (receiver) {
    return receiver.e8y();
  }, null);
}
function glDeleteRenderbuffers$factory_0() {
  return getPropertyCallableRef('glDeleteRenderbuffers', 1, KProperty1, function (receiver) {
    return receiver.f8y();
  }, null);
}
function glDeleteShader$factory_0() {
  return getPropertyCallableRef('glDeleteShader', 1, KProperty1, function (receiver) {
    return receiver.g8y();
  }, null);
}
function glDetachShader$factory_0() {
  return getPropertyCallableRef('glDetachShader', 1, KProperty1, function (receiver) {
    return receiver.s91();
  }, null);
}
function glDisableVertexAttribArray$factory_0() {
  return getPropertyCallableRef('glDisableVertexAttribArray', 1, KProperty1, function (receiver) {
    return receiver.m8y();
  }, null);
}
function glEnableVertexAttribArray$factory_0() {
  return getPropertyCallableRef('glEnableVertexAttribArray', 1, KProperty1, function (receiver) {
    return receiver.q8y();
  }, null);
}
function glFramebufferRenderbuffer$factory_0() {
  return getPropertyCallableRef('glFramebufferRenderbuffer', 1, KProperty1, function (receiver) {
    return receiver.s8y();
  }, null);
}
function glFramebufferTexture2D$factory_0() {
  return getPropertyCallableRef('glFramebufferTexture2D', 1, KProperty1, function (receiver) {
    return receiver.t8y();
  }, null);
}
function glGenBuffers$factory_0() {
  return getPropertyCallableRef('glGenBuffers', 1, KProperty1, function (receiver) {
    return receiver.v8y();
  }, null);
}
function glGenerateMipmap$factory_0() {
  return getPropertyCallableRef('glGenerateMipmap', 1, KProperty1, function (receiver) {
    return receiver.w8y();
  }, null);
}
function glGenFramebuffers$factory_0() {
  return getPropertyCallableRef('glGenFramebuffers', 1, KProperty1, function (receiver) {
    return receiver.x8y();
  }, null);
}
function glGenRenderbuffers$factory_0() {
  return getPropertyCallableRef('glGenRenderbuffers', 1, KProperty1, function (receiver) {
    return receiver.y8y();
  }, null);
}
function glGetActiveAttrib$factory_0() {
  return getPropertyCallableRef('glGetActiveAttrib', 1, KProperty1, function (receiver) {
    return receiver.t91();
  }, null);
}
function glGetActiveUniform$factory_0() {
  return getPropertyCallableRef('glGetActiveUniform', 1, KProperty1, function (receiver) {
    return receiver.u91();
  }, null);
}
function glGetAttachedShaders$factory_0() {
  return getPropertyCallableRef('glGetAttachedShaders', 1, KProperty1, function (receiver) {
    return receiver.v91();
  }, null);
}
function glGetAttribLocation$factory_0() {
  return getPropertyCallableRef('glGetAttribLocation', 1, KProperty1, function (receiver) {
    return receiver.w91();
  }, null);
}
function glGetUniformLocation$factory_0() {
  return getPropertyCallableRef('glGetUniformLocation', 1, KProperty1, function (receiver) {
    return receiver.a8z();
  }, null);
}
function glGetBufferParameteriv$factory_0() {
  return getPropertyCallableRef('glGetBufferParameteriv', 1, KProperty1, function (receiver) {
    return receiver.x91();
  }, null);
}
function glGetFramebufferAttachmentParameteriv$factory_0() {
  return getPropertyCallableRef('glGetFramebufferAttachmentParameteriv', 1, KProperty1, function (receiver) {
    return receiver.y91();
  }, null);
}
function glGetProgramInfoLog$factory_0() {
  return getPropertyCallableRef('glGetProgramInfoLog', 1, KProperty1, function (receiver) {
    return receiver.z91();
  }, null);
}
function glGetRenderbufferParameteriv$factory_0() {
  return getPropertyCallableRef('glGetRenderbufferParameteriv', 1, KProperty1, function (receiver) {
    return receiver.a92();
  }, null);
}
function glGetProgramiv$factory_0() {
  return getPropertyCallableRef('glGetProgramiv', 1, KProperty1, function (receiver) {
    return receiver.d8z();
  }, null);
}
function glGetShaderiv$factory_0() {
  return getPropertyCallableRef('glGetShaderiv', 1, KProperty1, function (receiver) {
    return receiver.e8z();
  }, null);
}
function glGetShaderInfoLog$factory_0() {
  return getPropertyCallableRef('glGetShaderInfoLog', 1, KProperty1, function (receiver) {
    return receiver.f8z();
  }, null);
}
function glGetShaderPrecisionFormat$factory_0() {
  return getPropertyCallableRef('glGetShaderPrecisionFormat', 1, KProperty1, function (receiver) {
    return receiver.b92();
  }, null);
}
function glGetShaderSource$factory_0() {
  return getPropertyCallableRef('glGetShaderSource', 1, KProperty1, function (receiver) {
    return receiver.c92();
  }, null);
}
function glGetUniformfv$factory_0() {
  return getPropertyCallableRef('glGetUniformfv', 1, KProperty1, function (receiver) {
    return receiver.d92();
  }, null);
}
function glGetUniformiv$factory_0() {
  return getPropertyCallableRef('glGetUniformiv', 1, KProperty1, function (receiver) {
    return receiver.e92();
  }, null);
}
function glGetVertexAttribfv$factory_0() {
  return getPropertyCallableRef('glGetVertexAttribfv', 1, KProperty1, function (receiver) {
    return receiver.f92();
  }, null);
}
function glGetVertexAttribiv$factory_0() {
  return getPropertyCallableRef('glGetVertexAttribiv', 1, KProperty1, function (receiver) {
    return receiver.g92();
  }, null);
}
function glGetVertexAttribPointerv$factory_0() {
  return getPropertyCallableRef('glGetVertexAttribPointerv', 1, KProperty1, function (receiver) {
    return receiver.h92();
  }, null);
}
function glIsBuffer$factory_0() {
  return getPropertyCallableRef('glIsBuffer', 1, KProperty1, function (receiver) {
    return receiver.i92();
  }, null);
}
function glIsFramebuffer$factory_0() {
  return getPropertyCallableRef('glIsFramebuffer', 1, KProperty1, function (receiver) {
    return receiver.j92();
  }, null);
}
function glIsProgram$factory_0() {
  return getPropertyCallableRef('glIsProgram', 1, KProperty1, function (receiver) {
    return receiver.k92();
  }, null);
}
function glIsRenderbuffer$factory_0() {
  return getPropertyCallableRef('glIsRenderbuffer', 1, KProperty1, function (receiver) {
    return receiver.l92();
  }, null);
}
function glIsTexture$factory_0() {
  return getPropertyCallableRef('glIsTexture', 1, KProperty1, function (receiver) {
    return receiver.m92();
  }, null);
}
function glIsShader$factory_0() {
  return getPropertyCallableRef('glIsShader', 1, KProperty1, function (receiver) {
    return receiver.n92();
  }, null);
}
function glLinkProgram$factory_0() {
  return getPropertyCallableRef('glLinkProgram', 1, KProperty1, function (receiver) {
    return receiver.h8z();
  }, null);
}
function glReleaseShaderCompiler$factory_0() {
  return getPropertyCallableRef('glReleaseShaderCompiler', 1, KProperty1, function (receiver) {
    return receiver.o92();
  }, null);
}
function glRenderbufferStorage$factory_0() {
  return getPropertyCallableRef('glRenderbufferStorage', 1, KProperty1, function (receiver) {
    return receiver.j8z();
  }, null);
}
function glSampleCoverage$factory_0() {
  return getPropertyCallableRef('glSampleCoverage', 1, KProperty1, function (receiver) {
    return receiver.p92();
  }, null);
}
function glShaderBinary$factory_0() {
  return getPropertyCallableRef('glShaderBinary', 1, KProperty1, function (receiver) {
    return receiver.q92();
  }, null);
}
function glShaderSource$factory_0() {
  return getPropertyCallableRef('glShaderSource', 1, KProperty1, function (receiver) {
    return receiver.l8z();
  }, null);
}
function glStencilFuncSeparate$factory_0() {
  return getPropertyCallableRef('glStencilFuncSeparate', 1, KProperty1, function (receiver) {
    return receiver.n8z();
  }, null);
}
function glStencilMaskSeparate$factory_0() {
  return getPropertyCallableRef('glStencilMaskSeparate', 1, KProperty1, function (receiver) {
    return receiver.p8z();
  }, null);
}
function glStencilOpSeparate$factory_0() {
  return getPropertyCallableRef('glStencilOpSeparate', 1, KProperty1, function (receiver) {
    return receiver.r8z();
  }, null);
}
function glUniform1f$factory_0() {
  return getPropertyCallableRef('glUniform1f', 1, KProperty1, function (receiver) {
    return receiver.r92();
  }, null);
}
function glUniform2f$factory_0() {
  return getPropertyCallableRef('glUniform2f', 1, KProperty1, function (receiver) {
    return receiver.s92();
  }, null);
}
function glUniform3f$factory_0() {
  return getPropertyCallableRef('glUniform3f', 1, KProperty1, function (receiver) {
    return receiver.t92();
  }, null);
}
function glUniform4f$factory_0() {
  return getPropertyCallableRef('glUniform4f', 1, KProperty1, function (receiver) {
    return receiver.u92();
  }, null);
}
function glUniform1i$factory_0() {
  return getPropertyCallableRef('glUniform1i', 1, KProperty1, function (receiver) {
    return receiver.v8z();
  }, null);
}
function glUniform2i$factory_0() {
  return getPropertyCallableRef('glUniform2i', 1, KProperty1, function (receiver) {
    return receiver.v92();
  }, null);
}
function glUniform3i$factory_0() {
  return getPropertyCallableRef('glUniform3i', 1, KProperty1, function (receiver) {
    return receiver.w92();
  }, null);
}
function glUniform4i$factory_0() {
  return getPropertyCallableRef('glUniform4i', 1, KProperty1, function (receiver) {
    return receiver.x92();
  }, null);
}
function glUniform1fv$factory_0() {
  return getPropertyCallableRef('glUniform1fv', 1, KProperty1, function (receiver) {
    return receiver.u8z();
  }, null);
}
function glUniform2fv$factory_0() {
  return getPropertyCallableRef('glUniform2fv', 1, KProperty1, function (receiver) {
    return receiver.x8z();
  }, null);
}
function glUniform3fv$factory_0() {
  return getPropertyCallableRef('glUniform3fv', 1, KProperty1, function (receiver) {
    return receiver.z8z();
  }, null);
}
function glUniform4fv$factory_0() {
  return getPropertyCallableRef('glUniform4fv', 1, KProperty1, function (receiver) {
    return receiver.b90();
  }, null);
}
function glUniform1iv$factory_0() {
  return getPropertyCallableRef('glUniform1iv', 1, KProperty1, function (receiver) {
    return receiver.w8z();
  }, null);
}
function glUniform2iv$factory_0() {
  return getPropertyCallableRef('glUniform2iv', 1, KProperty1, function (receiver) {
    return receiver.y8z();
  }, null);
}
function glUniform3iv$factory_0() {
  return getPropertyCallableRef('glUniform3iv', 1, KProperty1, function (receiver) {
    return receiver.a90();
  }, null);
}
function glUniform4iv$factory_0() {
  return getPropertyCallableRef('glUniform4iv', 1, KProperty1, function (receiver) {
    return receiver.c90();
  }, null);
}
function glUniformMatrix2fv$factory_0() {
  return getPropertyCallableRef('glUniformMatrix2fv', 1, KProperty1, function (receiver) {
    return receiver.d90();
  }, null);
}
function glUniformMatrix3fv$factory_0() {
  return getPropertyCallableRef('glUniformMatrix3fv', 1, KProperty1, function (receiver) {
    return receiver.e90();
  }, null);
}
function glUniformMatrix4fv$factory_0() {
  return getPropertyCallableRef('glUniformMatrix4fv', 1, KProperty1, function (receiver) {
    return receiver.f90();
  }, null);
}
function glUseProgram$factory_0() {
  return getPropertyCallableRef('glUseProgram', 1, KProperty1, function (receiver) {
    return receiver.g90();
  }, null);
}
function glValidateProgram$factory_0() {
  return getPropertyCallableRef('glValidateProgram', 1, KProperty1, function (receiver) {
    return receiver.y92();
  }, null);
}
function glVertexAttrib1f$factory_0() {
  return getPropertyCallableRef('glVertexAttrib1f', 1, KProperty1, function (receiver) {
    return receiver.z92();
  }, null);
}
function glVertexAttrib2f$factory_0() {
  return getPropertyCallableRef('glVertexAttrib2f', 1, KProperty1, function (receiver) {
    return receiver.a93();
  }, null);
}
function glVertexAttrib3f$factory_0() {
  return getPropertyCallableRef('glVertexAttrib3f', 1, KProperty1, function (receiver) {
    return receiver.b93();
  }, null);
}
function glVertexAttrib4f$factory_0() {
  return getPropertyCallableRef('glVertexAttrib4f', 1, KProperty1, function (receiver) {
    return receiver.c93();
  }, null);
}
function glVertexAttrib1fv$factory_0() {
  return getPropertyCallableRef('glVertexAttrib1fv', 1, KProperty1, function (receiver) {
    return receiver.d93();
  }, null);
}
function glVertexAttrib2fv$factory_0() {
  return getPropertyCallableRef('glVertexAttrib2fv', 1, KProperty1, function (receiver) {
    return receiver.e93();
  }, null);
}
function glVertexAttrib3fv$factory_0() {
  return getPropertyCallableRef('glVertexAttrib3fv', 1, KProperty1, function (receiver) {
    return receiver.f93();
  }, null);
}
function glBindBufferRange$factory_0() {
  return getPropertyCallableRef('glBindBufferRange', 1, KProperty1, function (receiver) {
    return receiver.m90();
  }, null);
}
function glGetUniformBlockIndex$factory_0() {
  return getPropertyCallableRef('glGetUniformBlockIndex', 1, KProperty1, function (receiver) {
    return receiver.n90();
  }, null);
}
function glUniformBlockBinding$factory_0() {
  return getPropertyCallableRef('glUniformBlockBinding', 1, KProperty1, function (receiver) {
    return receiver.o90();
  }, null);
}
function glGenVertexArrays$factory_0() {
  return getPropertyCallableRef('glGenVertexArrays', 1, KProperty1, function (receiver) {
    return receiver.p90();
  }, null);
}
function glDeleteVertexArrays$factory_0() {
  return getPropertyCallableRef('glDeleteVertexArrays', 1, KProperty1, function (receiver) {
    return receiver.g93();
  }, null);
}
function glBindVertexArray$factory_0() {
  return getPropertyCallableRef('glBindVertexArray', 1, KProperty1, function (receiver) {
    return receiver.q90();
  }, null);
}
var properties_initialized_SDL_kt_s4ko39;
function _init_properties_SDL_kt__pqu7sn() {
  if (!properties_initialized_SDL_kt_s4ko39) {
    properties_initialized_SDL_kt_s4ko39 = true;
    SDLPath$delegate = lazy(SDLPath$delegate$lambda);
  }
}
var AGOpenglFactory_instance;
function AGOpenglFactory_getInstance() {
  return AGOpenglFactory_instance;
}
function get_korgwCanvasQuery() {
  _init_properties_GlExt_kt__oxmdm();
  // Inline function 'kotlin.getValue' call
  var this_0 = korgwCanvasQuery$delegate;
  korgwCanvasQuery$factory();
  return this_0.u1();
}
var korgwCanvasQuery$delegate;
function jsObject(pairs) {
  _init_properties_GlExt_kt__oxmdm();
  var out = jsEmptyObject();
  var inductionVariable = 0;
  var last = pairs.length;
  while (inductionVariable < last) {
    var _destruct__k2r9zo = pairs[inductionVariable];
    inductionVariable = inductionVariable + 1 | 0;
    var k = _destruct__k2r9zo.jl();
    var v = _destruct__k2r9zo.kl();
    if (!(v == null)) {
      out[k] = v;
    }
  }
  return out;
}
function jsEmptyObject() {
  _init_properties_GlExt_kt__oxmdm();
  return {};
}
function AGDefaultCanvas() {
  _init_properties_GlExt_kt__oxmdm();
  var tmp0_safe_receiver = get_korgwCanvasQuery();
  var tmp;
  if (tmp0_safe_receiver == null) {
    tmp = null;
  } else {
    // Inline function 'kotlin.let' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.graphics.gl.AGDefaultCanvas.<anonymous>' call
    var tmp_0 = document.querySelector(tmp0_safe_receiver);
    tmp = tmp_0 instanceof HTMLCanvasElement ? tmp_0 : THROW_CCE();
  }
  var tmp1_elvis_lhs = tmp;
  var tmp_1;
  if (tmp1_elvis_lhs == null) {
    var tmp_2 = document.createElement('canvas');
    tmp_1 = tmp_2 instanceof HTMLCanvasElement ? tmp_2 : THROW_CCE();
  } else {
    tmp_1 = tmp1_elvis_lhs;
  }
  return tmp_1;
}
function AGWebgl(config, canvas) {
  canvas = canvas === VOID ? AGDefaultCanvas() : canvas;
  _init_properties_GlExt_kt__oxmdm();
  // Inline function 'kotlin.also' call
  var this_0 = AGOpengl.f79(new KmlGlJsCanvas(canvas, jsObject([to('premultipliedAlpha', false), to('alpha', false), to('stencil', true), to('antialias', config.z6w_1)])));
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'korlibs.graphics.gl.AGWebgl.<anonymous>' call
  // Inline function 'kotlin.js.asDynamic' call
  window.ag = this_0;
  canvas.addEventListener('webglcontextlost', AGWebgl$lambda, false);
  canvas.addEventListener('webglcontextrestored', AGWebgl$lambda_0(this_0), false);
  return this_0;
}
function get_isCanvasCreatedAndHandled() {
  _init_properties_GlExt_kt__oxmdm();
  return get_korgwCanvasQuery() == null;
}
function korgwCanvasQuery$delegate$lambda() {
  _init_properties_GlExt_kt__oxmdm();
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  return window.korgwCanvasQuery;
}
function AGWebgl$lambda(e) {
  _init_properties_GlExt_kt__oxmdm();
  e.preventDefault();
  return Unit_instance;
}
function AGWebgl$lambda_0($ag) {
  return function (e) {
    $ag.i6j();
    return Unit_instance;
  };
}
function korgwCanvasQuery$factory() {
  return getPropertyCallableRef('korgwCanvasQuery', 0, KProperty0, function () {
    return get_korgwCanvasQuery();
  }, null);
}
var properties_initialized_GlExt_kt_6pmiss;
function _init_properties_GlExt_kt__oxmdm() {
  if (!properties_initialized_GlExt_kt_6pmiss) {
    properties_initialized_GlExt_kt_6pmiss = true;
    korgwCanvasQuery$delegate = lazy(korgwCanvasQuery$delegate$lambda);
  }
}
function alloc(_this__u8e3s4, $this) {
  if (_this__u8e3s4 === null)
    return 0;
  // Inline function 'kotlin.js.asDynamic' call
  if (_this__u8e3s4.id === undefined) {
    if ($this.v96_1.g1()) {
      // Inline function 'kotlin.error' call
      var message = 'KmlGlJsCanvas.freeList is empty. (Probably allocating lots of OpenGL objects without releasing them)';
      throw IllegalStateException.z4(toString(message));
    }
    var index = $this.v96_1.p3($this.v96_1.e1() - 1 | 0);
    $this.u96_1[index] = _this__u8e3s4;
    // Inline function 'kotlin.js.asDynamic' call
    _this__u8e3s4.id = index;
  }
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  return _this__u8e3s4.id;
}
function get_2(_this__u8e3s4, $this) {
  var tmp;
  if (!(_this__u8e3s4 === 0)) {
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp = $this.u96_1[_this__u8e3s4];
  } else {
    tmp = null;
  }
  return tmp;
}
function free(_this__u8e3s4, $this) {
  var tmp;
  if (!(_this__u8e3s4 === 0)) {
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var out = $this.u96_1[_this__u8e3s4];
    // Inline function 'kotlin.collections.plusAssign' call
    $this.v96_1.h(_this__u8e3s4);
    $this.u96_1[_this__u8e3s4] = null;
    tmp = out;
  } else {
    tmp = null;
  }
  return tmp;
}
function KmlGlJsCanvas$extensions$delegate$lambda(this$0) {
  return function () {
    var tmp0_elvis_lhs = this$0.t96_1.getSupportedExtensions();
    var tmp;
    if (tmp0_elvis_lhs == null) {
      // Inline function 'kotlin.arrayOf' call
      // Inline function 'kotlin.js.unsafeCast' call
      // Inline function 'kotlin.js.asDynamic' call
      tmp = [];
    } else {
      tmp = tmp0_elvis_lhs;
    }
    return toSet_0(tmp);
  };
}
function KmlGlJsCanvas$isFloatTextureSupported$delegate$lambda(this$0) {
  return function () {
    return this$0.t96_1.getExtension('OES_texture_float_linear') != null || this$0.t96_1.getExtension('OES_texture_float') != null || this$0.s96_1 >= 2;
  };
}
function extensions$factory() {
  return getPropertyCallableRef('extensions', 1, KProperty1, function (receiver) {
    return receiver.x81();
  }, null);
}
function get_KorgeReloadInternal() {
  _init_properties_KorgeReload_getReloadedClass_kt__lithzw();
  return KorgeReloadInternal;
}
var KorgeReloadInternal;
var properties_initialized_KorgeReload_getReloadedClass_kt_tswp16;
function _init_properties_KorgeReload_getReloadedClass_kt__lithzw() {
  if (!properties_initialized_KorgeReload_getReloadedClass_kt_tswp16) {
    properties_initialized_KorgeReload_getReloadedClass_kt_tswp16 = true;
    KorgeReloadInternal = new KorgeReloadInternal$1();
  }
}
function CreateDefaultGameWindow(config) {
  return Companion_getInstance_2().nu() ? DenoJsGameWindow.p9f(VOID, config) : Companion_getInstance_2().mu() ? NodeJsGameWindow.u9c() : BrowserCanvasJsGameWindow.i9a();
}
function *_generator_invoke__zhh2q8_0($this, $completion) {
  var tmp0_safe_receiver = $this.c9i_1.f9a_1;
  if (tmp0_safe_receiver == null)
    null;
  else {
    var tmp = cancelAndJoin(tmp0_safe_receiver, $completion);
    if (tmp === get_COROUTINE_SUSPENDED())
      tmp = yield tmp;
  }
  window.close();
  return Unit_instance;
}
function *_generator_invoke__zhh2q8_1($this, $completion) {
  var tmp = $this.d9i_1($this.e9i_1, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  return Unit_instance;
}
function onResized($this) {
  $this.w99_1 = null;
  if (get_isCanvasCreatedAndHandled()) {
    var scale = $this.k8e().k8l(window.innerWidth, window.innerHeight, $this.c8f());
    var canvasWidth = numberToInt(window.innerWidth * scale);
    var canvasHeight = numberToInt(window.innerHeight * scale);
    $this.t99_1.width = canvasWidth;
    $this.t99_1.height = canvasHeight;
    $this.t99_1.style.position = 'absolute';
    $this.t99_1.style.left = '0';
    $this.t99_1.style.right = '0';
    $this.t99_1.style.width = '' + window.innerWidth + 'px';
    $this.t99_1.style.height = '' + window.innerHeight + 'px';
    $this.b9a_1 = scale;
  } else {
    $this.b9a_1 = $this.t99_1.width / $this.t99_1.clientWidth;
  }
  $this.p8n(0, 0, $this.t99_1.width, $this.t99_1.height);
}
function keyEvent($this, me) {
  var tmp;
  switch (me.key) {
    case '0':
      tmp = Key_N0_getInstance();
      break;
    case '1':
      tmp = Key_N1_getInstance();
      break;
    case '2':
      tmp = Key_N2_getInstance();
      break;
    case '3':
      tmp = Key_N3_getInstance();
      break;
    case '4':
      tmp = Key_N4_getInstance();
      break;
    case '5':
      tmp = Key_N5_getInstance();
      break;
    case '6':
      tmp = Key_N6_getInstance();
      break;
    case '7':
      tmp = Key_N7_getInstance();
      break;
    case '8':
      tmp = Key_N8_getInstance();
      break;
    case '9':
      tmp = Key_N9_getInstance();
      break;
    case 'a':
      tmp = Key_A_getInstance();
      break;
    case 'b':
      tmp = Key_B_getInstance();
      break;
    case 'c':
      tmp = Key_C_getInstance();
      break;
    case 'd':
      tmp = Key_D_getInstance();
      break;
    case 'e':
      tmp = Key_E_getInstance();
      break;
    case 'f':
      tmp = Key_F_getInstance();
      break;
    case 'g':
      tmp = Key_G_getInstance();
      break;
    case 'h':
      tmp = Key_H_getInstance();
      break;
    case 'i':
      tmp = Key_I_getInstance();
      break;
    case 'j':
      tmp = Key_J_getInstance();
      break;
    case 'k':
      tmp = Key_K_getInstance();
      break;
    case 'l':
      tmp = Key_L_getInstance();
      break;
    case 'm':
      tmp = Key_M_getInstance();
      break;
    case 'n':
      tmp = Key_N_getInstance();
      break;
    case 'o':
      tmp = Key_O_getInstance();
      break;
    case 'p':
      tmp = Key_P_getInstance();
      break;
    case 'q':
      tmp = Key_Q_getInstance();
      break;
    case 'r':
      tmp = Key_R_getInstance();
      break;
    case 's':
      tmp = Key_S_getInstance();
      break;
    case 't':
      tmp = Key_T_getInstance();
      break;
    case 'u':
      tmp = Key_U_getInstance();
      break;
    case 'v':
      tmp = Key_V_getInstance();
      break;
    case 'w':
      tmp = Key_W_getInstance();
      break;
    case 'x':
      tmp = Key_X_getInstance();
      break;
    case 'y':
      tmp = Key_Y_getInstance();
      break;
    case 'z':
      tmp = Key_Z_getInstance();
      break;
    case 'F1':
      tmp = Key_F1_getInstance();
      break;
    case 'F2':
      tmp = Key_F2_getInstance();
      break;
    case 'F3':
      tmp = Key_F3_getInstance();
      break;
    case 'F4':
      tmp = Key_F4_getInstance();
      break;
    case 'F5':
      tmp = Key_F5_getInstance();
      break;
    case 'F6':
      tmp = Key_F6_getInstance();
      break;
    case 'F7':
      tmp = Key_F7_getInstance();
      break;
    case 'F8':
      tmp = Key_F8_getInstance();
      break;
    case 'F9':
      tmp = Key_F9_getInstance();
      break;
    case 'F10':
      tmp = Key_F10_getInstance();
      break;
    case 'F11':
      tmp = Key_F11_getInstance();
      break;
    case 'F12':
      tmp = Key_F12_getInstance();
      break;
    case 'F13':
      tmp = Key_F13_getInstance();
      break;
    case 'F14':
      tmp = Key_F14_getInstance();
      break;
    case 'F15':
      tmp = Key_F15_getInstance();
      break;
    case 'F16':
      tmp = Key_F16_getInstance();
      break;
    case 'F17':
      tmp = Key_F17_getInstance();
      break;
    case 'F18':
      tmp = Key_F18_getInstance();
      break;
    case 'F19':
      tmp = Key_F19_getInstance();
      break;
    case 'F20':
      tmp = Key_F20_getInstance();
      break;
    case 'F21':
      tmp = Key_F21_getInstance();
      break;
    case 'F22':
      tmp = Key_F22_getInstance();
      break;
    case 'F23':
      tmp = Key_F23_getInstance();
      break;
    case 'F24':
      tmp = Key_F24_getInstance();
      break;
    case 'F25':
      tmp = Key_F25_getInstance();
      break;
    case '+':
      tmp = Key_PLUS_getInstance();
      break;
    case '-':
      tmp = Key_MINUS_getInstance();
      break;
    case "'":
      tmp = Key_APOSTROPHE_getInstance();
      break;
    case '"':
      tmp = Key_QUOTE_getInstance();
      break;
    default:
      var tmp_0;
      switch (me.code) {
        case 'MetaLeft':
          tmp_0 = Companion_getInstance_35().q6h();
          break;
        case 'MetaRight':
          tmp_0 = Companion_getInstance_35().r6h();
          break;
        case 'ShiftLeft':
          tmp_0 = Companion_getInstance_35().m6h();
          break;
        case 'ShiftRight':
          tmp_0 = Companion_getInstance_35().n6h();
          break;
        case 'ControlLeft':
          tmp_0 = Companion_getInstance_35().k6h();
          break;
        case 'ControlRight':
          tmp_0 = Companion_getInstance_35().l6h();
          break;
        case 'AltLeft':
          tmp_0 = Companion_getInstance_35().o6h();
          break;
        case 'AltRight':
          tmp_0 = Companion_getInstance_35().p6h();
          break;
        case 'Space':
          tmp_0 = Key_SPACE_getInstance();
          break;
        case 'ArrowUp':
          tmp_0 = Key_UP_getInstance();
          break;
        case 'ArrowDown':
          tmp_0 = Key_DOWN_getInstance();
          break;
        case 'ArrowLeft':
          tmp_0 = Key_LEFT_getInstance();
          break;
        case 'ArrowRight':
          tmp_0 = Key_RIGHT_getInstance();
          break;
        case 'PageUp':
          tmp_0 = Key_PAGE_UP_getInstance();
          break;
        case 'PageDown':
          tmp_0 = Key_PAGE_DOWN_getInstance();
          break;
        case 'Home':
          tmp_0 = Key_HOME_getInstance();
          break;
        case 'End':
          tmp_0 = Key_END_getInstance();
          break;
        case 'Enter':
          tmp_0 = Key_ENTER_getInstance();
          break;
        case 'Escape':
          tmp_0 = Key_ESCAPE_getInstance();
          break;
        case 'Backspace':
          tmp_0 = Key_BACKSPACE_getInstance();
          break;
        case 'Delete':
          tmp_0 = Key_DELETE_getInstance();
          break;
        case 'Insert':
          tmp_0 = Key_INSERT_getInstance();
          break;
        case 'Period':
          tmp_0 = Key_PERIOD_getInstance();
          break;
        case 'Comma':
          tmp_0 = Key_COMMA_getInstance();
          break;
        case 'Semicolon':
          tmp_0 = Key_SEMICOLON_getInstance();
          break;
        case 'Slash':
          tmp_0 = Key_SLASH_getInstance();
          break;
        case 'Tab':
          tmp_0 = Key_TAB_getInstance();
          break;
        default:
          // Inline function 'kotlin.js.asDynamic' call

          if (window.korgwShowUnsupportedKeys) {
            // Inline function 'korlibs.logger.Logger.info' call
            var this_0 = CoroutineKey_getInstance().s8i_1;
            var level = Level_INFO_getInstance();
            var tmp_1;
            if (this_0.a2u(level)) {
              // Inline function 'korlibs.render.BrowserCanvasJsGameWindow.keyEvent.<anonymous>' call
              var tmp$ret$1 = 'Unsupported key key=' + me.key + ', code=' + me.code;
              this_0.b2u(level, tmp$ret$1);
              tmp_1 = Unit_instance;
            }
          }

          tmp_0 = Key_UNKNOWN_getInstance();
          break;
      }

      tmp = tmp_0;
      break;
  }
  var key = tmp;
  $this.g6a(invoke_0($this.o8j_1, BrowserCanvasJsGameWindow$keyEvent$lambda(me, key)));
  if (key.equals(Key_TAB_getInstance()) || key.u6h()) {
    me.preventDefault();
  }
}
function touchEvent($this, e, type) {
  var canvasBounds = $this.t99_1.getBoundingClientRect();
  // Inline function 'kotlin.also' call
  // Inline function 'korlibs.event.TouchBuilder.frame' call
  var this_0 = $this.c9a_1;
  this_0.f6f_1 = Mode_JS_getInstance();
  this_0.g6f(type, false);
  try {
    // Inline function 'korlibs.render.BrowserCanvasJsGameWindow.touchEvent.<anonymous>' call
    var inductionVariable = 0;
    var last = e.touches.length;
    if (inductionVariable < last)
      $l$loop: do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var tmp0_elvis_lhs = e.touches.item(n);
        var tmp;
        if (tmp0_elvis_lhs == null) {
          continue $l$loop;
        } else {
          tmp = tmp0_elvis_lhs;
        }
        var touch = tmp;
        var touchId = touch.identifier;
        // Inline function 'korlibs.render.BrowserCanvasJsGameWindow.transformEventX' call
        var tmp_0 = (touch.clientX - canvasBounds.left) * $this.b9a_1;
        // Inline function 'korlibs.render.BrowserCanvasJsGameWindow.transformEventY' call
        var tmp$ret$1 = (touch.clientY - canvasBounds.top) * $this.b9a_1;
        var tmp_1 = Vector2D.q2a(tmp_0, tmp$ret$1);
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        var tmp1_elvis_lhs = touch.force;
        this_0.j6f(touchId, tmp_1, tmp1_elvis_lhs == null ? 1.0 : tmp1_elvis_lhs, Kind_FINGER_getInstance());
      }
       while (inductionVariable < last);
  }finally {
    this_0.h6f();
  }
  var this_1 = this_0.e6f_1;
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'korlibs.render.BrowserCanvasJsGameWindow.touchEvent.<anonymous>' call
  $this.g6a(this_1);
}
function mouseEvent($this, e, type, pressingType) {
  var canvasBounds = $this.t99_1.getBoundingClientRect();
  // Inline function 'korlibs.render.BrowserCanvasJsGameWindow.transformEventX' call
  var tmp$ret$0 = (e.clientX - canvasBounds.left) * $this.b9a_1;
  var tx = numberToInt(tmp$ret$0);
  // Inline function 'korlibs.render.BrowserCanvasJsGameWindow.transformEventY' call
  var tmp$ret$1 = (e.clientY - canvasBounds.top) * $this.b9a_1;
  var ty = numberToInt(tmp$ret$1);
  invoke_0($this.p8j_1, BrowserCanvasJsGameWindow$mouseEvent$lambda(e, pressingType, type, tx, ty));
  if (!$this.f9i() || type.equals(Type_SCROLL_getInstance())) {
    $this.g6a($this.p8j_1);
  }
}
function mouseEvent$default($this, e, type, pressingType, $super) {
  pressingType = pressingType === VOID ? type : pressingType;
  return mouseEvent($this, e, type, pressingType);
}
function *_generator_loop__qll5p8_0($this, entry, $completion) {
  var tmp = $this;
  var tmp_0 = $this.l8l($completion);
  if (tmp_0 === get_COROUTINE_SUSPENDED())
    tmp_0 = yield tmp_0;
  tmp.f9a_1 = launchImmediately(tmp_0, BrowserCanvasJsGameWindow$loop$slambda_0(entry, $this));
  _get_jsFrame__gugpar($this)(0.0);
  return Unit_instance;
}
function _get_jsFrame__gugpar($this) {
  var tmp = $this.g9a_1;
  if (!(tmp == null))
    return tmp;
  else {
    throwUninitializedPropertyAccessException('jsFrame');
  }
}
function ensureSoftKeyboardInput($this) {
  if ($this.h9a_1 == null) {
    var tmp = $this;
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.h9a_1 = document.createElement('input');
    var tmp0_safe_receiver = $this.h9a_1;
    if (tmp0_safe_receiver == null)
      null;
    else {
      tmp0_safe_receiver.id = 'softKeyboardInput';
    }
    var tmp1_safe_receiver = $this.h9a_1;
    if (tmp1_safe_receiver == null)
      null;
    else {
      tmp1_safe_receiver.type = 'input';
    }
    var tmp2_safe_receiver = $this.h9a_1;
    var tmp3_safe_receiver = tmp2_safe_receiver == null ? null : tmp2_safe_receiver.style;
    if (tmp3_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      // Inline function 'kotlin.contracts.contract' call
      tmp3_safe_receiver.zIndex = '10000000';
      tmp3_safe_receiver.position = 'absolute';
      tmp3_safe_receiver.top = '0';
      tmp3_safe_receiver.left = '0';
      tmp3_safe_receiver.width = '200px';
      tmp3_safe_receiver.height = '24px';
      tmp3_safe_receiver.background = 'transparent';
    }
  }
}
function _get_navigatorClipboard__ni2gks($this) {
  // Inline function 'kotlin.js.unsafeCast' call
  return navigator.clipboard;
}
function *_generator_clipboardRead__wie2ug($this, $completion) {
  var tmp = await_0(_get_navigatorClipboard__ni2gks($this).readText(), $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  var text = tmp;
  var tmp_0;
  // Inline function 'kotlin.text.isNotEmpty' call
  if (charSequenceLength(text) > 0) {
    tmp_0 = new TextClipboardData(text);
  } else {
    tmp_0 = null;
  }
  return tmp_0;
}
function BrowserCanvasJsGameWindow$keyEvent$lambda($me, $key) {
  return function ($this$keyEvent) {
    var tmp = $this$keyEvent;
    var tmp_0;
    switch ($me.type) {
      case 'keydown':
        tmp_0 = Type_DOWN_getInstance();
        break;
      case 'keyup':
        tmp_0 = Type_UP_getInstance();
        break;
      case 'keypress':
        tmp_0 = Type_TYPE_getInstance();
        break;
      default:
        var message = 'Unsupported event type ' + $me.type;
        throw IllegalStateException.z4(toString(message));
    }
    tmp.n6b_1 = tmp_0;
    $this$keyEvent.o6b_1 = 0;
    $this$keyEvent.q6b_1 = $me.keyCode;
    $this$keyEvent.p6b_1 = $key;
    $this$keyEvent.s6b_1 = $me.shiftKey;
    $this$keyEvent.t6b_1 = $me.ctrlKey;
    $this$keyEvent.u6b_1 = $me.altKey;
    $this$keyEvent.v6b_1 = $me.metaKey;
    $this$keyEvent.r6b_1 = numberToChar($me.charCode);
    return Unit_instance;
  };
}
function BrowserCanvasJsGameWindow$mouseEvent$lambda($e, $pressingType, $type, $tx, $ty) {
  return function ($this$mouseEvent) {
    $this$mouseEvent.g6c_1 = !($e.buttons === 0) ? $pressingType : $type;
    $this$mouseEvent.t6c_1 = false;
    $this$mouseEvent.h6c_1 = 0;
    $this$mouseEvent.i6c_1 = $tx;
    $this$mouseEvent.j6c_1 = $ty;
    $this$mouseEvent.k6c_1 = Companion_getInstance_36().d1($e.button);
    $this$mouseEvent.l6c_1 = $e.buttons;
    $this$mouseEvent.p6c_1 = $e.shiftKey;
    $this$mouseEvent.q6c_1 = $e.ctrlKey;
    $this$mouseEvent.r6c_1 = $e.altKey;
    $this$mouseEvent.s6c_1 = $e.metaKey;
    var tmp;
    if ($type.equals(Type_SCROLL_getInstance())) {
      // Inline function 'kotlin.js.unsafeCast' call
      // Inline function 'kotlin.js.asDynamic' call
      var we = $e;
      var tmp0_subject = we.deltaMode;
      var mode = tmp0_subject === WheelEvent.DOM_DELTA_PIXEL ? ScrollDeltaMode_PIXEL_getInstance() : tmp0_subject === WheelEvent.DOM_DELTA_LINE ? ScrollDeltaMode_LINE_getInstance() : tmp0_subject === WheelEvent.DOM_DELTA_PAGE ? ScrollDeltaMode_PAGE_getInstance() : ScrollDeltaMode_LINE_getInstance();
      var sensitivity = 0.05;
      $this$mouseEvent.z6c(mode, we.deltaX * sensitivity, we.deltaY * sensitivity, we.deltaZ * sensitivity);
      tmp = Unit_instance;
    }
    return Unit_instance;
  };
}
function BrowserCanvasJsGameWindow$close$slambda_0(this$0) {
  var i = new BrowserCanvasJsGameWindow$close$slambda(this$0);
  var l = function ($completion) {
    return i.ud($completion);
  };
  l.$arity = 0;
  return l;
}
function BrowserCanvasJsGameWindow$loop$slambda_0($entry, this$0) {
  var i = new BrowserCanvasJsGameWindow$loop$slambda($entry, this$0);
  var l = function ($completion) {
    return i.ud($completion);
  };
  l.$arity = 0;
  return l;
}
function BrowserCanvasJsGameWindow$lambda(this$0) {
  return function (it) {
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    mouseEvent$default(this$0, it, Type_SCROLL_getInstance());
    return Unit_instance;
  };
}
function BrowserCanvasJsGameWindow$lambda_0(this$0) {
  return function (it) {
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    mouseEvent$default(this$0, it, Type_ENTER_getInstance());
    return Unit_instance;
  };
}
function BrowserCanvasJsGameWindow$lambda_1(this$0) {
  return function (it) {
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    mouseEvent$default(this$0, it, Type_EXIT_getInstance());
    return Unit_instance;
  };
}
function BrowserCanvasJsGameWindow$lambda_2(this$0) {
  return function (it) {
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    mouseEvent(this$0, it, Type_MOVE_getInstance(), Type_DRAG_getInstance());
    return Unit_instance;
  };
}
function BrowserCanvasJsGameWindow$lambda_3(this$0) {
  return function (it) {
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    mouseEvent(this$0, it, Type_MOVE_getInstance(), Type_DRAG_getInstance());
    return Unit_instance;
  };
}
function BrowserCanvasJsGameWindow$lambda_4(this$0) {
  return function (it) {
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    mouseEvent$default(this$0, it, Type_EXIT_getInstance());
    return Unit_instance;
  };
}
function BrowserCanvasJsGameWindow$lambda_5(this$0) {
  return function (it) {
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    mouseEvent$default(this$0, it, Type_UP_getInstance_0());
    return Unit_instance;
  };
}
function BrowserCanvasJsGameWindow$lambda_6(this$0) {
  return function (it) {
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    mouseEvent$default(this$0, it, Type_DOWN_getInstance_0());
    return Unit_instance;
  };
}
function BrowserCanvasJsGameWindow$lambda_7(this$0) {
  return function (it) {
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    mouseEvent$default(this$0, it, Type_CLICK_getInstance());
    return Unit_instance;
  };
}
function BrowserCanvasJsGameWindow$lambda_8(this$0) {
  return function (it) {
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    touchEvent(this$0, it, Type_START_getInstance_0());
    return Unit_instance;
  };
}
function BrowserCanvasJsGameWindow$lambda_9(this$0) {
  return function (it) {
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    touchEvent(this$0, it, Type_MOVE_getInstance_0());
    return Unit_instance;
  };
}
function BrowserCanvasJsGameWindow$lambda_10(this$0) {
  return function (it) {
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    touchEvent(this$0, it, Type_END_getInstance_0());
    return Unit_instance;
  };
}
function BrowserCanvasJsGameWindow$lambda_11(this$0) {
  return function (it) {
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    keyEvent(this$0, it);
    return Unit_instance;
  };
}
function BrowserCanvasJsGameWindow$lambda_12(this$0) {
  return function (it) {
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    keyEvent(this$0, it);
    return Unit_instance;
  };
}
function BrowserCanvasJsGameWindow$lambda_13(this$0) {
  return function (it) {
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    keyEvent(this$0, it);
    return Unit_instance;
  };
}
function BrowserCanvasJsGameWindow$lambda_14(this$0) {
  return function (it) {
    onResized(this$0);
    return Unit_instance;
  };
}
function BrowserCanvasJsGameWindow$lambda_15(this$0) {
  return function (it) {
    return this$0.u8n(Type_START_getInstance(), null);
  };
}
function BrowserCanvasJsGameWindow$lambda_16(this$0) {
  return function (it) {
    return this$0.u8n(Type_END_getInstance(), null);
  };
}
function BrowserCanvasJsGameWindow$lambda_17(this$0) {
  return function (it) {
    return this$0.u8n(Type_END_getInstance(), null);
  };
}
function BrowserCanvasJsGameWindow$lambda_18(it) {
  it.preventDefault();
  return Unit_instance;
}
function BrowserCanvasJsGameWindow$lambda_19(this$0) {
  return function (it) {
    return this$0.u8n(Type_START_getInstance(), null);
  };
}
function BrowserCanvasJsGameWindow$lambda_20(this$0) {
  return function (it) {
    return this$0.u8n(Type_END_getInstance(), null);
  };
}
function BrowserCanvasJsGameWindow$lambda_21(this$0) {
  return function (it) {
    it.preventDefault();
    this$0.u8n(Type_END_getInstance(), null);
    var items = ensureNotNull(it.dataTransfer).items;
    // Inline function 'kotlin.collections.mapNotNull' call
    // Inline function 'kotlin.collections.mapNotNullTo' call
    var this_0 = until(0, items.length);
    var destination = ArrayList.h1();
    // Inline function 'kotlin.collections.forEach' call
    var inductionVariable = this_0.d2_1;
    var last = this_0.e2_1;
    if (inductionVariable <= last)
      do {
        var element = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        // Inline function 'kotlin.collections.mapNotNullTo.<anonymous>' call
        // Inline function 'korlibs.render.BrowserCanvasJsGameWindow.<anonymous>.<anonymous>' call
        // Inline function 'org.w3c.dom.get' call
        // Inline function 'kotlin.js.asDynamic' call
        var tmp0_safe_receiver = items[element];
        var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.getAsFile();
        var tmp0_safe_receiver_0 = tmp1_safe_receiver == null ? null : toVfs(tmp1_safe_receiver);
        if (tmp0_safe_receiver_0 == null)
          null;
        else {
          // Inline function 'kotlin.let' call
          // Inline function 'kotlin.contracts.contract' call
          destination.h(tmp0_safe_receiver_0);
        }
      }
       while (!(element === last));
    var files = destination;
    return this$0.u8n(Type_DROP_getInstance(), files);
  };
}
function BrowserCanvasJsGameWindow$lambda_22(this$0) {
  return function (step) {
    window.requestAnimationFrame(_get_jsFrame__gugpar(this$0));
    this$0.m8l();
    return Unit_instance;
  };
}
function *_generator_invoke__zhh2q8_2($this, $completion) {
  var tmp = $this.i9i_1($this.j9i_1, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  return Unit_instance;
}
function *_generator_loop__qll5p8_1($this, entry, $completion) {
  var tmp = $this.l8l($completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  launchImmediately(tmp, DenoJsGameWindow$loop$slambda_0(entry, $this));
  var tmp_0 = get_jsGlobalThis();
  tmp_0.setInterval(DenoJsGameWindow$loop$lambda($this), 16);
  return Unit_instance;
}
function DenoJsGameWindow$loop$slambda_0($entry, this$0) {
  var i = new DenoJsGameWindow$loop$slambda($entry, this$0);
  var l = function ($completion) {
    return i.ud($completion);
  };
  l.$arity = 0;
  return l;
}
function DenoJsGameWindow$loop$lambda(this$0) {
  return function () {
    this$0.h96();
    this$0.m8l();
    this$0.i96();
    return Unit_instance;
  };
}
//region block: post-declaration
initMetadataForClass(TimedTask, 'TimedTask', VOID, VOID, [Comparable, AutoCloseable]);
initMetadataForClass(BaseEventLoop, 'BaseEventLoop', VOID, VOID, [AutoCloseable]);
initMetadataForClass(SyncEventLoop, 'SyncEventLoop', SyncEventLoop);
protoOf(Listener).as = cancel;
initMetadataForClass(Listener, 'Listener', VOID, VOID, [CloseableCancellable]);
initMetadataForClass(ListenerNode, 'ListenerNode');
initMetadataForInterface(EventListener, 'EventListener');
protoOf(BaseEventListener).f6a = dispatch$default;
protoOf(BaseEventListener).h6a = onEvents;
protoOf(BaseEventListener).i6a = dispatchDown;
protoOf(BaseEventListener).j6a = dispatchUp;
initMetadataForClass(BaseEventListener, 'BaseEventListener', BaseEventListener.t69, VOID, [EventListener]);
initMetadataForClass(EventResult, 'EventResult', EventResult);
initMetadataForCompanion(Companion);
initMetadataForClass(Event, 'Event');
initMetadataForClass(TypedEvent, 'TypedEvent');
initMetadataForClass(PauseEvent, 'PauseEvent', PauseEvent);
initMetadataForCompanion(Companion_0);
initMetadataForClass(ResumeEvent, 'ResumeEvent', ResumeEvent);
initMetadataForCompanion(Companion_1);
initMetadataForClass(StopEvent, 'StopEvent', StopEvent);
initMetadataForCompanion(Companion_2);
initMetadataForClass(DestroyEvent, 'DestroyEvent', DestroyEvent);
initMetadataForClass(RenderEvent, 'RenderEvent', RenderEvent);
initMetadataForCompanion(Companion_3);
initMetadataForClass(InitEvent, 'InitEvent', InitEvent);
initMetadataForCompanion(Companion_4);
initMetadataForCompanion(Companion_5);
initMetadataForClass(DisposeEvent, 'DisposeEvent', DisposeEvent);
initMetadataForCompanion(Companion_6);
initMetadataForClass(FullScreenEvent, 'FullScreenEvent', FullScreenEvent);
initMetadataForCompanion(Companion_7);
initMetadataForClass(ReshapeEvent, 'ReshapeEvent', ReshapeEvent);
initMetadataForCompanion(Companion_8);
initMetadataForClass(Type, 'Type');
initMetadataForClass(KeyEvent, 'KeyEvent', KeyEvent);
initMetadataForCompanion(Companion_9);
initMetadataForClass(Type_0, 'Type');
initMetadataForClass(ScrollDeltaMode, 'ScrollDeltaMode');
initMetadataForClass(MouseEvent, 'MouseEvent', MouseEvent);
initMetadataForCompanion(Companion_10);
initMetadataForClass(Type_1, 'Type');
initMetadataForClass(GestureEvent, 'GestureEvent', GestureEvent);
initMetadataForCompanion(Companion_11);
initMetadataForClass(Type_2, 'Type');
initMetadataForClass(DropFileEvent, 'DropFileEvent', DropFileEvent);
initMetadataForClass(StopPropagatingException, 'StopPropagatingException', StopPropagatingException.q6d);
initMetadataForClass(Status, 'Status');
initMetadataForClass(Kind, 'Kind');
initMetadataForCompanion(Companion_12);
initMetadataForClass(Touch, 'Touch', Touch);
initMetadataForCompanion(Companion_13);
initMetadataForClass(Type_3, 'Type');
initMetadataForCompanion(Companion_14);
initMetadataForClass(TouchEvent, 'TouchEvent', TouchEvent);
initMetadataForClass(Mode, 'Mode');
initMetadataForClass(TouchBuilder, 'TouchBuilder', TouchBuilder);
initMetadataForClass(GamepadInfoEmitter, 'GamepadInfoEmitter');
initMetadataForClass(BatteryStatus, 'BatteryStatus');
initMetadataForCompanion(Companion_15);
initMetadataForClass(GamepadInfo, 'GamepadInfo', GamepadInfo);
initMetadataForCompanion(Companion_16);
initMetadataForClass(GamePadUpdateEvent, 'GamePadUpdateEvent', GamePadUpdateEvent);
initMetadataForCompanion(Companion_17);
initMetadataForClass(Type_4, 'Type');
initMetadataForClass(GamePadConnectionEvent, 'GamePadConnectionEvent', GamePadConnectionEvent);
initMetadataForCompanion(Companion_18);
initMetadataForClass(GameButton, 'GameButton');
initMetadataForCompanion(Companion_19);
initMetadataForClass(Key, 'Key');
initMetadataForCompanion(Companion_20);
initMetadataForClass(MouseButton, 'MouseButton');
initMetadataForInterface(ISoftKeyboardConfig, 'ISoftKeyboardConfig');
initMetadataForClass(SoftKeyboardType, 'SoftKeyboardType');
initMetadataForClass(SoftKeyboardReturnKeyType, 'SoftKeyboardReturnKeyType');
initMetadataForClass(SoftKeyboardConfig, 'SoftKeyboardConfig', SoftKeyboardConfig, VOID, [ISoftKeyboardConfig]);
initMetadataForCompanion(Companion_21);
initMetadataForInterface(AGFeatures, 'AGFeatures');
protoOf(AG).o6j = get_parentFeatures;
protoOf(AG).p6j = get_isUniformBuffersSupported;
protoOf(AG).q6j = get_isVertexArraysSupported;
initMetadataForClass(AG, 'AG', VOID, VOID, [AGFeatures]);
initMetadataForClass(Immutable, 'Immutable', Immutable, VOID, [AGFeatures]);
initMetadataForClass(AGObject, 'AGObject', AGObject, VOID, [AutoCloseable]);
initMetadataForClass(AGBuffer, 'AGBuffer', AGBuffer);
initMetadataForCompanion(Companion_22);
initMetadataForClass(AGTextureUnits, 'AGTextureUnits', AGTextureUnits.u6m);
initMetadataForCompanion(Companion_23);
initMetadataForClass(AGFrameBuffer, 'AGFrameBuffer', AGFrameBuffer.g6j, VOID, [AutoCloseable]);
initMetadataForClass(AGTexture, 'AGTexture', AGTexture, VOID, [AGObject, AutoCloseable]);
initMetadataForClass(AGFrameBufferBase, 'AGFrameBufferBase');
initMetadataForCompanion(Companion_24);
initMetadataForClass(AGTextureUnitInfo, 'AGTextureUnitInfo');
initMetadataForInterface(AGNativeObject, 'AGNativeObject');
initMetadataForClass(BufferCache, 'BufferCache', BufferCache);
initMetadataForClass(AGProgramWithUniforms, 'AGProgramWithUniforms');
initMetadataForClass(AGVertexArrayObject, 'AGVertexArrayObject');
initMetadataForClass(AGVertexData, 'AGVertexData', AGVertexData);
initMetadataForCompanion(Companion_25);
initMetadataForClass(AGDrawType, 'AGDrawType');
initMetadataForCompanion(Companion_26);
initMetadataForCompanion(Companion_27);
initMetadataForClass(AGBlending, 'AGBlending');
initMetadataForCompanion(Companion_28);
initMetadataForClass(AGScissor, 'AGScissor');
initMetadataForCompanion(Companion_29);
initMetadataForObject(AGFinish, 'AGFinish');
initMetadataForClass(AGClear, 'AGClear');
initMetadataForCompanion(Companion_30);
initMetadataForClass(AGStencilReference, 'AGStencilReference');
initMetadataForCompanion(Companion_31);
initMetadataForClass(AGStencilOpFunc, 'AGStencilOpFunc');
initMetadataForCompanion(Companion_32);
initMetadataForClass(AGColorMask, 'AGColorMask');
initMetadataForCompanion(Companion_33);
initMetadataForCompanion(Companion_34);
initMetadataForClass(AGCullFace, 'AGCullFace');
initMetadataForClass(AGBatch, 'AGBatch');
initMetadataForCompanion(Companion_35);
initMetadataForClass(AGTextureTargetKind, 'AGTextureTargetKind');
initMetadataForCompanion(Companion_36);
initMetadataForClass(AGWrapMode, 'AGWrapMode');
initMetadataForCompanion(Companion_37);
initMetadataForClass(AGBlendFactor, 'AGBlendFactor');
initMetadataForCompanion(Companion_38);
initMetadataForClass(AGBlendEquation, 'AGBlendEquation');
initMetadataForCompanion(Companion_39);
initMetadataForCompanion(Companion_40);
initMetadataForClass(AGStencilOp, 'AGStencilOp');
initMetadataForCompanion(Companion_41);
initMetadataForClass(AGCompareMode, 'AGCompareMode');
initMetadataForCompanion(Companion_42);
initMetadataForClass(AGMultiBatch, 'AGMultiBatch');
initMetadataForClass(AGConfig, 'AGConfig', AGConfig);
initMetadataForClass(AGBufferKind, 'AGBufferKind');
initMetadataForClass(AGStats, 'AGStats', AGStats);
initMetadataForClass(UniformBlock, 'UniformBlock');
initMetadataForObject(ProjViewUB, 'ProjViewUB');
initMetadataForObject(DefaultShaders, 'DefaultShaders');
initMetadataForInterface(VarTypeAccessor, 'VarTypeAccessor');
initMetadataForInterface(ExpressionBuilder, 'ExpressionBuilder');
protoOf(Builder).d72 = get_Float1;
protoOf(Builder).e7o = get_Float2;
protoOf(Builder).f7o = get_Float4;
protoOf(Builder).q70 = get_out;
protoOf(Builder).e72 = atan;
protoOf(Builder).y70 = texture2D;
protoOf(Builder).w7m = TERNARY;
protoOf(Builder).f72 = pow;
protoOf(Builder).g72 = sqrt;
protoOf(Builder).h72 = abs;
protoOf(Builder).i72 = fract;
protoOf(Builder).x7m = clamp;
protoOf(Builder).y7m = min_0;
protoOf(Builder).z7m = max_1;
protoOf(Builder).a7n = fwidth;
protoOf(Builder).b7n = mix;
protoOf(Builder).j72 = smoothstep;
protoOf(Builder).c7n = length;
protoOf(Builder).t70 = get_lit;
protoOf(Builder).k72 = vec2;
protoOf(Builder).u70 = vec4;
protoOf(Builder).w70 = get_1;
protoOf(Builder).l72 = get_x;
protoOf(Builder).m72 = get_y;
protoOf(Builder).n72 = get_z;
protoOf(Builder).o72 = get_w;
protoOf(Builder).a71 = get_a;
protoOf(Builder).p72 = unaryMinus;
protoOf(Builder).q72 = minus_0;
protoOf(Builder).r72 = minus_1;
protoOf(Builder).s72 = plus_2;
protoOf(Builder).d7n = plus_3;
protoOf(Builder).e7n = plus_4;
protoOf(Builder).r70 = times;
protoOf(Builder).f7n = times_0;
protoOf(Builder).t72 = times_1;
protoOf(Builder).c71 = div;
protoOf(Builder).u72 = div_0;
protoOf(Builder).v72 = eq;
protoOf(Builder).w72 = lt;
protoOf(Builder).x72 = lt_0;
protoOf(Builder).y72 = le;
protoOf(Builder).z72 = gt;
protoOf(Builder).a73 = gt_0;
protoOf(Builder).b73 = and;
initMetadataForClass(Builder, 'Builder', Builder.d71, VOID, [VarTypeAccessor, ExpressionBuilder]);
initMetadataForInterface(IDefaultShaders, 'IDefaultShaders');
protoOf(ProgramBuilderDefault).x70 = get_u_Tex;
protoOf(ProgramBuilderDefault).a6y = get_u_ProjMat;
protoOf(ProgramBuilderDefault).b6y = get_u_ViewMat;
protoOf(ProgramBuilderDefault).s70 = get_a_Pos;
protoOf(ProgramBuilderDefault).k70 = get_a_Tex;
protoOf(ProgramBuilderDefault).p70 = get_a_Col;
protoOf(ProgramBuilderDefault).j70 = get_v_Tex;
protoOf(ProgramBuilderDefault).o70 = get_v_Col;
protoOf(ProgramBuilderDefault).b71 = get_t_Temp0;
protoOf(ProgramBuilderDefault).c73 = get_t_Temp1;
initMetadataForClass(ProgramBuilderDefault, 'ProgramBuilderDefault', ProgramBuilderDefault.i70, VOID, [Builder, IDefaultShaders]);
initMetadataForClass(GLVAO, 'GLVAO');
initMetadataForClass(ShaderException, 'ShaderException');
initMetadataForClass(TextureUnitParams, 'TextureUnitParams');
initMetadataForClass(AGOpengl, 'AGOpengl');
initMetadataForClass(GLGlobalState, 'GLGlobalState');
initMetadataForClass(GLBaseObject, 'GLBaseObject', VOID, VOID, [AGNativeObject]);
initMetadataForClass(GLBaseProgram, 'GLBaseProgram');
initMetadataForClass(GLBuffer, 'GLBuffer');
initMetadataForClass(GLTexture, 'GLTexture');
initMetadataForClass(GLFrameBuffer, 'GLFrameBuffer');
initMetadataForClass(GLProgramInfo, 'GLProgramInfo');
initMetadataForObject(GLShaderCompiler, 'GLShaderCompiler');
initMetadataForClass(AGDummy, 'AGDummy', AGDummy.b7d);
initMetadataForClass(AGBaseLog, 'AGBaseLog', AGBaseLog.v7d);
initMetadataForClass(AGPrint, 'AGPrint', AGPrint.l7d);
initMetadataForClass(Kind_0, 'Kind');
initMetadataForCompanion(Companion_43);
initMetadataForClass(UniformBlocksBuffersRef, 'UniformBlocksBuffersRef');
initMetadataForClass(Gen, 'Gen');
initMetadataForClass(Operand, 'Operand');
initMetadataForClass(OperandWithArray, 'OperandWithArray');
initMetadataForClass(Variable, 'Variable');
initMetadataForClass(VariableWithOffset, 'VariableWithOffset');
initMetadataForClass(TypedUniform, 'TypedUniform');
initMetadataForCompanion(Companion_44);
initMetadataForClass(UniformBlockBuffer, 'UniformBlockBuffer');
initMetadataForClass(UBLayoutBuilder, 'UBLayoutBuilder', UBLayoutBuilder);
initMetadataForClass(UniformsRef, 'UniformsRef');
initMetadataForCompanion(Companion_45);
initMetadataForClass(GLVariant, 'GLVariant');
initMetadataForClass(Visitor, 'Visitor');
initMetadataForClass(GlobalsProgramVisitor, 'GlobalsProgramVisitor', GlobalsProgramVisitor);
initMetadataForCompanion(Companion_46);
initMetadataForClass(Result, 'Result');
initMetadataForClass(sam$kotlin_Comparator$0, 'sam$kotlin_Comparator$0', VOID, VOID, [Comparator, FunctionAdapter]);
initMetadataForInterface(BaseGlslGenerator, 'BaseGlslGenerator');
protoOf(GlslGenerator).h7j = precToString;
protoOf(GlslGenerator).i7j = typeToString;
protoOf(GlslGenerator).j7j = get_arrayDecl;
protoOf(GlslGenerator).g7j = get_IN;
protoOf(GlslGenerator).l7j = get_OUT;
protoOf(GlslGenerator).k7j = get_UNIFORM;
initMetadataForClass(GlslGenerator, 'GlslGenerator', VOID, VOID, [BaseGlslGenerator]);
initMetadataForCompanion(Companion_47);
initMetadataForClass(GlslConfig, 'GlslConfig');
protoOf(GlslBodyGenerator).i7j = typeToString;
initMetadataForClass(GlslBodyGenerator, 'GlslBodyGenerator', VOID, VOID, [Visitor, BaseGlslGenerator]);
initMetadataForClass(ProgramLayout, 'ProgramLayout', VOID, VOID, [Iterable]);
initMetadataForClass(Attribute, 'Attribute');
initMetadataForClass(Stm, 'Stm');
initMetadataForClass(Stms, 'Stms');
initMetadataForClass(Set, 'Set');
initMetadataForClass(Return, 'Return');
initMetadataForObject(Break, 'Break');
initMetadataForObject(Continue, 'Continue');
initMetadataForObject(Discard, 'Discard');
initMetadataForClass(If, 'If');
initMetadataForClass(ForSimple, 'ForSimple');
initMetadataForClass(Raw, 'Raw');
protoOf(Program$ExpressionBuilder$Companion$INSTANCE$1).y70 = texture2D;
protoOf(Program$ExpressionBuilder$Companion$INSTANCE$1).f72 = pow;
protoOf(Program$ExpressionBuilder$Companion$INSTANCE$1).t70 = get_lit;
protoOf(Program$ExpressionBuilder$Companion$INSTANCE$1).w70 = get_1;
protoOf(Program$ExpressionBuilder$Companion$INSTANCE$1).q72 = minus_0;
protoOf(Program$ExpressionBuilder$Companion$INSTANCE$1).s72 = plus_2;
protoOf(Program$ExpressionBuilder$Companion$INSTANCE$1).r70 = times;
protoOf(Program$ExpressionBuilder$Companion$INSTANCE$1).c71 = div;
protoOf(Program$ExpressionBuilder$Companion$INSTANCE$1).w72 = lt;
protoOf(Program$ExpressionBuilder$Companion$INSTANCE$1).z72 = gt;
initMetadataForClass(Program$ExpressionBuilder$Companion$INSTANCE$1, VOID, VOID, VOID, [ExpressionBuilder]);
initMetadataForCompanion(Companion_48);
initMetadataForClass(FuncBuilder, 'FuncBuilder');
initMetadataForClass(FuncDeclGetter, 'FuncDeclGetter');
initMetadataForClass(FuncProvider, 'FuncProvider');
initMetadataForClass(Program$Builder$_funcs$1);
initMetadataForClass(Ternary, 'Ternary');
initMetadataForClass(Unop, 'Unop');
initMetadataForClass(Binop, 'Binop');
initMetadataForClass(IntLiteral, 'IntLiteral');
initMetadataForClass(FloatLiteral, 'FloatLiteral');
initMetadataForClass(BoolLiteral, 'BoolLiteral');
initMetadataForClass(Vector, 'Vector');
initMetadataForClass(Swizzle, 'Swizzle');
initMetadataForClass(ArrayAccess, 'ArrayAccess');
initMetadataForClass(BaseFunc, 'BaseFunc');
initMetadataForClass(Func, 'Func');
initMetadataForClass(CustomFunc, 'CustomFunc');
initMetadataForInterface(FuncRef, 'FuncRef');
initMetadataForClass(BuilderContext, 'BuilderContext', BuilderContext);
initMetadataForClass(Program, 'Program', VOID, VOID, [AutoCloseable]);
initMetadataForClass(Shader, 'Shader');
initMetadataForClass(Varying, 'Varying');
initMetadataForObject(Output, 'Output');
initMetadataForClass(Provider, 'Provider');
initMetadataForClass(Sampler, 'Sampler');
initMetadataForClass(SamplerVarType, 'SamplerVarType');
initMetadataForClass(Uniform, 'Uniform');
initMetadataForCompanion(Companion_49);
initMetadataForClass(VarType, 'VarType');
initMetadataForClass(Precision, 'Precision');
initMetadataForClass(Temp, 'Temp');
initMetadataForClass(FuncDecl, 'FuncDecl', VOID, VOID, [FuncRef]);
initMetadataForClass(VarKind, 'VarKind');
initMetadataForClass(UniformInProgram, 'UniformInProgram');
initMetadataForClass(Arg, 'Arg');
initMetadataForClass(ShaderType, 'ShaderType');
initMetadataForClass(sam$kotlinx_coroutines_DisposableHandle$0, 'sam$kotlinx_coroutines_DisposableHandle$0', VOID, VOID, [DisposableHandle, FunctionAdapter]);
initMetadataForClass(ContextInfo, 'ContextInfo', ContextInfo);
initMetadataForCompanion(Companion_50);
protoOf(KmlGl).o6j = get_parentFeatures;
protoOf(KmlGl).p6j = get_isUniformBuffersSupported;
protoOf(KmlGl).q6j = get_isVertexArraysSupported;
initMetadataForClass(KmlGl, 'KmlGl', KmlGl, VOID, [AGFeatures]);
initMetadataForClass(KmlGlContext, 'KmlGlContext', VOID, VOID, [AutoCloseable]);
initMetadataForClass(KorgeReloadInternalImpl, 'KorgeReloadInternalImpl', KorgeReloadInternalImpl);
initMetadataForClass(ReloadClassContext, 'ReloadClassContext');
initMetadataForObject(KorgeReload, 'KorgeReload');
initMetadataForCompanion(Companion_51);
initMetadataForCompanion(Companion_52);
initMetadataForClass(BlendMode, 'BlendMode');
initMetadataForClass(InputKeys, 'InputKeys', InputKeys);
initMetadataForCompanion(Companion_53);
initMetadataForClass(Input, 'Input', Input);
initMetadataForObject(DefaultViewport, 'DefaultViewport');
initMetadataForCompanion(Companion_54);
initMetadataForClass(Props, 'Props', Props, VOID, [KtMutableMap]);
initMetadataForClass(Entry, 'Entry', Entry);
initMetadataForClass(AgAutoFreeManager, 'AgAutoFreeManager', AgAutoFreeManager, VOID, [AutoCloseable]);
initMetadataForClass(BitmapTextureInfo, 'BitmapTextureInfo', BitmapTextureInfo);
initMetadataForClass(AgBitmapTextureManager, 'AgBitmapTextureManager', VOID, VOID, [AutoCloseable]);
initMetadataForClass(AgBufferManager, 'AgBufferManager');
initMetadataForClass(AgCachedBuffer, 'AgCachedBuffer');
initMetadataForClass(BatchBuffers, 'BatchBuffers', BatchBuffers);
initMetadataForCompanion(Companion_55);
initMetadataForClass(BatchBuilder2D, 'BatchBuilder2D');
initMetadataForInterface(BoundsProvider, 'BoundsProvider');
protoOf(Base).j8d = get_windowToGlobalScaleAvg;
protoOf(Base).k8d = get_globalToWindowScaleAvg;
protoOf(Base).l8d = windowToGlobalCoords;
initMetadataForClass(Base, 'Base', Base, VOID, [BoundsProvider]);
initMetadataForCompanion(Companion_56);
initMetadataForClass(LineRenderBatcher, 'LineRenderBatcher');
initMetadataForClass(FlushKind, 'FlushKind');
initMetadataForInterface(DeviceDimensionsProvider, 'DeviceDimensionsProvider');
initMetadataForClass(RenderContext, 'RenderContext', VOID, VOID, [BoundsProvider, AGFeatures, DeviceDimensionsProvider, AutoCloseable]);
initMetadataForClass(RenderContext2D, 'RenderContext2D');
initMetadataForObject(SDFShaders, 'SDFShaders');
initMetadataForClass(TextureBase, 'TextureBase', VOID, VOID, [AutoCloseable]);
initMetadataForCompanion(Companion_57);
initMetadataForClass(TexturedVertexArray, 'TexturedVertexArray');
initMetadataForClass(ResourcesRoot, 'ResourcesRoot', ResourcesRoot, VOID, [InjectorDependency], [1]);
initMetadataForClass(RCollection, 'RCollection', RCollection);
initMetadataForClass(Stats, 'Stats', Stats);
initMetadataForClass(V2, 'V2');
initMetadataForObject(V2CallbackSupport, 'V2CallbackSupport');
protoOf(DEFAULT).c8f = get_devicePixelRatio;
protoOf(DEFAULT).d8f = get_pixelsPerInch;
protoOf(DEFAULT).e8f = get_pixelsPerLogicalInchRatio;
protoOf(DEFAULT).n8e = get_computedPixelRatio;
initMetadataForObject(DEFAULT, 'DEFAULT', VOID, VOID, [DeviceDimensionsProvider]);
initMetadataForClass(Impl, 'Impl', Impl);
initMetadataForCompanion(Companion_58);
initMetadataForClass(Cursor, 'Cursor');
initMetadataForClass(MenuItem, 'MenuItem');
initMetadataForObject(CoroutineKey, 'CoroutineKey');
initMetadataForClass(Quality, 'Quality');
initMetadataForLambda(GameWindow$loop$slambda, VOID, VOID, [0]);
initMetadataForClass(_no_name_provided__qut3iv);
protoOf(GameWindow).c8f = get_devicePixelRatio;
protoOf(GameWindow).d8f = get_pixelsPerInch;
protoOf(GameWindow).e8f = get_pixelsPerLogicalInchRatio;
protoOf(GameWindow).n8e = get_computedPixelRatio;
protoOf(GameWindow).ed = get;
protoOf(GameWindow).cn = fold;
protoOf(GameWindow).bn = minusKey;
protoOf(GameWindow).dn = plus_1;
initMetadataForClass(GameWindow, 'GameWindow', GameWindow.t8l, VOID, [BaseEventListener, DeviceDimensionsProvider, Element], [0, 1]);
initMetadataForCompanion(Companion_59);
initMetadataForClass(GameWindowCreationConfig, 'GameWindowCreationConfig', GameWindowCreationConfig);
initMetadataForClass(TextClipboardData, 'TextClipboardData');
initMetadataForClass(TimedTask_0, 'TimedTask');
initMetadataForCompanion(Companion_60);
initMetadataForClass(sam$kotlinx_coroutines_DisposableHandle$0_0, 'sam$kotlinx_coroutines_DisposableHandle$0', VOID, VOID, [DisposableHandle, FunctionAdapter]);
initMetadataForClass(GameWindowCoroutineDispatcher, 'GameWindowCoroutineDispatcher', GameWindowCoroutineDispatcher.h8m, VOID, [CoroutineDispatcher, Delay, AutoCloseable], [1]);
initMetadataForClass(SyncEventLoopCoroutineDispatcher, 'SyncEventLoopCoroutineDispatcher', SyncEventLoopCoroutineDispatcher.w8l, VOID, [CoroutineDispatcher, Delay, AutoCloseable], [1]);
initMetadataForCompanion(Companion_61);
initMetadataForClass(UpdateEvent, 'UpdateEvent', UpdateEvent);
initMetadataForCompanion(Companion_62);
initMetadataForClass(SDL, 'SDL', SDL.j8q);
initMetadataForClass(KmlGlOpenGL, 'KmlGlOpenGL', KmlGlOpenGL);
initMetadataForCompanion(Companion_63);
initMetadataForClass(OpenGL, 'OpenGL', OpenGL.a8x);
initMetadataForClass(SDLGameWindow$ag$1);
initMetadataForClass(SDLGameWindow, 'SDLGameWindow', VOID, VOID, VOID, [0, 1]);
initMetadataForClass(Size3D, 'Size3D');
initMetadataForObject(AGOpenglFactory, 'AGOpenglFactory');
initMetadataForClass(KmlGlJsCanvas, 'KmlGlJsCanvas');
initMetadataForClass(WebGLExtension, 'WebGLExtension');
initMetadataForClass(KorgeReloadInternal$1);
initMetadataForClass(JsGameWindow, 'JsGameWindow', JsGameWindow.b9i, VOID, VOID, [0, 1]);
initMetadataForClass(NodeJsGameWindow, 'NodeJsGameWindow', NodeJsGameWindow.u9c, VOID, VOID, [0, 1]);
initMetadataForLambda(BrowserCanvasJsGameWindow$close$slambda, VOID, VOID, [0]);
initMetadataForLambda(BrowserCanvasJsGameWindow$loop$slambda, VOID, VOID, [0]);
initMetadataForClass(BrowserCanvasJsGameWindow, 'BrowserCanvasJsGameWindow', BrowserCanvasJsGameWindow.i9a, VOID, VOID, [1, 0]);
initMetadataForLambda(DenoJsGameWindow$loop$slambda, VOID, VOID, [0]);
initMetadataForClass(DenoJsGameWindow, 'DenoJsGameWindow', DenoJsGameWindow.p9f, VOID, VOID, [1, 0]);
initMetadataForClass(DialogInterfaceJs, 'DialogInterfaceJs', DialogInterfaceJs, VOID, VOID, [1, 2, 4]);
//endregion
//region block: init
Companion_instance_8 = new Companion();
Companion_instance_9 = new Companion_0();
Companion_instance_10 = new Companion_1();
Companion_instance_11 = new Companion_2();
Companion_instance_14 = new Companion_5();
Companion_instance_15 = new Companion_6();
Companion_instance_16 = new Companion_7();
Companion_instance_23 = new Companion_14();
Companion_instance_24 = new Companion_15();
Companion_instance_25 = new Companion_16();
Companion_instance_31 = new Companion_22();
Companion_instance_32 = new Companion_23();
AGFinish_instance = new AGFinish();
Companion_instance_48 = new Companion_39();
Companion_instance_53 = new Companion_44();
Companion_instance_54 = new Companion_45();
Companion_instance_58 = new Companion_49();
Companion_instance_59 = new Companion_50();
Companion_instance_60 = new Companion_51();
debugBmpFontOrNull = null;
Companion_instance_62 = new Companion_53();
Companion_instance_63 = new Companion_54();
DEFAULT_instance = new DEFAULT();
GLOBAL_CHECK_GL = false;
Companion_instance_70 = new Companion_61();
korgwJvmEngine = null;
Companion_instance_71 = new Companion_62();
Companion_instance_72 = new Companion_63();
AGOpenglFactory_instance = new AGOpenglFactory();
//endregion
//region block: exports
export {
  Size3D as Size3D,
};
export {
  Key_BACKSPACE_getInstance as Key_BACKSPACE_getInstance1qsaehdyc2n7u,
  Key_F12_getInstance as Key_F12_getInstance20smmrbslhgku,
  Key_F7_getInstance as Key_F7_getInstance1fxfgbmldwoq6,
  Key_SPACE_getInstance as Key_SPACE_getInstance3ccpin6uc1wp0,
  Key_TAB_getInstance as Key_TAB_getInstancerm3v8lzruhq1,
  Key_X_getInstance as Key_X_getInstance2ymba0j0rmblp,
  Type_DOWN_getInstance as Type_DOWN_getInstance3w3upujzs6x5,
  Type_TYPE_getInstance as Type_TYPE_getInstance3kl3gtiytkq1p,
  Type_UP_getInstance as Type_UP_getInstance2onpl7vaj0n6f,
  MouseButton_LEFT_getInstance as MouseButton_LEFT_getInstance2pxjdxrpl68c5,
  Type_DOWN_getInstance_0 as Type_DOWN_getInstance1zas01g4tazis,
  Type_DRAG_getInstance as Type_DRAG_getInstance1oyczma3u1sfi,
  Type_UP_getInstance_0 as Type_UP_getInstance1azeslmnft6l5,
  Kind_MOUSE_getInstance as Kind_MOUSE_getInstance104tc4m897tyy,
  Status_ADD_getInstance as Status_ADD_getInstance22apyg5ct4px7,
  Status_KEEP_getInstance as Status_KEEP_getInstance3tj4183qdgyi5,
  Status_REMOVE_getInstance as Status_REMOVE_getInstance19drpw6lfvon8,
  Type_END_getInstance_0 as Type_END_getInstance3ekhp9k4xqwsb,
  Type_MOVE_getInstance_0 as Type_MOVE_getInstanceavavmobr5nzz,
  Type_START_getInstance_0 as Type_START_getInstance27oonvh9zpi1o,
  Precision_MEDIUM_getInstance as Precision_MEDIUM_getInstancewn61okav7bh4,
  VarType_Float1_getInstance as VarType_Float1_getInstance1fp6gxp2vmo7y,
  VarType_Float2_getInstance as VarType_Float2_getInstance321ftm11bbyai,
  Cursor_DEFAULT_getInstance as Cursor_DEFAULT_getInstancemdqrzfwu4c9e,
  Cursor_HAND_getInstance as Cursor_HAND_getInstance18p4ksi2yuad6,
  Cursor_TEXT_getInstance as Cursor_TEXT_getInstancebh4jd1821ndb,
  Quality_PERFORMANCE_getInstance as Quality_PERFORMANCE_getInstance2edcjnp9auwx5,
  debugBmpFont as debugBmpFont2i7i2ml66o1iy,
  configureLoggerFromProperties as configureLoggerFromProperties2zy8apzr93pqp,
  AGStencilOpFunc__withActionOnBothPass$default_impl_69nsgo as AGStencilOpFunc__withActionOnBothPass$default_impl_69nsgoupfk5vp49hcf,
  AGStencilOpFunc__withCompareMode$default_impl_rzbauv as AGStencilOpFunc__withCompareMode$default_impl_rzbauv2a7p3ocsjaav3,
  AGStencilReference__withReadMask$default_impl_7mdffx as AGStencilReference__withReadMask$default_impl_7mdffx3h4nrtbyv01sb,
  AGStencilReference__withReferenceValue$default_impl_2trj0v as AGStencilReference__withReferenceValue$default_impl_2trj0vn7k078mgur5t,
  AGStencilReference__withWriteMask$default_impl_b7j7b4 as AGStencilReference__withWriteMask$default_impl_b7j7b425xwuml31ig42,
  _AGColorMask___init__impl__j38ai8_0 as _AGColorMask___init__impl__j38ai828hvpfxybxjk7,
  _AGColorMask___init__impl__j38ai8_1 as _AGColorMask___init__impl__j38ai819ejt5rq8iy6o,
  AGColorMask__hashCode_impl_g9082f as AGColorMask__hashCode_impl_g9082fge542b8j3bn5,
  AGColorMask__toString_impl_5i5oqg as AGColorMask__toString_impl_5i5oqgpd3xxn1kc5a,
  AGCompareMode__inverted_impl_7xxk8m as AGCompareMode__inverted_impl_7xxk8m1fvhgazpgzedy,
  AGCullFace__hashCode_impl_t4e5ur as AGCullFace__hashCode_impl_t4e5urey2md6modztx,
  AGCullFace__toString_impl_7d891w as AGCullFace__toString_impl_7d891w3d9dwll45l9u7,
  AGDrawType__hashCode_impl_ylaury as AGDrawType__hashCode_impl_ylaurytzzq8sas7cp2,
  AGDrawType__toString_impl_eonaeb as AGDrawType__toString_impl_eonaeb3ais8d8qrz6pw,
  AGStencilOpFunc__hashCode_impl_nopebb as AGStencilOpFunc__hashCode_impl_nopebb37r56bx19rj5s,
  AGStencilOpFunc__toString_impl_pl8quy as AGStencilOpFunc__toString_impl_pl8quy1rqibzqlcrdqz,
  AGStencilOpFunc__withActionOnBothPass_impl_qbn6at as AGStencilOpFunc__withActionOnBothPass_impl_qbn6at1fkyyctti87u0,
  AGStencilOpFunc__withEnabled_impl_mpcwmr as AGStencilOpFunc__withEnabled_impl_mpcwmr3endm713vq1t4,
  AGStencilReference__hashCode_impl_52zufx as AGStencilReference__hashCode_impl_52zufx32vlakxm4newn,
  AGStencilReference__toString_impl_qu5r8s as AGStencilReference__toString_impl_qu5r8s2c4bvb2linrx,
  AGTextureUnitInfoArray__get_impl_xhvpef as AGTextureUnitInfoArray__get_impl_xhvpef1gqflly73w69y,
  Companion_instance_11 as Companion_instance99w5lpdgjzr4,
  Companion_getInstance_27 as Companion_getInstance18y91gyxi2z7,
  Companion_getInstance_33 as Companion_getInstanceok0yphc67vv6,
  Companion_instance_25 as Companion_instancekcgdgz2aik3h,
  Companion_getInstance_26 as Companion_getInstance2ckr5i14ndxro,
  Companion_getInstance_35 as Companion_getInstance2y4l90zc9q53m,
  Companion_getInstance_24 as Companion_getInstance1wltq3fgn1avz,
  Companion_getInstance_25 as Companion_getInstancekjblelnta22u,
  Companion_instance_8 as Companion_instance2ovjg7lp6gfg7,
  Companion_instance_16 as Companion_instance12t49ingjwxzt,
  Companion_instance_9 as Companion_instance3i2v9jzzqvdkl,
  Companion_instance_10 as Companion_instancef7estul0zruo,
  Companion_getInstance_29 as Companion_getInstance6ryfwvwg9trm,
  Companion_getInstance_64 as Companion_getInstance31h96uhdj5cc,
  Companion_instance_53 as Companion_instance31en7fj48z7ti,
  Companion_getInstance_48 as Companion_getInstance29a9zmyrrw3c9,
  Companion_getInstance_57 as Companion_getInstancei2plsq4vst79,
  Companion_getInstance_50 as Companion_getInstance14dcva8uz4sb6,
  Companion_getInstance_41 as Companion_getInstanceae40js4gnuwg,
  Companion_getInstance_44 as Companion_getInstance23l94gq35u9ye,
  Companion_getInstance_56 as Companion_getInstance203qp9xyfv543,
  Companion_getInstance_47 as Companion_getInstance2cx7brx0y6bm1,
  Companion_getInstance_46 as Companion_getInstance3dym1csqm206y,
  Companion_getInstance_40 as Companion_getInstance27aqys8b8jo0e,
  ProjViewUB_getInstance as ProjViewUB_getInstance2c14wyrj73xek,
  DefaultShaders_getInstance as DefaultShaders_getInstance2nkm3g7twu3qg,
  Companion_getInstance_68 as Companion_getInstance1ifu77pbb1si2,
  DefaultViewport_getInstance as DefaultViewport_getInstance3ta8638tkh0q1,
  Companion_getInstance_71 as Companion_getInstance1dp345vz250gb,
  SDFShaders_getInstance as SDFShaders_getInstance2aqc6fv2u457r,
  Companion_getInstance_73 as Companion_getInstance2vwksse73neff,
  KorgeReload_getInstance as KorgeReload_getInstance1jsrcs9uzp4z9,
  Companion_instance_60 as Companion_instance7uo85wjiqj61,
  Companion_instance_70 as Companion_instanceyamrbth4pjfq,
  CoroutineKey_getInstance as CoroutineKey_getInstance2jikmq30sknr8,
  BaseEventListener as BaseEventListener6clplq3qhf9k,
  EventResult as EventResult1qajuo9ssrvv5,
  Event as Eventnral6s6c3h27,
  ISoftKeyboardConfig as ISoftKeyboardConfige7b4czi6ukd7,
  KeyEvent as KeyEvent3kdv2rq8w0dew,
  MouseEvent as MouseEventmt8xebywpdp9,
  ReshapeEvent as ReshapeEvent3137ki3m95agm,
  SoftKeyboardConfig as SoftKeyboardConfig3ue4h4egpkqhq,
  StopPropagatingException as StopPropagatingException3fryyzw9pc422,
  TouchEvent as TouchEvent37l81isz00qgj,
  AGPrint as AGPrint2do8iynklt71b,
  Attribute as Attribute3obvnbxr5w4xd,
  FragmentShader as FragmentShader2u3ycaqbgbmdi,
  If as If1av5krmfyt44s,
  ProgramLayout as ProgramLayout373hh4xkth3qt,
  Program as Program1hnygp9hph4ry,
  Shader as Shader39o79ur9unxav,
  UniformBlockBuffer as UniformBlockBuffer2p2oao2ic417b,
  UniformBlock as UniformBlock2qoqszhm3r9i2,
  Varying as Varying105nnu9x9j75f,
  VertexShader as VertexShader26kcg39ndf3s1,
  AGBatch as AGBatch2bse24318tbhc,
  AGColorMask as AGColorMaskwqd86t1dhpnk,
  AGCullFace as AGCullFaceff7di2v9k2ne,
  AGDrawType as AGDrawType11vxw4gf0yugk,
  AGScissor as AGScissor1lpa42gfyr1p2,
  AGStencilOpFunc as AGStencilOpFunc1juigl5mvjr07,
  AGStencilReference as AGStencilReference8at184sv64zi,
  AGTextureUnits as AGTextureUnits3k80ikbk5qbv9,
  AGVertexArrayObject as AGVertexArrayObjectp6l6cor3jhq8,
  AGVertexData as AGVertexDatawn78bdwnwjab,
  AG as AG35f0xk1ko87rh,
  ProgramBuilderDefault as ProgramBuilderDefault3573mhybddt0b,
  applyMatrixBounds as applyMatrixBounds3j13fpymjibm6,
  draw as drawfyi5eaogony1,
  draw_1 as draw3n7i8s75fp58g,
  plus_5 as plus3tmekjwnqrsa6,
  toAGScissor as toAGScissor50oxbqy8vpfx,
  drawText as drawText2ld6eqw3mc9xd,
  Input as Input3ljaq07eyi73v,
  AgCachedBuffer as AgCachedBuffer8k1i505isl6b,
  get_BB_MAX_TEXTURES as get_BB_MAX_TEXTURES19x2awozztfc7,
  Base as Basef4lqzcfsxjhi,
  BoundsProvider as BoundsProvideri69utw6h2duh,
  RenderContext as RenderContext3l27as458i66g,
  get_TEXTURED_ARRAY_QUAD_INDICES as get_TEXTURED_ARRAY_QUAD_INDICES20zmm5sqavviz,
  TextureBase as TextureBase31xvoisoo1pp7,
  TexturedVertexArray as TexturedVertexArrayt1cf0uhgxqi1,
  Texture as Texture2obedkmljq67n,
  Texture_1 as Texture39uvj3jju6ujd,
  get_debugLineRenderContext as get_debugLineRenderContext3s3h9yq8a0rtj,
  ResourcesRoot as ResourcesRoot36ooexy6oq69y,
  Stats as Statslnkcsgem8jjl,
  V2Callback as V2Callback2d6dtckx13wqz,
  V2 as V22su20mpwty0v0,
  _interpolateColor as _interpolateColor3ps0kri0tazz4,
  _interpolateRatio as _interpolateRatio2cj6ldbl0g6ae,
  _interpolate as _interpolated0idy8l9id9j,
  UpdateEvent as UpdateEvent2wwv3f0im2cby,
  CreateDefaultGameWindow as CreateDefaultGameWindow1l94icsbq4y8h,
  DeviceDimensionsProvider as DeviceDimensionsProvider22igvmdnpe2w1,
  GameWindowCreationConfig as GameWindowCreationConfigbzmga8g39et1,
  GameWindow as GameWindow35197f3hcbh1b,
  TextClipboardData as TextClipboardDatafimoftc14pmm,
  configure as configure1a7py4k2lj4vi,
};
//endregion
